import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * The `DateTime` scalar type represents a date and time in the UTC
   * timezone. The DateTime appears in a JSON response as an ISO8601 formatted
   * string, including UTC timezone ("Z"). The parsed date and time string will
   * be converted to UTC if there is an offset.
   */
  DateTime: { input: string; output: string; }
  /**
   * The `Decimal` scalar type represents signed double-precision fractional
   * values parsed by the `Decimal` library. The Decimal appears in a JSON
   * response as a string to preserve precision.
   */
  Decimal: { input: any; output: any; }
  /** Binary data serialised as a lowercase hex (Base16) string. */
  HexString: { input: any; output: any; }
  /**
   * Datetime scalar with 3 decimals of microsecond precision fixed at 0.
   * e.g. datetime         -> "2019-07-15T04:36:57Z"
   *      precise_datetime -> "2019-07-15T04:36:57.000Z"
   */
  PreciseDateTime: { input: string; output: string; }
  /** Enum of "FINAL" or "DRAFT". */
  ReleaseType: { input: any; output: any; }
};

export type AccessCode = {
  __typename?: 'AccessCode';
  active: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Maybe<Scalars['String']['output']>;
  type: AccessCodeType;
};

export type AccessCodeInput = {
  active: Scalars['Boolean']['input'];
  code: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AccessCodeType>;
};

export enum AccessCodeType {
  /** Standard entry code used for a student's first session */
  Entry = 'ENTRY',
  /** Re-entry code that authorises a subsequent session after an exit */
  Reentry = 'REENTRY'
}

/** Access group for a question */
export enum AccessGroup {
  Restricted = 'RESTRICTED',
  Subject = 'SUBJECT',
  University = 'UNIVERSITY'
}

/** Access role for a question */
export enum AccessRole {
  Editor = 'EDITOR',
  Owner = 'OWNER',
  Viewer = 'VIEWER'
}

/**
 * Gradebook result access summary describing the last access to a unique
 * external service via the result.
 */
export type AccessSummary = {
  __typename?: 'AccessSummary';
  accessCount: Scalars['Int']['output'];
  lastAccess: Scalars['PreciseDateTime']['output'];
  memberSummaries: Array<MemberSummary>;
  service: GradebookService;
};

export type AddQuestionBanksToAssessmentInput = {
  filter: QuestionBankFilterInput;
  questionBankNodes: Array<QuestionBankNodes>;
};

/** A representation of an answer to a question block */
export type AnswerBlock = {
  __typename?: 'AnswerBlock';
  /** Attachments to this answer block */
  blockAttachments: Array<BlockAttachment>;
  /** Special Block name, used for naming classic editor blocks. */
  blockName: Maybe<Scalars['String']['output']>;
  /** Bookmarked by the student. */
  bookmark: Maybe<Scalars['Boolean']['output']>;
  /** Explicit student confirmation on completed attempt */
  confirm: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  latestBlockSnapshot: Maybe<BlockSnapshot>;
  /** Tree layout node ID for the block */
  nodeId: Scalars['ID']['output'];
  /** Numeric ordering */
  order: Maybe<Scalars['Int']['output']>;
  /** Labelled ordering */
  orderLabel: Maybe<Scalars['String']['output']>;
  /** Tree layout parent node ID for this block */
  parentNodeId: Maybe<Scalars['ID']['output']>;
  /** Points alloted to this answer. */
  points: Maybe<Scalars['Int']['output']>;
  /** Tree layout previous node ID for this block */
  previousNodeId: Maybe<Scalars['ID']['output']>;
  /** Question being answered by the Answer block */
  question: Maybe<Question>;
  /** Question ID that this Answer is answering */
  questionId: Maybe<Scalars['ID']['output']>;
  /** Shuffle answer options */
  shuffle: Maybe<Scalars['Boolean']['output']>;
  /** Skipped by the student. */
  skip: Maybe<Scalars['Boolean']['output']>;
};

/** Known editing block names */
export enum AnswerBlockName {
  Body = 'body',
  Notes = 'notes',
  References = 'references'
}

/** API status information */
export type ApiStatusType = {
  __typename?: 'ApiStatusType';
  hasBrightspaceApi: Scalars['Boolean']['output'];
  hasCanvasApi: Scalars['Boolean']['output'];
};

/**
 * A Cadmus Assessment
 *
 * Contains information available to all roles. Wraps some Subject information
 * and the latest Instruction sheet.
 */
export type Assessment = {
  __typename?: 'Assessment';
  /** Submission due date for on-time submissions, set in the LMS. */
  dueDate: Maybe<Scalars['PreciseDateTime']['output']>;
  /** Assessment Edition */
  edition: Scalars['Int']['output'];
  /** Assessment cut-off date, set in the LMS. */
  endDate: Maybe<Scalars['PreciseDateTime']['output']>;
  /** Grading reminder date, set in the LMS. */
  gradingDueDate: Maybe<Scalars['PreciseDateTime']['output']>;
  /** Predicate checking if at least 1 save has been made in the Assessment. */
  hasSave: Scalars['Boolean']['output'];
  /** Predicate checking if at least 1 submission has been made in the Assessment. */
  hasSubmission: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** LTI Custom Parameters from source LMS. */
  ltiCustomParams: Maybe<CustomParams>;
  /** All the LTI 1.1 and 1.3 services recorded for this Assessment. */
  ltiServices: Array<LtiService>;
  /** Institutions LMS Tool Provider used to launch this Assessment. */
  ltiTool: InstitutionTool;
  name: Scalars['String']['output'];
  /** Schoolyear Exam linked to this assessment. */
  schoolyearExam: Maybe<SchoolyearExam>;
  /** Assessment wide settings. */
  settings: Maybe<AssessmentSettings>;
  /** Assessment submission start date set in the LMS. */
  startDate: Maybe<Scalars['PreciseDateTime']['output']>;
  subject: Subject;
  subjectId: Scalars['ID']['output'];
  /** @deprecated Use the subject name from subject.name instead */
  subjectName: Scalars['String']['output'];
  /** All Tasks belonging to this Assessment. */
  tasks: Array<Task>;
};


/**
 * A Cadmus Assessment
 *
 * Contains information available to all roles. Wraps some Subject information
 * and the latest Instruction sheet.
 */
export type AssessmentSubjectArgs = {
  assessmentId: InputMaybe<Scalars['ID']['input']>;
};

/** A student's email-sharing consent state for a group assessment. */
export type AssessmentEmailConsent = {
  __typename?: 'AssessmentEmailConsent';
  /** Latest consent choice; null if the student has never answered. */
  consent: Maybe<Scalars['Boolean']['output']>;
  /** Mirror of the assessment setting `group_show_email_to_students`. */
  enabled: Scalars['Boolean']['output'];
};

/**
 * A lightweight assessment search result — just enough to label an option
 * in a search/autocomplete UI.
 */
export type AssessmentOption = {
  __typename?: 'AssessmentOption';
  id: Scalars['ID']['output'];
  insertedAt: Scalars['PreciseDateTime']['output'];
  name: Scalars['String']['output'];
};

/** Enum of Assessment presets */
export enum AssessmentPreset {
  Classic = 'CLASSIC',
  Group = 'GROUP',
  Multiformat = 'MULTIFORMAT',
  Viva = 'VIVA'
}

export type AssessmentProgressResponse = {
  __typename?: 'AssessmentProgressResponse';
  charter: ProgressSection;
  peer: ProgressSection;
  work: WorkProgress;
};

/** Settings for an Assessment */
export type AssessmentSettings = {
  __typename?: 'AssessmentSettings';
  allowGenerativeAi: Maybe<Scalars['Boolean']['output']>;
  anonymousMarking: Maybe<Scalars['Boolean']['output']>;
  assessmentType: AssessmentType;
  countFootnotes: Scalars['Boolean']['output'];
  countReferences: Scalars['Boolean']['output'];
  doubleBlindMarkingEnabled: Scalars['Boolean']['output'];
  draftDueDate: Maybe<Scalars['PreciseDateTime']['output']>;
  draftEnabled: Scalars['Boolean']['output'];
  draftScoringEnabled: Scalars['Boolean']['output'];
  dueDate: Maybe<Scalars['PreciseDateTime']['output']>;
  examAccessCodeEnabled: Scalars['Boolean']['output'];
  examAutoSubmissionDisabled: Scalars['Boolean']['output'];
  examBacktrackDisabled: Scalars['Boolean']['output'];
  examEndDate: Maybe<Scalars['PreciseDateTime']['output']>;
  examInactivityTimeout: Maybe<Scalars['Int']['output']>;
  examLdbEnabled: Scalars['Boolean']['output'];
  examReadingTime: Maybe<Scalars['Int']['output']>;
  examReadingTimeDisabled: Scalars['Boolean']['output'];
  examReentryPreventionEnabled: Scalars['Boolean']['output'];
  examSchoolyearEnabled: Scalars['Boolean']['output'];
  examStartDate: Maybe<Scalars['PreciseDateTime']['output']>;
  examTiming: ExamTiming;
  examType: Array<Scalars['String']['output']>;
  examWritingTime: Maybe<Scalars['Int']['output']>;
  feedbackDate: Maybe<Scalars['PreciseDateTime']['output']>;
  feedbackDateDisabled: Scalars['Boolean']['output'];
  groupAssessmentEnabled: Scalars['Boolean']['output'];
  groupChangeRequestCutoff: Maybe<Scalars['PreciseDateTime']['output']>;
  groupChangeRequestsEnabled: Scalars['Boolean']['output'];
  groupCharterAcceptanceRequired: Scalars['Boolean']['output'];
  /** Charter is usable by students: enabled AND a published charter form exists. */
  groupCharterAvailable: Scalars['Boolean']['output'];
  groupCharterDueDate: Maybe<Scalars['PreciseDateTime']['output']>;
  groupCharterEnabled: Scalars['Boolean']['output'];
  groupDraftDueDate: Maybe<Scalars['PreciseDateTime']['output']>;
  groupDraftEnabled: Scalars['Boolean']['output'];
  groupDraftFeedbackAlwaysAvailable: Scalars['Boolean']['output'];
  /** @deprecated Use group-level finalised field instead */
  groupFinalised: Scalars['Boolean']['output'];
  groupHideMembersName: Scalars['Boolean']['output'];
  groupReportMaxGrade: Maybe<Scalars['Int']['output']>;
  groupReportWeight: Maybe<Scalars['Int']['output']>;
  groupSelfEnrollmentDeadline: Maybe<Scalars['PreciseDateTime']['output']>;
  groupSelfEnrollmentEnabled: Scalars['Boolean']['output'];
  groupShowEmailToStudents: Scalars['Boolean']['output'];
  groupWorkAttachmentEnabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  individualDraftFeedbackAlwaysAvailable: Scalars['Boolean']['output'];
  individualReportDueDate: Maybe<Scalars['PreciseDateTime']['output']>;
  individualReportEnabled: Scalars['Boolean']['output'];
  individualReportMaxGrade: Maybe<Scalars['Int']['output']>;
  individualReportWeight: Maybe<Scalars['Int']['output']>;
  individualWorkAttachmentEnabled: Scalars['Boolean']['output'];
  lateResubmissionEnabled: Scalars['Boolean']['output'];
  /** @deprecated Use `late_submission_time_limit` instead */
  lateResubmissionTimeLimit: Maybe<Scalars['Int']['output']>;
  lateSubmissionTimeLimit: Maybe<Scalars['Int']['output']>;
  markingAclEnabled: Scalars['Boolean']['output'];
  markingTool: Maybe<MarkingTool>;
  markingToolPdf: Maybe<MarkingToolPdf>;
  maxGrade: Scalars['Int']['output'];
  openDate: Maybe<Scalars['PreciseDateTime']['output']>;
  peerEvaluationDueDate: Maybe<Scalars['PreciseDateTime']['output']>;
  peerEvaluationEnabled: Scalars['Boolean']['output'];
  peerEvaluationMaxGrade: Maybe<Scalars['Int']['output']>;
  peerEvaluationMaxScaleFactor: Scalars['Float']['output'];
  peerEvaluationMinScaleFactor: Scalars['Float']['output'];
  peerEvaluationMode: PeerEvaluationMode;
  peerEvaluationWeight: Maybe<Scalars['Int']['output']>;
  referencingStyle: Maybe<Scalars['String']['output']>;
  referencingStyleEnabled: Scalars['Boolean']['output'];
  releaseDate: Maybe<Scalars['PreciseDateTime']['output']>;
  restrictMarkingToolPdf: Scalars['Boolean']['output'];
  rubricDisplayDisabled: Scalars['Boolean']['output'];
  selfEvaluationEnabled: Scalars['Boolean']['output'];
  selfEvaluationMaxGrade: Maybe<Scalars['Int']['output']>;
  selfEvaluationMode: SelfEvaluationMode;
  selfEvaluationWeight: Maybe<Scalars['Int']['output']>;
  sentimentCheckEnabled: Scalars['Boolean']['output'];
  sentimentCheckFirstCheckAt: Maybe<Scalars['PreciseDateTime']['output']>;
  sentimentCheckIntervalInHr: Maybe<Scalars['Int']['output']>;
  sentimentCheckScheduleType: SentimentCheckScheduleType;
  sentimentCheckSchedules: Maybe<Array<SentimentCheckSchedule>>;
  sentimentCheckSkipEnabled: Scalars['Boolean']['output'];
  smartAutomarkingEnabled: Scalars['Boolean']['output'];
  spellCheckDisabled: Scalars['Boolean']['output'];
  /** @deprecated Use `openDate` instead */
  startDate: Maybe<Scalars['PreciseDateTime']['output']>;
  submissionPdfDisabled: Scalars['Boolean']['output'];
  submitAttemptLimit: Maybe<Scalars['Int']['output']>;
  tiiDraftSViewReports: Scalars['Int']['output'];
  tiiSViewReports: Scalars['Int']['output'];
  timeLimit: Maybe<Scalars['Int']['output']>;
  timeLimitEnabled: Scalars['Boolean']['output'];
  vivaCameraRequiredDisabled: Scalars['Boolean']['output'];
  vivaEnabled: Scalars['Boolean']['output'];
  vivaReattemptWindowTime: Maybe<Scalars['Int']['output']>;
  vivaSourceTask: Maybe<VivaSourceTask>;
  /** @deprecated Use `vivaSourceTask` instead */
  vivaSourceTaskId: Maybe<Scalars['ID']['output']>;
  weight: Maybe<Scalars['Float']['output']>;
  weightEnabled: Scalars['Boolean']['output'];
  wordLimit: Maybe<Scalars['Int']['output']>;
  wordLimitEnabled: Scalars['Boolean']['output'];
  wordLimitGroup: Maybe<Scalars['Int']['output']>;
};

export type AssessmentSettingsInput = {
  allowGenerativeAi?: InputMaybe<Scalars['Boolean']['input']>;
  anonymousMarking?: InputMaybe<Scalars['Boolean']['input']>;
  assessmentType?: InputMaybe<AssessmentType>;
  countFootnotes?: InputMaybe<Scalars['Boolean']['input']>;
  countReferences?: InputMaybe<Scalars['Boolean']['input']>;
  doubleBlindMarkingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  draftDueDate?: InputMaybe<Scalars['PreciseDateTime']['input']>;
  draftEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  draftScoringEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  dueDate?: InputMaybe<Scalars['PreciseDateTime']['input']>;
  examAccessCodeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  examAutoSubmissionDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  examBacktrackDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  examEndDate?: InputMaybe<Scalars['PreciseDateTime']['input']>;
  examInactivityTimeout?: InputMaybe<Scalars['Int']['input']>;
  examLdbEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  examReadingTime?: InputMaybe<Scalars['Int']['input']>;
  examReadingTimeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  examReentryPreventionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  examSchoolyearEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  examStartDate?: InputMaybe<Scalars['PreciseDateTime']['input']>;
  examTiming?: InputMaybe<ExamTiming>;
  examType?: InputMaybe<Array<Scalars['String']['input']>>;
  examWritingTime?: InputMaybe<Scalars['Int']['input']>;
  feedbackDate?: InputMaybe<Scalars['PreciseDateTime']['input']>;
  feedbackDateDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  groupAssessmentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  groupChangeRequestCutoff?: InputMaybe<Scalars['PreciseDateTime']['input']>;
  groupChangeRequestsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  groupCharterAcceptanceRequired?: InputMaybe<Scalars['Boolean']['input']>;
  groupCharterDueDate?: InputMaybe<Scalars['PreciseDateTime']['input']>;
  groupCharterEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  groupDraftDueDate?: InputMaybe<Scalars['PreciseDateTime']['input']>;
  groupDraftEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  groupDraftFeedbackAlwaysAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  groupFinalised?: InputMaybe<Scalars['Boolean']['input']>;
  groupHideMembersName?: InputMaybe<Scalars['Boolean']['input']>;
  groupReportWeight?: InputMaybe<Scalars['Int']['input']>;
  groupSelfEnrollmentDeadline?: InputMaybe<Scalars['PreciseDateTime']['input']>;
  groupSelfEnrollmentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  groupShowEmailToStudents?: InputMaybe<Scalars['Boolean']['input']>;
  groupWorkAttachmentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  individualDraftFeedbackAlwaysAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  individualReportDueDate?: InputMaybe<Scalars['PreciseDateTime']['input']>;
  individualReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  individualReportWeight?: InputMaybe<Scalars['Int']['input']>;
  individualWorkAttachmentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  lateResubmissionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  lateSubmissionTimeLimit?: InputMaybe<Scalars['Int']['input']>;
  markingAclEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  markingTool?: InputMaybe<MarkingTool>;
  maxGrade?: InputMaybe<Scalars['Int']['input']>;
  peerEvaluationDueDate?: InputMaybe<Scalars['PreciseDateTime']['input']>;
  peerEvaluationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  peerEvaluationMaxScaleFactor?: InputMaybe<Scalars['Float']['input']>;
  peerEvaluationMinScaleFactor?: InputMaybe<Scalars['Float']['input']>;
  peerEvaluationMode?: InputMaybe<PeerEvaluationMode>;
  peerEvaluationWeight?: InputMaybe<Scalars['Int']['input']>;
  referencingStyle?: InputMaybe<Scalars['String']['input']>;
  referencingStyleEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  rubricDisplayDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  selfEvaluationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  selfEvaluationMode?: InputMaybe<SelfEvaluationMode>;
  selfEvaluationWeight?: InputMaybe<Scalars['Int']['input']>;
  sentimentCheckEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  sentimentCheckFirstCheckAt?: InputMaybe<Scalars['PreciseDateTime']['input']>;
  sentimentCheckIntervalInHr?: InputMaybe<Scalars['Int']['input']>;
  sentimentCheckScheduleType?: InputMaybe<SentimentCheckScheduleType>;
  sentimentCheckSchedules?: InputMaybe<Array<SentimentCheckScheduleInput>>;
  sentimentCheckSkipEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  spellCheckDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  submissionPdfDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  submitAttemptLimit?: InputMaybe<Scalars['Int']['input']>;
  tiiDraftSViewReports?: InputMaybe<Scalars['Int']['input']>;
  tiiSViewReports?: InputMaybe<Scalars['Int']['input']>;
  timeLimit?: InputMaybe<Scalars['Int']['input']>;
  timeLimitEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  vivaCameraRequiredDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  vivaEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  vivaReattemptWindowTime?: InputMaybe<Scalars['Int']['input']>;
  vivaSourceTaskId?: InputMaybe<Scalars['ID']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  weightEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  wordLimit?: InputMaybe<Scalars['Int']['input']>;
  wordLimitEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  wordLimitGroup?: InputMaybe<Scalars['Int']['input']>;
};

/** Cadmus assessments can be assignments or exams. */
export enum AssessmentType {
  Assignment = 'ASSIGNMENT',
  Exam = 'EXAM'
}

/** Automarking status of the field outcome */
export enum AutomarkStatus {
  Complete = 'COMPLETE',
  Processing = 'PROCESSING'
}

/** A background job running in an Assessment. */
export type BackgroundJob = {
  __typename?: 'BackgroundJob';
  id: Scalars['ID']['output'];
  kind: BackgroundJobKind;
  state: BackgroundJobState;
};

/** Known kinds of background jobs in an Assessment. */
export enum BackgroundJobKind {
  RosterSync = 'ROSTER_SYNC'
}

/** States of a background job. */
export enum BackgroundJobState {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Discarded = 'DISCARDED',
  Executing = 'EXECUTING',
  Scheduled = 'SCHEDULED'
}

/** Base type of a response. Used to determine the type of response expected. */
export enum BaseType {
  Coords = 'coords',
  DirectedPair = 'directed_pair',
  Float = 'float',
  Identifier = 'identifier',
  Range = 'range',
  Record = 'record',
  String = 'string'
}

/** A single blank in a fill-in-the-blanks response. */
export type Blank = {
  __typename?: 'Blank';
  id: Scalars['String']['output'];
  phrases: Array<Scalars['String']['output']>;
};

export type BlanksInput = {
  id: Scalars['String']['input'];
  phrases: Array<Scalars['String']['input']>;
};

/** Response as a fill-in-the-blanks type. */
export type BlanksResponse = {
  __typename?: 'BlanksResponse';
  /** Whether the matching is case sensitive */
  caseSensitive: Maybe<Scalars['Boolean']['output']>;
  matchBlanks: Array<Blank>;
  /** Similarity threshold between 0.0 and 1.0 inclusive */
  matchSimilarity: Maybe<Scalars['Float']['output']>;
};

export type BlanksResponseInput = {
  caseSensitive?: InputMaybe<Scalars['Boolean']['input']>;
  matchBlanks: Array<BlanksInput>;
  /** Between 0.0 and 1.0 inclusive. */
  matchSimilarity?: InputMaybe<Scalars['Float']['input']>;
};

/** Block Attachment associated with an AnswerBlock */
export type BlockAttachment = {
  __typename?: 'BlockAttachment';
  fileExtension: Maybe<Scalars['String']['output']>;
  fileSize: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  insertedAt: Maybe<Scalars['DateTime']['output']>;
  mediaUrl: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** The user who uploaded this attachment */
  uploadedBy: Maybe<User>;
  uploadedById: Maybe<Scalars['ID']['output']>;
};

/** A snapshot of a block inside a work */
export type BlockSnapshot = {
  __typename?: 'BlockSnapshot';
  answerBlockId: Scalars['ID']['output'];
  /** Special Block name, used for naming classic editor blocks. */
  blockName: Maybe<Scalars['String']['output']>;
  /** Special ID for client side caching. Defaults to the actual ID */
  cacheId: Scalars['ID']['output'];
  /** Serialised Snapshot contents */
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  version: Scalars['Int']['output'];
};

/** Response as a binary choice. */
export type BooleanResponse = {
  __typename?: 'BooleanResponse';
  isTrue: Maybe<Scalars['Boolean']['output']>;
};

export type BooleanResponseInput = {
  isTrue: Scalars['Boolean']['input'];
};

/**
 * Query namespace for invoking the Brightspace REST API operations via OAuth2
 * authorization.
 */
export type BrightspaceApi = {
  __typename?: 'BrightspaceApi';
  /** Brightspace Provider authorization URL */
  authorizeUrl: Scalars['String']['output'];
  authorized: Scalars['Boolean']['output'];
  groups: Array<BrightspaceGroup>;
};


/**
 * Query namespace for invoking the Brightspace REST API operations via OAuth2
 * authorization.
 */
export type BrightspaceApiAuthorizeUrlArgs = {
  brightspaceScopeFor?: InputMaybe<BrightspaceScopeKeyType>;
  redirectTo: InputMaybe<Scalars['String']['input']>;
};


/**
 * Query namespace for invoking the Brightspace REST API operations via OAuth2
 * authorization.
 */
export type BrightspaceApiGroupsArgs = {
  brightspaceScopeFor?: InputMaybe<BrightspaceScopeKeyType>;
};

/**
 * Brightspace OrgUnit object, directly mapped from the Brightspace REST API.
 *
 * See https://docs.valence.desire2learn.com/res/orgunit.html.
 */
export type BrightspaceGroup = {
  __typename?: 'BrightspaceGroup';
  code: Maybe<Scalars['String']['output']>;
  /** Brightspace Group ID. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  students: Maybe<Array<BrightspaceUser>>;
  totalStudents: Scalars['Int']['output'];
};

export enum BrightspaceScopeKeyType {
  /** Default scope */
  Default = 'DEFAULT',
  /** scope for getting groups */
  GetGroups = 'GET_GROUPS'
}

/**
 * Brightspace User object, directly mapped from the Brightspace REST API.
 *
 * See https://docs.valence.desire2learn.com/res/user.html#User.
 */
export type BrightspaceUser = {
  __typename?: 'BrightspaceUser';
  /** Brightspace User ID. */
  id: Scalars['ID']['output'];
};

export type BuildMarkerRubricInput = {
  fieldRubricId?: InputMaybe<Scalars['ID']['input']>;
  kind: MarkerRubricKind;
  sourceMarkerRubricId?: InputMaybe<Scalars['ID']['input']>;
  taskBlockId?: InputMaybe<Scalars['ID']['input']>;
};

export type BuildMarkerRubricPayload = {
  __typename?: 'BuildMarkerRubricPayload';
  fieldRubric: Maybe<FieldRubric>;
  markerRubric: MarkerRubric;
  taskBlock: Maybe<TaskBlock>;
};

/** Return type for cancelRelease mutation. */
export type CancelReleasePayload = {
  __typename?: 'CancelReleasePayload';
  /** Latest state of the task. */
  task: Task;
};

/**
 * Query namespace for invoking the Canvas REST API operations via OAuth2
 * authorization.
 */
export type CanvasApi = {
  __typename?: 'CanvasApi';
  /** Canvas Provider authorization URL */
  authorizeUrl: Scalars['String']['output'];
  authorized: Scalars['Boolean']['output'];
  sections: Array<CanvasSection>;
};


/**
 * Query namespace for invoking the Canvas REST API operations via OAuth2
 * authorization.
 */
export type CanvasApiAuthorizeUrlArgs = {
  canvasScopeFor?: InputMaybe<CanvasScopeKeyType>;
  redirectTo: InputMaybe<Scalars['String']['input']>;
};


/**
 * Query namespace for invoking the Canvas REST API operations via OAuth2
 * authorization.
 */
export type CanvasApiSectionsArgs = {
  canvasScopeFor?: InputMaybe<CanvasScopeKeyType>;
};

export enum CanvasScopeKeyType {
  /** Default scope */
  Default = 'DEFAULT',
  /** scope for getting assignment overrides */
  GetAssignmentOverrides = 'GET_ASSIGNMENT_OVERRIDES',
  /** scope for getting section */
  GetSections = 'GET_SECTIONS'
}

/**
 * Canvas Section object, directly mapped from the Canvas REST API.
 *
 * See https://canvas.instructure.com/doc/api/sections.html.
 */
export type CanvasSection = {
  __typename?: 'CanvasSection';
  courseId: Scalars['ID']['output'];
  /** Canvas Section ID. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sisCourseId: Maybe<Scalars['ID']['output']>;
  students: Maybe<Array<CanvasUser>>;
  totalStudents: Scalars['Int']['output'];
};

/**
 * Canvas User object, directly mapped from the Canvas REST API.
 *
 * See https://canvas.instructure.com/doc/api/users.html#User.
 */
export type CanvasUser = {
  __typename?: 'CanvasUser';
  /** Canvas User ID. */
  id: Scalars['ID']['output'];
  /** Canvas User full name. */
  name: Scalars['String']['output'];
  /** Canvas SIS User ID. */
  sisUserId: Maybe<Scalars['ID']['output']>;
};

/**
 * Cardinality of the expected response in a Question as defined in the QTI spec.
 *
 * A question can have a single, multiple, or requirement for an ordered correct
 * response expressed as its cardinality.
 */
export enum Cardinality {
  Multiple = 'multiple',
  Ordered = 'ordered',
  Single = 'single'
}

export type ChangeAssessmentPresetResult = {
  __typename?: 'ChangeAssessmentPresetResult';
  assessmentSettings: AssessmentSettings;
  task: Task;
};

/** Charter for assessment group */
export type Charter = {
  __typename?: 'Charter';
  allMembersAccepted: Scalars['Boolean']['output'];
  editors: Array<CharterEditor>;
  feedbackThreads: Array<Thread>;
  groupId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  latestAgreement: Maybe<CharterAgreement>;
  milestones: Array<CharterMilestone>;
};

/** Charter agreements */
export type CharterAgreement = {
  __typename?: 'CharterAgreement';
  acceptedAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  studentId: Scalars['String']['output'];
  unlockedAt: Maybe<Scalars['DateTime']['output']>;
};

/**
 * Input for student's agreemeent to the charter,
 *   the `charter_id` is passed to identify the charter and
 *   the student's `id` is taken from the context
 */
export type CharterAgreementInput = {
  charterId: Scalars['ID']['input'];
};

/** Charter editor for students */
export type CharterEditor = {
  __typename?: 'CharterEditor';
  charterFormSectionId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  snapshotDoc: Maybe<Scalars['String']['output']>;
  snapshotVersion: Maybe<Scalars['Int']['output']>;
  /** Stream Identifier for Editor */
  streamUuid: Scalars['String']['output'];
};

/**
 * Input to save the editor state by passing the `editor_id`
 *   and the `snapshot_doc` and `snapshot_version` at every save of the
 *   editor
 */
export type CharterEditorInput = {
  editorId: Scalars['ID']['input'];
  snapshotDoc: Scalars['String']['input'];
  snapshotVersion: Scalars['Int']['input'];
};

/** Charter Form created by the teacher for assessment */
export type CharterForm = {
  __typename?: 'CharterForm';
  editedAt: Maybe<Scalars['DateTime']['output']>;
  hasUnpublishedChanges: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  publishTimestamp: Maybe<Scalars['DateTime']['output']>;
  published: Scalars['Boolean']['output'];
  sections: Array<CharterFormSection>;
};

export type CharterFormInput = {
  charterFormId: Scalars['ID']['input'];
  sections?: InputMaybe<Array<CharterFormSectionInput>>;
};

export type CharterFormSection = {
  __typename?: 'CharterFormSection';
  /** Soft delete */
  deleted: Scalars['Boolean']['output'];
  /** Toggle if this section will be shown to students */
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  milestonePresets: Maybe<Array<MilestonePresetType>>;
  /** Description of the section as a serialised ProseMirror document */
  promptDoc: Maybe<Scalars['String']['output']>;
  /** Sort order of the section */
  rank: Maybe<Scalars['Int']['output']>;
  title: Maybe<Scalars['String']['output']>;
  type: CharterFormSectionType;
  /** Number of words allowed. Only used if it is an input type section */
  wordLimit: Maybe<Scalars['Int']['output']>;
  /** Toggle if word limit is enabled for this section. Only used if it is an input type section */
  wordLimitEnabled: Scalars['Boolean']['output'];
};

export type CharterFormSectionInput = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Can be null for new sections */
  id?: InputMaybe<Scalars['ID']['input']>;
  milestonePresets?: InputMaybe<Array<MilestonePresetInput>>;
  promptDoc?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CharterFormSectionType>;
  wordLimit?: InputMaybe<Scalars['Int']['input']>;
  wordLimitEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Different form sections creatable in a charter form */
export enum CharterFormSectionType {
  Instruction = 'INSTRUCTION',
  Milestone = 'MILESTONE',
  Overview = 'OVERVIEW',
  TextInput = 'TEXT_INPUT'
}

/** Charter milestones */
export type CharterMilestone = {
  __typename?: 'CharterMilestone';
  deleted: Scalars['Boolean']['output'];
  description: Maybe<Scalars['String']['output']>;
  dueDate: Scalars['DateTime']['output'];
  id: Maybe<Scalars['ID']['output']>;
  title: Scalars['String']['output'];
};

/** Charter section types that can have threads. */
export enum CharterSectionType {
  Editor = 'EDITOR',
  Milestone = 'MILESTONE'
}

/** A single choice in a response with an ID and label text. */
export type Choice = {
  __typename?: 'Choice';
  id: Scalars['String']['output'];
  isCorrect: Maybe<Scalars['Boolean']['output']>;
  text: Scalars['String']['output'];
};

export type ChoiceInput = {
  id: Scalars['String']['input'];
  isCorrect?: InputMaybe<Scalars['Boolean']['input']>;
  text: Scalars['String']['input'];
};

export type ChoiceInteraction = {
  __typename?: 'ChoiceInteraction';
  choices: Array<SimpleChoice>;
  /** Optional Category label */
  label: Maybe<Scalars['String']['output']>;
  /** Maximum number of choices the user can select */
  maxChoices: Scalars['Int']['output'];
};

export type ChoiceInteractionInput = {
  choices: Array<SimpleChoiceInput>;
  label?: InputMaybe<Scalars['String']['input']>;
  maxChoices?: InputMaybe<Scalars['Int']['input']>;
};

/** Cadmus Class information for an Assessment. */
export type Class = {
  __typename?: 'Class';
  /** How the groups were setup for the assessment. */
  groupType: GroupType;
  /** List of all groups and their members */
  groups: Array<Group>;
  /** Class assessment ID */
  id: Scalars['ID']['output'];
  /** List of student enrollments in a class, including deleted enrollments. */
  students: Array<Enrollment>;
};

/** A full Class list with works and stats. */
export type ClassList = {
  __typename?: 'ClassList';
  /** List of Enrollments in a Class */
  enrollments: Array<Enrollment>;
  id: Scalars['ID']['output'];
};

/** Enum for the different Class List tab contexts. */
export enum ClassTab {
  /** Drafts tab */
  Drafts = 'DRAFTS',
  /** Finals tab */
  Finals = 'FINALS',
  /** Students or Progress tab */
  Students = 'STUDENTS'
}

export type Comment = {
  __typename?: 'Comment';
  content: Scalars['String']['output'];
  createdBy: User;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['PreciseDateTime']['output'];
  smartCommentId: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['PreciseDateTime']['output'];
};

/** CommentRelease represents a snapshot of a comment at the time of feedback release. */
export type CommentRelease = {
  __typename?: 'CommentRelease';
  content: Scalars['String']['output'];
  createdBy: User;
  /** The ID of the Comment`. */
  id: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
};

export enum CompleteSocraticTurnError {
  /** Already completed */
  AlreadyCompleted = 'ALREADY_COMPLETED',
  /** Not started */
  NotStarted = 'NOT_STARTED'
}

export type CompleteSocraticTurnInput = {
  /** Duration of the recorded media in seconds. */
  durationSeconds?: InputMaybe<Scalars['Int']['input']>;
  mediaId: Scalars['ID']['input'];
  /** URL of the recorded media associated with this turn. */
  mediaUrl?: InputMaybe<Scalars['String']['input']>;
  turnId: Scalars['ID']['input'];
};

export type CompleteSocraticTurnPayload = {
  __typename?: 'CompleteSocraticTurnPayload';
  dialogue: Maybe<SocraticDialogue>;
  error: Maybe<CompleteSocraticTurnError>;
};

export type CompleteSubmissionOutcomesPayload = {
  __typename?: 'CompleteSubmissionOutcomesPayload';
  submissionOutcomes: Array<SubmissionOutcome>;
  updatedCount: Scalars['Int']['output'];
};

/**
 * Overview of marking and moderation data for in-progress (`base`) and released (`provisional`, `final`) feedback.
 * Includes weighted totals and scores by component (`group`, `individual`, `peer`, `self`).
 *
 * ### Component States
 * * `complete`: `weight` > 0 and `score` exists. (Released for `final`/`provisional`; marking started for `base`).
 * * `incomplete`: `weight` > 0 but null `score`. (Not released or marking not started).
 * * `disabled`: Not enabled in AssessmentSettings (entire component will be null e.g, `%ComponentBreakdown{group: null}`).
 * * `zero-weight`: `weight = 0`. Still required and must be completed/marked before release; contributes 0 to total/grades.
 */
export type ComponentBreakdown = {
  __typename?: 'ComponentBreakdown';
  group: Maybe<ComponentScore>;
  individual: Maybe<ComponentScore>;
  peer: Maybe<ComponentScore>;
  self: Maybe<ComponentScore>;
  total: WeightedScore;
};

/** Marking and moderation data for all components. */
export type ComponentScore = {
  __typename?: 'ComponentScore';
  /**
   * The max score set in AssessmentSettings (default 100) for the component.
   * E.g., `individual_report_max_grade`, `self_evaluation_max_grade`.
   */
  maxScore: Scalars['Int']['output'];
  /**
   * Adjustment applied to this component's score during moderation.
   * E.g. `WorkOutcome.moderator_modifier`
   */
  moderatorModifier: Scalars['Float']['output'];
  /**
   * Applied raw (pre-weight) marker adjustment folded into this component.
   * Surfaces the delta separately from `score` (which keeps the marked value);
   * `weighted_score` already reflects it.
   */
  modifiersTotal: Scalars['Float']['output'];
  /**
   * Deduction applied to this component (positive float >= 0.0).
   * E.g., `1.0` reduces the component score by 1.0.
   */
  penaltyScore: Scalars['Float']['output'];
  /**
   * Unweighted raw score.
   * * `final`/`provisional`: Non-null only if component is released.
   * * `base`: Non-null if any marking exists.
   */
  score: Maybe<Scalars['Float']['output']>;
  /**
   * Percentage contribution (0-100) of this component to the total grade.
   * Derived from AssessmentSettings. Zero-weight components have weight `0`.
   * E.g., `individual_report_weight`
   */
  weight: Scalars['Int']['output'];
  /** The max_score scaled by the component's weight contribution. */
  weightedMaxScore: Scalars['Float']['output'];
  /** The moderator_modifier scaled by the component's weight contribution. */
  weightedModeratorModifier: Scalars['Float']['output'];
  /** The penalty_score scaled by the component's weight contribution. */
  weightedPenaltyScore: Scalars['Float']['output'];
  /**
   * Score scaled by `weight`.
   * * `final`/`provisional`: Non-null only if component is released.
   * * `base`: Non-null if any marking exists.
   */
  weightedScore: Maybe<Scalars['Float']['output']>;
};

export type ContributedRange = {
  __typename?: 'ContributedRange';
  from: Scalars['Int']['output'];
  to: Scalars['Int']['output'];
};

export type Contribution = {
  __typename?: 'Contribution';
  asOfVersion: Scalars['Int']['output'];
  members: Array<MemberContribution>;
};

/** Conversation event payload for subscriptions - can be either a comment event or title change */
export type ConversationEvent = {
  __typename?: 'ConversationEvent';
  comment: Maybe<Comment>;
  eventType: ConversationEventType;
  threadId: Scalars['ID']['output'];
  title: Maybe<Scalars['String']['output']>;
};

/** Conversation event types for subscriptions */
export enum ConversationEventType {
  CommentAdded = 'COMMENT_ADDED',
  CommentEdited = 'COMMENT_EDITED',
  TitleEdited = 'TITLE_EDITED'
}

/** Country information */
export type Country = {
  __typename?: 'Country';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CreateGraderMarkerRubricInput = {
  fieldRubricId: Scalars['ID']['input'];
};

export type CreateGraderMarkerRubricPayload = {
  __typename?: 'CreateGraderMarkerRubricPayload';
  fieldRubric: FieldRubric;
  markerRubric: MarkerRubric;
};

export type CreateMarkerRubricInput = {
  format: MarkerRubricFormat;
  kind: MarkerRubricKind;
  reversedScale: Scalars['Boolean']['input'];
};

export type CreateQuestionBankFileOriginInput = {
  filename: Scalars['String']['input'];
  filepath: Scalars['String']['input'];
};

export type CreateQuestionBankInput = {
  /** @deprecated Deprecated. Use fields instead */
  blanksResponse?: InputMaybe<BlanksResponseInput>;
  /** @deprecated Deprecated. Use fields instead */
  booleanResponse?: InputMaybe<BooleanResponseInput>;
  category?: InputMaybe<Scalars['String']['input']>;
  difficulty?: InputMaybe<QuestionDifficulty>;
  /** @deprecated Deprecated. Use fields instead */
  editorResponse?: InputMaybe<EditorResponseInput>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  /** Question fields with response declaration and interaction type */
  fields?: InputMaybe<Array<InputMaybe<QuestionFieldInput>>>;
  fileOriginId?: InputMaybe<Scalars['ID']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  filepath?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Deprecated. Use fields instead */
  multiResponse?: InputMaybe<MultiResponseInput>;
  points?: InputMaybe<Scalars['Int']['input']>;
  promptDoc: Scalars['String']['input'];
  /** Question Prompt Image information and associated layers for a question prompt. */
  promptImage?: InputMaybe<PromptImageInput>;
  /** Question type */
  questionType: QuestionType;
  scope: QuestionBankScope;
  /** Short plain text prompt description */
  shortPrompt: Scalars['String']['input'];
  /** @deprecated Deprecated. Use fields instead */
  shortResponse?: InputMaybe<ShortResponseInput>;
  shuffle?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateQuestionMarkerRubricInput = {
  taskBlockId: Scalars['ID']['input'];
};

export type CreateQuestionMarkerRubricPayload = {
  __typename?: 'CreateQuestionMarkerRubricPayload';
  markerRubric: MarkerRubric;
  taskBlock: TaskBlock;
};

export type CreateQuestionSelectionPayload = {
  __typename?: 'CreateQuestionSelectionPayload';
  /** Array index of incomplete rule */
  incompleteRuleIndex: Maybe<Scalars['Int']['output']>;
  /** N questions required */
  requiredQuestionCount: Maybe<Scalars['Int']['output']>;
  /** N sets required */
  requiredSetsQuantity: Maybe<Scalars['Int']['output']>;
  /** N questions found */
  selectedQuestionCount: Maybe<Scalars['Int']['output']>;
  /** Fulfilled QuestionSelection generation. */
  selection: Maybe<QuestionSelection>;
};

export type CreateSchoolyearDashboardUrlPayload = {
  __typename?: 'CreateSchoolyearDashboardUrlPayload';
  url: Maybe<Scalars['String']['output']>;
};

export type CreateSchoolyearSettingsUrlPayload = {
  __typename?: 'CreateSchoolyearSettingsUrlPayload';
  url: Maybe<Scalars['String']['output']>;
};

export type CreateSkillInput = {
  skill: Scalars['String']['input'];
};

export type CreateSmartCommentInput = {
  commentId?: InputMaybe<Scalars['ID']['input']>;
  content: Scalars['String']['input'];
  maxScore: Scalars['Int']['input'];
  rangeFrom?: InputMaybe<Scalars['Int']['input']>;
  rangeTo: Scalars['Int']['input'];
  skillId: Scalars['ID']['input'];
};

export enum CreateSocraticDialogueError {
  /** Attempt with this number has already been created */
  AttemptAlreadyExists = 'ATTEMPT_ALREADY_EXISTS',
  /** Attempt number exceeds maximum allowed */
  AttemptNumberGtMaxAttempts = 'ATTEMPT_NUMBER_GT_MAX_ATTEMPTS'
}

export type CreateSocraticDialoguePayload = {
  __typename?: 'CreateSocraticDialoguePayload';
  error: Maybe<CreateSocraticDialogueError>;
  session: Maybe<SocraticSession>;
};

/** Creation attributes for a TaskBlock and linked Question */
export type CreateTaskBlockInput = {
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  nodeId?: InputMaybe<Scalars['ID']['input']>;
  parentNodeId?: InputMaybe<Scalars['ID']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  previousNodeId?: InputMaybe<Scalars['ID']['input']>;
  questionType: QuestionType;
  shuffle?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Criterion = {
  __typename?: 'Criterion';
  color: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  /** Whether any outcomes exist for this Criterion. */
  hasOutcomes: Scalars['Boolean']['output'];
  id: Maybe<Scalars['ID']['output']>;
  maxScore: Maybe<Scalars['Int']['output']>;
  order: Scalars['Int']['output'];
  scaleItems: Array<ScaleItem>;
  skill: Maybe<LearningOutcomeSkill>;
  /** Learning Outcome Skill with Criterion title as fallback. */
  title: Maybe<Scalars['String']['output']>;
};

export type CriterionInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  maxScore?: InputMaybe<Scalars['Int']['input']>;
  order: Scalars['Int']['input'];
  scaleItems: Array<ScaleItemInput>;
  skillId?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CriterionOutcome = {
  __typename?: 'CriterionOutcome';
  id: Scalars['ID']['output'];
  markerRubricCriterion: Criterion;
  markerRubricCriterionId: Scalars['ID']['output'];
  markerRubricScaleItemId: Scalars['ID']['output'];
  markerScore: Scalars['Float']['output'];
  /** For Peer Evaluations: the student that marked this outcome. */
  markerUserId: Maybe<Scalars['ID']['output']>;
  /** For Peer Evaluations: when the student published their evaluation. */
  publishedAt: Maybe<Scalars['PreciseDateTime']['output']>;
  /** For Peer Evaluations: the student that received this outcome. */
  targetUserId: Maybe<Scalars['ID']['output']>;
  /** For Peer Evaluations: when a student evaluated a target user, updated this outcome. */
  updatedAt: Maybe<Scalars['PreciseDateTime']['output']>;
};

/**
 * CriterionOutcomeRelease represents a snapshot of a criterion outcome at release time.
 * Contains the rubric-based marking for a specific criterion.
 */
export type CriterionOutcomeRelease = {
  __typename?: 'CriterionOutcomeRelease';
  id: Scalars['ID']['output'];
  markerRubricCriterionId: Scalars['ID']['output'];
  markerRubricScaleItemId: Scalars['ID']['output'];
  markerScore: Scalars['Float']['output'];
};

/** Custom params captured for a user during LTI launches. */
export type CustomParams = {
  __typename?: 'CustomParams';
  brightspaceUserId: Maybe<Scalars['ID']['output']>;
  canvasAssignmentId: Maybe<Scalars['ID']['output']>;
  canvasSubmissionId: Maybe<Scalars['ID']['output']>;
  canvasUserId: Maybe<Scalars['ID']['output']>;
  lisPersonSourcedid: Maybe<Scalars['String']['output']>;
  moodleAttemptReopenMethod: Maybe<Scalars['String']['output']>;
};

export type DeletedContribution = {
  __typename?: 'DeletedContribution';
  anchor: Scalars['Int']['output'];
  deletedById: Maybe<Scalars['ID']['output']>;
  marks: Array<DeletedMark>;
  media: Maybe<DeletedMedia>;
  node: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

export type DeletedMark = {
  __typename?: 'DeletedMark';
  attrs: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type DeletedMedia = {
  __typename?: 'DeletedMedia';
  customWidth: Maybe<Scalars['Float']['output']>;
  imageAlign: Maybe<Scalars['String']['output']>;
  src: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  width: Maybe<Scalars['String']['output']>;
};

export type DeletedMember = {
  __typename?: 'DeletedMember';
  groupId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
};

/** All possible Disciplines in Cadmus */
export enum Discipline {
  ArchitectureBuilding = 'ARCHITECTURE_BUILDING',
  Business = 'BUSINESS',
  ComputingIt = 'COMPUTING_IT',
  Design = 'DESIGN',
  Education = 'EDUCATION',
  Engineering = 'ENGINEERING',
  HumanitiesLanguages = 'HUMANITIES_LANGUAGES',
  Law = 'LAW',
  Mathematics = 'MATHEMATICS',
  MediaCommunication = 'MEDIA_COMMUNICATION',
  MedicineHealth = 'MEDICINE_HEALTH',
  PerformingFineArts = 'PERFORMING_FINE_ARTS',
  Science = 'SCIENCE',
  SocialScience = 'SOCIAL_SCIENCE'
}

export type DocumentBase = {
  __typename?: 'DocumentBase';
  baseDoc: Scalars['String']['output'];
  /** @deprecated Always 0; the scrubber bounds on snapshot ticks. Slated for removal. */
  headVersion: Scalars['Int']['output'];
};

export type DocumentStep = {
  __typename?: 'DocumentStep';
  data: Scalars['String']['output'];
  userId: Maybe<Scalars['ID']['output']>;
  version: Scalars['Int']['output'];
};

export type DocumentWindow = {
  __typename?: 'DocumentWindow';
  baseVersion: Scalars['Int']['output'];
  document: Maybe<Scalars['String']['output']>;
  /** @deprecated Always 0; the scrubber bounds on snapshot ticks. Slated for removal. */
  headVersion: Scalars['Int']['output'];
  steps: Array<DocumentStep>;
};

/** Response as a rich text editor. */
export type EditorResponse = {
  __typename?: 'EditorResponse';
  wordLimit: Maybe<Scalars['Int']['output']>;
};

export type EditorResponseInput = {
  wordLimit?: InputMaybe<Scalars['Int']['input']>;
};

/** Different kinds of client-side Editors */
export enum EditorType {
  Prosemirror = 'PROSEMIRROR',
  Slate = 'SLATE'
}

/** A class Enrollment. */
export type Enrollment = {
  __typename?: 'Enrollment';
  /**
   * Access code used by the Student in the enrollment.
   * @deprecated Use `verified_codes` instead
   */
  accessCode: Maybe<AccessCode>;
  /** Index of the enrollment for anonymous marking */
  anonymousIndex: Maybe<Scalars['Int']['output']>;
  /** LTI Custom params */
  customParams: CustomParams;
  deleted: Scalars['Boolean']['output'];
  deletedBy: Maybe<User>;
  id: Scalars['ID']['output'];
  /** Total number of re-entry verifications across the student's sessions in this enrollment. */
  reentryCount: Scalars['Int']['output'];
  /** Section this student belongs to (null = not in any section) */
  sectionId: Maybe<Scalars['ID']['output']>;
  /** Source LMS' SIS ID for the enrolled user */
  sisUserId: Maybe<Scalars['String']['output']>;
  /** Enrollment synced at date if the enrollment is inserted/updated through roster sync not lti launch */
  syncedAt: Maybe<Scalars['PreciseDateTime']['output']>;
  /** Tags for the enrollment */
  tags: Array<Tag>;
  /** Enrolled user */
  user: User;
  /** List of all the verified access codes used by the student in the enrollment. */
  verifiedCodes: Maybe<Array<VerifiedCode>>;
  /** Work started under the Enrollment, if any */
  work: Maybe<Work>;
  workSettings: Maybe<WorkSettings>;
};

/** Entity thread event payload for subscriptions */
export type EntityThreadEvent = {
  __typename?: 'EntityThreadEvent';
  criterionId: Maybe<Scalars['ID']['output']>;
  entityId: Maybe<Scalars['ID']['output']>;
  entityType: Maybe<EntityType>;
  eventType: EntityThreadEventType;
  resolvedAt: Maybe<Scalars['PreciseDateTime']['output']>;
  resolvedBy: Maybe<User>;
  status: ThreadStatus;
  threadId: Scalars['ID']['output'];
};

/** Entity thread event types for subscriptions */
export enum EntityThreadEventType {
  Created = 'CREATED',
  Deleted = 'DELETED',
  Linked = 'LINKED',
  Resolved = 'RESOLVED',
  Unlinked = 'UNLINKED',
  Unresolved = 'UNRESOLVED'
}

/** Entity types associated with threads. */
export enum EntityType {
  AnswerBlock = 'ANSWER_BLOCK',
  Charter = 'CHARTER',
  FieldOutcome = 'FIELD_OUTCOME',
  PeerOutcome = 'PEER_OUTCOME',
  SubmissionOutcome = 'SUBMISSION_OUTCOME'
}

/** Type of examination time windowing strategy. */
export enum ExamTiming {
  Live = 'LIVE',
  Window = 'WINDOW'
}

export type ExceptionInput = {
  feedbackModeration?: InputMaybe<FeedbackModerationDecisionInput>;
  flagReason?: InputMaybe<Scalars['String']['input']>;
  scoreModeration?: InputMaybe<ScoreModerationDecisionInput>;
  workOutcomeIds: Array<Scalars['ID']['input']>;
};

export type ExtendedInteraction = {
  __typename?: 'ExtendedInteraction';
  attachmentEnabled: Maybe<Scalars['Boolean']['output']>;
  referencingEnabled: Maybe<Scalars['Boolean']['output']>;
  wordLimit: Maybe<Scalars['Int']['output']>;
};

export type ExtendedInteractionInput = {
  attachmentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  referencingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  wordLimit?: InputMaybe<Scalars['Int']['input']>;
};

/** Valid conflic actions for extensions sync types */
export enum ExtensionConflictActionType {
  Override = 'OVERRIDE',
  Skip = 'SKIP'
}

/** A feature flag and whether it is enabled for the requesting context. */
export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  enabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export enum FeedbackLevel {
  Answer = 'ANSWER',
  Feedback = 'FEEDBACK',
  Mark = 'MARK'
}

/** Moderation decisions for feedback of a submission outcome. */
export enum FeedbackModerationDecision {
  Custom = 'CUSTOM',
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY'
}

/** Input for feedback moderation decision. :highest and :lowest resolve per-outcome to :primary or :secondary. */
export enum FeedbackModerationDecisionInput {
  Custom = 'CUSTOM',
  Highest = 'HIGHEST',
  Lowest = 'LOWEST',
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY'
}

/** Types of Feedback Release Rule. */
export enum FeedbackReleaseBasePool {
  All = 'ALL',
  Empty = 'EMPTY'
}

/** Feedback Release Rule to release feedback to students in the future. */
export type FeedbackReleaseRule = {
  __typename?: 'FeedbackReleaseRule';
  basePool: FeedbackReleaseBasePool;
  excludedStudentIds: Array<Scalars['ID']['output']>;
  excludedTags: Array<Scalars['String']['output']>;
  executedAt: Maybe<Scalars['DateTime']['output']>;
  executedStudentIds: Maybe<Array<Scalars['ID']['output']>>;
  id: Scalars['ID']['output'];
  includedGroupIds: Array<Scalars['ID']['output']>;
  includedStudentIds: Array<Scalars['ID']['output']>;
  includedTags: Array<Scalars['String']['output']>;
  releaseType: FeedbackReleaseType;
  ruleKind: ReleaseRuleKind;
  scheduledAt: Maybe<Scalars['DateTime']['output']>;
};

export type FeedbackReleaseRuleInput = {
  basePool: FeedbackReleaseBasePool;
  excludedStudentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  excludedTags?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  includedGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includedStudentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includedTags?: InputMaybe<Array<Scalars['String']['input']>>;
  releaseType?: InputMaybe<FeedbackReleaseType>;
  ruleKind: ReleaseRuleKind;
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum FeedbackReleaseType {
  Final = 'FINAL',
  Provisional = 'PROVISIONAL'
}

/**
 * Assessment-wide Feedback Visibility. Controls level of feedback visible to
 * the students after it is released. They are unique on AssessmentID and
 * ReleaseType.
 */
export type FeedbackVisibility = {
  __typename?: 'FeedbackVisibility';
  feedbackViewLevel: FeedbackLevel;
  id: Scalars['ID']['output'];
  jointRelease: Scalars['Boolean']['output'];
  notifyStudents: Scalars['Boolean']['output'];
  releaseType: FeedbackReleaseType;
  showPeerComments: Scalars['Boolean']['output'];
  showPeerScores: Scalars['Boolean']['output'];
  withFeedbackPdf: Scalars['Boolean']['output'];
};

export type FeedbackVisibilityInput = {
  feedbackViewLevel: FeedbackLevel;
  jointRelease?: InputMaybe<Scalars['Boolean']['input']>;
  notifyStudents?: InputMaybe<Scalars['Boolean']['input']>;
  releaseType?: InputMaybe<FeedbackReleaseType>;
  showPeerComments?: InputMaybe<Scalars['Boolean']['input']>;
  showPeerScores?: InputMaybe<Scalars['Boolean']['input']>;
  withFeedbackPdf: Scalars['Boolean']['input'];
};

/** Outcome on a single field in a question. */
export type FieldOutcome = {
  __typename?: 'FieldOutcome';
  /** Single answer if given */
  answer: Maybe<Scalars['String']['output']>;
  /** Similarity score for the answer */
  answerSimilarity: Maybe<Scalars['Float']['output']>;
  /** Multiple answers if given */
  answers: Maybe<Array<Scalars['String']['output']>>;
  automarkScore: Maybe<Scalars['Float']['output']>;
  /** Status of the automarking */
  automarkStatus: Maybe<AutomarkStatus>;
  comments: Maybe<Array<Comment>>;
  docContent: Maybe<Scalars['String']['output']>;
  docStreamUuid: Maybe<Scalars['ID']['output']>;
  docVersion: Maybe<Scalars['Int']['output']>;
  fieldRubricId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Unique identifier within the question */
  identifier: Scalars['String']['output'];
  markerScore: Maybe<Scalars['Float']['output']>;
  referencesDocContent: Maybe<Scalars['String']['output']>;
  referencesDocStreamUuid: Maybe<Scalars['ID']['output']>;
  referencesDocVersion: Maybe<Scalars['Int']['output']>;
  /** Marking outcome from using a MarkerRubric to score the parent Outcome. */
  rubricOutcome: RubricOutcome;
  score: Maybe<Scalars['Float']['output']>;
  /** Best matched expected response value */
  targetValue: Maybe<Scalars['String']['output']>;
};

/**
 * FieldOutcomeRelease represents a snapshot of a field outcome at release time.
 * Contains the marking and feedback for a specific field within a question.
 */
export type FieldOutcomeRelease = {
  __typename?: 'FieldOutcomeRelease';
  /** Single answer if given */
  answer: Maybe<Scalars['String']['output']>;
  /** Similarity score for the answer */
  answerSimilarity: Maybe<Scalars['Float']['output']>;
  /** Multiple answers if given */
  answers: Maybe<Array<Scalars['String']['output']>>;
  automarkScore: Maybe<Scalars['Float']['output']>;
  commentReleases: Array<CommentRelease>;
  criterionOutcomeReleases: Array<CriterionOutcomeRelease>;
  docContent: Maybe<Scalars['String']['output']>;
  docStreamUuid: Maybe<Scalars['ID']['output']>;
  docVersion: Maybe<Scalars['Int']['output']>;
  fieldRubricId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Unique identifier within the question */
  identifier: Scalars['String']['output'];
  markerScore: Maybe<Scalars['Float']['output']>;
  referencesDocContent: Maybe<Scalars['String']['output']>;
  referencesDocStreamUuid: Maybe<Scalars['ID']['output']>;
  referencesDocVersion: Maybe<Scalars['Int']['output']>;
  score: Scalars['Float']['output'];
  /** Best matched expected response value */
  targetValue: Maybe<Scalars['String']['output']>;
  threadReleases: Array<ThreadRelease>;
};

export type FieldResponse = {
  __typename?: 'FieldResponse';
  /** Single answer */
  answer: Maybe<Scalars['String']['output']>;
  /** Multiple answers (such as ranges) */
  answers: Maybe<Array<Scalars['String']['output']>>;
  count: Scalars['Int']['output'];
  /** If the response was correct. */
  isCorrect: Scalars['Boolean']['output'];
  /** @deprecated Use `answer` instead. */
  response: Maybe<Scalars['String']['output']>;
  /** Best similarity score from 0 to 1 if the response was not correct. */
  similarity: Maybe<Scalars['Float']['output']>;
};

/** Rubric for a single field across all questions in the assessment task. */
export type FieldRubric = {
  __typename?: 'FieldRubric';
  /** Whether the field is automarked. */
  automarked: Scalars['Boolean']['output'];
  baseType: Maybe<BaseType>;
  caseSensitive: Scalars['Boolean']['output'];
  /** List of accepted position area answers */
  correctAreas: Maybe<Array<PositionArea>>;
  /** List of accepted numerical range answers */
  correctRanges: Maybe<Array<NumericRange>>;
  errorMargin: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  markerChanges: Maybe<FieldRubricChanges>;
  markerRubric: Maybe<MarkerRubric>;
  moderatorChanges: Maybe<FieldRubricChanges>;
  partialScoring: Scalars['Boolean']['output'];
  /** Aggregate of all responses provided to the field. */
  responses: Array<FieldResponse>;
  similarity: Maybe<Scalars['Float']['output']>;
  /** String matching strategy */
  strategy: Maybe<MatchStrategy>;
  /** List of accepted answers */
  values: Maybe<Array<Scalars['String']['output']>>;
};

/** Overriding change tracking made by marker or moderator to a FieldRubric. */
export type FieldRubricChanges = {
  __typename?: 'FieldRubricChanges';
  id: Scalars['ID']['output'];
  valuesAdded: Array<Scalars['String']['output']>;
  valuesRemoved: Array<Scalars['String']['output']>;
};

export type FindSimilarQuestionsInput = {
  excludeQuestionIds: Array<Scalars['ID']['input']>;
  questionIds: Array<Scalars['ID']['input']>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** The input object which represents the global portion of the user's settings. */
export type GlobalUserSettingsInput = {
  /** User must be shown the IA onboarding */
  showIaOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  showUserpilotOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Grade information for a Result.
 *
 * A grade stored as a floating point numeric value between 0 and 1. For display
 * however, this value has to be mulitplied by the latest released maximum grade
 * point requirements. The display is also string formatted with 2-digit padding
 * and 2-decimal point accuracy.
 */
export type Grade = {
  __typename?: 'Grade';
  /** Human formatted representation of the grade */
  display: Scalars['String']['output'];
  /** Maximum score possible */
  max: Scalars['Int']['output'];
  /** Actual 0-1 grade value */
  value: Scalars['Float']['output'];
};

/** Background processing result for a Submission against a Result. */
export type GradebookReceipt = {
  __typename?: 'GradebookReceipt';
  /** Email receipt sent to student. */
  emailComplete: Scalars['Boolean']['output'];
  /** Submission PDF or Record sent to the LMS. */
  lmsComplete: Scalars['Boolean']['output'];
  /** LMS Stage is snoozed until this date. */
  lmsSnooze: Maybe<Scalars['DateTime']['output']>;
  /** PDF WorkArtifact ID for complete render of the Submission. */
  pdfArtifactId: Maybe<Scalars['ID']['output']>;
  /** Submission PDF sent to Turnitin. */
  turnitinComplete: Scalars['Boolean']['output'];
};

/** Known service integrations into the Cadmus Gradebook result */
export enum GradebookService {
  Cadmusgrader = 'CADMUSGRADER',
  Moodlegrader = 'MOODLEGRADER',
  Speedgrader = 'SPEEDGRADER',
  Turnitin = 'TURNITIN'
}

/** A group of students in an assessment */
export type Group = {
  __typename?: 'Group';
  /** Group members whose enrollment has not been withdrawn */
  activeGroupMembers: Array<GroupMember>;
  code: Maybe<Scalars['String']['output']>;
  /** Whether this group has been finalised */
  finalised: Scalars['Boolean']['output'];
  /** The date and time when this group was finalised */
  finalisedAt: Maybe<Scalars['DateTime']['output']>;
  groupMembers: Array<GroupMember>;
  groupSet: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  marker: Maybe<User>;
  markerId: Maybe<Scalars['ID']['output']>;
  /** The maximum number of students that can be in a group */
  maxLimit: Maybe<Scalars['Int']['output']>;
  /**
   * Deprecated: use :group_members or :active_group_members instead
   * @deprecated Use groupMembers or activeGroupMembers instead
   */
  members: Array<User>;
  /** The minimum number of students required to be in a group */
  minLimit: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  questionId: Maybe<Scalars['String']['output']>;
  /** Section this group is scoped to (null = whole-class group) */
  sectionId: Maybe<Scalars['ID']['output']>;
  /** Tags attached to this group */
  tags: Array<GroupTag>;
  workSettings: Maybe<WorkSettings>;
};

export type GroupExtensionInput = {
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  updateReason?: InputMaybe<Scalars['String']['input']>;
};

export type GroupInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  groupSet?: InputMaybe<Scalars['String']['input']>;
  maxLimit?: InputMaybe<Scalars['Int']['input']>;
  members?: InputMaybe<Array<Scalars['ID']['input']>>;
  minLimit?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  sectionId?: InputMaybe<Scalars['ID']['input']>;
};

/** A marker assigned to a group member. */
export type GroupMarker = {
  __typename?: 'GroupMarker';
  groupMemberId: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  marker: Maybe<User>;
  markerId: Maybe<Scalars['ID']['output']>;
  markerPlaceholder: Maybe<Scalars['String']['output']>;
  role: MarkerRole;
};

/** A member of a group in an assessment. */
export type GroupMember = {
  __typename?: 'GroupMember';
  /** Avatar colourset, de-conflicted within the group */
  colourset: Scalars['Int']['output'];
  groupMarkers: Array<GroupMarker>;
  id: Scalars['ID']['output'];
  /** Whether this member's enrollment is currently active (not withdrawn) */
  isActive: Scalars['Boolean']['output'];
  user: Maybe<User>;
};

export type GroupMembershipInput = {
  groupId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type GroupRule = {
  markerId?: InputMaybe<Scalars['String']['input']>;
  markerIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  questionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Section to form these groups within (null = whole-class) */
  sectionId?: InputMaybe<Scalars['ID']['input']>;
  totalStudents?: InputMaybe<Scalars['Int']['input']>;
};

/** Group-formation settings persisted alongside setup_groups. */
export type GroupSettingsInput = {
  groupChangeRequestCutoff?: InputMaybe<Scalars['DateTime']['input']>;
  groupChangeRequestsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  groupFinalised?: InputMaybe<Scalars['Boolean']['input']>;
  groupHideMembersName?: InputMaybe<Scalars['Boolean']['input']>;
  groupShowEmailToStudents?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A Tag attached to a Group */
export type GroupTag = {
  __typename?: 'GroupTag';
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
};

/** Purpose of the groups setup in an Assessment */
export enum GroupType {
  Question = 'QUESTION',
  Student = 'STUDENT'
}

export type GroupUpdateInput = {
  addedMembers?: InputMaybe<Array<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
  markerId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  removedMembers?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Input for importing library question to task block */
export type ImportLibraryQuestionInput = {
  questionId: Scalars['ID']['input'];
  questionVersionId?: InputMaybe<Scalars['ID']['input']>;
  taskBlockId: Scalars['ID']['input'];
};

export type ImportSectionsInput = {
  assignments: Array<SectionAssignmentInput>;
};

/** Result of importing a section roster, including roster mismatches. */
export type ImportSectionsResult = {
  __typename?: 'ImportSectionsResult';
  sections: Array<Section>;
  /** user_ids enrolled in the assessment but absent from the upload */
  ungroupedStudents: Array<Scalars['ID']['output']>;
  /** user_ids present in the upload but not enrolled in the assessment */
  unmatchedStudents: Array<Scalars['ID']['output']>;
};

export type ImportSmartCommentInput = {
  content: Scalars['String']['input'];
  maxScore: Scalars['Int']['input'];
  rangeFrom?: InputMaybe<Scalars['Int']['input']>;
  rangeTo: Scalars['Int']['input'];
  skillId: Scalars['ID']['input'];
};

export type ImportSmartCommentsResult = {
  __typename?: 'ImportSmartCommentsResult';
  /** Content of entries that were skipped because they duplicated another entry in the same import, or an existing smart comment for the same skill. */
  skippedDuplicates: Array<Scalars['String']['output']>;
  smartComments: Array<SmartComment>;
};

/** Cadmus Institution. */
export type Institution = {
  __typename?: 'Institution';
  /**
   * Institution has the Access Code feature pack added to their account
   * @deprecated Use query-level `featureFlags
   */
  accessCodeFeatureEnabled: Scalars['Boolean']['output'];
  apiStatus: ApiStatusType;
  /**
   * Institution has the Cadmus Grader feature pack added to their account
   * @deprecated Use query-level `featureFlags
   */
  cadmusGraderFeatureEnabled: Scalars['Boolean']['output'];
  /** Institution's country of origin information. Also known as home country. */
  country: Country;
  /** Custom declaration Rich text JSON from contentful */
  customDeclarationText: Maybe<Scalars['String']['output']>;
  /**
   * Institution has the Exams feature pack added to their account
   * @deprecated Use query-level `featureFlags
   */
  examsFeatureEnabled: Scalars['Boolean']['output'];
  /**
   * Feature flags enabled for the institution.
   * @deprecated Use query-level `featureFlags`
   */
  features: InstitutionFeatures;
  /**
   * Institution has the Footnote Referencing feature pack added to their account
   * @deprecated Use query-level `featureFlags
   */
  footnoteReferencingEnabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /**
   * Institution has the LDB feature pack added to their account
   * @deprecated Use query-level `featureFlags
   */
  ldbFeatureEnabled: Scalars['Boolean']['output'];
  /**
   * Institution has the Moodle Grader feature pack added to their account
   * @deprecated Use query-level `featureFlags
   */
  moodlegraderFeatureEnabled: Scalars['Boolean']['output'];
  /**
   * Institution has the Multiformat Task feature pack added to their account
   * @deprecated Use query-level `featureFlags
   */
  multiformatFeatureEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  tenant: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
  /**
   * Institution has the Turnitin Feedback Studio feature pack added to their account
   * @deprecated Use query-level `featureFlags
   */
  turnitinGraderFeatureEnabled: Scalars['Boolean']['output'];
};

/** Institution feature flags. */
export type InstitutionFeatures = {
  __typename?: 'InstitutionFeatures';
  accessCode: Scalars['Boolean']['output'];
  adminAccess: Scalars['Boolean']['output'];
  advancedMarking: Scalars['Boolean']['output'];
  autoExtensionSync: Scalars['Boolean']['output'];
  cadmusGrader: Scalars['Boolean']['output'];
  exams: Scalars['Boolean']['output'];
  extensionSyncing: Scalars['Boolean']['output'];
  footnoteReferencing: Scalars['Boolean']['output'];
  genAiDeclaration: Scalars['Boolean']['output'];
  groupAssessment: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  labsContextualiser: Scalars['Boolean']['output'];
  moodleGrader: Scalars['Boolean']['output'];
  multiformat: Scalars['Boolean']['output'];
  questionLibrary: Scalars['Boolean']['output'];
  respondusLdb: Scalars['Boolean']['output'];
  schoolyear: Scalars['Boolean']['output'];
  smartAutomarking: Scalars['Boolean']['output'];
  timeline: Scalars['Boolean']['output'];
  turnitin: Scalars['Boolean']['output'];
  turnitinGrader: Scalars['Boolean']['output'];
  viva: Scalars['Boolean']['output'];
};

/** Institution LMS Tool Provider information. */
export type InstitutionTool = {
  __typename?: 'InstitutionTool';
  familyCode: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
};

export type IssueAssigneeInput = {
  userId: Scalars['ID']['input'];
};

export enum IssueStatus {
  Blocked = 'BLOCKED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

export enum IssueType {
  Milestone = 'MILESTONE',
  Task = 'TASK'
}

/** Status information on a background Job */
export type Job = {
  __typename?: 'Job';
  assessmentId: Scalars['ID']['output'];
  conflict: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  /** Final result URL if available */
  resultUrl: Maybe<Scalars['String']['output']>;
};

export type LearningOutcomeSkill = {
  __typename?: 'LearningOutcomeSkill';
  id: Scalars['ID']['output'];
  skill: Scalars['String']['output'];
};

/** An LTI Service like AGS or NRPS. */
export type LtiService = {
  __typename?: 'LtiService';
  id: Scalars['ID']['output'];
  isLtiPluginAgs: Scalars['Boolean']['output'];
  /** LTI Advantage (V2) services have OAuth2 token issuers */
  issuer: Maybe<Scalars['String']['output']>;
  metaUrl: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/**
 * A Mailing List representation which can be active or in-active depending on
 * the `subscribed` field.
 */
export type MailingList = {
  __typename?: 'MailingList';
  id: Scalars['String']['output'];
  members: Array<Scalars['String']['output']>;
  subscribed: Scalars['Boolean']['output'];
};

export type MarkFieldOutcomeInput = {
  fieldOutcomeId: Scalars['ID']['input'];
  scaleItemId?: InputMaybe<Scalars['Int']['input']>;
  score: Scalars['Float']['input'];
};

export type MarkFieldOutcomePayload = {
  __typename?: 'MarkFieldOutcomePayload';
  fieldOutcome: FieldOutcome;
  questionOutcome: QuestionOutcome;
  workOutcome: WorkOutcome;
};

export type MarkPeerOutcomeInput = {
  scaleItemId: Scalars['ID']['input'];
  targetUserId: Scalars['ID']['input'];
};

export type MarkSubmissionOutcomeInput = {
  scaleItemId?: InputMaybe<Scalars['Int']['input']>;
  score: Scalars['Float']['input'];
  submissionOutcomeId: Scalars['Int']['input'];
};

export type MarkSubmissionOutcomePayload = {
  __typename?: 'MarkSubmissionOutcomePayload';
  studentOutcomes: Array<StudentOutcome>;
  submissionOutcome: SubmissionOutcome;
  workOutcome: WorkOutcome;
};

export type MarkerAdjustmentPayload = {
  __typename?: 'MarkerAdjustmentPayload';
  studentOutcome: StudentOutcome;
};

/** Input for creating or updating markers assigned to members. */
export type MarkerForMembersInput = {
  markerId?: InputMaybe<Scalars['ID']['input']>;
  markerPlaceholder?: InputMaybe<Scalars['String']['input']>;
  role: MarkerRole;
  userIds: Array<Scalars['ID']['input']>;
};

export enum MarkerRole {
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY'
}

export type MarkerRubric = {
  __typename?: 'MarkerRubric';
  assessmentId: Scalars['ID']['output'];
  /** @deprecated Use `location` field instead. */
  assessmentName: Scalars['String']['output'];
  criteria: Array<Criterion>;
  format: MarkerRubricFormat;
  /** Has un-published changes over the last published version. */
  hasChanges: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  kind: MarkerRubricKind;
  location: MarkerRubricLocation;
  /** @deprecated Use `has_outcomes` field of each criteria instead. */
  markingExists: Scalars['Boolean']['output'];
  /** Last publish timestamp */
  publishedAt: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use `location` field instead. */
  questionShortPrompt: Maybe<Scalars['String']['output']>;
  reversedScale: Scalars['Boolean']['output'];
  /** Lifecycle state of the rubric. */
  state: MarkerRubricState;
  /** Timestamp of the last save. */
  updatedAt: Maybe<Scalars['PreciseDateTime']['output']>;
};

/**
 * The format of the MarkerRubric determines how Scale Items are defined for
 * each Criterion:
 *
 *   * `:percentage` – Each criterion's scale items represent percentage ranges
 *   * `:points` – Each criterion defines a range of possible point values.
 *   * `:absolute` – Each criterion allows selection of a single, fixed point value.
 */
export enum MarkerRubricFormat {
  Absolute = 'ABSOLUTE',
  Percentage = 'PERCENTAGE',
  Points = 'POINTS'
}

export type MarkerRubricInput = {
  criteria: Array<CriterionInput>;
  format: MarkerRubricFormat;
  kind?: InputMaybe<MarkerRubricKind>;
  reversedScale: Scalars['Boolean']['input'];
};

/** Kinds of Marker Rubrics for different purposes. */
export enum MarkerRubricKind {
  Extended = 'EXTENDED',
  Group = 'GROUP',
  Individual = 'INDIVIDUAL',
  Peer = 'PEER'
}

/** Location of a MarkerRubric within an Assessment. */
export type MarkerRubricLocation = {
  __typename?: 'MarkerRubricLocation';
  /** assessment name */
  assessment: Scalars['String']['output'];
  /** path within the assessment */
  path: Scalars['String']['output'];
  /** question ID for extended marker rubrics */
  questionId: Maybe<Scalars['ID']['output']>;
};

/** Lifecycle state of a MarkerRubric. */
export enum MarkerRubricState {
  /** Has draft changes (or was never released) */
  Draft = 'DRAFT',
  /** Has draft changes that fail publish-level validation */
  DraftError = 'DRAFT_ERROR',
  /** Published with no pending draft changes */
  Released = 'RELEASED'
}

export enum MarkerRubricStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

/** Scope of the marker in the submission outcome. */
export enum MarkerScope {
  Average = 'AVERAGE',
  Custom = 'CUSTOM',
  Main = 'MAIN',
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY'
}

/** Marker scopes allowed for creation of marking outcomes. */
export enum MarkerScopeInput {
  Custom = 'CUSTOM',
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY'
}

export enum MarkingRole {
  Marker = 'MARKER',
  Moderator = 'MODERATOR'
}

/** Marking tool used for the assessment. */
export enum MarkingTool {
  Cadmusgrader = 'CADMUSGRADER',
  Moodlegrader = 'MOODLEGRADER',
  Speedgrader = 'SPEEDGRADER',
  Turnitin = 'TURNITIN'
}

/**
 * Restrict student result view via the PDF sent to the LMS marking tool.
 *
 *   * UnmarkedOnly - Show un-marked responses only
 *
 *   * UnmarkedAndAutomarkedSummary - Show un-marked responses and auto-mark
 *     summary
 */
export enum MarkingToolPdf {
  UnmarkedAndAutomarkedSummary = 'UNMARKED_AND_AUTOMARKED_SUMMARY',
  UnmarkedOnly = 'UNMARKED_ONLY'
}

export type MatchInteraction = {
  __typename?: 'MatchInteraction';
  /** Answer options that can be selected for matching */
  sourceSet: Array<SimpleChoice>;
  /** Prompts that are matched against */
  targetSet: Array<SimpleChoice>;
};

export type MatchInteractionInput = {
  sourceSet: Array<SimpleChoiceInput>;
  targetSet: Array<SimpleChoiceInput>;
};

/** Matching strategy used to auto-mark a string Field */
export enum MatchStrategy {
  Exact = 'EXACT',
  Levdist = 'LEVDIST',
  Smart = 'SMART'
}

export type MemberContribution = {
  __typename?: 'MemberContribution';
  deletions: Array<DeletedContribution>;
  ranges: Array<ContributedRange>;
  userId: Scalars['ID']['output'];
};

export type MemberProgress = {
  __typename?: 'MemberProgress';
  lastEventTimestamp: Maybe<Scalars['PreciseDateTime']['output']>;
  status: ProgressStatus;
  userId: Scalars['ID']['output'];
  workId: Maybe<Scalars['ID']['output']>;
};

export type MemberSummary = {
  __typename?: 'MemberSummary';
  accessCount: Scalars['Int']['output'];
  lastAccess: Scalars['PreciseDateTime']['output'];
  userId: Scalars['ID']['output'];
};

/** A Message sent in a Class from an enrolled user. */
export type Message = {
  __typename?: 'Message';
  expiresAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  messageType: MessageRequestType;
  resolvedAt: Maybe<Scalars['DateTime']['output']>;
  sourceUserId: Scalars['ID']['output'];
};

export type MessageInput = {
  expiresInDays?: InputMaybe<Scalars['Int']['input']>;
  messageType: MessageRequestType;
  targetUserId?: InputMaybe<Scalars['ID']['input']>;
};

export enum MessageRequestType {
  GroupChange = 'GROUP_CHANGE'
}

export type Metadata = {
  __typename?: 'Metadata';
  /** ID of the BlockAttachment this thread is about */
  blockAttachmentId: Maybe<Scalars['Int']['output']>;
  /** Display name of the file */
  blockAttachmentName: Maybe<Scalars['String']['output']>;
  /** ID of the charter editor associated with this thread. */
  charterEditorId: Maybe<Scalars['ID']['output']>;
  /** Type of charter section this thread is associated with, can be 'Editor' or 'Milestone'. */
  charterSectionType: Maybe<CharterSectionType>;
};

/** Input for charter milestone details for updating it */
export type MilestoneInput = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** can be null for new milestones */
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Milestone preset type for charter form section */
export type MilestonePresetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  /** Datetime when the milestone is due */
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Unique identifier for the milestone preset */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Title for the milestone */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Milestone preset type for charter form section */
export type MilestonePresetType = {
  __typename?: 'MilestonePresetType';
  description: Maybe<Scalars['String']['output']>;
  /** Datetime this milestone is due */
  dueDate: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier for the milestone preset */
  id: Scalars['ID']['output'];
  /** Title for the milestone */
  title: Maybe<Scalars['String']['output']>;
};

/** Derived moderation values computed from the moderation decision on a :main SubmissionOutcome. */
export type ModerationOutcome = {
  __typename?: 'ModerationOutcome';
  bodyDoc: Maybe<Scalars['String']['output']>;
  feedbackModerationId: Maybe<Scalars['ID']['output']>;
  /** The marker's additive adjustment on top of the rubric outcome score. */
  markerModifier: Maybe<Scalars['Float']['output']>;
  referencesDoc: Maybe<Scalars['String']['output']>;
  /** Rubric outcome derived from the moderation decision. */
  rubricOutcome: Maybe<RubricOutcome>;
  score: Maybe<Scalars['Float']['output']>;
  scoreModerationId: Maybe<Scalars['ID']['output']>;
};

/** Moderation Penalty Rule to apply penalties on feedback release. */
export type ModerationPenaltyRule = {
  __typename?: 'ModerationPenaltyRule';
  canStack: Scalars['Boolean']['output'];
  excludedStudentIds: Maybe<Array<Scalars['ID']['output']>>;
  formatUnit: Maybe<PenaltyFormatUnit>;
  id: Scalars['ID']['output'];
  includedGroupIds: Array<Scalars['ID']['output']>;
  includedTags: Maybe<Array<Scalars['String']['output']>>;
  minutesLateBy: Maybe<Scalars['Int']['output']>;
  penaltyScore: Scalars['Float']['output'];
  penaltyType: ModerationPenaltyType;
  reason: Maybe<Scalars['String']['output']>;
  ruleKind: PenaltyRuleKind;
  scoreUnit: PenaltyScoreUnit;
};

export type ModerationPenaltyRuleInput = {
  canStack: Scalars['Boolean']['input'];
  excludedStudentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  formatUnit: PenaltyFormatUnit;
  id?: InputMaybe<Scalars['ID']['input']>;
  includedGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includedTags?: InputMaybe<Array<Scalars['String']['input']>>;
  minutesLateBy?: InputMaybe<Scalars['Int']['input']>;
  penaltyScore: Scalars['Float']['input'];
  penaltyType: ModerationPenaltyType;
  reason?: InputMaybe<Scalars['String']['input']>;
  ruleKind: PenaltyRuleKind;
  scoreUnit?: InputMaybe<PenaltyScoreUnit>;
};

export enum ModerationPenaltyType {
  Custom = 'CUSTOM',
  MoreThan = 'MORE_THAN'
}

/**
 * A question in the moderation "Questions" view, fully computed on the server:
 * the instruction-sheet question-tree node merged with its rubric, response
 * counts, and rates. Resolves from `Marking.Moderation.QuestionSummary`.
 */
export type ModerationQuestion = {
  __typename?: 'ModerationQuestion';
  answerable: Maybe<Scalars['Boolean']['output']>;
  automarked: Scalars['Boolean']['output'];
  body: Maybe<QuestionBody>;
  hasMarkerChanges: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  longLabel: Maybe<Scalars['String']['output']>;
  maxScore: Maybe<Scalars['Float']['output']>;
  nodeId: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  parentNodeId: Maybe<Scalars['ID']['output']>;
  questionId: Scalars['ID']['output'];
  questionType: QuestionType;
  rates: Maybe<QuestionRates>;
  rubric: Maybe<QuestionRubric>;
  score: Maybe<Scalars['Float']['output']>;
  shortLabel: Maybe<Scalars['String']['output']>;
  shortPrompt: Maybe<Scalars['String']['output']>;
};

/** Response as multiple choice selections. */
export type MultiResponse = {
  __typename?: 'MultiResponse';
  cardinality: Maybe<Cardinality>;
  choices: Array<Choice>;
  partialScoring: Maybe<Scalars['Boolean']['output']>;
};

export type MultiResponseInput = {
  choices: Array<ChoiceInput>;
  /** Partial scoring for multiple choice questions. */
  partialScoring?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NumericRange = {
  __typename?: 'NumericRange';
  end: Scalars['Float']['output'];
  identifier: Scalars['ID']['output'];
  start: Scalars['Float']['output'];
};

export type NumericRangeInput = {
  end: Scalars['Float']['input'];
  identifier: Scalars['String']['input'];
  start: Scalars['Float']['input'];
};

/** Mutation return for `captureOnboardingInput`. */
export type OnboardingPayload = {
  __typename?: 'OnboardingPayload';
  subject: Maybe<Subject>;
  userSettings: Maybe<UserSettings>;
};

/** A lightweight signal that an assessment's student outcomes have changed. */
export type OutcomeSyncSignal = {
  __typename?: 'OutcomeSyncSignal';
  /** How many student outcomes changed in this batch. */
  changedCount: Scalars['Int']['output'];
  /** IDs of the students whose outcomes changed in this batch. */
  studentIds: Array<Scalars['ID']['output']>;
};

export type OutcomesDeletedPayload = {
  __typename?: 'OutcomesDeletedPayload';
  outcomesDeleted: Scalars['Int']['output'];
};

/** A past instruction, which includes information about each assessment and its related, latest released instructions. */
export type PastInstructionSheet = {
  __typename?: 'PastInstructionSheet';
  assessment: Assessment;
  id: Scalars['ID']['output'];
  sheet: Sheet;
};

/** How peer evaluation scores affect the final grade. :component adds the peer score as a grade component; :scaling applies a scale factor to the group report score. */
export enum PeerEvaluationMode {
  Component = 'COMPONENT',
  Scaling = 'SCALING'
}

/** Marking outcome when a student peer evaluates another peer in a group. */
export type PeerOutcome = {
  __typename?: 'PeerOutcome';
  /** DEPRECATED: Use is_complete instead. When all group members published their complete evaluations of the target_user_id */
  completedAt: Maybe<Scalars['PreciseDateTime']['output']>;
  /** All Criterion selections made by peers against this Peer Outcome */
  criterionOutcomes: Array<CriterionOutcome>;
  /** When this student finished evaluating all their peers — the last time they touched an evaluation they authored. Inferred from activity, not an explicit submit: post-due drafts count. Nil while has_evaluated_all_peers is false, or when they had nobody to evaluate. Compare against the peer evaluation due date to show lateness. */
  evaluationsSubmittedAt: Maybe<Scalars['PreciseDateTime']['output']>;
  /** When the peer outcome was used for the Students Gradebook Result */
  feedbackReleasedTimestamp: Maybe<Scalars['PreciseDateTime']['output']>;
  /** Criterion selections that the current user has made on this Peer Outcome. */
  givenCriterionOutcomes: Array<CriterionOutcome>;
  /**
   * Scale factor applied to the group report score. Present when peer
   * evaluation is enabled in scaling mode. Computed per member as
   * `sqrt(peer_score / average_group_peer_score)`, clamped to
   * `[peer_evaluation_min_scale_factor, peer_evaluation_max_scale_factor]`.
   * Students who did not complete every assigned peer evaluation receive
   * `peer_evaluation_min_scale_factor` and are excluded from the group
   * average used to derive other members' factors.
   */
  groupReportScaleFactor: Maybe<Scalars['Float']['output']>;
  /** Whether this student submitted their self evaluation. True when self_evaluation is disabled. */
  hasCompletedSelfEvaluation: Maybe<Scalars['Boolean']['output']>;
  /** Whether this student completed every assigned peer evaluation. Pre-due requires published criterion outcomes for each (peer × criterion); post-due drafts also count, so a student who filled every score but did not finalise is still considered complete. */
  hasEvaluatedAllPeers: Maybe<Scalars['Boolean']['output']>;
  /** Whether every required peer published a complete evaluation of this student (all criteria covered by every required peer). */
  hasReceivedAllEvaluations: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /**
   * Whether the peer outcome is complete (all required evaluations submitted and published). Replaces completed_at logic.
   * @deprecated Use has_received_all_evaluations and has_completed_self_evaluation instead.
   */
  isComplete: Maybe<Scalars['Boolean']['output']>;
  /** Max score for peer evaluation, taken from assessment settings */
  peerMaxScore: Maybe<Scalars['Int']['output']>;
  /** Computed peer score, only available when is_complete is true and the assessment has peer_evaluations enabled */
  peerScore: Maybe<Scalars['Float']['output']>;
  /** Max score for self evaluation, taken from assessment settings */
  selfMaxScore: Maybe<Scalars['Int']['output']>;
  /** Precomputed self score, only available when is_complete is true, and the assessment has self_evaluations enabled */
  selfScore: Maybe<Scalars['Float']['output']>;
  /** Student being evaluated */
  targetUserId: Scalars['ID']['output'];
};

export enum PenaltyFormatUnit {
  Custom = 'CUSTOM',
  Day = 'DAY',
  Hour = 'HOUR',
  Minute = 'MINUTE'
}

/** Scope a moderation penalty rule applies to. */
export enum PenaltyRuleKind {
  Group = 'GROUP',
  Individual = 'INDIVIDUAL',
  Peer = 'PEER'
}

/** Format of Moderation Penalty Value Unit. */
export enum PenaltyScoreUnit {
  Percentage = 'PERCENTAGE',
  Points = 'POINTS'
}

/** A single position area in a position object response. */
export type PositionArea = {
  __typename?: 'PositionArea';
  coords: Array<Scalars['Float']['output']>;
  identifier: Scalars['ID']['output'];
  shape: Shape;
};

export type PositionAreaInput = {
  coords: Array<Scalars['Float']['input']>;
  identifier: Scalars['String']['input'];
  shape: Shape;
};

export type PositionObjectInteraction = {
  __typename?: 'PositionObjectInteraction';
  /** Label for the position object */
  label: Maybe<Scalars['String']['output']>;
  /** Maximum number of choices the user can select */
  maxChoices: Scalars['Int']['output'];
};

export type PositionObjectInteractionInput = {
  /** Label for the interaction */
  label: Scalars['String']['input'];
  maxChoices?: InputMaybe<Scalars['Int']['input']>;
};

export type PrintArchiveInput = {
  assessmentName: Scalars['String']['input'];
  date?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ProgressItem = {
  __typename?: 'ProgressItem';
  entityId: Scalars['ID']['output'];
  lastEventTimestamp: Maybe<Scalars['PreciseDateTime']['output']>;
  members: Array<MemberProgress>;
  overallStatus: ProgressStatus;
};

export type ProgressSection = {
  __typename?: 'ProgressSection';
  items: Array<ProgressItem>;
  statistics: ProgressStatistics;
};

export type ProgressStatistics = {
  __typename?: 'ProgressStatistics';
  inProgressCount: Scalars['Int']['output'];
  notStartedCount: Scalars['Int']['output'];
  submittedCount: Scalars['Int']['output'];
  viewedCount: Scalars['Int']['output'];
};

export enum ProgressStatus {
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  Submitted = 'SUBMITTED',
  Viewed = 'VIEWED'
}

/** SubmissionOutcome used in progress table for double-blind marking. Relax visibility rules to show progress to markers. Should not expose score. */
export type ProgressSubmissionOutcome = {
  __typename?: 'ProgressSubmissionOutcome';
  completedAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  markerScope: MarkerScope;
};

/** Issue for Assessment Group's Project Management Board */
export type ProjectIssue = {
  __typename?: 'ProjectIssue';
  /** List of user IDs assigned to the issue. */
  assignees: Array<Scalars['ID']['output']>;
  deleted: Scalars['Boolean']['output'];
  description: Maybe<Scalars['String']['output']>;
  dueDate: Maybe<Scalars['DateTime']['output']>;
  groupId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  parentId: Maybe<Scalars['ID']['output']>;
  status: IssueStatus;
  title: Scalars['String']['output'];
  type: IssueType;
};

/** Input to update Project Issues for Group Assessment */
export type ProjectIssueInput = {
  assignees?: InputMaybe<Array<IssueAssigneeInput>>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** ID of an existing issue or null for new issues. */
  id?: InputMaybe<Scalars['ID']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<IssueStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<IssueType>;
};

/** Image information and associated annotations. */
export type PromptImage = {
  __typename?: 'PromptImage';
  /** Image height */
  height: Scalars['Int']['output'];
  /** Image layers for annotations. */
  layers: Array<PromptImageLayer>;
  /** Image URL */
  url: Scalars['String']['output'];
  /** Image width */
  width: Scalars['Int']['output'];
};

/** Question Prompt Image attributes */
export type PromptImageInput = {
  /** Image height */
  height: Scalars['Int']['input'];
  /** Image layers attributes */
  layers?: InputMaybe<Array<PromptImageLayerInput>>;
  /** Image URL */
  url: Scalars['String']['input'];
  /** Image width */
  width: Scalars['Int']['input'];
};

/** Image layer information */
export type PromptImageLayer = {
  __typename?: 'PromptImageLayer';
  /** Layer coordinates */
  coords: Array<Scalars['Float']['output']>;
  /** Layer identifier */
  identifier: Scalars['String']['output'];
  /** Layer shape */
  shape: Shape;
};

/** Question Prompt Image Layer attributes */
export type PromptImageLayerInput = {
  /** Layer coordinates */
  coords: Array<Scalars['Float']['input']>;
  /** Layer identifier */
  identifier: Scalars['String']['input'];
  /** Layer shape */
  shape: Shape;
};

export type PublishImportedQuestionsInput = {
  assessmentId: Scalars['ID']['input'];
  questions: Array<QuestionAttributes>;
  sourceFile: SourceFileInput;
  subjectId: Scalars['ID']['input'];
  tags?: InputMaybe<Array<TagInput>>;
};

/** A single Question as part of the Cadmus Assessments. */
export type Question = {
  __typename?: 'Question';
  accessGroup: Maybe<AccessGroup>;
  accessRole: Maybe<AccessRole>;
  /** Whether the question was deleted from the library. */
  archived: Scalars['Boolean']['output'];
  /** Retrieves the list of assessments where the question was used. */
  assessmentUsages: Array<QuestionAssessment>;
  /** Question body with prompt and fields. */
  body: Maybe<QuestionBody>;
  /** Preferred caching ID on the client. */
  cacheId: Scalars['ID']['output'];
  childrenQuestions: Array<Question>;
  createdAt: Scalars['PreciseDateTime']['output'];
  currentVersionId: Maybe<Scalars['ID']['output']>;
  difficulty: Maybe<QuestionDifficulty>;
  hash: Scalars['HexString']['output'];
  id: Scalars['ID']['output'];
  lastUpdatedBy: Maybe<User>;
  libraryId: Scalars['String']['output'];
  /** Order for a child sub-question. */
  order: Maybe<Scalars['Int']['output']>;
  /** Parent question ID for sub questions. */
  parentQuestionId: Maybe<Scalars['ID']['output']>;
  /** Points alloted to this question. */
  points: Maybe<Scalars['Int']['output']>;
  questionType: QuestionType;
  /** Short plain text prompt description */
  shortPrompt: Maybe<Scalars['String']['output']>;
  shuffle: Scalars['Boolean']['output'];
  sourceFile: Maybe<QuestionSourceFile>;
  subjectGroupId: Maybe<Scalars['ID']['output']>;
  subjectId: Maybe<Scalars['ID']['output']>;
  /** Attached tags of the questions */
  tags: Array<QuestionTag>;
  /** Should be used only for task block edge. */
  updatedAt: Maybe<Scalars['PreciseDateTime']['output']>;
  /** @deprecated Version number is not relevant now as IDs are used for versioning. */
  version: Maybe<Scalars['Int']['output']>;
  /** All the versions of the question */
  versions: Array<QuestionVersion>;
};

export type QuestionAssessment = {
  __typename?: 'QuestionAssessment';
  /** When and how the question was used in an assessment. */
  assessment: Assessment;
  points: Maybe<Scalars['Int']['output']>;
  releaseTimestamp: Scalars['PreciseDateTime']['output'];
};

export type QuestionAttributes = {
  /** Difficulty level of the question */
  difficulty?: InputMaybe<QuestionDifficulty>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  /** Question fields with response declaration and interaction type */
  fields?: InputMaybe<Array<QuestionFieldInput>>;
  /** Order of the question in the parent question */
  order?: InputMaybe<Scalars['Int']['input']>;
  /** Parent question ID if this is a child of sub question */
  parentQuestionId?: InputMaybe<Scalars['ID']['input']>;
  /** Points for the question */
  points?: InputMaybe<Scalars['Int']['input']>;
  /** Question prompt prosemirror contents */
  promptDoc: Scalars['String']['input'];
  /** Question Prompt Image information and associated layers for a question prompt. */
  promptImage?: InputMaybe<PromptImageInput>;
  /** Question type */
  questionType: QuestionType;
  /** Short plain text prompt description */
  shortPrompt: Scalars['String']['input'];
  /** Shuffle the choices in the question */
  shuffle?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Updatable attributes for a question */
export type QuestionAttributesInput = {
  currentVersionId?: InputMaybe<Scalars['ID']['input']>;
  difficulty?: InputMaybe<QuestionDifficulty>;
  points?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionBank = {
  __typename?: 'QuestionBank';
  assessmentId: Maybe<Scalars['ID']['output']>;
  category: Maybe<QuestionBankCategory>;
  createdBy: User;
  difficulty: Maybe<QuestionDifficulty>;
  fileOrigin: Maybe<QuestionBankFileOrigin>;
  id: Scalars['ID']['output'];
  points: Maybe<Scalars['Int']['output']>;
  question: Question;
  questionBankId: Scalars['ID']['output'];
  subjectGroupId: Maybe<Scalars['ID']['output']>;
  subjectId: Maybe<Scalars['ID']['output']>;
};

export type QuestionBankCategory = {
  __typename?: 'QuestionBankCategory';
  assessmentId: Maybe<Scalars['ID']['output']>;
  createdBy: User;
  deleted: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  subjectGroupId: Maybe<Scalars['ID']['output']>;
  subjectId: Maybe<Scalars['ID']['output']>;
};

export type QuestionBankCategoryInput = {
  category: Scalars['String']['input'];
  scope: QuestionBankScope;
};

export type QuestionBankFileOrigin = {
  __typename?: 'QuestionBankFileOrigin';
  filename: Maybe<Scalars['String']['output']>;
  filepath: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type QuestionBankFilterInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  difficulty?: InputMaybe<QuestionDifficulty>;
  questionBankIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  questionType?: InputMaybe<QuestionType>;
};

export type QuestionBankNodes = {
  nodeId: Scalars['ID']['input'];
  parentNodeId?: InputMaybe<Scalars['ID']['input']>;
  previousNodeId?: InputMaybe<Scalars['ID']['input']>;
  questionBankId: Scalars['ID']['input'];
};

export type QuestionBankScope = {
  assessmentId?: InputMaybe<Scalars['ID']['input']>;
  subjectGroupId?: InputMaybe<Scalars['ID']['input']>;
  subjectId?: InputMaybe<Scalars['ID']['input']>;
};

/** A node (or sub-tree) in the QuestionTree */
export type QuestionBlock = {
  __typename?: 'QuestionBlock';
  /** e.g. Question 1 */
  longLabel: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the node */
  nodeId: Scalars['ID']['output'];
  /** Type of the node */
  nodeType: QuestionTreeNodeType;
  /** Order position of this node among siblings */
  order: Scalars['Int']['output'];
  /** ID of the parent node, if any */
  parentNodeId: Maybe<Scalars['ID']['output']>;
  /** Total points below this tree node */
  points: Maybe<Scalars['Int']['output']>;
  /** Question attached to this node */
  question: Maybe<Question>;
  questionId: Maybe<Scalars['ID']['output']>;
  questionSetId: Maybe<Scalars['ID']['output']>;
  /** e.g. Q1 */
  shortLabel: Maybe<Scalars['String']['output']>;
  /** Whether to shuffle this node's children */
  shuffle: Maybe<Scalars['Boolean']['output']>;
  socraticQuestionerEnabled: Scalars['Boolean']['output'];
};

/** Saved contents of the Question. */
export type QuestionBody = {
  __typename?: 'QuestionBody';
  feedback: Maybe<Scalars['String']['output']>;
  /** Interactions and their response declaration in the question. */
  fields: Maybe<Array<QuestionField>>;
  /** Question Body ID used for caching body separately, not expected to be used. */
  id: Scalars['ID']['output'];
  /** Serialised ProseMirror document */
  promptDoc: Maybe<Scalars['String']['output']>;
  /** Question Prompt Image information and associated layers for a question prompt. */
  promptImage: Maybe<PromptImage>;
  /** @deprecated Use `fields` */
  response: Maybe<QuestionResponse>;
};

export enum QuestionDifficulty {
  Easy = 'EASY',
  Hard = 'HARD',
  Medium = 'MEDIUM'
}

/** A single Question field. */
export type QuestionField = {
  __typename?: 'QuestionField';
  identifier: Scalars['String']['output'];
  /** How the student interacts with the field. */
  interaction: QuestionInteraction;
  /** How the response should be interpreted and marked. */
  response: Maybe<ResponseDeclaration>;
};

export type QuestionFieldInput = {
  choiceInteraction?: InputMaybe<ChoiceInteractionInput>;
  extendedInteraction?: InputMaybe<ExtendedInteractionInput>;
  identifier: Scalars['String']['input'];
  matchInteraction?: InputMaybe<MatchInteractionInput>;
  positionObjectInteraction?: InputMaybe<PositionObjectInteractionInput>;
  response: ResponseDeclarationInput;
  socraticInteraction?: InputMaybe<SocraticInteractionInput>;
  textEntryInteraction?: InputMaybe<TextEntryInteractionInput>;
};

/** Different kinds of interactions expected for a question. */
export type QuestionInteraction = ChoiceInteraction | ExtendedInteraction | MatchInteraction | PositionObjectInteraction | SocraticInteraction | TextEntryInteraction;

/** Outcome recorded for a single question answered by a Student. */
export type QuestionOutcome = {
  __typename?: 'QuestionOutcome';
  /** Answer snapshot submitted for marking by the student. */
  blockSnapshot: Maybe<BlockSnapshot>;
  fieldOutcomes: Array<FieldOutcome>;
  id: Scalars['ID']['output'];
  questionId: Scalars['ID']['output'];
  /** References snapshot submitted for marking by the student. */
  referencesBlockSnapshot: Maybe<BlockSnapshot>;
  /** Question outcome score breakdowns */
  scoreBreakdown: ScoreBreakdown;
};

/** QuestionOutcomeRelease represents a snapshot of a question outcome at release time. */
export type QuestionOutcomeRelease = {
  __typename?: 'QuestionOutcomeRelease';
  answerBlockId: Scalars['ID']['output'];
  /** Answer snapshot submitted for marking by the student. */
  blockSnapshot: Maybe<BlockSnapshot>;
  blockSnapshotId: Scalars['ID']['output'];
  fieldOutcomeReleases: Array<FieldOutcomeRelease>;
  /** The ID of the QuestionOutcome. */
  id: Scalars['ID']['output'];
  questionId: Scalars['ID']['output'];
  questionOutcomeId: Scalars['ID']['output'];
  referencesAnswerBlockId: Maybe<Scalars['ID']['output']>;
  /** References snapshot submitted for marking by the student. */
  referencesBlockSnapshot: Maybe<BlockSnapshot>;
  referencesBlockSnapshotId: Maybe<Scalars['ID']['output']>;
};

/** Server-computed response/success rates for a moderation question. */
export type QuestionRates = {
  __typename?: 'QuestionRates';
  averageScore: Maybe<Scalars['Float']['output']>;
  responseRate: Scalars['Int']['output'];
  successRate: Maybe<Scalars['Int']['output']>;
};

/** Different kinds of responses expected for a question. */
export type QuestionResponse = BlanksResponse | BooleanResponse | EditorResponse | MultiResponse | ShortResponse;

export type QuestionResponseCounts = {
  __typename?: 'QuestionResponseCounts';
  /** Average percentage score (0–100) across responses. Null when no responses exist. */
  averageScore: Maybe<Scalars['Float']['output']>;
  /** Count of provided responses. */
  responseCount: Scalars['Int']['output'];
  /** Count of responses that achieved 100% of the outcomes. */
  successCount: Scalars['Int']['output'];
};

/** A Question's marking rubric. */
export type QuestionRubric = {
  __typename?: 'QuestionRubric';
  /** Metrics on the responses provided to the marked question. */
  counts: QuestionResponseCounts;
  fieldRubrics: Array<FieldRubric>;
  id: Scalars['ID']['output'];
  maxScore: Scalars['Float']['output'];
  questionId: Scalars['ID']['output'];
};

/** Aggregated score for a single question within a WorkOutcome. */
export type QuestionScore = {
  __typename?: 'QuestionScore';
  questionId: Scalars['ID']['output'];
  score: Maybe<Scalars['Float']['output']>;
};

export type QuestionSelection = {
  __typename?: 'QuestionSelection';
  id: Scalars['ID']['output'];
  rules: Array<QuestionSelectionRule>;
  sets: Maybe<Array<QuestionSet>>;
  setsQuantity: Scalars['Int']['output'];
};

export type QuestionSelectionFilterInput = {
  selectedSetId: Scalars['Int']['input'];
  selectionId: Scalars['ID']['input'];
};

export type QuestionSelectionInput = {
  excludeQuestionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeUsed?: InputMaybe<Scalars['Boolean']['input']>;
  overlap?: InputMaybe<Scalars['Boolean']['input']>;
  questionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  questionsPerSet?: InputMaybe<Scalars['Int']['input']>;
  rules: Array<QuestionSelectionRuleInput>;
  setsQuantity: Scalars['Int']['input'];
  usedFrom?: InputMaybe<Scalars['DateTime']['input']>;
  usedTo?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QuestionSelectionRule = {
  __typename?: 'QuestionSelectionRule';
  createdBy: Maybe<Scalars['ID']['output']>;
  difficulty: Maybe<QuestionDifficulty>;
  id: Scalars['ID']['output'];
  includeUsed: Maybe<Scalars['Boolean']['output']>;
  points: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  questionType: QuestionType;
  usedFrom: Maybe<Scalars['DateTime']['output']>;
  usedTo: Maybe<Scalars['DateTime']['output']>;
};

export type QuestionSelectionRuleInput = {
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  difficulty?: InputMaybe<QuestionDifficulty>;
  includeUsed?: InputMaybe<Scalars['Boolean']['input']>;
  points: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
  questionType: QuestionType;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  usedFrom?: InputMaybe<Scalars['DateTime']['input']>;
  usedTo?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QuestionSet = {
  __typename?: 'QuestionSet';
  id: Scalars['ID']['output'];
  label: Maybe<Scalars['String']['output']>;
  order: Maybe<Scalars['Int']['output']>;
  questions: Array<QuestionSetQuestion>;
};

export type QuestionSetQuestion = {
  __typename?: 'QuestionSetQuestion';
  id: Scalars['ID']['output'];
  /** Tree layout node Id for the question inside question set */
  nodeId: Scalars['ID']['output'];
  /** Tree layout previous node Id for the question inside question set */
  parentNodeId: Maybe<Scalars['ID']['output']>;
  points: Maybe<Scalars['Int']['output']>;
  /** Tree layout parent node Id for the question inside question set */
  previousNodeId: Maybe<Scalars['ID']['output']>;
  question: Question;
  /** Id of the question version used in this question set question */
  questionVersionId: Maybe<Scalars['ID']['output']>;
  shuffle: Scalars['Boolean']['output'];
};

/** A source file for imported question in the library. */
export type QuestionSourceFile = {
  __typename?: 'QuestionSourceFile';
  filename: Maybe<Scalars['String']['output']>;
  filepath: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
};

export type QuestionTag = {
  __typename?: 'QuestionTag';
  categoryId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type QuestionTagCategory = {
  __typename?: 'QuestionTagCategory';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Type of tree-node in the QuestionTree */
export enum QuestionTreeNodeType {
  Overview = 'OVERVIEW',
  Question = 'QUESTION',
  Section = 'SECTION',
  Selection = 'SELECTION',
  Set = 'SET',
  Sub = 'SUB'
}

/** Valid Question types */
export enum QuestionType {
  Blanks = 'BLANKS',
  Extended = 'EXTENDED',
  Hotspot = 'HOTSPOT',
  Matching = 'MATCHING',
  Mcq = 'MCQ',
  Numerical = 'NUMERICAL',
  Overview = 'OVERVIEW',
  Section = 'SECTION',
  Short = 'SHORT',
  Sub = 'SUB',
  Truefalse = 'TRUEFALSE',
  Video = 'VIDEO'
}

export type QuestionVersion = {
  __typename?: 'QuestionVersion';
  /** Question body with prompt and fields. */
  body: Maybe<QuestionBody>;
  childrenQuestions: Array<QuestionVersion>;
  hash: Scalars['HexString']['output'];
  id: Scalars['ID']['output'];
  insertedAt: Scalars['PreciseDateTime']['output'];
  order: Maybe<Scalars['Int']['output']>;
  parentQuestionId: Maybe<Scalars['ID']['output']>;
  questionId: Scalars['ID']['output'];
  questionType: QuestionType;
  shortPrompt: Maybe<Scalars['String']['output']>;
  user: User;
  userId: Scalars['ID']['output'];
  /** @deprecated Version number is not relevant now as IDs are used for versioning. */
  version: Maybe<Scalars['Int']['output']>;
};

export enum RecordSocraticTurnPreparationMediaError {
  /** Turn not found */
  TurnNotFound = 'TURN_NOT_FOUND'
}

export type RecordSocraticTurnPreparationMediaInput = {
  /** Duration of the recorded preparation media in seconds. */
  durationSeconds?: InputMaybe<Scalars['Int']['input']>;
  mediaId: Scalars['ID']['input'];
  /** URL of the recorded preparation media associated with this turn. */
  mediaUrl?: InputMaybe<Scalars['String']['input']>;
  turnId: Scalars['ID']['input'];
};

export type RecordSocraticTurnPreparationMediaPayload = {
  __typename?: 'RecordSocraticTurnPreparationMediaPayload';
  error: Maybe<RecordSocraticTurnPreparationMediaError>;
  turn: Maybe<SocraticTurn>;
};

/** Re-entry metadata for a student's exam session. */
export type ReentryStatus = {
  __typename?: 'ReentryStatus';
  /** True when re-entry prevention is enabled and the student has a prior verified session. */
  requiresReentryCode: Scalars['Boolean']['output'];
  /** Total number of re-entry events recorded for this enrollment. */
  sessionCount: Scalars['Int']['output'];
};

export type RegenerateQuestionSetInput = {
  allowOverlappingSets?: InputMaybe<Scalars['Boolean']['input']>;
  questionSetId: Scalars['ID']['input'];
  questionSetQuestionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type RegenerateQuestionSetPayload = {
  __typename?: 'RegenerateQuestionSetPayload';
  /** True if the replacement set is incomplete */
  incompleteReplacement: Maybe<Scalars['Boolean']['output']>;
  /** Updated Question Set. May be nil if the replacement set is incomplete. */
  questionSet: Maybe<QuestionSet>;
};

export type RegisterQuestionSourceFileInput = {
  filename: Scalars['String']['input'];
  filepath: Scalars['String']['input'];
};

/** Return type for cancelRelease mutation. */
export type ReleaseAssessmentPayload = {
  __typename?: 'ReleaseAssessmentPayload';
  assessment: Assessment;
  sheets: Array<Sheet>;
};

export type ReleaseFeedbackForEveryonePayload = {
  __typename?: 'ReleaseFeedbackForEveryonePayload';
  feedbackReleaseRules: Array<FeedbackReleaseRule>;
  studentOutcomes: Array<StudentOutcome>;
  workOutcomes: Array<WorkOutcome>;
};

/** Scope a feedback release rule applies to. */
export enum ReleaseRuleKind {
  Group = 'GROUP',
  Individual = 'INDIVIDUAL',
  Joint = 'JOINT'
}

export type RemoveQuestionsUniformlyInput = {
  /** ID of the Question Selection to remove questions from */
  questionSelectionId: Scalars['ID']['input'];
  /** List of selected question set question IDs to remove. These questions will be used to determine which questions to remove from the other sets. */
  questionSetQuestionIds: Array<Scalars['ID']['input']>;
};

export type ReplaceQuestionInSetInput = {
  /** ID of the Question to use as replacement */
  questionId: Scalars['ID']['input'];
  /** ID of the Question Set to update */
  questionSetId: Scalars['ID']['input'];
  /** ID of the QuestionSetQuestion to update */
  questionSetQuestionId: Scalars['ID']['input'];
  /** ID of the specific Question Version to use as replacement (optional) */
  questionVersionId?: InputMaybe<Scalars['ID']['input']>;
};

/** Assessment Task requirements. */
export type Requirements = {
  __typename?: 'Requirements';
  /** Allow the use of Generative AI or not. */
  allowGenerativeAi: Maybe<Scalars['Boolean']['output']>;
  /** Allow late re-submissions or not. */
  allowLateResubmission: Scalars['Boolean']['output'];
  /** If anonymous marking is selected. */
  anonymousMarking: Maybe<Scalars['Boolean']['output']>;
  assessmentType: AssessmentType;
  countFootnotes: Scalars['Boolean']['output'];
  countReferences: Scalars['Boolean']['output'];
  disableExamBacktrack: Maybe<Scalars['Boolean']['output']>;
  disableSpellCheck: Scalars['Boolean']['output'];
  /** Drafting due date with Institution timezone */
  draftDueDate: Maybe<Scalars['PreciseDateTime']['output']>;
  /**
   * Are students allowed to view draft similarity scores/reports.
   *
   * 0 - Never
   * 1 - Only After the final due date
   * 2 - Always
   */
  draftSViewReports: Scalars['Int']['output'];
  /** When true, numeric scoring of draft submissions is available in Cadmus Marker; when false, comments only. */
  draftScoringEnabled: Scalars['Boolean']['output'];
  /** Final due date with Institution timezone. */
  dueDate: Maybe<Scalars['PreciseDateTime']['output']>;
  enableExamAccessCode: Scalars['Boolean']['output'];
  enableExamAutoSubmission: Scalars['Boolean']['output'];
  enableExamLdb: Maybe<Scalars['Boolean']['output']>;
  enableExamReentryPrevention: Scalars['Boolean']['output'];
  /** Enable or disable PDF attachment in submission receipts. */
  enableSubmissionPdf: Scalars['Boolean']['output'];
  examEndDate: Maybe<Scalars['PreciseDateTime']['output']>;
  examFeedbackDate: Maybe<Scalars['PreciseDateTime']['output']>;
  examInactivityTimeout: Maybe<Scalars['Int']['output']>;
  examReadingTime: Maybe<Scalars['Int']['output']>;
  examSchoolyearEnabled: Scalars['Boolean']['output'];
  examStartDate: Maybe<Scalars['PreciseDateTime']['output']>;
  examTiming: ExamTiming;
  examType: Array<Scalars['String']['output']>;
  examWritingTime: Maybe<Scalars['Int']['output']>;
  /** Selected grading integration. Either `turnitin` or `speedgrader` or `moodlegrader` currently. */
  gradingService: Scalars['String']['output'];
  /**
   * Has the set of requirements been altered by a user?
   *
   * This checks whether we have saved any requirements against the assessment
   */
  hasChanged: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** When true, students can see individual draft feedback before the draft due date. */
  individualDraftFeedbackAlwaysAvailable: Scalars['Boolean']['output'];
  lateSubmissionTimeLimit: Maybe<Scalars['Int']['output']>;
  /** Restrict student result view in LMS marking tool. */
  markingToolPdf: Maybe<MarkingToolPdf>;
  /** Maximum grade points. */
  maxGrade: Scalars['Int']['output'];
  noDraft: Scalars['Boolean']['output'];
  noExamFeedbackDate: Scalars['Boolean']['output'];
  noExamReadingTime: Scalars['Boolean']['output'];
  noLimit: Scalars['Boolean']['output'];
  noReferencing: Scalars['Boolean']['output'];
  /** Do students need to work in a limited time window */
  noTimeLimit: Scalars['Boolean']['output'];
  noWeight: Scalars['Boolean']['output'];
  referencingStyle: Maybe<Scalars['String']['output']>;
  /** If student result view is restricted. */
  restrictMarkingToolPdf: Scalars['Boolean']['output'];
  /** Final grade and feedback return date date with Institution timezone. */
  returnDate: Maybe<Scalars['PreciseDateTime']['output']>;
  /** Show rubrics to students on sheet. */
  rubricDisplayDisabled: Maybe<Scalars['Boolean']['output']>;
  /**
   * Are students allowed to view final similarity scores/reports.
   *
   * 0 - Never
   * 1 - Only After the final due date
   * 2 - Always
   */
  sViewReports: Scalars['Int']['output'];
  /** Maximum number of submission attempts allowed for students. Null means unlimited attempts. */
  submitAttemptLimit: Maybe<Scalars['Int']['output']>;
  /** Allowed working time in minutes */
  timeLimit: Maybe<Scalars['Int']['output']>;
  weight: Maybe<Scalars['Float']['output']>;
  wordLimit: Maybe<Scalars['Int']['output']>;
};

export type RequirementsInput = {
  allowGenerativeAi?: InputMaybe<Scalars['Boolean']['input']>;
  allowLateResubmission?: InputMaybe<Scalars['Boolean']['input']>;
  anonymousMarking?: InputMaybe<Scalars['Boolean']['input']>;
  assessmentType?: InputMaybe<AssessmentType>;
  countFootnotes?: InputMaybe<Scalars['Boolean']['input']>;
  countReferences?: InputMaybe<Scalars['Boolean']['input']>;
  disableExamBacktrack?: InputMaybe<Scalars['Boolean']['input']>;
  disableSpellCheck?: InputMaybe<Scalars['Boolean']['input']>;
  draftDueDate?: InputMaybe<Scalars['DateTime']['input']>;
  draftSViewReports?: InputMaybe<Scalars['Int']['input']>;
  draftScoringEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  enableExamAccessCode?: InputMaybe<Scalars['Boolean']['input']>;
  enableExamAutoSubmission?: InputMaybe<Scalars['Boolean']['input']>;
  enableExamLdb?: InputMaybe<Scalars['Boolean']['input']>;
  enableExamReentryPrevention?: InputMaybe<Scalars['Boolean']['input']>;
  enableSubmissionPdf?: InputMaybe<Scalars['Boolean']['input']>;
  examEndDate?: InputMaybe<Scalars['PreciseDateTime']['input']>;
  examFeedbackDate?: InputMaybe<Scalars['PreciseDateTime']['input']>;
  examInactivityTimeout?: InputMaybe<Scalars['Int']['input']>;
  examReadingTime?: InputMaybe<Scalars['Int']['input']>;
  examSchoolyearEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  examStartDate?: InputMaybe<Scalars['PreciseDateTime']['input']>;
  examTiming?: InputMaybe<ExamTiming>;
  examType?: InputMaybe<Array<Scalars['String']['input']>>;
  examWritingTime?: InputMaybe<Scalars['Int']['input']>;
  gradingService?: InputMaybe<Scalars['String']['input']>;
  individualDraftFeedbackAlwaysAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  lateSubmissionTimeLimit?: InputMaybe<Scalars['Int']['input']>;
  markingToolPdf?: InputMaybe<MarkingToolPdf>;
  maxGrade?: InputMaybe<Scalars['Int']['input']>;
  noDraft?: InputMaybe<Scalars['Boolean']['input']>;
  noExamFeedbackDate?: InputMaybe<Scalars['Boolean']['input']>;
  noExamReadingTime?: InputMaybe<Scalars['Boolean']['input']>;
  noLimit?: InputMaybe<Scalars['Boolean']['input']>;
  noReferencing?: InputMaybe<Scalars['Boolean']['input']>;
  noTimeLimit?: InputMaybe<Scalars['Boolean']['input']>;
  noWeight?: InputMaybe<Scalars['Boolean']['input']>;
  referencingStyle?: InputMaybe<Scalars['String']['input']>;
  restrictMarkingToolPdf?: InputMaybe<Scalars['Boolean']['input']>;
  returnDate?: InputMaybe<Scalars['DateTime']['input']>;
  rubricDisplayDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  sViewReports?: InputMaybe<Scalars['Int']['input']>;
  submitAttemptLimit?: InputMaybe<Scalars['Int']['input']>;
  timeLimit?: InputMaybe<Scalars['Int']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  wordLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type ResetModerationDecisionsPayload = {
  __typename?: 'ResetModerationDecisionsPayload';
  submissionOutcomes: Array<SubmissionOutcome>;
  workOutcomes: Array<WorkOutcome>;
};

export type ResetQuestionModerationChangesPayload = {
  __typename?: 'ResetQuestionModerationChangesPayload';
  fieldRubrics: Array<FieldRubric>;
  questionOutcomes: Array<QuestionOutcome>;
  questionRubrics: Array<QuestionRubric>;
  studentOutcomes: Array<StudentOutcome>;
  workOutcomes: Array<WorkOutcome>;
};

export type ResetRubricOutcomeForFieldPayload = {
  __typename?: 'ResetRubricOutcomeForFieldPayload';
  criterionOutcomesDeleted: Scalars['Int']['output'];
  fieldOutcome: FieldOutcome;
  questionOutcome: QuestionOutcome;
  studentOutcomes: Array<StudentOutcome>;
  workOutcome: WorkOutcome;
};

export type ResetRubricOutcomeForSubmissionPayload = {
  __typename?: 'ResetRubricOutcomeForSubmissionPayload';
  criterionOutcomesDeleted: Scalars['Int']['output'];
  studentOutcomes: Array<StudentOutcome>;
  submissionOutcome: SubmissionOutcome;
  workOutcome: WorkOutcome;
};

export type ResetRubricOutcomePayload = {
  __typename?: 'ResetRubricOutcomePayload';
  criteria: Array<Criterion>;
};

export type ResetScoreModerationChangesPayload = {
  __typename?: 'ResetScoreModerationChangesPayload';
  studentOutcomes: Array<StudentOutcome>;
  workOutcomes: Array<WorkOutcome>;
};

/** A Task resource. */
export type Resource = {
  __typename?: 'Resource';
  /** File size in bytes */
  fileSize: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  invalidated: Scalars['Boolean']['output'];
  isFreshlyUploaded: Scalars['Boolean']['output'];
  name: Maybe<Scalars['String']['output']>;
  /** Additional notes on this resource */
  notes: Maybe<Scalars['String']['output']>;
  order: Maybe<Scalars['Int']['output']>;
  url: Maybe<Scalars['String']['output']>;
};

/** Response declaration for a question field. */
export type ResponseDeclaration = {
  __typename?: 'ResponseDeclaration';
  /** Data type of the student response */
  baseType: Maybe<BaseType>;
  /** How many correct answers expected */
  cardinality: Maybe<Cardinality>;
  caseSensitive: Maybe<Scalars['Boolean']['output']>;
  correctAreas: Array<PositionArea>;
  correctRanges: Array<NumericRange>;
  correctValues: Array<Scalars['String']['output']>;
  /** Accepted margin of error */
  errorMargin: Maybe<Scalars['Float']['output']>;
  /** Similarity threshold between 0.0 and 1.0 inclusive */
  matchSimilarity: Maybe<Scalars['Float']['output']>;
  partialScoring: Maybe<Scalars['Boolean']['output']>;
};

export type ResponseDeclarationInput = {
  baseType?: InputMaybe<BaseType>;
  caseSensitive?: InputMaybe<Scalars['Boolean']['input']>;
  correctAreas?: InputMaybe<Array<PositionAreaInput>>;
  correctRanges?: InputMaybe<Array<NumericRangeInput>>;
  correctValues: Array<Scalars['String']['input']>;
  errorMargin?: InputMaybe<Scalars['Float']['input']>;
  matchSimilarity?: InputMaybe<Scalars['Float']['input']>;
  partialScoring?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A Gradebook Result. */
export type Result = {
  __typename?: 'Result';
  /** Canvas LTI API url for a successfully recorded submission in Canvas. */
  canvasResultUrl: Maybe<Scalars['String']['output']>;
  /**
   * Find the last access summary for launching this result with the configured
   * external grading service.
   */
  feedbackAccess: Maybe<AccessSummary>;
  /** Grade information on the Result. */
  grade: Maybe<Grade>;
  /** Connection to Hera for a successfully recorded submission in Hera and Turnitin. */
  heraResultId: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /**
   * Is the hera connection complete?
   * @deprecated Use receipt edge instead.
   */
  isReady: Scalars['Boolean']['output'];
  /** Moodle LTI API url for a successfully recorded submission in Moodle. */
  moodleGraderUrl: Maybe<Scalars['String']['output']>;
  /**
   * Submission pipeline processing receipt for the latest submission made in
   * this Result.
   */
  receipt: Maybe<GradebookReceipt>;
  /** When Student grades were sent to the LMS */
  returnedAt: Maybe<Scalars['PreciseDateTime']['output']>;
  /** Similarity information on the Result. */
  similarity: Maybe<Similarity>;
  /** Latest submission tracked in the Result */
  submission: Maybe<Submission>;
  /** Type of the Submission that the Result belongs to. */
  submissionType: SubmissionType;
  /** ID of the Work that the Result belongs to. */
  workId: Scalars['String']['output'];
};

/** Criterion with fields for reuse */
export type ReuseCriterion = {
  __typename?: 'ReuseCriterion';
  /** Parent MarkerRubric's assessment */
  assessmentName: Scalars['String']['output'];
  color: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  /** Parent MarkerRubric's kind */
  kind: MarkerRubricKind;
  maxScore: Maybe<Scalars['Int']['output']>;
  /** Parent MarkerRubric's published_at */
  publishedAt: Scalars['DateTime']['output'];
  scaleItems: Array<ScaleItem>;
  skill: LearningOutcomeSkill;
};

export type RootMutationType = {
  __typename?: 'RootMutationType';
  /** Accept the charter agreement */
  acceptStudentCharter: CharterAgreement;
  /** Add a tag to a group. */
  addGroupTag: GroupTag;
  /**
   * Import Library Questions to Task.
   *
   * Returns newly created TaskBlocks with Library Questions' data copied over.
   */
  addLibraryQuestionsToTask: Array<TaskBlock>;
  /** Add questions from question bank as TaskBlocks */
  addQuestionBanksToAssessment: Array<TaskBlock>;
  /**
   * Add QuestionSelection to Task which will allow to use QuestionSets.
   *
   * Returns created TaskBlock with QuestionSelection associated with it.
   */
  addQuestionSelectionToTask: TaskBlock;
  /** Add a tag to an enrollment */
  addTag: Tag;
  /** Append groups using group setup rules for an assessment. */
  appendGroups: Array<Group>;
  /** Append tags to the questions in given questions set, if tag's name doesn't exist in question */
  appendTagsForQuestions: Array<Question>;
  archiveQuestion: Maybe<Question>;
  /** Assign a marker to a group or groups */
  assignMarkerToGroups: Maybe<Array<Group>>;
  /** Assign markers to members. */
  assignMarkersToMembers: Array<GroupMarker>;
  /** Auto fill groups with students */
  autoAssignGroups: Maybe<Array<Group>>;
  /** Create a new MarkerRubric, or copy an existing one, into an Assessment. */
  buildMarkerRubric: BuildMarkerRubricPayload;
  /** Add a tag to multiple enrollments. */
  bulkAddTag: Array<Tag>;
  /** Remove a tag from multiple enrollments. */
  bulkRemoveTag: Scalars['Boolean']['output'];
  /** Cancel an existing Instruction Sheet release. */
  cancelRelease: CancelReleasePayload;
  /** Update user settings in a Subject context during an onboarding flow. */
  captureOnboardingInput: OnboardingPayload;
  /** Atomically switch Assessment Preset. */
  changeAssessmentPreset: ChangeAssessmentPresetResult;
  /** Clear the marker adjustment on a student's group component outcome. */
  clearMarkerAdjustment: MarkerAdjustmentPayload;
  /**
   * Finalise all submitted Criterion selection against the current student's
   * peers in the group.
   */
  completePeerOutcomes: Array<PeerOutcome>;
  /** Complete a Turn */
  completeSocraticTurn: CompleteSocraticTurnPayload;
  /** Complete marking for all submission outcomes assigned to the current marker */
  completeSubmissionOutcomes: CompleteSubmissionOutcomesPayload;
  /**
   * Copy Assessment accessories, which include resources, state and
   * settings from another assessment.
   */
  copyAssessment: Task;
  copyQuestion: Question;
  /** Create an attachment from an answer block. */
  createBlockAttachment: BlockAttachment;
  /** Create a draft Charter Form */
  createCharterForm: CharterForm;
  /** Create a new comment under a thread. */
  createComment: Comment;
  /** Register a file imported for question bank as an origin */
  createFileOrigin: QuestionBankFileOrigin;
  /**
   * Create Marker Rubric via Cadmus Grader
   * @deprecated Use buildMarkerRubric instead.
   */
  createGraderMarkerRubric: CreateGraderMarkerRubricPayload;
  /** Create a new group. */
  createGroup: Group;
  /** Create multiple groups. */
  createGroups: Array<Group>;
  /**
   * Create a new MarkerRubric in an Assessment.
   * @deprecated Use buildMarkerRubric instead.
   */
  createMarkerRubric: MarkerRubric;
  createPrintArchive: Scalars['String']['output'];
  /**
   * Create a new question in the question library. It's possible to add an
   * array of children question for SUB question type. Returns the array of
   * questions created.
   */
  createQuestion: Question;
  /** Create a new question bank */
  createQuestionBank: QuestionBank;
  /** Create a new question bank category */
  createQuestionBankCategory: QuestionBankCategory;
  /**
   * Create a new MarkerRubric attached to a TaskBlock.
   * @deprecated Use buildMarkerRubric instead.
   */
  createQuestionMarkerRubric: CreateQuestionMarkerRubricPayload;
  /** Create a new Question Selection with pre-generated Question Sets */
  createQuestionSelection: CreateQuestionSelectionPayload;
  /** Create a new Link/Url Resource. */
  createResource: Resource;
  /** Create a one-time deep link URL to open the Schoolyear exam dashboard UI. */
  createSchoolyearDashboardUrl: Maybe<CreateSchoolyearDashboardUrlPayload>;
  /** Create a one-time deep link URL to open the Schoolyear exam settings UI. */
  createSchoolyearSettingsUrl: Maybe<CreateSchoolyearSettingsUrlPayload>;
  /** Create a new learning outcome Skill */
  createSkill: LearningOutcomeSkill;
  /** Create a new smart comment for a skill. */
  createSmartComment: SmartComment;
  /** Create a Dialogue */
  createSocraticDialogue: CreateSocraticDialoguePayload;
  /** Creates a SubmissionOutcome for the marker based on their scope. */
  createSubmissionOutcome: SubmissionOutcome;
  /** Create tag with given name */
  createTag: QuestionTag;
  /** Creating a task block */
  createTaskBlock: TaskBlock;
  /**
   * Save new Task instructions for the given Assessment.
   * @deprecated Use `create_task_save_v2` instead
   */
  createTaskSave: SaveState;
  /** Save new Task instructions. */
  createTaskSaveV2: SaveState;
  /** Create a new thread. */
  createThread: Thread;
  /** Delete GenAI Guideline Notice for a Task, clearing custom instructions. */
  deleteGenaiGuidelineNotice: Task;
  /** Delete an existing group; returns the remaining groups for the assessment (after optional `auto_assign` redistribution) so clients can refresh their cache directly. */
  deleteGroup: Array<Group>;
  /** Delete a member from a group. */
  deleteGroupMember: Maybe<DeletedMember>;
  /** Delete multiple groups; returns the remaining groups for the assessment (after optional `auto_assign` redistribution) so clients can refresh their cache directly. */
  deleteGroups: Array<Group>;
  /** Invalidate an existing Link/Url Resource. */
  deleteResource: Resource;
  /** Delete an existing smart comment */
  deleteSmartComment: Maybe<SmartComment>;
  /** Delete a thread. */
  deleteThread: Thread;
  /** Generate a pre-signed download URL for the peer evaluation XLSX export. */
  downloadPeerEvaluationData: Scalars['String']['output'];
  /** Generate a pre-signed download URL for the given save */
  downloadSavePdf: Scalars['String']['output'];
  /**
   * Generate a pre-signed download URL for the given submissions in the
   * Assessment.
   */
  downloadSubmissions: Scalars['String']['output'];
  /**
   * Generate a pre-signed download URL for the given work artifacts ids and filenames.
   * Single artifact will download a pdf. Multiple will create a presigned url for zip.
   */
  downloadWorkArtifacts: Scalars['String']['output'];
  /**
   * Generate a pre-signed download URL for the given work file attachments.
   * Single attachment will download the file. Multiple will create a presigned url for zip.
   */
  downloadWorkAttachments: Scalars['String']['output'];
  /** Duplicating a task block and children task blocks */
  duplicateTaskBlock: Array<TaskBlock>;
  /** Edit an existing comment. */
  editComment: Comment;
  /**
   * Change Task status to editing.
   * @deprecated Use `edit_task_v2` instead
   */
  editTask: Task;
  /** Change Task status to editing. */
  editTaskV2: Task;
  /** Edit an existing thread's title. */
  editThreadTitle: Thread;
  /**
   * Extend a Work's submit attempt limit to allow a re-submission attempt.
   * @deprecated Use updateWorkSettings or updateStudentSettings with submitAttemptLimit instead
   */
  extendWorkSubmitAttemptLimit: WorkSettings;
  /** Finalise all groups for an assessment. */
  finaliseAllGroups: Array<Group>;
  /** Finalise the student's own group in an assessment. */
  finaliseGroup: Group;
  /** Finalise specific groups for an assessment. */
  finaliseGroups: Array<Group>;
  /**
   * Select similar questions that can be used to replace the given questions
   * in the selection.
   *
   * Similar questions are selected based on question type and points. Tags can
   * be also provided to filter the questions.
   *
   * If not enough similar questions are found, the replacement is considered
   * incomplete.
   */
  findSimilarQuestions: SimilarQuestionsPayload;
  /** Flag the main submission outcomes for given work outcomes as needing attention. */
  flagAttention: SubmissionOutcomesPayload;
  /**
   * Make submissions for Student's works on their behalf.
   *
   * This mutation is used by the Teacher to batch submit student's latest save
   * if they haven't submitted their work on their own.
   */
  forceSubmissions: Array<Result>;
  /**
   * Make submissions for Student's works on their behalf.
   *
   * This mutation is used by the Teacher to batch submit student's latest save
   * if they haven't submitted their work on their own.
   */
  forceSubmissionsV2: Array<Result>;
  /** Generate Assessment and Student reports. */
  generateReport: Job;
  /**
   * Generate a moderation performance CSV for an Assessment and return a
   * presigned download URL.
   *
   * Defaults to the per-student "class performance" export; pass `by_questions:
   * true` for the per-question ("success rate across questions") export.
   */
  generateWorkOutcomesCsv: Scalars['String']['output'];
  /** Grant extension settings to all active members of one or more groups. */
  grantGroupExtensions: Array<Maybe<WorkSettings>>;
  /**
   * Imports Library Question to existing TaskBlock. If `:question_version_id` is not provided,
   * the TaskBlock will be populated with the current versionof the Library Question.
   *
   * Returns the updated TaskBlock with Library Question references updated.
   */
  importLibraryQuestion: TaskBlock;
  /** Import a roster spreadsheet assigning students to sections. */
  importSections: ImportSectionsResult;
  /** Import a list of smart comments in a single transaction. */
  importSmartComments: ImportSmartCommentsResult;
  /** Queue a RosterSyncing background job for the Assessment. */
  insertSyncRosterJob: BackgroundJob;
  /** Join an existing group as a student */
  joinGroup: Group;
  /** Leave group as a student */
  leaveGroup: Group;
  /** Link a comment thread to a marking criterion. */
  linkCommentThread: Thread;
  /** Marking a Field Outcome for Marker Rubric. */
  markFieldOutcome: MarkFieldOutcomePayload;
  /** Mark a Peer student as the current student. */
  markPeerOutcome: PeerOutcome;
  /** Mark a SubmissionOutcome connected to a MarkOutcome, optionally using a Rubric. */
  markSubmissionOutcome: MarkSubmissionOutcomePayload;
  /** Moderate score and/or feedback for multiple submission outcomes. */
  moderateMainOutcomes: SubmissionOutcomesPayload;
  /** Move groups (and their members' enrolments) into a section (null clears it). */
  moveGroupsToSection: Array<Group>;
  /** Move students' enrolments into a section (null clears it). Returns the sections. */
  moveStudentsToSection: Array<Section>;
  /** Publish a Charter Form */
  publishCharterForm: CharterForm;
  /** Import questions to the Question Library */
  publishImportedQuestions: Array<Question>;
  /**
   * Publish the draft changes on the MarkerRubric.
   * @deprecated Use saveMarkerRubric instead.
   */
  publishMarkerRubric: MarkerRubric;
  /** Push Submission Worker Job for the Result and Result's Last Submission ID. */
  pushSubmission: Result;
  /**
   * Start a submission-pipeline rerun for student submissions in an Assessment,
   * which can force a re-run of one or more stages of the pipeline in case of
   * errors or changes to the pipeline.
   *
   * Runs asynchronously in the background, while the mutation returns
   * immediately.
   */
  queueSubmissionPipeline: Maybe<Scalars['Boolean']['output']>;
  /** Record the preparation-phase video for a Turn. */
  recordSocraticTurnPreparationMedia: RecordSocraticTurnPreparationMediaPayload;
  /**
   * Update Question Set by replacing its questions with similar ones.
   *
   * Similar questions are selected based on the rules of the original set. If
   * no rules were defined, similar questions are selected based on the
   * question type and points. Tags can be also provided to filter the questions.
   *
   * If not enough similar questions are found, the replacement is considered
   * incomplete.
   */
  regenerateQuestionSet: RegenerateQuestionSetPayload;
  /** Register the source file with the given path and name */
  registerQuestionSourceFile: QuestionSourceFile;
  /** Release the Assessment, releasing all Tasks and publishing draft MarkerRubrics. */
  releaseAssessment: ReleaseAssessmentPayload;
  releaseFeedbackForEveryone: ReleaseFeedbackForEveryonePayload;
  /** Release the given Task, returning a new latest Instruction Sheet. */
  releaseTask: Sheet;
  /** Remove an attachment from an AnswerBlock. */
  removeBlockAttachment: BlockAttachment;
  /** Remove a tag from a group. */
  removeGroupTag: Scalars['Boolean']['output'];
  /** Delete an existing MarkerRubric. */
  removeMarkerRubric: MarkerRubric;
  /**
   * Remove outcomes for marker rubric
   * @deprecated Use resetRubricOutcome instead
   */
  removeMarkerRubricOutcomes: OutcomesDeletedPayload;
  /** remove a question bank category */
  removeQuestionBankCategory: Maybe<Scalars['Boolean']['output']>;
  /**
   * Remove questions uniformly across all sets in a Question Selection.
   *
   * This mutation removes the same number of questions from each set based on
   * the similarity rules derived from the provided Question Set Questions. If
   * no explicit Question Selection Rule rules are defined, the removal is
   * guided by matching question type and points.
   */
  removeQuestionsUniformly: QuestionSelection;
  /** Remove a tag from an enrollment */
  removeTag: Scalars['Boolean']['output'];
  /** Replace a question in a Question Set with another question. */
  replaceQuestionInSet: QuestionSet;
  /** Reset all the student's given peer evaluation outcomes. */
  resetCriterionOutcomes: Scalars['Int']['output'];
  /** Remove all unexecuted feedback release rules for an assessment. */
  resetFeedbackReleaseRules: Array<FeedbackReleaseRule>;
  /** Delete all groups in an assessment. */
  resetGroups: Scalars['Boolean']['output'];
  /**
   * Reset any un-published changes on the Marker Rubric.
   * @deprecated Use resetRubricOutcome instead.
   */
  resetMarkerRubric: MarkerRubric;
  resetModerationDecisions: ResetModerationDecisionsPayload;
  resetModerationPenaltyRules: Array<ModerationPenaltyRule>;
  /** Reset all moderation changes made against marking rubrics for all questions. */
  resetQuestionModerationChanges: ResetQuestionModerationChangesPayload;
  /** Delete criterion outcomes, submission and field scores for criteria */
  resetRubricOutcome: ResetRubricOutcomePayload;
  /** Reset rubric outcome and related field outcomes from marker rubric */
  resetRubricOutcomeForField: ResetRubricOutcomeForFieldPayload;
  /** Reset rubric outcome and related submission outcomes from marker rubric */
  resetRubricOutcomeForSubmission: ResetRubricOutcomeForSubmissionPayload;
  /** Reset all moderation changes made against the scores of the work outcomes. */
  resetScoreModerationChanges: ResetScoreModerationChangesPayload;
  /** Resolve messages by their IDs. */
  resolveMessages: Array<Message>;
  /** Cloud save for a Work. */
  save: Save;
  /** Save a new block snapshot against an answer block. */
  saveBlockSnapshot: SaveBlockSnapshotResponse;
  /**
   * Save the editor state by updating the `snapshot_doc`
   *     and `snapshot_version`
   */
  saveCharterEditor: CharterEditor;
  /** Save GenAI Guideline Notice content for a Task. */
  saveGenaiGuidelineNotice: TaskNotice;
  /** Save Institution wide settings for the current user. */
  saveGlobalUserSettings: SaveGlobalUserSettingsPayload;
  /** Save changes to a draft or published MarkerRubric. */
  saveMarkerRubric: MarkerRubric;
  /** Append new state to the question in a task block */
  saveQuestionState: Question;
  /**
   * Send emails to students in class with a work artifact.
   *
   * This mutation is used by the teacher to batch send Automarked PDF (`complete_pdf`s)
   * to students in their class. The submission ids are provided by the client.
   */
  sendEmailsToClass: Scalars['String']['output'];
  /** Create a new pending message in the Assessment. */
  sendMessage: Message;
  /** Record the student's email-sharing consent for a group assessment. */
  setAssessmentEmailConsent: AssessmentEmailConsent;
  /** Set a marker adjustment on a student's group component outcome. */
  setMarkerAdjustment: MarkerAdjustmentPayload;
  /** Create or update a Access code */
  setupAccessCode: AccessCode;
  /** Create or access the latest student Group Charter. */
  setupCharter: Charter;
  /** Setup Work document for a finalised Student group. */
  setupGroupWork: WorkGroup;
  /** Initial wizard flow setup for groups in an assessment. */
  setupGroups: Array<Group>;
  /** Create a new Task for the given Assessment. */
  setupTask: Task;
  /** Manually setup a Work for a given Task explicitly */
  setupWork: Work;
  snapshotFieldOutcome: FieldOutcome;
  /** Save new snapshot for a SubmissionOutcome feedback. */
  snapshotSubmissionOutcome: SubmissionOutcome;
  /** Mark start of a work with time limit. */
  start: Work;
  /** Start a Dialogue */
  startSocraticDialogue: StartSocraticDialoguePayload;
  /** Start a preview questioner run for a task block and return the run. */
  startSocraticQuestionerRun: SocraticQuestionerRunPayload;
  /** Start a Turn */
  startSocraticTurn: StartSocraticTurnPayload;
  /** Draft or final Submission. */
  submit: Submission;
  /**
   * Make a server-side submission attempt.
   * @deprecated Use `submitAttemptV2` instead
   */
  submitAttempt: Result;
  /**
   * Make a Submission attempt with a fixed attempt number.
   *
   * The latest server-recorded state of the Work is submitted if allowed.
   */
  submitAttemptV2: SubmitAttemptPayload;
  /** Submit a new sentiment check */
  submitSentimentCheck: SentimentCheck;
  /** Draft or final Submission (v2) */
  submitV2: Submission;
  /** Swap the order of two Resources. */
  swapResource: Scalars['Boolean']['output'];
  /**
   * Pass all existing final grades to the source LMS of an Assessment.
   *
   * This process happens asynchronously in the background, while the mutation
   * returns immediately.
   */
  syncGrades: Maybe<Scalars['Boolean']['output']>;
  /**
   * Perform a Roster Sync with the source LMS of an Assessment.
   *
   * Returns the list of new enrollments created, if any. The roster sync will
   * fail if the source LMS does not support it or has not provided service
   * params to sync with.
   */
  syncRoster: Array<Maybe<Enrollment>>;
  /** Unassign assessment markers. */
  unassignMarkers: Scalars['Boolean']['output'];
  /** Unlink a comment thread from its current marking criterion. */
  unlinkCommentThread: Thread;
  /** Unlink Library Question references from the TaskBlock. */
  unlinkLibraryQuestion: TaskBlock;
  /** Unlock the charter agreement */
  unlockStudentCharter: CharterAgreement;
  /** Unsubmission, which is really to allow Re-submissions. */
  unsubmit: Submission;
  /** Update a existing answer block. */
  updateAnswerBlock: AnswerBlock;
  /** Update an Assessment name. */
  updateAssessmentName: Assessment;
  updateAssessmentSettings: Assessment;
  /** Update an existing Charter Form and its fields */
  updateCharterForm: CharterForm;
  /**
   * Update enrollment status(deleted/withdrawn) of a list of enrollment ids on an assessment.
   *
   * This mutation is used by the Teacher to batch withdrawn/un-withdrawn students from the classlist
   * due to the fact that NRPS is not returning the right list of students on some LMS
   */
  updateEnrollmentsStatus: Array<Enrollment>;
  /** Update the cadmus experience survey score. */
  updateExperience: Survey;
  /** Update assessment's feedback release rules as a whole. */
  updateFeedbackReleaseRules: Array<FeedbackReleaseRule>;
  updateFeedbackVisibility: FeedbackVisibility;
  /** Update the marking rubric user for a single field. */
  updateFieldRubricResponse: UpdateFieldRubricPayload;
  /** Update a file origin name */
  updateFileOrigin: QuestionBankFileOrigin;
  /**
   * Update an existing group's memberships / marker assignments / name
   * @deprecated Use update_group_memberships / assign_marker_to_groups / update_group_name (to be created) instead
   */
  updateGroup: Group;
  /**
   * Bulk update user memberships across multiple existing groups.
   *
   * Returns the new complete list of an Assessment's marking groups.
   */
  updateGroupMemberships: Array<Group>;
  /** Updates the existing Insights Mailing List for the given assessment. */
  updateInsightsMailingList: MailingList;
  /**
   * Update existing MarkerRubric.
   * @deprecated Use saveMarkerRubric instead.
   */
  updateMarkerRubric: MarkerRubric;
  /** Upsert the milestones of a charter */
  updateMilestones: Charter;
  updateModerationPenaltyRules: Array<ModerationPenaltyRule>;
  /** Set the assessments preferred as Smart Comment sources while grading assessmentId. */
  updatePreferredAssessmentSources: Array<Assessment>;
  /** Update all project issues for a Student Group to reflect the latest input state. */
  updateProjectIssue: Array<ProjectIssue>;
  updateQuestion: Question;
  /** Bulk edit attributes questions without creating a new version. */
  updateQuestionAttributes: Array<Question>;
  /** Update a question bank */
  updateQuestionBank: QuestionBank;
  /** Update (set or remove) category of a list of question banks */
  updateQuestionBanksCategory: Array<QuestionBank>;
  /**
   * Update automarking conditions for a question.
   *
   * This mutation updates automark settings at the question level, which are applied
   * to all field rubrics within the given question rubric.
   *
   * Changes trigger recalculation of student outcomes.
   */
  updateQuestionRubric: UpdateQuestionRubricPayload;
  /** Update a source file name */
  updateQuestionSourceFile: QuestionSourceFile;
  /** Update a question to save a new version */
  updateQuestionVersion: Question;
  /** Partial Requirements update. */
  updateRequirements: Requirements;
  /** Update an existing Link/Url Resource. */
  updateResource: Resource;
  /** Update the moderator modifier score on a student outcome. */
  updateStudentOutcomeScore: UpdateStudentOutcomeScorePayload;
  /** Batch update student settings. */
  updateStudentSettings: Array<Maybe<WorkSettings>>;
  /**
   * Set or clear a marker's modifier on a SubmissionOutcome.
   *
   * When `awarded_points` is given, derives the additive modifier from the
   * marker's target total, clamps it so the awarded total stays within
   * `[0, max_score]` (the modifier may be negative), and recomputes the
   * SubmissionOutcome score. When `awarded_points` is null, clears the modifier
   * and recomputes the score from the rubric alone.
   */
  updateSubmissionMarkerModifier: SubmissionMarkerModifierPayload;
  /** Update all tags for a question */
  updateTagsForQuestion: Question;
  /** Update TaskBlock attributes */
  updateTaskBlock: TaskBlock;
  /** Update TaskBlocks ordering/deleted flag. Returns the updated TaskBlock */
  updateTaskBlocks: Array<TaskBlock>;
  /**
   * Update Task Format.
   * @deprecated Use `change_assessment_preset` instead
   */
  updateTaskFormat: Task;
  /** Update thread resolution status. */
  updateThreadResolution: Thread;
  /** Update the moderator modifier score on a work outcome. */
  updateWorkOutcomeScore: UpdateWorkOutcomeScorePayload;
  /** Update a Work's settings. */
  updateWorkSettings: WorkSettings;
  /** Verify a student-supplied access code for the assessment. */
  verifyAccessCode: Session;
  /**
   * Withdraw feedback for the Students.
   *
   * Withdraws all `final` WorkOutcomeReleases for the Student and Student's
   * Group (if applicable). Removes grades from the Gradebook.Result for the
   * Students.
   */
  withdrawFeedback: Array<StudentOutcome>;
};


export type RootMutationTypeAcceptStudentCharterArgs = {
  input: CharterAgreementInput;
};


export type RootMutationTypeAddGroupTagArgs = {
  assessmentId: Scalars['ID']['input'];
  groupId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};


export type RootMutationTypeAddLibraryQuestionsToTaskArgs = {
  questionIds: Array<Scalars['ID']['input']>;
  taskId: Scalars['ID']['input'];
};


export type RootMutationTypeAddQuestionBanksToAssessmentArgs = {
  assessmentId: Scalars['ID']['input'];
  input: Array<AddQuestionBanksToAssessmentInput>;
  taskId: Scalars['ID']['input'];
};


export type RootMutationTypeAddQuestionSelectionToTaskArgs = {
  questionSelectionId: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
};


export type RootMutationTypeAddTagArgs = {
  column: InputMaybe<Scalars['Int']['input']>;
  enrollmentId: Scalars['ID']['input'];
  tab: InputMaybe<ClassTab>;
  text: Scalars['String']['input'];
};


export type RootMutationTypeAppendGroupsArgs = {
  assessmentId: Scalars['ID']['input'];
  input: SetupGroupInput;
  userIds: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type RootMutationTypeAppendTagsForQuestionsArgs = {
  input: Array<TagInput>;
  questionIds: Array<Scalars['ID']['input']>;
};


export type RootMutationTypeArchiveQuestionArgs = {
  questionId: Scalars['ID']['input'];
};


export type RootMutationTypeAssignMarkerToGroupsArgs = {
  assessmentId: Scalars['ID']['input'];
  groupIds: InputMaybe<Array<Scalars['ID']['input']>>;
  markerId: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeAssignMarkersToMembersArgs = {
  assessmentId: Scalars['ID']['input'];
  inputs: Array<MarkerForMembersInput>;
};


export type RootMutationTypeAutoAssignGroupsArgs = {
  assessmentId: Scalars['ID']['input'];
  groupId: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeBuildMarkerRubricArgs = {
  assessmentId: Scalars['ID']['input'];
  input: BuildMarkerRubricInput;
};


export type RootMutationTypeBulkAddTagArgs = {
  enrollmentIds: Array<Scalars['ID']['input']>;
  tab: ClassTab;
  text: Scalars['String']['input'];
};


export type RootMutationTypeBulkRemoveTagArgs = {
  enrollmentIds: Array<Scalars['ID']['input']>;
  tab: ClassTab;
  text: Scalars['String']['input'];
};


export type RootMutationTypeCancelReleaseArgs = {
  assessmentId: Scalars['ID']['input'];
  sheetId: Scalars['ID']['input'];
};


export type RootMutationTypeCaptureOnboardingInputArgs = {
  discipline: InputMaybe<Discipline>;
  subjectId: Scalars['ID']['input'];
  subjectRole: InputMaybe<SubjectRole>;
};


export type RootMutationTypeChangeAssessmentPresetArgs = {
  assessmentId: Scalars['ID']['input'];
  preset: AssessmentPreset;
};


export type RootMutationTypeClearMarkerAdjustmentArgs = {
  studentId: Scalars['ID']['input'];
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeCompletePeerOutcomesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootMutationTypeCompleteSocraticTurnArgs = {
  input: CompleteSocraticTurnInput;
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeCompleteSubmissionOutcomesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootMutationTypeCopyAssessmentArgs = {
  destinationAssessmentId: Scalars['ID']['input'];
  destinationTaskId: InputMaybe<Scalars['ID']['input']>;
  sourceInstructionSheetId: Scalars['ID']['input'];
};


export type RootMutationTypeCopyQuestionArgs = {
  questionId: Scalars['ID']['input'];
};


export type RootMutationTypeCreateBlockAttachmentArgs = {
  answerBlockId: Scalars['ID']['input'];
  mediaId: Scalars['ID']['input'];
  mediaUrl: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeCreateCharterFormArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootMutationTypeCreateCommentArgs = {
  content: Scalars['String']['input'];
  smartCommentId: InputMaybe<Scalars['ID']['input']>;
  threadId: Scalars['ID']['input'];
};


export type RootMutationTypeCreateFileOriginArgs = {
  input: CreateQuestionBankFileOriginInput;
};


export type RootMutationTypeCreateGraderMarkerRubricArgs = {
  assessmentId: Scalars['ID']['input'];
  input: CreateGraderMarkerRubricInput;
};


export type RootMutationTypeCreateGroupArgs = {
  assessmentId: Scalars['ID']['input'];
  group: GroupInput;
};


export type RootMutationTypeCreateGroupsArgs = {
  assessmentId: Scalars['ID']['input'];
  groups: Array<GroupInput>;
};


export type RootMutationTypeCreateMarkerRubricArgs = {
  assessmentId: Scalars['ID']['input'];
  input: CreateMarkerRubricInput;
};


export type RootMutationTypeCreatePrintArchiveArgs = {
  input: PrintArchiveInput;
  taskId: Scalars['ID']['input'];
};


export type RootMutationTypeCreateQuestionArgs = {
  assessmentId: Scalars['ID']['input'];
  childrenQuestions: InputMaybe<Array<QuestionAttributes>>;
  input: QuestionAttributes;
  subjectId: Scalars['ID']['input'];
  tags: InputMaybe<Array<TagInput>>;
};


export type RootMutationTypeCreateQuestionBankArgs = {
  questionBank: CreateQuestionBankInput;
};


export type RootMutationTypeCreateQuestionBankCategoryArgs = {
  input: QuestionBankCategoryInput;
};


export type RootMutationTypeCreateQuestionMarkerRubricArgs = {
  assessmentId: Scalars['ID']['input'];
  input: CreateQuestionMarkerRubricInput;
};


export type RootMutationTypeCreateQuestionSelectionArgs = {
  input: QuestionSelectionInput;
};


export type RootMutationTypeCreateResourceArgs = {
  assessmentId: Scalars['ID']['input'];
  fileSize: InputMaybe<Scalars['Int']['input']>;
  mediaId: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  notes: InputMaybe<Scalars['String']['input']>;
  taskId: InputMaybe<Scalars['ID']['input']>;
  url: Scalars['String']['input'];
};


export type RootMutationTypeCreateSchoolyearDashboardUrlArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootMutationTypeCreateSchoolyearSettingsUrlArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootMutationTypeCreateSkillArgs = {
  assessmentId: Scalars['ID']['input'];
  input: CreateSkillInput;
};


export type RootMutationTypeCreateSmartCommentArgs = {
  assessmentId: Scalars['ID']['input'];
  input: CreateSmartCommentInput;
};


export type RootMutationTypeCreateSocraticDialogueArgs = {
  attemptNumber: Scalars['Int']['input'];
  sessionId: Scalars['ID']['input'];
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeCreateSubmissionOutcomeArgs = {
  assessmentId: Scalars['ID']['input'];
  markerScope: MarkerScopeInput;
  workOutcomeId: Scalars['ID']['input'];
};


export type RootMutationTypeCreateTagArgs = {
  name: Scalars['String']['input'];
};


export type RootMutationTypeCreateTaskBlockArgs = {
  input: InputMaybe<CreateTaskBlockInput>;
  taskId: Scalars['ID']['input'];
};


export type RootMutationTypeCreateTaskSaveArgs = {
  assessmentId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
  editor: InputMaybe<EditorType>;
  taskId: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeCreateTaskSaveV2Args = {
  content: Scalars['String']['input'];
  taskId: Scalars['ID']['input'];
};


export type RootMutationTypeCreateThreadArgs = {
  input: ThreadInput;
  threadId: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteGenaiGuidelineNoticeArgs = {
  taskId: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteGroupArgs = {
  assessmentId: Scalars['ID']['input'];
  autoAssign?: InputMaybe<Scalars['Boolean']['input']>;
  groupId: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteGroupMemberArgs = {
  assessmentId: Scalars['ID']['input'];
  groupId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteGroupsArgs = {
  assessmentId: Scalars['ID']['input'];
  autoAssign?: InputMaybe<Scalars['Boolean']['input']>;
  groupIds: Array<Scalars['ID']['input']>;
};


export type RootMutationTypeDeleteResourceArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteSmartCommentArgs = {
  assessmentId: Scalars['ID']['input'];
  smartCommentId: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteThreadArgs = {
  threadId: Scalars['ID']['input'];
};


export type RootMutationTypeDownloadPeerEvaluationDataArgs = {
  assessmentId: Scalars['ID']['input'];
  enrollmentId: Scalars['ID']['input'];
};


export type RootMutationTypeDownloadSavePdfArgs = {
  saveId: Scalars['ID']['input'];
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeDownloadSubmissionsArgs = {
  assessmentId: Scalars['ID']['input'];
  preferPdf: InputMaybe<Scalars['Boolean']['input']>;
  submissions: Array<SubmissionDetailInput>;
};


export type RootMutationTypeDownloadWorkArtifactsArgs = {
  assessmentId: Scalars['ID']['input'];
  workArtifacts: Array<WorkArtifactDetailInput>;
};


export type RootMutationTypeDownloadWorkAttachmentsArgs = {
  answerBlockId: Scalars['ID']['input'];
  blockAttachmentIds: Array<Scalars['ID']['input']>;
};


export type RootMutationTypeDuplicateTaskBlockArgs = {
  taskBlockId: Scalars['ID']['input'];
};


export type RootMutationTypeEditCommentArgs = {
  commentId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
};


export type RootMutationTypeEditTaskArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootMutationTypeEditTaskV2Args = {
  taskId: Scalars['ID']['input'];
};


export type RootMutationTypeEditThreadTitleArgs = {
  threadId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};


export type RootMutationTypeExtendWorkSubmitAttemptLimitArgs = {
  assessmentId: Scalars['ID']['input'];
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeFinaliseAllGroupsArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootMutationTypeFinaliseGroupArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootMutationTypeFinaliseGroupsArgs = {
  assessmentId: Scalars['ID']['input'];
  groupIds: Array<Scalars['ID']['input']>;
};


export type RootMutationTypeFindSimilarQuestionsArgs = {
  input: FindSimilarQuestionsInput;
};


export type RootMutationTypeFlagAttentionArgs = {
  assessmentId: Scalars['ID']['input'];
  flagReason: InputMaybe<Scalars['String']['input']>;
  workOutcomeIds: Array<Scalars['ID']['input']>;
};


export type RootMutationTypeForceSubmissionsArgs = {
  assessmentId: Scalars['ID']['input'];
  submittedAt: Scalars['DateTime']['input'];
  type: SubmissionType;
  workIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type RootMutationTypeForceSubmissionsV2Args = {
  assessmentId: Scalars['ID']['input'];
  submittedAt: Scalars['DateTime']['input'];
  type: SubmissionType;
  workIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type RootMutationTypeGenerateReportArgs = {
  anonymousName: InputMaybe<Scalars['String']['input']>;
  assessmentId: Scalars['ID']['input'];
  kind: Scalars['String']['input'];
  studentId: InputMaybe<Scalars['ID']['input']>;
  workId: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeGenerateWorkOutcomesCsvArgs = {
  assessmentId: Scalars['ID']['input'];
  byQuestions: InputMaybe<Scalars['Boolean']['input']>;
  taskId: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeGrantGroupExtensionsArgs = {
  assessmentId: Scalars['ID']['input'];
  groupIds: Array<Scalars['ID']['input']>;
  input: GroupExtensionInput;
};


export type RootMutationTypeImportLibraryQuestionArgs = {
  input: ImportLibraryQuestionInput;
};


export type RootMutationTypeImportSectionsArgs = {
  assessmentId: Scalars['ID']['input'];
  input: ImportSectionsInput;
};


export type RootMutationTypeImportSmartCommentsArgs = {
  assessmentId: Scalars['ID']['input'];
  comments: Array<ImportSmartCommentInput>;
};


export type RootMutationTypeInsertSyncRosterJobArgs = {
  assessmentId: Scalars['ID']['input'];
  extensionConflictAction?: InputMaybe<ExtensionConflictActionType>;
  withExtensions?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootMutationTypeJoinGroupArgs = {
  assessmentId: Scalars['ID']['input'];
  groupId: Scalars['ID']['input'];
};


export type RootMutationTypeLeaveGroupArgs = {
  assessmentId: Scalars['ID']['input'];
  groupId: Scalars['ID']['input'];
};


export type RootMutationTypeLinkCommentThreadArgs = {
  assessmentId: Scalars['ID']['input'];
  criterionId: Scalars['Int']['input'];
  threadId: Scalars['ID']['input'];
};


export type RootMutationTypeMarkFieldOutcomeArgs = {
  assessmentId: Scalars['ID']['input'];
  input: MarkFieldOutcomeInput;
};


export type RootMutationTypeMarkPeerOutcomeArgs = {
  assessmentId: Scalars['ID']['input'];
  input: MarkPeerOutcomeInput;
};


export type RootMutationTypeMarkSubmissionOutcomeArgs = {
  assessmentId: Scalars['ID']['input'];
  input: MarkSubmissionOutcomeInput;
};


export type RootMutationTypeModerateMainOutcomesArgs = {
  assessmentId: Scalars['ID']['input'];
  exceptions: InputMaybe<Array<ExceptionInput>>;
  feedbackModeration: InputMaybe<FeedbackModerationDecisionInput>;
  scoreModeration: InputMaybe<ScoreModerationDecisionInput>;
  workOutcomeIds: Array<Scalars['ID']['input']>;
};


export type RootMutationTypeMoveGroupsToSectionArgs = {
  assessmentId: Scalars['ID']['input'];
  groupIds: Array<Scalars['ID']['input']>;
  sectionId: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeMoveStudentsToSectionArgs = {
  assessmentId: Scalars['ID']['input'];
  sectionId: InputMaybe<Scalars['ID']['input']>;
  userIds: Array<Scalars['ID']['input']>;
};


export type RootMutationTypePublishCharterFormArgs = {
  charterFormId: Scalars['ID']['input'];
};


export type RootMutationTypePublishImportedQuestionsArgs = {
  input: PublishImportedQuestionsInput;
};


export type RootMutationTypePublishMarkerRubricArgs = {
  markerRubricId: Scalars['ID']['input'];
};


export type RootMutationTypePushSubmissionArgs = {
  assessmentId: Scalars['ID']['input'];
  resultId: Scalars['ID']['input'];
};


export type RootMutationTypeQueueSubmissionPipelineArgs = {
  assessmentId: Scalars['ID']['input'];
  payload: SubmissionPipelineInput;
};


export type RootMutationTypeRecordSocraticTurnPreparationMediaArgs = {
  input: RecordSocraticTurnPreparationMediaInput;
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeRegenerateQuestionSetArgs = {
  input: RegenerateQuestionSetInput;
};


export type RootMutationTypeRegisterQuestionSourceFileArgs = {
  input: RegisterQuestionSourceFileInput;
};


export type RootMutationTypeReleaseAssessmentArgs = {
  assessmentId: Scalars['ID']['input'];
  scheduleTimestamp: InputMaybe<Scalars['DateTime']['input']>;
};


export type RootMutationTypeReleaseFeedbackForEveryoneArgs = {
  assessmentId: Scalars['ID']['input'];
  feedbackVisibility: InputMaybe<FeedbackVisibilityInput>;
  releaseType: InputMaybe<FeedbackReleaseType>;
};


export type RootMutationTypeReleaseTaskArgs = {
  assessmentId: Scalars['ID']['input'];
  releaseType: InputMaybe<Scalars['ReleaseType']['input']>;
  saveId: Scalars['ID']['input'];
  scheduleTimestamp: InputMaybe<Scalars['DateTime']['input']>;
};


export type RootMutationTypeRemoveBlockAttachmentArgs = {
  blockAttachmentId: Scalars['ID']['input'];
};


export type RootMutationTypeRemoveGroupTagArgs = {
  assessmentId: Scalars['ID']['input'];
  groupId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};


export type RootMutationTypeRemoveMarkerRubricArgs = {
  markerRubricId: Scalars['ID']['input'];
};


export type RootMutationTypeRemoveMarkerRubricOutcomesArgs = {
  markerRubricId: Scalars['ID']['input'];
};


export type RootMutationTypeRemoveQuestionBankCategoryArgs = {
  categoryId: Scalars['ID']['input'];
};


export type RootMutationTypeRemoveQuestionsUniformlyArgs = {
  input: RemoveQuestionsUniformlyInput;
};


export type RootMutationTypeRemoveTagArgs = {
  column: InputMaybe<Scalars['Int']['input']>;
  enrollmentId: Scalars['ID']['input'];
  tab: InputMaybe<ClassTab>;
  text: Scalars['String']['input'];
};


export type RootMutationTypeReplaceQuestionInSetArgs = {
  input: ReplaceQuestionInSetInput;
};


export type RootMutationTypeResetCriterionOutcomesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootMutationTypeResetFeedbackReleaseRulesArgs = {
  assessmentId: Scalars['ID']['input'];
  releaseType: InputMaybe<FeedbackReleaseType>;
};


export type RootMutationTypeResetGroupsArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootMutationTypeResetMarkerRubricArgs = {
  markerRubricId: Scalars['ID']['input'];
};


export type RootMutationTypeResetModerationDecisionsArgs = {
  assessmentId: Scalars['ID']['input'];
  workOutcomeIds: Array<Scalars['ID']['input']>;
};


export type RootMutationTypeResetModerationPenaltyRulesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootMutationTypeResetQuestionModerationChangesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootMutationTypeResetRubricOutcomeArgs = {
  criteriaId: InputMaybe<Scalars['ID']['input']>;
  markerRubricId: Scalars['ID']['input'];
};


export type RootMutationTypeResetRubricOutcomeForFieldArgs = {
  assessmentId: Scalars['ID']['input'];
  fieldOutcomeId: Scalars['ID']['input'];
  markerRubricId: Scalars['ID']['input'];
};


export type RootMutationTypeResetRubricOutcomeForSubmissionArgs = {
  assessmentId: Scalars['ID']['input'];
  markerRubricId: Scalars['ID']['input'];
  submissionOutcomeId: Scalars['ID']['input'];
};


export type RootMutationTypeResetScoreModerationChangesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootMutationTypeResolveMessagesArgs = {
  assessmentId: Scalars['ID']['input'];
  messageIds: Array<Scalars['ID']['input']>;
};


export type RootMutationTypeSaveArgs = {
  content: Scalars['String']['input'];
  dispatchedAt: Scalars['DateTime']['input'];
  editor: InputMaybe<EditorType>;
  metadata: InputMaybe<SaveMetadataInput>;
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeSaveBlockSnapshotArgs = {
  answerBlockId: Scalars['ID']['input'];
  previousBlockSnapshotId: InputMaybe<Scalars['ID']['input']>;
  snapshotContent: Scalars['String']['input'];
  version: Scalars['Int']['input'];
  wordCountChange: InputMaybe<Scalars['String']['input']>;
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeSaveCharterEditorArgs = {
  input: CharterEditorInput;
};


export type RootMutationTypeSaveGenaiGuidelineNoticeArgs = {
  content: Scalars['String']['input'];
  taskId: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
};


export type RootMutationTypeSaveGlobalUserSettingsArgs = {
  userSettingsInput: GlobalUserSettingsInput;
};


export type RootMutationTypeSaveMarkerRubricArgs = {
  input: MarkerRubricInput;
  markerRubricId: Scalars['ID']['input'];
};


export type RootMutationTypeSaveQuestionStateArgs = {
  input: SaveQuestionStateInput;
  questionId: Scalars['ID']['input'];
};


export type RootMutationTypeSendEmailsToClassArgs = {
  assessmentId: Scalars['ID']['input'];
  submissionIds: Array<InputMaybe<Scalars['ID']['input']>>;
  taskId: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeSendMessageArgs = {
  assessmentId: Scalars['ID']['input'];
  message: MessageInput;
};


export type RootMutationTypeSetAssessmentEmailConsentArgs = {
  assessmentId: Scalars['ID']['input'];
  consent: Scalars['Boolean']['input'];
};


export type RootMutationTypeSetMarkerAdjustmentArgs = {
  note: InputMaybe<Scalars['String']['input']>;
  studentId: Scalars['ID']['input'];
  value: Scalars['Decimal']['input'];
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeSetupAccessCodeArgs = {
  assessmentId: Scalars['ID']['input'];
  input: AccessCodeInput;
};


export type RootMutationTypeSetupCharterArgs = {
  groupId: Scalars['ID']['input'];
};


export type RootMutationTypeSetupGroupWorkArgs = {
  groupId: Scalars['ID']['input'];
};


export type RootMutationTypeSetupGroupsArgs = {
  assessmentId: Scalars['ID']['input'];
  input: SetupGroupInput;
  settingsInput: InputMaybe<GroupSettingsInput>;
};


export type RootMutationTypeSetupTaskArgs = {
  assessmentId: Scalars['ID']['input'];
  kind: TaskKind;
};


export type RootMutationTypeSetupWorkArgs = {
  taskId: Scalars['ID']['input'];
};


export type RootMutationTypeSnapshotFieldOutcomeArgs = {
  fieldOutcomeId: Scalars['ID']['input'];
  input: SnapshotFieldOutcomeInput;
};


export type RootMutationTypeSnapshotSubmissionOutcomeArgs = {
  input: SnapshotSubmissionOutcomeInput;
  submissionOutcomeId: Scalars['ID']['input'];
};


export type RootMutationTypeStartArgs = {
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeStartSocraticDialogueArgs = {
  dialogueId: Scalars['ID']['input'];
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeStartSocraticQuestionerRunArgs = {
  input: StartSocraticQuestionerRunInput;
  taskId: Scalars['ID']['input'];
};


export type RootMutationTypeStartSocraticTurnArgs = {
  turnId: Scalars['ID']['input'];
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeSubmitArgs = {
  acceptedDeclaration: Scalars['Boolean']['input'];
  editor: InputMaybe<EditorType>;
  saveId: Scalars['ID']['input'];
  sessionId: InputMaybe<Scalars['String']['input']>;
  submittedAt: InputMaybe<Scalars['DateTime']['input']>;
  type: SubmissionType;
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeSubmitAttemptArgs = {
  attemptNumber: Scalars['Int']['input'];
  submissionDate: InputMaybe<Scalars['DateTime']['input']>;
  type: SubmissionType;
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeSubmitAttemptV2Args = {
  attemptNumber: Scalars['Int']['input'];
  submissionDate: InputMaybe<Scalars['DateTime']['input']>;
  type: SubmissionType;
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeSubmitSentimentCheckArgs = {
  assessmentId: Scalars['ID']['input'];
  input: SentimentCheckInput;
};


export type RootMutationTypeSubmitV2Args = {
  blockSnapshotIds: Array<Scalars['ID']['input']>;
  forceSubmitted: InputMaybe<Scalars['Boolean']['input']>;
  submittedAt: InputMaybe<Scalars['DateTime']['input']>;
  submittedBy: InputMaybe<Scalars['String']['input']>;
  type: SubmissionType;
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeSwapResourceArgs = {
  firstId: Scalars['ID']['input'];
  secondId: Scalars['ID']['input'];
};


export type RootMutationTypeSyncGradesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootMutationTypeSyncRosterArgs = {
  assessmentId: Scalars['ID']['input'];
  extensionConflictAction?: InputMaybe<ExtensionConflictActionType>;
  withExtensions?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootMutationTypeUnassignMarkersArgs = {
  assessmentId: Scalars['ID']['input'];
  groupMarkerIds: Array<Scalars['ID']['input']>;
};


export type RootMutationTypeUnlinkCommentThreadArgs = {
  assessmentId: Scalars['ID']['input'];
  threadId: Scalars['ID']['input'];
};


export type RootMutationTypeUnlinkLibraryQuestionArgs = {
  input: UnlinkLibraryQuestionInput;
};


export type RootMutationTypeUnlockStudentCharterArgs = {
  input: CharterAgreementInput;
};


export type RootMutationTypeUnsubmitArgs = {
  submissionId: Scalars['ID']['input'];
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeUpdateAnswerBlockArgs = {
  answerBlockId: Scalars['ID']['input'];
  input: UpdateAnswerBlockInput;
};


export type RootMutationTypeUpdateAssessmentNameArgs = {
  assessmentId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type RootMutationTypeUpdateAssessmentSettingsArgs = {
  assessmentId: Scalars['ID']['input'];
  input: AssessmentSettingsInput;
};


export type RootMutationTypeUpdateCharterFormArgs = {
  input: CharterFormInput;
};


export type RootMutationTypeUpdateEnrollmentsStatusArgs = {
  assessmentId: Scalars['ID']['input'];
  enrollmentIds: Array<Scalars['ID']['input']>;
  withdrawn: Scalars['Boolean']['input'];
};


export type RootMutationTypeUpdateExperienceArgs = {
  score: Scalars['Int']['input'];
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeUpdateFeedbackReleaseRulesArgs = {
  assessmentId: Scalars['ID']['input'];
  releaseType: InputMaybe<FeedbackReleaseType>;
  rules: Array<FeedbackReleaseRuleInput>;
};


export type RootMutationTypeUpdateFeedbackVisibilityArgs = {
  assessmentId: Scalars['ID']['input'];
  input: FeedbackVisibilityInput;
  releaseType: InputMaybe<FeedbackReleaseType>;
};


export type RootMutationTypeUpdateFieldRubricResponseArgs = {
  assessmentId: Scalars['ID']['input'];
  input: UpdateFieldRubricInput;
};


export type RootMutationTypeUpdateFileOriginArgs = {
  input: UpdateQuestionBankFileOriginInput;
};


export type RootMutationTypeUpdateGroupArgs = {
  assessmentId: Scalars['ID']['input'];
  group: GroupUpdateInput;
};


export type RootMutationTypeUpdateGroupMembershipsArgs = {
  assessmentId: Scalars['ID']['input'];
  memberships: Array<GroupMembershipInput>;
};


export type RootMutationTypeUpdateInsightsMailingListArgs = {
  assessmentId: Scalars['ID']['input'];
  members: Array<Scalars['String']['input']>;
  subscribed: Scalars['Boolean']['input'];
};


export type RootMutationTypeUpdateMarkerRubricArgs = {
  input: MarkerRubricInput;
  markerRubricId: Scalars['ID']['input'];
};


export type RootMutationTypeUpdateMilestonesArgs = {
  input: UpdateMilestonesInput;
};


export type RootMutationTypeUpdateModerationPenaltyRulesArgs = {
  assessmentId: Scalars['ID']['input'];
  rules: Array<ModerationPenaltyRuleInput>;
};


export type RootMutationTypeUpdatePreferredAssessmentSourcesArgs = {
  assessmentId: Scalars['ID']['input'];
  sourceAssessmentIds: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type RootMutationTypeUpdateProjectIssueArgs = {
  input: UpdateProjectIssueInput;
};


export type RootMutationTypeUpdateQuestionArgs = {
  input: QuestionAttributesInput;
  questionId: Scalars['ID']['input'];
};


export type RootMutationTypeUpdateQuestionAttributesArgs = {
  input: QuestionAttributesInput;
  questionIds: Array<Scalars['ID']['input']>;
};


export type RootMutationTypeUpdateQuestionBankArgs = {
  questionBank: UpdateQuestionBankInput;
};


export type RootMutationTypeUpdateQuestionBanksCategoryArgs = {
  input: UpdateQuestionBanksCategoryInput;
};


export type RootMutationTypeUpdateQuestionRubricArgs = {
  assessmentId: Scalars['ID']['input'];
  input: UpdateQuestionRubricInput;
};


export type RootMutationTypeUpdateQuestionSourceFileArgs = {
  input: UpdateQuestionSourceFileInput;
};


export type RootMutationTypeUpdateQuestionVersionArgs = {
  childrenQuestions: InputMaybe<Array<UpdateQuestionVersionInput>>;
  input: UpdateQuestionVersionInput;
};


export type RootMutationTypeUpdateRequirementsArgs = {
  assessmentId: Scalars['ID']['input'];
  requirements: RequirementsInput;
};


export type RootMutationTypeUpdateResourceArgs = {
  id: Scalars['ID']['input'];
  name: InputMaybe<Scalars['String']['input']>;
  notes: InputMaybe<Scalars['String']['input']>;
  url: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeUpdateStudentOutcomeScoreArgs = {
  assessmentId: Scalars['ID']['input'];
  input: UpdateStudentOutcomeScoreInput;
  studentId: Scalars['ID']['input'];
};


export type RootMutationTypeUpdateStudentSettingsArgs = {
  assessmentId: Scalars['ID']['input'];
  settings: Array<InputMaybe<StudentSettingsInput>>;
};


export type RootMutationTypeUpdateSubmissionMarkerModifierArgs = {
  assessmentId: Scalars['ID']['input'];
  awardedPoints: InputMaybe<Scalars['Float']['input']>;
  submissionOutcomeId: Scalars['Int']['input'];
};


export type RootMutationTypeUpdateTagsForQuestionArgs = {
  input: Array<TagInput>;
  questionId: Scalars['ID']['input'];
};


export type RootMutationTypeUpdateTaskBlockArgs = {
  input: UpdateTaskBlockInput;
  taskBlockId: Scalars['ID']['input'];
};


export type RootMutationTypeUpdateTaskBlocksArgs = {
  taskBlockList: Array<UpdateTaskBlocksInput>;
};


export type RootMutationTypeUpdateTaskFormatArgs = {
  format: TaskFormat;
  taskId: Scalars['ID']['input'];
};


export type RootMutationTypeUpdateThreadResolutionArgs = {
  resolved: Scalars['Boolean']['input'];
  threadId: Scalars['ID']['input'];
};


export type RootMutationTypeUpdateWorkOutcomeScoreArgs = {
  assessmentId: Scalars['ID']['input'];
  input: UpdateWorkOutcomeScoreInput;
};


export type RootMutationTypeUpdateWorkSettingsArgs = {
  assessmentId: Scalars['ID']['input'];
  draftExamEndDate: InputMaybe<Scalars['String']['input']>;
  draftExamStartDate: InputMaybe<Scalars['String']['input']>;
  dueDate: InputMaybe<Scalars['DateTime']['input']>;
  enrollmentId: Scalars['ID']['input'];
  examDeferred: InputMaybe<Scalars['Boolean']['input']>;
  examEndDate: InputMaybe<Scalars['DateTime']['input']>;
  examReadingTime: InputMaybe<Scalars['Int']['input']>;
  examStartDate: InputMaybe<Scalars['DateTime']['input']>;
  examWritingTime: InputMaybe<Scalars['Int']['input']>;
  submitAttemptLimit: InputMaybe<Scalars['Int']['input']>;
  taskKind?: InputMaybe<TaskKind>;
  timeLimit: InputMaybe<Scalars['Int']['input']>;
  updateReason: InputMaybe<Scalars['String']['input']>;
  vivaExtraAttempts: InputMaybe<Scalars['Int']['input']>;
};


export type RootMutationTypeVerifyAccessCodeArgs = {
  assessmentId: Scalars['ID']['input'];
  code: Scalars['String']['input'];
};


export type RootMutationTypeWithdrawFeedbackArgs = {
  assessmentId: Scalars['ID']['input'];
  studentIds: Array<Scalars['ID']['input']>;
};

export type RootQueryType = {
  __typename?: 'RootQueryType';
  /** Token to use for making API calls to all Cadmus services */
  apiToken: Scalars['String']['output'];
  /** A single assessment. */
  assessment: Assessment;
  /** Returns all active AccessCodes in an Assessment. */
  assessmentAccessCodes: Maybe<Array<AccessCode>>;
  /** All Student Group Charter documents in the Assessment. */
  assessmentCharters: Array<Charter>;
  /** Current student's email-sharing consent state in the Assessment. */
  assessmentEmailConsent: AssessmentEmailConsent;
  /** List of all published marker rubrics for an Assessment. */
  assessmentMarkerRubrics: Array<MarkerRubric>;
  assessmentProgress: AssessmentProgressResponse;
  assessmentProjectIssues: Array<ProjectIssue>;
  /** Per-question scores for every WorkOutcome in an Assessment. */
  assessmentQuestionScores: Array<WorkOutcomeQuestionScores>;
  /** List all Sentiment Checks submitted by students in an Assessment. */
  assessmentSentimentChecks: Array<SentimentCheck>;
  /** Lookup existing background job. */
  backgroundJob: Maybe<BackgroundJob>;
  /** Access the Brightspace REST API as the current user via OAuth2 interface. */
  brightspaceApi: BrightspaceApi;
  /** Access the Canvas REST API as the current user via OAuth2 interface. */
  canvasApi: CanvasApi;
  /** Student group charter document */
  charter: Charter;
  /** Assessment's Group Charter form (draft or published) */
  charterForm: Maybe<CharterForm>;
  /** Complete Class information for an Assessment's cohort. */
  class: Class;
  /**
   * A full Class list for the given Assessment.
   * @deprecated Use `class` query field instead
   */
  classList: ClassList;
  /** All Peer Outcomes in a Class, for teacher eyes only. */
  classPeerOutcomes: Array<PeerOutcome>;
  /** All Work Groups in a Group Assessment. */
  classWorkGroups: Array<WorkGroup>;
  /**
   * Authorship overlay for an answer block (`answer_block_id` is the stream id):
   * which author wrote each surviving range, plus deleted text/media on request.
   *
   * `from`/`to` (1-based PM positions, `to` exclusive) window the result to a
   * viewport — only the ranges and deletions overlapping it are returned, and the
   * rest of the document is never materialised. Give both or neither.
   * `include_deletions` adds the (larger) deletions list; off by default.
   * `as_of_version` time-travels for the timeline scrubber; omit for the latest.
   */
  contribution: Contribution;
  /**
   * Contribution overlays at several versions in one progressive fold — the batch
   * counterpart to `contribution(as_of_version:)`. Steps are folded once across
   * all versions rather than re-folded per version. Results are ascending by
   * version and deduplicated (re-key by `as_of_version`), not in input order.
   */
  contributionsAt: Array<Contribution>;
  /** Reusing Scale Items by Skill */
  criteriaBySkill: Array<ReuseCriterion>;
  /** Recover a deleted extended answer block for a question. */
  deletedAnswerBlock: Maybe<AnswerBlock>;
  /**
   * The version-0 base document for an answer block. The client replays
   * `document_steps` over `base_doc` to reconstruct any version locally without
   * per-version snapshots or S3 reads.
   */
  documentBase: DocumentBase;
  /**
   * ProseMirror steps in the inclusive `from_version..to_version` range, ascending.
   * A buffered scrubber fetches the window it needs and applies the steps over
   * `document_base` to render frames.
   */
  documentSteps: Array<DocumentStep>;
  /**
   * Seek window for the timeline scrubber. Returns the nearest snapshot at or
   * before `target_version` (as `base_version`) plus steps
   * `base_version+1 .. target_version+buffer`, so the client seeds the snapshot,
   * applies the few steps to land on the target, and keeps the buffer to scrub
   * forward without a refetch.
   *
   * Pass `have_snapshot_version` with the snapshot the client already holds:
   * when it matches `base_version`, `document` is null and only steps ship.
   * `base_version` is 0 when no snapshot precedes the target.
   */
  documentWindow: DocumentWindow;
  /**
   * The feature flags currently enabled for the requesting user,
   * institution, and (optionally) assessment. Only flags evaluated to
   * `true` are returned; the full flag registry is intentionally not
   * exposed.
   *
   * Pass `assessmentId` from any UI that knows which assessment it is
   * showing — flags scoped to a specific assessment (or to a group that
   * includes the assessment's institution) can then evaluate correctly.
   */
  enabledFlags: Array<FeatureFlag>;
  /** Fetch threads by entity ID and type. */
  entityThreads: Array<Thread>;
  /** MarkerRubric lookup by ID and document status. */
  extendedRubric: Maybe<MarkerRubric>;
  /** Feature flags enabled in the user's context. */
  featureFlags: InstitutionFeatures;
  /** Feedback Release Rule: schedule feedback release based on filters. */
  feedbackReleaseRules: Array<FeedbackReleaseRule>;
  /**
   * feedback visibility for assessment
   * @deprecated Use `feedback_visibility_for_type` instead
   */
  feedbackVisibility: FeedbackVisibility;
  /** feedback visibility for assessment */
  feedbackVisibilityForType: FeedbackVisibility;
  /**
   * Future scheduled Instruction sheet, if any
   * @deprecated Use tasks.futureSheet instead
   */
  futureSheet: Maybe<Sheet>;
  groupList: Array<Group>;
  /** Peer Outcomes for members of a Student Group. */
  groupPeerOutcomes: Array<PeerOutcome>;
  /** List Sentiment Checks submitted by students in a group. */
  groupSentimentChecks: Array<SentimentCheck>;
  /** Work Outcome for a Student Group in an assessment. */
  groupWorkOutcome: Maybe<WorkOutcome>;
  /**
   * Groups for assessment.
   * @deprecated Use `class` query field instead
   */
  groups: Array<Group>;
  /**
   * Assessment's latest Insights mailing list consisting of teacher emails who
   * want to receive Insight updates via email.
   */
  insightsMailingList: MailingList;
  /** Current user Institution. */
  institution: Institution;
  /**
   * InstructionSheet within an Assessment defaulting to the latest.
   * @deprecated Use tasks.instructionSheet instead
   */
  instructionSheet: Maybe<Sheet>;
  /**
   * Latest Gradebook result for a particular submission type.
   *
   * This field always tries to resolve to the most up to date information, and
   * can also query Hera (and in turn Turnitin) to get it.
   */
  latestResult: Result;
  /** List of lecturers for an assessment */
  lecturers: Array<User>;
  /** Lists all library questions viewable by the current user. */
  libraryQuestions: Array<Question>;
  /** MarkerRubric lookup in an Assessment for a given kind and document status. */
  markerRubric: Maybe<MarkerRubric>;
  /** Lookup marker rubric by ID for lecturers. */
  markerRubricById: MarkerRubric;
  /** Current logged in User profile */
  me: User;
  /** List messages receivable by current user. */
  messageInbox: Array<Message>;
  /** Moderation Penalty Rule: penalties to apply on feedback release. */
  moderationPenaltyRules: Maybe<Array<ModerationPenaltyRule>>;
  /**
   * Question read-model for Moderation in Cadmus Marker for particular Task in an Assessment.
   * If task kind is not provided, defaults to `:individual`.
   */
  moderationQuestions: Array<ModerationQuestion>;
  /** Past instruction sheets that the user has been involved in. */
  pastInstructionSheets: Array<PastInstructionSheet>;
  /** Past Marker Rubric by ID */
  pastMarkerRubric: MarkerRubric;
  /** List all MarkerRubrics accessibly to the current lecturer. */
  pastMarkerRubrics: Array<MarkerRubric>;
  /** Peer Rubric for Students */
  peerRubric: Maybe<MarkerRubric>;
  /** The assessments the current user has preferred as Smart Comment sources while grading assessmentId. */
  preferredAssessmentSources: Array<Assessment>;
  /** URL for a expected PrintInstruction archive, if it is ready. */
  printArchiveUrl: Maybe<Scalars['String']['output']>;
  /** List of issues in a student Group's project board. */
  projectIssues: Array<ProjectIssue>;
  /** Single library published question */
  question: Maybe<Question>;
  questionBankCategories: Array<QuestionBankCategory>;
  questionBanks: Array<QuestionBank>;
  /** Single question rubric. */
  questionRubric: QuestionRubric;
  questionSelection: Maybe<QuestionSelection>;
  /** All Tag categories in the Question Library for the current Tenant */
  questionTagCategories: Array<QuestionTagCategory>;
  /** List of all selected question blocks in the Task. */
  questionTree: Array<QuestionBlock>;
  /** Select a known past Question version */
  questionVersion: Maybe<QuestionVersion>;
  /**
   * Re-entry metadata for the student's current exam session. Returns whether a
   * re-entry code is required and how many re-entry events have occurred, so
   * aphrodite can render the correct access code modal variant and attempt number.
   */
  reentryStatus: ReentryStatus;
  /** Assessment's marking rubrics. */
  rubric: Maybe<Rubric>;
  /**
   * Search assessments by assessment or subject name.
   * Scoped to assessments the current user is enrolled in.
   */
  searchAssessments: Array<AssessmentOption>;
  /** List an assessment's group-formation sections, ordered by position. */
  sections: Array<Section>;
  /** @deprecated Please use :api_token instead, which is more scoped */
  serviceToken: Scalars['String']['output'];
  /** User's session information. */
  session: Session;
  /**
   * Current Session ID tied to the user's authenticated session.
   * @deprecated Please use the `session` field instead.
   */
  sessionId: Scalars['String']['output'];
  /** Learning Outcome Skills for the Tenant. */
  skills: Array<LearningOutcomeSkill>;
  /** Learning Outcome Skills used in the Assessment. */
  skillsByAssessment: Array<LearningOutcomeSkill>;
  smartCommentsBySkills: Array<SmartComment>;
  /**
   * Document and contribution overlay at one point on the timeline, folded to
   * `version` and scoped to the group's active members.
   */
  snapshot: Snapshot;
  /**
   * Timeline ticks for an answer block, oldest first — one per adaptive time
   * bucket (per-save would flood the scrubber). The bucket scales with the
   * snapshot count, from every snapshot down to one per day. Pair each
   * `version` with `snapshot` to load the document and contribution there.
   *
   * `max_snapshot_id` caps the timeline at that snapshot's version, so a draft
   * scrubber ends on the draft.
   */
  snapshotTicks: Array<SnapshotTick>;
  /**
   * Batched `snapshot` for buffering the scrubber. Versions with no snapshot
   * or a failed doc fetch are omitted; the caller keeps whatever loaded.
   */
  snapshots: Array<Snapshot>;
  /** Fetch a specific Socratic Dialogue by ID. */
  socraticDialogue: Maybe<SocraticDialogue>;
  /** Fetch multiple Socratic Dialogues by IDs. Restricted to lecturers. */
  socraticDialogues: Array<SocraticDialogue>;
  /** Fetch the questioner preview for a task block. */
  socraticQuestionerPreview: SocraticQuestionerPreview;
  /** Fetch a Socratic Session for a student and answer block, creating it if it does not exist. */
  socraticSession: SocraticSession;
  /** Fetch the transcription outcome for a Socratic Dialogue's turn. */
  socraticTranscript: Maybe<SocraticTranscription>;
  studentEnrollments: Array<Enrollment>;
  /** Student Outcome in an Assessment */
  studentOutcome: StudentOutcome;
  /** Student Outcomes in an Assessment */
  studentOutcomes: Array<StudentOutcome>;
  /**
   * Completion status for the current student's peer evaluation in this
   * assessment. Returns `null` when no peer rubric is published, or when
   * the student is not in a group for the assessment.
   */
  studentPeerEvalProgress: Maybe<StudentPeerEvalProgress>;
  /** The current student's Peer Outcome in the Assessment. */
  studentPeerOutcome: Maybe<PeerOutcome>;
  /** List all sentiment check intervals for the current student in an assessment. */
  studentSentimentChecks: Array<SentimentCheckInterval>;
  /** Current student users' Work Group in the Assessment. */
  studentWorkGroup: Maybe<WorkGroup>;
  /** Work Outcome for a Student in an assessment. */
  studentWorkOutcome: Maybe<WorkOutcome>;
  /** A single assessment task of a specific kind. */
  task: Maybe<Task>;
  /** Fetch a thread by ID. */
  thread: Thread;
  /** Fetch multiple threads by IDs. */
  threads: Array<Thread>;
  /** Token for Current User token authentication with Phoenix channels. */
  token: Scalars['String']['output'];
  /** Lookup complete user settings for an asseessment */
  userSettings: Maybe<UserSettings>;
  /** A single Work. */
  work: Work;
  /** Outcome recorded for a student's work. */
  workOutcome: Maybe<WorkOutcome>;
  /** Work Outcomes in an Assessment that the user can access. */
  workOutcomes: Array<WorkOutcome>;
};


export type RootQueryTypeApiTokenArgs = {
  assessmentId: Scalars['ID']['input'];
  workId: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeAssessmentArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeAssessmentAccessCodesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeAssessmentChartersArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeAssessmentEmailConsentArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeAssessmentMarkerRubricsArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeAssessmentProgressArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeAssessmentProjectIssuesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeAssessmentQuestionScoresArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeAssessmentSentimentChecksArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeBackgroundJobArgs = {
  jobId: Scalars['ID']['input'];
};


export type RootQueryTypeBrightspaceApiArgs = {
  assessmentId: Scalars['ID']['input'];
  brightspaceScopeFor?: InputMaybe<BrightspaceScopeKeyType>;
};


export type RootQueryTypeCanvasApiArgs = {
  assessmentId: Scalars['ID']['input'];
  canvasScopeFor?: InputMaybe<CanvasScopeKeyType>;
};


export type RootQueryTypeCharterArgs = {
  charterId: Scalars['ID']['input'];
};


export type RootQueryTypeCharterFormArgs = {
  assessmentId: Scalars['ID']['input'];
  published?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeClassArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeClassListArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeClassPeerOutcomesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeClassWorkGroupsArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeContributionArgs = {
  answerBlockId: Scalars['ID']['input'];
  asOfVersion: InputMaybe<Scalars['Int']['input']>;
  assessmentId: Scalars['ID']['input'];
  from: InputMaybe<Scalars['Int']['input']>;
  includeDeletions?: InputMaybe<Scalars['Boolean']['input']>;
  to: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeContributionsAtArgs = {
  answerBlockId: Scalars['ID']['input'];
  assessmentId: Scalars['ID']['input'];
  versions: Array<Scalars['Int']['input']>;
};


export type RootQueryTypeCriteriaBySkillArgs = {
  assessmentId: Scalars['ID']['input'];
  skillId: Scalars['ID']['input'];
};


export type RootQueryTypeDeletedAnswerBlockArgs = {
  answerBlockId: Scalars['ID']['input'];
};


export type RootQueryTypeDocumentBaseArgs = {
  answerBlockId: Scalars['ID']['input'];
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeDocumentStepsArgs = {
  answerBlockId: Scalars['ID']['input'];
  assessmentId: Scalars['ID']['input'];
  fromVersion: Scalars['Int']['input'];
  toVersion: Scalars['Int']['input'];
};


export type RootQueryTypeDocumentWindowArgs = {
  answerBlockId: Scalars['ID']['input'];
  assessmentId: Scalars['ID']['input'];
  buffer?: InputMaybe<Scalars['Int']['input']>;
  haveSnapshotVersion: InputMaybe<Scalars['Int']['input']>;
  targetVersion: Scalars['Int']['input'];
};


export type RootQueryTypeEnabledFlagsArgs = {
  assessmentId: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeEntityThreadsArgs = {
  entityId: InputMaybe<Scalars['ID']['input']>;
  entityIds: InputMaybe<Array<Scalars['ID']['input']>>;
  entityType: EntityType;
};


export type RootQueryTypeExtendedRubricArgs = {
  assessmentId: Scalars['ID']['input'];
  markerRubricId: Scalars['ID']['input'];
  status: MarkerRubricStatus;
};


export type RootQueryTypeFeatureFlagsArgs = {
  assessmentId: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeFeedbackReleaseRulesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeFeedbackVisibilityArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeFeedbackVisibilityForTypeArgs = {
  assessmentId: Scalars['ID']['input'];
  releaseType: FeedbackReleaseType;
};


export type RootQueryTypeFutureSheetArgs = {
  assessmentId: Scalars['ID']['input'];
  kind: InputMaybe<TaskKind>;
};


export type RootQueryTypeGroupListArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeGroupPeerOutcomesArgs = {
  assessmentId: Scalars['ID']['input'];
  groupId: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeGroupSentimentChecksArgs = {
  assessmentId: Scalars['ID']['input'];
  groupId: Scalars['ID']['input'];
};


export type RootQueryTypeGroupWorkOutcomeArgs = {
  assessmentId: Scalars['ID']['input'];
  studentId: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeGroupsArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeInsightsMailingListArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeInstructionSheetArgs = {
  assessmentId: Scalars['ID']['input'];
  kind: InputMaybe<TaskKind>;
  sheetId: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeLatestResultArgs = {
  submissionType: SubmissionType;
  workId: Scalars['ID']['input'];
};


export type RootQueryTypeLecturersArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeMarkerRubricArgs = {
  assessmentId: Scalars['ID']['input'];
  kind: MarkerRubricKind;
  status: MarkerRubricStatus;
};


export type RootQueryTypeMarkerRubricByIdArgs = {
  markerRubricId: Scalars['ID']['input'];
};


export type RootQueryTypeMessageInboxArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeModerationPenaltyRulesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeModerationQuestionsArgs = {
  assessmentId: Scalars['ID']['input'];
  taskKind: InputMaybe<TaskKind>;
};


export type RootQueryTypePastInstructionSheetsArgs = {
  assessmentId: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypePastMarkerRubricArgs = {
  markerRubricId: Scalars['ID']['input'];
};


export type RootQueryTypePastMarkerRubricsArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypePeerRubricArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypePreferredAssessmentSourcesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypePrintArchiveUrlArgs = {
  archiveId: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
};


export type RootQueryTypeProjectIssuesArgs = {
  groupId: Scalars['ID']['input'];
};


export type RootQueryTypeQuestionArgs = {
  questionId: Scalars['ID']['input'];
};


export type RootQueryTypeQuestionBankCategoriesArgs = {
  assessmentId: InputMaybe<Scalars['ID']['input']>;
  subjectGroupId: InputMaybe<Scalars['ID']['input']>;
  subjectId: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeQuestionBanksArgs = {
  assessmentId: InputMaybe<Scalars['ID']['input']>;
  subjectGroupId: InputMaybe<Scalars['ID']['input']>;
  subjectId: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeQuestionRubricArgs = {
  questionRubricId: Scalars['ID']['input'];
};


export type RootQueryTypeQuestionSelectionArgs = {
  questionSelectionId: Scalars['ID']['input'];
};


export type RootQueryTypeQuestionTreeArgs = {
  selectionInput: Array<QuestionSelectionFilterInput>;
  taskId: Scalars['ID']['input'];
};


export type RootQueryTypeQuestionVersionArgs = {
  questionId: InputMaybe<Scalars['ID']['input']>;
  version: InputMaybe<Scalars['Int']['input']>;
  versionId: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeReentryStatusArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeRubricArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeSearchAssessmentsArgs = {
  search: Scalars['String']['input'];
};


export type RootQueryTypeSectionsArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeSkillsByAssessmentArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeSmartCommentsBySkillsArgs = {
  assessmentIds: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  maxScore: InputMaybe<Scalars['Int']['input']>;
  rangeFrom: InputMaybe<Scalars['Int']['input']>;
  rangeTo: InputMaybe<Scalars['Int']['input']>;
  skillIds: Array<Scalars['ID']['input']>;
};


export type RootQueryTypeSnapshotArgs = {
  answerBlockId: Scalars['ID']['input'];
  assessmentId: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
};


export type RootQueryTypeSnapshotTicksArgs = {
  answerBlockId: Scalars['ID']['input'];
  assessmentId: Scalars['ID']['input'];
  maxSnapshotId: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeSnapshotsArgs = {
  answerBlockId: Scalars['ID']['input'];
  assessmentId: Scalars['ID']['input'];
  versions: Array<Scalars['Int']['input']>;
};


export type RootQueryTypeSocraticDialogueArgs = {
  assessmentId: Scalars['ID']['input'];
  dialogueId: Scalars['ID']['input'];
};


export type RootQueryTypeSocraticDialoguesArgs = {
  assessmentId: Scalars['ID']['input'];
  dialogueIds: Array<Scalars['ID']['input']>;
};


export type RootQueryTypeSocraticQuestionerPreviewArgs = {
  input: SocraticQuestionerPreviewInput;
  taskId: Scalars['ID']['input'];
};


export type RootQueryTypeSocraticSessionArgs = {
  answerBlockId: Scalars['ID']['input'];
  workId: Scalars['ID']['input'];
};


export type RootQueryTypeSocraticTranscriptArgs = {
  assessmentId: Scalars['ID']['input'];
  dialogueId: Scalars['ID']['input'];
};


export type RootQueryTypeStudentEnrollmentsArgs = {
  assessmentId: Scalars['ID']['input'];
  studentIds: Array<Scalars['ID']['input']>;
  withDeleted: Scalars['Boolean']['input'];
};


export type RootQueryTypeStudentOutcomeArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeStudentOutcomesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeStudentPeerEvalProgressArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeStudentPeerOutcomeArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeStudentSentimentChecksArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeStudentWorkGroupArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeStudentWorkOutcomeArgs = {
  assessmentId: Scalars['ID']['input'];
  studentId: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeTaskArgs = {
  assessmentId: Scalars['ID']['input'];
  kind: InputMaybe<TaskKind>;
  taskId: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeThreadArgs = {
  threadId: Scalars['ID']['input'];
};


export type RootQueryTypeThreadsArgs = {
  threadIds: Array<Scalars['ID']['input']>;
};


export type RootQueryTypeUserSettingsArgs = {
  assessmentId: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeWorkArgs = {
  workId: Scalars['ID']['input'];
};


export type RootQueryTypeWorkOutcomeArgs = {
  workId: Scalars['ID']['input'];
};


export type RootQueryTypeWorkOutcomesArgs = {
  assessmentId: Scalars['ID']['input'];
};

export type RootSubscriptionType = {
  __typename?: 'RootSubscriptionType';
  /** Deprecated: use assessmentSettingsUpdated instead. Subscribe to updates for AssessmentSettings */
  assessmentSettings: AssessmentSettings;
  /** Subscribe to updates for AssessmentSettings. Prefer this over the deprecated assessmentSettings subscription. */
  assessmentSettingsUpdated: AssessmentSettings;
  /** Notification on number of enrollments updated */
  enrollmentsUpdated: Scalars['Int']['output'];
  /** Subscribe to thread updates for a specific entity (e.g., answer block). Receives lightweight thread lifecycle events. */
  entityThreadsUpdated: EntityThreadEvent;
  /** Subscription for field outcome batch updates. */
  fieldOutcomesUpdated: Maybe<Array<Maybe<FieldOutcome>>>;
  /** Subscription for field_rubric updates. */
  fieldRubricsUpdated: Array<FieldRubric>;
  /** Future sheet release schedule timestamp */
  futureReleaseSchedule: Maybe<Scalars['PreciseDateTime']['output']>;
  /** Subscription for when a group is updated by self enrollment. */
  groupUpdated: Group;
  /** At least one submission has been made in the Assessment. */
  hasSubmission: Scalars['Boolean']['output'];
  /**
   * A Gradebook Result update in an Assessment.
   * @deprecated Use `results_updated` instead
   */
  resultUpdated: Result;
  /** Multiple Gradebook Results updated in an Assessment. */
  resultsUpdated: Array<Result>;
  /** Subscribe to updates for a Schoolyear exam. */
  schoolyearExamUpdated: SchoolyearExam;
  /** New Instruction Sheet release. */
  sheetReleased: Sheet;
  /** A question in a run reached a terminal state (completed or failed). */
  socraticQuestionerRunUpdated: SocraticQuestion;
  /** Pushed when a Socratic turn's transcription attempt finishes. */
  socraticTranscriptionUpdated: SocraticTranscriptionOutcome;
  /**
   * Lightweight notification that one or more student outcomes changed for an
   * assessment.
   *
   * Unlike `student_outcomes_updated`, this does not resolve the (expensive)
   * score breakdowns — it only reports how many, and which, students changed,
   * so it is safe to fan out to every connected lecturer even for large
   * cohorts. Clients use it to surface an "out of sync" indicator and refetch
   * on demand.
   */
  studentOutcomesInvalidated: OutcomeSyncSignal;
  /** Subscription for student outcomes updates for an assessment */
  studentOutcomesUpdated: Array<StudentOutcome>;
  /** Subscribe to conversation updates for a specific thread. Receives comment additions, edits, and title changes. */
  threadConversationUpdated: ConversationEvent;
  /** [DEPRECATED] Subscribe to thread updates. Use entity_threads_updated for thread lifecycle events or thread_conversation_updated for comment events. */
  threadUpdated: Thread;
  /**
   * Subscription for work outcome batch updates.
   * @deprecated use `student_outcomes_updated`
   */
  workOutcomesUpdated: Array<WorkOutcome>;
  /** Pdf Artifact created in an assessment. */
  workPdfCreated: WorkArtifact;
  /** Update for a Gradebook result for a particular Work only. */
  workResultUpdated: Result;
  /** Update for a Work Settings. */
  workSettingsUpdated: WorkSettings;
  /** Update for work started */
  workStarted: Work;
  /** A Work has a new submission. */
  workSubmitted: Submission;
  /** A Work has been updated. Usually it's the settings that update for a work. */
  workUpdated: Work;
  /** A list of works' settings has been updated */
  worksSettingsUpdated: Array<Maybe<WorkSettings>>;
  /**
   * Multiple Works were submitted in the assessment.
   * @deprecated Use `results_updated` instead for updates on multiple submissions.
   */
  worksSubmitted: Array<Submission>;
};


export type RootSubscriptionTypeAssessmentSettingsArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeAssessmentSettingsUpdatedArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeEnrollmentsUpdatedArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeEntityThreadsUpdatedArgs = {
  entityId: Scalars['ID']['input'];
  entityType: EntityType;
};


export type RootSubscriptionTypeFieldOutcomesUpdatedArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeFieldRubricsUpdatedArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeFutureReleaseScheduleArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeGroupUpdatedArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeHasSubmissionArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeResultUpdatedArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeResultsUpdatedArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeSchoolyearExamUpdatedArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeSheetReleasedArgs = {
  assessmentId: Scalars['ID']['input'];
  workId: InputMaybe<Scalars['ID']['input']>;
};


export type RootSubscriptionTypeSocraticQuestionerRunUpdatedArgs = {
  runId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeSocraticTranscriptionUpdatedArgs = {
  dialogueId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeStudentOutcomesInvalidatedArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeStudentOutcomesUpdatedArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeThreadConversationUpdatedArgs = {
  threadId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeThreadUpdatedArgs = {
  threadId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeWorkOutcomesUpdatedArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeWorkPdfCreatedArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeWorkResultUpdatedArgs = {
  workId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeWorkSettingsUpdatedArgs = {
  workId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeWorkStartedArgs = {
  workId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeWorkSubmittedArgs = {
  workId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeWorkUpdatedArgs = {
  workId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeWorksSettingsUpdatedArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeWorksSubmittedArgs = {
  assessmentId: Scalars['ID']['input'];
};

/** An Assessment's marking rubrics. */
export type Rubric = {
  __typename?: 'Rubric';
  id: Scalars['ID']['output'];
  questions: Array<QuestionRubric>;
};

/** Marking outcome from using a MarkerRubric to score the parent Outcome. */
export type RubricOutcome = {
  __typename?: 'RubricOutcome';
  criterionOutcomes: Array<CriterionOutcome>;
  score: Maybe<Scalars['Float']['output']>;
};

/** A Save for a work. */
export type Save = {
  __typename?: 'Save';
  /** Fetched contents of the embedded S3 Store reference. */
  content: Scalars['String']['output'];
  dispatchedAt: Scalars['PreciseDateTime']['output'];
  id: Scalars['ID']['output'];
  /**
   * Database ID of the persisted save.
   *
   * This always reflects the actual table primary key of the Save, even when the
   * the `:id` value is some constant string. Sometimes the `:id` field has to
   * resolve to a constant string to make the client side cache always hit.
   */
  serverId: Scalars['ID']['output'];
  /** S3 object version ID. */
  version: Scalars['String']['output'];
};

/** Response for saving a block snapshot */
export type SaveBlockSnapshotResponse = {
  __typename?: 'SaveBlockSnapshotResponse';
  blockSnapshot: BlockSnapshot;
};

/** Mutation return for `saveGlobalUserSettings`. */
export type SaveGlobalUserSettingsPayload = {
  __typename?: 'SaveGlobalUserSettingsPayload';
  userSettings: Maybe<UserSettings>;
};

export type SaveMetadataInput = {
  assessmentId: Scalars['String']['input'];
  prevSaveId?: InputMaybe<Scalars['String']['input']>;
  prevVersionId?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated will be automatically added from session */
  sessionId?: InputMaybe<Scalars['String']['input']>;
  workId: Scalars['String']['input'];
};

/** Question state append attributes */
export type SaveQuestionStateInput = {
  feedback: Scalars['String']['input'];
  /** Question fields with response declaration and interaction type */
  fields?: InputMaybe<Array<QuestionFieldInput>>;
  /** Question prompt prosemirror contents */
  promptDoc?: InputMaybe<Scalars['String']['input']>;
  /** Question Prompt Image information and associated layers for a question prompt. */
  promptImage?: InputMaybe<PromptImageInput>;
  /** Question type */
  questionType: QuestionType;
  /** Short plain text prompt description */
  shortPrompt: Scalars['String']['input'];
};

/** Latest Task content save. */
export type SaveState = {
  __typename?: 'SaveState';
  /** Latest Task save ID. */
  id: Scalars['ID']['output'];
  /** JSON serialised raw content in this save. */
  rawContent: Maybe<Scalars['String']['output']>;
  /** The persisted TaskState server ID */
  serverId: Scalars['ID']['output'];
  updatedAt: Scalars['PreciseDateTime']['output'];
  version: Scalars['Int']['output'];
};

export type ScaleItem = {
  __typename?: 'ScaleItem';
  description: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  order: Scalars['Int']['output'];
  rangeFrom: Maybe<Scalars['Float']['output']>;
  rangeTo: Maybe<Scalars['Float']['output']>;
  scaleLabel: Maybe<Scalars['String']['output']>;
};

export type ScaleItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  order: Scalars['Int']['input'];
  rangeFrom?: InputMaybe<Scalars['Int']['input']>;
  rangeTo?: InputMaybe<Scalars['Int']['input']>;
  scaleLabel?: InputMaybe<Scalars['String']['input']>;
};

/** A Schoolyear exam linked to a Cadmus assessment. */
export type SchoolyearExam = {
  __typename?: 'SchoolyearExam';
  id: Scalars['ID']['output'];
  /** The push status of the Schoolyear exam. */
  pushStatus: SchoolyearExamPushStatus;
  /** The Schoolyear exam ID. Present only when push_status is ready. */
  schoolyearExamId: Maybe<Scalars['String']['output']>;
};

/** The push status of a Schoolyear exam. */
export enum SchoolyearExamPushStatus {
  /** The exam could not be created in Schoolyear. */
  Error = 'ERROR',
  /** The exam is being created in Schoolyear. */
  Pending = 'PENDING',
  /** The exam has been created in Schoolyear. */
  Ready = 'READY'
}

/** Score Breakdown */
export type ScoreBreakdown = {
  __typename?: 'ScoreBreakdown';
  automark: Maybe<Scalars['Float']['output']>;
  automarkScore: Maybe<Scalars['Float']['output']>;
  marker: Maybe<Scalars['Float']['output']>;
  markerModifier: Maybe<Scalars['Float']['output']>;
  markerScore: Maybe<Scalars['Float']['output']>;
  moderatorModifier: Maybe<Scalars['Float']['output']>;
  score: Maybe<Scalars['Float']['output']>;
};

/** Moderation decisions for score of a submission outcome. */
export enum ScoreModerationDecision {
  Average = 'AVERAGE',
  Custom = 'CUSTOM',
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY'
}

/** Input for score moderation decision. :highest and :lowest resolve per-outcome to :primary or :secondary. */
export enum ScoreModerationDecisionInput {
  Average = 'AVERAGE',
  Custom = 'CUSTOM',
  Highest = 'HIGHEST',
  Lowest = 'LOWEST',
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY'
}

/** A roster sub-division of an assessment (e.g. a tutorial cohort) */
export type Section = {
  __typename?: 'Section';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  /** Number of (non-withdrawn) students assigned to this section */
  studentCount: Scalars['Int']['output'];
};

/** One row of a section roster import: a student and the section they belong to. */
export type SectionAssignmentInput = {
  sectionName: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

/** How self evaluation affects the final grade. :component adds the self score as a grade component; :peer_scaling includes the student's own self evaluation alongside their peers in the peer group-report multiplier. */
export enum SelfEvaluationMode {
  Component = 'COMPONENT',
  PeerScaling = 'PEER_SCALING'
}

/** A sentiment check */
export type SentimentCheck = {
  __typename?: 'SentimentCheck';
  comment: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insertedAt: Maybe<Scalars['PreciseDateTime']['output']>;
  level: Maybe<SentimentCheckLevel>;
  order: Scalars['Int']['output'];
  sessionId: Scalars['String']['output'];
  skipped: Scalars['Boolean']['output'];
  user: User;
};

export type SentimentCheckInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<SentimentCheckLevel>;
  skipped: Scalars['Boolean']['input'];
};

/** A sentiment check interval representing a time window for submitting a check */
export type SentimentCheckInterval = {
  __typename?: 'SentimentCheckInterval';
  endTime: Scalars['PreciseDateTime']['output'];
  order: Scalars['Int']['output'];
  sentimentCheck: Maybe<SentimentCheck>;
  startTime: Scalars['PreciseDateTime']['output'];
};

/** Enum of sentiment check levels */
export enum SentimentCheckLevel {
  Green = 'GREEN',
  Orange = 'ORANGE',
  Red = 'RED'
}

/** A custom sentiment check schedule entry */
export type SentimentCheckSchedule = {
  __typename?: 'SentimentCheckSchedule';
  id: Scalars['ID']['output'];
  scheduledAt: Scalars['PreciseDateTime']['output'];
};

/** Input for a custom sentiment check schedule entry */
export type SentimentCheckScheduleInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  scheduledAt: Scalars['PreciseDateTime']['input'];
};

/** Schedule type for sentiment checks */
export enum SentimentCheckScheduleType {
  Custom = 'CUSTOM',
  Frequency = 'FREQUENCY'
}

/** Session information */
export type Session = {
  __typename?: 'Session';
  /** Session ID */
  id: Scalars['ID']['output'];
  /** Verification status for a session tied to an enrollment. */
  verified: Scalars['Boolean']['output'];
};


/** Session information */
export type SessionVerifiedArgs = {
  assessmentId: Scalars['ID']['input'];
};

export type SetupGroupInput = {
  bulkMarkerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  divideEqually?: InputMaybe<Scalars['Boolean']['input']>;
  excludedTags?: InputMaybe<Array<Scalars['String']['input']>>;
  groupAssessmentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  groupRules?: InputMaybe<Array<GroupRule>>;
  groupSelfEnrollment?: InputMaybe<Scalars['Boolean']['input']>;
  groupSelfEnrollmentDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  groupType: GroupType;
  maxLimit?: InputMaybe<Scalars['Int']['input']>;
  minLimit?: InputMaybe<Scalars['Int']['input']>;
};

export enum Shape {
  Ellipse = 'ellipse',
  Point = 'point',
  Polygon = 'polygon',
  Rectangle = 'rectangle'
}

/** Latest Instruction sheet for an Assessment. */
export type Sheet = {
  __typename?: 'Sheet';
  /**
   * List of released TaskBlocks in the Sheet
   * @deprecated Use the `question_blocks` field instead
   */
  blocks: Array<TaskBlock>;
  /** Released task format */
  format: TaskFormat;
  /** Settings to be used in the future, if this is a future sheet. */
  futureSettings: Maybe<AssessmentSettings>;
  /** GenAI Guideline notice released to students. */
  genaiGuidelineNotice: Maybe<TaskNotice>;
  /**
   * Task ID for which this sheet is released.
   *
   * NOTE: this is the Task ID and not the actual sheet ID which changes from
   * sheet to sheet. Use `serverId` for the actual sheet ID. This was done for
   * automatic cache replacement in apollo client for new sheets.
   */
  id: Scalars['String']['output'];
  kind: TaskKind;
  /** When the next sheet, if any, will be released. */
  nextReleaseTimestamp: Maybe<Scalars['PreciseDateTime']['output']>;
  /** Flattened Question Tree */
  questionBlocks: Array<QuestionBlock>;
  /** Serialised Editor contents of the Task body with other embedded metadata */
  rawContent: Maybe<Scalars['String']['output']>;
  /** When the sheet was released. */
  releaseTimestamp: Scalars['PreciseDateTime']['output'];
  /** List of released resources. */
  resources: Array<Resource>;
  /** Actual TaskHistory primary ID. */
  serverId: Scalars['ID']['output'];
  /** Settings for this assessment */
  settings: Maybe<AssessmentSettings>;
  /** Source Task ID for the Sheet */
  taskId: Scalars['ID']['output'];
  /** Task save version number from which the Sheet was created. */
  version: Scalars['Int']['output'];
};

/** Response as a plain text short phrase. */
export type ShortResponse = {
  __typename?: 'ShortResponse';
  /** Whether the matching is case sensitive */
  caseSensitive: Maybe<Scalars['Boolean']['output']>;
  /** Expected answer matches */
  matchPhrases: Maybe<Array<Scalars['String']['output']>>;
  /** Similarity threshold between 0.0 and 1.0 inclusive */
  matchSimilarity: Maybe<Scalars['Float']['output']>;
};

export type ShortResponseInput = {
  caseSensitive?: InputMaybe<Scalars['Boolean']['input']>;
  matchPhrases?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Between 0.0 and 1.0 inclusive. */
  matchSimilarity?: InputMaybe<Scalars['Float']['input']>;
};

export type SimilarQuestionsPayload = {
  __typename?: 'SimilarQuestionsPayload';
  /** True if the replacement set is incomplete */
  incompleteReplacement: Maybe<Scalars['Boolean']['output']>;
  /** List of similar questions found */
  questions: Maybe<Array<Question>>;
};

/**
 * Similarity information for a Result.
 *
 * Currently a Turnitin similarity score is available in the gradebook. This
 * score is a floating point percentage value.
 */
export type Similarity = {
  __typename?: 'Similarity';
  /** Human formatted representation */
  display: Scalars['String']['output'];
  /** Label color for the similarity score */
  label: Scalars['String']['output'];
  /** Actual similarity score value between 0-100 */
  value: Scalars['Float']['output'];
};

export type SimpleChoice = {
  __typename?: 'SimpleChoice';
  content: Scalars['String']['output'];
  identifier: Scalars['String']['output'];
};

export type SimpleChoiceInput = {
  content: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
};

export type SmartComment = {
  __typename?: 'SmartComment';
  assessmentId: Maybe<Scalars['ID']['output']>;
  /** The name of the assessment under which the smart comment was created. */
  assessmentName: Maybe<Scalars['String']['output']>;
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  insertedAt: Scalars['PreciseDateTime']['output'];
  lastUsed: Maybe<Scalars['PreciseDateTime']['output']>;
  score: Scalars['Int']['output'];
  skillId: Scalars['ID']['output'];
  updatedAt: Scalars['PreciseDateTime']['output'];
  usageCount: Scalars['Int']['output'];
  userId: Scalars['ID']['output'];
  userName: Maybe<Scalars['String']['output']>;
};

export type Snapshot = {
  __typename?: 'Snapshot';
  asOfVersion: Scalars['Int']['output'];
  contributions: Contribution;
  document: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export type SnapshotFieldOutcomeInput = {
  blockName: AnswerBlockName;
  /** JSON ProseMirror Document */
  doc: Scalars['String']['input'];
  /** Version of the document */
  version: Scalars['Int']['input'];
};

export type SnapshotSubmissionOutcomeInput = {
  blockName: AnswerBlockName;
  /** JSON ProseMirror Document */
  doc: Scalars['String']['input'];
  /** Version of the document */
  version: Scalars['Int']['input'];
};

export type SnapshotTick = {
  __typename?: 'SnapshotTick';
  id: Scalars['ID']['output'];
  timestamp: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

/** A Socratic Dialogue represents a full conversation between a student and the socratic challenger. */
export type SocraticDialogue = {
  __typename?: 'SocraticDialogue';
  attemptNumber: Scalars['Int']['output'];
  /** Started at + duration */
  expiredAt: Maybe<Scalars['PreciseDateTime']['output']>;
  id: Scalars['ID']['output'];
  maxTurns: Scalars['Int']['output'];
  readingTimeSeconds: Scalars['Int']['output'];
  responseTimeSeconds: Scalars['Int']['output'];
  startedAt: Maybe<Scalars['PreciseDateTime']['output']>;
  /** All turns in this Dialogue */
  turns: Array<SocraticTurn>;
};

export type SocraticInteraction = {
  __typename?: 'SocraticInteraction';
  kind: Maybe<Scalars['String']['output']>;
  maxAttempts: Maybe<Scalars['Int']['output']>;
  readingTime: Maybe<Scalars['Int']['output']>;
  responseTime: Maybe<Scalars['Int']['output']>;
};

export type SocraticInteractionInput = {
  /**
   * Maximum number of attempts the student has to submit finished dialogue.
   *         Must be at least 1.
   */
  maxAttempts: Scalars['Int']['input'];
  /** Time in seconds the student has to read the prompt before responding. */
  readingTime: Scalars['Int']['input'];
  /** Time in seconds the student has to respond. */
  responseTime: Scalars['Int']['input'];
};

/** A single Socratic follow-up question generated from one submission. */
export type SocraticQuestion = {
  __typename?: 'SocraticQuestion';
  /** The generated question text; absent until generation succeeds. */
  content: Maybe<Scalars['String']['output']>;
  /** Failure detail when generation failed. */
  error: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  status: SocraticQuestionStatus;
  /** The submission's author; absent for group work and legacy runs. */
  student: Maybe<User>;
};

/** The generation state of a Socratic question. */
export enum SocraticQuestionStatus {
  /** A question was generated successfully. */
  Completed = 'COMPLETED',
  /** Generation errored, from the LLM or resolving the submission. */
  Failed = 'FAILED',
  /** Generation is queued or in-flight; no result yet. */
  Pending = 'PENDING'
}

/** The Socratic Questioner surface for a single task block. */
export type SocraticQuestionerPreview = {
  __typename?: 'SocraticQuestionerPreview';
  /** Identifier for this preview, currently the task block id. */
  id: Scalars['ID']['output'];
  questionerRuns: Array<SocraticQuestionerRun>;
  /** The task block this preview is for. */
  taskBlock: TaskBlock;
};

export type SocraticQuestionerPreviewInput = {
  /** The task block to preview the questioner for. */
  taskBlockId: Scalars['ID']['input'];
};

/**
 * One teacher-initiated batch of question generation for the submissions on a
 * single source task.
 */
export type SocraticQuestionerRun = {
  __typename?: 'SocraticQuestionerRun';
  /** The teacher-authored question stating what to probe. */
  baseQuestion: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** The questions generated by this run, one per submission. */
  socraticQuestions: Maybe<Array<Maybe<SocraticQuestion>>>;
  /** The task whose submissions are being probed. */
  sourceTaskId: Scalars['String']['output'];
};

export type SocraticQuestionerRunPayload = {
  __typename?: 'SocraticQuestionerRunPayload';
  error: Maybe<StartSocraticQuestionerRunError>;
  run: Maybe<SocraticQuestionerRun>;
};

/** A Socratic Session represents a single session of socratic interaction for a student. */
export type SocraticSession = {
  __typename?: 'SocraticSession';
  answerBlock: AnswerBlock;
  /** All Dialogues in this Session. */
  dialogues: Array<SocraticDialogue>;
  id: Scalars['ID']['output'];
  /** The latest Dialogue in this Session, or null if no Dialogues have been created yet. */
  latestDialogue: Maybe<SocraticDialogue>;
  maxAttempts: Scalars['Int']['output'];
  /** When the student can reattempt, or null if they haven't started their first attempt yet, or reattempts never expire. */
  reattemptWindowEndsAt: Maybe<Scalars['PreciseDateTime']['output']>;
};

/** A single timestamped segment of a Socratic transcript. */
export type SocraticTranscriptSegment = {
  __typename?: 'SocraticTranscriptSegment';
  endTime: Scalars['Float']['output'];
  startTime: Scalars['Float']['output'];
  text: Scalars['String']['output'];
};

/** Outcome of a finished transcription attempt for a Socratic Turn. */
export type SocraticTranscription = {
  __typename?: 'SocraticTranscription';
  dialogueId: Scalars['ID']['output'];
  /** The failure reason, present only when status is FAILED. */
  error: Maybe<Scalars['String']['output']>;
  /** Timestamped transcript segments, present only when status is SUCCEEDED. */
  segments: Maybe<Array<SocraticTranscriptSegment>>;
  status: SocraticTranscriptionStatus;
  /** The transcript text, present only when status is SUCCEEDED. */
  text: Maybe<Scalars['String']['output']>;
  turnId: Scalars['ID']['output'];
};

/** Outcome of a finished transcription attempt for a Socratic Turn. */
export type SocraticTranscriptionOutcome = {
  __typename?: 'SocraticTranscriptionOutcome';
  dialogueId: Scalars['ID']['output'];
  /** The failure reason, present only when status is FAILED. */
  error: Maybe<Scalars['String']['output']>;
  status: SocraticTranscriptionStatus;
  turnId: Scalars['ID']['output'];
};

export enum SocraticTranscriptionStatus {
  Failed = 'FAILED',
  Succeeded = 'SUCCEEDED'
}

/** A Socratic Turn represents a single exchange in a Socratic Dialogue. */
export type SocraticTurn = {
  __typename?: 'SocraticTurn';
  /** Whether this turn's prompt was generated by the Socratic Questioner for the student, rather than the base authored prompt. */
  generated: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  /** The student's preparation-phase video for this turn, if recorded. */
  preparationMedia: Maybe<TurnResponse>;
  /** The question prompt text for this turn. */
  questionPrompt: Maybe<Scalars['String']['output']>;
  /** When the recording was completed. */
  recordingCompletedAt: Maybe<Scalars['PreciseDateTime']['output']>;
  /** When the recording was started. */
  recordingStartedAt: Maybe<Scalars['PreciseDateTime']['output']>;
  /** The student's video response for this turn, if submitted. */
  response: Maybe<TurnResponse>;
};

export type SourceFileInput = {
  /** Imported file name set by the user */
  filename?: InputMaybe<Scalars['String']['input']>;
  /** File path of imported file */
  filepath?: InputMaybe<Scalars['String']['input']>;
  /** ID of the file source */
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum StartSocraticDialogueError {
  /** Already completed */
  AlreadyCompleted = 'ALREADY_COMPLETED',
  /** Already started */
  AlreadyStarted = 'ALREADY_STARTED',
  /** Outside reattempt window */
  OutsideReattemptWindow = 'OUTSIDE_REATTEMPT_WINDOW'
}

export type StartSocraticDialoguePayload = {
  __typename?: 'StartSocraticDialoguePayload';
  dialogue: Maybe<SocraticDialogue>;
  error: Maybe<Array<Maybe<StartSocraticDialogueError>>>;
  session: Maybe<SocraticSession>;
};

export enum StartSocraticQuestionerRunError {
  /** No final submissions to the anchor task to preview. */
  NoSubmissions = 'NO_SUBMISSIONS'
}

export type StartSocraticQuestionerRunInput = {
  /** Max anchor submissions to sample. Defaults to 5. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Question prompt ProseMirror contents (JSON); overrides the block's saved question. */
  promptDocOverrides?: InputMaybe<Scalars['String']['input']>;
  /** The task block to run the questioner for. */
  taskBlockId: Scalars['ID']['input'];
};

export enum StartSocraticTurnError {
  /** Already started */
  AlreadyStarted = 'ALREADY_STARTED',
  /** Dialogue already finished, can't start any new turns */
  DialogueAlreadyFinished = 'DIALOGUE_ALREADY_FINISHED'
}

export type StartSocraticTurnPayload = {
  __typename?: 'StartSocraticTurnPayload';
  dialogue: Maybe<SocraticDialogue>;
  error: Maybe<StartSocraticTurnError>;
};

/** All possible Task release states. */
export enum Status {
  Editing = 'EDITING',
  Released = 'RELEASED'
}

/** Marking outcome targetting a single student in the assessment. */
export type StudentOutcome = {
  __typename?: 'StudentOutcome';
  /**
   * The `base` field calculates a ComponentBreakdown for each component using the up-to-date
   * data sources such as WorkOutcome, SubmissionOutcome, or FieldOutcome as the source of scores.
   *
   * Any marking or moderation action such as `markFieldOutcome`, `markSubmissionOutcome`,
   * or `updateWorkOutcomeScore` will alter the underlying outcome and there the `base` scores.
   */
  base: ComponentBreakdown;
  /**
   * The `:final` edge calculates a ComponentBreakdown of each component using only released
   * data sources such as WorkOutcomeRelease as the source of scores.
   *
   * The only way to alter any final score is to withdraw feedback and then subsequently make
   * a new final release to the student with some marking or moderation actions being taken.
   */
  final: ComponentBreakdown;
  groupWorkOutcome: Maybe<WorkOutcome>;
  id: Scalars['ID']['output'];
  individualWorkOutcome: Maybe<WorkOutcome>;
  moderatorModifier: Maybe<Scalars['Float']['output']>;
  /** Per-student additive score modifiers (e.g. marker adjustments). */
  modifiers: Array<StudentOutcomeModifier>;
  peerOutcome: Maybe<PeerOutcome>;
  /**
   * The `:provisional` edge calculates a ComponentBreakdown of each component using only released
   * data sources such as WorkOutcomeRelease as the source of scores.
   *
   * The only way to alter any provisional score is to a new provisional release to the student
   * with some new marking or moderation actions being taken.
   *
   * One notable exception: changes to student_outcome_moderator_modifier will alter
   * the total score immediately (not a component's score such as individual or group).
   */
  provisional: ComponentBreakdown;
  studentId: Scalars['ID']['output'];
};

/** Per-student additive score modifier. Generic over `type`/`origin`/`component`. */
export type StudentOutcomeModifier = {
  __typename?: 'StudentOutcomeModifier';
  addedAt: Scalars['DateTime']['output'];
  addedByUserId: Maybe<Scalars['ID']['output']>;
  component: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  note: Maybe<Scalars['String']['output']>;
  origin: StudentOutcomeModifierOrigin;
  sourceOutcomeId: Maybe<Scalars['ID']['output']>;
  type: StudentOutcomeModifierType;
  value: Scalars['Decimal']['output'];
};

/** Origins that can create per-student additive score modifiers. */
export enum StudentOutcomeModifierOrigin {
  Marker = 'MARKER',
  Moderator = 'MODERATOR'
}

/** Types of per-student additive score modifiers. */
export enum StudentOutcomeModifierType {
  Contribution = 'CONTRIBUTION'
}

/**
 * Completion booleans describing whether the current student has finished
 * their peer evaluation for an assessment. Replaces the per-row
 * `has_evaluated_all_peers` / `has_completed_self_evaluation` flags on
 * `peer_outcome` for callers that need the viewing student's own status,
 * which may not exist as a row when no peer has evaluated them yet.
 */
export type StudentPeerEvalProgress = {
  __typename?: 'StudentPeerEvalProgress';
  /** Whether the current student has submitted their self evaluation. `true` when self evaluation is disabled. */
  hasCompletedSelfEvaluation: Scalars['Boolean']['output'];
  /** Whether the current student has evaluated every assigned peer (pre-due requires published; post-due drafts count). */
  hasEvaluatedAllPeers: Scalars['Boolean']['output'];
};

/** Input object for updating a student's settings within an assessment context. */
export type StudentSettingsInput = {
  draftExamEndDate?: InputMaybe<Scalars['String']['input']>;
  draftExamStartDate?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  examDeferred?: InputMaybe<Scalars['Boolean']['input']>;
  examEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  examReadingTime?: InputMaybe<Scalars['Int']['input']>;
  examStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  examWritingTime?: InputMaybe<Scalars['Int']['input']>;
  studentId: Scalars['ID']['input'];
  submitAttemptLimit?: InputMaybe<Scalars['Int']['input']>;
  timeLimit?: InputMaybe<Scalars['Int']['input']>;
  updateReason?: InputMaybe<Scalars['String']['input']>;
  vivaExtraAttempts?: InputMaybe<Scalars['Int']['input']>;
};

/** A Cadmus Subject. */
export type Subject = {
  __typename?: 'Subject';
  discipline: Maybe<Discipline>;
  id: Scalars['ID']['output'];
  label: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export enum SubjectRole {
  ExternalExaminer = 'EXTERNAL_EXAMINER',
  FacultyLeader = 'FACULTY_LEADER',
  LearningDesigner = 'LEARNING_DESIGNER',
  LearningTechnologist = 'LEARNING_TECHNOLOGIST',
  Lecturer = 'LECTURER',
  Marker = 'MARKER',
  Other = 'OTHER',
  SubjectCoordinator = 'SUBJECT_COORDINATOR',
  Tutor = 'TUTOR',
  UniversityLeader = 'UNIVERSITY_LEADER'
}

/** A Final or Draft Submission. */
export type Submission = {
  __typename?: 'Submission';
  /** Attempt number if provided during submission. */
  attemptNumber: Maybe<Scalars['Int']['output']>;
  /** A representation of an answer to a question block */
  blockSnapshots: Array<BlockSnapshot>;
  /**
   * If the submission was forcefully submitted on behalf of the student.
   *
   * Use the `submittedBy` field to know who submitted the submission.
   */
  forceSubmitted: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /**
   * Gradebook result on the submission.
   * @deprecated Use Work.result directly instead. Result should be the parent of Submission.
   */
  result: Result;
  /** Save attached to the submission. */
  save: Maybe<Save>;
  submittedAt: Scalars['PreciseDateTime']['output'];
  /**
   * The User who made the submission.
   *
   * If the value is null, the user should be assumed to be the student who owns
   * the Work.
   */
  submittedBy: Maybe<User>;
  /** Type of Submission. */
  type: SubmissionType;
  unsubmittedAt: Maybe<Scalars['PreciseDateTime']['output']>;
  workId: Scalars['ID']['output'];
};

/**
 * Input to downloadSubmissions mutation to add a submission's PDF to the
 * archive.
 */
export type SubmissionDetailInput = {
  /** Submission ID */
  id: Scalars['ID']['input'];
  /** Filename inside the archive */
  name: Scalars['String']['input'];
};

export type SubmissionMarkerModifierPayload = {
  __typename?: 'SubmissionMarkerModifierPayload';
  studentOutcomes: Array<StudentOutcome>;
  submissionOutcome: SubmissionOutcome;
  workOutcome: WorkOutcome;
};

/** Outcome recorded for a student's submission. */
export type SubmissionOutcome = {
  __typename?: 'SubmissionOutcome';
  bodyBlockSnapshotId: Maybe<Scalars['ID']['output']>;
  bodyDoc: Maybe<Scalars['String']['output']>;
  bodyDocStreamUuid: Maybe<Scalars['ID']['output']>;
  bodyDocVersion: Scalars['Int']['output'];
  completedAt: Maybe<Scalars['DateTime']['output']>;
  feedbackModeration: Maybe<FeedbackModerationDecision>;
  flagReason: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Indicated whether the SubmissionOutcome is the latest for FINAL or DRAFT */
  latestForType: Scalars['Boolean']['output'];
  /** The marker's additive adjustment on top of the rubric outcome score. */
  markerModifier: Maybe<Scalars['Float']['output']>;
  markerScope: MarkerScope;
  markerUserId: Maybe<Scalars['ID']['output']>;
  moderationOutcome: Maybe<ModerationOutcome>;
  referencesBlockSnapshotId: Maybe<Scalars['ID']['output']>;
  referencesDoc: Maybe<Scalars['String']['output']>;
  referencesDocStreamUuid: Maybe<Scalars['ID']['output']>;
  referencesDocVersion: Scalars['Int']['output'];
  /** Marking outcome from using a MarkerRubric to score the parent Outcome. */
  rubricOutcome: RubricOutcome;
  score: Maybe<Scalars['Float']['output']>;
  scoreModeration: Maybe<ScoreModerationDecision>;
  submissionId: Scalars['ID']['output'];
  submissionType: SubmissionType;
  submittedAt: Scalars['PreciseDateTime']['output'];
};

/**
 * SubmissionOutcomeRelease represents a snapshot of a submission outcome at release time.
 * Contains the overall submission marking and documentation.
 */
export type SubmissionOutcomeRelease = {
  __typename?: 'SubmissionOutcomeRelease';
  bodyBlockSnapshotId: Maybe<Scalars['ID']['output']>;
  bodyDoc: Maybe<Scalars['String']['output']>;
  bodyDocStreamUuid: Scalars['ID']['output'];
  bodyDocVersion: Scalars['Int']['output'];
  criterionOutcomeReleases: Array<CriterionOutcomeRelease>;
  id: Scalars['ID']['output'];
  referencesBlockSnapshotId: Maybe<Scalars['ID']['output']>;
  referencesDoc: Maybe<Scalars['String']['output']>;
  referencesDocStreamUuid: Maybe<Scalars['ID']['output']>;
  referencesDocVersion: Scalars['Int']['output'];
  score: Scalars['Float']['output'];
  submissionId: Scalars['ID']['output'];
  threadReleases: Array<ThreadRelease>;
};

export type SubmissionOutcomesPayload = {
  __typename?: 'SubmissionOutcomesPayload';
  submissionOutcomes: Array<SubmissionOutcome>;
};

/** Options for queueSubmissionPipeline. Mirrors the SubmissionWorker force_* options. */
export type SubmissionPipelineInput = {
  forceLms?: InputMaybe<Scalars['Boolean']['input']>;
  forceManifest?: InputMaybe<Scalars['Boolean']['input']>;
  forcePdf?: InputMaybe<Scalars['Boolean']['input']>;
  forceTurnitin?: InputMaybe<Scalars['Boolean']['input']>;
  resultIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  submissionType?: InputMaybe<SubmissionType>;
};

/** Types of submissions the client can make. */
export enum SubmissionType {
  Draft = 'DRAFT',
  Final = 'FINAL'
}

export type SubmitAttemptPayload = {
  __typename?: 'SubmitAttemptPayload';
  /** Next acceptable submission attempt number */
  nextAttemptNumber: Scalars['Int']['output'];
  result: Result;
};

/** A recorded Survey response. */
export type Survey = {
  __typename?: 'Survey';
  /** Is the survey open for accepting new answers? */
  active: Scalars['Boolean']['output'];
  answer: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  score: Maybe<Scalars['Int']['output']>;
};

/** A Tag attached to an Enrollment */
export type Tag = {
  __typename?: 'Tag';
  /** @deprecated Use an explicit `tab` instead of column */
  column: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  tab: ClassTab;
  text: Scalars['String']['output'];
};

export type TagInput = {
  /** Link tag to a category */
  categoryId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

/**
 * An Assessment's Task.
 *
 * A single `Task` document is edited by a teacher and released as `Sheet` to
 * their Assessment. An Assessment can have multiple Tasks, one of each
 * `TaskKind`. The `INDIVIDUAL` kinded Task is the default and always-present
 * Task.
 *
 * A Task has a latest `SaveState` which is the latest content saved by the
 * teacher.
 *
 * A Task has attached `Resources`.
 *
 * DEPRECATED A Task has settings in the form of `Requirements`. Use `settings`
 * edge on `Assessment` instead.
 */
export type Task = {
  __typename?: 'Task';
  /** List of all multi-format Task blocks. */
  blocks: Array<TaskBlock>;
  format: Maybe<TaskFormat>;
  /**
   * Future scheduled instruction sheet for this task.
   *
   * Returns null if no future release is scheduled.
   * Uses batching to prevent N+1 queries when resolving multiple tasks.
   */
  futureSheet: Maybe<Sheet>;
  /** Latest GenAI Guideline notice attached to this Task, if any. */
  genaiGuidelineNotice: Maybe<TaskNotice>;
  /** Task has a linked Marker Rubric. */
  hasMarkerRubric: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /**
   * Current released instruction sheet for this task.
   *
   * Returns null if task has never been released.
   * Uses batching to prevent N+1 queries when resolving multiple tasks.
   */
  instructionSheet: Maybe<Sheet>;
  kind: TaskKind;
  /** Latest Task requirement values. */
  requirements: Requirements;
  /** Latest Task resources. */
  resources: Array<Resource>;
  /** Latest Task save state. */
  saveState: SaveState;
  /** Task is in a released state or not. */
  status: Status;
};

/**
 * A block inside a Task or TaskHistory.
 *
 * Task blocks convey a question or bunch of questions within a Task. A list of
 * blocks within a Task have a Tree structure with nesting. This Tree structure
 * is constructed using the 3 fields:
 *
 *   1. `nodeId` required
 *   2. `parentNodeId` optional
 *   3. `previousNodeId` optional
 *
 * Task blocks can also be flattened and given a fixed ordering using the `order`
 * field. The flattened tree numbering is preserved in `orderLabel` field.
 */
export type TaskBlock = {
  __typename?: 'TaskBlock';
  deleted: Scalars['Boolean']['output'];
  hidden: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Library Question ID linked to this block */
  libraryQuestionId: Maybe<Scalars['ID']['output']>;
  /** Library Question Version ID linked to this block */
  libraryQuestionVersionId: Maybe<Scalars['ID']['output']>;
  markerRubric: Maybe<MarkerRubric>;
  /** Tree layout node ID for the block. */
  nodeId: Scalars['ID']['output'];
  order: Maybe<Scalars['Int']['output']>;
  orderLabel: Maybe<Scalars['String']['output']>;
  /** @deprecated Use parentNodeId */
  parentId: Maybe<Scalars['ID']['output']>;
  /** Tree layout parent node ID for this block. */
  parentNodeId: Maybe<Scalars['ID']['output']>;
  points: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use previousNodeId */
  previousId: Maybe<Scalars['ID']['output']>;
  /** Tree layout previous node ID for this block. */
  previousNodeId: Maybe<Scalars['ID']['output']>;
  /** Number of questions referenced by the TaskBlock */
  quantity: Maybe<Scalars['Int']['output']>;
  /** Question attached to a Task block. */
  question: Maybe<Question>;
  /** QuestionSelection with sets attached this block */
  questionSelection: Maybe<QuestionSelection>;
  shuffle: Scalars['Boolean']['output'];
  /** Whether Socratic AI Questioner is enabled for this block */
  socraticQuestionerEnabled: Scalars['Boolean']['output'];
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

/** Enum of format of task */
export enum TaskFormat {
  Classic = 'CLASSIC',
  Multiformat = 'MULTIFORMAT'
}

/** Kinds of Tasks created in an Assessment. */
export enum TaskKind {
  Group = 'GROUP',
  Individual = 'INDIVIDUAL',
  Peer = 'PEER',
  Viva = 'VIVA'
}

/** A Task Notice. */
export type TaskNotice = {
  __typename?: 'TaskNotice';
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  version: Scalars['Int']['output'];
};

export type TextEntryInteraction = {
  __typename?: 'TextEntryInteraction';
  /** Allow file attachments */
  attachmentEnabled: Maybe<Scalars['Boolean']['output']>;
  /** Base type of the student's answer */
  baseType: Maybe<BaseType>;
  /** Expected length of the text entry */
  expectedLength: Maybe<Scalars['Int']['output']>;
};

export type TextEntryInteractionInput = {
  attachmentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  expectedLength?: InputMaybe<Scalars['Int']['input']>;
};

export type Thread = {
  __typename?: 'Thread';
  comments: Array<Comment>;
  createdBy: User;
  criterion: Maybe<Criterion>;
  /** Linked rubric Criterion */
  criterionId: Maybe<Scalars['ID']['output']>;
  entityId: Maybe<Scalars['ID']['output']>;
  entityType: Maybe<EntityType>;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['PreciseDateTime']['output'];
  metadata: Maybe<Metadata>;
  resolvedAt: Maybe<Scalars['PreciseDateTime']['output']>;
  resolvedBy: Maybe<User>;
  status: ThreadStatus;
  title: Maybe<Scalars['String']['output']>;
};

export type ThreadInput = {
  /** Initial comment content as HTML string */
  comment?: InputMaybe<Scalars['String']['input']>;
  criterionId?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the associated entity. */
  entityId: Scalars['ID']['input'];
  /** Type of the associated entity. */
  entityType: EntityType;
  /** ID of the group the thread belongs to. */
  groupId?: InputMaybe<Scalars['ID']['input']>;
  metadata?: InputMaybe<ThreadMetadataInput>;
  /** ID of the associated smart comment, if any. */
  smartCommentId?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ThreadMetadataInput = {
  /** ID of the BlockAttachment this thread is about */
  blockAttachmentId?: InputMaybe<Scalars['Int']['input']>;
  /** Display name of the file */
  blockAttachmentName?: InputMaybe<Scalars['String']['input']>;
  charterEditorId?: InputMaybe<Scalars['ID']['input']>;
  charterSectionType?: InputMaybe<CharterSectionType>;
};

/**
 * ThreadRelease represents a snapshot of a thread at the time of feedback release.
 * Contains the thread information and its comments at release time.
 */
export type ThreadRelease = {
  __typename?: 'ThreadRelease';
  commentReleases: Array<CommentRelease>;
  /** Linked rubric Criterion */
  criterionId: Maybe<Scalars['ID']['output']>;
  /** The ID of the Thread. */
  id: Scalars['ID']['output'];
  metadata: Maybe<Metadata>;
  threadInsertedAt: Scalars['PreciseDateTime']['output'];
  title: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

/** Thread states. */
export enum ThreadStatus {
  Closed = 'CLOSED',
  Deleted = 'DELETED',
  Editing = 'EDITING'
}

/** The student's video response to a Socratic Turn. */
export type TurnResponse = {
  __typename?: 'TurnResponse';
  /** Duration of the student's recorded response media in seconds. */
  durationSeconds: Maybe<Scalars['Int']['output']>;
  /** The URL where the student's recorded response media can be accessed. */
  mediaUrl: Maybe<Scalars['String']['output']>;
};

/** Input for unlinking library question references */
export type UnlinkLibraryQuestionInput = {
  taskBlockId: Scalars['ID']['input'];
  unlinkVersionOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateAnswerBlockInput = {
  bookmark?: InputMaybe<Scalars['Boolean']['input']>;
  confirm?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateFieldRubricInput = {
  fieldRubricId: Scalars['ID']['input'];
  role: MarkingRole;
  valuesAdded?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  valuesRemoved?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateFieldRubricPayload = {
  __typename?: 'UpdateFieldRubricPayload';
  fieldOutcomes: Array<FieldOutcome>;
  fieldRubric: Maybe<FieldRubric>;
  questionOutcomes: Array<QuestionOutcome>;
  questionRubric: Maybe<QuestionRubric>;
  studentOutcomes: Array<StudentOutcome>;
  workOutcomes: Array<WorkOutcome>;
};

/**
 * Input to update the milestones of a charter by passing
 *   the `charter_id` and the list of `milestones`
 */
export type UpdateMilestonesInput = {
  charterId: Scalars['ID']['input'];
  milestones?: InputMaybe<Array<MilestoneInput>>;
};

export type UpdateProjectIssueInput = {
  groupId: Scalars['ID']['input'];
  issues?: InputMaybe<Array<ProjectIssueInput>>;
};

export type UpdateQuestionBankFileOriginInput = {
  filename: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type UpdateQuestionBankInput = {
  /** @deprecated Deprecated. Use fields instead */
  blanksResponse?: InputMaybe<BlanksResponseInput>;
  /** @deprecated Deprecated. Use fields instead */
  booleanResponse?: InputMaybe<BooleanResponseInput>;
  category?: InputMaybe<Scalars['String']['input']>;
  difficulty?: InputMaybe<QuestionDifficulty>;
  /** @deprecated Deprecated. Use fields instead */
  editorResponse?: InputMaybe<EditorResponseInput>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  /** Question fields with response declaration and interaction type */
  fields?: InputMaybe<Array<InputMaybe<QuestionFieldInput>>>;
  /** @deprecated Deprecated. Use fields instead */
  multiResponse?: InputMaybe<MultiResponseInput>;
  points?: InputMaybe<Scalars['Int']['input']>;
  promptDoc: Scalars['String']['input'];
  questionBankId: Scalars['ID']['input'];
  /** Question type */
  questionType: QuestionType;
  scope: QuestionBankScope;
  /** Short plain text prompt description */
  shortPrompt: Scalars['String']['input'];
  /** @deprecated Deprecated. Use fields instead */
  shortResponse?: InputMaybe<ShortResponseInput>;
  shuffle?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateQuestionBanksCategoryInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  questionBankIds: Array<Scalars['ID']['input']>;
  scope: QuestionBankScope;
};

export type UpdateQuestionRubricInput = {
  caseSensitive?: InputMaybe<Scalars['Boolean']['input']>;
  errorMargin?: InputMaybe<Scalars['Float']['input']>;
  partialScoring?: InputMaybe<Scalars['Boolean']['input']>;
  questionRubricId: Scalars['ID']['input'];
  role: MarkingRole;
  similarity?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateQuestionRubricPayload = {
  __typename?: 'UpdateQuestionRubricPayload';
  fieldOutcomes: Array<FieldOutcome>;
  questionOutcomes: Array<QuestionOutcome>;
  questionRubric: Maybe<QuestionRubric>;
  studentOutcomes: Array<StudentOutcome>;
  workOutcomes: Array<WorkOutcome>;
};

export type UpdateQuestionSourceFileInput = {
  filename: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type UpdateQuestionVersionInput = {
  /** The attributes to update the question with */
  attributes: QuestionAttributes;
  /** The ID of the question to be updated */
  id: Scalars['ID']['input'];
  /** The version of the question to be updated */
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateStudentOutcomeScoreInput = {
  moderatorModifier?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateStudentOutcomeScorePayload = {
  __typename?: 'UpdateStudentOutcomeScorePayload';
  studentOutcome: StudentOutcome;
};

/** Updatable attributes for a TaskBlock */
export type UpdateTaskBlockInput = {
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  nodeId?: InputMaybe<Scalars['ID']['input']>;
  parentNodeId?: InputMaybe<Scalars['ID']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  previousNodeId?: InputMaybe<Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  shuffle?: InputMaybe<Scalars['Boolean']['input']>;
  socraticQuestionerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Updatable attributes for a TaskBlock for UpdateTaskBlocks */
export type UpdateTaskBlocksInput = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  nodeId?: InputMaybe<Scalars['ID']['input']>;
  parentNodeId?: InputMaybe<Scalars['ID']['input']>;
  previousNodeId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateWorkOutcomeScoreInput = {
  moderatorModifier: Scalars['Float']['input'];
  workOutcomeId: Scalars['ID']['input'];
};

export type UpdateWorkOutcomeScorePayload = {
  __typename?: 'UpdateWorkOutcomeScorePayload';
  fieldOutcome: Maybe<FieldOutcome>;
  fieldRubric: Maybe<FieldRubric>;
  questionOutcome: Maybe<QuestionOutcome>;
  studentOutcomes: Array<StudentOutcome>;
  workOutcome: Maybe<WorkOutcome>;
};

/** Cadmus User profile */
export type User = {
  __typename?: 'User';
  /** Optional user colourset index for group context. */
  colourset: Maybe<Scalars['Int']['output']>;
  email: Maybe<Scalars['String']['output']>;
  /** User family name to be used for sorting. */
  familyName: Scalars['String']['output'];
  /** User given name to be used as a short display name. */
  givenName: Scalars['String']['output'];
  hidden: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Full name, parsed from the LMS request which created the user. */
  name: Scalars['String']['output'];
  /** Has the user seen the latest onboarding manual screens? */
  onboardingSeen: Scalars['Boolean']['output'];
  tags: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** Personal settings of a user. */
export type UserSettings = {
  __typename?: 'UserSettings';
  id: Scalars['ID']['output'];
  /** Integrity Assuranceonboarding flag */
  showIaOnboarding: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated No more UserPilot */
  showUserpilotOnboarding: Maybe<Scalars['Boolean']['output']>;
  /** User provided role in the subject */
  subjectRole: Maybe<SubjectRole>;
};

export type VerifiedCode = {
  __typename?: 'VerifiedCode';
  code: Scalars['String']['output'];
  insertedAt: Maybe<Scalars['PreciseDateTime']['output']>;
  label: Maybe<Scalars['String']['output']>;
};

export type VivaSourceTask = {
  __typename?: 'VivaSourceTask';
  assessmentId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Aggregated weighted scoring data across all components and outcome-level modifiers. */
export type WeightedScore = {
  __typename?: 'WeightedScore';
  /**
   * Summed applied raw (pre-weight) marker adjustment across components after
   * clamping. Reported for transparency only — already folded into `score`,
   * never re-added on top.
   */
  adjustment: Scalars['Float']['output'];
  /** The maximum possible grade for the score. */
  maxScore: Scalars['Float']['output'];
  /** Total weighted moderation adjustment from all components. */
  moderatorModifierComponents: Scalars['Float']['output'];
  /** A modifier applied directly to the student's final weighted score with 100% weightage. */
  moderatorModifierStudent: Scalars['Float']['output'];
  /** Total weighted penalty deduction (positive float or 0.0). */
  penaltyScore: Scalars['Float']['output'];
  /**
   * The student's running weighted total score.
   * * `base`: Exists as soon as any score is recorded.
   * * `final`/`provisional`: Exists only when all components are released.
   *
   * Formula: Sum of component weighted scores, penalties, and modifiers + `student_outcome_moderator_modifier`.
   */
  score: Maybe<Scalars['Float']['output']>;
};

/** A Student's Work with submissions and saves. */
export type Work = {
  __typename?: 'Work';
  /** Answer blocks linked to a Work */
  answerBlocks: Array<AnswerBlock>;
  /** Current attempt count: not 1 to 1 for Submissions */
  attemptCount: Scalars['Int']['output'];
  /** Student's Cadmus experience survey response related to this work */
  experience: Survey;
  /** Feature flags enabled on a Work */
  features: WorkFeatures;
  /** Group that owns the work in group assessments. */
  group: Maybe<Group>;
  /**
   * Is there a save (either Save or BlockSnapshot for this work?).
   *
   * Note: this field is an optimized version of `:last_save_time`
   * since the client never uses the actual date but `existence` of
   * a save.
   */
  hasSave: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /**
   * Last save timestamp if there is a last save.
   *
   * For work-authority (snapshots) works this reads the denormalised
   * `works.last_snapshot_at` column.
   */
  lastSaveTime: Maybe<Scalars['PreciseDateTime']['output']>;
  /**
   * Latest save for the Work, if any.
   *
   * NOTE: This field is not optimised for batch loading on multiple works.
   */
  latestSave: Maybe<Save>;
  /** Latest sentiment check for a work */
  latestSentimentCheck: Maybe<SentimentCheck>;
  /** Latest Gradebook result for the Work. */
  result: Maybe<Result>;
  /** Settings specific to the Work that override the Assessment's released sheet. */
  settings: Maybe<WorkSettings>;
  /** Instruction Sheet released to the Student. */
  sheet: Maybe<Sheet>;
  /** Start date for a timed Work that the student has to manually trigger. */
  startDate: Maybe<Scalars['PreciseDateTime']['output']>;
  /** Student with access to the work. */
  student: User;
  /** ID of the Task this Work belongs to, if any. */
  taskId: Maybe<Scalars['ID']['output']>;
  /** Kind of Task this Work belongs to (individual, group, peer, viva). */
  taskKind: Maybe<TaskKind>;
  /** Last update timestamp. */
  updatedAt: Maybe<Scalars['PreciseDateTime']['output']>;
};


/** A Student's Work with submissions and saves. */
export type WorkResultArgs = {
  submissionType: SubmissionType;
};

/** Work Artifacts Associated with this Work. */
export type WorkArtifact = {
  __typename?: 'WorkArtifact';
  /** Marking service or AGS receipt date */
  agsSentAt: Maybe<Scalars['PreciseDateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Email receipt date */
  studentSentAt: Maybe<Scalars['PreciseDateTime']['output']>;
  submissionId: Scalars['ID']['output'];
  taskHistoryId: Scalars['ID']['output'];
  workId: Scalars['ID']['output'];
};

/**
 * Input to downloadWorkArtifacts mutation to add an artifact's PDF to the
 * archive.
 */
export type WorkArtifactDetailInput = {
  /** Filename inside the archive */
  filename: Scalars['String']['input'];
  /** Work Artifact ID */
  id: Scalars['ID']['input'];
  /** Force regenerate the WorkArtifact */
  regenerate?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Feature flags enabled on a Work */
export type WorkFeatures = {
  __typename?: 'WorkFeatures';
  /** Enable usage of Work Authority API */
  enableWorkAuthority: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
};

/** A Working Group of students in a group assessment. */
export type WorkGroup = {
  __typename?: 'WorkGroup';
  /** Group's charter, if created */
  charter: Maybe<Charter>;
  /** Finalised status of the current group. */
  finalised: Scalars['Boolean']['output'];
  /** Student's current group in the Assessment. */
  group: Group;
  id: Scalars['ID']['output'];
  /** Student's individual Work, if created. */
  individualWork: Maybe<Work>;
  /**
   * ID for Individual work report if enabled for the group assessment.
   * @deprecated Use `individual_work` edge.
   */
  individualWorkId: Maybe<Scalars['ID']['output']>;
  /** Latest group change request of the current user. */
  latestGroupChangeRequest: Maybe<Message>;
  /** Group's Work document, if created. */
  work: Maybe<Work>;
};


/** A Working Group of students in a group assessment. */
export type WorkGroupLatestGroupChangeRequestArgs = {
  assessmentId: Scalars['ID']['input'];
};

export enum WorkItemKind {
  Group = 'GROUP',
  Individual = 'INDIVIDUAL'
}

/** Outcome recorded for a student's work. */
export type WorkOutcome = {
  __typename?: 'WorkOutcome';
  /** Answer blocks seen by the connected Work. */
  answerBlocks: Array<AnswerBlock>;
  assessmentId: Scalars['ID']['output'];
  /** If there are FieldOutcomes still being automarked. */
  automarkPending: Maybe<Scalars['Boolean']['output']>;
  /** Current SubmissionOutcome for the DRAFT submission. */
  draftSubmissionOutcome: Maybe<SubmissionOutcome>;
  /** Released SubmissionOutcome for the draft Submission. */
  draftSubmissionOutcomeRelease: Maybe<SubmissionOutcomeRelease>;
  /** Indicates whether final feedback has been released for the work outcome. */
  feedbackReleased: Scalars['Boolean']['output'];
  feedbackReleasedTimestamp: Maybe<Scalars['DateTime']['output']>;
  finalRelease: Maybe<WorkOutcomeRelease>;
  /** The final score of the most recent final feedback. */
  finalScore: Maybe<Scalars['Float']['output']>;
  /** The final score penalty of the most recent final feedback. */
  finalScorePenalty: Maybe<Scalars['Float']['output']>;
  /** Current SubmissionOutcome for the FINAL submission. */
  finalSubmissionOutcome: Maybe<SubmissionOutcome>;
  groupId: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  /** SubmissionOutcome for the FINAL submission for the assigned marker. */
  markingSubmissionOutcome: Maybe<SubmissionOutcome>;
  maxScore: Scalars['Int']['output'];
  moderationPenaltyRules: Array<ModerationPenaltyRule>;
  /**
   * SubmissionOutcomes for the FINAL submission used during moderation.
   * Only available when double-blind marking is enabled.
   *
   * ## Visibility rules:
   * - `:primary` and `:secondary` outcomes are only returned once both markers have fully
   *   submitted their marking (both `score` and `completed_at` must be set).
   *
   * - Other scopes (`:main`, `:average`, `:custom`) are always returned if existing.
   */
  moderationSubmissionOutcomes: Array<SubmissionOutcome>;
  moderatorModifier: Maybe<Scalars['Float']['output']>;
  /**
   * SubmissionOutcomes for the FINAL submission used in progress table.
   * Used in double marking.
   */
  progressSubmissionOutcomes: Array<ProgressSubmissionOutcome>;
  provisionalRelease: Maybe<WorkOutcomeRelease>;
  questionOutcomes: Array<QuestionOutcome>;
  /**
   * Whether every active QuestionOutcome's FieldOutcome has a score.
   * If there are no QuestionOutcomes, returns `true`.
   */
  questionOutcomesScored: Scalars['Boolean']['output'];
  /** Score breakdown for the SubmissionOutcome for the final Submission. */
  scoreBreakdown: ScoreBreakdown;
  /** The student whose work this outcome belongs to. `nil` for group outcomes. */
  student: Maybe<User>;
  studentId: Maybe<Scalars['ID']['output']>;
  /** The past 5 SubmissionOutcomes with MAIN marker scope including latest. */
  submissionOutcomes: Array<SubmissionOutcome>;
  workId: Scalars['ID']['output'];
  /** Released WorkOutcome for the final Submission. */
  workOutcomeRelease: Maybe<WorkOutcomeRelease>;
};

/**
 * Per-question scores for a single WorkOutcome, used to compute question
 * performance metrics in moderation.
 */
export type WorkOutcomeQuestionScores = {
  __typename?: 'WorkOutcomeQuestionScores';
  id: Scalars['ID']['output'];
  questionScores: Array<QuestionScore>;
  workOutcomeId: Scalars['ID']['output'];
};

/**
 * WorkOutcomeRelease represents a snapshot of a WorkOutcome at the time of feedback release.
 * Each release event (provisional or final) creates a new WorkOutcomeRelease record.
 *
 * This edge can also be resolve by any `WorkOutcomeRelease.t()`.
 */
export type WorkOutcomeRelease = {
  __typename?: 'WorkOutcomeRelease';
  feedbackVisibility: FeedbackVisibility;
  finalScore: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  moderationPenaltyRules: Array<ModerationPenaltyRule>;
  moderatorModifier: Maybe<Scalars['Float']['output']>;
  penaltyScore: Scalars['Float']['output'];
  questionOutcomeReleases: Array<QuestionOutcomeRelease>;
  releaseType: FeedbackReleaseType;
  releasedAt: Scalars['DateTime']['output'];
  submissionOutcomeRelease: Maybe<SubmissionOutcomeRelease>;
};

export type WorkProgress = {
  __typename?: 'WorkProgress';
  groupStatistics: ProgressStatistics;
  individualStatistics: ProgressStatistics;
  items: Array<WorkProgressItem>;
};

export type WorkProgressItem = {
  __typename?: 'WorkProgressItem';
  entityId: Scalars['ID']['output'];
  kind: WorkItemKind;
  lastEventTimestamp: Maybe<Scalars['PreciseDateTime']['output']>;
  members: Array<MemberProgress>;
  overallStatus: ProgressStatus;
};

/** Settings for a work */
export type WorkSettings = {
  __typename?: 'WorkSettings';
  assessmentId: Scalars['ID']['output'];
  draftExamEndDate: Maybe<Scalars['String']['output']>;
  draftExamStartDate: Maybe<Scalars['String']['output']>;
  dueDate: Maybe<Scalars['PreciseDateTime']['output']>;
  examDeferred: Maybe<Scalars['Boolean']['output']>;
  examEndDate: Maybe<Scalars['DateTime']['output']>;
  examReadingTime: Maybe<Scalars['Int']['output']>;
  examStartDate: Maybe<Scalars['DateTime']['output']>;
  examWritingTime: Maybe<Scalars['Int']['output']>;
  groupId: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  lastUpdatedBy: Maybe<User>;
  studentId: Maybe<Scalars['ID']['output']>;
  submitAttemptLimit: Maybe<Scalars['Int']['output']>;
  timeLimit: Maybe<Scalars['Int']['output']>;
  updateReason: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['PreciseDateTime']['output']>;
  vivaExtraAttempts: Maybe<Scalars['Int']['output']>;
};

export type ApiTokenQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  workId: InputMaybe<Scalars['ID']['input']>;
}>;


export type ApiTokenQuery = { __typename?: 'RootQueryType', apiToken: string };

export type AssessmentProgressQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type AssessmentProgressQuery = { __typename?: 'RootQueryType', assessmentProgress: { __typename?: 'AssessmentProgressResponse', work: { __typename?: 'WorkProgress', individualStatistics: { __typename?: 'ProgressStatistics', notStartedCount: number, viewedCount: number, inProgressCount: number, submittedCount: number }, groupStatistics: { __typename?: 'ProgressStatistics', notStartedCount: number, viewedCount: number, inProgressCount: number, submittedCount: number }, items: Array<{ __typename?: 'WorkProgressItem', kind: WorkItemKind, entityId: string, overallStatus: ProgressStatus, lastEventTimestamp: string | null, members: Array<{ __typename?: 'MemberProgress', userId: string, workId: string | null, status: ProgressStatus, lastEventTimestamp: string | null }> }> }, charter: { __typename?: 'ProgressSection', statistics: { __typename?: 'ProgressStatistics', notStartedCount: number, viewedCount: number, inProgressCount: number, submittedCount: number }, items: Array<{ __typename?: 'ProgressItem', entityId: string, overallStatus: ProgressStatus, lastEventTimestamp: string | null, members: Array<{ __typename?: 'MemberProgress', userId: string, workId: string | null, status: ProgressStatus, lastEventTimestamp: string | null }> }> }, peer: { __typename?: 'ProgressSection', statistics: { __typename?: 'ProgressStatistics', notStartedCount: number, viewedCount: number, inProgressCount: number, submittedCount: number }, items: Array<{ __typename?: 'ProgressItem', entityId: string, overallStatus: ProgressStatus, lastEventTimestamp: string | null, members: Array<{ __typename?: 'MemberProgress', userId: string, workId: string | null, status: ProgressStatus, lastEventTimestamp: string | null }> }> } } };

export type BackgroundJobFragment = { __typename?: 'BackgroundJob', id: string, kind: BackgroundJobKind, state: BackgroundJobState };

export type BackgroundJobQueryVariables = Exact<{
  jobId: Scalars['ID']['input'];
}>;


export type BackgroundJobQuery = { __typename?: 'RootQueryType', backgroundJob: { __typename?: 'BackgroundJob', id: string, kind: BackgroundJobKind, state: BackgroundJobState } | null };

export type BrightspaceAuthorizationQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  redirectTo: Scalars['String']['input'];
  brightspaceScopeFor: InputMaybe<BrightspaceScopeKeyType>;
}>;


export type BrightspaceAuthorizationQuery = { __typename?: 'RootQueryType', brightspaceApi: { __typename?: 'BrightspaceApi', authorizeUrl: string, authorized: boolean } };

export type CanvasAuthorizationQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  redirectTo: Scalars['String']['input'];
  canvasScopeFor: InputMaybe<CanvasScopeKeyType>;
}>;


export type CanvasAuthorizationQuery = { __typename?: 'RootQueryType', canvasApi: { __typename?: 'CanvasApi', authorizeUrl: string, authorized: boolean } };

export type AssessmentChartersQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type AssessmentChartersQuery = { __typename?: 'RootQueryType', assessmentCharters: Array<{ __typename?: 'Charter', id: string, groupId: string }> };

export type CharterEditorFragment = { __typename?: 'CharterEditor', id: string, charterFormSectionId: string, snapshotDoc: string | null, snapshotVersion: number | null, streamUuid: string };

export type CharterFormFragment = { __typename?: 'CharterForm', id: string, published: boolean, hasUnpublishedChanges: boolean, publishTimestamp: string | null, editedAt: string | null, sections: Array<{ __typename?: 'CharterFormSection', id: string, deleted: boolean, enabled: boolean, rank: number | null, promptDoc: string | null, title: string | null, type: CharterFormSectionType, wordLimit: number | null, wordLimitEnabled: boolean, milestonePresets: Array<{ __typename?: 'MilestonePresetType', id: string, description: string | null, dueDate: string | null, title: string | null }> | null }> };

export type CharterFormMilestonePresetFragment = { __typename?: 'MilestonePresetType', id: string, description: string | null, dueDate: string | null, title: string | null };

export type CharterFormQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type CharterFormQuery = { __typename?: 'RootQueryType', assessment: { __typename?: 'Assessment', id: string, settings: { __typename?: 'AssessmentSettings', id: string, peerEvaluationEnabled: boolean } | null }, draftForm: { __typename?: 'CharterForm', id: string, published: boolean, hasUnpublishedChanges: boolean, publishTimestamp: string | null, editedAt: string | null, sections: Array<{ __typename?: 'CharterFormSection', id: string, deleted: boolean, enabled: boolean, rank: number | null, promptDoc: string | null, title: string | null, type: CharterFormSectionType, wordLimit: number | null, wordLimitEnabled: boolean, milestonePresets: Array<{ __typename?: 'MilestonePresetType', id: string, description: string | null, dueDate: string | null, title: string | null }> | null }> } | null, publishedForm: { __typename?: 'CharterForm', id: string, published: boolean, hasUnpublishedChanges: boolean, publishTimestamp: string | null, editedAt: string | null, sections: Array<{ __typename?: 'CharterFormSection', id: string, deleted: boolean, enabled: boolean, rank: number | null, promptDoc: string | null, title: string | null, type: CharterFormSectionType, wordLimit: number | null, wordLimitEnabled: boolean, milestonePresets: Array<{ __typename?: 'MilestonePresetType', id: string, description: string | null, dueDate: string | null, title: string | null }> | null }> } | null };

export type CharterFormSectionFragment = { __typename?: 'CharterFormSection', id: string, deleted: boolean, enabled: boolean, promptDoc: string | null, rank: number | null, title: string | null, type: CharterFormSectionType, wordLimit: number | null, wordLimitEnabled: boolean, milestonePresets: Array<{ __typename?: 'MilestonePresetType', id: string, description: string | null, dueDate: string | null, title: string | null }> | null };

export type CharterFragment = { __typename?: 'Charter', id: string, groupId: string, milestones: Array<{ __typename?: 'CharterMilestone', id: string | null, title: string, description: string | null, dueDate: string, deleted: boolean }>, editors: Array<{ __typename?: 'CharterEditor', id: string, charterFormSectionId: string, snapshotDoc: string | null, snapshotVersion: number | null, streamUuid: string }>, feedbackThreads: Array<{ __typename?: 'Thread', id: string, title: string | null, entityType: EntityType | null, entityId: string | null, criterionId: string | null, insertedAt: string, createdBy: { __typename?: 'User', id: string }, metadata: { __typename?: 'Metadata', charterSectionType: CharterSectionType | null, charterEditorId: string | null, blockAttachmentId: number | null, blockAttachmentName: string | null } | null, comments: Array<{ __typename?: 'Comment', id: string, content: string, updatedAt: string, smartCommentId: string | null, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> };

export type CharterMilestoneFragment = { __typename?: 'CharterMilestone', id: string | null, title: string, description: string | null, dueDate: string, deleted: boolean };

export type CharterQueryVariables = Exact<{
  charterId: Scalars['ID']['input'];
}>;


export type CharterQuery = { __typename?: 'RootQueryType', charter: { __typename?: 'Charter', id: string, groupId: string, milestones: Array<{ __typename?: 'CharterMilestone', id: string | null, title: string, description: string | null, dueDate: string, deleted: boolean }>, editors: Array<{ __typename?: 'CharterEditor', id: string, charterFormSectionId: string, snapshotDoc: string | null, snapshotVersion: number | null, streamUuid: string }>, feedbackThreads: Array<{ __typename?: 'Thread', id: string, title: string | null, entityType: EntityType | null, entityId: string | null, criterionId: string | null, insertedAt: string, createdBy: { __typename?: 'User', id: string }, metadata: { __typename?: 'Metadata', charterSectionType: CharterSectionType | null, charterEditorId: string | null, blockAttachmentId: number | null, blockAttachmentName: string | null } | null, comments: Array<{ __typename?: 'Comment', id: string, content: string, updatedAt: string, smartCommentId: string | null, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> } };

export type CreateCharterFormMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type CreateCharterFormMutation = { __typename?: 'RootMutationType', createCharterForm: { __typename?: 'CharterForm', id: string, published: boolean, hasUnpublishedChanges: boolean, publishTimestamp: string | null, editedAt: string | null, sections: Array<{ __typename?: 'CharterFormSection', id: string, deleted: boolean, enabled: boolean, rank: number | null, promptDoc: string | null, title: string | null, type: CharterFormSectionType, wordLimit: number | null, wordLimitEnabled: boolean, milestonePresets: Array<{ __typename?: 'MilestonePresetType', id: string, description: string | null, dueDate: string | null, title: string | null }> | null }> } };

export type UpdateCharterFormMutationVariables = Exact<{
  input: CharterFormInput;
}>;


export type UpdateCharterFormMutation = { __typename?: 'RootMutationType', updateCharterForm: { __typename?: 'CharterForm', id: string, published: boolean, hasUnpublishedChanges: boolean, publishTimestamp: string | null, editedAt: string | null, sections: Array<{ __typename?: 'CharterFormSection', id: string, deleted: boolean, enabled: boolean, rank: number | null, promptDoc: string | null, title: string | null, type: CharterFormSectionType, wordLimit: number | null, wordLimitEnabled: boolean, milestonePresets: Array<{ __typename?: 'MilestonePresetType', id: string, description: string | null, dueDate: string | null, title: string | null }> | null }> } };

export type ClassInstructionSheetFragment = { __typename?: 'Sheet', id: string, serverId: string, taskId: string, kind: TaskKind, format: TaskFormat, releaseTimestamp: string, version: number, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean }> };

export type ClassQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type ClassQuery = { __typename?: 'RootQueryType', token: string, me: { __typename?: 'User', id: string, email: string | null }, institution: { __typename?: 'Institution', id: string, tenant: string, country: { __typename?: 'Country', code: string, name: string } }, featureFlags: { __typename?: 'InstitutionFeatures', id: string, accessCode: boolean, exams: boolean, respondusLdb: boolean, moodleGrader: boolean, multiformat: boolean, turnitin: boolean, turnitinGrader: boolean, cadmusGrader: boolean, groupAssessment: boolean, genAiDeclaration: boolean, extensionSyncing: boolean, advancedMarking: boolean, timeline: boolean, adminAccess: boolean, viva: boolean, labsContextualiser: boolean, schoolyear: boolean }, assessment: { __typename?: 'Assessment', id: string, name: string, subjectName: string, subjectId: string, dueDate: string | null, gradingDueDate: string | null, startDate: string | null, endDate: string | null, edition: number, subject: { __typename?: 'Subject', id: string, discipline: Discipline | null, name: string, label: string | null }, ltiTool: { __typename?: 'InstitutionTool', id: string, name: string | null, familyCode: string | null }, ltiServices: Array<{ __typename?: 'LtiService', id: string, name: string, version: string, issuer: string | null, metaUrl: string | null, isLtiPluginAgs: boolean }>, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, groupDraftDueDate: string | null, groupDraftEnabled: boolean, individualDraftFeedbackAlwaysAvailable: boolean, groupDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, submitAttemptLimit: number | null, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, rubricDisplayDisabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, examReentryPreventionEnabled: boolean, examInactivityTimeout: number | null, examSchoolyearEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckSkipEnabled: boolean, sentimentCheckIntervalInHr: number | null, sentimentCheckFirstCheckAt: string | null, sentimentCheckScheduleType: SentimentCheckScheduleType, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, peerEvaluationMode: PeerEvaluationMode, peerEvaluationMinScaleFactor: number, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMode: SelfEvaluationMode, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterAcceptanceRequired: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, vivaEnabled: boolean, vivaReattemptWindowTime: number | null, vivaCameraRequiredDisabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, sentimentCheckSchedules: Array<{ __typename?: 'SentimentCheckSchedule', id: string, scheduledAt: string }> | null, vivaSourceTask: { __typename?: 'VivaSourceTask', id: string, assessmentId: string, name: string } | null } | null, ltiCustomParams: { __typename?: 'CustomParams', moodleAttemptReopenMethod: string | null } | null, schoolyearExam: { __typename?: 'SchoolyearExam', id: string, pushStatus: SchoolyearExamPushStatus } | null }, sections: Array<{ __typename?: 'Section', id: string, name: string, position: number, studentCount: number }>, class: { __typename?: 'Class', id: string, groupType: GroupType, students: Array<{ __typename?: 'Enrollment', id: string, sectionId: string | null, syncedAt: string | null, deleted: boolean, sisUserId: string | null, reentryCount: number, anonymousIndex: number | null, deletedBy: { __typename?: 'User', id: string, name: string } | null, user: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }, work: { __typename?: 'Work', id: string, startDate: string | null, updatedAt: string | null, lastSaveTime: string | null, attemptCount: number, finalResult: { __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number, memberSummaries: Array<{ __typename?: 'MemberSummary', lastAccess: string, accessCount: number, userId: string }> } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null } | null, draftResult: { __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number, memberSummaries: Array<{ __typename?: 'MemberSummary', lastAccess: string, accessCount: number, userId: string }> } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null } | null, features: { __typename?: 'WorkFeatures', id: string, enableWorkAuthority: boolean } } | null, tags: Array<{ __typename?: 'Tag', id: string, text: string, column: number, tab: ClassTab }>, workSettings: { __typename?: 'WorkSettings', id: string, studentId: string | null, dueDate: string | null, timeLimit: number | null, examReadingTime: number | null, examWritingTime: number | null, examStartDate: string | null, examEndDate: string | null, examDeferred: boolean | null, submitAttemptLimit: number | null, updatedAt: string | null, updateReason: string | null, draftExamStartDate: string | null, draftExamEndDate: string | null, groupId: string | null, vivaExtraAttempts: number | null, lastUpdatedBy: { __typename?: 'User', id: string, name: string } | null } | null, accessCode: { __typename?: 'AccessCode', code: string, label: string | null, active: boolean, type: AccessCodeType } | null, verifiedCodes: Array<{ __typename?: 'VerifiedCode', label: string | null, insertedAt: string | null }> | null }>, groups: Array<{ __typename?: 'Group', id: string, name: string, markerId: string | null, code: string | null, sectionId: string | null, questionId: string | null, maxLimit: number | null, minLimit: number | null, finalised: boolean, finalisedAt: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, members: Array<{ __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }>, groupMembers: Array<{ __typename?: 'GroupMember', id: string, colourset: number, user: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, groupMarkers: Array<{ __typename?: 'GroupMarker', id: string, role: MarkerRole, markerPlaceholder: string | null, groupMemberId: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null }> }>, tags: Array<{ __typename?: 'GroupTag', id: string, text: string }>, workSettings: { __typename?: 'WorkSettings', id: string, dueDate: string | null, groupId: string | null } | null }> }, classWorkGroups: Array<{ __typename?: 'WorkGroup', id: string, group: { __typename?: 'Group', id: string, name: string, markerId: string | null, code: string | null, sectionId: string | null, questionId: string | null, maxLimit: number | null, minLimit: number | null, finalised: boolean, finalisedAt: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, members: Array<{ __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }>, groupMembers: Array<{ __typename?: 'GroupMember', id: string, colourset: number, user: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, groupMarkers: Array<{ __typename?: 'GroupMarker', id: string, role: MarkerRole, markerPlaceholder: string | null, groupMemberId: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null }> }>, tags: Array<{ __typename?: 'GroupTag', id: string, text: string }>, workSettings: { __typename?: 'WorkSettings', id: string, dueDate: string | null, groupId: string | null } | null }, work: { __typename?: 'Work', id: string, startDate: string | null, updatedAt: string | null, lastSaveTime: string | null, attemptCount: number, finalResult: { __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number, memberSummaries: Array<{ __typename?: 'MemberSummary', lastAccess: string, accessCount: number, userId: string }> } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null } | null, draftResult: { __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number, memberSummaries: Array<{ __typename?: 'MemberSummary', lastAccess: string, accessCount: number, userId: string }> } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null } | null, features: { __typename?: 'WorkFeatures', id: string, enableWorkAuthority: boolean } } | null }>, individualSheet: { __typename?: 'Sheet', id: string, serverId: string, taskId: string, kind: TaskKind, format: TaskFormat, releaseTimestamp: string, version: number, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean }> } | null, groupSheet: { __typename?: 'Sheet', id: string, serverId: string, taskId: string, kind: TaskKind, format: TaskFormat, releaseTimestamp: string, version: number, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean }> } | null, futureSheet: { __typename?: 'Sheet', id: string, releaseTimestamp: string } | null, userSettings: { __typename?: 'UserSettings', id: string, subjectRole: SubjectRole | null, showIaOnboarding: boolean | null } | null };

export type CountryFragment = { __typename?: 'Country', code: string, name: string };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'RootQueryType', sessionId: string, me: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }, institution: { __typename?: 'Institution', id: string, tenant: string } };

export type DoubleMarkingProgressQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type DoubleMarkingProgressQuery = { __typename?: 'RootQueryType', studentOutcomes: Array<{ __typename?: 'StudentOutcome', id: string, studentId: string, individualWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, progressSubmissionOutcomes: Array<{ __typename?: 'ProgressSubmissionOutcome', id: string, completedAt: string | null, markerScope: MarkerScope }> } | null }> };

export type FlagAttentionMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  workOutcomeIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  flagReason: InputMaybe<Scalars['String']['input']>;
}>;


export type FlagAttentionMutation = { __typename?: 'RootMutationType', flagAttention: { __typename?: 'SubmissionOutcomesPayload', submissionOutcomes: Array<{ __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, markerScope: MarkerScope, score: number | null, markerModifier: number | null, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, flagReason: string | null, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null } | null }> } };

export type ModerateMainOutcomesMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  workOutcomeIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  scoreModeration?: InputMaybe<ScoreModerationDecisionInput>;
  feedbackModeration?: InputMaybe<FeedbackModerationDecisionInput>;
  exceptions?: InputMaybe<Array<ExceptionInput> | ExceptionInput>;
}>;


export type ModerateMainOutcomesMutation = { __typename?: 'RootMutationType', moderateMainOutcomes: { __typename?: 'SubmissionOutcomesPayload', submissionOutcomes: Array<{ __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, markerScope: MarkerScope, score: number | null, markerModifier: number | null, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, flagReason: string | null, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null } | null }> } };

export type ResetModerationDecisionsMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  workOutcomeIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ResetModerationDecisionsMutation = { __typename?: 'RootMutationType', resetModerationDecisions: { __typename?: 'ResetModerationDecisionsPayload', submissionOutcomes: Array<{ __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, markerScope: MarkerScope, score: number | null, markerModifier: number | null, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, flagReason: string | null, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null } | null }>, workOutcomes: Array<{ __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, maxScore: number, automarkPending: boolean | null, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } }> } };

export type StudentOutcomeForDoubleMarkingFragment = { __typename?: 'StudentOutcome', id: string, studentId: string, individualWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, progressSubmissionOutcomes: Array<{ __typename?: 'ProgressSubmissionOutcome', id: string, completedAt: string | null, markerScope: MarkerScope }> } | null };

export type FeatureFlagsFragment = { __typename?: 'InstitutionFeatures', id: string, accessCode: boolean, exams: boolean, respondusLdb: boolean, moodleGrader: boolean, multiformat: boolean, turnitin: boolean, turnitinGrader: boolean, cadmusGrader: boolean, groupAssessment: boolean, genAiDeclaration: boolean, extensionSyncing: boolean, advancedMarking: boolean, timeline: boolean, adminAccess: boolean, viva: boolean, labsContextualiser: boolean, schoolyear: boolean };

export type AddGroupTagMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  groupId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
}>;


export type AddGroupTagMutation = { __typename?: 'RootMutationType', addGroupTag: { __typename?: 'GroupTag', id: string, text: string } };

export type AppendGroupsMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  input: SetupGroupInput;
}>;


export type AppendGroupsMutation = { __typename?: 'RootMutationType', appendGroups: Array<{ __typename?: 'Group', id: string, name: string, markerId: string | null, code: string | null, sectionId: string | null, questionId: string | null, maxLimit: number | null, minLimit: number | null, finalised: boolean, finalisedAt: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, members: Array<{ __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }>, groupMembers: Array<{ __typename?: 'GroupMember', id: string, colourset: number, user: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, groupMarkers: Array<{ __typename?: 'GroupMarker', id: string, role: MarkerRole, markerPlaceholder: string | null, groupMemberId: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null }> }>, tags: Array<{ __typename?: 'GroupTag', id: string, text: string }>, workSettings: { __typename?: 'WorkSettings', id: string, dueDate: string | null, groupId: string | null } | null }> };

export type AssignMarkersToMembersMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  inputs: Array<MarkerForMembersInput> | MarkerForMembersInput;
}>;


export type AssignMarkersToMembersMutation = { __typename?: 'RootMutationType', assignMarkersToMembers: Array<{ __typename?: 'GroupMarker', id: string, role: MarkerRole, markerPlaceholder: string | null, groupMemberId: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null }> };

export type AutoAssignGroupsMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  groupId: InputMaybe<Scalars['ID']['input']>;
}>;


export type AutoAssignGroupsMutation = { __typename?: 'RootMutationType', autoAssignGroups: Array<{ __typename?: 'Group', id: string, name: string, markerId: string | null, code: string | null, sectionId: string | null, questionId: string | null, maxLimit: number | null, minLimit: number | null, finalised: boolean, finalisedAt: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, members: Array<{ __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }>, groupMembers: Array<{ __typename?: 'GroupMember', id: string, colourset: number, user: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, groupMarkers: Array<{ __typename?: 'GroupMarker', id: string, role: MarkerRole, markerPlaceholder: string | null, groupMemberId: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null }> }>, tags: Array<{ __typename?: 'GroupTag', id: string, text: string }>, workSettings: { __typename?: 'WorkSettings', id: string, dueDate: string | null, groupId: string | null } | null }> | null };

export type BrightspaceGroupFragment = { __typename?: 'BrightspaceGroup', id: string, name: string, code: string | null, totalStudents: number, students: Array<{ __typename?: 'BrightspaceUser', id: string }> | null };

export type BrightspaceGroupsQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  brightspaceScopeFor: BrightspaceScopeKeyType;
}>;


export type BrightspaceGroupsQuery = { __typename?: 'RootQueryType', brightspaceApi: { __typename?: 'BrightspaceApi', groups: Array<{ __typename?: 'BrightspaceGroup', id: string, name: string, code: string | null, totalStudents: number, students: Array<{ __typename?: 'BrightspaceUser', id: string }> | null }> }, class: { __typename?: 'Class', students: Array<{ __typename?: 'Enrollment', sisUserId: string | null, customParams: { __typename?: 'CustomParams', brightspaceUserId: string | null }, user: { __typename?: 'User', id: string, name: string } }> } };

export type CanvasSectionFragment = { __typename?: 'CanvasSection', id: string, courseId: string, name: string, sisCourseId: string | null, totalStudents: number, students: Array<{ __typename?: 'CanvasUser', id: string, name: string, sisUserId: string | null }> | null };

export type CanvasSectionsQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  canvasScopeFor: CanvasScopeKeyType;
}>;


export type CanvasSectionsQuery = { __typename?: 'RootQueryType', canvasApi: { __typename?: 'CanvasApi', sections: Array<{ __typename?: 'CanvasSection', id: string, courseId: string, name: string, sisCourseId: string | null, totalStudents: number, students: Array<{ __typename?: 'CanvasUser', id: string, name: string, sisUserId: string | null }> | null }> }, class: { __typename?: 'Class', students: Array<{ __typename?: 'Enrollment', sisUserId: string | null, customParams: { __typename?: 'CustomParams', canvasUserId: string | null }, user: { __typename?: 'User', id: string, name: string } }> } };

export type ClassGroupsFragment = { __typename?: 'Class', id: string, groupType: GroupType, groups: Array<{ __typename?: 'Group', id: string, name: string, markerId: string | null, code: string | null, sectionId: string | null, questionId: string | null, maxLimit: number | null, minLimit: number | null, finalised: boolean, finalisedAt: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, members: Array<{ __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }>, groupMembers: Array<{ __typename?: 'GroupMember', id: string, colourset: number, user: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, groupMarkers: Array<{ __typename?: 'GroupMarker', id: string, role: MarkerRole, markerPlaceholder: string | null, groupMemberId: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null }> }>, tags: Array<{ __typename?: 'GroupTag', id: string, text: string }>, workSettings: { __typename?: 'WorkSettings', id: string, dueDate: string | null, groupId: string | null } | null }> };

export type CreateGroupsMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  groups: Array<GroupInput> | GroupInput;
}>;


export type CreateGroupsMutation = { __typename?: 'RootMutationType', createGroups: Array<{ __typename?: 'Group', id: string, name: string, markerId: string | null, code: string | null, sectionId: string | null, questionId: string | null, maxLimit: number | null, minLimit: number | null, finalised: boolean, finalisedAt: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, members: Array<{ __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }>, groupMembers: Array<{ __typename?: 'GroupMember', id: string, colourset: number, user: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, groupMarkers: Array<{ __typename?: 'GroupMarker', id: string, role: MarkerRole, markerPlaceholder: string | null, groupMemberId: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null }> }>, tags: Array<{ __typename?: 'GroupTag', id: string, text: string }>, workSettings: { __typename?: 'WorkSettings', id: string, dueDate: string | null, groupId: string | null } | null }> };

export type DeletedMemberFragment = { __typename?: 'DeletedMember', id: string, groupId: string };

export type DeleteGroupMemberMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  groupId: Scalars['ID']['input'];
}>;


export type DeleteGroupMemberMutation = { __typename?: 'RootMutationType', deleteGroupMember: { __typename?: 'DeletedMember', id: string, groupId: string } | null };

export type DeleteGroupMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  groupId: Scalars['ID']['input'];
  autoAssign: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteGroupMutation = { __typename?: 'RootMutationType', deleteGroup: Array<{ __typename?: 'Group', id: string, name: string, markerId: string | null, code: string | null, sectionId: string | null, questionId: string | null, maxLimit: number | null, minLimit: number | null, finalised: boolean, finalisedAt: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, members: Array<{ __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }>, groupMembers: Array<{ __typename?: 'GroupMember', id: string, colourset: number, user: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, groupMarkers: Array<{ __typename?: 'GroupMarker', id: string, role: MarkerRole, markerPlaceholder: string | null, groupMemberId: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null }> }>, tags: Array<{ __typename?: 'GroupTag', id: string, text: string }>, workSettings: { __typename?: 'WorkSettings', id: string, dueDate: string | null, groupId: string | null } | null }> };

export type DeleteGroupsMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  groupIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  autoAssign: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteGroupsMutation = { __typename?: 'RootMutationType', deleteGroups: Array<{ __typename?: 'Group', id: string, name: string, markerId: string | null, code: string | null, sectionId: string | null, questionId: string | null, maxLimit: number | null, minLimit: number | null, finalised: boolean, finalisedAt: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, members: Array<{ __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }>, groupMembers: Array<{ __typename?: 'GroupMember', id: string, colourset: number, user: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, groupMarkers: Array<{ __typename?: 'GroupMarker', id: string, role: MarkerRole, markerPlaceholder: string | null, groupMemberId: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null }> }>, tags: Array<{ __typename?: 'GroupTag', id: string, text: string }>, workSettings: { __typename?: 'WorkSettings', id: string, dueDate: string | null, groupId: string | null } | null }> };

export type FinaliseAllGroupsMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type FinaliseAllGroupsMutation = { __typename?: 'RootMutationType', finaliseAllGroups: Array<{ __typename?: 'Group', id: string, name: string, markerId: string | null, code: string | null, sectionId: string | null, questionId: string | null, maxLimit: number | null, minLimit: number | null, finalised: boolean, finalisedAt: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, members: Array<{ __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }>, groupMembers: Array<{ __typename?: 'GroupMember', id: string, colourset: number, user: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, groupMarkers: Array<{ __typename?: 'GroupMarker', id: string, role: MarkerRole, markerPlaceholder: string | null, groupMemberId: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null }> }>, tags: Array<{ __typename?: 'GroupTag', id: string, text: string }>, workSettings: { __typename?: 'WorkSettings', id: string, dueDate: string | null, groupId: string | null } | null }> };

export type FinaliseGroupsMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  groupIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type FinaliseGroupsMutation = { __typename?: 'RootMutationType', finaliseGroups: Array<{ __typename?: 'Group', id: string, name: string, markerId: string | null, code: string | null, sectionId: string | null, questionId: string | null, maxLimit: number | null, minLimit: number | null, finalised: boolean, finalisedAt: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, members: Array<{ __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }>, groupMembers: Array<{ __typename?: 'GroupMember', id: string, colourset: number, user: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, groupMarkers: Array<{ __typename?: 'GroupMarker', id: string, role: MarkerRole, markerPlaceholder: string | null, groupMemberId: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null }> }>, tags: Array<{ __typename?: 'GroupTag', id: string, text: string }>, workSettings: { __typename?: 'WorkSettings', id: string, dueDate: string | null, groupId: string | null } | null }> };

export type GroupEnrollmentFragment = { __typename?: 'Enrollment', id: string, deleted: boolean, user: { __typename?: 'User', id: string }, workSettings: { __typename?: 'WorkSettings', id: string, examDeferred: boolean | null, groupId: string | null } | null };

export type GroupFragment = { __typename?: 'Group', id: string, name: string, markerId: string | null, code: string | null, sectionId: string | null, questionId: string | null, maxLimit: number | null, minLimit: number | null, finalised: boolean, finalisedAt: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, members: Array<{ __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }>, groupMembers: Array<{ __typename?: 'GroupMember', id: string, colourset: number, user: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, groupMarkers: Array<{ __typename?: 'GroupMarker', id: string, role: MarkerRole, markerPlaceholder: string | null, groupMemberId: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null }> }>, tags: Array<{ __typename?: 'GroupTag', id: string, text: string }>, workSettings: { __typename?: 'WorkSettings', id: string, dueDate: string | null, groupId: string | null } | null };

export type GroupMarkerFragment = { __typename?: 'GroupMarker', id: string, role: MarkerRole, markerPlaceholder: string | null, groupMemberId: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null };

export type GroupMemberFragment = { __typename?: 'GroupMember', id: string, colourset: number, user: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, groupMarkers: Array<{ __typename?: 'GroupMarker', id: string, role: MarkerRole, markerPlaceholder: string | null, groupMemberId: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null }> };

export type GroupTagFragment = { __typename?: 'GroupTag', id: string, text: string };

export type GroupUpdatedSubscriptionVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type GroupUpdatedSubscription = { __typename?: 'RootSubscriptionType', groupUpdated: { __typename?: 'Group', id: string, name: string, markerId: string | null, code: string | null, sectionId: string | null, questionId: string | null, maxLimit: number | null, minLimit: number | null, finalised: boolean, finalisedAt: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, members: Array<{ __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }>, groupMembers: Array<{ __typename?: 'GroupMember', id: string, colourset: number, user: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, groupMarkers: Array<{ __typename?: 'GroupMarker', id: string, role: MarkerRole, markerPlaceholder: string | null, groupMemberId: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null }> }>, tags: Array<{ __typename?: 'GroupTag', id: string, text: string }>, workSettings: { __typename?: 'WorkSettings', id: string, dueDate: string | null, groupId: string | null } | null } };

export type GroupsRouteQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type GroupsRouteQuery = { __typename?: 'RootQueryType', token: string, me: { __typename?: 'User', id: string, email: string | null }, lecturers: Array<{ __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }>, assessment: { __typename?: 'Assessment', id: string, name: string, subjectName: string, subjectId: string, dueDate: string | null, gradingDueDate: string | null, startDate: string | null, endDate: string | null, edition: number, subject: { __typename?: 'Subject', id: string, discipline: Discipline | null, name: string, label: string | null }, ltiTool: { __typename?: 'InstitutionTool', id: string, name: string | null, familyCode: string | null }, ltiServices: Array<{ __typename?: 'LtiService', id: string, name: string, version: string, issuer: string | null, metaUrl: string | null, isLtiPluginAgs: boolean }>, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, groupDraftDueDate: string | null, groupDraftEnabled: boolean, individualDraftFeedbackAlwaysAvailable: boolean, groupDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, submitAttemptLimit: number | null, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, rubricDisplayDisabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, examReentryPreventionEnabled: boolean, examInactivityTimeout: number | null, examSchoolyearEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckSkipEnabled: boolean, sentimentCheckIntervalInHr: number | null, sentimentCheckFirstCheckAt: string | null, sentimentCheckScheduleType: SentimentCheckScheduleType, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, peerEvaluationMode: PeerEvaluationMode, peerEvaluationMinScaleFactor: number, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMode: SelfEvaluationMode, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterAcceptanceRequired: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, vivaEnabled: boolean, vivaReattemptWindowTime: number | null, vivaCameraRequiredDisabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, sentimentCheckSchedules: Array<{ __typename?: 'SentimentCheckSchedule', id: string, scheduledAt: string }> | null, vivaSourceTask: { __typename?: 'VivaSourceTask', id: string, assessmentId: string, name: string } | null } | null, ltiCustomParams: { __typename?: 'CustomParams', moodleAttemptReopenMethod: string | null } | null, schoolyearExam: { __typename?: 'SchoolyearExam', id: string, pushStatus: SchoolyearExamPushStatus } | null }, sections: Array<{ __typename?: 'Section', id: string, name: string, position: number, studentCount: number }>, class: { __typename?: 'Class', id: string, groupType: GroupType, students: Array<{ __typename?: 'Enrollment', id: string, sectionId: string | null, syncedAt: string | null, deleted: boolean, sisUserId: string | null, reentryCount: number, anonymousIndex: number | null, deletedBy: { __typename?: 'User', id: string, name: string } | null, user: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }, work: { __typename?: 'Work', id: string, startDate: string | null, updatedAt: string | null, lastSaveTime: string | null, attemptCount: number, finalResult: { __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number, memberSummaries: Array<{ __typename?: 'MemberSummary', lastAccess: string, accessCount: number, userId: string }> } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null } | null, draftResult: { __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number, memberSummaries: Array<{ __typename?: 'MemberSummary', lastAccess: string, accessCount: number, userId: string }> } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null } | null, features: { __typename?: 'WorkFeatures', id: string, enableWorkAuthority: boolean } } | null, tags: Array<{ __typename?: 'Tag', id: string, text: string, column: number, tab: ClassTab }>, workSettings: { __typename?: 'WorkSettings', id: string, studentId: string | null, dueDate: string | null, timeLimit: number | null, examReadingTime: number | null, examWritingTime: number | null, examStartDate: string | null, examEndDate: string | null, examDeferred: boolean | null, submitAttemptLimit: number | null, updatedAt: string | null, updateReason: string | null, draftExamStartDate: string | null, draftExamEndDate: string | null, groupId: string | null, vivaExtraAttempts: number | null, lastUpdatedBy: { __typename?: 'User', id: string, name: string } | null } | null, accessCode: { __typename?: 'AccessCode', code: string, label: string | null, active: boolean, type: AccessCodeType } | null, verifiedCodes: Array<{ __typename?: 'VerifiedCode', label: string | null, insertedAt: string | null }> | null }>, groups: Array<{ __typename?: 'Group', id: string, name: string, markerId: string | null, code: string | null, sectionId: string | null, questionId: string | null, maxLimit: number | null, minLimit: number | null, finalised: boolean, finalisedAt: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, members: Array<{ __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }>, groupMembers: Array<{ __typename?: 'GroupMember', id: string, colourset: number, user: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, groupMarkers: Array<{ __typename?: 'GroupMarker', id: string, role: MarkerRole, markerPlaceholder: string | null, groupMemberId: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null }> }>, tags: Array<{ __typename?: 'GroupTag', id: string, text: string }>, workSettings: { __typename?: 'WorkSettings', id: string, dueDate: string | null, groupId: string | null } | null }> }, messageInbox: Array<{ __typename?: 'Message', id: string, sourceUserId: string, messageType: MessageRequestType }>, individualSheet: { __typename?: 'Sheet', id: string, serverId: string, taskId: string, kind: TaskKind, format: TaskFormat, rawContent: string | null, releaseTimestamp: string, version: number, questionBlocks: Array<{ __typename?: 'QuestionBlock', nodeId: string, parentNodeId: string | null, nodeType: QuestionTreeNodeType, order: number, shortLabel: string | null, longLabel: string | null, shuffle: boolean | null, points: number | null, socraticQuestionerEnabled: boolean, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null }>, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean }>, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, groupDraftDueDate: string | null, groupDraftEnabled: boolean, individualDraftFeedbackAlwaysAvailable: boolean, groupDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, submitAttemptLimit: number | null, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, rubricDisplayDisabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, examReentryPreventionEnabled: boolean, examInactivityTimeout: number | null, examSchoolyearEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckSkipEnabled: boolean, sentimentCheckIntervalInHr: number | null, sentimentCheckFirstCheckAt: string | null, sentimentCheckScheduleType: SentimentCheckScheduleType, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, peerEvaluationMode: PeerEvaluationMode, peerEvaluationMinScaleFactor: number, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMode: SelfEvaluationMode, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterAcceptanceRequired: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, vivaEnabled: boolean, vivaReattemptWindowTime: number | null, vivaCameraRequiredDisabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, sentimentCheckSchedules: Array<{ __typename?: 'SentimentCheckSchedule', id: string, scheduledAt: string }> | null, vivaSourceTask: { __typename?: 'VivaSourceTask', id: string, assessmentId: string, name: string } | null } | null } | null, institution: { __typename?: 'Institution', id: string, apiStatus: { __typename?: 'ApiStatusType', hasBrightspaceApi: boolean, hasCanvasApi: boolean } }, featureFlags: { __typename?: 'InstitutionFeatures', id: string, accessCode: boolean, exams: boolean, respondusLdb: boolean, moodleGrader: boolean, multiformat: boolean, turnitin: boolean, turnitinGrader: boolean, cadmusGrader: boolean, groupAssessment: boolean, genAiDeclaration: boolean, extensionSyncing: boolean, advancedMarking: boolean, timeline: boolean, adminAccess: boolean, viva: boolean, labsContextualiser: boolean, schoolyear: boolean } };

export type ImportSectionsMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  input: ImportSectionsInput;
}>;


export type ImportSectionsMutation = { __typename?: 'RootMutationType', importSections: { __typename?: 'ImportSectionsResult', unmatchedStudents: Array<string>, ungroupedStudents: Array<string>, sections: Array<{ __typename?: 'Section', id: string, name: string, position: number, studentCount: number }> } };

export type LtiServiceFragment = { __typename?: 'LtiService', id: string, issuer: string | null, name: string, version: string };

export type RemoveGroupTagMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  groupId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
}>;


export type RemoveGroupTagMutation = { __typename?: 'RootMutationType', removeGroupTag: boolean };

export type ResetGroupsMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type ResetGroupsMutation = { __typename?: 'RootMutationType', resetGroups: boolean };

export type ResolveMessagesMutationVariables = Exact<{
  messageIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  assessmentId: Scalars['ID']['input'];
}>;


export type ResolveMessagesMutation = { __typename?: 'RootMutationType', resolveMessages: Array<{ __typename?: 'Message', id: string, sourceUserId: string, messageType: MessageRequestType }> };

export type GroupSectionFragment = { __typename?: 'Section', id: string, name: string, position: number, studentCount: number };

export type SetupGroupsMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  input: SetupGroupInput;
  settingsInput: InputMaybe<GroupSettingsInput>;
}>;


export type SetupGroupsMutation = { __typename?: 'RootMutationType', setupGroups: Array<{ __typename?: 'Group', id: string, name: string, markerId: string | null, code: string | null, sectionId: string | null, questionId: string | null, maxLimit: number | null, minLimit: number | null, finalised: boolean, finalisedAt: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, members: Array<{ __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }>, groupMembers: Array<{ __typename?: 'GroupMember', id: string, colourset: number, user: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, groupMarkers: Array<{ __typename?: 'GroupMarker', id: string, role: MarkerRole, markerPlaceholder: string | null, groupMemberId: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null }> }>, tags: Array<{ __typename?: 'GroupTag', id: string, text: string }>, workSettings: { __typename?: 'WorkSettings', id: string, dueDate: string | null, groupId: string | null } | null }> };

export type UnassignMarkersMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  groupMarkerIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type UnassignMarkersMutation = { __typename?: 'RootMutationType', unassignMarkers: boolean };

export type UpdateGroupMembershipsMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  memberships: Array<GroupMembershipInput> | GroupMembershipInput;
}>;


export type UpdateGroupMembershipsMutation = { __typename?: 'RootMutationType', updateGroupMemberships: Array<{ __typename?: 'Group', id: string, name: string, markerId: string | null, code: string | null, sectionId: string | null, questionId: string | null, maxLimit: number | null, minLimit: number | null, finalised: boolean, finalisedAt: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, members: Array<{ __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }>, groupMembers: Array<{ __typename?: 'GroupMember', id: string, colourset: number, user: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, groupMarkers: Array<{ __typename?: 'GroupMarker', id: string, role: MarkerRole, markerPlaceholder: string | null, groupMemberId: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null }> }>, tags: Array<{ __typename?: 'GroupTag', id: string, text: string }>, workSettings: { __typename?: 'WorkSettings', id: string, dueDate: string | null, groupId: string | null } | null }> };

export type UpdateGroupMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  group: GroupUpdateInput;
}>;


export type UpdateGroupMutation = { __typename?: 'RootMutationType', updateGroup: { __typename?: 'Group', id: string, name: string, markerId: string | null, code: string | null, sectionId: string | null, questionId: string | null, maxLimit: number | null, minLimit: number | null, finalised: boolean, finalisedAt: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, members: Array<{ __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }>, groupMembers: Array<{ __typename?: 'GroupMember', id: string, colourset: number, user: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, groupMarkers: Array<{ __typename?: 'GroupMarker', id: string, role: MarkerRole, markerPlaceholder: string | null, groupMemberId: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null }> }>, tags: Array<{ __typename?: 'GroupTag', id: string, text: string }>, workSettings: { __typename?: 'WorkSettings', id: string, dueDate: string | null, groupId: string | null } | null } };

export type UpdateGroupNameMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  input: GroupUpdateInput;
}>;


export type UpdateGroupNameMutation = { __typename?: 'RootMutationType', updateGroup: { __typename?: 'Group', id: string, name: string } };

export type AssignMarkerToGroupsMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  groupIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  markerId: InputMaybe<Scalars['ID']['input']>;
}>;


export type AssignMarkerToGroupsMutation = { __typename?: 'RootMutationType', assignMarkerToGroups: Array<{ __typename?: 'Group', id: string, markerId: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null }> | null };

export type WorkGroupFragment = { __typename?: 'WorkGroup', id: string, group: { __typename?: 'Group', id: string, name: string, markerId: string | null, code: string | null, sectionId: string | null, questionId: string | null, maxLimit: number | null, minLimit: number | null, finalised: boolean, finalisedAt: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, members: Array<{ __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }>, groupMembers: Array<{ __typename?: 'GroupMember', id: string, colourset: number, user: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, groupMarkers: Array<{ __typename?: 'GroupMarker', id: string, role: MarkerRole, markerPlaceholder: string | null, groupMemberId: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null }> }>, tags: Array<{ __typename?: 'GroupTag', id: string, text: string }>, workSettings: { __typename?: 'WorkSettings', id: string, dueDate: string | null, groupId: string | null } | null }, work: { __typename?: 'Work', id: string, startDate: string | null, updatedAt: string | null, lastSaveTime: string | null, attemptCount: number, finalResult: { __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number, memberSummaries: Array<{ __typename?: 'MemberSummary', lastAccess: string, accessCount: number, userId: string }> } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null } | null, draftResult: { __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number, memberSummaries: Array<{ __typename?: 'MemberSummary', lastAccess: string, accessCount: number, userId: string }> } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null } | null, features: { __typename?: 'WorkFeatures', id: string, enableWorkAuthority: boolean } } | null };

export type GroupHubNavigationQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type GroupHubNavigationQuery = { __typename?: 'RootQueryType', assessment: { __typename?: 'Assessment', id: string, settings: { __typename?: 'AssessmentSettings', id: string, releaseDate: string | null, openDate: string | null, dueDate: string | null, feedbackDate: string | null, individualReportEnabled: boolean, peerEvaluationEnabled: boolean, selfEvaluationEnabled: boolean, groupCharterEnabled: boolean, groupCharterAcceptanceRequired: boolean, referencingStyleEnabled: boolean, wordLimitEnabled: boolean, sentimentCheckEnabled: boolean, groupReportWeight: number | null, individualReportWeight: number | null, peerEvaluationWeight: number | null, peerEvaluationMode: PeerEvaluationMode, selfEvaluationWeight: number | null, selfEvaluationMode: SelfEvaluationMode, individualReportDueDate: string | null, groupCharterDueDate: string | null, peerEvaluationDueDate: string | null, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupChangeRequestCutoff: string | null, groupShowEmailToStudents: boolean, maxGrade: number, draftEnabled: boolean, draftDueDate: string | null, groupDraftEnabled: boolean, groupDraftDueDate: string | null, allowGenerativeAi: boolean | null } | null } };

export type GroupHubQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type GroupHubQuery = { __typename?: 'RootQueryType', assessment: { __typename?: 'Assessment', id: string, settings: { __typename?: 'AssessmentSettings', id: string, releaseDate: string | null, openDate: string | null, dueDate: string | null, feedbackDate: string | null, individualReportEnabled: boolean, peerEvaluationEnabled: boolean, selfEvaluationEnabled: boolean, groupCharterEnabled: boolean, groupCharterAcceptanceRequired: boolean, referencingStyleEnabled: boolean, wordLimitEnabled: boolean, sentimentCheckEnabled: boolean, groupReportWeight: number | null, individualReportWeight: number | null, peerEvaluationWeight: number | null, peerEvaluationMode: PeerEvaluationMode, selfEvaluationWeight: number | null, selfEvaluationMode: SelfEvaluationMode, individualReportDueDate: string | null, groupCharterDueDate: string | null, peerEvaluationDueDate: string | null, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupChangeRequestCutoff: string | null, groupShowEmailToStudents: boolean, maxGrade: number, draftEnabled: boolean, draftDueDate: string | null, groupDraftEnabled: boolean, groupDraftDueDate: string | null, allowGenerativeAi: boolean | null } | null }, messageInbox: Array<{ __typename?: 'Message', id: string, sourceUserId: string, messageType: MessageRequestType }>, class: { __typename?: 'Class', id: string, students: Array<{ __typename?: 'Enrollment', id: string, deleted: boolean, user: { __typename?: 'User', id: string }, workSettings: { __typename?: 'WorkSettings', id: string, examDeferred: boolean | null, groupId: string | null } | null }>, groups: Array<{ __typename?: 'Group', id: string, name: string, markerId: string | null, code: string | null, sectionId: string | null, questionId: string | null, maxLimit: number | null, minLimit: number | null, finalised: boolean, finalisedAt: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, members: Array<{ __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }>, groupMembers: Array<{ __typename?: 'GroupMember', id: string, colourset: number, user: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, groupMarkers: Array<{ __typename?: 'GroupMarker', id: string, role: MarkerRole, markerPlaceholder: string | null, groupMemberId: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null }> }>, tags: Array<{ __typename?: 'GroupTag', id: string, text: string }>, workSettings: { __typename?: 'WorkSettings', id: string, dueDate: string | null, groupId: string | null } | null }> }, charterDraft: { __typename?: 'CharterForm', id: string, published: boolean, hasUnpublishedChanges: boolean, publishTimestamp: string | null, editedAt: string | null, sections: Array<{ __typename?: 'CharterFormSection', id: string, deleted: boolean, enabled: boolean, rank: number | null, promptDoc: string | null, title: string | null, type: CharterFormSectionType, wordLimit: number | null, wordLimitEnabled: boolean, milestonePresets: Array<{ __typename?: 'MilestonePresetType', id: string, description: string | null, dueDate: string | null, title: string | null }> | null }> } | null, charterPublished: { __typename?: 'CharterForm', id: string, publishTimestamp: string | null } | null, groupTask: { __typename?: 'Task', id: string, kind: TaskKind, status: Status, saveState: { __typename?: 'SaveState', id: string, version: number, rawContent: string | null }, genaiGuidelineNotice: { __typename?: 'TaskNotice', id: string } | null } | null, groupInstructionSheet: { __typename?: 'Sheet', id: string, genaiGuidelineNotice: { __typename?: 'TaskNotice', id: string } | null } | null, individualTask: { __typename?: 'Task', id: string, kind: TaskKind, status: Status, saveState: { __typename?: 'SaveState', id: string, version: number, rawContent: string | null }, genaiGuidelineNotice: { __typename?: 'TaskNotice', id: string } | null } | null, peerTask: { __typename?: 'Task', id: string, kind: TaskKind, status: Status, saveState: { __typename?: 'SaveState', id: string, version: number, rawContent: string | null }, genaiGuidelineNotice: { __typename?: 'TaskNotice', id: string } | null } | null, groupRubricMarkingStatus: { __typename?: 'MarkerRubric', id: string, markingExists: boolean, hasChanges: boolean, publishedAt: string | null } | null, individualRubricMarkingStatus: { __typename?: 'MarkerRubric', id: string, markingExists: boolean, hasChanges: boolean, publishedAt: string | null } | null, peerRubricMarkingStatus: { __typename?: 'MarkerRubric', id: string, markingExists: boolean, hasChanges: boolean, publishedAt: string | null } | null };

export type HomeQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type HomeQuery = { __typename?: 'RootQueryType', token: string, me: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }, institution: { __typename?: 'Institution', id: string, tenant: string, timezone: string }, featureFlags: { __typename?: 'InstitutionFeatures', id: string, accessCode: boolean, exams: boolean, respondusLdb: boolean, moodleGrader: boolean, multiformat: boolean, turnitin: boolean, turnitinGrader: boolean, cadmusGrader: boolean, groupAssessment: boolean, genAiDeclaration: boolean, extensionSyncing: boolean, advancedMarking: boolean, timeline: boolean, adminAccess: boolean, viva: boolean, labsContextualiser: boolean, schoolyear: boolean }, assessment: { __typename?: 'Assessment', id: string, name: string, subjectName: string, subjectId: string, dueDate: string | null, gradingDueDate: string | null, startDate: string | null, endDate: string | null, edition: number, tasks: Array<{ __typename?: 'Task', id: string, status: Status, kind: TaskKind, format: TaskFormat | null, instructionSheet: { __typename?: 'Sheet', id: string, serverId: string, taskId: string, kind: TaskKind, format: TaskFormat, rawContent: string | null, releaseTimestamp: string, version: number, questionBlocks: Array<{ __typename?: 'QuestionBlock', nodeId: string, parentNodeId: string | null, nodeType: QuestionTreeNodeType, order: number, shortLabel: string | null, longLabel: string | null, shuffle: boolean | null, points: number | null, socraticQuestionerEnabled: boolean, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null }>, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean }>, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, groupDraftDueDate: string | null, groupDraftEnabled: boolean, individualDraftFeedbackAlwaysAvailable: boolean, groupDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, submitAttemptLimit: number | null, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, rubricDisplayDisabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, examReentryPreventionEnabled: boolean, examInactivityTimeout: number | null, examSchoolyearEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckSkipEnabled: boolean, sentimentCheckIntervalInHr: number | null, sentimentCheckFirstCheckAt: string | null, sentimentCheckScheduleType: SentimentCheckScheduleType, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, peerEvaluationMode: PeerEvaluationMode, peerEvaluationMinScaleFactor: number, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMode: SelfEvaluationMode, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterAcceptanceRequired: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, vivaEnabled: boolean, vivaReattemptWindowTime: number | null, vivaCameraRequiredDisabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, sentimentCheckSchedules: Array<{ __typename?: 'SentimentCheckSchedule', id: string, scheduledAt: string }> | null, vivaSourceTask: { __typename?: 'VivaSourceTask', id: string, assessmentId: string, name: string } | null } | null } | null, futureSheet: { __typename?: 'Sheet', id: string, serverId: string, format: TaskFormat, kind: TaskKind, taskId: string, rawContent: string | null, releaseTimestamp: string, version: number, questionBlocks: Array<{ __typename?: 'QuestionBlock', nodeId: string, parentNodeId: string | null, nodeType: QuestionTreeNodeType, order: number, shortLabel: string | null, longLabel: string | null, shuffle: boolean | null, points: number | null, socraticQuestionerEnabled: boolean, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null }>, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean }>, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, groupDraftDueDate: string | null, groupDraftEnabled: boolean, individualDraftFeedbackAlwaysAvailable: boolean, groupDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, submitAttemptLimit: number | null, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, rubricDisplayDisabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, examReentryPreventionEnabled: boolean, examInactivityTimeout: number | null, examSchoolyearEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckSkipEnabled: boolean, sentimentCheckIntervalInHr: number | null, sentimentCheckFirstCheckAt: string | null, sentimentCheckScheduleType: SentimentCheckScheduleType, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, peerEvaluationMode: PeerEvaluationMode, peerEvaluationMinScaleFactor: number, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMode: SelfEvaluationMode, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterAcceptanceRequired: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, vivaEnabled: boolean, vivaReattemptWindowTime: number | null, vivaCameraRequiredDisabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, sentimentCheckSchedules: Array<{ __typename?: 'SentimentCheckSchedule', id: string, scheduledAt: string }> | null, vivaSourceTask: { __typename?: 'VivaSourceTask', id: string, assessmentId: string, name: string } | null } | null, futureSettings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, groupDraftDueDate: string | null, groupDraftEnabled: boolean, individualDraftFeedbackAlwaysAvailable: boolean, groupDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, submitAttemptLimit: number | null, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, rubricDisplayDisabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, examReentryPreventionEnabled: boolean, examInactivityTimeout: number | null, examSchoolyearEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckSkipEnabled: boolean, sentimentCheckIntervalInHr: number | null, sentimentCheckFirstCheckAt: string | null, sentimentCheckScheduleType: SentimentCheckScheduleType, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, peerEvaluationMode: PeerEvaluationMode, peerEvaluationMinScaleFactor: number, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMode: SelfEvaluationMode, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterAcceptanceRequired: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, vivaEnabled: boolean, vivaReattemptWindowTime: number | null, vivaCameraRequiredDisabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, sentimentCheckSchedules: Array<{ __typename?: 'SentimentCheckSchedule', id: string, scheduledAt: string }> | null, vivaSourceTask: { __typename?: 'VivaSourceTask', id: string, assessmentId: string, name: string } | null } | null } | null, blocks: Array<{ __typename?: 'TaskBlock', id: string, previousNodeId: string | null, nodeId: string, parentNodeId: string | null, deleted: boolean, hidden: boolean, quantity: number | null, shuffle: boolean, points: number | null, order: number | null, orderLabel: string | null, libraryQuestionId: string | null, libraryQuestionVersionId: string | null, socraticQuestionerEnabled: boolean, updatedAt: string | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null, questionSelection: { __typename?: 'QuestionSelection', id: string, sets: Array<{ __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, questionVersionId: string | null, question: { __typename?: 'Question', updatedAt: string | null, id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string, subject: { __typename?: 'Subject', id: string, name: string } } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } }> }> | null } | null, markerRubric: { __typename?: 'MarkerRubric', id: string, assessmentId: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, hasChanges: boolean, state: MarkerRubricState, updatedAt: string | null, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, hasOutcomes: boolean, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null }>, requirements: { __typename?: 'Requirements', id: string, assessmentType: AssessmentType, enableExamAutoSubmission: boolean, enableExamLdb: boolean | null, enableSubmissionPdf: boolean, enableExamAccessCode: boolean, examEndDate: string | null, examFeedbackDate: string | null, examReadingTime: number | null, examStartDate: string | null, examTiming: ExamTiming, examType: Array<string>, examWritingTime: number | null, lateSubmissionTimeLimit: number | null, noExamReadingTime: boolean, noExamFeedbackDate: boolean, submitAttemptLimit: number | null, dueDate: string | null, returnDate: string | null, maxGrade: number, sViewReports: number, anonymousMarking: boolean | null, gradingService: string, allowLateResubmission: boolean, draftDueDate: string | null, noDraft: boolean, draftSViewReports: number, individualDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, weight: number | null, noWeight: boolean, wordLimit: number | null, noLimit: boolean, timeLimit: number | null, noTimeLimit: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, disableSpellCheck: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, rubricDisplayDisabled: boolean | null, referencingStyle: string | null, noReferencing: boolean, disableExamBacktrack: boolean | null, hasChanged: boolean, enableExamReentryPrevention: boolean, examInactivityTimeout: number | null, examSchoolyearEnabled: boolean }, saveState: { __typename?: 'SaveState', id: string, serverId: string, version: number, rawContent: string | null, updatedAt: string }, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean }>, genaiGuidelineNotice: { __typename?: 'TaskNotice', id: string, version: number, content: string } | null }>, subject: { __typename?: 'Subject', id: string, discipline: Discipline | null, name: string, label: string | null }, ltiTool: { __typename?: 'InstitutionTool', id: string, name: string | null, familyCode: string | null }, ltiServices: Array<{ __typename?: 'LtiService', id: string, name: string, version: string, issuer: string | null, metaUrl: string | null, isLtiPluginAgs: boolean }>, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, groupDraftDueDate: string | null, groupDraftEnabled: boolean, individualDraftFeedbackAlwaysAvailable: boolean, groupDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, submitAttemptLimit: number | null, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, rubricDisplayDisabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, examReentryPreventionEnabled: boolean, examInactivityTimeout: number | null, examSchoolyearEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckSkipEnabled: boolean, sentimentCheckIntervalInHr: number | null, sentimentCheckFirstCheckAt: string | null, sentimentCheckScheduleType: SentimentCheckScheduleType, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, peerEvaluationMode: PeerEvaluationMode, peerEvaluationMinScaleFactor: number, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMode: SelfEvaluationMode, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterAcceptanceRequired: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, vivaEnabled: boolean, vivaReattemptWindowTime: number | null, vivaCameraRequiredDisabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, sentimentCheckSchedules: Array<{ __typename?: 'SentimentCheckSchedule', id: string, scheduledAt: string }> | null, vivaSourceTask: { __typename?: 'VivaSourceTask', id: string, assessmentId: string, name: string } | null } | null, ltiCustomParams: { __typename?: 'CustomParams', moodleAttemptReopenMethod: string | null } | null, schoolyearExam: { __typename?: 'SchoolyearExam', id: string, pushStatus: SchoolyearExamPushStatus } | null }, class: { __typename?: 'Class', id: string, students: Array<{ __typename?: 'Enrollment', id: string, deleted: boolean, user: { __typename?: 'User', id: string }, workSettings: { __typename?: 'WorkSettings', id: string, examDeferred: boolean | null, groupId: string | null } | null }>, groups: Array<{ __typename?: 'Group', id: string, name: string, markerId: string | null, code: string | null, sectionId: string | null, questionId: string | null, maxLimit: number | null, minLimit: number | null, finalised: boolean, finalisedAt: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, members: Array<{ __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }>, groupMembers: Array<{ __typename?: 'GroupMember', id: string, colourset: number, user: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, groupMarkers: Array<{ __typename?: 'GroupMarker', id: string, role: MarkerRole, markerPlaceholder: string | null, groupMemberId: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null }> }>, tags: Array<{ __typename?: 'GroupTag', id: string, text: string }>, workSettings: { __typename?: 'WorkSettings', id: string, dueDate: string | null, groupId: string | null } | null }> }, userSettings: { __typename?: 'UserSettings', id: string, subjectRole: SubjectRole | null, showIaOnboarding: boolean | null } | null, assessmentAccessCodes: Array<{ __typename?: 'AccessCode', code: string, label: string | null, active: boolean, type: AccessCodeType }> | null };

export type HubAssessmentSettingsFragment = { __typename?: 'AssessmentSettings', id: string, releaseDate: string | null, openDate: string | null, dueDate: string | null, feedbackDate: string | null, individualReportEnabled: boolean, peerEvaluationEnabled: boolean, selfEvaluationEnabled: boolean, groupCharterEnabled: boolean, groupCharterAcceptanceRequired: boolean, referencingStyleEnabled: boolean, wordLimitEnabled: boolean, sentimentCheckEnabled: boolean, groupReportWeight: number | null, individualReportWeight: number | null, peerEvaluationWeight: number | null, peerEvaluationMode: PeerEvaluationMode, selfEvaluationWeight: number | null, selfEvaluationMode: SelfEvaluationMode, individualReportDueDate: string | null, groupCharterDueDate: string | null, peerEvaluationDueDate: string | null, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupChangeRequestCutoff: string | null, groupShowEmailToStudents: boolean, maxGrade: number, draftEnabled: boolean, draftDueDate: string | null, groupDraftEnabled: boolean, groupDraftDueDate: string | null, allowGenerativeAi: boolean | null };

export type MessageFragment = { __typename?: 'Message', id: string, sourceUserId: string, messageType: MessageRequestType };

export type ReleaseAssessmentMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type ReleaseAssessmentMutation = { __typename?: 'RootMutationType', releaseAssessment: { __typename?: 'ReleaseAssessmentPayload', assessment: { __typename?: 'Assessment', id: string, settings: { __typename?: 'AssessmentSettings', id: string, openDate: string | null, assessmentType: AssessmentType } | null }, sheets: Array<{ __typename?: 'Sheet', id: string, serverId: string, taskId: string, kind: TaskKind, format: TaskFormat, rawContent: string | null, releaseTimestamp: string, version: number, questionBlocks: Array<{ __typename?: 'QuestionBlock', nodeId: string, parentNodeId: string | null, nodeType: QuestionTreeNodeType, order: number, shortLabel: string | null, longLabel: string | null, shuffle: boolean | null, points: number | null, socraticQuestionerEnabled: boolean, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null }>, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean }>, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, groupDraftDueDate: string | null, groupDraftEnabled: boolean, individualDraftFeedbackAlwaysAvailable: boolean, groupDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, submitAttemptLimit: number | null, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, rubricDisplayDisabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, examReentryPreventionEnabled: boolean, examInactivityTimeout: number | null, examSchoolyearEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckSkipEnabled: boolean, sentimentCheckIntervalInHr: number | null, sentimentCheckFirstCheckAt: string | null, sentimentCheckScheduleType: SentimentCheckScheduleType, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, peerEvaluationMode: PeerEvaluationMode, peerEvaluationMinScaleFactor: number, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMode: SelfEvaluationMode, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterAcceptanceRequired: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, vivaEnabled: boolean, vivaReattemptWindowTime: number | null, vivaCameraRequiredDisabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, sentimentCheckSchedules: Array<{ __typename?: 'SentimentCheckSchedule', id: string, scheduledAt: string }> | null, vivaSourceTask: { __typename?: 'VivaSourceTask', id: string, assessmentId: string, name: string } | null } | null }> } };

export type SettingsQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type SettingsQuery = { __typename?: 'RootQueryType', token: string, me: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }, institution: { __typename?: 'Institution', id: string, tenant: string, timezone: string }, featureFlags: { __typename?: 'InstitutionFeatures', id: string, accessCode: boolean, exams: boolean, respondusLdb: boolean, moodleGrader: boolean, multiformat: boolean, turnitin: boolean, turnitinGrader: boolean, cadmusGrader: boolean, groupAssessment: boolean, genAiDeclaration: boolean, extensionSyncing: boolean, advancedMarking: boolean, timeline: boolean, adminAccess: boolean, viva: boolean, labsContextualiser: boolean, schoolyear: boolean }, assessment: { __typename?: 'Assessment', id: string, name: string, subjectName: string, subjectId: string, dueDate: string | null, gradingDueDate: string | null, startDate: string | null, endDate: string | null, edition: number, hasSave: boolean, hasSubmission: boolean, subject: { __typename?: 'Subject', id: string, name: string, discipline: Discipline | null }, ltiTool: { __typename?: 'InstitutionTool', id: string, name: string | null, familyCode: string | null }, ltiServices: Array<{ __typename?: 'LtiService', id: string, name: string, version: string, issuer: string | null, metaUrl: string | null, isLtiPluginAgs: boolean }>, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, groupDraftDueDate: string | null, groupDraftEnabled: boolean, individualDraftFeedbackAlwaysAvailable: boolean, groupDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, submitAttemptLimit: number | null, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, rubricDisplayDisabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, examReentryPreventionEnabled: boolean, examInactivityTimeout: number | null, examSchoolyearEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckSkipEnabled: boolean, sentimentCheckIntervalInHr: number | null, sentimentCheckFirstCheckAt: string | null, sentimentCheckScheduleType: SentimentCheckScheduleType, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, peerEvaluationMode: PeerEvaluationMode, peerEvaluationMinScaleFactor: number, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMode: SelfEvaluationMode, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterAcceptanceRequired: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, vivaEnabled: boolean, vivaReattemptWindowTime: number | null, vivaCameraRequiredDisabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, sentimentCheckSchedules: Array<{ __typename?: 'SentimentCheckSchedule', id: string, scheduledAt: string }> | null, vivaSourceTask: { __typename?: 'VivaSourceTask', id: string, assessmentId: string, name: string } | null } | null, ltiCustomParams: { __typename?: 'CustomParams', moodleAttemptReopenMethod: string | null } | null, tasks: Array<{ __typename?: 'Task', id: string, status: Status, kind: TaskKind, format: TaskFormat | null, instructionSheet: { __typename?: 'Sheet', id: string, serverId: string, taskId: string, kind: TaskKind, format: TaskFormat, rawContent: string | null, releaseTimestamp: string, version: number, questionBlocks: Array<{ __typename?: 'QuestionBlock', nodeId: string, parentNodeId: string | null, nodeType: QuestionTreeNodeType, order: number, shortLabel: string | null, longLabel: string | null, shuffle: boolean | null, points: number | null, socraticQuestionerEnabled: boolean, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null }>, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean }>, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, groupDraftDueDate: string | null, groupDraftEnabled: boolean, individualDraftFeedbackAlwaysAvailable: boolean, groupDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, submitAttemptLimit: number | null, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, rubricDisplayDisabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, examReentryPreventionEnabled: boolean, examInactivityTimeout: number | null, examSchoolyearEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckSkipEnabled: boolean, sentimentCheckIntervalInHr: number | null, sentimentCheckFirstCheckAt: string | null, sentimentCheckScheduleType: SentimentCheckScheduleType, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, peerEvaluationMode: PeerEvaluationMode, peerEvaluationMinScaleFactor: number, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMode: SelfEvaluationMode, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterAcceptanceRequired: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, vivaEnabled: boolean, vivaReattemptWindowTime: number | null, vivaCameraRequiredDisabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, sentimentCheckSchedules: Array<{ __typename?: 'SentimentCheckSchedule', id: string, scheduledAt: string }> | null, vivaSourceTask: { __typename?: 'VivaSourceTask', id: string, assessmentId: string, name: string } | null } | null } | null, futureSheet: { __typename?: 'Sheet', id: string, serverId: string, format: TaskFormat, kind: TaskKind, taskId: string, rawContent: string | null, releaseTimestamp: string, version: number, questionBlocks: Array<{ __typename?: 'QuestionBlock', nodeId: string, parentNodeId: string | null, nodeType: QuestionTreeNodeType, order: number, shortLabel: string | null, longLabel: string | null, shuffle: boolean | null, points: number | null, socraticQuestionerEnabled: boolean, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null }>, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean }>, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, groupDraftDueDate: string | null, groupDraftEnabled: boolean, individualDraftFeedbackAlwaysAvailable: boolean, groupDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, submitAttemptLimit: number | null, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, rubricDisplayDisabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, examReentryPreventionEnabled: boolean, examInactivityTimeout: number | null, examSchoolyearEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckSkipEnabled: boolean, sentimentCheckIntervalInHr: number | null, sentimentCheckFirstCheckAt: string | null, sentimentCheckScheduleType: SentimentCheckScheduleType, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, peerEvaluationMode: PeerEvaluationMode, peerEvaluationMinScaleFactor: number, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMode: SelfEvaluationMode, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterAcceptanceRequired: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, vivaEnabled: boolean, vivaReattemptWindowTime: number | null, vivaCameraRequiredDisabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, sentimentCheckSchedules: Array<{ __typename?: 'SentimentCheckSchedule', id: string, scheduledAt: string }> | null, vivaSourceTask: { __typename?: 'VivaSourceTask', id: string, assessmentId: string, name: string } | null } | null, futureSettings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, groupDraftDueDate: string | null, groupDraftEnabled: boolean, individualDraftFeedbackAlwaysAvailable: boolean, groupDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, submitAttemptLimit: number | null, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, rubricDisplayDisabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, examReentryPreventionEnabled: boolean, examInactivityTimeout: number | null, examSchoolyearEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckSkipEnabled: boolean, sentimentCheckIntervalInHr: number | null, sentimentCheckFirstCheckAt: string | null, sentimentCheckScheduleType: SentimentCheckScheduleType, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, peerEvaluationMode: PeerEvaluationMode, peerEvaluationMinScaleFactor: number, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMode: SelfEvaluationMode, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterAcceptanceRequired: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, vivaEnabled: boolean, vivaReattemptWindowTime: number | null, vivaCameraRequiredDisabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, sentimentCheckSchedules: Array<{ __typename?: 'SentimentCheckSchedule', id: string, scheduledAt: string }> | null, vivaSourceTask: { __typename?: 'VivaSourceTask', id: string, assessmentId: string, name: string } | null } | null } | null, blocks: Array<{ __typename?: 'TaskBlock', id: string, previousNodeId: string | null, nodeId: string, parentNodeId: string | null, deleted: boolean, hidden: boolean, quantity: number | null, shuffle: boolean, points: number | null, order: number | null, orderLabel: string | null, libraryQuestionId: string | null, libraryQuestionVersionId: string | null, socraticQuestionerEnabled: boolean, updatedAt: string | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null, questionSelection: { __typename?: 'QuestionSelection', id: string, sets: Array<{ __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, questionVersionId: string | null, question: { __typename?: 'Question', updatedAt: string | null, id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string, subject: { __typename?: 'Subject', id: string, name: string } } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } }> }> | null } | null, markerRubric: { __typename?: 'MarkerRubric', id: string, assessmentId: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, hasChanges: boolean, state: MarkerRubricState, updatedAt: string | null, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, hasOutcomes: boolean, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null }>, requirements: { __typename?: 'Requirements', id: string, assessmentType: AssessmentType, enableExamAutoSubmission: boolean, enableExamLdb: boolean | null, enableSubmissionPdf: boolean, enableExamAccessCode: boolean, examEndDate: string | null, examFeedbackDate: string | null, examReadingTime: number | null, examStartDate: string | null, examTiming: ExamTiming, examType: Array<string>, examWritingTime: number | null, lateSubmissionTimeLimit: number | null, noExamReadingTime: boolean, noExamFeedbackDate: boolean, submitAttemptLimit: number | null, dueDate: string | null, returnDate: string | null, maxGrade: number, sViewReports: number, anonymousMarking: boolean | null, gradingService: string, allowLateResubmission: boolean, draftDueDate: string | null, noDraft: boolean, draftSViewReports: number, individualDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, weight: number | null, noWeight: boolean, wordLimit: number | null, noLimit: boolean, timeLimit: number | null, noTimeLimit: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, disableSpellCheck: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, rubricDisplayDisabled: boolean | null, referencingStyle: string | null, noReferencing: boolean, disableExamBacktrack: boolean | null, hasChanged: boolean, enableExamReentryPrevention: boolean, examInactivityTimeout: number | null, examSchoolyearEnabled: boolean }, saveState: { __typename?: 'SaveState', id: string, serverId: string, version: number, rawContent: string | null, updatedAt: string }, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean }>, genaiGuidelineNotice: { __typename?: 'TaskNotice', id: string, version: number, content: string } | null }> } };

export type SettingsRouteAssessmentFragment = { __typename?: 'Assessment', id: string, name: string, subjectName: string, subjectId: string, dueDate: string | null, gradingDueDate: string | null, startDate: string | null, endDate: string | null, edition: number, hasSave: boolean, hasSubmission: boolean, subject: { __typename?: 'Subject', id: string, name: string, discipline: Discipline | null }, ltiTool: { __typename?: 'InstitutionTool', id: string, name: string | null, familyCode: string | null }, ltiServices: Array<{ __typename?: 'LtiService', id: string, name: string, version: string, issuer: string | null, metaUrl: string | null, isLtiPluginAgs: boolean }>, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, groupDraftDueDate: string | null, groupDraftEnabled: boolean, individualDraftFeedbackAlwaysAvailable: boolean, groupDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, submitAttemptLimit: number | null, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, rubricDisplayDisabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, examReentryPreventionEnabled: boolean, examInactivityTimeout: number | null, examSchoolyearEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckSkipEnabled: boolean, sentimentCheckIntervalInHr: number | null, sentimentCheckFirstCheckAt: string | null, sentimentCheckScheduleType: SentimentCheckScheduleType, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, peerEvaluationMode: PeerEvaluationMode, peerEvaluationMinScaleFactor: number, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMode: SelfEvaluationMode, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterAcceptanceRequired: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, vivaEnabled: boolean, vivaReattemptWindowTime: number | null, vivaCameraRequiredDisabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, sentimentCheckSchedules: Array<{ __typename?: 'SentimentCheckSchedule', id: string, scheduledAt: string }> | null, vivaSourceTask: { __typename?: 'VivaSourceTask', id: string, assessmentId: string, name: string } | null } | null, ltiCustomParams: { __typename?: 'CustomParams', moodleAttemptReopenMethod: string | null } | null, tasks: Array<{ __typename?: 'Task', id: string, status: Status, kind: TaskKind, format: TaskFormat | null, instructionSheet: { __typename?: 'Sheet', id: string, serverId: string, taskId: string, kind: TaskKind, format: TaskFormat, rawContent: string | null, releaseTimestamp: string, version: number, questionBlocks: Array<{ __typename?: 'QuestionBlock', nodeId: string, parentNodeId: string | null, nodeType: QuestionTreeNodeType, order: number, shortLabel: string | null, longLabel: string | null, shuffle: boolean | null, points: number | null, socraticQuestionerEnabled: boolean, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null }>, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean }>, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, groupDraftDueDate: string | null, groupDraftEnabled: boolean, individualDraftFeedbackAlwaysAvailable: boolean, groupDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, submitAttemptLimit: number | null, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, rubricDisplayDisabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, examReentryPreventionEnabled: boolean, examInactivityTimeout: number | null, examSchoolyearEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckSkipEnabled: boolean, sentimentCheckIntervalInHr: number | null, sentimentCheckFirstCheckAt: string | null, sentimentCheckScheduleType: SentimentCheckScheduleType, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, peerEvaluationMode: PeerEvaluationMode, peerEvaluationMinScaleFactor: number, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMode: SelfEvaluationMode, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterAcceptanceRequired: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, vivaEnabled: boolean, vivaReattemptWindowTime: number | null, vivaCameraRequiredDisabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, sentimentCheckSchedules: Array<{ __typename?: 'SentimentCheckSchedule', id: string, scheduledAt: string }> | null, vivaSourceTask: { __typename?: 'VivaSourceTask', id: string, assessmentId: string, name: string } | null } | null } | null, futureSheet: { __typename?: 'Sheet', id: string, serverId: string, format: TaskFormat, kind: TaskKind, taskId: string, rawContent: string | null, releaseTimestamp: string, version: number, questionBlocks: Array<{ __typename?: 'QuestionBlock', nodeId: string, parentNodeId: string | null, nodeType: QuestionTreeNodeType, order: number, shortLabel: string | null, longLabel: string | null, shuffle: boolean | null, points: number | null, socraticQuestionerEnabled: boolean, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null }>, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean }>, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, groupDraftDueDate: string | null, groupDraftEnabled: boolean, individualDraftFeedbackAlwaysAvailable: boolean, groupDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, submitAttemptLimit: number | null, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, rubricDisplayDisabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, examReentryPreventionEnabled: boolean, examInactivityTimeout: number | null, examSchoolyearEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckSkipEnabled: boolean, sentimentCheckIntervalInHr: number | null, sentimentCheckFirstCheckAt: string | null, sentimentCheckScheduleType: SentimentCheckScheduleType, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, peerEvaluationMode: PeerEvaluationMode, peerEvaluationMinScaleFactor: number, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMode: SelfEvaluationMode, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterAcceptanceRequired: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, vivaEnabled: boolean, vivaReattemptWindowTime: number | null, vivaCameraRequiredDisabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, sentimentCheckSchedules: Array<{ __typename?: 'SentimentCheckSchedule', id: string, scheduledAt: string }> | null, vivaSourceTask: { __typename?: 'VivaSourceTask', id: string, assessmentId: string, name: string } | null } | null, futureSettings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, groupDraftDueDate: string | null, groupDraftEnabled: boolean, individualDraftFeedbackAlwaysAvailable: boolean, groupDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, submitAttemptLimit: number | null, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, rubricDisplayDisabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, examReentryPreventionEnabled: boolean, examInactivityTimeout: number | null, examSchoolyearEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckSkipEnabled: boolean, sentimentCheckIntervalInHr: number | null, sentimentCheckFirstCheckAt: string | null, sentimentCheckScheduleType: SentimentCheckScheduleType, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, peerEvaluationMode: PeerEvaluationMode, peerEvaluationMinScaleFactor: number, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMode: SelfEvaluationMode, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterAcceptanceRequired: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, vivaEnabled: boolean, vivaReattemptWindowTime: number | null, vivaCameraRequiredDisabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, sentimentCheckSchedules: Array<{ __typename?: 'SentimentCheckSchedule', id: string, scheduledAt: string }> | null, vivaSourceTask: { __typename?: 'VivaSourceTask', id: string, assessmentId: string, name: string } | null } | null } | null, blocks: Array<{ __typename?: 'TaskBlock', id: string, previousNodeId: string | null, nodeId: string, parentNodeId: string | null, deleted: boolean, hidden: boolean, quantity: number | null, shuffle: boolean, points: number | null, order: number | null, orderLabel: string | null, libraryQuestionId: string | null, libraryQuestionVersionId: string | null, socraticQuestionerEnabled: boolean, updatedAt: string | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null, questionSelection: { __typename?: 'QuestionSelection', id: string, sets: Array<{ __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, questionVersionId: string | null, question: { __typename?: 'Question', updatedAt: string | null, id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string, subject: { __typename?: 'Subject', id: string, name: string } } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } }> }> | null } | null, markerRubric: { __typename?: 'MarkerRubric', id: string, assessmentId: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, hasChanges: boolean, state: MarkerRubricState, updatedAt: string | null, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, hasOutcomes: boolean, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null }>, requirements: { __typename?: 'Requirements', id: string, assessmentType: AssessmentType, enableExamAutoSubmission: boolean, enableExamLdb: boolean | null, enableSubmissionPdf: boolean, enableExamAccessCode: boolean, examEndDate: string | null, examFeedbackDate: string | null, examReadingTime: number | null, examStartDate: string | null, examTiming: ExamTiming, examType: Array<string>, examWritingTime: number | null, lateSubmissionTimeLimit: number | null, noExamReadingTime: boolean, noExamFeedbackDate: boolean, submitAttemptLimit: number | null, dueDate: string | null, returnDate: string | null, maxGrade: number, sViewReports: number, anonymousMarking: boolean | null, gradingService: string, allowLateResubmission: boolean, draftDueDate: string | null, noDraft: boolean, draftSViewReports: number, individualDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, weight: number | null, noWeight: boolean, wordLimit: number | null, noLimit: boolean, timeLimit: number | null, noTimeLimit: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, disableSpellCheck: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, rubricDisplayDisabled: boolean | null, referencingStyle: string | null, noReferencing: boolean, disableExamBacktrack: boolean | null, hasChanged: boolean, enableExamReentryPrevention: boolean, examInactivityTimeout: number | null, examSchoolyearEnabled: boolean }, saveState: { __typename?: 'SaveState', id: string, serverId: string, version: number, rawContent: string | null, updatedAt: string }, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean }>, genaiGuidelineNotice: { __typename?: 'TaskNotice', id: string, version: number, content: string } | null }> };

export type InsightsQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type InsightsQuery = { __typename?: 'RootQueryType', token: string, assessment: { __typename?: 'Assessment', id: string, name: string, subjectName: string, subjectId: string, dueDate: string | null, gradingDueDate: string | null, startDate: string | null, endDate: string | null, edition: number, subject: { __typename?: 'Subject', id: string, discipline: Discipline | null, name: string, label: string | null }, ltiTool: { __typename?: 'InstitutionTool', id: string, name: string | null, familyCode: string | null }, ltiServices: Array<{ __typename?: 'LtiService', id: string, name: string, version: string, issuer: string | null, metaUrl: string | null, isLtiPluginAgs: boolean }>, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, groupDraftDueDate: string | null, groupDraftEnabled: boolean, individualDraftFeedbackAlwaysAvailable: boolean, groupDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, submitAttemptLimit: number | null, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, rubricDisplayDisabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, examReentryPreventionEnabled: boolean, examInactivityTimeout: number | null, examSchoolyearEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckSkipEnabled: boolean, sentimentCheckIntervalInHr: number | null, sentimentCheckFirstCheckAt: string | null, sentimentCheckScheduleType: SentimentCheckScheduleType, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, peerEvaluationMode: PeerEvaluationMode, peerEvaluationMinScaleFactor: number, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMode: SelfEvaluationMode, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterAcceptanceRequired: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, vivaEnabled: boolean, vivaReattemptWindowTime: number | null, vivaCameraRequiredDisabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, sentimentCheckSchedules: Array<{ __typename?: 'SentimentCheckSchedule', id: string, scheduledAt: string }> | null, vivaSourceTask: { __typename?: 'VivaSourceTask', id: string, assessmentId: string, name: string } | null } | null, ltiCustomParams: { __typename?: 'CustomParams', moodleAttemptReopenMethod: string | null } | null, schoolyearExam: { __typename?: 'SchoolyearExam', id: string, pushStatus: SchoolyearExamPushStatus } | null }, futureSheet: { __typename?: 'Sheet', id: string, releaseTimestamp: string } | null, class: { __typename?: 'Class', groups: Array<{ __typename?: 'Group', id: string, name: string, markerId: string | null, code: string | null, sectionId: string | null, questionId: string | null, maxLimit: number | null, minLimit: number | null, finalised: boolean, finalisedAt: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, members: Array<{ __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }>, groupMembers: Array<{ __typename?: 'GroupMember', id: string, colourset: number, user: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, groupMarkers: Array<{ __typename?: 'GroupMarker', id: string, role: MarkerRole, markerPlaceholder: string | null, groupMemberId: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null }> }>, tags: Array<{ __typename?: 'GroupTag', id: string, text: string }>, workSettings: { __typename?: 'WorkSettings', id: string, dueDate: string | null, groupId: string | null } | null }> }, institution: { __typename?: 'Institution', id: string, timezone: string } };

export type MailingListFragment = { __typename?: 'MailingList', id: string, subscribed: boolean, members: Array<string> };

export type MailingListQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type MailingListQuery = { __typename?: 'RootQueryType', me: { __typename?: 'User', email: string | null }, insightsMailingList: { __typename?: 'MailingList', id: string, subscribed: boolean, members: Array<string> } };

export type UpdateInsightsMailingListMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  subscribed: Scalars['Boolean']['input'];
  members: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UpdateInsightsMailingListMutation = { __typename?: 'RootMutationType', updateInsightsMailingList: { __typename?: 'MailingList', id: string, subscribed: boolean, members: Array<string> } };

export type InstitutionFragment = { __typename?: 'Institution', id: string, tenant: string, timezone: string };

export type AnswerBlockFragment = { __typename?: 'AnswerBlock', id: string, nodeId: string, blockName: string | null, blockAttachments: Array<{ __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null, insertedAt: string | null, uploadedBy: { __typename?: 'User', id: string, name: string } | null }> };

export type AssessmentOverviewFragment = { __typename?: 'Assessment', id: string, name: string, subject: { __typename?: 'Subject', name: string } };

export type BlockAttachmentFragment = { __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null, insertedAt: string | null, uploadedBy: { __typename?: 'User', id: string, name: string } | null };

export type SnapshotTicksQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  answerBlockId: Scalars['ID']['input'];
  maxSnapshotId: InputMaybe<Scalars['ID']['input']>;
}>;


export type SnapshotTicksQuery = { __typename?: 'RootQueryType', snapshotTicks: Array<{ __typename?: 'SnapshotTick', id: string, version: number, timestamp: string }> };

export type BuildMarkerRubricMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  input: BuildMarkerRubricInput;
}>;


export type BuildMarkerRubricMutation = { __typename?: 'RootMutationType', buildMarkerRubric: { __typename?: 'BuildMarkerRubricPayload', markerRubric: { __typename?: 'MarkerRubric', id: string, assessmentId: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, hasChanges: boolean, state: MarkerRubricState, updatedAt: string | null, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, hasOutcomes: boolean, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> }, taskBlock: { __typename?: 'TaskBlock', id: string, markerRubric: { __typename?: 'MarkerRubric', id: string } | null } | null, fieldRubric: { __typename?: 'FieldRubric', id: string, markerRubric: { __typename?: 'MarkerRubric', id: string } | null } | null } };

export type ClassListEnrollmentsFragment = { __typename?: 'ClassList', id: string, enrollments: Array<{ __typename?: 'Enrollment', id: string, sectionId: string | null, syncedAt: string | null, deleted: boolean, sisUserId: string | null, reentryCount: number, anonymousIndex: number | null, deletedBy: { __typename?: 'User', id: string, name: string } | null, user: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }, work: { __typename?: 'Work', id: string, startDate: string | null, updatedAt: string | null, lastSaveTime: string | null, attemptCount: number, finalResult: { __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number, memberSummaries: Array<{ __typename?: 'MemberSummary', lastAccess: string, accessCount: number, userId: string }> } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null } | null, draftResult: { __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number, memberSummaries: Array<{ __typename?: 'MemberSummary', lastAccess: string, accessCount: number, userId: string }> } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null } | null, features: { __typename?: 'WorkFeatures', id: string, enableWorkAuthority: boolean } } | null, tags: Array<{ __typename?: 'Tag', id: string, text: string, column: number, tab: ClassTab }>, workSettings: { __typename?: 'WorkSettings', id: string, studentId: string | null, dueDate: string | null, timeLimit: number | null, examReadingTime: number | null, examWritingTime: number | null, examStartDate: string | null, examEndDate: string | null, examDeferred: boolean | null, submitAttemptLimit: number | null, updatedAt: string | null, updateReason: string | null, draftExamStartDate: string | null, draftExamEndDate: string | null, groupId: string | null, vivaExtraAttempts: number | null, lastUpdatedBy: { __typename?: 'User', id: string, name: string } | null } | null, accessCode: { __typename?: 'AccessCode', code: string, label: string | null, active: boolean, type: AccessCodeType } | null, verifiedCodes: Array<{ __typename?: 'VerifiedCode', label: string | null, insertedAt: string | null }> | null }> };

export type ClassOutcomesQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type ClassOutcomesQuery = { __typename?: 'RootQueryType', workOutcomes: Array<{ __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, assessmentId: string, finalScore: number | null, maxScore: number, automarkPending: boolean | null, feedbackReleasedTimestamp: string | null, finalScorePenalty: number | null, questionOutcomesScored: boolean, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, provisionalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, finalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, moderationSubmissionOutcomes: Array<{ __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, markerScope: MarkerScope, score: number | null, markerModifier: number | null, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, flagReason: string | null, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null } | null }>, markingSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, markerScope: MarkerScope, score: number | null, markerModifier: number | null, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, flagReason: string | null, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null } | null } | null, draftSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, score: number | null } | null }> };

export type ClassPeerOutcomesQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type ClassPeerOutcomesQuery = { __typename?: 'RootQueryType', classPeerOutcomes: Array<{ __typename?: 'PeerOutcome', id: string, targetUserId: string, selfScore: number | null, selfMaxScore: number | null, peerScore: number | null, peerMaxScore: number | null, isComplete: boolean | null, hasEvaluatedAllPeers: boolean | null, hasReceivedAllEvaluations: boolean | null, hasCompletedSelfEvaluation: boolean | null, feedbackReleasedTimestamp: string | null, evaluationsSubmittedAt: string | null, groupReportScaleFactor: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> }>, peerRubric: { __typename?: 'MarkerRubric', id: string, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, hasOutcomes: boolean, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null };

export type ClassicMarkingQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
}>;


export type ClassicMarkingQuery = { __typename?: 'RootQueryType', me: { __typename?: 'User', id: string, email: string | null }, featureFlags: { __typename?: 'InstitutionFeatures', id: string, accessCode: boolean, exams: boolean, respondusLdb: boolean, moodleGrader: boolean, multiformat: boolean, turnitin: boolean, turnitinGrader: boolean, cadmusGrader: boolean, groupAssessment: boolean, genAiDeclaration: boolean, extensionSyncing: boolean, advancedMarking: boolean, timeline: boolean, adminAccess: boolean, viva: boolean, labsContextualiser: boolean, schoolyear: boolean }, individualMarkerRubric: { __typename?: 'MarkerRubric', id: string, assessmentId: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, hasChanges: boolean, state: MarkerRubricState, updatedAt: string | null, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, hasOutcomes: boolean, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null, groupMarkerRubric: { __typename?: 'MarkerRubric', id: string, assessmentId: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, hasChanges: boolean, state: MarkerRubricState, updatedAt: string | null, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, hasOutcomes: boolean, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null, peerMarkerRubric: { __typename?: 'MarkerRubric', id: string, assessmentId: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, hasChanges: boolean, state: MarkerRubricState, updatedAt: string | null, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, hasOutcomes: boolean, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null, studentWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, groupId: string | null, studentId: string | null, maxScore: number, automarkPending: boolean | null, feedbackReleased: boolean, feedbackReleasedTimestamp: string | null, finalScore: number | null, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, questionOutcomes: Array<{ __typename?: 'QuestionOutcome', id: string, questionId: string, blockSnapshot: { __typename?: 'BlockSnapshot', id: string, content: string, blockName: string | null, answerBlockId: string } | null, referencesBlockSnapshot: { __typename?: 'BlockSnapshot', id: string, content: string, blockName: string | null } | null, fieldOutcomes: Array<{ __typename?: 'FieldOutcome', id: string, identifier: string, fieldRubricId: string, score: number | null, automarkScore: number | null, automarkStatus: AutomarkStatus | null, answer: string | null, answers: Array<string> | null, answerSimilarity: number | null, docContent: string | null, docVersion: number | null, referencesDocContent: string | null, referencesDocVersion: number | null, comments: Array<{ __typename?: 'Comment', id: string }> | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } }>, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, automark: number | null } }>, draftSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, submittedAt: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, markerScope: MarkerScope, score: number | null, markerModifier: number | null, latestForType: boolean, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } } | null, finalSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, submittedAt: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, markerScope: MarkerScope, score: number | null, markerModifier: number | null, latestForType: boolean, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } } | null, submissionOutcomes: Array<{ __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, submittedAt: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, markerScope: MarkerScope, score: number | null, markerModifier: number | null, latestForType: boolean, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } }>, moderationSubmissionOutcomes: Array<{ __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, submittedAt: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, markerScope: MarkerScope, score: number | null, markerModifier: number | null, latestForType: boolean, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> }, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null, feedbackModerationId: string | null, bodyDoc: string | null, referencesDoc: string | null, markerModifier: number | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } | null } | null }>, markingSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, submittedAt: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, markerScope: MarkerScope, score: number | null, markerModifier: number | null, latestForType: boolean, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } } | null, workOutcomeRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, answerBlocks: Array<{ __typename?: 'AnswerBlock', id: string, nodeId: string, blockName: string | null, blockAttachments: Array<{ __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null, insertedAt: string | null, uploadedBy: { __typename?: 'User', id: string, name: string } | null }> }> } | null, groupWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, groupId: string | null, studentId: string | null, maxScore: number, automarkPending: boolean | null, feedbackReleased: boolean, feedbackReleasedTimestamp: string | null, finalScore: number | null, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, questionOutcomes: Array<{ __typename?: 'QuestionOutcome', id: string, questionId: string, blockSnapshot: { __typename?: 'BlockSnapshot', id: string, content: string, blockName: string | null, answerBlockId: string } | null, referencesBlockSnapshot: { __typename?: 'BlockSnapshot', id: string, content: string, blockName: string | null } | null, fieldOutcomes: Array<{ __typename?: 'FieldOutcome', id: string, identifier: string, fieldRubricId: string, score: number | null, automarkScore: number | null, automarkStatus: AutomarkStatus | null, answer: string | null, answers: Array<string> | null, answerSimilarity: number | null, docContent: string | null, docVersion: number | null, referencesDocContent: string | null, referencesDocVersion: number | null, comments: Array<{ __typename?: 'Comment', id: string }> | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } }>, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, automark: number | null } }>, draftSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, submittedAt: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, markerScope: MarkerScope, score: number | null, markerModifier: number | null, latestForType: boolean, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } } | null, finalSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, submittedAt: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, markerScope: MarkerScope, score: number | null, markerModifier: number | null, latestForType: boolean, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } } | null, submissionOutcomes: Array<{ __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, submittedAt: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, markerScope: MarkerScope, score: number | null, markerModifier: number | null, latestForType: boolean, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } }>, moderationSubmissionOutcomes: Array<{ __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, submittedAt: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, markerScope: MarkerScope, score: number | null, markerModifier: number | null, latestForType: boolean, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> }, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null, feedbackModerationId: string | null, bodyDoc: string | null, referencesDoc: string | null, markerModifier: number | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } | null } | null }>, markingSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, submittedAt: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, markerScope: MarkerScope, score: number | null, markerModifier: number | null, latestForType: boolean, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } } | null, workOutcomeRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, answerBlocks: Array<{ __typename?: 'AnswerBlock', id: string, nodeId: string, blockName: string | null, blockAttachments: Array<{ __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null, insertedAt: string | null, uploadedBy: { __typename?: 'User', id: string, name: string } | null }> }> } | null };

export type ClearMarkerAdjustmentMutationVariables = Exact<{
  workId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
}>;


export type ClearMarkerAdjustmentMutation = { __typename?: 'RootMutationType', clearMarkerAdjustment: { __typename?: 'MarkerAdjustmentPayload', studentOutcome: { __typename?: 'StudentOutcome', id: string, studentId: string, modifiers: Array<{ __typename?: 'StudentOutcomeModifier', id: string, type: StudentOutcomeModifierType, component: string, value: any, note: string | null, addedByUserId: string | null, addedAt: string }> } } };

export type CompleteSubmissionOutcomesMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type CompleteSubmissionOutcomesMutation = { __typename?: 'RootMutationType', completeSubmissionOutcomes: { __typename?: 'CompleteSubmissionOutcomesPayload', updatedCount: number, submissionOutcomes: Array<{ __typename?: 'SubmissionOutcome', id: string, completedAt: string | null }> } };

export type ComponentBreakdownFragment = { __typename?: 'ComponentBreakdown', total: { __typename?: 'WeightedScore', score: number | null, maxScore: number, penaltyScore: number, moderatorModifierComponents: number, moderatorModifierStudent: number }, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null };

export type ComponentScoreFragment = { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number };

export type ContributionFieldsFragment = { __typename?: 'Contribution', asOfVersion: number, members: Array<{ __typename?: 'MemberContribution', userId: string, ranges: Array<{ __typename?: 'ContributedRange', from: number, to: number }>, deletions: Array<{ __typename?: 'DeletedContribution', deletedById: string | null, anchor: number, text: string, node: string | null, marks: Array<{ __typename?: 'DeletedMark', type: string, attrs: string | null }>, media: { __typename?: 'DeletedMedia', type: string, src: string | null, width: string | null, customWidth: number | null, imageAlign: string | null } | null }> }> };

export type ContributionQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  bodyAnswerBlockId: Scalars['ID']['input'];
  referencesAnswerBlockId: Scalars['ID']['input'];
  includeReferences: Scalars['Boolean']['input'];
  includeDeletions: Scalars['Boolean']['input'];
  bodyFrom: InputMaybe<Scalars['Int']['input']>;
  bodyTo: InputMaybe<Scalars['Int']['input']>;
}>;


export type ContributionQuery = { __typename?: 'RootQueryType', body: { __typename?: 'Contribution', asOfVersion: number, members: Array<{ __typename?: 'MemberContribution', userId: string, ranges: Array<{ __typename?: 'ContributedRange', from: number, to: number }>, deletions: Array<{ __typename?: 'DeletedContribution', deletedById: string | null, anchor: number, text: string, node: string | null, marks: Array<{ __typename?: 'DeletedMark', type: string, attrs: string | null }>, media: { __typename?: 'DeletedMedia', type: string, src: string | null, width: string | null, customWidth: number | null, imageAlign: string | null } | null }> }> }, references?: { __typename?: 'Contribution', asOfVersion: number, members: Array<{ __typename?: 'MemberContribution', userId: string, ranges: Array<{ __typename?: 'ContributedRange', from: number, to: number }>, deletions: Array<{ __typename?: 'DeletedContribution', deletedById: string | null, anchor: number, text: string, node: string | null, marks: Array<{ __typename?: 'DeletedMark', type: string, attrs: string | null }>, media: { __typename?: 'DeletedMedia', type: string, src: string | null, width: string | null, customWidth: number | null, imageAlign: string | null } | null }> }> } };

export type CreateSkillMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  input: CreateSkillInput;
}>;


export type CreateSkillMutation = { __typename?: 'RootMutationType', createSkill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } };

export type CreateSmartCommentMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  input: CreateSmartCommentInput;
}>;


export type CreateSmartCommentMutation = { __typename?: 'RootMutationType', createSmartComment: { __typename?: 'SmartComment', id: string } };

export type CreateSubmissionOutcomeMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  workOutcomeId: Scalars['ID']['input'];
  markerScope: MarkerScopeInput;
}>;


export type CreateSubmissionOutcomeMutation = { __typename?: 'RootMutationType', createSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string } };

export type CreateThreadMutationVariables = Exact<{
  threadId: Scalars['ID']['input'];
  input: ThreadInput;
}>;


export type CreateThreadMutation = { __typename?: 'RootMutationType', createThread: { __typename?: 'Thread', id: string, title: string | null, entityType: EntityType | null, entityId: string | null, criterionId: string | null, insertedAt: string, createdBy: { __typename?: 'User', id: string }, metadata: { __typename?: 'Metadata', charterSectionType: CharterSectionType | null, charterEditorId: string | null, blockAttachmentId: number | null, blockAttachmentName: string | null } | null, comments: Array<{ __typename?: 'Comment', id: string, content: string, updatedAt: string, smartCommentId: string | null, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> } };

export type CriteriaBySkillQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  skillId: Scalars['ID']['input'];
}>;


export type CriteriaBySkillQuery = { __typename?: 'RootQueryType', criteriaBySkill: Array<{ __typename?: 'ReuseCriterion', assessmentName: string, color: string | null, description: string | null, kind: MarkerRubricKind, maxScore: number | null, publishedAt: string, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string }, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> };

export type CriterionFragment = { __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, hasOutcomes: boolean, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> };

export type CriterionOutcomeFragment = { __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null };

export type DeleteSmartCommentMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  smartCommentId: Scalars['ID']['input'];
}>;


export type DeleteSmartCommentMutation = { __typename?: 'RootMutationType', deleteSmartComment: { __typename?: 'SmartComment', id: string } | null };

export type DeleteThreadMutationVariables = Exact<{
  threadId: Scalars['ID']['input'];
}>;


export type DeleteThreadMutation = { __typename?: 'RootMutationType', deleteThread: { __typename?: 'Thread', id: string } };

export type DeletedAnswerBlockQueryVariables = Exact<{
  answerBlockId: Scalars['ID']['input'];
}>;


export type DeletedAnswerBlockQuery = { __typename?: 'RootQueryType', deletedAnswerBlock: { __typename?: 'AnswerBlock', id: string, blockName: string | null, latestBlockSnapshot: { __typename?: 'BlockSnapshot', id: string, content: string, blockName: string | null } | null } | null };

export type DocumentBaseQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  answerBlockId: Scalars['ID']['input'];
}>;


export type DocumentBaseQuery = { __typename?: 'RootQueryType', documentBase: { __typename?: 'DocumentBase', baseDoc: string } };

export type DocumentWindowQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  answerBlockId: Scalars['ID']['input'];
  targetVersion: Scalars['Int']['input'];
  haveSnapshotVersion: InputMaybe<Scalars['Int']['input']>;
  buffer: InputMaybe<Scalars['Int']['input']>;
}>;


export type DocumentWindowQuery = { __typename?: 'RootQueryType', documentWindow: { __typename?: 'DocumentWindow', baseVersion: number, document: string | null, steps: Array<{ __typename?: 'DocumentStep', version: number, data: string, userId: string | null }> } };

export type DownloadWorkAttachmentsMutationVariables = Exact<{
  answerBlockId: Scalars['ID']['input'];
  blockAttachmentIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DownloadWorkAttachmentsMutation = { __typename?: 'RootMutationType', downloadWorkAttachments: string };

export type EditCommentMutationVariables = Exact<{
  commentId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
}>;


export type EditCommentMutation = { __typename?: 'RootMutationType', editComment: { __typename?: 'Comment', id: string, content: string, updatedAt: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } } };

export type EditThreadTitleMutationVariables = Exact<{
  threadId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
}>;


export type EditThreadTitleMutation = { __typename?: 'RootMutationType', editThreadTitle: { __typename?: 'Thread', id: string, title: string | null } };

export type EntityThreadEventFragment = { __typename?: 'EntityThreadEvent', eventType: EntityThreadEventType, threadId: string, status: ThreadStatus, entityId: string | null, entityType: EntityType | null, resolvedAt: string | null, criterionId: string | null, resolvedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null };

export type EntityThreadsQueryVariables = Exact<{
  entityType: EntityType;
  entityIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type EntityThreadsQuery = { __typename?: 'RootQueryType', entityThreads: Array<{ __typename?: 'Thread', id: string, title: string | null, entityType: EntityType | null, entityId: string | null, criterionId: string | null, insertedAt: string, createdBy: { __typename?: 'User', id: string }, metadata: { __typename?: 'Metadata', charterSectionType: CharterSectionType | null, charterEditorId: string | null, blockAttachmentId: number | null, blockAttachmentName: string | null } | null, comments: Array<{ __typename?: 'Comment', id: string, content: string, updatedAt: string, smartCommentId: string | null, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> };

export type OnEntityThreadsUpdatedSubscriptionVariables = Exact<{
  entityId: Scalars['ID']['input'];
  entityType: EntityType;
}>;


export type OnEntityThreadsUpdatedSubscription = { __typename?: 'RootSubscriptionType', entityThreadsUpdated: { __typename?: 'EntityThreadEvent', eventType: EntityThreadEventType, threadId: string, status: ThreadStatus, entityId: string | null, entityType: EntityType | null, resolvedAt: string | null, criterionId: string | null, resolvedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } };

export type FeedbackReleaseRuleFragment = { __typename?: 'FeedbackReleaseRule', id: string, basePool: FeedbackReleaseBasePool, excludedStudentIds: Array<string>, excludedTags: Array<string>, executedAt: string | null, includedStudentIds: Array<string>, scheduledAt: string | null, executedStudentIds: Array<string> | null, ruleKind: ReleaseRuleKind, includedGroupIds: Array<string>, releaseType: FeedbackReleaseType };

export type FeedbackVisibilityFragment = { __typename?: 'FeedbackVisibility', id: string, feedbackViewLevel: FeedbackLevel, withFeedbackPdf: boolean, notifyStudents: boolean, showPeerScores: boolean, showPeerComments: boolean, jointRelease: boolean, releaseType: FeedbackReleaseType };

export type FieldOutcomeFragment = { __typename?: 'FieldOutcome', id: string, identifier: string, fieldRubricId: string, score: number | null, automarkScore: number | null, automarkStatus: AutomarkStatus | null, answer: string | null, answers: Array<string> | null, answerSimilarity: number | null, docContent: string | null, docVersion: number | null, referencesDocContent: string | null, referencesDocVersion: number | null, comments: Array<{ __typename?: 'Comment', id: string }> | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } };

export type FieldOutcomeScoreFragment = { __typename?: 'FieldOutcome', id: string, identifier: string, fieldRubricId: string, score: number | null, markerScore: number | null, automarkScore: number | null };

export type FieldResponseFragment = { __typename?: 'FieldResponse', answer: string | null, answers: Array<string> | null, count: number, isCorrect: boolean, similarity: number | null };

export type FieldRubricChangesFragment = { __typename?: 'FieldRubricChanges', id: string, valuesAdded: Array<string>, valuesRemoved: Array<string> };

export type FieldRubricFragment = { __typename?: 'FieldRubric', id: string, identifier: string, baseType: BaseType | null, values: Array<string> | null, automarked: boolean, strategy: MatchStrategy | null, similarity: number | null, errorMargin: number | null, caseSensitive: boolean, partialScoring: boolean, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }> | null, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> | null, markerChanges: { __typename?: 'FieldRubricChanges', id: string, valuesAdded: Array<string>, valuesRemoved: Array<string> } | null, moderatorChanges: { __typename?: 'FieldRubricChanges', id: string, valuesAdded: Array<string>, valuesRemoved: Array<string> } | null, markerRubric: { __typename?: 'MarkerRubric', id: string, assessmentId: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, hasChanges: boolean, state: MarkerRubricState, updatedAt: string | null, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, hasOutcomes: boolean, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null };

export type FieldRubricResponseFragment = { __typename?: 'FieldRubric', id: string, identifier: string, responses: Array<{ __typename?: 'FieldResponse', answer: string | null, answers: Array<string> | null, count: number, isCorrect: boolean, similarity: number | null }> };

export type GenerateWorkOutcomesCsvMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  byQuestions: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GenerateWorkOutcomesCsvMutation = { __typename?: 'RootMutationType', generateWorkOutcomesCsv: string };

export type GradebookReceiptFragment = { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean };

export type GraderRouteQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type GraderRouteQuery = { __typename?: 'RootQueryType', token: string, me: { __typename?: 'User', id: string }, workOutcomes: Array<{ __typename?: 'WorkOutcome', id: string, workId: string, groupId: string | null, studentId: string | null, maxScore: number, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } }>, assessment: { __typename?: 'Assessment', id: string, name: string, subjectName: string, subjectId: string, dueDate: string | null, gradingDueDate: string | null, startDate: string | null, endDate: string | null, edition: number, subject: { __typename?: 'Subject', id: string, discipline: Discipline | null, name: string, label: string | null }, ltiTool: { __typename?: 'InstitutionTool', id: string, name: string | null, familyCode: string | null }, ltiServices: Array<{ __typename?: 'LtiService', id: string, name: string, version: string, issuer: string | null, metaUrl: string | null, isLtiPluginAgs: boolean }>, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, groupDraftDueDate: string | null, groupDraftEnabled: boolean, individualDraftFeedbackAlwaysAvailable: boolean, groupDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, submitAttemptLimit: number | null, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, rubricDisplayDisabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, examReentryPreventionEnabled: boolean, examInactivityTimeout: number | null, examSchoolyearEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckSkipEnabled: boolean, sentimentCheckIntervalInHr: number | null, sentimentCheckFirstCheckAt: string | null, sentimentCheckScheduleType: SentimentCheckScheduleType, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, peerEvaluationMode: PeerEvaluationMode, peerEvaluationMinScaleFactor: number, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMode: SelfEvaluationMode, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterAcceptanceRequired: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, vivaEnabled: boolean, vivaReattemptWindowTime: number | null, vivaCameraRequiredDisabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, sentimentCheckSchedules: Array<{ __typename?: 'SentimentCheckSchedule', id: string, scheduledAt: string }> | null, vivaSourceTask: { __typename?: 'VivaSourceTask', id: string, assessmentId: string, name: string } | null } | null, ltiCustomParams: { __typename?: 'CustomParams', moodleAttemptReopenMethod: string | null } | null, schoolyearExam: { __typename?: 'SchoolyearExam', id: string, pushStatus: SchoolyearExamPushStatus } | null }, individualSheet: { __typename?: 'Sheet', id: string, serverId: string, format: TaskFormat, releaseTimestamp: string, questionBlocks: Array<{ __typename?: 'QuestionBlock', nodeId: string, parentNodeId: string | null, nodeType: QuestionTreeNodeType, order: number, shortLabel: string | null, longLabel: string | null, shuffle: boolean | null, points: number | null, socraticQuestionerEnabled: boolean, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null }> } | null, rubric: { __typename?: 'Rubric', id: string, questions: Array<{ __typename?: 'QuestionRubric', id: string, questionId: string, maxScore: number, fieldRubrics: Array<{ __typename?: 'FieldRubric', id: string, identifier: string, baseType: BaseType | null, values: Array<string> | null, automarked: boolean, strategy: MatchStrategy | null, similarity: number | null, errorMargin: number | null, caseSensitive: boolean, partialScoring: boolean, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }> | null, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> | null, markerChanges: { __typename?: 'FieldRubricChanges', id: string, valuesAdded: Array<string>, valuesRemoved: Array<string> } | null, moderatorChanges: { __typename?: 'FieldRubricChanges', id: string, valuesAdded: Array<string>, valuesRemoved: Array<string> } | null, markerRubric: { __typename?: 'MarkerRubric', id: string, assessmentId: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, hasChanges: boolean, state: MarkerRubricState, updatedAt: string | null, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, hasOutcomes: boolean, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null }> }> } | null, class: { __typename?: 'Class', groupType: GroupType, students: Array<{ __typename?: 'Enrollment', id: string, sectionId: string | null, syncedAt: string | null, deleted: boolean, sisUserId: string | null, reentryCount: number, anonymousIndex: number | null, deletedBy: { __typename?: 'User', id: string, name: string } | null, user: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }, work: { __typename?: 'Work', id: string, startDate: string | null, updatedAt: string | null, lastSaveTime: string | null, attemptCount: number, finalResult: { __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number, memberSummaries: Array<{ __typename?: 'MemberSummary', lastAccess: string, accessCount: number, userId: string }> } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null } | null, draftResult: { __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number, memberSummaries: Array<{ __typename?: 'MemberSummary', lastAccess: string, accessCount: number, userId: string }> } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null } | null, features: { __typename?: 'WorkFeatures', id: string, enableWorkAuthority: boolean } } | null, tags: Array<{ __typename?: 'Tag', id: string, text: string, column: number, tab: ClassTab }>, workSettings: { __typename?: 'WorkSettings', id: string, studentId: string | null, dueDate: string | null, timeLimit: number | null, examReadingTime: number | null, examWritingTime: number | null, examStartDate: string | null, examEndDate: string | null, examDeferred: boolean | null, submitAttemptLimit: number | null, updatedAt: string | null, updateReason: string | null, draftExamStartDate: string | null, draftExamEndDate: string | null, groupId: string | null, vivaExtraAttempts: number | null, lastUpdatedBy: { __typename?: 'User', id: string, name: string } | null } | null, accessCode: { __typename?: 'AccessCode', code: string, label: string | null, active: boolean, type: AccessCodeType } | null, verifiedCodes: Array<{ __typename?: 'VerifiedCode', label: string | null, insertedAt: string | null }> | null }>, groups: Array<{ __typename?: 'Group', id: string, name: string, markerId: string | null, code: string | null, sectionId: string | null, questionId: string | null, maxLimit: number | null, minLimit: number | null, finalised: boolean, finalisedAt: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, members: Array<{ __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }>, groupMembers: Array<{ __typename?: 'GroupMember', id: string, colourset: number, user: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, groupMarkers: Array<{ __typename?: 'GroupMarker', id: string, role: MarkerRole, markerPlaceholder: string | null, groupMemberId: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null }> }>, tags: Array<{ __typename?: 'GroupTag', id: string, text: string }>, workSettings: { __typename?: 'WorkSettings', id: string, dueDate: string | null, groupId: string | null } | null }> } };

export type GroupPeerOutcomesQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  groupId: Scalars['ID']['input'];
}>;


export type GroupPeerOutcomesQuery = { __typename?: 'RootQueryType', groupPeerOutcomes: Array<{ __typename?: 'PeerOutcome', id: string, targetUserId: string, selfScore: number | null, selfMaxScore: number | null, peerScore: number | null, peerMaxScore: number | null, isComplete: boolean | null, hasEvaluatedAllPeers: boolean | null, hasReceivedAllEvaluations: boolean | null, hasCompletedSelfEvaluation: boolean | null, feedbackReleasedTimestamp: string | null, evaluationsSubmittedAt: string | null, groupReportScaleFactor: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> }> };

export type ImportSmartCommentsMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  comments: Array<ImportSmartCommentInput> | ImportSmartCommentInput;
}>;


export type ImportSmartCommentsMutation = { __typename?: 'RootMutationType', importSmartComments: { __typename?: 'ImportSmartCommentsResult', skippedDuplicates: Array<string>, smartComments: Array<{ __typename?: 'SmartComment', id: string, assessmentId: string | null, content: string, lastUsed: string | null, score: number }> } };

export type LearningOutcomeSkillFragment = { __typename?: 'LearningOutcomeSkill', id: string, skill: string };

export type LinkCommentThreadMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  threadId: Scalars['ID']['input'];
  criterionId: Scalars['Int']['input'];
}>;


export type LinkCommentThreadMutation = { __typename?: 'RootMutationType', linkCommentThread: { __typename?: 'Thread', id: string, title: string | null, entityType: EntityType | null, entityId: string | null, criterionId: string | null, createdBy: { __typename?: 'User', id: string }, metadata: { __typename?: 'Metadata', charterSectionType: CharterSectionType | null, charterEditorId: string | null } | null, comments: Array<{ __typename?: 'Comment', id: string, content: string, updatedAt: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> } };

export type MarkEnrollmentFragment = { __typename?: 'Enrollment', id: string, anonymousIndex: number | null, user: { __typename?: 'User', id: string, name: string } };

export type MarkFieldOutcomeMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  input: MarkFieldOutcomeInput;
}>;


export type MarkFieldOutcomeMutation = { __typename?: 'RootMutationType', markFieldOutcome: { __typename?: 'MarkFieldOutcomePayload', fieldOutcome: { __typename?: 'FieldOutcome', id: string, score: number | null, markerScore: number | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } }, questionOutcome: { __typename?: 'QuestionOutcome', id: string, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } }, workOutcome: { __typename?: 'WorkOutcome', id: string, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } } } };

export type MfaMarkingQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
}>;


export type MfaMarkingQuery = { __typename?: 'RootQueryType', studentWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, groupId: string | null, studentId: string | null, maxScore: number, automarkPending: boolean | null, feedbackReleased: boolean, feedbackReleasedTimestamp: string | null, finalScore: number | null, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, questionOutcomes: Array<{ __typename?: 'QuestionOutcome', id: string, questionId: string, blockSnapshot: { __typename?: 'BlockSnapshot', id: string, content: string, blockName: string | null, answerBlockId: string } | null, referencesBlockSnapshot: { __typename?: 'BlockSnapshot', id: string, content: string, blockName: string | null } | null, fieldOutcomes: Array<{ __typename?: 'FieldOutcome', id: string, identifier: string, fieldRubricId: string, score: number | null, automarkScore: number | null, automarkStatus: AutomarkStatus | null, answer: string | null, answers: Array<string> | null, answerSimilarity: number | null, docContent: string | null, docVersion: number | null, referencesDocContent: string | null, referencesDocVersion: number | null, comments: Array<{ __typename?: 'Comment', id: string }> | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } }>, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, automark: number | null } }>, draftSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, submittedAt: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, markerScope: MarkerScope, score: number | null, markerModifier: number | null, latestForType: boolean, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } } | null, finalSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, submittedAt: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, markerScope: MarkerScope, score: number | null, markerModifier: number | null, latestForType: boolean, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } } | null, submissionOutcomes: Array<{ __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, submittedAt: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, markerScope: MarkerScope, score: number | null, markerModifier: number | null, latestForType: boolean, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } }>, moderationSubmissionOutcomes: Array<{ __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, submittedAt: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, markerScope: MarkerScope, score: number | null, markerModifier: number | null, latestForType: boolean, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> }, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null, feedbackModerationId: string | null, bodyDoc: string | null, referencesDoc: string | null, markerModifier: number | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } | null } | null }>, markingSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, submittedAt: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, markerScope: MarkerScope, score: number | null, markerModifier: number | null, latestForType: boolean, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } } | null, workOutcomeRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, answerBlocks: Array<{ __typename?: 'AnswerBlock', id: string, nodeId: string, blockName: string | null, blockAttachments: Array<{ __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null, insertedAt: string | null, uploadedBy: { __typename?: 'User', id: string, name: string } | null }> }> } | null, featureFlags: { __typename?: 'InstitutionFeatures', id: string, accessCode: boolean, exams: boolean, respondusLdb: boolean, moodleGrader: boolean, multiformat: boolean, turnitin: boolean, turnitinGrader: boolean, cadmusGrader: boolean, groupAssessment: boolean, genAiDeclaration: boolean, extensionSyncing: boolean, advancedMarking: boolean, timeline: boolean, adminAccess: boolean, viva: boolean, labsContextualiser: boolean, schoolyear: boolean } };

export type MarkRouteQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type MarkRouteQuery = { __typename?: 'RootQueryType', token: string, me: { __typename?: 'User', id: string, email: string | null }, assessment: { __typename?: 'Assessment', id: string, name: string, subjectName: string, subjectId: string, dueDate: string | null, gradingDueDate: string | null, startDate: string | null, endDate: string | null, edition: number, tasks: Array<{ __typename?: 'Task', id: string, kind: TaskKind, instructionSheet: { __typename?: 'Sheet', id: string, serverId: string, format: TaskFormat, releaseTimestamp: string, questionBlocks: Array<{ __typename?: 'QuestionBlock', nodeId: string, parentNodeId: string | null, nodeType: QuestionTreeNodeType, order: number, shortLabel: string | null, longLabel: string | null, shuffle: boolean | null, points: number | null, socraticQuestionerEnabled: boolean, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null }> } | null }>, subject: { __typename?: 'Subject', id: string, discipline: Discipline | null, name: string, label: string | null }, ltiTool: { __typename?: 'InstitutionTool', id: string, name: string | null, familyCode: string | null }, ltiServices: Array<{ __typename?: 'LtiService', id: string, name: string, version: string, issuer: string | null, metaUrl: string | null, isLtiPluginAgs: boolean }>, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, groupDraftDueDate: string | null, groupDraftEnabled: boolean, individualDraftFeedbackAlwaysAvailable: boolean, groupDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, submitAttemptLimit: number | null, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, rubricDisplayDisabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, examReentryPreventionEnabled: boolean, examInactivityTimeout: number | null, examSchoolyearEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckSkipEnabled: boolean, sentimentCheckIntervalInHr: number | null, sentimentCheckFirstCheckAt: string | null, sentimentCheckScheduleType: SentimentCheckScheduleType, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, peerEvaluationMode: PeerEvaluationMode, peerEvaluationMinScaleFactor: number, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMode: SelfEvaluationMode, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterAcceptanceRequired: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, vivaEnabled: boolean, vivaReattemptWindowTime: number | null, vivaCameraRequiredDisabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, sentimentCheckSchedules: Array<{ __typename?: 'SentimentCheckSchedule', id: string, scheduledAt: string }> | null, vivaSourceTask: { __typename?: 'VivaSourceTask', id: string, assessmentId: string, name: string } | null } | null, ltiCustomParams: { __typename?: 'CustomParams', moodleAttemptReopenMethod: string | null } | null, schoolyearExam: { __typename?: 'SchoolyearExam', id: string, pushStatus: SchoolyearExamPushStatus } | null }, class: { __typename?: 'Class', groupType: GroupType, groups: Array<{ __typename?: 'Group', id: string, name: string, markerId: string | null, code: string | null, sectionId: string | null, questionId: string | null, maxLimit: number | null, minLimit: number | null, finalised: boolean, finalisedAt: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, members: Array<{ __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }>, groupMembers: Array<{ __typename?: 'GroupMember', id: string, colourset: number, user: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, groupMarkers: Array<{ __typename?: 'GroupMarker', id: string, role: MarkerRole, markerPlaceholder: string | null, groupMemberId: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null }> }>, tags: Array<{ __typename?: 'GroupTag', id: string, text: string }>, workSettings: { __typename?: 'WorkSettings', id: string, dueDate: string | null, groupId: string | null } | null }>, students: Array<{ __typename?: 'Enrollment', id: string, anonymousIndex: number | null, user: { __typename?: 'User', id: string, name: string } }> }, workOutcomes: Array<{ __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, finalSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string } | null, markingSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string } | null }>, rubric: { __typename?: 'Rubric', id: string, questions: Array<{ __typename?: 'QuestionRubric', id: string, questionId: string, maxScore: number, counts: { __typename?: 'QuestionResponseCounts', responseCount: number, successCount: number, averageScore: number | null }, fieldRubrics: Array<{ __typename?: 'FieldRubric', id: string, identifier: string, baseType: BaseType | null, values: Array<string> | null, automarked: boolean, strategy: MatchStrategy | null, similarity: number | null, errorMargin: number | null, caseSensitive: boolean, partialScoring: boolean, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }> | null, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> | null, markerChanges: { __typename?: 'FieldRubricChanges', id: string, valuesAdded: Array<string>, valuesRemoved: Array<string> } | null, moderatorChanges: { __typename?: 'FieldRubricChanges', id: string, valuesAdded: Array<string>, valuesRemoved: Array<string> } | null, markerRubric: { __typename?: 'MarkerRubric', id: string, assessmentId: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, hasChanges: boolean, state: MarkerRubricState, updatedAt: string | null, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, hasOutcomes: boolean, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null }> }> } | null };

export type MarkSubmissionOutcomeMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  input: MarkSubmissionOutcomeInput;
}>;


export type MarkSubmissionOutcomeMutation = { __typename?: 'RootMutationType', markSubmissionOutcome: { __typename?: 'MarkSubmissionOutcomePayload', submissionOutcome: { __typename?: 'SubmissionOutcome', id: string, score: number | null, markerModifier: number | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } }, workOutcome: { __typename?: 'WorkOutcome', id: string, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } } } };

export type MarkerRubricByIdQueryVariables = Exact<{
  markerRubricId: Scalars['ID']['input'];
}>;


export type MarkerRubricByIdQuery = { __typename?: 'RootQueryType', markerRubricById: { __typename?: 'MarkerRubric', id: string, assessmentId: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, hasChanges: boolean, state: MarkerRubricState, updatedAt: string | null, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, hasOutcomes: boolean, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } };

export type MarkerRubricFragment = { __typename?: 'MarkerRubric', id: string, assessmentId: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, hasChanges: boolean, state: MarkerRubricState, updatedAt: string | null, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, hasOutcomes: boolean, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> };

export type MarkerRubricQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  kind: MarkerRubricKind;
  status: MarkerRubricStatus;
}>;


export type MarkerRubricQuery = { __typename?: 'RootQueryType', markerRubric: { __typename?: 'MarkerRubric', id: string, assessmentId: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, hasChanges: boolean, state: MarkerRubricState, updatedAt: string | null, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, hasOutcomes: boolean, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null };

export type MarkingSheetFragment = { __typename?: 'Sheet', id: string, serverId: string, format: TaskFormat, releaseTimestamp: string, questionBlocks: Array<{ __typename?: 'QuestionBlock', nodeId: string, parentNodeId: string | null, nodeType: QuestionTreeNodeType, order: number, shortLabel: string | null, longLabel: string | null, shuffle: boolean | null, points: number | null, socraticQuestionerEnabled: boolean, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null }> };

export type ModerationPenaltyRuleFragment = { __typename?: 'ModerationPenaltyRule', canStack: boolean, excludedStudentIds: Array<string> | null, includedTags: Array<string> | null, id: string, minutesLateBy: number | null, penaltyScore: number, scoreUnit: PenaltyScoreUnit, penaltyType: ModerationPenaltyType, reason: string | null, formatUnit: PenaltyFormatUnit | null, ruleKind: PenaltyRuleKind, includedGroupIds: Array<string> };

export type ModerationQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type ModerationQuery = { __typename?: 'RootQueryType', token: string, me: { __typename?: 'User', id: string }, assessment: { __typename?: 'Assessment', id: string, name: string, subjectName: string, subjectId: string, dueDate: string | null, gradingDueDate: string | null, startDate: string | null, endDate: string | null, edition: number, tasks: Array<{ __typename?: 'Task', id: string, kind: TaskKind, instructionSheet: { __typename?: 'Sheet', id: string, serverId: string, format: TaskFormat, releaseTimestamp: string, questionBlocks: Array<{ __typename?: 'QuestionBlock', nodeId: string, parentNodeId: string | null, nodeType: QuestionTreeNodeType, order: number, shortLabel: string | null, longLabel: string | null, shuffle: boolean | null, points: number | null, socraticQuestionerEnabled: boolean, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null }> } | null }>, subject: { __typename?: 'Subject', id: string, discipline: Discipline | null, name: string, label: string | null }, ltiTool: { __typename?: 'InstitutionTool', id: string, name: string | null, familyCode: string | null }, ltiServices: Array<{ __typename?: 'LtiService', id: string, name: string, version: string, issuer: string | null, metaUrl: string | null, isLtiPluginAgs: boolean }>, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, groupDraftDueDate: string | null, groupDraftEnabled: boolean, individualDraftFeedbackAlwaysAvailable: boolean, groupDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, submitAttemptLimit: number | null, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, rubricDisplayDisabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, examReentryPreventionEnabled: boolean, examInactivityTimeout: number | null, examSchoolyearEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckSkipEnabled: boolean, sentimentCheckIntervalInHr: number | null, sentimentCheckFirstCheckAt: string | null, sentimentCheckScheduleType: SentimentCheckScheduleType, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, peerEvaluationMode: PeerEvaluationMode, peerEvaluationMinScaleFactor: number, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMode: SelfEvaluationMode, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterAcceptanceRequired: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, vivaEnabled: boolean, vivaReattemptWindowTime: number | null, vivaCameraRequiredDisabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, sentimentCheckSchedules: Array<{ __typename?: 'SentimentCheckSchedule', id: string, scheduledAt: string }> | null, vivaSourceTask: { __typename?: 'VivaSourceTask', id: string, assessmentId: string, name: string } | null } | null, ltiCustomParams: { __typename?: 'CustomParams', moodleAttemptReopenMethod: string | null } | null, schoolyearExam: { __typename?: 'SchoolyearExam', id: string, pushStatus: SchoolyearExamPushStatus } | null }, class: { __typename?: 'Class', groupType: GroupType, groups: Array<{ __typename?: 'Group', id: string, name: string, markerId: string | null, code: string | null, sectionId: string | null, questionId: string | null, maxLimit: number | null, minLimit: number | null, finalised: boolean, finalisedAt: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, members: Array<{ __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }>, groupMembers: Array<{ __typename?: 'GroupMember', id: string, colourset: number, user: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, groupMarkers: Array<{ __typename?: 'GroupMarker', id: string, role: MarkerRole, markerPlaceholder: string | null, groupMemberId: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null }> }>, tags: Array<{ __typename?: 'GroupTag', id: string, text: string }>, workSettings: { __typename?: 'WorkSettings', id: string, dueDate: string | null, groupId: string | null } | null }>, students: Array<{ __typename?: 'Enrollment', id: string, sectionId: string | null, syncedAt: string | null, deleted: boolean, sisUserId: string | null, reentryCount: number, anonymousIndex: number | null, deletedBy: { __typename?: 'User', id: string, name: string } | null, user: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }, work: { __typename?: 'Work', id: string, startDate: string | null, updatedAt: string | null, lastSaveTime: string | null, attemptCount: number, finalResult: { __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number, memberSummaries: Array<{ __typename?: 'MemberSummary', lastAccess: string, accessCount: number, userId: string }> } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null } | null, draftResult: { __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number, memberSummaries: Array<{ __typename?: 'MemberSummary', lastAccess: string, accessCount: number, userId: string }> } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null } | null, features: { __typename?: 'WorkFeatures', id: string, enableWorkAuthority: boolean } } | null, tags: Array<{ __typename?: 'Tag', id: string, text: string, column: number, tab: ClassTab }>, workSettings: { __typename?: 'WorkSettings', id: string, studentId: string | null, dueDate: string | null, timeLimit: number | null, examReadingTime: number | null, examWritingTime: number | null, examStartDate: string | null, examEndDate: string | null, examDeferred: boolean | null, submitAttemptLimit: number | null, updatedAt: string | null, updateReason: string | null, draftExamStartDate: string | null, draftExamEndDate: string | null, groupId: string | null, vivaExtraAttempts: number | null, lastUpdatedBy: { __typename?: 'User', id: string, name: string } | null } | null, accessCode: { __typename?: 'AccessCode', code: string, label: string | null, active: boolean, type: AccessCodeType } | null, verifiedCodes: Array<{ __typename?: 'VerifiedCode', label: string | null, insertedAt: string | null }> | null }> }, classWorkGroups: Array<{ __typename?: 'WorkGroup', id: string, group: { __typename?: 'Group', id: string, name: string, markerId: string | null, code: string | null, sectionId: string | null, questionId: string | null, maxLimit: number | null, minLimit: number | null, finalised: boolean, finalisedAt: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, members: Array<{ __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }>, groupMembers: Array<{ __typename?: 'GroupMember', id: string, colourset: number, user: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, groupMarkers: Array<{ __typename?: 'GroupMarker', id: string, role: MarkerRole, markerPlaceholder: string | null, groupMemberId: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null }> }>, tags: Array<{ __typename?: 'GroupTag', id: string, text: string }>, workSettings: { __typename?: 'WorkSettings', id: string, dueDate: string | null, groupId: string | null } | null }, work: { __typename?: 'Work', id: string, startDate: string | null, updatedAt: string | null, lastSaveTime: string | null, attemptCount: number, finalResult: { __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number, memberSummaries: Array<{ __typename?: 'MemberSummary', lastAccess: string, accessCount: number, userId: string }> } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null } | null, draftResult: { __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number, memberSummaries: Array<{ __typename?: 'MemberSummary', lastAccess: string, accessCount: number, userId: string }> } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null } | null, features: { __typename?: 'WorkFeatures', id: string, enableWorkAuthority: boolean } } | null }>, feedbackReleaseRules: Array<{ __typename?: 'FeedbackReleaseRule', id: string, basePool: FeedbackReleaseBasePool, excludedStudentIds: Array<string>, excludedTags: Array<string>, executedAt: string | null, includedStudentIds: Array<string>, scheduledAt: string | null, executedStudentIds: Array<string> | null, ruleKind: ReleaseRuleKind, includedGroupIds: Array<string>, releaseType: FeedbackReleaseType }>, moderationPenaltyRules: Array<{ __typename?: 'ModerationPenaltyRule', canStack: boolean, excludedStudentIds: Array<string> | null, includedTags: Array<string> | null, id: string, minutesLateBy: number | null, penaltyScore: number, scoreUnit: PenaltyScoreUnit, penaltyType: ModerationPenaltyType, reason: string | null, formatUnit: PenaltyFormatUnit | null, ruleKind: PenaltyRuleKind, includedGroupIds: Array<string> }> | null, finalFeedbackVisibility: { __typename?: 'FeedbackVisibility', id: string, feedbackViewLevel: FeedbackLevel, withFeedbackPdf: boolean, notifyStudents: boolean, showPeerScores: boolean, showPeerComments: boolean, jointRelease: boolean, releaseType: FeedbackReleaseType }, provisionalFeedbackVisibility: { __typename?: 'FeedbackVisibility', id: string, feedbackViewLevel: FeedbackLevel, withFeedbackPdf: boolean, notifyStudents: boolean, showPeerScores: boolean, showPeerComments: boolean, jointRelease: boolean, releaseType: FeedbackReleaseType }, studentOutcomes: Array<{ __typename?: 'StudentOutcome', id: string, studentId: string, moderatorModifier: number | null, peerOutcome: { __typename?: 'PeerOutcome', id: string, targetUserId: string, selfScore: number | null, selfMaxScore: number | null, peerScore: number | null, peerMaxScore: number | null, isComplete: boolean | null, hasEvaluatedAllPeers: boolean | null, hasReceivedAllEvaluations: boolean | null, hasCompletedSelfEvaluation: boolean | null, feedbackReleasedTimestamp: string | null, evaluationsSubmittedAt: string | null, groupReportScaleFactor: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } | null, groupWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, assessmentId: string, finalScore: number | null, maxScore: number, automarkPending: boolean | null, feedbackReleasedTimestamp: string | null, finalScorePenalty: number | null, questionOutcomesScored: boolean, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, provisionalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, finalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, moderationSubmissionOutcomes: Array<{ __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, markerScope: MarkerScope, score: number | null, markerModifier: number | null, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, flagReason: string | null, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null } | null }>, markingSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, markerScope: MarkerScope, score: number | null, markerModifier: number | null, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, flagReason: string | null, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null } | null } | null, draftSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, score: number | null } | null } | null, individualWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, assessmentId: string, finalScore: number | null, maxScore: number, automarkPending: boolean | null, feedbackReleasedTimestamp: string | null, finalScorePenalty: number | null, questionOutcomesScored: boolean, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, provisionalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, finalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, moderationSubmissionOutcomes: Array<{ __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, markerScope: MarkerScope, score: number | null, markerModifier: number | null, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, flagReason: string | null, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null } | null }>, markingSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, markerScope: MarkerScope, score: number | null, markerModifier: number | null, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, flagReason: string | null, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null } | null } | null, draftSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, score: number | null } | null } | null, modifiers: Array<{ __typename?: 'StudentOutcomeModifier', id: string, type: StudentOutcomeModifierType, component: string, value: any }>, base: { __typename?: 'ComponentBreakdown', total: { __typename?: 'WeightedScore', score: number | null, maxScore: number, penaltyScore: number, moderatorModifierComponents: number, moderatorModifierStudent: number }, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null }, provisional: { __typename?: 'ComponentBreakdown', total: { __typename?: 'WeightedScore', score: number | null, maxScore: number, penaltyScore: number, moderatorModifierComponents: number, moderatorModifierStudent: number }, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null }, final: { __typename?: 'ComponentBreakdown', total: { __typename?: 'WeightedScore', score: number | null, maxScore: number, penaltyScore: number, moderatorModifierComponents: number, moderatorModifierStudent: number }, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null } }>, peerRubric: { __typename?: 'MarkerRubric', id: string, assessmentId: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, hasChanges: boolean, state: MarkerRubricState, updatedAt: string | null, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, hasOutcomes: boolean, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null };

export type ModerationQuestionFragment = { __typename?: 'ModerationQuestion', id: string, nodeId: string, parentNodeId: string | null, questionId: string, questionType: QuestionType, shortPrompt: string | null, shortLabel: string | null, longLabel: string | null, order: number, maxScore: number | null, score: number | null, automarked: boolean, answerable: boolean | null, hasMarkerChanges: boolean, rates: { __typename?: 'QuestionRates', responseRate: number, successRate: number | null, averageScore: number | null } | null, rubric: { __typename?: 'QuestionRubric', id: string, questionId: string, maxScore: number, counts: { __typename?: 'QuestionResponseCounts', responseCount: number, successCount: number, averageScore: number | null }, fieldRubrics: Array<{ __typename?: 'FieldRubric', id: string, identifier: string, baseType: BaseType | null, values: Array<string> | null, automarked: boolean, strategy: MatchStrategy | null, similarity: number | null, errorMargin: number | null, caseSensitive: boolean, partialScoring: boolean, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }> | null, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> | null, markerChanges: { __typename?: 'FieldRubricChanges', id: string, valuesAdded: Array<string>, valuesRemoved: Array<string> } | null, moderatorChanges: { __typename?: 'FieldRubricChanges', id: string, valuesAdded: Array<string>, valuesRemoved: Array<string> } | null, markerRubric: { __typename?: 'MarkerRubric', id: string, assessmentId: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, hasChanges: boolean, state: MarkerRubricState, updatedAt: string | null, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, hasOutcomes: boolean, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null }> } | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null };

export type WorkOutcomeQuestionScoresFragment = { __typename?: 'WorkOutcomeQuestionScores', id: string, workOutcomeId: string, questionScores: Array<{ __typename?: 'QuestionScore', questionId: string, score: number | null }> };

export type ModerationQuestionsQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  taskKind: InputMaybe<TaskKind>;
}>;


export type ModerationQuestionsQuery = { __typename?: 'RootQueryType', moderationQuestions: Array<{ __typename?: 'ModerationQuestion', id: string, nodeId: string, parentNodeId: string | null, questionId: string, questionType: QuestionType, shortPrompt: string | null, shortLabel: string | null, longLabel: string | null, order: number, maxScore: number | null, score: number | null, automarked: boolean, answerable: boolean | null, hasMarkerChanges: boolean, rates: { __typename?: 'QuestionRates', responseRate: number, successRate: number | null, averageScore: number | null } | null, rubric: { __typename?: 'QuestionRubric', id: string, questionId: string, maxScore: number, counts: { __typename?: 'QuestionResponseCounts', responseCount: number, successCount: number, averageScore: number | null }, fieldRubrics: Array<{ __typename?: 'FieldRubric', id: string, identifier: string, baseType: BaseType | null, values: Array<string> | null, automarked: boolean, strategy: MatchStrategy | null, similarity: number | null, errorMargin: number | null, caseSensitive: boolean, partialScoring: boolean, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }> | null, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> | null, markerChanges: { __typename?: 'FieldRubricChanges', id: string, valuesAdded: Array<string>, valuesRemoved: Array<string> } | null, moderatorChanges: { __typename?: 'FieldRubricChanges', id: string, valuesAdded: Array<string>, valuesRemoved: Array<string> } | null, markerRubric: { __typename?: 'MarkerRubric', id: string, assessmentId: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, hasChanges: boolean, state: MarkerRubricState, updatedAt: string | null, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, hasOutcomes: boolean, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null }> } | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null }>, assessmentQuestionScores: Array<{ __typename?: 'WorkOutcomeQuestionScores', id: string, workOutcomeId: string, questionScores: Array<{ __typename?: 'QuestionScore', questionId: string, score: number | null }> }> };

export type ModerationSubmissionOutcomeFragment = { __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, submittedAt: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, markerScope: MarkerScope, score: number | null, markerModifier: number | null, latestForType: boolean, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> }, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null, feedbackModerationId: string | null, bodyDoc: string | null, referencesDoc: string | null, markerModifier: number | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } | null } | null };

export type ModerationSubmissionOutcomeScoreFragment = { __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, markerScope: MarkerScope, score: number | null, markerModifier: number | null, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, flagReason: string | null, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null } | null };

export type ModeratorUpdateFieldRubricResponseMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  input: UpdateFieldRubricInput;
}>;


export type ModeratorUpdateFieldRubricResponseMutation = { __typename?: 'RootMutationType', updateFieldRubricResponse: { __typename?: 'UpdateFieldRubricPayload', fieldRubric: { __typename?: 'FieldRubric', id: string, identifier: string, baseType: BaseType | null, values: Array<string> | null, automarked: boolean, strategy: MatchStrategy | null, similarity: number | null, errorMargin: number | null, caseSensitive: boolean, partialScoring: boolean, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }> | null, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> | null, markerChanges: { __typename?: 'FieldRubricChanges', id: string, valuesAdded: Array<string>, valuesRemoved: Array<string> } | null, moderatorChanges: { __typename?: 'FieldRubricChanges', id: string, valuesAdded: Array<string>, valuesRemoved: Array<string> } | null, markerRubric: { __typename?: 'MarkerRubric', id: string, assessmentId: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, hasChanges: boolean, state: MarkerRubricState, updatedAt: string | null, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, hasOutcomes: boolean, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null, responses: Array<{ __typename?: 'FieldResponse', answer: string | null, answers: Array<string> | null, count: number, isCorrect: boolean, similarity: number | null }> } | null, questionRubric: { __typename?: 'QuestionRubric', id: string, counts: { __typename?: 'QuestionResponseCounts', responseCount: number, successCount: number, averageScore: number | null } } | null, questionOutcomes: Array<{ __typename?: 'QuestionOutcome', id: string, questionId: string, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, automark: number | null } }>, fieldOutcomes: Array<{ __typename?: 'FieldOutcome', id: string, identifier: string, fieldRubricId: string, score: number | null, markerScore: number | null, automarkScore: number | null }>, workOutcomes: Array<{ __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, maxScore: number, automarkPending: boolean | null, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } }> } };

export type PastMarkerRubricFragment = { __typename?: 'MarkerRubric', id: string, assessmentId: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, hasOutcomes: boolean, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> };

export type PastMarkerRubricQueryVariables = Exact<{
  markerRubricId: Scalars['ID']['input'];
}>;


export type PastMarkerRubricQuery = { __typename?: 'RootQueryType', pastMarkerRubric: { __typename?: 'MarkerRubric', id: string, assessmentId: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, hasChanges: boolean, state: MarkerRubricState, updatedAt: string | null, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, hasOutcomes: boolean, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } };

export type PastMarkerRubricsQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type PastMarkerRubricsQuery = { __typename?: 'RootQueryType', pastMarkerRubrics: Array<{ __typename?: 'MarkerRubric', id: string, assessmentId: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, hasOutcomes: boolean, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> }> };

export type PeerOutcomeFragment = { __typename?: 'PeerOutcome', id: string, targetUserId: string, selfScore: number | null, selfMaxScore: number | null, peerScore: number | null, peerMaxScore: number | null, isComplete: boolean | null, hasEvaluatedAllPeers: boolean | null, hasReceivedAllEvaluations: boolean | null, hasCompletedSelfEvaluation: boolean | null, feedbackReleasedTimestamp: string | null, evaluationsSubmittedAt: string | null, groupReportScaleFactor: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> };

export type PublishMarkerRubricMutationVariables = Exact<{
  markerRubricId: Scalars['ID']['input'];
}>;


export type PublishMarkerRubricMutation = { __typename?: 'RootMutationType', publishMarkerRubric: { __typename?: 'MarkerRubric', id: string, assessmentId: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, hasChanges: boolean, state: MarkerRubricState, updatedAt: string | null, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, hasOutcomes: boolean, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } };

export type QuestionOutcomeFragment = { __typename?: 'QuestionOutcome', id: string, questionId: string, blockSnapshot: { __typename?: 'BlockSnapshot', id: string, content: string, blockName: string | null, answerBlockId: string } | null, referencesBlockSnapshot: { __typename?: 'BlockSnapshot', id: string, content: string, blockName: string | null } | null, fieldOutcomes: Array<{ __typename?: 'FieldOutcome', id: string, identifier: string, fieldRubricId: string, score: number | null, automarkScore: number | null, automarkStatus: AutomarkStatus | null, answer: string | null, answers: Array<string> | null, answerSimilarity: number | null, docContent: string | null, docVersion: number | null, referencesDocContent: string | null, referencesDocVersion: number | null, comments: Array<{ __typename?: 'Comment', id: string }> | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } }>, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, automark: number | null } };

export type QuestionOutcomeScoreFragment = { __typename?: 'QuestionOutcome', id: string, questionId: string, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, automark: number | null } };

export type QuestionOutcomeSubscriptionFragment = { __typename?: 'QuestionOutcome', id: string, questionId: string, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, fieldOutcomes: Array<{ __typename?: 'FieldOutcome', id: string, identifier: string, fieldRubricId: string, score: number | null, automarkScore: number | null, automarkStatus: AutomarkStatus | null, answer: string | null, answers: Array<string> | null, answerSimilarity: number | null, docContent: string | null, docVersion: number | null, referencesDocContent: string | null, referencesDocVersion: number | null, comments: Array<{ __typename?: 'Comment', id: string }> | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } }> };

export type QuestionResponseCountsFragment = { __typename?: 'QuestionResponseCounts', responseCount: number, successCount: number, averageScore: number | null };

export type QuestionRubricFragment = { __typename?: 'QuestionRubric', id: string, questionId: string, maxScore: number, fieldRubrics: Array<{ __typename?: 'FieldRubric', id: string, identifier: string, baseType: BaseType | null, values: Array<string> | null, automarked: boolean, strategy: MatchStrategy | null, similarity: number | null, errorMargin: number | null, caseSensitive: boolean, partialScoring: boolean, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }> | null, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> | null, markerChanges: { __typename?: 'FieldRubricChanges', id: string, valuesAdded: Array<string>, valuesRemoved: Array<string> } | null, moderatorChanges: { __typename?: 'FieldRubricChanges', id: string, valuesAdded: Array<string>, valuesRemoved: Array<string> } | null, markerRubric: { __typename?: 'MarkerRubric', id: string, assessmentId: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, hasChanges: boolean, state: MarkerRubricState, updatedAt: string | null, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, hasOutcomes: boolean, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null }> };

export type QuestionRubricQueryVariables = Exact<{
  questionRubricId: Scalars['ID']['input'];
}>;


export type QuestionRubricQuery = { __typename?: 'RootQueryType', questionRubric: { __typename?: 'QuestionRubric', fieldRubrics: Array<{ __typename?: 'FieldRubric', id: string, identifier: string, responses: Array<{ __typename?: 'FieldResponse', answer: string | null, answers: Array<string> | null, count: number, isCorrect: boolean, similarity: number | null }> }> } };

export type QuestionRubricWithCountsFragment = { __typename?: 'QuestionRubric', id: string, questionId: string, maxScore: number, counts: { __typename?: 'QuestionResponseCounts', responseCount: number, successCount: number, averageScore: number | null }, fieldRubrics: Array<{ __typename?: 'FieldRubric', id: string, identifier: string, baseType: BaseType | null, values: Array<string> | null, automarked: boolean, strategy: MatchStrategy | null, similarity: number | null, errorMargin: number | null, caseSensitive: boolean, partialScoring: boolean, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }> | null, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> | null, markerChanges: { __typename?: 'FieldRubricChanges', id: string, valuesAdded: Array<string>, valuesRemoved: Array<string> } | null, moderatorChanges: { __typename?: 'FieldRubricChanges', id: string, valuesAdded: Array<string>, valuesRemoved: Array<string> } | null, markerRubric: { __typename?: 'MarkerRubric', id: string, assessmentId: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, hasChanges: boolean, state: MarkerRubricState, updatedAt: string | null, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, hasOutcomes: boolean, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null }> };

export type ReleaseFeedbackForEveryoneMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  feedbackVisibility: InputMaybe<FeedbackVisibilityInput>;
  releaseType: InputMaybe<FeedbackReleaseType>;
}>;


export type ReleaseFeedbackForEveryoneMutation = { __typename?: 'RootMutationType', releaseFeedbackForEveryone: { __typename?: 'ReleaseFeedbackForEveryonePayload', feedbackReleaseRules: Array<{ __typename?: 'FeedbackReleaseRule', id: string, basePool: FeedbackReleaseBasePool, excludedStudentIds: Array<string>, excludedTags: Array<string>, executedAt: string | null, includedStudentIds: Array<string>, scheduledAt: string | null, executedStudentIds: Array<string> | null, ruleKind: ReleaseRuleKind, includedGroupIds: Array<string>, releaseType: FeedbackReleaseType }>, studentOutcomes: Array<{ __typename?: 'StudentOutcome', id: string, studentId: string, moderatorModifier: number | null, peerOutcome: { __typename?: 'PeerOutcome', id: string, targetUserId: string, selfScore: number | null, selfMaxScore: number | null, peerScore: number | null, peerMaxScore: number | null, isComplete: boolean | null, hasEvaluatedAllPeers: boolean | null, hasReceivedAllEvaluations: boolean | null, hasCompletedSelfEvaluation: boolean | null, feedbackReleasedTimestamp: string | null, evaluationsSubmittedAt: string | null, groupReportScaleFactor: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } | null, groupWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, assessmentId: string, finalScore: number | null, maxScore: number, automarkPending: boolean | null, feedbackReleasedTimestamp: string | null, finalScorePenalty: number | null, questionOutcomesScored: boolean, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, provisionalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, finalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, moderationSubmissionOutcomes: Array<{ __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, markerScope: MarkerScope, score: number | null, markerModifier: number | null, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, flagReason: string | null, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null } | null }>, markingSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, markerScope: MarkerScope, score: number | null, markerModifier: number | null, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, flagReason: string | null, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null } | null } | null, draftSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, score: number | null } | null } | null, individualWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, assessmentId: string, finalScore: number | null, maxScore: number, automarkPending: boolean | null, feedbackReleasedTimestamp: string | null, finalScorePenalty: number | null, questionOutcomesScored: boolean, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, provisionalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, finalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, moderationSubmissionOutcomes: Array<{ __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, markerScope: MarkerScope, score: number | null, markerModifier: number | null, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, flagReason: string | null, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null } | null }>, markingSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, markerScope: MarkerScope, score: number | null, markerModifier: number | null, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, flagReason: string | null, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null } | null } | null, draftSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, score: number | null } | null } | null, modifiers: Array<{ __typename?: 'StudentOutcomeModifier', id: string, type: StudentOutcomeModifierType, component: string, value: any }>, base: { __typename?: 'ComponentBreakdown', total: { __typename?: 'WeightedScore', score: number | null, maxScore: number, penaltyScore: number, moderatorModifierComponents: number, moderatorModifierStudent: number }, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null }, provisional: { __typename?: 'ComponentBreakdown', total: { __typename?: 'WeightedScore', score: number | null, maxScore: number, penaltyScore: number, moderatorModifierComponents: number, moderatorModifierStudent: number }, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null }, final: { __typename?: 'ComponentBreakdown', total: { __typename?: 'WeightedScore', score: number | null, maxScore: number, penaltyScore: number, moderatorModifierComponents: number, moderatorModifierStudent: number }, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null } }> } };

export type RemoveMarkerRubricMutationVariables = Exact<{
  markerRubricId: Scalars['ID']['input'];
}>;


export type RemoveMarkerRubricMutation = { __typename?: 'RootMutationType', removeMarkerRubric: { __typename?: 'MarkerRubric', id: string } };

export type ResetFeedbackReleaseRuleMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  releaseType: InputMaybe<FeedbackReleaseType>;
}>;


export type ResetFeedbackReleaseRuleMutation = { __typename?: 'RootMutationType', resetFeedbackReleaseRules: Array<{ __typename?: 'FeedbackReleaseRule', id: string, basePool: FeedbackReleaseBasePool, excludedStudentIds: Array<string>, excludedTags: Array<string>, executedAt: string | null, includedStudentIds: Array<string>, scheduledAt: string | null, executedStudentIds: Array<string> | null, ruleKind: ReleaseRuleKind, includedGroupIds: Array<string>, releaseType: FeedbackReleaseType }> };

export type ResetQuestionModerationChangesMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type ResetQuestionModerationChangesMutation = { __typename?: 'RootMutationType', resetQuestionModerationChanges: { __typename?: 'ResetQuestionModerationChangesPayload', fieldRubrics: Array<{ __typename?: 'FieldRubric', id: string, identifier: string, baseType: BaseType | null, values: Array<string> | null, automarked: boolean, strategy: MatchStrategy | null, similarity: number | null, errorMargin: number | null, caseSensitive: boolean, partialScoring: boolean, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }> | null, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> | null, markerChanges: { __typename?: 'FieldRubricChanges', id: string, valuesAdded: Array<string>, valuesRemoved: Array<string> } | null, moderatorChanges: { __typename?: 'FieldRubricChanges', id: string, valuesAdded: Array<string>, valuesRemoved: Array<string> } | null, markerRubric: { __typename?: 'MarkerRubric', id: string, assessmentId: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, hasChanges: boolean, state: MarkerRubricState, updatedAt: string | null, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, hasOutcomes: boolean, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null, responses: Array<{ __typename?: 'FieldResponse', answer: string | null, answers: Array<string> | null, count: number, isCorrect: boolean, similarity: number | null }> }>, studentOutcomes: Array<{ __typename?: 'StudentOutcome', id: string, studentId: string, moderatorModifier: number | null, peerOutcome: { __typename?: 'PeerOutcome', id: string, targetUserId: string, selfScore: number | null, selfMaxScore: number | null, peerScore: number | null, peerMaxScore: number | null, isComplete: boolean | null, hasEvaluatedAllPeers: boolean | null, hasReceivedAllEvaluations: boolean | null, hasCompletedSelfEvaluation: boolean | null, feedbackReleasedTimestamp: string | null, evaluationsSubmittedAt: string | null, groupReportScaleFactor: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } | null, groupWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, assessmentId: string, finalScore: number | null, maxScore: number, automarkPending: boolean | null, feedbackReleasedTimestamp: string | null, finalScorePenalty: number | null, questionOutcomesScored: boolean, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, provisionalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, finalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, moderationSubmissionOutcomes: Array<{ __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, markerScope: MarkerScope, score: number | null, markerModifier: number | null, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, flagReason: string | null, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null } | null }>, markingSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, markerScope: MarkerScope, score: number | null, markerModifier: number | null, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, flagReason: string | null, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null } | null } | null, draftSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, score: number | null } | null } | null, individualWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, assessmentId: string, finalScore: number | null, maxScore: number, automarkPending: boolean | null, feedbackReleasedTimestamp: string | null, finalScorePenalty: number | null, questionOutcomesScored: boolean, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, provisionalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, finalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, moderationSubmissionOutcomes: Array<{ __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, markerScope: MarkerScope, score: number | null, markerModifier: number | null, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, flagReason: string | null, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null } | null }>, markingSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, markerScope: MarkerScope, score: number | null, markerModifier: number | null, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, flagReason: string | null, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null } | null } | null, draftSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, score: number | null } | null } | null, modifiers: Array<{ __typename?: 'StudentOutcomeModifier', id: string, type: StudentOutcomeModifierType, component: string, value: any }>, base: { __typename?: 'ComponentBreakdown', total: { __typename?: 'WeightedScore', score: number | null, maxScore: number, penaltyScore: number, moderatorModifierComponents: number, moderatorModifierStudent: number }, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null }, provisional: { __typename?: 'ComponentBreakdown', total: { __typename?: 'WeightedScore', score: number | null, maxScore: number, penaltyScore: number, moderatorModifierComponents: number, moderatorModifierStudent: number }, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null }, final: { __typename?: 'ComponentBreakdown', total: { __typename?: 'WeightedScore', score: number | null, maxScore: number, penaltyScore: number, moderatorModifierComponents: number, moderatorModifierStudent: number }, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null } }>, questionOutcomes: Array<{ __typename?: 'QuestionOutcome', id: string, questionId: string, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, automark: number | null } }>, questionRubrics: Array<{ __typename?: 'QuestionRubric', id: string, counts: { __typename?: 'QuestionResponseCounts', responseCount: number, successCount: number, averageScore: number | null } }> } };

export type ResetRubricOutcomeForFieldMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  markerRubricId: Scalars['ID']['input'];
  fieldOutcomeId: Scalars['ID']['input'];
}>;


export type ResetRubricOutcomeForFieldMutation = { __typename?: 'RootMutationType', resetRubricOutcomeForField: { __typename?: 'ResetRubricOutcomeForFieldPayload', criterionOutcomesDeleted: number, fieldOutcome: { __typename?: 'FieldOutcome', id: string, score: number | null, markerScore: number | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } }, questionOutcome: { __typename?: 'QuestionOutcome', id: string, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } }, workOutcome: { __typename?: 'WorkOutcome', id: string, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } } } };

export type ResetRubricOutcomeForSubmissionMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  markerRubricId: Scalars['ID']['input'];
  submissionOutcomeId: Scalars['ID']['input'];
}>;


export type ResetRubricOutcomeForSubmissionMutation = { __typename?: 'RootMutationType', resetRubricOutcomeForSubmission: { __typename?: 'ResetRubricOutcomeForSubmissionPayload', criterionOutcomesDeleted: number, submissionOutcome: { __typename?: 'SubmissionOutcome', id: string, score: number | null, markerModifier: number | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } }, workOutcome: { __typename?: 'WorkOutcome', id: string, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } } } };

export type ResetRubricOutcomeMutationVariables = Exact<{
  markerRubricId: Scalars['ID']['input'];
  criteriaId: InputMaybe<Scalars['ID']['input']>;
}>;


export type ResetRubricOutcomeMutation = { __typename?: 'RootMutationType', resetRubricOutcome: { __typename?: 'ResetRubricOutcomePayload', criteria: Array<{ __typename?: 'Criterion', id: string | null, hasOutcomes: boolean }> } };

export type ResetScoreModerationChangesMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type ResetScoreModerationChangesMutation = { __typename?: 'RootMutationType', resetScoreModerationChanges: { __typename?: 'ResetScoreModerationChangesPayload', studentOutcomes: Array<{ __typename?: 'StudentOutcome', id: string, studentId: string, moderatorModifier: number | null, peerOutcome: { __typename?: 'PeerOutcome', id: string, targetUserId: string, selfScore: number | null, selfMaxScore: number | null, peerScore: number | null, peerMaxScore: number | null, isComplete: boolean | null, hasEvaluatedAllPeers: boolean | null, hasReceivedAllEvaluations: boolean | null, hasCompletedSelfEvaluation: boolean | null, feedbackReleasedTimestamp: string | null, evaluationsSubmittedAt: string | null, groupReportScaleFactor: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } | null, groupWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, assessmentId: string, finalScore: number | null, maxScore: number, automarkPending: boolean | null, feedbackReleasedTimestamp: string | null, finalScorePenalty: number | null, questionOutcomesScored: boolean, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, provisionalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, finalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, moderationSubmissionOutcomes: Array<{ __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, markerScope: MarkerScope, score: number | null, markerModifier: number | null, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, flagReason: string | null, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null } | null }>, markingSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, markerScope: MarkerScope, score: number | null, markerModifier: number | null, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, flagReason: string | null, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null } | null } | null, draftSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, score: number | null } | null } | null, individualWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, assessmentId: string, finalScore: number | null, maxScore: number, automarkPending: boolean | null, feedbackReleasedTimestamp: string | null, finalScorePenalty: number | null, questionOutcomesScored: boolean, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, provisionalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, finalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, moderationSubmissionOutcomes: Array<{ __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, markerScope: MarkerScope, score: number | null, markerModifier: number | null, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, flagReason: string | null, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null } | null }>, markingSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, markerScope: MarkerScope, score: number | null, markerModifier: number | null, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, flagReason: string | null, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null } | null } | null, draftSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, score: number | null } | null } | null, modifiers: Array<{ __typename?: 'StudentOutcomeModifier', id: string, type: StudentOutcomeModifierType, component: string, value: any }>, base: { __typename?: 'ComponentBreakdown', total: { __typename?: 'WeightedScore', score: number | null, maxScore: number, penaltyScore: number, moderatorModifierComponents: number, moderatorModifierStudent: number }, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null }, provisional: { __typename?: 'ComponentBreakdown', total: { __typename?: 'WeightedScore', score: number | null, maxScore: number, penaltyScore: number, moderatorModifierComponents: number, moderatorModifierStudent: number }, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null }, final: { __typename?: 'ComponentBreakdown', total: { __typename?: 'WeightedScore', score: number | null, maxScore: number, penaltyScore: number, moderatorModifierComponents: number, moderatorModifierStudent: number }, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null } }>, workOutcomes: Array<{ __typename?: 'WorkOutcome', id: string, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } }> } };

export type ReuseCriterionFragment = { __typename?: 'ReuseCriterion', assessmentName: string, color: string | null, description: string | null, kind: MarkerRubricKind, maxScore: number | null, publishedAt: string, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string }, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> };

export type SaveFragment = { __typename?: 'Save', id: string, serverId: string, version: string, content: string, dispatchedAt: string };

export type SaveMarkerRubricMutationVariables = Exact<{
  markerRubricId: Scalars['ID']['input'];
  input: MarkerRubricInput;
}>;


export type SaveMarkerRubricMutation = { __typename?: 'RootMutationType', saveMarkerRubric: { __typename?: 'MarkerRubric', id: string, assessmentId: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, hasChanges: boolean, state: MarkerRubricState, updatedAt: string | null, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, hasOutcomes: boolean, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } };

export type ScaleItemFragment = { __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null };

export type ScoreBreakdownFragment = { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null };

export type SetMarkerAdjustmentMutationVariables = Exact<{
  workId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
  value: Scalars['Decimal']['input'];
  note: InputMaybe<Scalars['String']['input']>;
}>;


export type SetMarkerAdjustmentMutation = { __typename?: 'RootMutationType', setMarkerAdjustment: { __typename?: 'MarkerAdjustmentPayload', studentOutcome: { __typename?: 'StudentOutcome', id: string, studentId: string, modifiers: Array<{ __typename?: 'StudentOutcomeModifier', id: string, type: StudentOutcomeModifierType, component: string, value: any, note: string | null, addedByUserId: string | null, addedAt: string }> } } };

export type SimilarityQueryVariables = Exact<{
  submissionType: SubmissionType;
  workId: Scalars['ID']['input'];
}>;


export type SimilarityQuery = { __typename?: 'RootQueryType', latestResult: { __typename?: 'Result', id: string, workId: string, heraResultId: number | null, similarity: { __typename?: 'Similarity', display: string, label: string, value: number } | null } };

export type SkillFragment = { __typename?: 'LearningOutcomeSkill', id: string, skill: string };

export type SkillsQueryVariables = Exact<{ [key: string]: never; }>;


export type SkillsQuery = { __typename?: 'RootQueryType', skills: Array<{ __typename?: 'LearningOutcomeSkill', id: string, skill: string }> };

export type SmartCommentFragment = { __typename?: 'SmartComment', id: string, score: number, skillId: string, content: string, insertedAt: string, assessmentId: string | null, assessmentName: string | null, userName: string | null, lastUsed: string | null, usageCount: number };

export type SmartCommentsBySkillsQueryVariables = Exact<{
  skillIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  rangeFrom: InputMaybe<Scalars['Int']['input']>;
  rangeTo: InputMaybe<Scalars['Int']['input']>;
  maxScore: InputMaybe<Scalars['Int']['input']>;
}>;


export type SmartCommentsBySkillsQuery = { __typename?: 'RootQueryType', smartCommentsBySkills: Array<{ __typename?: 'SmartComment', id: string, score: number, skillId: string, content: string, insertedAt: string, assessmentId: string | null, assessmentName: string | null, userName: string | null, lastUsed: string | null, usageCount: number }> };

export type SnapshotFieldOutcomeMutationVariables = Exact<{
  fieldOutcomeId: Scalars['ID']['input'];
  input: SnapshotFieldOutcomeInput;
}>;


export type SnapshotFieldOutcomeMutation = { __typename?: 'RootMutationType', snapshotFieldOutcome: { __typename?: 'FieldOutcome', id: string, identifier: string, fieldRubricId: string, score: number | null, automarkScore: number | null, automarkStatus: AutomarkStatus | null, answer: string | null, answers: Array<string> | null, answerSimilarity: number | null, docContent: string | null, docVersion: number | null, referencesDocContent: string | null, referencesDocVersion: number | null, comments: Array<{ __typename?: 'Comment', id: string }> | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } } };

export type SnapshotSubmissionOutcomeMutationVariables = Exact<{
  submissionOutcomeId: Scalars['ID']['input'];
  input: SnapshotSubmissionOutcomeInput;
}>;


export type SnapshotSubmissionOutcomeMutation = { __typename?: 'RootMutationType', snapshotSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, submittedAt: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, markerScope: MarkerScope, score: number | null, markerModifier: number | null, latestForType: boolean, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } } };

export type StudentEnrollmentsQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
}>;


export type StudentEnrollmentsQuery = { __typename?: 'RootQueryType', studentEnrollments: Array<{ __typename?: 'Enrollment', id: string, sectionId: string | null, syncedAt: string | null, deleted: boolean, sisUserId: string | null, reentryCount: number, anonymousIndex: number | null, deletedBy: { __typename?: 'User', id: string, name: string } | null, user: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }, work: { __typename?: 'Work', id: string, startDate: string | null, updatedAt: string | null, lastSaveTime: string | null, attemptCount: number, finalResult: { __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number, memberSummaries: Array<{ __typename?: 'MemberSummary', lastAccess: string, accessCount: number, userId: string }> } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null } | null, draftResult: { __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number, memberSummaries: Array<{ __typename?: 'MemberSummary', lastAccess: string, accessCount: number, userId: string }> } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null } | null, features: { __typename?: 'WorkFeatures', id: string, enableWorkAuthority: boolean } } | null, tags: Array<{ __typename?: 'Tag', id: string, text: string, column: number, tab: ClassTab }>, workSettings: { __typename?: 'WorkSettings', id: string, studentId: string | null, dueDate: string | null, timeLimit: number | null, examReadingTime: number | null, examWritingTime: number | null, examStartDate: string | null, examEndDate: string | null, examDeferred: boolean | null, submitAttemptLimit: number | null, updatedAt: string | null, updateReason: string | null, draftExamStartDate: string | null, draftExamEndDate: string | null, groupId: string | null, vivaExtraAttempts: number | null, lastUpdatedBy: { __typename?: 'User', id: string, name: string } | null } | null, accessCode: { __typename?: 'AccessCode', code: string, label: string | null, active: boolean, type: AccessCodeType } | null, verifiedCodes: Array<{ __typename?: 'VerifiedCode', label: string | null, insertedAt: string | null }> | null }> };

export type StudentOutcomeFragment = { __typename?: 'StudentOutcome', id: string, studentId: string, moderatorModifier: number | null, peerOutcome: { __typename?: 'PeerOutcome', id: string, targetUserId: string, selfScore: number | null, selfMaxScore: number | null, peerScore: number | null, peerMaxScore: number | null, isComplete: boolean | null, hasEvaluatedAllPeers: boolean | null, hasReceivedAllEvaluations: boolean | null, hasCompletedSelfEvaluation: boolean | null, feedbackReleasedTimestamp: string | null, evaluationsSubmittedAt: string | null, groupReportScaleFactor: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } | null, groupWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, assessmentId: string, finalScore: number | null, maxScore: number, automarkPending: boolean | null, feedbackReleasedTimestamp: string | null, finalScorePenalty: number | null, questionOutcomesScored: boolean, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, provisionalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, finalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, moderationSubmissionOutcomes: Array<{ __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, markerScope: MarkerScope, score: number | null, markerModifier: number | null, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, flagReason: string | null, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null } | null }>, markingSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, markerScope: MarkerScope, score: number | null, markerModifier: number | null, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, flagReason: string | null, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null } | null } | null, draftSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, score: number | null } | null } | null, individualWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, assessmentId: string, finalScore: number | null, maxScore: number, automarkPending: boolean | null, feedbackReleasedTimestamp: string | null, finalScorePenalty: number | null, questionOutcomesScored: boolean, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, provisionalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, finalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, moderationSubmissionOutcomes: Array<{ __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, markerScope: MarkerScope, score: number | null, markerModifier: number | null, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, flagReason: string | null, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null } | null }>, markingSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, markerScope: MarkerScope, score: number | null, markerModifier: number | null, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, flagReason: string | null, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null } | null } | null, draftSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, score: number | null } | null } | null, modifiers: Array<{ __typename?: 'StudentOutcomeModifier', id: string, type: StudentOutcomeModifierType, component: string, value: any }>, base: { __typename?: 'ComponentBreakdown', total: { __typename?: 'WeightedScore', score: number | null, maxScore: number, penaltyScore: number, moderatorModifierComponents: number, moderatorModifierStudent: number }, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null }, provisional: { __typename?: 'ComponentBreakdown', total: { __typename?: 'WeightedScore', score: number | null, maxScore: number, penaltyScore: number, moderatorModifierComponents: number, moderatorModifierStudent: number }, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null }, final: { __typename?: 'ComponentBreakdown', total: { __typename?: 'WeightedScore', score: number | null, maxScore: number, penaltyScore: number, moderatorModifierComponents: number, moderatorModifierStudent: number }, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null } };

export type StudentOutcomesQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type StudentOutcomesQuery = { __typename?: 'RootQueryType', studentOutcomes: Array<{ __typename?: 'StudentOutcome', id: string, studentId: string, moderatorModifier: number | null, peerOutcome: { __typename?: 'PeerOutcome', id: string, targetUserId: string, selfScore: number | null, selfMaxScore: number | null, peerScore: number | null, peerMaxScore: number | null, isComplete: boolean | null, hasEvaluatedAllPeers: boolean | null, hasReceivedAllEvaluations: boolean | null, hasCompletedSelfEvaluation: boolean | null, feedbackReleasedTimestamp: string | null, evaluationsSubmittedAt: string | null, groupReportScaleFactor: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } | null, groupWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, assessmentId: string, finalScore: number | null, maxScore: number, automarkPending: boolean | null, feedbackReleasedTimestamp: string | null, finalScorePenalty: number | null, questionOutcomesScored: boolean, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, provisionalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, finalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, moderationSubmissionOutcomes: Array<{ __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, markerScope: MarkerScope, score: number | null, markerModifier: number | null, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, flagReason: string | null, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null } | null }>, markingSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, markerScope: MarkerScope, score: number | null, markerModifier: number | null, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, flagReason: string | null, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null } | null } | null, draftSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, score: number | null } | null } | null, individualWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, assessmentId: string, finalScore: number | null, maxScore: number, automarkPending: boolean | null, feedbackReleasedTimestamp: string | null, finalScorePenalty: number | null, questionOutcomesScored: boolean, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, provisionalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, finalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, moderationSubmissionOutcomes: Array<{ __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, markerScope: MarkerScope, score: number | null, markerModifier: number | null, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, flagReason: string | null, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null } | null }>, markingSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, markerScope: MarkerScope, score: number | null, markerModifier: number | null, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, flagReason: string | null, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null } | null } | null, draftSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, score: number | null } | null } | null, modifiers: Array<{ __typename?: 'StudentOutcomeModifier', id: string, type: StudentOutcomeModifierType, component: string, value: any }>, base: { __typename?: 'ComponentBreakdown', total: { __typename?: 'WeightedScore', score: number | null, maxScore: number, penaltyScore: number, moderatorModifierComponents: number, moderatorModifierStudent: number }, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null }, provisional: { __typename?: 'ComponentBreakdown', total: { __typename?: 'WeightedScore', score: number | null, maxScore: number, penaltyScore: number, moderatorModifierComponents: number, moderatorModifierStudent: number }, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null }, final: { __typename?: 'ComponentBreakdown', total: { __typename?: 'WeightedScore', score: number | null, maxScore: number, penaltyScore: number, moderatorModifierComponents: number, moderatorModifierStudent: number }, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null } }> };

export type StudentOutcomesUpdatedSubscriptionVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type StudentOutcomesUpdatedSubscription = { __typename?: 'RootSubscriptionType', studentOutcomesUpdated: Array<{ __typename?: 'StudentOutcome', id: string, studentId: string, groupWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, groupId: string | null, studentId: string | null, maxScore: number, finalScore: number | null, finalScorePenalty: number | null, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, draftSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, submittedAt: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, markerScope: MarkerScope, score: number | null, markerModifier: number | null, latestForType: boolean, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } } | null, finalSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, submittedAt: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, markerScope: MarkerScope, score: number | null, markerModifier: number | null, latestForType: boolean, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } } | null, questionOutcomes: Array<{ __typename?: 'QuestionOutcome', id: string, questionId: string, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, fieldOutcomes: Array<{ __typename?: 'FieldOutcome', id: string, identifier: string, fieldRubricId: string, score: number | null, automarkScore: number | null, automarkStatus: AutomarkStatus | null, answer: string | null, answers: Array<string> | null, answerSimilarity: number | null, docContent: string | null, docVersion: number | null, referencesDocContent: string | null, referencesDocVersion: number | null, comments: Array<{ __typename?: 'Comment', id: string }> | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } }> }>, provisionalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, finalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, moderationSubmissionOutcomes: Array<{ __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, markerScope: MarkerScope, score: number | null, markerModifier: number | null, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, flagReason: string | null, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null } | null }>, markingSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, markerScope: MarkerScope, score: number | null, markerModifier: number | null, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, flagReason: string | null, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null } | null } | null } | null, individualWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, groupId: string | null, studentId: string | null, maxScore: number, finalScore: number | null, finalScorePenalty: number | null, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, draftSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, submittedAt: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, markerScope: MarkerScope, score: number | null, markerModifier: number | null, latestForType: boolean, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } } | null, finalSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, submittedAt: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, markerScope: MarkerScope, score: number | null, markerModifier: number | null, latestForType: boolean, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } } | null, questionOutcomes: Array<{ __typename?: 'QuestionOutcome', id: string, questionId: string, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, fieldOutcomes: Array<{ __typename?: 'FieldOutcome', id: string, identifier: string, fieldRubricId: string, score: number | null, automarkScore: number | null, automarkStatus: AutomarkStatus | null, answer: string | null, answers: Array<string> | null, answerSimilarity: number | null, docContent: string | null, docVersion: number | null, referencesDocContent: string | null, referencesDocVersion: number | null, comments: Array<{ __typename?: 'Comment', id: string }> | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } }> }>, provisionalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, finalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, moderationSubmissionOutcomes: Array<{ __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, markerScope: MarkerScope, score: number | null, markerModifier: number | null, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, flagReason: string | null, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null } | null }>, markingSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, markerScope: MarkerScope, score: number | null, markerModifier: number | null, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, flagReason: string | null, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null } | null } | null } | null, base: { __typename?: 'ComponentBreakdown', total: { __typename?: 'WeightedScore', score: number | null, maxScore: number, penaltyScore: number, moderatorModifierComponents: number, moderatorModifierStudent: number }, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null }, provisional: { __typename?: 'ComponentBreakdown', total: { __typename?: 'WeightedScore', score: number | null, maxScore: number, penaltyScore: number, moderatorModifierComponents: number, moderatorModifierStudent: number }, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null }, final: { __typename?: 'ComponentBreakdown', total: { __typename?: 'WeightedScore', score: number | null, maxScore: number, penaltyScore: number, moderatorModifierComponents: number, moderatorModifierStudent: number }, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null } }> };

export type SubmissionOutcomeFragment = { __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, submittedAt: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, markerScope: MarkerScope, score: number | null, markerModifier: number | null, latestForType: boolean, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } };

export type ThreadFragment = { __typename?: 'Thread', id: string, title: string | null, entityType: EntityType | null, entityId: string | null, criterionId: string | null, insertedAt: string, createdBy: { __typename?: 'User', id: string }, metadata: { __typename?: 'Metadata', charterSectionType: CharterSectionType | null, charterEditorId: string | null, blockAttachmentId: number | null, blockAttachmentName: string | null } | null, comments: Array<{ __typename?: 'Comment', id: string, content: string, updatedAt: string, smartCommentId: string | null, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> };

export type TimelineContributionQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  answerBlockId: Scalars['ID']['input'];
  asOfVersion: InputMaybe<Scalars['Int']['input']>;
  includeDeletions: Scalars['Boolean']['input'];
  from: InputMaybe<Scalars['Int']['input']>;
  to: InputMaybe<Scalars['Int']['input']>;
}>;


export type TimelineContributionQuery = { __typename?: 'RootQueryType', contribution: { __typename?: 'Contribution', asOfVersion: number, members: Array<{ __typename?: 'MemberContribution', userId: string, ranges: Array<{ __typename?: 'ContributedRange', from: number, to: number }>, deletions: Array<{ __typename?: 'DeletedContribution', deletedById: string | null, anchor: number, text: string, node: string | null, marks: Array<{ __typename?: 'DeletedMark', type: string, attrs: string | null }>, media: { __typename?: 'DeletedMedia', type: string, src: string | null, width: string | null, customWidth: number | null, imageAlign: string | null } | null }> }> } };

export type TimelineSnapshotsQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  answerBlockId: Scalars['ID']['input'];
  versions: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type TimelineSnapshotsQuery = { __typename?: 'RootQueryType', snapshots: Array<{ __typename?: 'Snapshot', asOfVersion: number, document: string }> };

export type UnlinkCommentThreadMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  threadId: Scalars['ID']['input'];
}>;


export type UnlinkCommentThreadMutation = { __typename?: 'RootMutationType', unlinkCommentThread: { __typename?: 'Thread', id: string, title: string | null, entityType: EntityType | null, entityId: string | null, criterionId: string | null, createdBy: { __typename?: 'User', id: string }, metadata: { __typename?: 'Metadata', charterSectionType: CharterSectionType | null, charterEditorId: string | null } | null, comments: Array<{ __typename?: 'Comment', id: string, content: string, updatedAt: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> } };

export type UpdateFeedbackReleaseRulesMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  rules: Array<FeedbackReleaseRuleInput> | FeedbackReleaseRuleInput;
  releaseType: InputMaybe<FeedbackReleaseType>;
}>;


export type UpdateFeedbackReleaseRulesMutation = { __typename?: 'RootMutationType', updateFeedbackReleaseRules: Array<{ __typename?: 'FeedbackReleaseRule', id: string, basePool: FeedbackReleaseBasePool, excludedStudentIds: Array<string>, excludedTags: Array<string>, executedAt: string | null, includedStudentIds: Array<string>, scheduledAt: string | null, executedStudentIds: Array<string> | null, ruleKind: ReleaseRuleKind, includedGroupIds: Array<string>, releaseType: FeedbackReleaseType }> };

export type UpdateFeedbackVisibilityMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  input: FeedbackVisibilityInput;
  releaseType: InputMaybe<FeedbackReleaseType>;
}>;


export type UpdateFeedbackVisibilityMutation = { __typename?: 'RootMutationType', updateFeedbackVisibility: { __typename?: 'FeedbackVisibility', id: string, feedbackViewLevel: FeedbackLevel, withFeedbackPdf: boolean, notifyStudents: boolean, showPeerScores: boolean, showPeerComments: boolean, jointRelease: boolean, releaseType: FeedbackReleaseType } };

export type UpdateFieldRubricResponseMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  input: UpdateFieldRubricInput;
}>;


export type UpdateFieldRubricResponseMutation = { __typename?: 'RootMutationType', updateFieldRubricResponse: { __typename?: 'UpdateFieldRubricPayload', fieldRubric: { __typename?: 'FieldRubric', id: string, identifier: string, baseType: BaseType | null, values: Array<string> | null, automarked: boolean, strategy: MatchStrategy | null, similarity: number | null, errorMargin: number | null, caseSensitive: boolean, partialScoring: boolean, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }> | null, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> | null, markerChanges: { __typename?: 'FieldRubricChanges', id: string, valuesAdded: Array<string>, valuesRemoved: Array<string> } | null, moderatorChanges: { __typename?: 'FieldRubricChanges', id: string, valuesAdded: Array<string>, valuesRemoved: Array<string> } | null, markerRubric: { __typename?: 'MarkerRubric', id: string, assessmentId: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, hasChanges: boolean, state: MarkerRubricState, updatedAt: string | null, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, hasOutcomes: boolean, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null } | null, questionOutcomes: Array<{ __typename?: 'QuestionOutcome', id: string, questionId: string, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, automark: number | null } }>, fieldOutcomes: Array<{ __typename?: 'FieldOutcome', answer: string | null, answers: Array<string> | null, id: string, identifier: string, fieldRubricId: string, score: number | null, markerScore: number | null, automarkScore: number | null }>, workOutcomes: Array<{ __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, maxScore: number, automarkPending: boolean | null, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } }> } };

export type UpdateModerationPenaltyRulesMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  rules: Array<ModerationPenaltyRuleInput> | ModerationPenaltyRuleInput;
}>;


export type UpdateModerationPenaltyRulesMutation = { __typename?: 'RootMutationType', updateModerationPenaltyRules: Array<{ __typename?: 'ModerationPenaltyRule', canStack: boolean, excludedStudentIds: Array<string> | null, includedTags: Array<string> | null, id: string, minutesLateBy: number | null, penaltyScore: number, scoreUnit: PenaltyScoreUnit, penaltyType: ModerationPenaltyType, reason: string | null, formatUnit: PenaltyFormatUnit | null, ruleKind: PenaltyRuleKind, includedGroupIds: Array<string> }> };

export type UpdateQuestionRubricMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  input: UpdateQuestionRubricInput;
}>;


export type UpdateQuestionRubricMutation = { __typename?: 'RootMutationType', updateQuestionRubric: { __typename?: 'UpdateQuestionRubricPayload', questionRubric: { __typename?: 'QuestionRubric', id: string, fieldRubrics: Array<{ __typename?: 'FieldRubric', id: string, identifier: string, baseType: BaseType | null, values: Array<string> | null, automarked: boolean, strategy: MatchStrategy | null, similarity: number | null, errorMargin: number | null, caseSensitive: boolean, partialScoring: boolean, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }> | null, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> | null, markerChanges: { __typename?: 'FieldRubricChanges', id: string, valuesAdded: Array<string>, valuesRemoved: Array<string> } | null, moderatorChanges: { __typename?: 'FieldRubricChanges', id: string, valuesAdded: Array<string>, valuesRemoved: Array<string> } | null, markerRubric: { __typename?: 'MarkerRubric', id: string, assessmentId: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, hasChanges: boolean, state: MarkerRubricState, updatedAt: string | null, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, hasOutcomes: boolean, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null, responses: Array<{ __typename?: 'FieldResponse', answer: string | null, answers: Array<string> | null, count: number, isCorrect: boolean, similarity: number | null }> }> } | null, questionOutcomes: Array<{ __typename?: 'QuestionOutcome', id: string, questionId: string, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, automark: number | null } }>, fieldOutcomes: Array<{ __typename?: 'FieldOutcome', answer: string | null, answers: Array<string> | null, id: string, identifier: string, fieldRubricId: string, score: number | null, markerScore: number | null, automarkScore: number | null }>, workOutcomes: Array<{ __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, maxScore: number, automarkPending: boolean | null, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } }> } };

export type UpdateStudentOutcomeScoreMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
  input: UpdateStudentOutcomeScoreInput;
}>;


export type UpdateStudentOutcomeScoreMutation = { __typename?: 'RootMutationType', updateStudentOutcomeScore: { __typename?: 'UpdateStudentOutcomeScorePayload', studentOutcome: { __typename?: 'StudentOutcome', id: string, studentId: string, moderatorModifier: number | null, peerOutcome: { __typename?: 'PeerOutcome', id: string, targetUserId: string, selfScore: number | null, selfMaxScore: number | null, peerScore: number | null, peerMaxScore: number | null, isComplete: boolean | null, hasEvaluatedAllPeers: boolean | null, hasReceivedAllEvaluations: boolean | null, hasCompletedSelfEvaluation: boolean | null, feedbackReleasedTimestamp: string | null, evaluationsSubmittedAt: string | null, groupReportScaleFactor: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } | null, groupWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, assessmentId: string, finalScore: number | null, maxScore: number, automarkPending: boolean | null, feedbackReleasedTimestamp: string | null, finalScorePenalty: number | null, questionOutcomesScored: boolean, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, provisionalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, finalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, moderationSubmissionOutcomes: Array<{ __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, markerScope: MarkerScope, score: number | null, markerModifier: number | null, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, flagReason: string | null, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null } | null }>, markingSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, markerScope: MarkerScope, score: number | null, markerModifier: number | null, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, flagReason: string | null, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null } | null } | null, draftSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, score: number | null } | null } | null, individualWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, assessmentId: string, finalScore: number | null, maxScore: number, automarkPending: boolean | null, feedbackReleasedTimestamp: string | null, finalScorePenalty: number | null, questionOutcomesScored: boolean, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, provisionalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, finalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, moderationSubmissionOutcomes: Array<{ __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, markerScope: MarkerScope, score: number | null, markerModifier: number | null, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, flagReason: string | null, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null } | null }>, markingSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, markerScope: MarkerScope, score: number | null, markerModifier: number | null, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, flagReason: string | null, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null } | null } | null, draftSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, score: number | null } | null } | null, modifiers: Array<{ __typename?: 'StudentOutcomeModifier', id: string, type: StudentOutcomeModifierType, component: string, value: any }>, base: { __typename?: 'ComponentBreakdown', total: { __typename?: 'WeightedScore', score: number | null, maxScore: number, penaltyScore: number, moderatorModifierComponents: number, moderatorModifierStudent: number }, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null }, provisional: { __typename?: 'ComponentBreakdown', total: { __typename?: 'WeightedScore', score: number | null, maxScore: number, penaltyScore: number, moderatorModifierComponents: number, moderatorModifierStudent: number }, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null }, final: { __typename?: 'ComponentBreakdown', total: { __typename?: 'WeightedScore', score: number | null, maxScore: number, penaltyScore: number, moderatorModifierComponents: number, moderatorModifierStudent: number }, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null } } } };

export type UpdateSubmissionMarkerModifierMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  submissionOutcomeId: Scalars['Int']['input'];
  awardedPoints: InputMaybe<Scalars['Float']['input']>;
}>;


export type UpdateSubmissionMarkerModifierMutation = { __typename?: 'RootMutationType', updateSubmissionMarkerModifier: { __typename?: 'SubmissionMarkerModifierPayload', submissionOutcome: { __typename?: 'SubmissionOutcome', id: string, score: number | null, markerModifier: number | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } }, workOutcome: { __typename?: 'WorkOutcome', id: string, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } } } };

export type UpdateWorkOutcomeScoreMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  input: UpdateWorkOutcomeScoreInput;
}>;


export type UpdateWorkOutcomeScoreMutation = { __typename?: 'RootMutationType', updateWorkOutcomeScore: { __typename?: 'UpdateWorkOutcomeScorePayload', studentOutcomes: Array<{ __typename?: 'StudentOutcome', id: string, studentId: string, moderatorModifier: number | null, peerOutcome: { __typename?: 'PeerOutcome', id: string, targetUserId: string, selfScore: number | null, selfMaxScore: number | null, peerScore: number | null, peerMaxScore: number | null, isComplete: boolean | null, hasEvaluatedAllPeers: boolean | null, hasReceivedAllEvaluations: boolean | null, hasCompletedSelfEvaluation: boolean | null, feedbackReleasedTimestamp: string | null, evaluationsSubmittedAt: string | null, groupReportScaleFactor: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } | null, groupWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, assessmentId: string, finalScore: number | null, maxScore: number, automarkPending: boolean | null, feedbackReleasedTimestamp: string | null, finalScorePenalty: number | null, questionOutcomesScored: boolean, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, provisionalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, finalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, moderationSubmissionOutcomes: Array<{ __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, markerScope: MarkerScope, score: number | null, markerModifier: number | null, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, flagReason: string | null, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null } | null }>, markingSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, markerScope: MarkerScope, score: number | null, markerModifier: number | null, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, flagReason: string | null, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null } | null } | null, draftSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, score: number | null } | null } | null, individualWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, assessmentId: string, finalScore: number | null, maxScore: number, automarkPending: boolean | null, feedbackReleasedTimestamp: string | null, finalScorePenalty: number | null, questionOutcomesScored: boolean, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, provisionalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, finalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, moderationSubmissionOutcomes: Array<{ __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, markerScope: MarkerScope, score: number | null, markerModifier: number | null, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, flagReason: string | null, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null } | null }>, markingSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, markerScope: MarkerScope, score: number | null, markerModifier: number | null, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, flagReason: string | null, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null } | null } | null, draftSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, score: number | null } | null } | null, modifiers: Array<{ __typename?: 'StudentOutcomeModifier', id: string, type: StudentOutcomeModifierType, component: string, value: any }>, base: { __typename?: 'ComponentBreakdown', total: { __typename?: 'WeightedScore', score: number | null, maxScore: number, penaltyScore: number, moderatorModifierComponents: number, moderatorModifierStudent: number }, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null }, provisional: { __typename?: 'ComponentBreakdown', total: { __typename?: 'WeightedScore', score: number | null, maxScore: number, penaltyScore: number, moderatorModifierComponents: number, moderatorModifierStudent: number }, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null }, final: { __typename?: 'ComponentBreakdown', total: { __typename?: 'WeightedScore', score: number | null, maxScore: number, penaltyScore: number, moderatorModifierComponents: number, moderatorModifierStudent: number }, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null } }> } };

export type WeightedScoreFragment = { __typename?: 'WeightedScore', score: number | null, maxScore: number, penaltyScore: number, moderatorModifierComponents: number, moderatorModifierStudent: number };

export type WithdrawFeedbackMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  studentIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type WithdrawFeedbackMutation = { __typename?: 'RootMutationType', withdrawFeedback: Array<{ __typename?: 'StudentOutcome', id: string, studentId: string, moderatorModifier: number | null, peerOutcome: { __typename?: 'PeerOutcome', id: string, targetUserId: string, selfScore: number | null, selfMaxScore: number | null, peerScore: number | null, peerMaxScore: number | null, isComplete: boolean | null, hasEvaluatedAllPeers: boolean | null, hasReceivedAllEvaluations: boolean | null, hasCompletedSelfEvaluation: boolean | null, feedbackReleasedTimestamp: string | null, evaluationsSubmittedAt: string | null, groupReportScaleFactor: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } | null, groupWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, assessmentId: string, finalScore: number | null, maxScore: number, automarkPending: boolean | null, feedbackReleasedTimestamp: string | null, finalScorePenalty: number | null, questionOutcomesScored: boolean, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, provisionalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, finalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, moderationSubmissionOutcomes: Array<{ __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, markerScope: MarkerScope, score: number | null, markerModifier: number | null, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, flagReason: string | null, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null } | null }>, markingSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, markerScope: MarkerScope, score: number | null, markerModifier: number | null, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, flagReason: string | null, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null } | null } | null, draftSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, score: number | null } | null } | null, individualWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, assessmentId: string, finalScore: number | null, maxScore: number, automarkPending: boolean | null, feedbackReleasedTimestamp: string | null, finalScorePenalty: number | null, questionOutcomesScored: boolean, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, provisionalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, finalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, moderationSubmissionOutcomes: Array<{ __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, markerScope: MarkerScope, score: number | null, markerModifier: number | null, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, flagReason: string | null, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null } | null }>, markingSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, markerScope: MarkerScope, score: number | null, markerModifier: number | null, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, flagReason: string | null, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null } | null } | null, draftSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, score: number | null } | null } | null, modifiers: Array<{ __typename?: 'StudentOutcomeModifier', id: string, type: StudentOutcomeModifierType, component: string, value: any }>, base: { __typename?: 'ComponentBreakdown', total: { __typename?: 'WeightedScore', score: number | null, maxScore: number, penaltyScore: number, moderatorModifierComponents: number, moderatorModifierStudent: number }, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null }, provisional: { __typename?: 'ComponentBreakdown', total: { __typename?: 'WeightedScore', score: number | null, maxScore: number, penaltyScore: number, moderatorModifierComponents: number, moderatorModifierStudent: number }, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null }, final: { __typename?: 'ComponentBreakdown', total: { __typename?: 'WeightedScore', score: number | null, maxScore: number, penaltyScore: number, moderatorModifierComponents: number, moderatorModifierStudent: number }, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number, moderatorModifier: number, modifiersTotal: number, penaltyScore: number, weight: number, weightedScore: number | null, weightedMaxScore: number, weightedModeratorModifier: number, weightedPenaltyScore: number } | null } }> };

export type WorkOutcomeClassFragment = { __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, assessmentId: string, finalScore: number | null, maxScore: number, automarkPending: boolean | null, feedbackReleasedTimestamp: string | null, finalScorePenalty: number | null, questionOutcomesScored: boolean, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, provisionalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, finalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, moderationSubmissionOutcomes: Array<{ __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, markerScope: MarkerScope, score: number | null, markerModifier: number | null, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, flagReason: string | null, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null } | null }>, markingSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, markerScope: MarkerScope, score: number | null, markerModifier: number | null, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, flagReason: string | null, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null } | null } | null, draftSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, score: number | null } | null };

export type WorkOutcomeFragment = { __typename?: 'WorkOutcome', id: string, workId: string, groupId: string | null, studentId: string | null, maxScore: number, automarkPending: boolean | null, feedbackReleased: boolean, feedbackReleasedTimestamp: string | null, finalScore: number | null, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, questionOutcomes: Array<{ __typename?: 'QuestionOutcome', id: string, questionId: string, blockSnapshot: { __typename?: 'BlockSnapshot', id: string, content: string, blockName: string | null, answerBlockId: string } | null, referencesBlockSnapshot: { __typename?: 'BlockSnapshot', id: string, content: string, blockName: string | null } | null, fieldOutcomes: Array<{ __typename?: 'FieldOutcome', id: string, identifier: string, fieldRubricId: string, score: number | null, automarkScore: number | null, automarkStatus: AutomarkStatus | null, answer: string | null, answers: Array<string> | null, answerSimilarity: number | null, docContent: string | null, docVersion: number | null, referencesDocContent: string | null, referencesDocVersion: number | null, comments: Array<{ __typename?: 'Comment', id: string }> | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } }>, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, automark: number | null } }>, draftSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, submittedAt: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, markerScope: MarkerScope, score: number | null, markerModifier: number | null, latestForType: boolean, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } } | null, finalSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, submittedAt: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, markerScope: MarkerScope, score: number | null, markerModifier: number | null, latestForType: boolean, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } } | null, submissionOutcomes: Array<{ __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, submittedAt: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, markerScope: MarkerScope, score: number | null, markerModifier: number | null, latestForType: boolean, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } }>, moderationSubmissionOutcomes: Array<{ __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, submittedAt: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, markerScope: MarkerScope, score: number | null, markerModifier: number | null, latestForType: boolean, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> }, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null, feedbackModerationId: string | null, bodyDoc: string | null, referencesDoc: string | null, markerModifier: number | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } | null } | null }>, markingSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, submittedAt: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, markerScope: MarkerScope, score: number | null, markerModifier: number | null, latestForType: boolean, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } } | null, workOutcomeRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, answerBlocks: Array<{ __typename?: 'AnswerBlock', id: string, nodeId: string, blockName: string | null, blockAttachments: Array<{ __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null, insertedAt: string | null, uploadedBy: { __typename?: 'User', id: string, name: string } | null }> }> };

export type WorkOutcomeMarkFragment = { __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, finalSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string } | null, markingSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string } | null };

export type WorkOutcomeReleaseFragment = { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null };

export type WorkOutcomeScoreFragment = { __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, maxScore: number, automarkPending: boolean | null, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } };

export type WorkOutcomeUpdatedFragment = { __typename?: 'WorkOutcome', id: string, workId: string, groupId: string | null, studentId: string | null, maxScore: number, finalScore: number | null, finalScorePenalty: number | null, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, draftSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, submittedAt: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, markerScope: MarkerScope, score: number | null, markerModifier: number | null, latestForType: boolean, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } } | null, finalSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, submittedAt: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, markerScope: MarkerScope, score: number | null, markerModifier: number | null, latestForType: boolean, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } } | null, questionOutcomes: Array<{ __typename?: 'QuestionOutcome', id: string, questionId: string, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, fieldOutcomes: Array<{ __typename?: 'FieldOutcome', id: string, identifier: string, fieldRubricId: string, score: number | null, automarkScore: number | null, automarkStatus: AutomarkStatus | null, answer: string | null, answers: Array<string> | null, answerSimilarity: number | null, docContent: string | null, docVersion: number | null, referencesDocContent: string | null, referencesDocVersion: number | null, comments: Array<{ __typename?: 'Comment', id: string }> | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } }> }>, provisionalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, finalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, moderationSubmissionOutcomes: Array<{ __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, markerScope: MarkerScope, score: number | null, markerModifier: number | null, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, flagReason: string | null, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null } | null }>, markingSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, markerScope: MarkerScope, score: number | null, markerModifier: number | null, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, flagReason: string | null, moderationOutcome: { __typename?: 'ModerationOutcome', score: number | null } | null } | null };

export type WorkRerouteQueryVariables = Exact<{
  workId: Scalars['ID']['input'];
}>;


export type WorkRerouteQuery = { __typename?: 'RootQueryType', work: { __typename?: 'Work', student: { __typename?: 'User', id: string }, group: { __typename?: 'Group', id: string, members: Array<{ __typename?: 'User', id: string }> } | null } };

export type OnboardingPayloadFragment = { __typename?: 'OnboardingPayload', subject: { __typename?: 'Subject', id: string, discipline: Discipline | null, name: string, label: string | null } | null, userSettings: { __typename?: 'UserSettings', id: string, subjectRole: SubjectRole | null, showIaOnboarding: boolean | null } | null };

export type CaptureOnboardingInputMutationVariables = Exact<{
  subjectId: Scalars['ID']['input'];
  subjectRole: SubjectRole;
  discipline: InputMaybe<Discipline>;
}>;


export type CaptureOnboardingInputMutation = { __typename?: 'RootMutationType', captureOnboardingInput: { __typename?: 'OnboardingPayload', subject: { __typename?: 'Subject', id: string, discipline: Discipline | null, name: string, label: string | null } | null, userSettings: { __typename?: 'UserSettings', id: string, subjectRole: SubjectRole | null, showIaOnboarding: boolean | null } | null } };

export type SaveGlobalUserSettingsMutationVariables = Exact<{
  userSettingsInput: GlobalUserSettingsInput;
}>;


export type SaveGlobalUserSettingsMutation = { __typename?: 'RootMutationType', saveGlobalUserSettings: { __typename?: 'SaveGlobalUserSettingsPayload', userSettings: { __typename?: 'UserSettings', showIaOnboarding: boolean | null } | null } };

export type UserSettingsFragment = { __typename?: 'UserSettings', id: string, subjectRole: SubjectRole | null, showIaOnboarding: boolean | null };

export type AddTagMutationVariables = Exact<{
  enrollmentId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
  column: Scalars['Int']['input'];
}>;


export type AddTagMutation = { __typename?: 'RootMutationType', addTag: { __typename?: 'Tag', text: string, column: number } };

export type AssessmentProjectIssuesQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type AssessmentProjectIssuesQuery = { __typename?: 'RootQueryType', assessmentProjectIssues: Array<{ __typename?: 'ProjectIssue', id: string, type: IssueType, status: IssueStatus, dueDate: string | null, parentId: string | null, assignees: Array<string>, groupId: string }> };

export type BulkAddTagMutationVariables = Exact<{
  enrollmentIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  text: Scalars['String']['input'];
  tab: ClassTab;
}>;


export type BulkAddTagMutation = { __typename?: 'RootMutationType', bulkAddTag: Array<{ __typename?: 'Tag', text: string, tab: ClassTab }> };

export type BulkRemoveTagMutationVariables = Exact<{
  enrollmentIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  text: Scalars['String']['input'];
  tab: ClassTab;
}>;


export type BulkRemoveTagMutation = { __typename?: 'RootMutationType', bulkRemoveTag: boolean };

export type DownloadPeerEvaluationDataMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  enrollmentId: Scalars['ID']['input'];
}>;


export type DownloadPeerEvaluationDataMutation = { __typename?: 'RootMutationType', downloadPeerEvaluationData: string };

export type DownloadSubmissionsMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  submissions: Array<SubmissionDetailInput> | SubmissionDetailInput;
  preferPdf: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DownloadSubmissionsMutation = { __typename?: 'RootMutationType', downloadSubmissions: string };

export type DownloadWorkArtifactsMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  workArtifacts: Array<WorkArtifactDetailInput> | WorkArtifactDetailInput;
}>;


export type DownloadWorkArtifactsMutation = { __typename?: 'RootMutationType', downloadWorkArtifacts: string };

export type EnrollmentFragment = { __typename?: 'Enrollment', id: string, sectionId: string | null, syncedAt: string | null, deleted: boolean, sisUserId: string | null, reentryCount: number, anonymousIndex: number | null, deletedBy: { __typename?: 'User', id: string, name: string } | null, user: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }, work: { __typename?: 'Work', id: string, startDate: string | null, updatedAt: string | null, lastSaveTime: string | null, attemptCount: number, finalResult: { __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number, memberSummaries: Array<{ __typename?: 'MemberSummary', lastAccess: string, accessCount: number, userId: string }> } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null } | null, draftResult: { __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number, memberSummaries: Array<{ __typename?: 'MemberSummary', lastAccess: string, accessCount: number, userId: string }> } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null } | null, features: { __typename?: 'WorkFeatures', id: string, enableWorkAuthority: boolean } } | null, tags: Array<{ __typename?: 'Tag', id: string, text: string, column: number, tab: ClassTab }>, workSettings: { __typename?: 'WorkSettings', id: string, studentId: string | null, dueDate: string | null, timeLimit: number | null, examReadingTime: number | null, examWritingTime: number | null, examStartDate: string | null, examEndDate: string | null, examDeferred: boolean | null, submitAttemptLimit: number | null, updatedAt: string | null, updateReason: string | null, draftExamStartDate: string | null, draftExamEndDate: string | null, groupId: string | null, vivaExtraAttempts: number | null, lastUpdatedBy: { __typename?: 'User', id: string, name: string } | null } | null, accessCode: { __typename?: 'AccessCode', code: string, label: string | null, active: boolean, type: AccessCodeType } | null, verifiedCodes: Array<{ __typename?: 'VerifiedCode', label: string | null, insertedAt: string | null }> | null };

export type EnrollmentTagsFragment = { __typename?: 'Enrollment', id: string, tags: Array<{ __typename?: 'Tag', text: string, column: number, tab: ClassTab }> };

export type EnrollmentsUpdatedSubscriptionVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type EnrollmentsUpdatedSubscription = { __typename?: 'RootSubscriptionType', enrollmentsUpdated: number };

export type ForceSubmissionsV2MutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  workIds: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
  type: SubmissionType;
  submittedAt: Scalars['DateTime']['input'];
}>;


export type ForceSubmissionsV2Mutation = { __typename?: 'RootMutationType', forceSubmissionsV2: Array<{ __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number, memberSummaries: Array<{ __typename?: 'MemberSummary', lastAccess: string, accessCount: number, userId: string }> } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null }> };

export type ForceSubmissionsMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  workIds: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
  type: SubmissionType;
  submittedAt: Scalars['DateTime']['input'];
}>;


export type ForceSubmissionsMutation = { __typename?: 'RootMutationType', forceSubmissions: Array<{ __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number, memberSummaries: Array<{ __typename?: 'MemberSummary', lastAccess: string, accessCount: number, userId: string }> } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null }> };

export type GrantGroupExtensionsMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  groupIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  input: GroupExtensionInput;
}>;


export type GrantGroupExtensionsMutation = { __typename?: 'RootMutationType', grantGroupExtensions: Array<{ __typename?: 'WorkSettings', id: string, studentId: string | null, dueDate: string | null, timeLimit: number | null, examReadingTime: number | null, examWritingTime: number | null, examStartDate: string | null, examEndDate: string | null, examDeferred: boolean | null, submitAttemptLimit: number | null, updatedAt: string | null, updateReason: string | null, draftExamStartDate: string | null, draftExamEndDate: string | null, groupId: string | null, vivaExtraAttempts: number | null, lastUpdatedBy: { __typename?: 'User', id: string, name: string } | null } | null> };

export type InsertSyncRosterJobMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  withExtensions: InputMaybe<Scalars['Boolean']['input']>;
  extensionConflictAction: InputMaybe<ExtensionConflictActionType>;
}>;


export type InsertSyncRosterJobMutation = { __typename?: 'RootMutationType', insertSyncRosterJob: { __typename?: 'BackgroundJob', id: string, kind: BackgroundJobKind, state: BackgroundJobState } };

export type ProjectIssueFragment = { __typename?: 'ProjectIssue', id: string, type: IssueType, status: IssueStatus, dueDate: string | null, parentId: string | null, assignees: Array<string>, groupId: string };

export type RemoveTagMutationVariables = Exact<{
  enrollmentId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
  column: Scalars['Int']['input'];
}>;


export type RemoveTagMutation = { __typename?: 'RootMutationType', removeTag: boolean };

export type ResultFragment = { __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number, memberSummaries: Array<{ __typename?: 'MemberSummary', lastAccess: string, accessCount: number, userId: string }> } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null };

export type ResultsUpdatedSubscriptionVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type ResultsUpdatedSubscription = { __typename?: 'RootSubscriptionType', resultsUpdated: Array<{ __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number, memberSummaries: Array<{ __typename?: 'MemberSummary', lastAccess: string, accessCount: number, userId: string }> } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null }> };

export type SendEmailsToClassMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  submissionIds: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
}>;


export type SendEmailsToClassMutation = { __typename?: 'RootMutationType', sendEmailsToClass: string };

export type SubmissionFragment = { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null };

export type SyncGradesMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type SyncGradesMutation = { __typename?: 'RootMutationType', syncGrades: boolean | null };

export type UpdateStudentSettingsMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  settings: Array<InputMaybe<StudentSettingsInput>> | InputMaybe<StudentSettingsInput>;
}>;


export type UpdateStudentSettingsMutation = { __typename?: 'RootMutationType', updateStudentSettings: Array<{ __typename?: 'WorkSettings', studentId: string | null, id: string, dueDate: string | null, timeLimit: number | null, examReadingTime: number | null, examWritingTime: number | null, examStartDate: string | null, examEndDate: string | null, examDeferred: boolean | null, submitAttemptLimit: number | null, updatedAt: string | null, updateReason: string | null, draftExamStartDate: string | null, draftExamEndDate: string | null, groupId: string | null, vivaExtraAttempts: number | null, lastUpdatedBy: { __typename?: 'User', id: string, name: string } | null } | null> };

export type UpdateWorkSettingsMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  enrollmentId: Scalars['ID']['input'];
  dueDate: InputMaybe<Scalars['DateTime']['input']>;
  timeLimit: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateWorkSettingsMutation = { __typename?: 'RootMutationType', updateWorkSettings: { __typename?: 'WorkSettings', id: string, dueDate: string | null, timeLimit: number | null } };

export type UpdateEnrollmentsStatusMutationVariables = Exact<{
  enrollmentIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  withdrawn: Scalars['Boolean']['input'];
  assessmentId: Scalars['ID']['input'];
}>;


export type UpdateEnrollmentsStatusMutation = { __typename?: 'RootMutationType', updateEnrollmentsStatus: Array<{ __typename?: 'Enrollment', id: string, sectionId: string | null, syncedAt: string | null, deleted: boolean, sisUserId: string | null, reentryCount: number, anonymousIndex: number | null, deletedBy: { __typename?: 'User', id: string, name: string } | null, user: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }, work: { __typename?: 'Work', id: string, startDate: string | null, updatedAt: string | null, lastSaveTime: string | null, attemptCount: number, finalResult: { __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number, memberSummaries: Array<{ __typename?: 'MemberSummary', lastAccess: string, accessCount: number, userId: string }> } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null } | null, draftResult: { __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number, memberSummaries: Array<{ __typename?: 'MemberSummary', lastAccess: string, accessCount: number, userId: string }> } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null } | null, features: { __typename?: 'WorkFeatures', id: string, enableWorkAuthority: boolean } } | null, tags: Array<{ __typename?: 'Tag', id: string, text: string, column: number, tab: ClassTab }>, workSettings: { __typename?: 'WorkSettings', id: string, studentId: string | null, dueDate: string | null, timeLimit: number | null, examReadingTime: number | null, examWritingTime: number | null, examStartDate: string | null, examEndDate: string | null, examDeferred: boolean | null, submitAttemptLimit: number | null, updatedAt: string | null, updateReason: string | null, draftExamStartDate: string | null, draftExamEndDate: string | null, groupId: string | null, vivaExtraAttempts: number | null, lastUpdatedBy: { __typename?: 'User', id: string, name: string } | null } | null, accessCode: { __typename?: 'AccessCode', code: string, label: string | null, active: boolean, type: AccessCodeType } | null, verifiedCodes: Array<{ __typename?: 'VerifiedCode', label: string | null, insertedAt: string | null }> | null }> };

export type VerifiedCodeFragment = { __typename?: 'VerifiedCode', label: string | null, insertedAt: string | null };

export type WorkArtifactFragment = { __typename?: 'WorkArtifact', id: string, name: string, taskHistoryId: string, submissionId: string, workId: string, studentSentAt: string | null, agsSentAt: string | null };

export type WorkFeaturesFragment = { __typename?: 'WorkFeatures', id: string, enableWorkAuthority: boolean };

export type WorkFragment = { __typename?: 'Work', id: string, startDate: string | null, updatedAt: string | null, lastSaveTime: string | null, attemptCount: number, finalResult: { __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number, memberSummaries: Array<{ __typename?: 'MemberSummary', lastAccess: string, accessCount: number, userId: string }> } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null } | null, draftResult: { __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number, memberSummaries: Array<{ __typename?: 'MemberSummary', lastAccess: string, accessCount: number, userId: string }> } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null } | null, features: { __typename?: 'WorkFeatures', id: string, enableWorkAuthority: boolean } };

export type WorkSettingsFragment = { __typename?: 'WorkSettings', id: string, studentId: string | null, dueDate: string | null, timeLimit: number | null, examReadingTime: number | null, examWritingTime: number | null, examStartDate: string | null, examEndDate: string | null, examDeferred: boolean | null, submitAttemptLimit: number | null, updatedAt: string | null, updateReason: string | null, draftExamStartDate: string | null, draftExamEndDate: string | null, groupId: string | null, vivaExtraAttempts: number | null, lastUpdatedBy: { __typename?: 'User', id: string, name: string } | null };

export type WorksSettingsUpdatedSubscriptionVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type WorksSettingsUpdatedSubscription = { __typename?: 'RootSubscriptionType', worksSettingsUpdated: Array<{ __typename?: 'WorkSettings', id: string, studentId: string | null, dueDate: string | null, timeLimit: number | null, examReadingTime: number | null, examWritingTime: number | null, examStartDate: string | null, examEndDate: string | null, examDeferred: boolean | null, submitAttemptLimit: number | null, updatedAt: string | null, updateReason: string | null, draftExamStartDate: string | null, draftExamEndDate: string | null, groupId: string | null, vivaExtraAttempts: number | null, lastUpdatedBy: { __typename?: 'User', id: string, name: string } | null } | null> };

export type AppendTagsForQuestionsMutationVariables = Exact<{
  id: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  input: Array<TagInput> | TagInput;
}>;


export type AppendTagsForQuestionsMutation = { __typename?: 'RootMutationType', appendTagsForQuestions: Array<{ __typename?: 'Question', id: string, cacheId: string, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string }> }> };

export type ArchiveQuestionMutationVariables = Exact<{
  questionId: Scalars['ID']['input'];
}>;


export type ArchiveQuestionMutation = { __typename?: 'RootMutationType', archiveQuestion: { __typename?: 'Question', id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string, subject: { __typename?: 'Subject', id: string, name: string } } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } | null };

export type ChildQuestionFragment = { __typename?: 'Question', id: string, parentQuestionId: string | null, libraryId: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, order: number | null, shuffle: boolean, difficulty: QuestionDifficulty | null, currentVersionId: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, versions: Array<{ __typename?: 'QuestionVersion', id: string, insertedAt: string, version: number | null, user: { __typename?: 'User', id: string, name: string } }> };

export type ChildQuestionVersionFragment = { __typename?: 'QuestionVersion', id: string, insertedAt: string, parentQuestionId: string | null, questionId: string, questionType: QuestionType, shortPrompt: string | null, version: number | null, order: number | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, user: { __typename?: 'User', id: string, name: string } };

export type CopyQuestionMutationVariables = Exact<{
  questionId: Scalars['ID']['input'];
}>;


export type CopyQuestionMutation = { __typename?: 'RootMutationType', copyQuestion: { __typename?: 'Question', id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string, subject: { __typename?: 'Subject', id: string, name: string } } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } };

export type CreateQuestionMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  childrenQuestions: InputMaybe<Array<QuestionAttributes> | QuestionAttributes>;
  input: QuestionAttributes;
  subjectId: Scalars['ID']['input'];
}>;


export type CreateQuestionMutation = { __typename?: 'RootMutationType', createQuestion: { __typename?: 'Question', id: string, cacheId: string, libraryId: string, parentQuestionId: string | null, currentVersionId: string | null, questionType: QuestionType, shortPrompt: string | null, points: number | null, shuffle: boolean, difficulty: QuestionDifficulty | null, order: number | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, childrenQuestions: Array<{ __typename?: 'Question', id: string, parentQuestionId: string | null, libraryId: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, order: number | null, shuffle: boolean, difficulty: QuestionDifficulty | null, currentVersionId: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, versions: Array<{ __typename?: 'QuestionVersion', id: string, insertedAt: string, version: number | null, user: { __typename?: 'User', id: string, name: string } }> }>, versions: Array<{ __typename?: 'QuestionVersion', id: string, insertedAt: string, version: number | null, user: { __typename?: 'User', id: string, name: string } }>, lastUpdatedBy: { __typename?: 'User', id: string, name: string } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string, subject: { __typename?: 'Subject', id: string, name: string } } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } };

export type CreateQuestionSelectionMutationVariables = Exact<{
  input: QuestionSelectionInput;
}>;


export type CreateQuestionSelectionMutation = { __typename?: 'RootMutationType', createQuestionSelection: { __typename?: 'CreateQuestionSelectionPayload', incompleteRuleIndex: number | null, selectedQuestionCount: number | null, requiredQuestionCount: number | null, selection: { __typename?: 'QuestionSelection', id: string, setsQuantity: number, sets: Array<{ __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, questionVersionId: string | null, question: { __typename?: 'Question', updatedAt: string | null, id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string, subject: { __typename?: 'Subject', id: string, name: string } } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } }> }> | null, rules: Array<{ __typename?: 'QuestionSelectionRule', id: string, points: number, quantity: number, questionType: QuestionType, difficulty: QuestionDifficulty | null }> } | null } };

export type CreateTagMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateTagMutation = { __typename?: 'RootMutationType', createTag: { __typename?: 'QuestionTag', id: string, name: string } };

export type FindSimilarQuestionsMutationVariables = Exact<{
  input: FindSimilarQuestionsInput;
}>;


export type FindSimilarQuestionsMutation = { __typename?: 'RootMutationType', findSimilarQuestions: { __typename?: 'SimilarQuestionsPayload', incompleteReplacement: boolean | null, questions: Array<{ __typename?: 'Question', id: string, cacheId: string }> | null } };

export type LibraryQuestionFragment = { __typename?: 'Question', id: string, cacheId: string, libraryId: string, parentQuestionId: string | null, currentVersionId: string | null, questionType: QuestionType, shortPrompt: string | null, points: number | null, shuffle: boolean, difficulty: QuestionDifficulty | null, order: number | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, childrenQuestions: Array<{ __typename?: 'Question', id: string, parentQuestionId: string | null, libraryId: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, order: number | null, shuffle: boolean, difficulty: QuestionDifficulty | null, currentVersionId: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, versions: Array<{ __typename?: 'QuestionVersion', id: string, insertedAt: string, version: number | null, user: { __typename?: 'User', id: string, name: string } }> }>, versions: Array<{ __typename?: 'QuestionVersion', id: string, insertedAt: string, version: number | null, user: { __typename?: 'User', id: string, name: string } }>, lastUpdatedBy: { __typename?: 'User', id: string, name: string } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string, subject: { __typename?: 'Subject', id: string, name: string } } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null };

export type LibraryQuestionOverviewFragment = { __typename?: 'Question', id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string, subject: { __typename?: 'Subject', id: string, name: string } } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null };

export type LibraryQuestionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LibraryQuestionQuery = { __typename?: 'RootQueryType', question: { __typename?: 'Question', id: string, cacheId: string, libraryId: string, parentQuestionId: string | null, currentVersionId: string | null, questionType: QuestionType, shortPrompt: string | null, points: number | null, shuffle: boolean, difficulty: QuestionDifficulty | null, order: number | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, childrenQuestions: Array<{ __typename?: 'Question', id: string, parentQuestionId: string | null, libraryId: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, order: number | null, shuffle: boolean, difficulty: QuestionDifficulty | null, currentVersionId: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, versions: Array<{ __typename?: 'QuestionVersion', id: string, insertedAt: string, version: number | null, user: { __typename?: 'User', id: string, name: string } }> }>, versions: Array<{ __typename?: 'QuestionVersion', id: string, insertedAt: string, version: number | null, user: { __typename?: 'User', id: string, name: string } }>, lastUpdatedBy: { __typename?: 'User', id: string, name: string } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string, subject: { __typename?: 'Subject', id: string, name: string } } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } | null, questionTagCategories: Array<{ __typename?: 'QuestionTagCategory', id: string, name: string }> };

export type LibraryQuestionsQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type LibraryQuestionsQuery = { __typename?: 'RootQueryType', libraryQuestions: Array<{ __typename?: 'Question', id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string, subject: { __typename?: 'Subject', id: string, name: string } } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null }>, assessment: { __typename?: 'Assessment', id: string, subjectId: string, name: string, settings: { __typename?: 'AssessmentSettings', id: string, vivaEnabled: boolean } | null, tasks: Array<{ __typename?: 'Task', id: string, kind: TaskKind, blocks: Array<{ __typename?: 'TaskBlock', id: string, libraryQuestionId: string | null, questionSelection: { __typename?: 'QuestionSelection', sets: Array<{ __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, questionVersionId: string | null, question: { __typename?: 'Question', updatedAt: string | null, id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string, subject: { __typename?: 'Subject', id: string, name: string } } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } }> }> | null } | null }> }> } };

export type PublishImportedQuestionsMutationVariables = Exact<{
  input: PublishImportedQuestionsInput;
}>;


export type PublishImportedQuestionsMutation = { __typename?: 'RootMutationType', publishImportedQuestions: Array<{ __typename?: 'Question', id: string, cacheId: string, libraryId: string, parentQuestionId: string | null, currentVersionId: string | null, questionType: QuestionType, shortPrompt: string | null, points: number | null, shuffle: boolean, difficulty: QuestionDifficulty | null, order: number | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, childrenQuestions: Array<{ __typename?: 'Question', id: string, parentQuestionId: string | null, libraryId: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, order: number | null, shuffle: boolean, difficulty: QuestionDifficulty | null, currentVersionId: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, versions: Array<{ __typename?: 'QuestionVersion', id: string, insertedAt: string, version: number | null, user: { __typename?: 'User', id: string, name: string } }> }>, versions: Array<{ __typename?: 'QuestionVersion', id: string, insertedAt: string, version: number | null, user: { __typename?: 'User', id: string, name: string } }>, lastUpdatedBy: { __typename?: 'User', id: string, name: string } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string, subject: { __typename?: 'Subject', id: string, name: string } } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null }> };

export type QuestionAssessmentFragment = { __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string, subject: { __typename?: 'Subject', id: string, name: string } } };

export type QuestionContentQueryVariables = Exact<{
  questionId: Scalars['ID']['input'];
}>;


export type QuestionContentQuery = { __typename?: 'RootQueryType', question: { __typename?: 'Question', id: string, cacheId: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, childrenQuestions: Array<{ __typename?: 'Question', id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string, subject: { __typename?: 'Subject', id: string, name: string } } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null }> } | null };

export type QuestionSelectionFragment = { __typename?: 'QuestionSelection', id: string, setsQuantity: number, sets: Array<{ __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, questionVersionId: string | null, question: { __typename?: 'Question', updatedAt: string | null, id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string, subject: { __typename?: 'Subject', id: string, name: string } } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } }> }> | null, rules: Array<{ __typename?: 'QuestionSelectionRule', id: string, points: number, quantity: number, questionType: QuestionType, difficulty: QuestionDifficulty | null }> };

export type QuestionSelectionQueryVariables = Exact<{
  questionSelectionId: Scalars['ID']['input'];
  assessmentId: Scalars['ID']['input'];
}>;


export type QuestionSelectionQuery = { __typename?: 'RootQueryType', questionSelection: { __typename?: 'QuestionSelection', id: string, setsQuantity: number, sets: Array<{ __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, questionVersionId: string | null, question: { __typename?: 'Question', updatedAt: string | null, id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string, subject: { __typename?: 'Subject', id: string, name: string } } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } }> }> | null, rules: Array<{ __typename?: 'QuestionSelectionRule', id: string, points: number, quantity: number, questionType: QuestionType, difficulty: QuestionDifficulty | null }> } | null, assessment: { __typename?: 'Assessment', id: string, name: string, subjectId: string, settings: { __typename?: 'AssessmentSettings', id: string, vivaEnabled: boolean } | null, tasks: Array<{ __typename?: 'Task', id: string, kind: TaskKind }> } };

export type QuestionSelectionRuleFragment = { __typename?: 'QuestionSelectionRule', id: string, points: number, quantity: number, questionType: QuestionType, difficulty: QuestionDifficulty | null };

export type QuestionSetFragment = { __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, questionVersionId: string | null, question: { __typename?: 'Question', updatedAt: string | null, id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string, subject: { __typename?: 'Subject', id: string, name: string } } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } }> };

export type QuestionSetQuestionFragment = { __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, questionVersionId: string | null, question: { __typename?: 'Question', updatedAt: string | null, id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string, subject: { __typename?: 'Subject', id: string, name: string } } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } };

export type QuestionSourceFileFragment = { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null };

export type QuestionTagCategoryFragment = { __typename?: 'QuestionTagCategory', id: string, name: string };

export type QuestionTagFragment = { __typename?: 'QuestionTag', id: string, name: string, categoryId: string };

export type QuestionVersionFragment = { __typename?: 'QuestionVersion', id: string, insertedAt: string, parentQuestionId: string | null, questionId: string, questionType: QuestionType, shortPrompt: string | null, user: { __typename?: 'User', id: string, name: string }, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, childrenQuestions: Array<{ __typename?: 'QuestionVersion', id: string, insertedAt: string, parentQuestionId: string | null, questionId: string, questionType: QuestionType, shortPrompt: string | null, version: number | null, order: number | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, user: { __typename?: 'User', id: string, name: string } }> };

export type QuestionVersionQueryVariables = Exact<{
  versionId: Scalars['ID']['input'];
}>;


export type QuestionVersionQuery = { __typename?: 'RootQueryType', questionVersion: { __typename?: 'QuestionVersion', id: string, insertedAt: string, parentQuestionId: string | null, questionId: string, questionType: QuestionType, shortPrompt: string | null, user: { __typename?: 'User', id: string, name: string }, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, childrenQuestions: Array<{ __typename?: 'QuestionVersion', id: string, insertedAt: string, parentQuestionId: string | null, questionId: string, questionType: QuestionType, shortPrompt: string | null, version: number | null, order: number | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, user: { __typename?: 'User', id: string, name: string } }> } | null };

export type QuestionVersionSummaryFragment = { __typename?: 'QuestionVersion', id: string, insertedAt: string, version: number | null, user: { __typename?: 'User', id: string, name: string } };

export type RegenerateQuestionSetMutationVariables = Exact<{
  input: RegenerateQuestionSetInput;
}>;


export type RegenerateQuestionSetMutation = { __typename?: 'RootMutationType', regenerateQuestionSet: { __typename?: 'RegenerateQuestionSetPayload', incompleteReplacement: boolean | null, questionSet: { __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, questionVersionId: string | null, question: { __typename?: 'Question', updatedAt: string | null, id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string, subject: { __typename?: 'Subject', id: string, name: string } } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } }> } | null } };

export type RegisterQuestionSourceFileMutationVariables = Exact<{
  input: RegisterQuestionSourceFileInput;
}>;


export type RegisterQuestionSourceFileMutation = { __typename?: 'RootMutationType', registerQuestionSourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } };

export type RemoveQuestionsUniformlyMutationVariables = Exact<{
  input: RemoveQuestionsUniformlyInput;
}>;


export type RemoveQuestionsUniformlyMutation = { __typename?: 'RootMutationType', removeQuestionsUniformly: { __typename?: 'QuestionSelection', id: string, setsQuantity: number, sets: Array<{ __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, questionVersionId: string | null, question: { __typename?: 'Question', updatedAt: string | null, id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string, subject: { __typename?: 'Subject', id: string, name: string } } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } }> }> | null, rules: Array<{ __typename?: 'QuestionSelectionRule', id: string, points: number, quantity: number, questionType: QuestionType, difficulty: QuestionDifficulty | null }> } };

export type ReplaceQuestionInSetMutationVariables = Exact<{
  input: ReplaceQuestionInSetInput;
}>;


export type ReplaceQuestionInSetMutation = { __typename?: 'RootMutationType', replaceQuestionInSet: { __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, questionVersionId: string | null, question: { __typename?: 'Question', updatedAt: string | null, id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string, subject: { __typename?: 'Subject', id: string, name: string } } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } }> } };

export type UpdateQuestionAttributesMutationVariables = Exact<{
  questionIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  input: QuestionAttributesInput;
}>;


export type UpdateQuestionAttributesMutation = { __typename?: 'RootMutationType', updateQuestionAttributes: Array<{ __typename?: 'Question', id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string, subject: { __typename?: 'Subject', id: string, name: string } } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null }> };

export type UpdateQuestionMutationVariables = Exact<{
  questionId: Scalars['ID']['input'];
  input: QuestionAttributesInput;
}>;


export type UpdateQuestionMutation = { __typename?: 'RootMutationType', updateQuestion: { __typename?: 'Question', id: string, cacheId: string, libraryId: string, parentQuestionId: string | null, currentVersionId: string | null, questionType: QuestionType, shortPrompt: string | null, points: number | null, shuffle: boolean, difficulty: QuestionDifficulty | null, order: number | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, childrenQuestions: Array<{ __typename?: 'Question', id: string, parentQuestionId: string | null, libraryId: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, order: number | null, shuffle: boolean, difficulty: QuestionDifficulty | null, currentVersionId: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, versions: Array<{ __typename?: 'QuestionVersion', id: string, insertedAt: string, version: number | null, user: { __typename?: 'User', id: string, name: string } }> }>, versions: Array<{ __typename?: 'QuestionVersion', id: string, insertedAt: string, version: number | null, user: { __typename?: 'User', id: string, name: string } }>, lastUpdatedBy: { __typename?: 'User', id: string, name: string } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string, subject: { __typename?: 'Subject', id: string, name: string } } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } };

export type UpdateQuestionSourceFileMutationVariables = Exact<{
  input: UpdateQuestionSourceFileInput;
}>;


export type UpdateQuestionSourceFileMutation = { __typename?: 'RootMutationType', updateQuestionSourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } };

export type UpdateQuestionVersionMutationVariables = Exact<{
  input: UpdateQuestionVersionInput;
  childrenQuestions: Array<UpdateQuestionVersionInput> | UpdateQuestionVersionInput;
}>;


export type UpdateQuestionVersionMutation = { __typename?: 'RootMutationType', updateQuestionVersion: { __typename?: 'Question', id: string, cacheId: string, libraryId: string, parentQuestionId: string | null, currentVersionId: string | null, questionType: QuestionType, shortPrompt: string | null, points: number | null, shuffle: boolean, difficulty: QuestionDifficulty | null, order: number | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, childrenQuestions: Array<{ __typename?: 'Question', id: string, parentQuestionId: string | null, libraryId: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, order: number | null, shuffle: boolean, difficulty: QuestionDifficulty | null, currentVersionId: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, versions: Array<{ __typename?: 'QuestionVersion', id: string, insertedAt: string, version: number | null, user: { __typename?: 'User', id: string, name: string } }> }>, versions: Array<{ __typename?: 'QuestionVersion', id: string, insertedAt: string, version: number | null, user: { __typename?: 'User', id: string, name: string } }>, lastUpdatedBy: { __typename?: 'User', id: string, name: string } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string, subject: { __typename?: 'Subject', id: string, name: string } } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } };

export type UpdateTagsForQuestionMutationVariables = Exact<{
  questionId: Scalars['ID']['input'];
  input: Array<TagInput> | TagInput;
}>;


export type UpdateTagsForQuestionMutation = { __typename?: 'RootMutationType', updateTagsForQuestion: { __typename?: 'Question', id: string, cacheId: string, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }> } };

export type CreateSchoolyearDashboardUrlMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type CreateSchoolyearDashboardUrlMutation = { __typename?: 'RootMutationType', createSchoolyearDashboardUrl: { __typename?: 'CreateSchoolyearDashboardUrlPayload', url: string | null } | null };

export type CreateSchoolyearSettingsUrlMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type CreateSchoolyearSettingsUrlMutation = { __typename?: 'RootMutationType', createSchoolyearSettingsUrl: { __typename?: 'CreateSchoolyearSettingsUrlPayload', url: string | null } | null };

export type SchoolyearExamFragment = { __typename?: 'SchoolyearExam', id: string, pushStatus: SchoolyearExamPushStatus };

export type OnSchoolyearExamUpdatedSubscriptionVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type OnSchoolyearExamUpdatedSubscription = { __typename?: 'RootSubscriptionType', schoolyearExamUpdated: { __typename?: 'SchoolyearExam', id: string, pushStatus: SchoolyearExamPushStatus } };

export type AssessmentSentimentQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type AssessmentSentimentQuery = { __typename?: 'RootQueryType', assessmentSentimentChecks: Array<{ __typename?: 'SentimentCheck', id: string, skipped: boolean, level: SentimentCheckLevel | null, order: number, comment: string | null, insertedAt: string | null, user: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } }> };

export type SentimentCheckFragment = { __typename?: 'SentimentCheck', id: string, skipped: boolean, level: SentimentCheckLevel | null, order: number, comment: string | null, insertedAt: string | null, user: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } };

export type SentimentQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  groupId: Scalars['ID']['input'];
}>;


export type SentimentQuery = { __typename?: 'RootQueryType', assessment: { __typename?: 'Assessment', id: string, name: string, subjectName: string, subjectId: string, dueDate: string | null, gradingDueDate: string | null, startDate: string | null, endDate: string | null, edition: number, subject: { __typename?: 'Subject', id: string, discipline: Discipline | null, name: string, label: string | null }, ltiTool: { __typename?: 'InstitutionTool', id: string, name: string | null, familyCode: string | null }, ltiServices: Array<{ __typename?: 'LtiService', id: string, name: string, version: string, issuer: string | null, metaUrl: string | null, isLtiPluginAgs: boolean }>, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, groupDraftDueDate: string | null, groupDraftEnabled: boolean, individualDraftFeedbackAlwaysAvailable: boolean, groupDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, submitAttemptLimit: number | null, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, rubricDisplayDisabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, examReentryPreventionEnabled: boolean, examInactivityTimeout: number | null, examSchoolyearEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckSkipEnabled: boolean, sentimentCheckIntervalInHr: number | null, sentimentCheckFirstCheckAt: string | null, sentimentCheckScheduleType: SentimentCheckScheduleType, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, peerEvaluationMode: PeerEvaluationMode, peerEvaluationMinScaleFactor: number, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMode: SelfEvaluationMode, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterAcceptanceRequired: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, vivaEnabled: boolean, vivaReattemptWindowTime: number | null, vivaCameraRequiredDisabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, sentimentCheckSchedules: Array<{ __typename?: 'SentimentCheckSchedule', id: string, scheduledAt: string }> | null, vivaSourceTask: { __typename?: 'VivaSourceTask', id: string, assessmentId: string, name: string } | null } | null, ltiCustomParams: { __typename?: 'CustomParams', moodleAttemptReopenMethod: string | null } | null, schoolyearExam: { __typename?: 'SchoolyearExam', id: string, pushStatus: SchoolyearExamPushStatus } | null }, groupSentimentChecks: Array<{ __typename?: 'SentimentCheck', id: string, skipped: boolean, level: SentimentCheckLevel | null, order: number, comment: string | null, insertedAt: string | null, user: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } }>, class: { __typename?: 'Class', groups: Array<{ __typename?: 'Group', id: string, name: string, markerId: string | null, code: string | null, sectionId: string | null, questionId: string | null, maxLimit: number | null, minLimit: number | null, finalised: boolean, finalisedAt: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, members: Array<{ __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }>, groupMembers: Array<{ __typename?: 'GroupMember', id: string, colourset: number, user: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, groupMarkers: Array<{ __typename?: 'GroupMarker', id: string, role: MarkerRole, markerPlaceholder: string | null, groupMemberId: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null }> }>, tags: Array<{ __typename?: 'GroupTag', id: string, text: string }>, workSettings: { __typename?: 'WorkSettings', id: string, dueDate: string | null, groupId: string | null } | null }> } };

export type SocraticDialogueFragment = { __typename?: 'SocraticDialogue', id: string, attemptNumber: number, turns: Array<{ __typename?: 'SocraticTurn', id: string, generated: boolean, questionPrompt: string | null, response: { __typename?: 'TurnResponse', mediaUrl: string | null, durationSeconds: number | null } | null }> };

export type SocraticDialoguesQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  dialogueIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type SocraticDialoguesQuery = { __typename?: 'RootQueryType', socraticDialogues: Array<{ __typename?: 'SocraticDialogue', id: string, attemptNumber: number, turns: Array<{ __typename?: 'SocraticTurn', id: string, generated: boolean, questionPrompt: string | null, response: { __typename?: 'TurnResponse', mediaUrl: string | null, durationSeconds: number | null } | null }> }> };

export type SocraticQuestionFragment = { __typename?: 'SocraticQuestion', id: string, content: string | null, error: string | null, status: SocraticQuestionStatus, student: { __typename?: 'User', id: string, name: string } | null };

export type SocraticQuestionerPreviewFragment = { __typename?: 'SocraticQuestionerPreview', id: string, taskBlock: { __typename?: 'TaskBlock', id: string, points: number | null, shuffle: boolean, hidden: boolean, socraticQuestionerEnabled: boolean, previousNodeId: string | null, parentNodeId: string | null, nodeId: string, libraryQuestionId: string | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null }, questionerRuns: Array<{ __typename?: 'SocraticQuestionerRun', id: string, baseQuestion: string, sourceTaskId: string, socraticQuestions: Array<{ __typename?: 'SocraticQuestion', id: string, content: string | null, error: string | null, status: SocraticQuestionStatus, student: { __typename?: 'User', id: string, name: string } | null } | null> | null }> };

export type SocraticQuestionerPreviewQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
  input: SocraticQuestionerPreviewInput;
}>;


export type SocraticQuestionerPreviewQuery = { __typename?: 'RootQueryType', assessment: { __typename?: 'Assessment', id: string, settings: { __typename?: 'AssessmentSettings', vivaSourceTask: { __typename?: 'VivaSourceTask', id: string, assessmentId: string, name: string } | null } | null }, socraticQuestionerPreview: { __typename?: 'SocraticQuestionerPreview', id: string, taskBlock: { __typename?: 'TaskBlock', id: string, points: number | null, shuffle: boolean, hidden: boolean, socraticQuestionerEnabled: boolean, previousNodeId: string | null, parentNodeId: string | null, nodeId: string, libraryQuestionId: string | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null }, questionerRuns: Array<{ __typename?: 'SocraticQuestionerRun', id: string, baseQuestion: string, sourceTaskId: string, socraticQuestions: Array<{ __typename?: 'SocraticQuestion', id: string, content: string | null, error: string | null, status: SocraticQuestionStatus, student: { __typename?: 'User', id: string, name: string } | null } | null> | null }> } };

export type SocraticQuestionerRunFragment = { __typename?: 'SocraticQuestionerRun', id: string, baseQuestion: string, sourceTaskId: string, socraticQuestions: Array<{ __typename?: 'SocraticQuestion', id: string, content: string | null, error: string | null, status: SocraticQuestionStatus, student: { __typename?: 'User', id: string, name: string } | null } | null> | null };

export type SocraticQuestionerRunUpdatedSubscriptionVariables = Exact<{
  runId: Scalars['ID']['input'];
}>;


export type SocraticQuestionerRunUpdatedSubscription = { __typename?: 'RootSubscriptionType', socraticQuestionerRunUpdated: { __typename?: 'SocraticQuestion', id: string, content: string | null, error: string | null, status: SocraticQuestionStatus, student: { __typename?: 'User', id: string, name: string } | null } };

export type SocraticTranscriptQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  dialogueId: Scalars['ID']['input'];
}>;


export type SocraticTranscriptQuery = { __typename?: 'RootQueryType', socraticTranscript: { __typename?: 'SocraticTranscription', status: SocraticTranscriptionStatus, error: string | null, text: string | null, segments: Array<{ __typename?: 'SocraticTranscriptSegment', text: string, startTime: number, endTime: number }> | null } | null };

export type SocraticTranscriptionUpdatedSubscriptionVariables = Exact<{
  dialogueId: Scalars['ID']['input'];
}>;


export type SocraticTranscriptionUpdatedSubscription = { __typename?: 'RootSubscriptionType', socraticTranscriptionUpdated: { __typename?: 'SocraticTranscriptionOutcome', turnId: string, dialogueId: string, status: SocraticTranscriptionStatus, error: string | null } };

export type SocraticTurnFragment = { __typename?: 'SocraticTurn', id: string, generated: boolean, questionPrompt: string | null, response: { __typename?: 'TurnResponse', mediaUrl: string | null, durationSeconds: number | null } | null };

export type StartSocraticQuestionerRunMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  input: StartSocraticQuestionerRunInput;
}>;


export type StartSocraticQuestionerRunMutation = { __typename?: 'RootMutationType', startSocraticQuestionerRun: { __typename?: 'SocraticQuestionerRunPayload', error: StartSocraticQuestionerRunError | null, run: { __typename?: 'SocraticQuestionerRun', id: string, baseQuestion: string, sourceTaskId: string, socraticQuestions: Array<{ __typename?: 'SocraticQuestion', id: string, content: string | null, error: string | null, status: SocraticQuestionStatus, student: { __typename?: 'User', id: string, name: string } | null } | null> | null } | null } };

export type StudentWorkOutcomePreviewQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
}>;


export type StudentWorkOutcomePreviewQuery = { __typename?: 'RootQueryType', assessment: { __typename?: 'Assessment', id: string, name: string }, studentWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, student: { __typename?: 'User', id: string, name: string } | null, finalSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, submittedAt: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, markerScope: MarkerScope, score: number | null, markerModifier: number | null, latestForType: boolean, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } } | null, answerBlocks: Array<{ __typename?: 'AnswerBlock', id: string, nodeId: string, blockName: string | null, blockAttachments: Array<{ __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null, insertedAt: string | null, uploadedBy: { __typename?: 'User', id: string, name: string } | null }> }> } | null };

export type TaskBlockQuestionerFragment = { __typename?: 'TaskBlock', id: string, points: number | null, shuffle: boolean, hidden: boolean, socraticQuestionerEnabled: boolean, previousNodeId: string | null, parentNodeId: string | null, nodeId: string, libraryQuestionId: string | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null };

export type WorkOutcomePreviewFragment = { __typename?: 'WorkOutcome', id: string, workId: string, student: { __typename?: 'User', id: string, name: string } | null, finalSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, submissionType: SubmissionType, submittedAt: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, markerScope: MarkerScope, score: number | null, markerModifier: number | null, latestForType: boolean, completedAt: string | null, scoreModeration: ScoreModerationDecision | null, feedbackModeration: FeedbackModerationDecision | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null, updatedAt: string | null, publishedAt: string | null }> } } | null, answerBlocks: Array<{ __typename?: 'AnswerBlock', id: string, nodeId: string, blockName: string | null, blockAttachments: Array<{ __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null, insertedAt: string | null, uploadedBy: { __typename?: 'User', id: string, name: string } | null }> }> };

export type AccessCodeFragment = { __typename?: 'AccessCode', code: string, label: string | null, active: boolean, type: AccessCodeType };

export type AddLibraryQuestionsToTaskMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  questionIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type AddLibraryQuestionsToTaskMutation = { __typename?: 'RootMutationType', addLibraryQuestionsToTask: Array<{ __typename?: 'TaskBlock', id: string, previousNodeId: string | null, nodeId: string, parentNodeId: string | null, deleted: boolean, hidden: boolean, quantity: number | null, shuffle: boolean, points: number | null, order: number | null, orderLabel: string | null, libraryQuestionId: string | null, libraryQuestionVersionId: string | null, socraticQuestionerEnabled: boolean, updatedAt: string | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null, questionSelection: { __typename?: 'QuestionSelection', id: string, sets: Array<{ __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, questionVersionId: string | null, question: { __typename?: 'Question', updatedAt: string | null, id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string, subject: { __typename?: 'Subject', id: string, name: string } } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } }> }> | null } | null, markerRubric: { __typename?: 'MarkerRubric', id: string, assessmentId: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, hasChanges: boolean, state: MarkerRubricState, updatedAt: string | null, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, hasOutcomes: boolean, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null }> };

export type AddQuestionSelectionToTaskMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  questionSelectionId: Scalars['ID']['input'];
}>;


export type AddQuestionSelectionToTaskMutation = { __typename?: 'RootMutationType', addQuestionSelectionToTask: { __typename?: 'TaskBlock', id: string, previousNodeId: string | null, nodeId: string, parentNodeId: string | null, deleted: boolean, hidden: boolean, quantity: number | null, shuffle: boolean, points: number | null, order: number | null, orderLabel: string | null, libraryQuestionId: string | null, libraryQuestionVersionId: string | null, socraticQuestionerEnabled: boolean, updatedAt: string | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null, questionSelection: { __typename?: 'QuestionSelection', id: string, sets: Array<{ __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, questionVersionId: string | null, question: { __typename?: 'Question', updatedAt: string | null, id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string, subject: { __typename?: 'Subject', id: string, name: string } } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } }> }> | null } | null, markerRubric: { __typename?: 'MarkerRubric', id: string, assessmentId: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, hasChanges: boolean, state: MarkerRubricState, updatedAt: string | null, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, hasOutcomes: boolean, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null } };

export type AssessmentAccessCodesQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type AssessmentAccessCodesQuery = { __typename?: 'RootQueryType', assessmentAccessCodes: Array<{ __typename?: 'AccessCode', code: string, label: string | null, active: boolean, type: AccessCodeType }> | null };

export type AssessmentFragment = { __typename?: 'Assessment', id: string, name: string, subjectName: string, subjectId: string, dueDate: string | null, gradingDueDate: string | null, startDate: string | null, endDate: string | null, edition: number, subject: { __typename?: 'Subject', id: string, discipline: Discipline | null, name: string, label: string | null }, ltiTool: { __typename?: 'InstitutionTool', id: string, name: string | null, familyCode: string | null }, ltiServices: Array<{ __typename?: 'LtiService', id: string, name: string, version: string, issuer: string | null, metaUrl: string | null, isLtiPluginAgs: boolean }>, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, groupDraftDueDate: string | null, groupDraftEnabled: boolean, individualDraftFeedbackAlwaysAvailable: boolean, groupDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, submitAttemptLimit: number | null, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, rubricDisplayDisabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, examReentryPreventionEnabled: boolean, examInactivityTimeout: number | null, examSchoolyearEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckSkipEnabled: boolean, sentimentCheckIntervalInHr: number | null, sentimentCheckFirstCheckAt: string | null, sentimentCheckScheduleType: SentimentCheckScheduleType, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, peerEvaluationMode: PeerEvaluationMode, peerEvaluationMinScaleFactor: number, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMode: SelfEvaluationMode, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterAcceptanceRequired: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, vivaEnabled: boolean, vivaReattemptWindowTime: number | null, vivaCameraRequiredDisabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, sentimentCheckSchedules: Array<{ __typename?: 'SentimentCheckSchedule', id: string, scheduledAt: string }> | null, vivaSourceTask: { __typename?: 'VivaSourceTask', id: string, assessmentId: string, name: string } | null } | null, ltiCustomParams: { __typename?: 'CustomParams', moodleAttemptReopenMethod: string | null } | null, schoolyearExam: { __typename?: 'SchoolyearExam', id: string, pushStatus: SchoolyearExamPushStatus } | null };

export type AssessmentSettingsFragment = { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, groupDraftDueDate: string | null, groupDraftEnabled: boolean, individualDraftFeedbackAlwaysAvailable: boolean, groupDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, submitAttemptLimit: number | null, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, rubricDisplayDisabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, examReentryPreventionEnabled: boolean, examInactivityTimeout: number | null, examSchoolyearEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckSkipEnabled: boolean, sentimentCheckIntervalInHr: number | null, sentimentCheckFirstCheckAt: string | null, sentimentCheckScheduleType: SentimentCheckScheduleType, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, peerEvaluationMode: PeerEvaluationMode, peerEvaluationMinScaleFactor: number, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMode: SelfEvaluationMode, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterAcceptanceRequired: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, vivaEnabled: boolean, vivaReattemptWindowTime: number | null, vivaCameraRequiredDisabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, sentimentCheckSchedules: Array<{ __typename?: 'SentimentCheckSchedule', id: string, scheduledAt: string }> | null, vivaSourceTask: { __typename?: 'VivaSourceTask', id: string, assessmentId: string, name: string } | null };

export type AssessmentSettingsSubscriptionVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type AssessmentSettingsSubscription = { __typename?: 'RootSubscriptionType', assessmentSettings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, groupDraftDueDate: string | null, groupDraftEnabled: boolean, individualDraftFeedbackAlwaysAvailable: boolean, groupDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, submitAttemptLimit: number | null, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, rubricDisplayDisabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, examReentryPreventionEnabled: boolean, examInactivityTimeout: number | null, examSchoolyearEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckSkipEnabled: boolean, sentimentCheckIntervalInHr: number | null, sentimentCheckFirstCheckAt: string | null, sentimentCheckScheduleType: SentimentCheckScheduleType, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, peerEvaluationMode: PeerEvaluationMode, peerEvaluationMinScaleFactor: number, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMode: SelfEvaluationMode, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterAcceptanceRequired: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, vivaEnabled: boolean, vivaReattemptWindowTime: number | null, vivaCameraRequiredDisabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, sentimentCheckSchedules: Array<{ __typename?: 'SentimentCheckSchedule', id: string, scheduledAt: string }> | null, vivaSourceTask: { __typename?: 'VivaSourceTask', id: string, assessmentId: string, name: string } | null } };

export type CancelReleaseMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  sheetId: Scalars['ID']['input'];
}>;


export type CancelReleaseMutation = { __typename?: 'RootMutationType', cancelRelease: { __typename?: 'CancelReleasePayload', task: { __typename?: 'Task', id: string, status: Status } } };

export type ChangeAssessmentPresetMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  preset: AssessmentPreset;
}>;


export type ChangeAssessmentPresetMutation = { __typename?: 'RootMutationType', changeAssessmentPreset: { __typename?: 'ChangeAssessmentPresetResult', task: { __typename?: 'Task', id: string, kind: TaskKind, format: TaskFormat | null }, assessmentSettings: { __typename?: 'AssessmentSettings', id: string, vivaEnabled: boolean, groupAssessmentEnabled: boolean } } };

export type CreatePrintArchiveMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  input: PrintArchiveInput;
}>;


export type CreatePrintArchiveMutation = { __typename?: 'RootMutationType', createPrintArchive: string };

export type CreateResourceMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  taskId: InputMaybe<Scalars['ID']['input']>;
  url: Scalars['String']['input'];
  name: Scalars['String']['input'];
  mediaId: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateResourceMutation = { __typename?: 'RootMutationType', createResource: { __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean } };

export type CreateTaskBlockMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  input: CreateTaskBlockInput;
}>;


export type CreateTaskBlockMutation = { __typename?: 'RootMutationType', createTaskBlock: { __typename?: 'TaskBlock', id: string, previousNodeId: string | null, nodeId: string, parentNodeId: string | null, deleted: boolean, hidden: boolean, quantity: number | null, shuffle: boolean, points: number | null, order: number | null, orderLabel: string | null, libraryQuestionId: string | null, libraryQuestionVersionId: string | null, socraticQuestionerEnabled: boolean, updatedAt: string | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null, questionSelection: { __typename?: 'QuestionSelection', id: string, sets: Array<{ __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, questionVersionId: string | null, question: { __typename?: 'Question', updatedAt: string | null, id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string, subject: { __typename?: 'Subject', id: string, name: string } } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } }> }> | null } | null, markerRubric: { __typename?: 'MarkerRubric', id: string, assessmentId: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, hasChanges: boolean, state: MarkerRubricState, updatedAt: string | null, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, hasOutcomes: boolean, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null } };

export type CreateTaskSaveMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
  editor: InputMaybe<EditorType>;
  taskId: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateTaskSaveMutation = { __typename?: 'RootMutationType', createTaskSave: { __typename?: 'SaveState', id: string, serverId: string, version: number, rawContent: string | null } };

export type DeleteGenaiGuidelineNoticeMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
}>;


export type DeleteGenaiGuidelineNoticeMutation = { __typename?: 'RootMutationType', deleteGenaiGuidelineNotice: { __typename?: 'Task', id: string, genaiGuidelineNotice: { __typename?: 'TaskNotice', id: string, version: number, content: string } | null } };

export type DeleteResourceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteResourceMutation = { __typename?: 'RootMutationType', deleteResource: { __typename?: 'Resource', id: string, invalidated: boolean } };

export type DuplicateTaskBlockMutationVariables = Exact<{
  taskBlockId: Scalars['ID']['input'];
}>;


export type DuplicateTaskBlockMutation = { __typename?: 'RootMutationType', duplicateTaskBlock: Array<{ __typename?: 'TaskBlock', id: string, previousNodeId: string | null, nodeId: string, parentNodeId: string | null, deleted: boolean, hidden: boolean, quantity: number | null, shuffle: boolean, points: number | null, order: number | null, orderLabel: string | null, libraryQuestionId: string | null, libraryQuestionVersionId: string | null, socraticQuestionerEnabled: boolean, updatedAt: string | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null, questionSelection: { __typename?: 'QuestionSelection', id: string, sets: Array<{ __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, questionVersionId: string | null, question: { __typename?: 'Question', updatedAt: string | null, id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string, subject: { __typename?: 'Subject', id: string, name: string } } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } }> }> | null } | null, markerRubric: { __typename?: 'MarkerRubric', id: string, assessmentId: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, hasChanges: boolean, state: MarkerRubricState, updatedAt: string | null, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, hasOutcomes: boolean, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null }> };

export type EditTaskMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type EditTaskMutation = { __typename?: 'RootMutationType', editTask: { __typename?: 'Task', id: string, status: Status } };

export type EditTaskV2MutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
}>;


export type EditTaskV2Mutation = { __typename?: 'RootMutationType', editTaskV2: { __typename?: 'Task', id: string, kind: TaskKind, status: Status, saveState: { __typename?: 'SaveState', id: string, version: number, rawContent: string | null }, genaiGuidelineNotice: { __typename?: 'TaskNotice', id: string } | null } };

export type GenerateReportMutationVariables = Exact<{
  kind: Scalars['String']['input'];
  assessmentId: Scalars['ID']['input'];
  workId: InputMaybe<Scalars['ID']['input']>;
  anonymousName: InputMaybe<Scalars['String']['input']>;
  studentId: InputMaybe<Scalars['ID']['input']>;
}>;


export type GenerateReportMutation = { __typename?: 'RootMutationType', generateReport: { __typename?: 'Job', id: string, assessmentId: string, conflict: boolean, resultUrl: string | null, insertedAt: string } };

export type HasSubmissionSubscriptionVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type HasSubmissionSubscription = { __typename?: 'RootSubscriptionType', hasSubmission: boolean };

export type HubTaskFragment = { __typename?: 'Task', id: string, kind: TaskKind, status: Status, saveState: { __typename?: 'SaveState', id: string, version: number, rawContent: string | null }, genaiGuidelineNotice: { __typename?: 'TaskNotice', id: string } | null };

export type ImportLibraryQuestionMutationVariables = Exact<{
  input: ImportLibraryQuestionInput;
}>;


export type ImportLibraryQuestionMutation = { __typename?: 'RootMutationType', importLibraryQuestion: { __typename?: 'TaskBlock', id: string, previousNodeId: string | null, nodeId: string, parentNodeId: string | null, deleted: boolean, hidden: boolean, quantity: number | null, shuffle: boolean, points: number | null, order: number | null, orderLabel: string | null, libraryQuestionId: string | null, libraryQuestionVersionId: string | null, socraticQuestionerEnabled: boolean, updatedAt: string | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null, questionSelection: { __typename?: 'QuestionSelection', id: string, sets: Array<{ __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, questionVersionId: string | null, question: { __typename?: 'Question', updatedAt: string | null, id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string, subject: { __typename?: 'Subject', id: string, name: string } } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } }> }> | null } | null, markerRubric: { __typename?: 'MarkerRubric', id: string, assessmentId: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, hasChanges: boolean, state: MarkerRubricState, updatedAt: string | null, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, hasOutcomes: boolean, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null } };

export type InstructionSheetFragment = { __typename?: 'Sheet', id: string, serverId: string, taskId: string, kind: TaskKind, format: TaskFormat, rawContent: string | null, releaseTimestamp: string, version: number, questionBlocks: Array<{ __typename?: 'QuestionBlock', nodeId: string, parentNodeId: string | null, nodeType: QuestionTreeNodeType, order: number, shortLabel: string | null, longLabel: string | null, shuffle: boolean | null, points: number | null, socraticQuestionerEnabled: boolean, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null }>, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean }>, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, groupDraftDueDate: string | null, groupDraftEnabled: boolean, individualDraftFeedbackAlwaysAvailable: boolean, groupDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, submitAttemptLimit: number | null, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, rubricDisplayDisabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, examReentryPreventionEnabled: boolean, examInactivityTimeout: number | null, examSchoolyearEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckSkipEnabled: boolean, sentimentCheckIntervalInHr: number | null, sentimentCheckFirstCheckAt: string | null, sentimentCheckScheduleType: SentimentCheckScheduleType, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, peerEvaluationMode: PeerEvaluationMode, peerEvaluationMinScaleFactor: number, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMode: SelfEvaluationMode, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterAcceptanceRequired: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, vivaEnabled: boolean, vivaReattemptWindowTime: number | null, vivaCameraRequiredDisabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, sentimentCheckSchedules: Array<{ __typename?: 'SentimentCheckSchedule', id: string, scheduledAt: string }> | null, vivaSourceTask: { __typename?: 'VivaSourceTask', id: string, assessmentId: string, name: string } | null } | null };

export type InstructionSheetQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type InstructionSheetQuery = { __typename?: 'RootQueryType', assessment: { __typename?: 'Assessment', id: string, name: string, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, groupDraftDueDate: string | null, groupDraftEnabled: boolean, individualDraftFeedbackAlwaysAvailable: boolean, groupDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, submitAttemptLimit: number | null, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, rubricDisplayDisabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, examReentryPreventionEnabled: boolean, examInactivityTimeout: number | null, examSchoolyearEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckSkipEnabled: boolean, sentimentCheckIntervalInHr: number | null, sentimentCheckFirstCheckAt: string | null, sentimentCheckScheduleType: SentimentCheckScheduleType, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, peerEvaluationMode: PeerEvaluationMode, peerEvaluationMinScaleFactor: number, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMode: SelfEvaluationMode, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterAcceptanceRequired: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, vivaEnabled: boolean, vivaReattemptWindowTime: number | null, vivaCameraRequiredDisabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, sentimentCheckSchedules: Array<{ __typename?: 'SentimentCheckSchedule', id: string, scheduledAt: string }> | null, vivaSourceTask: { __typename?: 'VivaSourceTask', id: string, assessmentId: string, name: string } | null } | null, tasks: Array<{ __typename?: 'Task', id: string, status: Status, kind: TaskKind, format: TaskFormat | null, instructionSheet: { __typename?: 'Sheet', id: string, serverId: string, taskId: string, kind: TaskKind, format: TaskFormat, rawContent: string | null, releaseTimestamp: string, version: number, questionBlocks: Array<{ __typename?: 'QuestionBlock', nodeId: string, parentNodeId: string | null, nodeType: QuestionTreeNodeType, order: number, shortLabel: string | null, longLabel: string | null, shuffle: boolean | null, points: number | null, socraticQuestionerEnabled: boolean, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null }>, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean }>, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, groupDraftDueDate: string | null, groupDraftEnabled: boolean, individualDraftFeedbackAlwaysAvailable: boolean, groupDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, submitAttemptLimit: number | null, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, rubricDisplayDisabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, examReentryPreventionEnabled: boolean, examInactivityTimeout: number | null, examSchoolyearEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckSkipEnabled: boolean, sentimentCheckIntervalInHr: number | null, sentimentCheckFirstCheckAt: string | null, sentimentCheckScheduleType: SentimentCheckScheduleType, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, peerEvaluationMode: PeerEvaluationMode, peerEvaluationMinScaleFactor: number, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMode: SelfEvaluationMode, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterAcceptanceRequired: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, vivaEnabled: boolean, vivaReattemptWindowTime: number | null, vivaCameraRequiredDisabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, sentimentCheckSchedules: Array<{ __typename?: 'SentimentCheckSchedule', id: string, scheduledAt: string }> | null, vivaSourceTask: { __typename?: 'VivaSourceTask', id: string, assessmentId: string, name: string } | null } | null } | null, futureSheet: { __typename?: 'Sheet', id: string, serverId: string, format: TaskFormat, kind: TaskKind, taskId: string, rawContent: string | null, releaseTimestamp: string, version: number, questionBlocks: Array<{ __typename?: 'QuestionBlock', nodeId: string, parentNodeId: string | null, nodeType: QuestionTreeNodeType, order: number, shortLabel: string | null, longLabel: string | null, shuffle: boolean | null, points: number | null, socraticQuestionerEnabled: boolean, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null }>, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean }>, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, groupDraftDueDate: string | null, groupDraftEnabled: boolean, individualDraftFeedbackAlwaysAvailable: boolean, groupDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, submitAttemptLimit: number | null, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, rubricDisplayDisabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, examReentryPreventionEnabled: boolean, examInactivityTimeout: number | null, examSchoolyearEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckSkipEnabled: boolean, sentimentCheckIntervalInHr: number | null, sentimentCheckFirstCheckAt: string | null, sentimentCheckScheduleType: SentimentCheckScheduleType, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, peerEvaluationMode: PeerEvaluationMode, peerEvaluationMinScaleFactor: number, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMode: SelfEvaluationMode, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterAcceptanceRequired: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, vivaEnabled: boolean, vivaReattemptWindowTime: number | null, vivaCameraRequiredDisabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, sentimentCheckSchedules: Array<{ __typename?: 'SentimentCheckSchedule', id: string, scheduledAt: string }> | null, vivaSourceTask: { __typename?: 'VivaSourceTask', id: string, assessmentId: string, name: string } | null } | null, futureSettings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, groupDraftDueDate: string | null, groupDraftEnabled: boolean, individualDraftFeedbackAlwaysAvailable: boolean, groupDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, submitAttemptLimit: number | null, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, rubricDisplayDisabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, examReentryPreventionEnabled: boolean, examInactivityTimeout: number | null, examSchoolyearEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckSkipEnabled: boolean, sentimentCheckIntervalInHr: number | null, sentimentCheckFirstCheckAt: string | null, sentimentCheckScheduleType: SentimentCheckScheduleType, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, peerEvaluationMode: PeerEvaluationMode, peerEvaluationMinScaleFactor: number, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMode: SelfEvaluationMode, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterAcceptanceRequired: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, vivaEnabled: boolean, vivaReattemptWindowTime: number | null, vivaCameraRequiredDisabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, sentimentCheckSchedules: Array<{ __typename?: 'SentimentCheckSchedule', id: string, scheduledAt: string }> | null, vivaSourceTask: { __typename?: 'VivaSourceTask', id: string, assessmentId: string, name: string } | null } | null } | null, blocks: Array<{ __typename?: 'TaskBlock', id: string, previousNodeId: string | null, nodeId: string, parentNodeId: string | null, deleted: boolean, hidden: boolean, quantity: number | null, shuffle: boolean, points: number | null, order: number | null, orderLabel: string | null, libraryQuestionId: string | null, libraryQuestionVersionId: string | null, socraticQuestionerEnabled: boolean, updatedAt: string | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null, questionSelection: { __typename?: 'QuestionSelection', id: string, sets: Array<{ __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, questionVersionId: string | null, question: { __typename?: 'Question', updatedAt: string | null, id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string, subject: { __typename?: 'Subject', id: string, name: string } } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } }> }> | null } | null, markerRubric: { __typename?: 'MarkerRubric', id: string, assessmentId: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, hasChanges: boolean, state: MarkerRubricState, updatedAt: string | null, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, hasOutcomes: boolean, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null }>, requirements: { __typename?: 'Requirements', id: string, assessmentType: AssessmentType, enableExamAutoSubmission: boolean, enableExamLdb: boolean | null, enableSubmissionPdf: boolean, enableExamAccessCode: boolean, examEndDate: string | null, examFeedbackDate: string | null, examReadingTime: number | null, examStartDate: string | null, examTiming: ExamTiming, examType: Array<string>, examWritingTime: number | null, lateSubmissionTimeLimit: number | null, noExamReadingTime: boolean, noExamFeedbackDate: boolean, submitAttemptLimit: number | null, dueDate: string | null, returnDate: string | null, maxGrade: number, sViewReports: number, anonymousMarking: boolean | null, gradingService: string, allowLateResubmission: boolean, draftDueDate: string | null, noDraft: boolean, draftSViewReports: number, individualDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, weight: number | null, noWeight: boolean, wordLimit: number | null, noLimit: boolean, timeLimit: number | null, noTimeLimit: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, disableSpellCheck: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, rubricDisplayDisabled: boolean | null, referencingStyle: string | null, noReferencing: boolean, disableExamBacktrack: boolean | null, hasChanged: boolean, enableExamReentryPrevention: boolean, examInactivityTimeout: number | null, examSchoolyearEnabled: boolean }, saveState: { __typename?: 'SaveState', id: string, serverId: string, version: number, rawContent: string | null, updatedAt: string }, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean }>, genaiGuidelineNotice: { __typename?: 'TaskNotice', id: string, version: number, content: string } | null }> } };

export type InstructionSheetWithFutureSettingsFragment = { __typename?: 'Sheet', id: string, serverId: string, format: TaskFormat, kind: TaskKind, taskId: string, rawContent: string | null, releaseTimestamp: string, version: number, questionBlocks: Array<{ __typename?: 'QuestionBlock', nodeId: string, parentNodeId: string | null, nodeType: QuestionTreeNodeType, order: number, shortLabel: string | null, longLabel: string | null, shuffle: boolean | null, points: number | null, socraticQuestionerEnabled: boolean, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null }>, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean }>, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, groupDraftDueDate: string | null, groupDraftEnabled: boolean, individualDraftFeedbackAlwaysAvailable: boolean, groupDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, submitAttemptLimit: number | null, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, rubricDisplayDisabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, examReentryPreventionEnabled: boolean, examInactivityTimeout: number | null, examSchoolyearEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckSkipEnabled: boolean, sentimentCheckIntervalInHr: number | null, sentimentCheckFirstCheckAt: string | null, sentimentCheckScheduleType: SentimentCheckScheduleType, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, peerEvaluationMode: PeerEvaluationMode, peerEvaluationMinScaleFactor: number, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMode: SelfEvaluationMode, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterAcceptanceRequired: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, vivaEnabled: boolean, vivaReattemptWindowTime: number | null, vivaCameraRequiredDisabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, sentimentCheckSchedules: Array<{ __typename?: 'SentimentCheckSchedule', id: string, scheduledAt: string }> | null, vivaSourceTask: { __typename?: 'VivaSourceTask', id: string, assessmentId: string, name: string } | null } | null, futureSettings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, groupDraftDueDate: string | null, groupDraftEnabled: boolean, individualDraftFeedbackAlwaysAvailable: boolean, groupDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, submitAttemptLimit: number | null, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, rubricDisplayDisabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, examReentryPreventionEnabled: boolean, examInactivityTimeout: number | null, examSchoolyearEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckSkipEnabled: boolean, sentimentCheckIntervalInHr: number | null, sentimentCheckFirstCheckAt: string | null, sentimentCheckScheduleType: SentimentCheckScheduleType, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, peerEvaluationMode: PeerEvaluationMode, peerEvaluationMinScaleFactor: number, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMode: SelfEvaluationMode, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterAcceptanceRequired: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, vivaEnabled: boolean, vivaReattemptWindowTime: number | null, vivaCameraRequiredDisabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, sentimentCheckSchedules: Array<{ __typename?: 'SentimentCheckSchedule', id: string, scheduledAt: string }> | null, vivaSourceTask: { __typename?: 'VivaSourceTask', id: string, assessmentId: string, name: string } | null } | null };

export type PrintArchiveUrlQueryVariables = Exact<{
  taskId: Scalars['ID']['input'];
  archiveId: Scalars['ID']['input'];
}>;


export type PrintArchiveUrlQuery = { __typename?: 'RootQueryType', printArchiveUrl: string | null };

export type QuestionBlockFragment = { __typename?: 'QuestionBlock', nodeId: string, parentNodeId: string | null, nodeType: QuestionTreeNodeType, order: number, shortLabel: string | null, longLabel: string | null, shuffle: boolean | null, points: number | null, socraticQuestionerEnabled: boolean, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null };

export type QuestionBodyFragment = { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null };

export type QuestionFieldFragment = { __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } };

export type QuestionFragment = { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null };

export type TaskQuestionSelectionFragment = { __typename?: 'QuestionSelection', id: string, setsQuantity: number, sets: Array<{ __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } }> }> | null, rules: Array<{ __typename?: 'QuestionSelectionRule', id: string, points: number, quantity: number, questionType: QuestionType, difficulty: QuestionDifficulty | null }> };

export type TaskQuestionSetFragment = { __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } }> };

export type TaskQuestionSetQuestionFragment = { __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } };

export type QuestionTreeQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
  input: Array<QuestionSelectionFilterInput> | QuestionSelectionFilterInput;
}>;


export type QuestionTreeQuery = { __typename?: 'RootQueryType', assessment: { __typename?: 'Assessment', id: string, name: string }, questionTree: Array<{ __typename?: 'QuestionBlock', nodeId: string, parentNodeId: string | null, nodeType: QuestionTreeNodeType, order: number, shortLabel: string | null, longLabel: string | null, shuffle: boolean | null, points: number | null, socraticQuestionerEnabled: boolean, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null }> };

export type ReleaseTaskMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  saveId: Scalars['ID']['input'];
  scheduleTimestamp: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type ReleaseTaskMutation = { __typename?: 'RootMutationType', releaseTask: { __typename?: 'Sheet', id: string, serverId: string, format: TaskFormat, kind: TaskKind, taskId: string, rawContent: string | null, releaseTimestamp: string, version: number, questionBlocks: Array<{ __typename?: 'QuestionBlock', nodeId: string, parentNodeId: string | null, nodeType: QuestionTreeNodeType, order: number, shortLabel: string | null, longLabel: string | null, shuffle: boolean | null, points: number | null, socraticQuestionerEnabled: boolean, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null }>, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean }>, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, groupDraftDueDate: string | null, groupDraftEnabled: boolean, individualDraftFeedbackAlwaysAvailable: boolean, groupDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, submitAttemptLimit: number | null, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, rubricDisplayDisabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, examReentryPreventionEnabled: boolean, examInactivityTimeout: number | null, examSchoolyearEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckSkipEnabled: boolean, sentimentCheckIntervalInHr: number | null, sentimentCheckFirstCheckAt: string | null, sentimentCheckScheduleType: SentimentCheckScheduleType, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, peerEvaluationMode: PeerEvaluationMode, peerEvaluationMinScaleFactor: number, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMode: SelfEvaluationMode, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterAcceptanceRequired: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, vivaEnabled: boolean, vivaReattemptWindowTime: number | null, vivaCameraRequiredDisabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, sentimentCheckSchedules: Array<{ __typename?: 'SentimentCheckSchedule', id: string, scheduledAt: string }> | null, vivaSourceTask: { __typename?: 'VivaSourceTask', id: string, assessmentId: string, name: string } | null } | null, futureSettings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, groupDraftDueDate: string | null, groupDraftEnabled: boolean, individualDraftFeedbackAlwaysAvailable: boolean, groupDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, submitAttemptLimit: number | null, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, rubricDisplayDisabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, examReentryPreventionEnabled: boolean, examInactivityTimeout: number | null, examSchoolyearEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckSkipEnabled: boolean, sentimentCheckIntervalInHr: number | null, sentimentCheckFirstCheckAt: string | null, sentimentCheckScheduleType: SentimentCheckScheduleType, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, peerEvaluationMode: PeerEvaluationMode, peerEvaluationMinScaleFactor: number, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMode: SelfEvaluationMode, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterAcceptanceRequired: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, vivaEnabled: boolean, vivaReattemptWindowTime: number | null, vivaCameraRequiredDisabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, sentimentCheckSchedules: Array<{ __typename?: 'SentimentCheckSchedule', id: string, scheduledAt: string }> | null, vivaSourceTask: { __typename?: 'VivaSourceTask', id: string, assessmentId: string, name: string } | null } | null } };

export type RequirementsFragment = { __typename?: 'Requirements', id: string, assessmentType: AssessmentType, enableExamAutoSubmission: boolean, enableExamLdb: boolean | null, enableSubmissionPdf: boolean, enableExamAccessCode: boolean, examEndDate: string | null, examFeedbackDate: string | null, examReadingTime: number | null, examStartDate: string | null, examTiming: ExamTiming, examType: Array<string>, examWritingTime: number | null, lateSubmissionTimeLimit: number | null, noExamReadingTime: boolean, noExamFeedbackDate: boolean, submitAttemptLimit: number | null, dueDate: string | null, returnDate: string | null, maxGrade: number, sViewReports: number, anonymousMarking: boolean | null, gradingService: string, allowLateResubmission: boolean, draftDueDate: string | null, noDraft: boolean, draftSViewReports: number, individualDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, weight: number | null, noWeight: boolean, wordLimit: number | null, noLimit: boolean, timeLimit: number | null, noTimeLimit: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, disableSpellCheck: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, rubricDisplayDisabled: boolean | null, referencingStyle: string | null, noReferencing: boolean, disableExamBacktrack: boolean | null, hasChanged: boolean, enableExamReentryPrevention: boolean, examInactivityTimeout: number | null, examSchoolyearEnabled: boolean };

export type ResourceFragment = { __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean };

export type ResponseDeclarationFragment = { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> };

export type SaveGenaiGuidelineNoticeMutationVariables = Exact<{
  content: Scalars['String']['input'];
  taskId: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
}>;


export type SaveGenaiGuidelineNoticeMutation = { __typename?: 'RootMutationType', saveGenaiGuidelineNotice: { __typename?: 'TaskNotice', id: string, version: number, content: string } };

export type SaveQuestionStateMutationVariables = Exact<{
  questionId: Scalars['ID']['input'];
  input: SaveQuestionStateInput;
}>;


export type SaveQuestionStateMutation = { __typename?: 'RootMutationType', saveQuestionState: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } };

export type SaveStateFragment = { __typename?: 'SaveState', id: string, serverId: string, version: number, rawContent: string | null, updatedAt: string };

export type SentimentCheckScheduleFragment = { __typename?: 'SentimentCheckSchedule', id: string, scheduledAt: string };

export type SetupAccessCodeMutationVariables = Exact<{
  input: AccessCodeInput;
  assessmentId: Scalars['ID']['input'];
}>;


export type SetupAccessCodeMutation = { __typename?: 'RootMutationType', setupAccessCode: { __typename?: 'AccessCode', code: string, label: string | null, active: boolean, type: AccessCodeType } };

export type SetupTaskMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  kind: TaskKind;
}>;


export type SetupTaskMutation = { __typename?: 'RootMutationType', setupTask: { __typename?: 'Task', id: string, kind: TaskKind, status: Status, saveState: { __typename?: 'SaveState', id: string, version: number, rawContent: string | null }, genaiGuidelineNotice: { __typename?: 'TaskNotice', id: string } | null } };

export type SheetReleasedSubscriptionVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type SheetReleasedSubscription = { __typename?: 'RootSubscriptionType', sheetReleased: { __typename?: 'Sheet', id: string, serverId: string, taskId: string, kind: TaskKind, format: TaskFormat, rawContent: string | null, releaseTimestamp: string, version: number, questionBlocks: Array<{ __typename?: 'QuestionBlock', nodeId: string, parentNodeId: string | null, nodeType: QuestionTreeNodeType, order: number, shortLabel: string | null, longLabel: string | null, shuffle: boolean | null, points: number | null, socraticQuestionerEnabled: boolean, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null }>, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean }>, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, groupDraftDueDate: string | null, groupDraftEnabled: boolean, individualDraftFeedbackAlwaysAvailable: boolean, groupDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, submitAttemptLimit: number | null, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, rubricDisplayDisabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, examReentryPreventionEnabled: boolean, examInactivityTimeout: number | null, examSchoolyearEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckSkipEnabled: boolean, sentimentCheckIntervalInHr: number | null, sentimentCheckFirstCheckAt: string | null, sentimentCheckScheduleType: SentimentCheckScheduleType, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, peerEvaluationMode: PeerEvaluationMode, peerEvaluationMinScaleFactor: number, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMode: SelfEvaluationMode, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterAcceptanceRequired: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, vivaEnabled: boolean, vivaReattemptWindowTime: number | null, vivaCameraRequiredDisabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, sentimentCheckSchedules: Array<{ __typename?: 'SentimentCheckSchedule', id: string, scheduledAt: string }> | null, vivaSourceTask: { __typename?: 'VivaSourceTask', id: string, assessmentId: string, name: string } | null } | null } };

export type SimpleChoiceFragment = { __typename?: 'SimpleChoice', identifier: string, content: string };

export type SubjectFragment = { __typename?: 'Subject', id: string, discipline: Discipline | null, name: string, label: string | null };

export type SwapResourceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  swapId: Scalars['ID']['input'];
}>;


export type SwapResourceMutation = { __typename?: 'RootMutationType', swapResource: boolean };

export type TaskBlockFragment = { __typename?: 'TaskBlock', id: string, previousNodeId: string | null, nodeId: string, parentNodeId: string | null, deleted: boolean, hidden: boolean, quantity: number | null, shuffle: boolean, points: number | null, order: number | null, orderLabel: string | null, libraryQuestionId: string | null, libraryQuestionVersionId: string | null, socraticQuestionerEnabled: boolean, updatedAt: string | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null, questionSelection: { __typename?: 'QuestionSelection', id: string, sets: Array<{ __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, questionVersionId: string | null, question: { __typename?: 'Question', updatedAt: string | null, id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string, subject: { __typename?: 'Subject', id: string, name: string } } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } }> }> | null } | null, markerRubric: { __typename?: 'MarkerRubric', id: string, assessmentId: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, hasChanges: boolean, state: MarkerRubricState, updatedAt: string | null, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, hasOutcomes: boolean, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null };

export type TaskFormatFragment = { __typename?: 'Task', id: string, kind: TaskKind, format: TaskFormat | null };

export type TaskFragment = { __typename?: 'Task', id: string, status: Status, kind: TaskKind, format: TaskFormat | null, blocks: Array<{ __typename?: 'TaskBlock', id: string, previousNodeId: string | null, nodeId: string, parentNodeId: string | null, deleted: boolean, hidden: boolean, quantity: number | null, shuffle: boolean, points: number | null, order: number | null, orderLabel: string | null, libraryQuestionId: string | null, libraryQuestionVersionId: string | null, socraticQuestionerEnabled: boolean, updatedAt: string | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null, questionSelection: { __typename?: 'QuestionSelection', id: string, sets: Array<{ __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, questionVersionId: string | null, question: { __typename?: 'Question', updatedAt: string | null, id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string, subject: { __typename?: 'Subject', id: string, name: string } } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } }> }> | null } | null, markerRubric: { __typename?: 'MarkerRubric', id: string, assessmentId: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, hasChanges: boolean, state: MarkerRubricState, updatedAt: string | null, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, hasOutcomes: boolean, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null }>, requirements: { __typename?: 'Requirements', id: string, assessmentType: AssessmentType, enableExamAutoSubmission: boolean, enableExamLdb: boolean | null, enableSubmissionPdf: boolean, enableExamAccessCode: boolean, examEndDate: string | null, examFeedbackDate: string | null, examReadingTime: number | null, examStartDate: string | null, examTiming: ExamTiming, examType: Array<string>, examWritingTime: number | null, lateSubmissionTimeLimit: number | null, noExamReadingTime: boolean, noExamFeedbackDate: boolean, submitAttemptLimit: number | null, dueDate: string | null, returnDate: string | null, maxGrade: number, sViewReports: number, anonymousMarking: boolean | null, gradingService: string, allowLateResubmission: boolean, draftDueDate: string | null, noDraft: boolean, draftSViewReports: number, individualDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, weight: number | null, noWeight: boolean, wordLimit: number | null, noLimit: boolean, timeLimit: number | null, noTimeLimit: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, disableSpellCheck: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, rubricDisplayDisabled: boolean | null, referencingStyle: string | null, noReferencing: boolean, disableExamBacktrack: boolean | null, hasChanged: boolean, enableExamReentryPrevention: boolean, examInactivityTimeout: number | null, examSchoolyearEnabled: boolean }, saveState: { __typename?: 'SaveState', id: string, serverId: string, version: number, rawContent: string | null, updatedAt: string }, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean }>, genaiGuidelineNotice: { __typename?: 'TaskNotice', id: string, version: number, content: string } | null };

export type TaskNoticeFragment = { __typename?: 'TaskNotice', id: string, version: number, content: string };

export type TaskQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  taskId: InputMaybe<Scalars['ID']['input']>;
}>;


export type TaskQuery = { __typename?: 'RootQueryType', token: string, me: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }, institution: { __typename?: 'Institution', id: string, tenant: string, timezone: string }, featureFlags: { __typename?: 'InstitutionFeatures', id: string, accessCode: boolean, exams: boolean, respondusLdb: boolean, moodleGrader: boolean, multiformat: boolean, turnitin: boolean, turnitinGrader: boolean, cadmusGrader: boolean, groupAssessment: boolean, genAiDeclaration: boolean, extensionSyncing: boolean, advancedMarking: boolean, timeline: boolean, adminAccess: boolean, viva: boolean, labsContextualiser: boolean, schoolyear: boolean }, assessment: { __typename?: 'Assessment', id: string, name: string, subjectName: string, subjectId: string, dueDate: string | null, gradingDueDate: string | null, startDate: string | null, endDate: string | null, edition: number, subject: { __typename?: 'Subject', id: string, discipline: Discipline | null, name: string, label: string | null }, ltiTool: { __typename?: 'InstitutionTool', id: string, name: string | null, familyCode: string | null }, ltiServices: Array<{ __typename?: 'LtiService', id: string, name: string, version: string, issuer: string | null, metaUrl: string | null, isLtiPluginAgs: boolean }>, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, groupDraftDueDate: string | null, groupDraftEnabled: boolean, individualDraftFeedbackAlwaysAvailable: boolean, groupDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, submitAttemptLimit: number | null, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, rubricDisplayDisabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, examReentryPreventionEnabled: boolean, examInactivityTimeout: number | null, examSchoolyearEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckSkipEnabled: boolean, sentimentCheckIntervalInHr: number | null, sentimentCheckFirstCheckAt: string | null, sentimentCheckScheduleType: SentimentCheckScheduleType, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, peerEvaluationMode: PeerEvaluationMode, peerEvaluationMinScaleFactor: number, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMode: SelfEvaluationMode, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterAcceptanceRequired: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, vivaEnabled: boolean, vivaReattemptWindowTime: number | null, vivaCameraRequiredDisabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, sentimentCheckSchedules: Array<{ __typename?: 'SentimentCheckSchedule', id: string, scheduledAt: string }> | null, vivaSourceTask: { __typename?: 'VivaSourceTask', id: string, assessmentId: string, name: string } | null } | null, ltiCustomParams: { __typename?: 'CustomParams', moodleAttemptReopenMethod: string | null } | null, schoolyearExam: { __typename?: 'SchoolyearExam', id: string, pushStatus: SchoolyearExamPushStatus } | null }, class: { __typename?: 'Class', id: string, students: Array<{ __typename?: 'Enrollment', id: string, deleted: boolean, user: { __typename?: 'User', id: string }, workSettings: { __typename?: 'WorkSettings', id: string, examDeferred: boolean | null, groupId: string | null } | null }>, groups: Array<{ __typename?: 'Group', id: string, name: string, markerId: string | null, code: string | null, sectionId: string | null, questionId: string | null, maxLimit: number | null, minLimit: number | null, finalised: boolean, finalisedAt: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, members: Array<{ __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }>, groupMembers: Array<{ __typename?: 'GroupMember', id: string, colourset: number, user: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, groupMarkers: Array<{ __typename?: 'GroupMarker', id: string, role: MarkerRole, markerPlaceholder: string | null, groupMemberId: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null }> }>, tags: Array<{ __typename?: 'GroupTag', id: string, text: string }>, workSettings: { __typename?: 'WorkSettings', id: string, dueDate: string | null, groupId: string | null } | null }> }, userSettings: { __typename?: 'UserSettings', id: string, subjectRole: SubjectRole | null, showIaOnboarding: boolean | null } | null, task: { __typename?: 'Task', id: string, status: Status, kind: TaskKind, format: TaskFormat | null, instructionSheet: { __typename?: 'Sheet', id: string, serverId: string, taskId: string, kind: TaskKind, format: TaskFormat, rawContent: string | null, releaseTimestamp: string, version: number, questionBlocks: Array<{ __typename?: 'QuestionBlock', nodeId: string, parentNodeId: string | null, nodeType: QuestionTreeNodeType, order: number, shortLabel: string | null, longLabel: string | null, shuffle: boolean | null, points: number | null, socraticQuestionerEnabled: boolean, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null }>, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean }>, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, groupDraftDueDate: string | null, groupDraftEnabled: boolean, individualDraftFeedbackAlwaysAvailable: boolean, groupDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, submitAttemptLimit: number | null, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, rubricDisplayDisabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, examReentryPreventionEnabled: boolean, examInactivityTimeout: number | null, examSchoolyearEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckSkipEnabled: boolean, sentimentCheckIntervalInHr: number | null, sentimentCheckFirstCheckAt: string | null, sentimentCheckScheduleType: SentimentCheckScheduleType, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, peerEvaluationMode: PeerEvaluationMode, peerEvaluationMinScaleFactor: number, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMode: SelfEvaluationMode, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterAcceptanceRequired: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, vivaEnabled: boolean, vivaReattemptWindowTime: number | null, vivaCameraRequiredDisabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, sentimentCheckSchedules: Array<{ __typename?: 'SentimentCheckSchedule', id: string, scheduledAt: string }> | null, vivaSourceTask: { __typename?: 'VivaSourceTask', id: string, assessmentId: string, name: string } | null } | null } | null, futureSheet: { __typename?: 'Sheet', id: string, serverId: string, format: TaskFormat, kind: TaskKind, taskId: string, rawContent: string | null, releaseTimestamp: string, version: number, questionBlocks: Array<{ __typename?: 'QuestionBlock', nodeId: string, parentNodeId: string | null, nodeType: QuestionTreeNodeType, order: number, shortLabel: string | null, longLabel: string | null, shuffle: boolean | null, points: number | null, socraticQuestionerEnabled: boolean, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null }>, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean }>, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, groupDraftDueDate: string | null, groupDraftEnabled: boolean, individualDraftFeedbackAlwaysAvailable: boolean, groupDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, submitAttemptLimit: number | null, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, rubricDisplayDisabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, examReentryPreventionEnabled: boolean, examInactivityTimeout: number | null, examSchoolyearEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckSkipEnabled: boolean, sentimentCheckIntervalInHr: number | null, sentimentCheckFirstCheckAt: string | null, sentimentCheckScheduleType: SentimentCheckScheduleType, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, peerEvaluationMode: PeerEvaluationMode, peerEvaluationMinScaleFactor: number, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMode: SelfEvaluationMode, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterAcceptanceRequired: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, vivaEnabled: boolean, vivaReattemptWindowTime: number | null, vivaCameraRequiredDisabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, sentimentCheckSchedules: Array<{ __typename?: 'SentimentCheckSchedule', id: string, scheduledAt: string }> | null, vivaSourceTask: { __typename?: 'VivaSourceTask', id: string, assessmentId: string, name: string } | null } | null, futureSettings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, groupDraftDueDate: string | null, groupDraftEnabled: boolean, individualDraftFeedbackAlwaysAvailable: boolean, groupDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, submitAttemptLimit: number | null, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, rubricDisplayDisabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, examReentryPreventionEnabled: boolean, examInactivityTimeout: number | null, examSchoolyearEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckSkipEnabled: boolean, sentimentCheckIntervalInHr: number | null, sentimentCheckFirstCheckAt: string | null, sentimentCheckScheduleType: SentimentCheckScheduleType, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, peerEvaluationMode: PeerEvaluationMode, peerEvaluationMinScaleFactor: number, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMode: SelfEvaluationMode, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterAcceptanceRequired: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, vivaEnabled: boolean, vivaReattemptWindowTime: number | null, vivaCameraRequiredDisabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, sentimentCheckSchedules: Array<{ __typename?: 'SentimentCheckSchedule', id: string, scheduledAt: string }> | null, vivaSourceTask: { __typename?: 'VivaSourceTask', id: string, assessmentId: string, name: string } | null } | null } | null, blocks: Array<{ __typename?: 'TaskBlock', id: string, previousNodeId: string | null, nodeId: string, parentNodeId: string | null, deleted: boolean, hidden: boolean, quantity: number | null, shuffle: boolean, points: number | null, order: number | null, orderLabel: string | null, libraryQuestionId: string | null, libraryQuestionVersionId: string | null, socraticQuestionerEnabled: boolean, updatedAt: string | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null, questionSelection: { __typename?: 'QuestionSelection', id: string, sets: Array<{ __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, questionVersionId: string | null, question: { __typename?: 'Question', updatedAt: string | null, id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string, subject: { __typename?: 'Subject', id: string, name: string } } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } }> }> | null } | null, markerRubric: { __typename?: 'MarkerRubric', id: string, assessmentId: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, hasChanges: boolean, state: MarkerRubricState, updatedAt: string | null, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, hasOutcomes: boolean, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null }>, requirements: { __typename?: 'Requirements', id: string, assessmentType: AssessmentType, enableExamAutoSubmission: boolean, enableExamLdb: boolean | null, enableSubmissionPdf: boolean, enableExamAccessCode: boolean, examEndDate: string | null, examFeedbackDate: string | null, examReadingTime: number | null, examStartDate: string | null, examTiming: ExamTiming, examType: Array<string>, examWritingTime: number | null, lateSubmissionTimeLimit: number | null, noExamReadingTime: boolean, noExamFeedbackDate: boolean, submitAttemptLimit: number | null, dueDate: string | null, returnDate: string | null, maxGrade: number, sViewReports: number, anonymousMarking: boolean | null, gradingService: string, allowLateResubmission: boolean, draftDueDate: string | null, noDraft: boolean, draftSViewReports: number, individualDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, weight: number | null, noWeight: boolean, wordLimit: number | null, noLimit: boolean, timeLimit: number | null, noTimeLimit: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, disableSpellCheck: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, rubricDisplayDisabled: boolean | null, referencingStyle: string | null, noReferencing: boolean, disableExamBacktrack: boolean | null, hasChanged: boolean, enableExamReentryPrevention: boolean, examInactivityTimeout: number | null, examSchoolyearEnabled: boolean }, saveState: { __typename?: 'SaveState', id: string, serverId: string, version: number, rawContent: string | null, updatedAt: string }, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean }>, genaiGuidelineNotice: { __typename?: 'TaskNotice', id: string, version: number, content: string } | null } | null };

export type TaskStatusFragment = { __typename?: 'Task', id: string, status: Status };

export type UnlinkLibraryQuestionMutationVariables = Exact<{
  input: UnlinkLibraryQuestionInput;
}>;


export type UnlinkLibraryQuestionMutation = { __typename?: 'RootMutationType', unlinkLibraryQuestion: { __typename?: 'TaskBlock', id: string, previousNodeId: string | null, nodeId: string, parentNodeId: string | null, deleted: boolean, hidden: boolean, quantity: number | null, shuffle: boolean, points: number | null, order: number | null, orderLabel: string | null, libraryQuestionId: string | null, libraryQuestionVersionId: string | null, socraticQuestionerEnabled: boolean, updatedAt: string | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null, questionSelection: { __typename?: 'QuestionSelection', id: string, sets: Array<{ __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, questionVersionId: string | null, question: { __typename?: 'Question', updatedAt: string | null, id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string, subject: { __typename?: 'Subject', id: string, name: string } } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } }> }> | null } | null, markerRubric: { __typename?: 'MarkerRubric', id: string, assessmentId: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, hasChanges: boolean, state: MarkerRubricState, updatedAt: string | null, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, hasOutcomes: boolean, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null } };

export type UpdateAssessmentNameMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateAssessmentNameMutation = { __typename?: 'RootMutationType', updateAssessmentName: { __typename?: 'Assessment', id: string, name: string } };

export type UpdateAssessmentSettingsMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  input: AssessmentSettingsInput;
}>;


export type UpdateAssessmentSettingsMutation = { __typename?: 'RootMutationType', updateAssessmentSettings: { __typename?: 'Assessment', id: string, name: string, subjectName: string, subjectId: string, dueDate: string | null, gradingDueDate: string | null, startDate: string | null, endDate: string | null, edition: number, subject: { __typename?: 'Subject', id: string, discipline: Discipline | null, name: string, label: string | null }, ltiTool: { __typename?: 'InstitutionTool', id: string, name: string | null, familyCode: string | null }, ltiServices: Array<{ __typename?: 'LtiService', id: string, name: string, version: string, issuer: string | null, metaUrl: string | null, isLtiPluginAgs: boolean }>, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, groupDraftDueDate: string | null, groupDraftEnabled: boolean, individualDraftFeedbackAlwaysAvailable: boolean, groupDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, submitAttemptLimit: number | null, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, rubricDisplayDisabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, examReentryPreventionEnabled: boolean, examInactivityTimeout: number | null, examSchoolyearEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckSkipEnabled: boolean, sentimentCheckIntervalInHr: number | null, sentimentCheckFirstCheckAt: string | null, sentimentCheckScheduleType: SentimentCheckScheduleType, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, peerEvaluationMode: PeerEvaluationMode, peerEvaluationMinScaleFactor: number, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMode: SelfEvaluationMode, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterAcceptanceRequired: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, vivaEnabled: boolean, vivaReattemptWindowTime: number | null, vivaCameraRequiredDisabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, sentimentCheckSchedules: Array<{ __typename?: 'SentimentCheckSchedule', id: string, scheduledAt: string }> | null, vivaSourceTask: { __typename?: 'VivaSourceTask', id: string, assessmentId: string, name: string } | null } | null, ltiCustomParams: { __typename?: 'CustomParams', moodleAttemptReopenMethod: string | null } | null, schoolyearExam: { __typename?: 'SchoolyearExam', id: string, pushStatus: SchoolyearExamPushStatus } | null } };

export type UpdateRequirementsMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  requirements: RequirementsInput;
}>;


export type UpdateRequirementsMutation = { __typename?: 'RootMutationType', updateRequirements: { __typename?: 'Requirements', id: string, assessmentType: AssessmentType, enableExamAutoSubmission: boolean, enableExamLdb: boolean | null, enableSubmissionPdf: boolean, enableExamAccessCode: boolean, examEndDate: string | null, examFeedbackDate: string | null, examReadingTime: number | null, examStartDate: string | null, examTiming: ExamTiming, examType: Array<string>, examWritingTime: number | null, lateSubmissionTimeLimit: number | null, noExamReadingTime: boolean, noExamFeedbackDate: boolean, submitAttemptLimit: number | null, dueDate: string | null, returnDate: string | null, maxGrade: number, sViewReports: number, anonymousMarking: boolean | null, gradingService: string, allowLateResubmission: boolean, draftDueDate: string | null, noDraft: boolean, draftSViewReports: number, individualDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, weight: number | null, noWeight: boolean, wordLimit: number | null, noLimit: boolean, timeLimit: number | null, noTimeLimit: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, disableSpellCheck: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, rubricDisplayDisabled: boolean | null, referencingStyle: string | null, noReferencing: boolean, disableExamBacktrack: boolean | null, hasChanged: boolean, enableExamReentryPrevention: boolean, examInactivityTimeout: number | null, examSchoolyearEnabled: boolean } };

export type UpdateResourceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: InputMaybe<Scalars['String']['input']>;
  url: InputMaybe<Scalars['String']['input']>;
  notes: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateResourceMutation = { __typename?: 'RootMutationType', updateResource: { __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean } };

export type UpdateTaskBlockMutationVariables = Exact<{
  taskBlockId: Scalars['ID']['input'];
  input: UpdateTaskBlockInput;
}>;


export type UpdateTaskBlockMutation = { __typename?: 'RootMutationType', updateTaskBlock: { __typename?: 'TaskBlock', id: string, points: number | null, deleted: boolean, hidden: boolean, shuffle: boolean, socraticQuestionerEnabled: boolean } };

export type UpdateTaskBlocksMutationVariables = Exact<{
  taskBlocksList: Array<UpdateTaskBlocksInput> | UpdateTaskBlocksInput;
}>;


export type UpdateTaskBlocksMutation = { __typename?: 'RootMutationType', updateTaskBlocks: Array<{ __typename?: 'TaskBlock', id: string, previousNodeId: string | null, nodeId: string, parentNodeId: string | null, deleted: boolean, hidden: boolean, quantity: number | null, shuffle: boolean, points: number | null, order: number | null, orderLabel: string | null, libraryQuestionId: string | null, libraryQuestionVersionId: string | null, socraticQuestionerEnabled: boolean, updatedAt: string | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null, questionSelection: { __typename?: 'QuestionSelection', id: string, sets: Array<{ __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, questionVersionId: string | null, question: { __typename?: 'Question', updatedAt: string | null, id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string, subject: { __typename?: 'Subject', id: string, name: string } } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } }> }> | null } | null, markerRubric: { __typename?: 'MarkerRubric', id: string, assessmentId: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, hasChanges: boolean, state: MarkerRubricState, updatedAt: string | null, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, hasOutcomes: boolean, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null }> };

export type UpdateTaskFormatMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  format: TaskFormat;
}>;


export type UpdateTaskFormatMutation = { __typename?: 'RootMutationType', updateTaskFormat: { __typename?: 'Task', id: string, format: TaskFormat | null } };

export type VivaSourceTaskFragment = { __typename?: 'VivaSourceTask', id: string, assessmentId: string, name: string };

export type CopyAssessmentMutationVariables = Exact<{
  destinationAssessmentId: Scalars['ID']['input'];
  sourceInstructionSheetId: Scalars['ID']['input'];
  destinationTaskId: InputMaybe<Scalars['ID']['input']>;
}>;


export type CopyAssessmentMutation = { __typename?: 'RootMutationType', copyAssessment: { __typename?: 'Task', id: string, status: Status, kind: TaskKind, format: TaskFormat | null, blocks: Array<{ __typename?: 'TaskBlock', id: string, previousNodeId: string | null, nodeId: string, parentNodeId: string | null, deleted: boolean, hidden: boolean, quantity: number | null, shuffle: boolean, points: number | null, order: number | null, orderLabel: string | null, libraryQuestionId: string | null, libraryQuestionVersionId: string | null, socraticQuestionerEnabled: boolean, updatedAt: string | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null, questionSelection: { __typename?: 'QuestionSelection', id: string, sets: Array<{ __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, questionVersionId: string | null, question: { __typename?: 'Question', updatedAt: string | null, id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string, subject: { __typename?: 'Subject', id: string, name: string } } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } }> }> | null } | null, markerRubric: { __typename?: 'MarkerRubric', id: string, assessmentId: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, hasChanges: boolean, state: MarkerRubricState, updatedAt: string | null, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, hasOutcomes: boolean, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null }>, requirements: { __typename?: 'Requirements', id: string, assessmentType: AssessmentType, enableExamAutoSubmission: boolean, enableExamLdb: boolean | null, enableSubmissionPdf: boolean, enableExamAccessCode: boolean, examEndDate: string | null, examFeedbackDate: string | null, examReadingTime: number | null, examStartDate: string | null, examTiming: ExamTiming, examType: Array<string>, examWritingTime: number | null, lateSubmissionTimeLimit: number | null, noExamReadingTime: boolean, noExamFeedbackDate: boolean, submitAttemptLimit: number | null, dueDate: string | null, returnDate: string | null, maxGrade: number, sViewReports: number, anonymousMarking: boolean | null, gradingService: string, allowLateResubmission: boolean, draftDueDate: string | null, noDraft: boolean, draftSViewReports: number, individualDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, weight: number | null, noWeight: boolean, wordLimit: number | null, noLimit: boolean, timeLimit: number | null, noTimeLimit: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, disableSpellCheck: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, rubricDisplayDisabled: boolean | null, referencingStyle: string | null, noReferencing: boolean, disableExamBacktrack: boolean | null, hasChanged: boolean, enableExamReentryPrevention: boolean, examInactivityTimeout: number | null, examSchoolyearEnabled: boolean }, saveState: { __typename?: 'SaveState', id: string, serverId: string, version: number, rawContent: string | null, updatedAt: string }, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean }>, genaiGuidelineNotice: { __typename?: 'TaskNotice', id: string, version: number, content: string } | null } };

export type PastAssessmentsQueryVariables = Exact<{
  assessmentId: InputMaybe<Scalars['ID']['input']>;
}>;


export type PastAssessmentsQuery = { __typename?: 'RootQueryType', pastInstructionSheets: Array<{ __typename?: 'PastInstructionSheet', assessment: { __typename?: 'Assessment', name: string, id: string, subject: { __typename?: 'Subject', id: string, discipline: Discipline | null, name: string, label: string | null }, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, groupDraftDueDate: string | null, groupDraftEnabled: boolean, individualDraftFeedbackAlwaysAvailable: boolean, groupDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, submitAttemptLimit: number | null, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, rubricDisplayDisabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, examReentryPreventionEnabled: boolean, examInactivityTimeout: number | null, examSchoolyearEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckSkipEnabled: boolean, sentimentCheckIntervalInHr: number | null, sentimentCheckFirstCheckAt: string | null, sentimentCheckScheduleType: SentimentCheckScheduleType, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, peerEvaluationMode: PeerEvaluationMode, peerEvaluationMinScaleFactor: number, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMode: SelfEvaluationMode, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterAcceptanceRequired: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, vivaEnabled: boolean, vivaReattemptWindowTime: number | null, vivaCameraRequiredDisabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, sentimentCheckSchedules: Array<{ __typename?: 'SentimentCheckSchedule', id: string, scheduledAt: string }> | null, vivaSourceTask: { __typename?: 'VivaSourceTask', id: string, assessmentId: string, name: string } | null } | null }, sheet: { __typename?: 'Sheet', id: string, serverId: string, taskId: string, kind: TaskKind, format: TaskFormat } }> };

export type PastInstructionSheetQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  sheetId: Scalars['ID']['input'];
}>;


export type PastInstructionSheetQuery = { __typename?: 'RootQueryType', instructionSheet: { __typename?: 'Sheet', id: string, serverId: string, taskId: string, kind: TaskKind, format: TaskFormat, rawContent: string | null, releaseTimestamp: string, version: number, questionBlocks: Array<{ __typename?: 'QuestionBlock', nodeId: string, parentNodeId: string | null, nodeType: QuestionTreeNodeType, order: number, shortLabel: string | null, longLabel: string | null, shuffle: boolean | null, points: number | null, socraticQuestionerEnabled: boolean, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null, referencingEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'SocraticInteraction', responseTime: number | null, readingTime: number | null, maxAttempts: number | null } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null }>, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean }>, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, groupDraftDueDate: string | null, groupDraftEnabled: boolean, individualDraftFeedbackAlwaysAvailable: boolean, groupDraftFeedbackAlwaysAvailable: boolean, draftScoringEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, submitAttemptLimit: number | null, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, rubricDisplayDisabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, examReentryPreventionEnabled: boolean, examInactivityTimeout: number | null, examSchoolyearEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckSkipEnabled: boolean, sentimentCheckIntervalInHr: number | null, sentimentCheckFirstCheckAt: string | null, sentimentCheckScheduleType: SentimentCheckScheduleType, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, peerEvaluationMode: PeerEvaluationMode, peerEvaluationMinScaleFactor: number, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMode: SelfEvaluationMode, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterAcceptanceRequired: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, vivaEnabled: boolean, vivaReattemptWindowTime: number | null, vivaCameraRequiredDisabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean, sentimentCheckSchedules: Array<{ __typename?: 'SentimentCheckSchedule', id: string, scheduledAt: string }> | null, vivaSourceTask: { __typename?: 'VivaSourceTask', id: string, assessmentId: string, name: string } | null } | null } | null };

export type UserFragment = { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null };

export const BackgroundJobFragmentDoc = gql`
    fragment BackgroundJob on BackgroundJob {
  id
  kind
  state
}
    `;
export const CharterFormFragmentDoc = gql`
    fragment CharterForm on CharterForm {
  id
  published
  hasUnpublishedChanges
  publishTimestamp
  editedAt
  sections {
    id
    deleted
    enabled
    rank
    milestonePresets {
      id
      description
      dueDate
      title
    }
    promptDoc
    rank
    title
    type
    wordLimit
    wordLimitEnabled
  }
}
    `;
export const CharterFormMilestonePresetFragmentDoc = gql`
    fragment CharterFormMilestonePreset on MilestonePresetType {
  id
  description
  dueDate
  title
}
    `;
export const CharterFormSectionFragmentDoc = gql`
    fragment CharterFormSection on CharterFormSection {
  id
  deleted
  enabled
  milestonePresets {
    ...CharterFormMilestonePreset
  }
  promptDoc
  rank
  title
  type
  wordLimit
  wordLimitEnabled
}
    ${CharterFormMilestonePresetFragmentDoc}`;
export const CharterMilestoneFragmentDoc = gql`
    fragment CharterMilestone on CharterMilestone {
  id
  title
  description
  dueDate
  deleted
}
    `;
export const CharterEditorFragmentDoc = gql`
    fragment CharterEditor on CharterEditor {
  id
  charterFormSectionId
  snapshotDoc
  snapshotVersion
  streamUuid
}
    `;
export const ThreadFragmentDoc = gql`
    fragment Thread on Thread {
  id
  title
  entityType
  entityId
  criterionId
  createdBy {
    id
  }
  insertedAt
  metadata {
    charterSectionType
    charterEditorId
    blockAttachmentId
    blockAttachmentName
  }
  comments {
    id
    content
    updatedAt
    smartCommentId
    createdBy {
      id
      name
      colourset
    }
  }
}
    `;
export const CharterFragmentDoc = gql`
    fragment Charter on Charter {
  id
  groupId
  milestones {
    ...CharterMilestone
  }
  editors {
    ...CharterEditor
  }
  feedbackThreads {
    ...Thread
  }
}
    ${CharterMilestoneFragmentDoc}
${CharterEditorFragmentDoc}
${ThreadFragmentDoc}`;
export const ResourceFragmentDoc = gql`
    fragment Resource on Resource {
  id
  name
  url
  invalidated
  order
  notes
  fileSize
  isFreshlyUploaded @client
}
    `;
export const ClassInstructionSheetFragmentDoc = gql`
    fragment ClassInstructionSheet on Sheet {
  id
  serverId
  taskId
  kind
  format
  releaseTimestamp
  version
  resources {
    ...Resource
  }
}
    ${ResourceFragmentDoc}`;
export const CountryFragmentDoc = gql`
    fragment Country on Country {
  code
  name
}
    `;
export const StudentOutcomeForDoubleMarkingFragmentDoc = gql`
    fragment StudentOutcomeForDoubleMarking on StudentOutcome {
  id
  studentId
  individualWorkOutcome {
    id
    workId
    studentId
    groupId
    progressSubmissionOutcomes {
      id
      completedAt
      markerScope
    }
  }
}
    `;
export const FeatureFlagsFragmentDoc = gql`
    fragment FeatureFlags on InstitutionFeatures {
  id
  accessCode
  exams
  respondusLdb
  moodleGrader
  multiformat
  turnitin
  turnitinGrader
  cadmusGrader
  groupAssessment
  genAiDeclaration
  extensionSyncing
  advancedMarking
  timeline
  adminAccess
  viva
  labsContextualiser
  schoolyear
}
    `;
export const BrightspaceGroupFragmentDoc = gql`
    fragment BrightspaceGroup on BrightspaceGroup {
  id
  name
  code
  students {
    id
  }
  totalStudents
}
    `;
export const CanvasSectionFragmentDoc = gql`
    fragment CanvasSection on CanvasSection {
  id
  courseId
  name
  sisCourseId
  students {
    id
    name
    sisUserId
  }
  totalStudents
}
    `;
export const UserFragmentDoc = gql`
    fragment User on User {
  id
  name
  givenName
  familyName
  email
  tags @client
  colourset
}
    `;
export const GroupMarkerFragmentDoc = gql`
    fragment GroupMarker on GroupMarker {
  id
  role
  marker {
    ...User
  }
  markerPlaceholder
  groupMemberId
}
    ${UserFragmentDoc}`;
export const GroupMemberFragmentDoc = gql`
    fragment GroupMember on GroupMember {
  id
  colourset
  user {
    ...User
  }
  groupMarkers {
    ...GroupMarker
  }
}
    ${UserFragmentDoc}
${GroupMarkerFragmentDoc}`;
export const GroupTagFragmentDoc = gql`
    fragment GroupTag on GroupTag {
  id
  text
}
    `;
export const GroupFragmentDoc = gql`
    fragment Group on Group {
  id
  name
  markerId
  code
  sectionId
  marker {
    ...User
  }
  questionId
  members {
    ...User
  }
  groupMembers {
    ...GroupMember
  }
  maxLimit
  minLimit
  finalised
  finalisedAt
  tags {
    ...GroupTag
  }
  workSettings {
    id
    dueDate
    groupId
  }
}
    ${UserFragmentDoc}
${GroupMemberFragmentDoc}
${GroupTagFragmentDoc}`;
export const ClassGroupsFragmentDoc = gql`
    fragment ClassGroups on Class {
  id
  groups {
    ...Group
  }
  groupType
}
    ${GroupFragmentDoc}`;
export const DeletedMemberFragmentDoc = gql`
    fragment DeletedMember on DeletedMember {
  id
  groupId
}
    `;
export const GroupEnrollmentFragmentDoc = gql`
    fragment GroupEnrollment on Enrollment {
  id
  deleted
  user {
    id
  }
  workSettings {
    id
    examDeferred
    groupId
  }
}
    `;
export const LtiServiceFragmentDoc = gql`
    fragment LtiService on LtiService {
  id
  issuer
  name
  version
}
    `;
export const GroupSectionFragmentDoc = gql`
    fragment GroupSection on Section {
  id
  name
  position
  studentCount
}
    `;
export const SubmissionFragmentDoc = gql`
    fragment Submission on Submission {
  id
  workId
  submittedAt
  forceSubmitted
  submittedBy {
    ...User
  }
  type
}
    ${UserFragmentDoc}`;
export const GradebookReceiptFragmentDoc = gql`
    fragment GradebookReceipt on GradebookReceipt {
  pdfArtifactId
  turnitinComplete
  lmsSnooze
  lmsComplete
  emailComplete
}
    `;
export const ResultFragmentDoc = gql`
    fragment Result on Result {
  id
  workId
  submissionType
  isReady
  heraResultId
  canvasResultUrl
  moodleGraderUrl
  grade {
    display
    value
    max
  }
  similarity {
    display
    value
    label
  }
  feedbackAccess {
    lastAccess
    accessCount
    memberSummaries {
      lastAccess
      accessCount
      userId
    }
  }
  submission {
    ...Submission
  }
  receipt {
    ...GradebookReceipt
  }
}
    ${SubmissionFragmentDoc}
${GradebookReceiptFragmentDoc}`;
export const WorkFeaturesFragmentDoc = gql`
    fragment WorkFeatures on WorkFeatures {
  id
  enableWorkAuthority
}
    `;
export const WorkFragmentDoc = gql`
    fragment Work on Work {
  id
  startDate
  updatedAt
  lastSaveTime
  finalResult: result(submissionType: FINAL) {
    ...Result
  }
  draftResult: result(submissionType: DRAFT) {
    ...Result
  }
  attemptCount
  features {
    ...WorkFeatures
  }
}
    ${ResultFragmentDoc}
${WorkFeaturesFragmentDoc}`;
export const WorkGroupFragmentDoc = gql`
    fragment WorkGroup on WorkGroup {
  id
  group {
    ...Group
  }
  work {
    ...Work
  }
}
    ${GroupFragmentDoc}
${WorkFragmentDoc}`;
export const HubAssessmentSettingsFragmentDoc = gql`
    fragment HubAssessmentSettings on AssessmentSettings {
  id
  releaseDate
  openDate
  dueDate
  feedbackDate
  individualReportEnabled
  peerEvaluationEnabled
  selfEvaluationEnabled
  groupCharterEnabled
  groupCharterAcceptanceRequired
  referencingStyleEnabled
  wordLimitEnabled
  sentimentCheckEnabled
  groupReportWeight
  individualReportWeight
  peerEvaluationWeight
  peerEvaluationMode
  selfEvaluationWeight
  selfEvaluationMode
  individualReportDueDate
  groupCharterDueDate
  peerEvaluationDueDate
  groupSelfEnrollmentEnabled
  groupSelfEnrollmentDeadline
  groupChangeRequestCutoff
  groupShowEmailToStudents
  maxGrade
  draftEnabled
  draftDueDate
  groupDraftEnabled
  groupDraftDueDate
  allowGenerativeAi
}
    `;
export const MessageFragmentDoc = gql`
    fragment Message on Message {
  id
  sourceUserId
  messageType
}
    `;
export const SentimentCheckScheduleFragmentDoc = gql`
    fragment SentimentCheckSchedule on SentimentCheckSchedule {
  id
  scheduledAt
}
    `;
export const VivaSourceTaskFragmentDoc = gql`
    fragment VivaSourceTask on VivaSourceTask {
  id
  assessmentId
  name
}
    `;
export const AssessmentSettingsFragmentDoc = gql`
    fragment AssessmentSettings on AssessmentSettings {
  id
  assessmentType
  releaseDate
  openDate
  dueDate
  draftDueDate
  draftEnabled
  groupDraftDueDate
  groupDraftEnabled
  individualDraftFeedbackAlwaysAvailable
  groupDraftFeedbackAlwaysAvailable
  draftScoringEnabled
  submissionPdfDisabled
  lateSubmissionTimeLimit
  lateResubmissionEnabled
  submitAttemptLimit
  markingTool
  feedbackDate
  feedbackDateDisabled
  maxGrade
  anonymousMarking
  doubleBlindMarkingEnabled
  markingAclEnabled
  rubricDisplayDisabled
  restrictMarkingToolPdf
  markingToolPdf
  tiiSViewReports
  tiiDraftSViewReports
  timeLimit
  timeLimitEnabled
  examType
  examTiming
  examStartDate
  examEndDate
  examReadingTime
  examReadingTimeDisabled
  examWritingTime
  examAutoSubmissionDisabled
  examBacktrackDisabled
  examLdbEnabled
  examAccessCodeEnabled
  examReentryPreventionEnabled
  examInactivityTimeout
  examSchoolyearEnabled
  weight
  weightEnabled
  wordLimit
  wordLimitEnabled
  wordLimitGroup
  referencingStyle
  referencingStyleEnabled
  countReferences
  countFootnotes
  allowGenerativeAi
  spellCheckDisabled
  groupAssessmentEnabled
  groupSelfEnrollmentEnabled
  groupSelfEnrollmentDeadline
  groupFinalised
  groupHideMembersName
  sentimentCheckEnabled
  sentimentCheckSkipEnabled
  sentimentCheckIntervalInHr
  sentimentCheckFirstCheckAt
  sentimentCheckScheduleType
  sentimentCheckSchedules {
    ...SentimentCheckSchedule
  }
  individualReportEnabled
  individualReportWeight
  individualReportMaxGrade
  individualReportDueDate
  peerEvaluationEnabled
  peerEvaluationWeight
  peerEvaluationMaxGrade
  peerEvaluationDueDate
  peerEvaluationMode
  peerEvaluationMinScaleFactor
  selfEvaluationEnabled
  selfEvaluationWeight
  selfEvaluationMode
  selfEvaluationMaxGrade
  groupCharterEnabled
  groupCharterAcceptanceRequired
  groupCharterDueDate
  groupReportWeight
  groupReportMaxGrade
  smartAutomarkingEnabled
  vivaEnabled
  vivaReattemptWindowTime
  vivaCameraRequiredDisabled
  vivaSourceTask {
    ...VivaSourceTask
  }
  individualWorkAttachmentEnabled
  groupWorkAttachmentEnabled
}
    ${SentimentCheckScheduleFragmentDoc}
${VivaSourceTaskFragmentDoc}`;
export const ResponseDeclarationFragmentDoc = gql`
    fragment ResponseDeclaration on ResponseDeclaration {
  partialScoring
  matchSimilarity
  errorMargin
  correctValues
  correctRanges {
    identifier
    start
    end
  }
  correctAreas {
    ... on PositionArea {
      identifier
      shape
      coords
    }
  }
  caseSensitive
  cardinality
  baseType
}
    `;
export const SimpleChoiceFragmentDoc = gql`
    fragment SimpleChoice on SimpleChoice {
  identifier
  content
}
    `;
export const QuestionFieldFragmentDoc = gql`
    fragment QuestionField on QuestionField {
  identifier
  response {
    ...ResponseDeclaration
  }
  interaction {
    ... on ChoiceInteraction {
      choices {
        ...SimpleChoice
      }
      label
      maxChoices
    }
    ... on MatchInteraction {
      targetSet {
        ...SimpleChoice
      }
      sourceSet {
        ...SimpleChoice
      }
    }
    ... on ExtendedInteraction {
      wordLimit
      attachmentEnabled
      referencingEnabled
    }
    ... on TextEntryInteraction {
      expectedLength
      baseType
      attachmentEnabled
    }
    ... on PositionObjectInteraction {
      label
      maxChoices
    }
    ... on SocraticInteraction {
      responseTime
      readingTime
      maxAttempts
    }
  }
}
    ${ResponseDeclarationFragmentDoc}
${SimpleChoiceFragmentDoc}`;
export const QuestionBodyFragmentDoc = gql`
    fragment QuestionBody on QuestionBody {
  feedback
  promptDoc
  promptImage {
    ... on PromptImage {
      url
      width
      height
      layers {
        ... on PromptImageLayer {
          identifier
          shape
          coords
        }
      }
    }
  }
  fields {
    ...QuestionField
  }
}
    ${QuestionFieldFragmentDoc}`;
export const QuestionFragmentDoc = gql`
    fragment Question on Question {
  id
  cacheId
  questionType
  shortPrompt
  body {
    ...QuestionBody
  }
  updatedAt
}
    ${QuestionBodyFragmentDoc}`;
export const QuestionTagFragmentDoc = gql`
    fragment QuestionTag on QuestionTag {
  id
  name
  categoryId
}
    `;
export const QuestionAssessmentFragmentDoc = gql`
    fragment QuestionAssessment on QuestionAssessment {
  assessment {
    id
    name
    subject {
      id
      name
    }
  }
  points
  releaseTimestamp
}
    `;
export const QuestionSourceFileFragmentDoc = gql`
    fragment QuestionSourceFile on QuestionSourceFile {
  id
  filename
  filepath
}
    `;
export const LibraryQuestionOverviewFragmentDoc = gql`
    fragment LibraryQuestionOverview on Question {
  id
  cacheId
  libraryId
  questionType
  shortPrompt
  points
  difficulty
  tags {
    ...QuestionTag
  }
  assessmentUsages {
    ...QuestionAssessment
  }
  sourceFile {
    ...QuestionSourceFile
  }
  createdAt
}
    ${QuestionTagFragmentDoc}
${QuestionAssessmentFragmentDoc}
${QuestionSourceFileFragmentDoc}`;
export const QuestionSetQuestionFragmentDoc = gql`
    fragment QuestionSetQuestion on QuestionSetQuestion {
  id
  points
  shuffle
  parentNodeId
  previousNodeId
  nodeId
  questionVersionId
  question {
    ...LibraryQuestionOverview
    updatedAt
    body {
      ...QuestionBody
    }
  }
}
    ${LibraryQuestionOverviewFragmentDoc}
${QuestionBodyFragmentDoc}`;
export const QuestionSetFragmentDoc = gql`
    fragment QuestionSet on QuestionSet {
  id
  label
  order
  questions {
    ...QuestionSetQuestion
  }
}
    ${QuestionSetQuestionFragmentDoc}`;
export const LearningOutcomeSkillFragmentDoc = gql`
    fragment LearningOutcomeSkill on LearningOutcomeSkill {
  id
  skill
}
    `;
export const ScaleItemFragmentDoc = gql`
    fragment ScaleItem on ScaleItem {
  id
  order
  scaleLabel
  description
  rangeFrom
  rangeTo
}
    `;
export const CriterionFragmentDoc = gql`
    fragment Criterion on Criterion {
  id
  title
  color
  order
  maxScore
  description
  hasOutcomes
  skill {
    ...LearningOutcomeSkill
  }
  scaleItems {
    ...ScaleItem
  }
}
    ${LearningOutcomeSkillFragmentDoc}
${ScaleItemFragmentDoc}`;
export const MarkerRubricFragmentDoc = gql`
    fragment MarkerRubric on MarkerRubric {
  id
  assessmentId
  kind
  format
  reversedScale
  publishedAt
  hasChanges
  state
  updatedAt
  location {
    assessment
    path
  }
  criteria {
    ...Criterion
  }
  markingExists
}
    ${CriterionFragmentDoc}`;
export const TaskBlockFragmentDoc = gql`
    fragment TaskBlock on TaskBlock {
  id
  previousNodeId
  nodeId
  parentNodeId
  deleted
  hidden
  quantity
  shuffle
  points
  order
  orderLabel
  question {
    ...Question
  }
  questionSelection {
    id
    sets {
      ...QuestionSet
    }
  }
  libraryQuestionId
  libraryQuestionVersionId
  markerRubric {
    ...MarkerRubric
  }
  socraticQuestionerEnabled
  updatedAt
}
    ${QuestionFragmentDoc}
${QuestionSetFragmentDoc}
${MarkerRubricFragmentDoc}`;
export const RequirementsFragmentDoc = gql`
    fragment Requirements on Requirements {
  id
  assessmentType
  enableExamAutoSubmission
  enableExamLdb
  enableSubmissionPdf
  enableExamAccessCode
  examEndDate
  examFeedbackDate
  examReadingTime
  examStartDate
  examTiming
  examType
  examWritingTime
  lateSubmissionTimeLimit
  noExamReadingTime
  noExamFeedbackDate
  submitAttemptLimit
  dueDate
  returnDate
  maxGrade
  sViewReports
  anonymousMarking
  gradingService
  allowLateResubmission
  draftDueDate
  noDraft
  draftSViewReports
  individualDraftFeedbackAlwaysAvailable
  draftScoringEnabled
  weight
  noWeight
  wordLimit
  noLimit
  timeLimit
  noTimeLimit
  countReferences
  countFootnotes
  allowGenerativeAi
  disableSpellCheck
  restrictMarkingToolPdf
  markingToolPdf
  rubricDisplayDisabled
  referencingStyle
  noReferencing
  disableExamBacktrack
  hasChanged
  enableExamReentryPrevention
  examInactivityTimeout
  examSchoolyearEnabled
}
    `;
export const SaveStateFragmentDoc = gql`
    fragment SaveState on SaveState {
  id
  serverId
  version
  rawContent
  updatedAt
}
    `;
export const TaskNoticeFragmentDoc = gql`
    fragment TaskNotice on TaskNotice {
  id
  version
  content
}
    `;
export const TaskFragmentDoc = gql`
    fragment Task on Task {
  id
  status
  kind
  format
  blocks {
    ...TaskBlock
  }
  requirements {
    ...Requirements
  }
  saveState {
    ...SaveState
  }
  resources {
    ...Resource
  }
  genaiGuidelineNotice {
    ...TaskNotice
  }
}
    ${TaskBlockFragmentDoc}
${RequirementsFragmentDoc}
${SaveStateFragmentDoc}
${ResourceFragmentDoc}
${TaskNoticeFragmentDoc}`;
export const QuestionBlockFragmentDoc = gql`
    fragment QuestionBlock on QuestionBlock {
  nodeId
  parentNodeId
  nodeType
  order
  shortLabel
  longLabel
  shuffle
  points
  socraticQuestionerEnabled
  question {
    ...Question
  }
}
    ${QuestionFragmentDoc}`;
export const InstructionSheetFragmentDoc = gql`
    fragment InstructionSheet on Sheet {
  id
  serverId
  taskId
  kind
  format
  rawContent
  releaseTimestamp
  version
  questionBlocks {
    ...QuestionBlock
  }
  resources {
    ...Resource
  }
  settings {
    ...AssessmentSettings
  }
}
    ${QuestionBlockFragmentDoc}
${ResourceFragmentDoc}
${AssessmentSettingsFragmentDoc}`;
export const InstructionSheetWithFutureSettingsFragmentDoc = gql`
    fragment InstructionSheetWithFutureSettings on Sheet {
  id
  serverId
  format
  kind
  taskId
  rawContent
  releaseTimestamp
  version
  questionBlocks {
    ...QuestionBlock
  }
  resources {
    ...Resource
  }
  settings {
    ...AssessmentSettings
  }
  futureSettings {
    ...AssessmentSettings
  }
}
    ${QuestionBlockFragmentDoc}
${ResourceFragmentDoc}
${AssessmentSettingsFragmentDoc}`;
export const SettingsRouteAssessmentFragmentDoc = gql`
    fragment SettingsRouteAssessment on Assessment {
  id
  name
  subjectName
  subjectId
  dueDate
  gradingDueDate
  startDate
  endDate
  subject {
    id
    name
    discipline
  }
  ltiTool {
    id
    name
    familyCode
  }
  ltiServices {
    id
    name
    version
    issuer
    metaUrl
    isLtiPluginAgs
  }
  settings {
    ...AssessmentSettings
  }
  ltiCustomParams {
    moodleAttemptReopenMethod
  }
  edition
  hasSave
  hasSubmission
  tasks {
    ...Task
    instructionSheet {
      ...InstructionSheet
    }
    futureSheet {
      ...InstructionSheetWithFutureSettings
    }
  }
}
    ${AssessmentSettingsFragmentDoc}
${TaskFragmentDoc}
${InstructionSheetFragmentDoc}
${InstructionSheetWithFutureSettingsFragmentDoc}`;
export const MailingListFragmentDoc = gql`
    fragment MailingList on MailingList {
  id
  subscribed
  members
}
    `;
export const InstitutionFragmentDoc = gql`
    fragment Institution on Institution {
  id
  tenant
  timezone
}
    `;
export const AssessmentOverviewFragmentDoc = gql`
    fragment AssessmentOverview on Assessment {
  id
  name
  subject {
    name
  }
}
    `;
export const WorkSettingsFragmentDoc = gql`
    fragment WorkSettings on WorkSettings {
  id
  studentId
  dueDate
  timeLimit
  examReadingTime
  examWritingTime
  examStartDate
  examEndDate
  examDeferred
  submitAttemptLimit
  updatedAt
  lastUpdatedBy {
    id
    name
  }
  updateReason
  draftExamStartDate
  draftExamEndDate
  groupId
  vivaExtraAttempts
}
    `;
export const AccessCodeFragmentDoc = gql`
    fragment AccessCode on AccessCode {
  code
  label
  active
  type
}
    `;
export const VerifiedCodeFragmentDoc = gql`
    fragment VerifiedCode on VerifiedCode {
  label
  insertedAt
}
    `;
export const EnrollmentFragmentDoc = gql`
    fragment Enrollment on Enrollment {
  id
  sectionId
  syncedAt
  deleted
  deletedBy {
    id
    name
  }
  user {
    ...User
  }
  work {
    ...Work
  }
  tags {
    id
    text
    column
    tab
  }
  workSettings {
    ...WorkSettings
  }
  sisUserId
  accessCode {
    ...AccessCode
  }
  verifiedCodes {
    ...VerifiedCode
  }
  reentryCount
  anonymousIndex
}
    ${UserFragmentDoc}
${WorkFragmentDoc}
${WorkSettingsFragmentDoc}
${AccessCodeFragmentDoc}
${VerifiedCodeFragmentDoc}`;
export const ClassListEnrollmentsFragmentDoc = gql`
    fragment ClassListEnrollments on ClassList {
  id
  enrollments {
    ...Enrollment
  }
}
    ${EnrollmentFragmentDoc}`;
export const ContributionFieldsFragmentDoc = gql`
    fragment ContributionFields on Contribution {
  asOfVersion
  members {
    userId
    ranges {
      from
      to
    }
    deletions {
      deletedById
      anchor
      text
      node
      marks {
        type
        attrs
      }
      media {
        type
        src
        width
        customWidth
        imageAlign
      }
    }
  }
}
    `;
export const EntityThreadEventFragmentDoc = gql`
    fragment EntityThreadEvent on EntityThreadEvent {
  eventType
  threadId
  status
  entityId
  entityType
  resolvedAt
  resolvedBy {
    ...User
  }
  criterionId
}
    ${UserFragmentDoc}`;
export const FeedbackReleaseRuleFragmentDoc = gql`
    fragment FeedbackReleaseRule on FeedbackReleaseRule {
  id
  basePool
  excludedStudentIds
  excludedTags
  executedAt
  includedStudentIds
  scheduledAt
  executedStudentIds
  ruleKind
  includedGroupIds
  releaseType
}
    `;
export const FeedbackVisibilityFragmentDoc = gql`
    fragment FeedbackVisibility on FeedbackVisibility {
  id
  feedbackViewLevel
  withFeedbackPdf
  notifyStudents
  showPeerScores
  showPeerComments
  jointRelease
  releaseType
}
    `;
export const FieldOutcomeScoreFragmentDoc = gql`
    fragment FieldOutcomeScore on FieldOutcome {
  id
  identifier
  fieldRubricId
  score
  markerScore
  automarkScore
}
    `;
export const FieldResponseFragmentDoc = gql`
    fragment FieldResponse on FieldResponse {
  answer
  answers
  count
  isCorrect
  similarity
}
    `;
export const FieldRubricResponseFragmentDoc = gql`
    fragment FieldRubricResponse on FieldRubric {
  id
  identifier
  responses {
    ...FieldResponse
  }
}
    ${FieldResponseFragmentDoc}`;
export const MarkEnrollmentFragmentDoc = gql`
    fragment MarkEnrollment on Enrollment {
  id
  anonymousIndex
  user {
    id
    name
  }
}
    `;
export const MarkingSheetFragmentDoc = gql`
    fragment MarkingSheet on Sheet {
  id
  serverId
  format
  releaseTimestamp
  questionBlocks {
    ...QuestionBlock
  }
}
    ${QuestionBlockFragmentDoc}`;
export const ModerationPenaltyRuleFragmentDoc = gql`
    fragment ModerationPenaltyRule on ModerationPenaltyRule {
  canStack
  excludedStudentIds
  includedTags
  id
  minutesLateBy
  penaltyScore
  scoreUnit
  penaltyType
  reason
  formatUnit
  ruleKind
  includedGroupIds
}
    `;
export const QuestionResponseCountsFragmentDoc = gql`
    fragment QuestionResponseCounts on QuestionResponseCounts {
  responseCount
  successCount
  averageScore
}
    `;
export const FieldRubricChangesFragmentDoc = gql`
    fragment FieldRubricChanges on FieldRubricChanges {
  id
  valuesAdded
  valuesRemoved
}
    `;
export const FieldRubricFragmentDoc = gql`
    fragment FieldRubric on FieldRubric {
  id
  identifier
  baseType
  values
  automarked
  strategy
  correctRanges {
    identifier
    start
    end
  }
  correctAreas {
    ... on PositionArea {
      identifier
      shape
      coords
    }
  }
  similarity
  errorMargin
  caseSensitive
  partialScoring
  markerChanges {
    ...FieldRubricChanges
  }
  moderatorChanges {
    ...FieldRubricChanges
  }
  markerRubric {
    ...MarkerRubric
  }
}
    ${FieldRubricChangesFragmentDoc}
${MarkerRubricFragmentDoc}`;
export const QuestionRubricWithCountsFragmentDoc = gql`
    fragment QuestionRubricWithCounts on QuestionRubric {
  id
  questionId
  maxScore
  counts {
    ...QuestionResponseCounts
  }
  fieldRubrics {
    ...FieldRubric
  }
}
    ${QuestionResponseCountsFragmentDoc}
${FieldRubricFragmentDoc}`;
export const ModerationQuestionFragmentDoc = gql`
    fragment ModerationQuestion on ModerationQuestion {
  id
  nodeId
  parentNodeId
  questionId
  questionType
  shortPrompt
  shortLabel
  longLabel
  order
  maxScore
  score
  automarked
  answerable
  hasMarkerChanges
  rates {
    responseRate
    successRate
    averageScore
  }
  rubric {
    ...QuestionRubricWithCounts
  }
  body {
    ...QuestionBody
  }
}
    ${QuestionRubricWithCountsFragmentDoc}
${QuestionBodyFragmentDoc}`;
export const WorkOutcomeQuestionScoresFragmentDoc = gql`
    fragment WorkOutcomeQuestionScores on WorkOutcomeQuestionScores {
  id
  workOutcomeId
  questionScores {
    questionId
    score
  }
}
    `;
export const PastMarkerRubricFragmentDoc = gql`
    fragment PastMarkerRubric on MarkerRubric {
  id
  assessmentId
  kind
  format
  reversedScale
  publishedAt
  location {
    assessment
    path
  }
  criteria {
    ...Criterion
  }
}
    ${CriterionFragmentDoc}`;
export const QuestionRubricFragmentDoc = gql`
    fragment QuestionRubric on QuestionRubric {
  id
  questionId
  maxScore
  fieldRubrics {
    ...FieldRubric
  }
}
    ${FieldRubricFragmentDoc}`;
export const ReuseCriterionFragmentDoc = gql`
    fragment ReuseCriterion on ReuseCriterion {
  assessmentName
  color
  description
  kind
  maxScore
  publishedAt
  skill {
    ...LearningOutcomeSkill
  }
  scaleItems {
    ...ScaleItem
  }
}
    ${LearningOutcomeSkillFragmentDoc}
${ScaleItemFragmentDoc}`;
export const SaveFragmentDoc = gql`
    fragment Save on Save {
  id
  serverId
  version
  content
  dispatchedAt
}
    `;
export const SkillFragmentDoc = gql`
    fragment Skill on LearningOutcomeSkill {
  id
  skill
}
    `;
export const SmartCommentFragmentDoc = gql`
    fragment SmartComment on SmartComment {
  id
  score
  skillId
  content
  insertedAt
  assessmentId
  assessmentName
  userName
  lastUsed
  usageCount
}
    `;
export const CriterionOutcomeFragmentDoc = gql`
    fragment CriterionOutcome on CriterionOutcome {
  id
  markerUserId
  markerScore
  markerRubricCriterionId
  markerRubricScaleItemId
  targetUserId
  updatedAt
  publishedAt
}
    `;
export const PeerOutcomeFragmentDoc = gql`
    fragment PeerOutcome on PeerOutcome {
  id
  targetUserId
  selfScore
  selfMaxScore
  peerScore
  peerMaxScore
  isComplete
  hasEvaluatedAllPeers
  hasReceivedAllEvaluations
  hasCompletedSelfEvaluation
  feedbackReleasedTimestamp
  evaluationsSubmittedAt
  groupReportScaleFactor
  criterionOutcomes {
    ...CriterionOutcome
  }
}
    ${CriterionOutcomeFragmentDoc}`;
export const ScoreBreakdownFragmentDoc = gql`
    fragment ScoreBreakdown on ScoreBreakdown {
  score
  marker
  automark
  markerModifier
  moderatorModifier
}
    `;
export const WorkOutcomeReleaseFragmentDoc = gql`
    fragment WorkOutcomeRelease on WorkOutcomeRelease {
  id
  releaseType
  releasedAt
  finalScore
  penaltyScore
  moderatorModifier
}
    `;
export const ModerationSubmissionOutcomeScoreFragmentDoc = gql`
    fragment ModerationSubmissionOutcomeScore on SubmissionOutcome {
  id
  submissionId
  submissionType
  markerScope
  score
  markerModifier
  completedAt
  scoreModeration
  feedbackModeration
  flagReason
  moderationOutcome {
    score
  }
}
    `;
export const WorkOutcomeClassFragmentDoc = gql`
    fragment WorkOutcomeClass on WorkOutcome {
  id
  workId
  studentId
  groupId
  assessmentId
  finalScore
  maxScore
  scoreBreakdown {
    ...ScoreBreakdown
  }
  automarkPending
  feedbackReleasedTimestamp
  finalScore
  finalScorePenalty
  questionOutcomesScored
  provisionalRelease {
    ...WorkOutcomeRelease
  }
  finalRelease {
    ...WorkOutcomeRelease
  }
  moderationSubmissionOutcomes {
    ...ModerationSubmissionOutcomeScore
  }
  markingSubmissionOutcome {
    ...ModerationSubmissionOutcomeScore
  }
  draftSubmissionOutcome {
    id
    score
  }
}
    ${ScoreBreakdownFragmentDoc}
${WorkOutcomeReleaseFragmentDoc}
${ModerationSubmissionOutcomeScoreFragmentDoc}`;
export const WeightedScoreFragmentDoc = gql`
    fragment WeightedScore on WeightedScore {
  score
  maxScore
  penaltyScore
  moderatorModifierComponents
  moderatorModifierStudent
}
    `;
export const ComponentScoreFragmentDoc = gql`
    fragment ComponentScore on ComponentScore {
  score
  maxScore
  moderatorModifier
  modifiersTotal
  penaltyScore
  weight
  weightedScore
  weightedMaxScore
  weightedModeratorModifier
  weightedPenaltyScore
}
    `;
export const ComponentBreakdownFragmentDoc = gql`
    fragment ComponentBreakdown on ComponentBreakdown {
  total {
    ...WeightedScore
  }
  group {
    ...ComponentScore
  }
  individual {
    ...ComponentScore
  }
  self {
    ...ComponentScore
  }
  peer {
    ...ComponentScore
  }
}
    ${WeightedScoreFragmentDoc}
${ComponentScoreFragmentDoc}`;
export const StudentOutcomeFragmentDoc = gql`
    fragment StudentOutcome on StudentOutcome {
  id
  studentId
  peerOutcome {
    ...PeerOutcome
  }
  groupWorkOutcome {
    ...WorkOutcomeClass
  }
  individualWorkOutcome {
    ...WorkOutcomeClass
  }
  moderatorModifier
  modifiers {
    id
    type
    component
    value
  }
  base {
    ...ComponentBreakdown
  }
  provisional {
    ...ComponentBreakdown
  }
  final {
    ...ComponentBreakdown
  }
}
    ${PeerOutcomeFragmentDoc}
${WorkOutcomeClassFragmentDoc}
${ComponentBreakdownFragmentDoc}`;
export const QuestionOutcomeScoreFragmentDoc = gql`
    fragment QuestionOutcomeScore on QuestionOutcome {
  id
  questionId
  scoreBreakdown {
    score
    automark
  }
}
    `;
export const FieldOutcomeFragmentDoc = gql`
    fragment FieldOutcome on FieldOutcome {
  id
  identifier
  fieldRubricId
  score
  automarkScore
  automarkStatus
  answer
  answers
  answerSimilarity
  comments {
    id
  }
  docContent
  docVersion
  referencesDocContent
  referencesDocVersion
  rubricOutcome {
    criterionOutcomes {
      ...CriterionOutcome
    }
    score
  }
}
    ${CriterionOutcomeFragmentDoc}`;
export const QuestionOutcomeFragmentDoc = gql`
    fragment QuestionOutcome on QuestionOutcome {
  ...QuestionOutcomeScore
  blockSnapshot {
    id
    content
    blockName
    answerBlockId
  }
  referencesBlockSnapshot {
    id
    content
    blockName
  }
  fieldOutcomes {
    ...FieldOutcome
  }
}
    ${QuestionOutcomeScoreFragmentDoc}
${FieldOutcomeFragmentDoc}`;
export const SubmissionOutcomeFragmentDoc = gql`
    fragment SubmissionOutcome on SubmissionOutcome {
  id
  submissionId
  submissionType
  submittedAt
  bodyBlockSnapshotId
  bodyDocVersion
  bodyDoc
  referencesBlockSnapshotId
  referencesDocVersion
  referencesDoc
  markerScope
  score
  markerModifier
  latestForType
  completedAt
  rubricOutcome {
    criterionOutcomes {
      ...CriterionOutcome
    }
    score
  }
  scoreModeration
  feedbackModeration
}
    ${CriterionOutcomeFragmentDoc}`;
export const ModerationSubmissionOutcomeFragmentDoc = gql`
    fragment ModerationSubmissionOutcome on SubmissionOutcome {
  id
  submissionId
  submissionType
  submittedAt
  bodyBlockSnapshotId
  bodyDocVersion
  bodyDoc
  referencesBlockSnapshotId
  referencesDocVersion
  referencesDoc
  markerScope
  score
  markerModifier
  latestForType
  completedAt
  rubricOutcome {
    criterionOutcomes {
      ...CriterionOutcome
    }
    score
  }
  scoreModeration
  feedbackModeration
  moderationOutcome {
    score
    feedbackModerationId
    bodyDoc
    referencesDoc
    markerModifier
    rubricOutcome {
      criterionOutcomes {
        ...CriterionOutcome
      }
      score
    }
  }
}
    ${CriterionOutcomeFragmentDoc}`;
export const BlockAttachmentFragmentDoc = gql`
    fragment BlockAttachment on BlockAttachment {
  id
  name
  mediaUrl
  fileSize
  fileExtension
  insertedAt
  uploadedBy {
    id
    name
  }
}
    `;
export const AnswerBlockFragmentDoc = gql`
    fragment AnswerBlock on AnswerBlock {
  id
  nodeId
  blockName
  blockAttachments {
    ...BlockAttachment
  }
}
    ${BlockAttachmentFragmentDoc}`;
export const WorkOutcomeFragmentDoc = gql`
    fragment WorkOutcome on WorkOutcome {
  id
  workId
  groupId
  studentId
  maxScore
  automarkPending
  feedbackReleased
  feedbackReleasedTimestamp
  finalScore
  scoreBreakdown {
    ...ScoreBreakdown
  }
  questionOutcomes {
    ...QuestionOutcome
  }
  draftSubmissionOutcome {
    ...SubmissionOutcome
  }
  finalSubmissionOutcome {
    ...SubmissionOutcome
  }
  submissionOutcomes {
    ...SubmissionOutcome
  }
  moderationSubmissionOutcomes {
    ...ModerationSubmissionOutcome
  }
  markingSubmissionOutcome {
    ...SubmissionOutcome
  }
  workOutcomeRelease {
    ...WorkOutcomeRelease
  }
  answerBlocks {
    ...AnswerBlock
  }
}
    ${ScoreBreakdownFragmentDoc}
${QuestionOutcomeFragmentDoc}
${SubmissionOutcomeFragmentDoc}
${ModerationSubmissionOutcomeFragmentDoc}
${WorkOutcomeReleaseFragmentDoc}
${AnswerBlockFragmentDoc}`;
export const WorkOutcomeMarkFragmentDoc = gql`
    fragment WorkOutcomeMark on WorkOutcome {
  id
  workId
  studentId
  groupId
  finalSubmissionOutcome {
    id
  }
  markingSubmissionOutcome {
    id
  }
}
    `;
export const WorkOutcomeScoreFragmentDoc = gql`
    fragment WorkOutcomeScore on WorkOutcome {
  id
  workId
  studentId
  groupId
  maxScore
  automarkPending
  scoreBreakdown {
    ...ScoreBreakdown
  }
}
    ${ScoreBreakdownFragmentDoc}`;
export const QuestionOutcomeSubscriptionFragmentDoc = gql`
    fragment QuestionOutcomeSubscription on QuestionOutcome {
  id
  questionId
  scoreBreakdown {
    ...ScoreBreakdown
  }
  fieldOutcomes {
    ...FieldOutcome
  }
}
    ${ScoreBreakdownFragmentDoc}
${FieldOutcomeFragmentDoc}`;
export const WorkOutcomeUpdatedFragmentDoc = gql`
    fragment WorkOutcomeUpdated on WorkOutcome {
  id
  workId
  groupId
  studentId
  maxScore
  finalScore
  finalScorePenalty
  scoreBreakdown {
    ...ScoreBreakdown
  }
  draftSubmissionOutcome {
    ...SubmissionOutcome
  }
  finalSubmissionOutcome {
    ...SubmissionOutcome
  }
  questionOutcomes {
    ...QuestionOutcomeSubscription
  }
  provisionalRelease {
    ...WorkOutcomeRelease
  }
  finalRelease {
    ...WorkOutcomeRelease
  }
  moderationSubmissionOutcomes {
    ...ModerationSubmissionOutcomeScore
  }
  markingSubmissionOutcome {
    ...ModerationSubmissionOutcomeScore
  }
}
    ${ScoreBreakdownFragmentDoc}
${SubmissionOutcomeFragmentDoc}
${QuestionOutcomeSubscriptionFragmentDoc}
${WorkOutcomeReleaseFragmentDoc}
${ModerationSubmissionOutcomeScoreFragmentDoc}`;
export const SubjectFragmentDoc = gql`
    fragment Subject on Subject {
  id
  discipline
  name
  label
}
    `;
export const UserSettingsFragmentDoc = gql`
    fragment UserSettings on UserSettings {
  id
  subjectRole
  showIaOnboarding
}
    `;
export const OnboardingPayloadFragmentDoc = gql`
    fragment OnboardingPayload on OnboardingPayload {
  subject {
    ...Subject
  }
  userSettings {
    ...UserSettings
  }
}
    ${SubjectFragmentDoc}
${UserSettingsFragmentDoc}`;
export const EnrollmentTagsFragmentDoc = gql`
    fragment EnrollmentTags on Enrollment {
  id
  tags {
    text
    column
    tab
  }
}
    `;
export const ProjectIssueFragmentDoc = gql`
    fragment ProjectIssue on ProjectIssue {
  id
  type
  status
  dueDate
  parentId
  assignees
  groupId
}
    `;
export const WorkArtifactFragmentDoc = gql`
    fragment WorkArtifact on WorkArtifact {
  id
  name
  taskHistoryId
  submissionId
  workId
  studentSentAt
  agsSentAt
}
    `;
export const QuestionVersionSummaryFragmentDoc = gql`
    fragment QuestionVersionSummary on QuestionVersion {
  id
  user {
    id
    name
  }
  insertedAt
  version
}
    `;
export const ChildQuestionFragmentDoc = gql`
    fragment ChildQuestion on Question {
  id
  parentQuestionId
  libraryId
  cacheId
  questionType
  shortPrompt
  points
  order
  shuffle
  body {
    ...QuestionBody
  }
  difficulty
  currentVersionId
  versions {
    ...QuestionVersionSummary
  }
}
    ${QuestionBodyFragmentDoc}
${QuestionVersionSummaryFragmentDoc}`;
export const LibraryQuestionFragmentDoc = gql`
    fragment LibraryQuestion on Question {
  id
  cacheId
  libraryId
  parentQuestionId
  currentVersionId
  questionType
  shortPrompt
  points
  shuffle
  body {
    ...QuestionBody
  }
  difficulty
  order
  updatedAt
  childrenQuestions {
    ...ChildQuestion
  }
  versions {
    ...QuestionVersionSummary
  }
  lastUpdatedBy {
    id
    name
  }
  tags {
    ...QuestionTag
  }
  assessmentUsages {
    ...QuestionAssessment
  }
  sourceFile {
    ...QuestionSourceFile
  }
}
    ${QuestionBodyFragmentDoc}
${ChildQuestionFragmentDoc}
${QuestionVersionSummaryFragmentDoc}
${QuestionTagFragmentDoc}
${QuestionAssessmentFragmentDoc}
${QuestionSourceFileFragmentDoc}`;
export const QuestionSelectionRuleFragmentDoc = gql`
    fragment QuestionSelectionRule on QuestionSelectionRule {
  id
  points
  quantity
  questionType
  difficulty
}
    `;
export const QuestionSelectionFragmentDoc = gql`
    fragment QuestionSelection on QuestionSelection {
  id
  setsQuantity
  sets {
    ...QuestionSet
  }
  rules {
    ...QuestionSelectionRule
  }
}
    ${QuestionSetFragmentDoc}
${QuestionSelectionRuleFragmentDoc}`;
export const QuestionTagCategoryFragmentDoc = gql`
    fragment QuestionTagCategory on QuestionTagCategory {
  id
  name
}
    `;
export const ChildQuestionVersionFragmentDoc = gql`
    fragment ChildQuestionVersion on QuestionVersion {
  id
  body {
    ...QuestionBody
  }
  insertedAt
  parentQuestionId
  questionId
  questionType
  shortPrompt
  version
  order
  user {
    id
    name
  }
}
    ${QuestionBodyFragmentDoc}`;
export const QuestionVersionFragmentDoc = gql`
    fragment QuestionVersion on QuestionVersion {
  id
  insertedAt
  parentQuestionId
  questionId
  questionType
  shortPrompt
  user {
    id
    name
  }
  body {
    ...QuestionBody
  }
  childrenQuestions {
    ...ChildQuestionVersion
  }
}
    ${QuestionBodyFragmentDoc}
${ChildQuestionVersionFragmentDoc}`;
export const SentimentCheckFragmentDoc = gql`
    fragment SentimentCheck on SentimentCheck {
  id
  skipped
  level
  order
  user {
    ...User
  }
  comment
  insertedAt
}
    ${UserFragmentDoc}`;
export const SocraticTurnFragmentDoc = gql`
    fragment SocraticTurn on SocraticTurn {
  id
  generated
  questionPrompt
  response {
    mediaUrl
    durationSeconds
  }
}
    `;
export const SocraticDialogueFragmentDoc = gql`
    fragment SocraticDialogue on SocraticDialogue {
  id
  attemptNumber
  turns {
    ...SocraticTurn
  }
}
    ${SocraticTurnFragmentDoc}`;
export const TaskBlockQuestionerFragmentDoc = gql`
    fragment TaskBlockQuestioner on TaskBlock {
  id
  points
  shuffle
  hidden
  socraticQuestionerEnabled
  previousNodeId
  parentNodeId
  nodeId
  question {
    ...Question
  }
  libraryQuestionId
}
    ${QuestionFragmentDoc}`;
export const SocraticQuestionFragmentDoc = gql`
    fragment SocraticQuestion on SocraticQuestion {
  id
  content
  error
  status
  student {
    id
    name
  }
}
    `;
export const SocraticQuestionerRunFragmentDoc = gql`
    fragment SocraticQuestionerRun on SocraticQuestionerRun {
  id
  baseQuestion
  sourceTaskId
  socraticQuestions {
    ...SocraticQuestion
  }
}
    ${SocraticQuestionFragmentDoc}`;
export const SocraticQuestionerPreviewFragmentDoc = gql`
    fragment SocraticQuestionerPreview on SocraticQuestionerPreview {
  id
  taskBlock {
    ...TaskBlockQuestioner
  }
  questionerRuns {
    ...SocraticQuestionerRun
  }
}
    ${TaskBlockQuestionerFragmentDoc}
${SocraticQuestionerRunFragmentDoc}`;
export const WorkOutcomePreviewFragmentDoc = gql`
    fragment WorkOutcomePreview on WorkOutcome {
  id
  workId
  student {
    id
    name
  }
  finalSubmissionOutcome {
    ...SubmissionOutcome
  }
  answerBlocks {
    ...AnswerBlock
  }
}
    ${SubmissionOutcomeFragmentDoc}
${AnswerBlockFragmentDoc}`;
export const SchoolyearExamFragmentDoc = gql`
    fragment SchoolyearExam on SchoolyearExam {
  id
  pushStatus
}
    `;
export const AssessmentFragmentDoc = gql`
    fragment Assessment on Assessment {
  id
  name
  subjectName
  subjectId
  dueDate
  gradingDueDate
  startDate
  endDate
  subject {
    ...Subject
  }
  ltiTool {
    id
    name
    familyCode
  }
  ltiServices {
    id
    name
    version
    issuer
    metaUrl
    isLtiPluginAgs
  }
  settings {
    ...AssessmentSettings
  }
  ltiCustomParams {
    moodleAttemptReopenMethod
  }
  schoolyearExam {
    ...SchoolyearExam
  }
  edition
}
    ${SubjectFragmentDoc}
${AssessmentSettingsFragmentDoc}
${SchoolyearExamFragmentDoc}`;
export const HubTaskFragmentDoc = gql`
    fragment HubTask on Task {
  id
  kind
  status
  saveState {
    id
    version
    rawContent
  }
  genaiGuidelineNotice {
    id
  }
}
    `;
export const TaskQuestionSetQuestionFragmentDoc = gql`
    fragment TaskQuestionSetQuestion on QuestionSetQuestion {
  id
  points
  shuffle
  parentNodeId
  previousNodeId
  nodeId
  question {
    ...Question
  }
}
    ${QuestionFragmentDoc}`;
export const TaskQuestionSetFragmentDoc = gql`
    fragment TaskQuestionSet on QuestionSet {
  id
  label
  order
  questions {
    ...TaskQuestionSetQuestion
  }
}
    ${TaskQuestionSetQuestionFragmentDoc}`;
export const TaskQuestionSelectionFragmentDoc = gql`
    fragment TaskQuestionSelection on QuestionSelection {
  id
  setsQuantity
  sets {
    ...TaskQuestionSet
  }
  rules {
    ...QuestionSelectionRule
  }
}
    ${TaskQuestionSetFragmentDoc}
${QuestionSelectionRuleFragmentDoc}`;
export const TaskFormatFragmentDoc = gql`
    fragment TaskFormat on Task {
  id
  kind
  format
}
    `;
export const TaskStatusFragmentDoc = gql`
    fragment TaskStatus on Task {
  id
  status
}
    `;
export const ApiTokenDocument = gql`
    query ApiToken($assessmentId: ID!, $workId: ID) {
  apiToken(assessmentId: $assessmentId, workId: $workId)
}
    `;

/**
 * __useApiTokenQuery__
 *
 * To run a query within a React component, call `useApiTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiTokenQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      workId: // value for 'workId'
 *   },
 * });
 */
export function useApiTokenQuery(baseOptions: Apollo.QueryHookOptions<ApiTokenQuery, ApiTokenQueryVariables> & ({ variables: ApiTokenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApiTokenQuery, ApiTokenQueryVariables>(ApiTokenDocument, options);
      }
export function useApiTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApiTokenQuery, ApiTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApiTokenQuery, ApiTokenQueryVariables>(ApiTokenDocument, options);
        }
export function useApiTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApiTokenQuery, ApiTokenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApiTokenQuery, ApiTokenQueryVariables>(ApiTokenDocument, options);
        }
export type ApiTokenQueryHookResult = ReturnType<typeof useApiTokenQuery>;
export type ApiTokenLazyQueryHookResult = ReturnType<typeof useApiTokenLazyQuery>;
export type ApiTokenSuspenseQueryHookResult = ReturnType<typeof useApiTokenSuspenseQuery>;
export type ApiTokenQueryResult = Apollo.QueryResult<ApiTokenQuery, ApiTokenQueryVariables>;
export const AssessmentProgressDocument = gql`
    query AssessmentProgress($assessmentId: ID!) {
  assessmentProgress(assessmentId: $assessmentId) {
    work {
      individualStatistics {
        notStartedCount
        viewedCount
        inProgressCount
        submittedCount
      }
      groupStatistics {
        notStartedCount
        viewedCount
        inProgressCount
        submittedCount
      }
      items {
        kind
        entityId
        overallStatus
        lastEventTimestamp
        members {
          userId
          workId
          status
          lastEventTimestamp
        }
      }
    }
    charter {
      statistics {
        notStartedCount
        viewedCount
        inProgressCount
        submittedCount
      }
      items {
        entityId
        overallStatus
        lastEventTimestamp
        members {
          userId
          workId
          status
          lastEventTimestamp
        }
      }
    }
    peer {
      statistics {
        notStartedCount
        viewedCount
        inProgressCount
        submittedCount
      }
      items {
        entityId
        overallStatus
        lastEventTimestamp
        members {
          userId
          workId
          status
          lastEventTimestamp
        }
      }
    }
  }
}
    `;

/**
 * __useAssessmentProgressQuery__
 *
 * To run a query within a React component, call `useAssessmentProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssessmentProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssessmentProgressQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useAssessmentProgressQuery(baseOptions: Apollo.QueryHookOptions<AssessmentProgressQuery, AssessmentProgressQueryVariables> & ({ variables: AssessmentProgressQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssessmentProgressQuery, AssessmentProgressQueryVariables>(AssessmentProgressDocument, options);
      }
export function useAssessmentProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssessmentProgressQuery, AssessmentProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssessmentProgressQuery, AssessmentProgressQueryVariables>(AssessmentProgressDocument, options);
        }
export function useAssessmentProgressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssessmentProgressQuery, AssessmentProgressQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AssessmentProgressQuery, AssessmentProgressQueryVariables>(AssessmentProgressDocument, options);
        }
export type AssessmentProgressQueryHookResult = ReturnType<typeof useAssessmentProgressQuery>;
export type AssessmentProgressLazyQueryHookResult = ReturnType<typeof useAssessmentProgressLazyQuery>;
export type AssessmentProgressSuspenseQueryHookResult = ReturnType<typeof useAssessmentProgressSuspenseQuery>;
export type AssessmentProgressQueryResult = Apollo.QueryResult<AssessmentProgressQuery, AssessmentProgressQueryVariables>;
export const BackgroundJobDocument = gql`
    query BackgroundJob($jobId: ID!) {
  backgroundJob(jobId: $jobId) {
    ...BackgroundJob
  }
}
    ${BackgroundJobFragmentDoc}`;

/**
 * __useBackgroundJobQuery__
 *
 * To run a query within a React component, call `useBackgroundJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useBackgroundJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBackgroundJobQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useBackgroundJobQuery(baseOptions: Apollo.QueryHookOptions<BackgroundJobQuery, BackgroundJobQueryVariables> & ({ variables: BackgroundJobQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BackgroundJobQuery, BackgroundJobQueryVariables>(BackgroundJobDocument, options);
      }
export function useBackgroundJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BackgroundJobQuery, BackgroundJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BackgroundJobQuery, BackgroundJobQueryVariables>(BackgroundJobDocument, options);
        }
export function useBackgroundJobSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BackgroundJobQuery, BackgroundJobQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BackgroundJobQuery, BackgroundJobQueryVariables>(BackgroundJobDocument, options);
        }
export type BackgroundJobQueryHookResult = ReturnType<typeof useBackgroundJobQuery>;
export type BackgroundJobLazyQueryHookResult = ReturnType<typeof useBackgroundJobLazyQuery>;
export type BackgroundJobSuspenseQueryHookResult = ReturnType<typeof useBackgroundJobSuspenseQuery>;
export type BackgroundJobQueryResult = Apollo.QueryResult<BackgroundJobQuery, BackgroundJobQueryVariables>;
export const BrightspaceAuthorizationDocument = gql`
    query BrightspaceAuthorization($assessmentId: ID!, $redirectTo: String!, $brightspaceScopeFor: BrightspaceScopeKeyType) {
  brightspaceApi(
    assessmentId: $assessmentId
    brightspaceScopeFor: $brightspaceScopeFor
  ) {
    authorizeUrl(redirectTo: $redirectTo, brightspaceScopeFor: $brightspaceScopeFor)
    authorized
  }
}
    `;

/**
 * __useBrightspaceAuthorizationQuery__
 *
 * To run a query within a React component, call `useBrightspaceAuthorizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrightspaceAuthorizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrightspaceAuthorizationQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      redirectTo: // value for 'redirectTo'
 *      brightspaceScopeFor: // value for 'brightspaceScopeFor'
 *   },
 * });
 */
export function useBrightspaceAuthorizationQuery(baseOptions: Apollo.QueryHookOptions<BrightspaceAuthorizationQuery, BrightspaceAuthorizationQueryVariables> & ({ variables: BrightspaceAuthorizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrightspaceAuthorizationQuery, BrightspaceAuthorizationQueryVariables>(BrightspaceAuthorizationDocument, options);
      }
export function useBrightspaceAuthorizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrightspaceAuthorizationQuery, BrightspaceAuthorizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrightspaceAuthorizationQuery, BrightspaceAuthorizationQueryVariables>(BrightspaceAuthorizationDocument, options);
        }
export function useBrightspaceAuthorizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BrightspaceAuthorizationQuery, BrightspaceAuthorizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BrightspaceAuthorizationQuery, BrightspaceAuthorizationQueryVariables>(BrightspaceAuthorizationDocument, options);
        }
export type BrightspaceAuthorizationQueryHookResult = ReturnType<typeof useBrightspaceAuthorizationQuery>;
export type BrightspaceAuthorizationLazyQueryHookResult = ReturnType<typeof useBrightspaceAuthorizationLazyQuery>;
export type BrightspaceAuthorizationSuspenseQueryHookResult = ReturnType<typeof useBrightspaceAuthorizationSuspenseQuery>;
export type BrightspaceAuthorizationQueryResult = Apollo.QueryResult<BrightspaceAuthorizationQuery, BrightspaceAuthorizationQueryVariables>;
export const CanvasAuthorizationDocument = gql`
    query CanvasAuthorization($assessmentId: ID!, $redirectTo: String!, $canvasScopeFor: CanvasScopeKeyType) {
  canvasApi(assessmentId: $assessmentId, canvasScopeFor: $canvasScopeFor) {
    authorizeUrl(redirectTo: $redirectTo, canvasScopeFor: $canvasScopeFor)
    authorized
  }
}
    `;

/**
 * __useCanvasAuthorizationQuery__
 *
 * To run a query within a React component, call `useCanvasAuthorizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanvasAuthorizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanvasAuthorizationQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      redirectTo: // value for 'redirectTo'
 *      canvasScopeFor: // value for 'canvasScopeFor'
 *   },
 * });
 */
export function useCanvasAuthorizationQuery(baseOptions: Apollo.QueryHookOptions<CanvasAuthorizationQuery, CanvasAuthorizationQueryVariables> & ({ variables: CanvasAuthorizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CanvasAuthorizationQuery, CanvasAuthorizationQueryVariables>(CanvasAuthorizationDocument, options);
      }
export function useCanvasAuthorizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CanvasAuthorizationQuery, CanvasAuthorizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CanvasAuthorizationQuery, CanvasAuthorizationQueryVariables>(CanvasAuthorizationDocument, options);
        }
export function useCanvasAuthorizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CanvasAuthorizationQuery, CanvasAuthorizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CanvasAuthorizationQuery, CanvasAuthorizationQueryVariables>(CanvasAuthorizationDocument, options);
        }
export type CanvasAuthorizationQueryHookResult = ReturnType<typeof useCanvasAuthorizationQuery>;
export type CanvasAuthorizationLazyQueryHookResult = ReturnType<typeof useCanvasAuthorizationLazyQuery>;
export type CanvasAuthorizationSuspenseQueryHookResult = ReturnType<typeof useCanvasAuthorizationSuspenseQuery>;
export type CanvasAuthorizationQueryResult = Apollo.QueryResult<CanvasAuthorizationQuery, CanvasAuthorizationQueryVariables>;
export const AssessmentChartersDocument = gql`
    query AssessmentCharters($assessmentId: ID!) {
  assessmentCharters(assessmentId: $assessmentId) {
    id
    groupId
  }
}
    `;

/**
 * __useAssessmentChartersQuery__
 *
 * To run a query within a React component, call `useAssessmentChartersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssessmentChartersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssessmentChartersQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useAssessmentChartersQuery(baseOptions: Apollo.QueryHookOptions<AssessmentChartersQuery, AssessmentChartersQueryVariables> & ({ variables: AssessmentChartersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssessmentChartersQuery, AssessmentChartersQueryVariables>(AssessmentChartersDocument, options);
      }
export function useAssessmentChartersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssessmentChartersQuery, AssessmentChartersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssessmentChartersQuery, AssessmentChartersQueryVariables>(AssessmentChartersDocument, options);
        }
export function useAssessmentChartersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssessmentChartersQuery, AssessmentChartersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AssessmentChartersQuery, AssessmentChartersQueryVariables>(AssessmentChartersDocument, options);
        }
export type AssessmentChartersQueryHookResult = ReturnType<typeof useAssessmentChartersQuery>;
export type AssessmentChartersLazyQueryHookResult = ReturnType<typeof useAssessmentChartersLazyQuery>;
export type AssessmentChartersSuspenseQueryHookResult = ReturnType<typeof useAssessmentChartersSuspenseQuery>;
export type AssessmentChartersQueryResult = Apollo.QueryResult<AssessmentChartersQuery, AssessmentChartersQueryVariables>;
export const CharterFormDocument = gql`
    query CharterForm($assessmentId: ID!) {
  assessment(assessmentId: $assessmentId) {
    id
    settings {
      id
      peerEvaluationEnabled
    }
  }
  draftForm: charterForm(assessmentId: $assessmentId, published: false) {
    ...CharterForm
  }
  publishedForm: charterForm(assessmentId: $assessmentId, published: true) {
    ...CharterForm
  }
}
    ${CharterFormFragmentDoc}`;

/**
 * __useCharterFormQuery__
 *
 * To run a query within a React component, call `useCharterFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useCharterFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCharterFormQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useCharterFormQuery(baseOptions: Apollo.QueryHookOptions<CharterFormQuery, CharterFormQueryVariables> & ({ variables: CharterFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CharterFormQuery, CharterFormQueryVariables>(CharterFormDocument, options);
      }
export function useCharterFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CharterFormQuery, CharterFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CharterFormQuery, CharterFormQueryVariables>(CharterFormDocument, options);
        }
export function useCharterFormSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CharterFormQuery, CharterFormQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CharterFormQuery, CharterFormQueryVariables>(CharterFormDocument, options);
        }
export type CharterFormQueryHookResult = ReturnType<typeof useCharterFormQuery>;
export type CharterFormLazyQueryHookResult = ReturnType<typeof useCharterFormLazyQuery>;
export type CharterFormSuspenseQueryHookResult = ReturnType<typeof useCharterFormSuspenseQuery>;
export type CharterFormQueryResult = Apollo.QueryResult<CharterFormQuery, CharterFormQueryVariables>;
export const CharterDocument = gql`
    query Charter($charterId: ID!) {
  charter(charterId: $charterId) {
    ...Charter
  }
}
    ${CharterFragmentDoc}`;

/**
 * __useCharterQuery__
 *
 * To run a query within a React component, call `useCharterQuery` and pass it any options that fit your needs.
 * When your component renders, `useCharterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCharterQuery({
 *   variables: {
 *      charterId: // value for 'charterId'
 *   },
 * });
 */
export function useCharterQuery(baseOptions: Apollo.QueryHookOptions<CharterQuery, CharterQueryVariables> & ({ variables: CharterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CharterQuery, CharterQueryVariables>(CharterDocument, options);
      }
export function useCharterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CharterQuery, CharterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CharterQuery, CharterQueryVariables>(CharterDocument, options);
        }
export function useCharterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CharterQuery, CharterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CharterQuery, CharterQueryVariables>(CharterDocument, options);
        }
export type CharterQueryHookResult = ReturnType<typeof useCharterQuery>;
export type CharterLazyQueryHookResult = ReturnType<typeof useCharterLazyQuery>;
export type CharterSuspenseQueryHookResult = ReturnType<typeof useCharterSuspenseQuery>;
export type CharterQueryResult = Apollo.QueryResult<CharterQuery, CharterQueryVariables>;
export const CreateCharterFormDocument = gql`
    mutation CreateCharterForm($assessmentId: ID!) {
  createCharterForm(assessmentId: $assessmentId) {
    ...CharterForm
  }
}
    ${CharterFormFragmentDoc}`;
export type CreateCharterFormMutationFn = Apollo.MutationFunction<CreateCharterFormMutation, CreateCharterFormMutationVariables>;

/**
 * __useCreateCharterFormMutation__
 *
 * To run a mutation, you first call `useCreateCharterFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCharterFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCharterFormMutation, { data, loading, error }] = useCreateCharterFormMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useCreateCharterFormMutation(baseOptions?: Apollo.MutationHookOptions<CreateCharterFormMutation, CreateCharterFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCharterFormMutation, CreateCharterFormMutationVariables>(CreateCharterFormDocument, options);
      }
export type CreateCharterFormMutationHookResult = ReturnType<typeof useCreateCharterFormMutation>;
export type CreateCharterFormMutationResult = Apollo.MutationResult<CreateCharterFormMutation>;
export type CreateCharterFormMutationOptions = Apollo.BaseMutationOptions<CreateCharterFormMutation, CreateCharterFormMutationVariables>;
export const UpdateCharterFormDocument = gql`
    mutation UpdateCharterForm($input: CharterFormInput!) {
  updateCharterForm(input: $input) {
    ...CharterForm
  }
}
    ${CharterFormFragmentDoc}`;
export type UpdateCharterFormMutationFn = Apollo.MutationFunction<UpdateCharterFormMutation, UpdateCharterFormMutationVariables>;

/**
 * __useUpdateCharterFormMutation__
 *
 * To run a mutation, you first call `useUpdateCharterFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCharterFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCharterFormMutation, { data, loading, error }] = useUpdateCharterFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCharterFormMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCharterFormMutation, UpdateCharterFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCharterFormMutation, UpdateCharterFormMutationVariables>(UpdateCharterFormDocument, options);
      }
export type UpdateCharterFormMutationHookResult = ReturnType<typeof useUpdateCharterFormMutation>;
export type UpdateCharterFormMutationResult = Apollo.MutationResult<UpdateCharterFormMutation>;
export type UpdateCharterFormMutationOptions = Apollo.BaseMutationOptions<UpdateCharterFormMutation, UpdateCharterFormMutationVariables>;
export const ClassDocument = gql`
    query Class($assessmentId: ID!) {
  token
  me {
    id
    email
  }
  institution {
    id
    tenant
    country {
      ...Country
    }
  }
  featureFlags(assessmentId: $assessmentId) {
    ...FeatureFlags
  }
  assessment(assessmentId: $assessmentId) {
    ...Assessment
  }
  sections(assessmentId: $assessmentId) {
    ...GroupSection
  }
  class(assessmentId: $assessmentId) {
    id
    students {
      ...Enrollment
    }
    groupType
    groups {
      ...Group
    }
  }
  classWorkGroups(assessmentId: $assessmentId) {
    ...WorkGroup
  }
  individualSheet: instructionSheet(assessmentId: $assessmentId, kind: INDIVIDUAL) {
    ...ClassInstructionSheet
  }
  groupSheet: instructionSheet(assessmentId: $assessmentId, kind: GROUP) {
    ...ClassInstructionSheet
  }
  futureSheet(assessmentId: $assessmentId) {
    id
    releaseTimestamp
  }
  userSettings(assessmentId: $assessmentId) {
    ...UserSettings
  }
}
    ${CountryFragmentDoc}
${FeatureFlagsFragmentDoc}
${AssessmentFragmentDoc}
${GroupSectionFragmentDoc}
${EnrollmentFragmentDoc}
${GroupFragmentDoc}
${WorkGroupFragmentDoc}
${ClassInstructionSheetFragmentDoc}
${UserSettingsFragmentDoc}`;

/**
 * __useClassQuery__
 *
 * To run a query within a React component, call `useClassQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useClassQuery(baseOptions: Apollo.QueryHookOptions<ClassQuery, ClassQueryVariables> & ({ variables: ClassQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClassQuery, ClassQueryVariables>(ClassDocument, options);
      }
export function useClassLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClassQuery, ClassQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClassQuery, ClassQueryVariables>(ClassDocument, options);
        }
export function useClassSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ClassQuery, ClassQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClassQuery, ClassQueryVariables>(ClassDocument, options);
        }
export type ClassQueryHookResult = ReturnType<typeof useClassQuery>;
export type ClassLazyQueryHookResult = ReturnType<typeof useClassLazyQuery>;
export type ClassSuspenseQueryHookResult = ReturnType<typeof useClassSuspenseQuery>;
export type ClassQueryResult = Apollo.QueryResult<ClassQuery, ClassQueryVariables>;
export const CurrentUserDocument = gql`
    query CurrentUser {
  sessionId
  me {
    ...User
  }
  institution {
    id
    tenant
  }
}
    ${UserFragmentDoc}`;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export function useCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserSuspenseQueryHookResult = ReturnType<typeof useCurrentUserSuspenseQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export const DoubleMarkingProgressDocument = gql`
    query DoubleMarkingProgress($assessmentId: ID!) {
  studentOutcomes(assessmentId: $assessmentId) {
    ...StudentOutcomeForDoubleMarking
  }
}
    ${StudentOutcomeForDoubleMarkingFragmentDoc}`;

/**
 * __useDoubleMarkingProgressQuery__
 *
 * To run a query within a React component, call `useDoubleMarkingProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoubleMarkingProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoubleMarkingProgressQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useDoubleMarkingProgressQuery(baseOptions: Apollo.QueryHookOptions<DoubleMarkingProgressQuery, DoubleMarkingProgressQueryVariables> & ({ variables: DoubleMarkingProgressQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoubleMarkingProgressQuery, DoubleMarkingProgressQueryVariables>(DoubleMarkingProgressDocument, options);
      }
export function useDoubleMarkingProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoubleMarkingProgressQuery, DoubleMarkingProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoubleMarkingProgressQuery, DoubleMarkingProgressQueryVariables>(DoubleMarkingProgressDocument, options);
        }
export function useDoubleMarkingProgressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoubleMarkingProgressQuery, DoubleMarkingProgressQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoubleMarkingProgressQuery, DoubleMarkingProgressQueryVariables>(DoubleMarkingProgressDocument, options);
        }
export type DoubleMarkingProgressQueryHookResult = ReturnType<typeof useDoubleMarkingProgressQuery>;
export type DoubleMarkingProgressLazyQueryHookResult = ReturnType<typeof useDoubleMarkingProgressLazyQuery>;
export type DoubleMarkingProgressSuspenseQueryHookResult = ReturnType<typeof useDoubleMarkingProgressSuspenseQuery>;
export type DoubleMarkingProgressQueryResult = Apollo.QueryResult<DoubleMarkingProgressQuery, DoubleMarkingProgressQueryVariables>;
export const FlagAttentionDocument = gql`
    mutation FlagAttention($assessmentId: ID!, $workOutcomeIds: [ID!]!, $flagReason: String) {
  flagAttention(
    assessmentId: $assessmentId
    workOutcomeIds: $workOutcomeIds
    flagReason: $flagReason
  ) {
    submissionOutcomes {
      ...ModerationSubmissionOutcomeScore
    }
  }
}
    ${ModerationSubmissionOutcomeScoreFragmentDoc}`;
export type FlagAttentionMutationFn = Apollo.MutationFunction<FlagAttentionMutation, FlagAttentionMutationVariables>;

/**
 * __useFlagAttentionMutation__
 *
 * To run a mutation, you first call `useFlagAttentionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFlagAttentionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [flagAttentionMutation, { data, loading, error }] = useFlagAttentionMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      workOutcomeIds: // value for 'workOutcomeIds'
 *      flagReason: // value for 'flagReason'
 *   },
 * });
 */
export function useFlagAttentionMutation(baseOptions?: Apollo.MutationHookOptions<FlagAttentionMutation, FlagAttentionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FlagAttentionMutation, FlagAttentionMutationVariables>(FlagAttentionDocument, options);
      }
export type FlagAttentionMutationHookResult = ReturnType<typeof useFlagAttentionMutation>;
export type FlagAttentionMutationResult = Apollo.MutationResult<FlagAttentionMutation>;
export type FlagAttentionMutationOptions = Apollo.BaseMutationOptions<FlagAttentionMutation, FlagAttentionMutationVariables>;
export const ModerateMainOutcomesDocument = gql`
    mutation ModerateMainOutcomes($assessmentId: ID!, $workOutcomeIds: [ID!]!, $scoreModeration: ScoreModerationDecisionInput = null, $feedbackModeration: FeedbackModerationDecisionInput = null, $exceptions: [ExceptionInput!] = null) {
  moderateMainOutcomes(
    assessmentId: $assessmentId
    workOutcomeIds: $workOutcomeIds
    scoreModeration: $scoreModeration
    feedbackModeration: $feedbackModeration
    exceptions: $exceptions
  ) {
    submissionOutcomes {
      ...ModerationSubmissionOutcomeScore
    }
  }
}
    ${ModerationSubmissionOutcomeScoreFragmentDoc}`;
export type ModerateMainOutcomesMutationFn = Apollo.MutationFunction<ModerateMainOutcomesMutation, ModerateMainOutcomesMutationVariables>;

/**
 * __useModerateMainOutcomesMutation__
 *
 * To run a mutation, you first call `useModerateMainOutcomesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModerateMainOutcomesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moderateMainOutcomesMutation, { data, loading, error }] = useModerateMainOutcomesMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      workOutcomeIds: // value for 'workOutcomeIds'
 *      scoreModeration: // value for 'scoreModeration'
 *      feedbackModeration: // value for 'feedbackModeration'
 *      exceptions: // value for 'exceptions'
 *   },
 * });
 */
export function useModerateMainOutcomesMutation(baseOptions?: Apollo.MutationHookOptions<ModerateMainOutcomesMutation, ModerateMainOutcomesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ModerateMainOutcomesMutation, ModerateMainOutcomesMutationVariables>(ModerateMainOutcomesDocument, options);
      }
export type ModerateMainOutcomesMutationHookResult = ReturnType<typeof useModerateMainOutcomesMutation>;
export type ModerateMainOutcomesMutationResult = Apollo.MutationResult<ModerateMainOutcomesMutation>;
export type ModerateMainOutcomesMutationOptions = Apollo.BaseMutationOptions<ModerateMainOutcomesMutation, ModerateMainOutcomesMutationVariables>;
export const ResetModerationDecisionsDocument = gql`
    mutation ResetModerationDecisions($assessmentId: ID!, $workOutcomeIds: [ID!]!) {
  resetModerationDecisions(
    assessmentId: $assessmentId
    workOutcomeIds: $workOutcomeIds
  ) {
    submissionOutcomes {
      ...ModerationSubmissionOutcomeScore
    }
    workOutcomes {
      ...WorkOutcomeScore
    }
  }
}
    ${ModerationSubmissionOutcomeScoreFragmentDoc}
${WorkOutcomeScoreFragmentDoc}`;
export type ResetModerationDecisionsMutationFn = Apollo.MutationFunction<ResetModerationDecisionsMutation, ResetModerationDecisionsMutationVariables>;

/**
 * __useResetModerationDecisionsMutation__
 *
 * To run a mutation, you first call `useResetModerationDecisionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetModerationDecisionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetModerationDecisionsMutation, { data, loading, error }] = useResetModerationDecisionsMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      workOutcomeIds: // value for 'workOutcomeIds'
 *   },
 * });
 */
export function useResetModerationDecisionsMutation(baseOptions?: Apollo.MutationHookOptions<ResetModerationDecisionsMutation, ResetModerationDecisionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetModerationDecisionsMutation, ResetModerationDecisionsMutationVariables>(ResetModerationDecisionsDocument, options);
      }
export type ResetModerationDecisionsMutationHookResult = ReturnType<typeof useResetModerationDecisionsMutation>;
export type ResetModerationDecisionsMutationResult = Apollo.MutationResult<ResetModerationDecisionsMutation>;
export type ResetModerationDecisionsMutationOptions = Apollo.BaseMutationOptions<ResetModerationDecisionsMutation, ResetModerationDecisionsMutationVariables>;
export const AddGroupTagDocument = gql`
    mutation AddGroupTag($assessmentId: ID!, $groupId: ID!, $text: String!) {
  addGroupTag(assessmentId: $assessmentId, groupId: $groupId, text: $text) {
    ...GroupTag
  }
}
    ${GroupTagFragmentDoc}`;
export type AddGroupTagMutationFn = Apollo.MutationFunction<AddGroupTagMutation, AddGroupTagMutationVariables>;

/**
 * __useAddGroupTagMutation__
 *
 * To run a mutation, you first call `useAddGroupTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddGroupTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addGroupTagMutation, { data, loading, error }] = useAddGroupTagMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      groupId: // value for 'groupId'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useAddGroupTagMutation(baseOptions?: Apollo.MutationHookOptions<AddGroupTagMutation, AddGroupTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddGroupTagMutation, AddGroupTagMutationVariables>(AddGroupTagDocument, options);
      }
export type AddGroupTagMutationHookResult = ReturnType<typeof useAddGroupTagMutation>;
export type AddGroupTagMutationResult = Apollo.MutationResult<AddGroupTagMutation>;
export type AddGroupTagMutationOptions = Apollo.BaseMutationOptions<AddGroupTagMutation, AddGroupTagMutationVariables>;
export const AppendGroupsDocument = gql`
    mutation AppendGroups($assessmentId: ID!, $userIds: [ID!]!, $input: SetupGroupInput!) {
  appendGroups(assessmentId: $assessmentId, userIds: $userIds, input: $input) {
    ...Group
  }
}
    ${GroupFragmentDoc}`;
export type AppendGroupsMutationFn = Apollo.MutationFunction<AppendGroupsMutation, AppendGroupsMutationVariables>;

/**
 * __useAppendGroupsMutation__
 *
 * To run a mutation, you first call `useAppendGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppendGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appendGroupsMutation, { data, loading, error }] = useAppendGroupsMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      userIds: // value for 'userIds'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAppendGroupsMutation(baseOptions?: Apollo.MutationHookOptions<AppendGroupsMutation, AppendGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AppendGroupsMutation, AppendGroupsMutationVariables>(AppendGroupsDocument, options);
      }
export type AppendGroupsMutationHookResult = ReturnType<typeof useAppendGroupsMutation>;
export type AppendGroupsMutationResult = Apollo.MutationResult<AppendGroupsMutation>;
export type AppendGroupsMutationOptions = Apollo.BaseMutationOptions<AppendGroupsMutation, AppendGroupsMutationVariables>;
export const AssignMarkersToMembersDocument = gql`
    mutation AssignMarkersToMembers($assessmentId: ID!, $inputs: [MarkerForMembersInput!]!) {
  assignMarkersToMembers(assessmentId: $assessmentId, inputs: $inputs) {
    ...GroupMarker
  }
}
    ${GroupMarkerFragmentDoc}`;
export type AssignMarkersToMembersMutationFn = Apollo.MutationFunction<AssignMarkersToMembersMutation, AssignMarkersToMembersMutationVariables>;

/**
 * __useAssignMarkersToMembersMutation__
 *
 * To run a mutation, you first call `useAssignMarkersToMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignMarkersToMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignMarkersToMembersMutation, { data, loading, error }] = useAssignMarkersToMembersMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useAssignMarkersToMembersMutation(baseOptions?: Apollo.MutationHookOptions<AssignMarkersToMembersMutation, AssignMarkersToMembersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignMarkersToMembersMutation, AssignMarkersToMembersMutationVariables>(AssignMarkersToMembersDocument, options);
      }
export type AssignMarkersToMembersMutationHookResult = ReturnType<typeof useAssignMarkersToMembersMutation>;
export type AssignMarkersToMembersMutationResult = Apollo.MutationResult<AssignMarkersToMembersMutation>;
export type AssignMarkersToMembersMutationOptions = Apollo.BaseMutationOptions<AssignMarkersToMembersMutation, AssignMarkersToMembersMutationVariables>;
export const AutoAssignGroupsDocument = gql`
    mutation AutoAssignGroups($assessmentId: ID!, $groupId: ID) {
  autoAssignGroups(assessmentId: $assessmentId, groupId: $groupId) {
    ...Group
  }
}
    ${GroupFragmentDoc}`;
export type AutoAssignGroupsMutationFn = Apollo.MutationFunction<AutoAssignGroupsMutation, AutoAssignGroupsMutationVariables>;

/**
 * __useAutoAssignGroupsMutation__
 *
 * To run a mutation, you first call `useAutoAssignGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAutoAssignGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [autoAssignGroupsMutation, { data, loading, error }] = useAutoAssignGroupsMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useAutoAssignGroupsMutation(baseOptions?: Apollo.MutationHookOptions<AutoAssignGroupsMutation, AutoAssignGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AutoAssignGroupsMutation, AutoAssignGroupsMutationVariables>(AutoAssignGroupsDocument, options);
      }
export type AutoAssignGroupsMutationHookResult = ReturnType<typeof useAutoAssignGroupsMutation>;
export type AutoAssignGroupsMutationResult = Apollo.MutationResult<AutoAssignGroupsMutation>;
export type AutoAssignGroupsMutationOptions = Apollo.BaseMutationOptions<AutoAssignGroupsMutation, AutoAssignGroupsMutationVariables>;
export const BrightspaceGroupsDocument = gql`
    query BrightspaceGroups($assessmentId: ID!, $brightspaceScopeFor: BrightspaceScopeKeyType!) {
  brightspaceApi(
    assessmentId: $assessmentId
    brightspaceScopeFor: $brightspaceScopeFor
  ) {
    groups {
      ...BrightspaceGroup
    }
  }
  class(assessmentId: $assessmentId) {
    students {
      customParams {
        brightspaceUserId
      }
      sisUserId
      user {
        id
        name
      }
    }
  }
}
    ${BrightspaceGroupFragmentDoc}`;

/**
 * __useBrightspaceGroupsQuery__
 *
 * To run a query within a React component, call `useBrightspaceGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrightspaceGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrightspaceGroupsQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      brightspaceScopeFor: // value for 'brightspaceScopeFor'
 *   },
 * });
 */
export function useBrightspaceGroupsQuery(baseOptions: Apollo.QueryHookOptions<BrightspaceGroupsQuery, BrightspaceGroupsQueryVariables> & ({ variables: BrightspaceGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrightspaceGroupsQuery, BrightspaceGroupsQueryVariables>(BrightspaceGroupsDocument, options);
      }
export function useBrightspaceGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrightspaceGroupsQuery, BrightspaceGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrightspaceGroupsQuery, BrightspaceGroupsQueryVariables>(BrightspaceGroupsDocument, options);
        }
export function useBrightspaceGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BrightspaceGroupsQuery, BrightspaceGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BrightspaceGroupsQuery, BrightspaceGroupsQueryVariables>(BrightspaceGroupsDocument, options);
        }
export type BrightspaceGroupsQueryHookResult = ReturnType<typeof useBrightspaceGroupsQuery>;
export type BrightspaceGroupsLazyQueryHookResult = ReturnType<typeof useBrightspaceGroupsLazyQuery>;
export type BrightspaceGroupsSuspenseQueryHookResult = ReturnType<typeof useBrightspaceGroupsSuspenseQuery>;
export type BrightspaceGroupsQueryResult = Apollo.QueryResult<BrightspaceGroupsQuery, BrightspaceGroupsQueryVariables>;
export const CanvasSectionsDocument = gql`
    query CanvasSections($assessmentId: ID!, $canvasScopeFor: CanvasScopeKeyType!) {
  canvasApi(assessmentId: $assessmentId, canvasScopeFor: $canvasScopeFor) {
    sections {
      ...CanvasSection
    }
  }
  class(assessmentId: $assessmentId) {
    students {
      customParams {
        canvasUserId
      }
      sisUserId
      user {
        id
        name
      }
    }
  }
}
    ${CanvasSectionFragmentDoc}`;

/**
 * __useCanvasSectionsQuery__
 *
 * To run a query within a React component, call `useCanvasSectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanvasSectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanvasSectionsQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      canvasScopeFor: // value for 'canvasScopeFor'
 *   },
 * });
 */
export function useCanvasSectionsQuery(baseOptions: Apollo.QueryHookOptions<CanvasSectionsQuery, CanvasSectionsQueryVariables> & ({ variables: CanvasSectionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CanvasSectionsQuery, CanvasSectionsQueryVariables>(CanvasSectionsDocument, options);
      }
export function useCanvasSectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CanvasSectionsQuery, CanvasSectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CanvasSectionsQuery, CanvasSectionsQueryVariables>(CanvasSectionsDocument, options);
        }
export function useCanvasSectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CanvasSectionsQuery, CanvasSectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CanvasSectionsQuery, CanvasSectionsQueryVariables>(CanvasSectionsDocument, options);
        }
export type CanvasSectionsQueryHookResult = ReturnType<typeof useCanvasSectionsQuery>;
export type CanvasSectionsLazyQueryHookResult = ReturnType<typeof useCanvasSectionsLazyQuery>;
export type CanvasSectionsSuspenseQueryHookResult = ReturnType<typeof useCanvasSectionsSuspenseQuery>;
export type CanvasSectionsQueryResult = Apollo.QueryResult<CanvasSectionsQuery, CanvasSectionsQueryVariables>;
export const CreateGroupsDocument = gql`
    mutation CreateGroups($assessmentId: ID!, $groups: [GroupInput!]!) {
  createGroups(assessmentId: $assessmentId, groups: $groups) {
    ...Group
  }
}
    ${GroupFragmentDoc}`;
export type CreateGroupsMutationFn = Apollo.MutationFunction<CreateGroupsMutation, CreateGroupsMutationVariables>;

/**
 * __useCreateGroupsMutation__
 *
 * To run a mutation, you first call `useCreateGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupsMutation, { data, loading, error }] = useCreateGroupsMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      groups: // value for 'groups'
 *   },
 * });
 */
export function useCreateGroupsMutation(baseOptions?: Apollo.MutationHookOptions<CreateGroupsMutation, CreateGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGroupsMutation, CreateGroupsMutationVariables>(CreateGroupsDocument, options);
      }
export type CreateGroupsMutationHookResult = ReturnType<typeof useCreateGroupsMutation>;
export type CreateGroupsMutationResult = Apollo.MutationResult<CreateGroupsMutation>;
export type CreateGroupsMutationOptions = Apollo.BaseMutationOptions<CreateGroupsMutation, CreateGroupsMutationVariables>;
export const DeleteGroupMemberDocument = gql`
    mutation DeleteGroupMember($assessmentId: ID!, $userId: ID!, $groupId: ID!) {
  deleteGroupMember(
    assessmentId: $assessmentId
    userId: $userId
    groupId: $groupId
  ) {
    ...DeletedMember
  }
}
    ${DeletedMemberFragmentDoc}`;
export type DeleteGroupMemberMutationFn = Apollo.MutationFunction<DeleteGroupMemberMutation, DeleteGroupMemberMutationVariables>;

/**
 * __useDeleteGroupMemberMutation__
 *
 * To run a mutation, you first call `useDeleteGroupMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGroupMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGroupMemberMutation, { data, loading, error }] = useDeleteGroupMemberMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      userId: // value for 'userId'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useDeleteGroupMemberMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGroupMemberMutation, DeleteGroupMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGroupMemberMutation, DeleteGroupMemberMutationVariables>(DeleteGroupMemberDocument, options);
      }
export type DeleteGroupMemberMutationHookResult = ReturnType<typeof useDeleteGroupMemberMutation>;
export type DeleteGroupMemberMutationResult = Apollo.MutationResult<DeleteGroupMemberMutation>;
export type DeleteGroupMemberMutationOptions = Apollo.BaseMutationOptions<DeleteGroupMemberMutation, DeleteGroupMemberMutationVariables>;
export const DeleteGroupDocument = gql`
    mutation DeleteGroup($assessmentId: ID!, $groupId: ID!, $autoAssign: Boolean) {
  deleteGroup(
    assessmentId: $assessmentId
    groupId: $groupId
    autoAssign: $autoAssign
  ) {
    ...Group
  }
}
    ${GroupFragmentDoc}`;
export type DeleteGroupMutationFn = Apollo.MutationFunction<DeleteGroupMutation, DeleteGroupMutationVariables>;

/**
 * __useDeleteGroupMutation__
 *
 * To run a mutation, you first call `useDeleteGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGroupMutation, { data, loading, error }] = useDeleteGroupMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      groupId: // value for 'groupId'
 *      autoAssign: // value for 'autoAssign'
 *   },
 * });
 */
export function useDeleteGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGroupMutation, DeleteGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGroupMutation, DeleteGroupMutationVariables>(DeleteGroupDocument, options);
      }
export type DeleteGroupMutationHookResult = ReturnType<typeof useDeleteGroupMutation>;
export type DeleteGroupMutationResult = Apollo.MutationResult<DeleteGroupMutation>;
export type DeleteGroupMutationOptions = Apollo.BaseMutationOptions<DeleteGroupMutation, DeleteGroupMutationVariables>;
export const DeleteGroupsDocument = gql`
    mutation DeleteGroups($assessmentId: ID!, $groupIds: [ID!]!, $autoAssign: Boolean) {
  deleteGroups(
    assessmentId: $assessmentId
    groupIds: $groupIds
    autoAssign: $autoAssign
  ) {
    ...Group
  }
}
    ${GroupFragmentDoc}`;
export type DeleteGroupsMutationFn = Apollo.MutationFunction<DeleteGroupsMutation, DeleteGroupsMutationVariables>;

/**
 * __useDeleteGroupsMutation__
 *
 * To run a mutation, you first call `useDeleteGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGroupsMutation, { data, loading, error }] = useDeleteGroupsMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      groupIds: // value for 'groupIds'
 *      autoAssign: // value for 'autoAssign'
 *   },
 * });
 */
export function useDeleteGroupsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGroupsMutation, DeleteGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGroupsMutation, DeleteGroupsMutationVariables>(DeleteGroupsDocument, options);
      }
export type DeleteGroupsMutationHookResult = ReturnType<typeof useDeleteGroupsMutation>;
export type DeleteGroupsMutationResult = Apollo.MutationResult<DeleteGroupsMutation>;
export type DeleteGroupsMutationOptions = Apollo.BaseMutationOptions<DeleteGroupsMutation, DeleteGroupsMutationVariables>;
export const FinaliseAllGroupsDocument = gql`
    mutation FinaliseAllGroups($assessmentId: ID!) {
  finaliseAllGroups(assessmentId: $assessmentId) {
    ...Group
  }
}
    ${GroupFragmentDoc}`;
export type FinaliseAllGroupsMutationFn = Apollo.MutationFunction<FinaliseAllGroupsMutation, FinaliseAllGroupsMutationVariables>;

/**
 * __useFinaliseAllGroupsMutation__
 *
 * To run a mutation, you first call `useFinaliseAllGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinaliseAllGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finaliseAllGroupsMutation, { data, loading, error }] = useFinaliseAllGroupsMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useFinaliseAllGroupsMutation(baseOptions?: Apollo.MutationHookOptions<FinaliseAllGroupsMutation, FinaliseAllGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinaliseAllGroupsMutation, FinaliseAllGroupsMutationVariables>(FinaliseAllGroupsDocument, options);
      }
export type FinaliseAllGroupsMutationHookResult = ReturnType<typeof useFinaliseAllGroupsMutation>;
export type FinaliseAllGroupsMutationResult = Apollo.MutationResult<FinaliseAllGroupsMutation>;
export type FinaliseAllGroupsMutationOptions = Apollo.BaseMutationOptions<FinaliseAllGroupsMutation, FinaliseAllGroupsMutationVariables>;
export const FinaliseGroupsDocument = gql`
    mutation FinaliseGroups($assessmentId: ID!, $groupIds: [ID!]!) {
  finaliseGroups(assessmentId: $assessmentId, groupIds: $groupIds) {
    ...Group
  }
}
    ${GroupFragmentDoc}`;
export type FinaliseGroupsMutationFn = Apollo.MutationFunction<FinaliseGroupsMutation, FinaliseGroupsMutationVariables>;

/**
 * __useFinaliseGroupsMutation__
 *
 * To run a mutation, you first call `useFinaliseGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinaliseGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finaliseGroupsMutation, { data, loading, error }] = useFinaliseGroupsMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      groupIds: // value for 'groupIds'
 *   },
 * });
 */
export function useFinaliseGroupsMutation(baseOptions?: Apollo.MutationHookOptions<FinaliseGroupsMutation, FinaliseGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinaliseGroupsMutation, FinaliseGroupsMutationVariables>(FinaliseGroupsDocument, options);
      }
export type FinaliseGroupsMutationHookResult = ReturnType<typeof useFinaliseGroupsMutation>;
export type FinaliseGroupsMutationResult = Apollo.MutationResult<FinaliseGroupsMutation>;
export type FinaliseGroupsMutationOptions = Apollo.BaseMutationOptions<FinaliseGroupsMutation, FinaliseGroupsMutationVariables>;
export const GroupUpdatedDocument = gql`
    subscription groupUpdated($assessmentId: ID!) {
  groupUpdated(assessmentId: $assessmentId) {
    ...Group
  }
}
    ${GroupFragmentDoc}`;

/**
 * __useGroupUpdatedSubscription__
 *
 * To run a query within a React component, call `useGroupUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGroupUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupUpdatedSubscription({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useGroupUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<GroupUpdatedSubscription, GroupUpdatedSubscriptionVariables> & ({ variables: GroupUpdatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GroupUpdatedSubscription, GroupUpdatedSubscriptionVariables>(GroupUpdatedDocument, options);
      }
export type GroupUpdatedSubscriptionHookResult = ReturnType<typeof useGroupUpdatedSubscription>;
export type GroupUpdatedSubscriptionResult = Apollo.SubscriptionResult<GroupUpdatedSubscription>;
export const GroupsRouteDocument = gql`
    query GroupsRoute($assessmentId: ID!) {
  token
  me {
    id
    email
  }
  lecturers(assessmentId: $assessmentId) {
    ...User
  }
  assessment(assessmentId: $assessmentId) {
    ...Assessment
  }
  sections(assessmentId: $assessmentId) {
    ...GroupSection
  }
  class(assessmentId: $assessmentId) {
    id
    students {
      ...Enrollment
    }
    groupType
    groups {
      ...Group
    }
  }
  messageInbox(assessmentId: $assessmentId) {
    ...Message
  }
  individualSheet: instructionSheet(assessmentId: $assessmentId, kind: INDIVIDUAL) {
    ...InstructionSheet
  }
  institution {
    id
    apiStatus {
      hasBrightspaceApi
      hasCanvasApi
    }
  }
  featureFlags(assessmentId: $assessmentId) {
    ...FeatureFlags
  }
}
    ${UserFragmentDoc}
${AssessmentFragmentDoc}
${GroupSectionFragmentDoc}
${EnrollmentFragmentDoc}
${GroupFragmentDoc}
${MessageFragmentDoc}
${InstructionSheetFragmentDoc}
${FeatureFlagsFragmentDoc}`;

/**
 * __useGroupsRouteQuery__
 *
 * To run a query within a React component, call `useGroupsRouteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupsRouteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupsRouteQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useGroupsRouteQuery(baseOptions: Apollo.QueryHookOptions<GroupsRouteQuery, GroupsRouteQueryVariables> & ({ variables: GroupsRouteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupsRouteQuery, GroupsRouteQueryVariables>(GroupsRouteDocument, options);
      }
export function useGroupsRouteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupsRouteQuery, GroupsRouteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupsRouteQuery, GroupsRouteQueryVariables>(GroupsRouteDocument, options);
        }
export function useGroupsRouteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupsRouteQuery, GroupsRouteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupsRouteQuery, GroupsRouteQueryVariables>(GroupsRouteDocument, options);
        }
export type GroupsRouteQueryHookResult = ReturnType<typeof useGroupsRouteQuery>;
export type GroupsRouteLazyQueryHookResult = ReturnType<typeof useGroupsRouteLazyQuery>;
export type GroupsRouteSuspenseQueryHookResult = ReturnType<typeof useGroupsRouteSuspenseQuery>;
export type GroupsRouteQueryResult = Apollo.QueryResult<GroupsRouteQuery, GroupsRouteQueryVariables>;
export const ImportSectionsDocument = gql`
    mutation ImportSections($assessmentId: ID!, $input: ImportSectionsInput!) {
  importSections(assessmentId: $assessmentId, input: $input) {
    sections {
      id
      name
      position
      studentCount
    }
    unmatchedStudents
    ungroupedStudents
  }
}
    `;
export type ImportSectionsMutationFn = Apollo.MutationFunction<ImportSectionsMutation, ImportSectionsMutationVariables>;

/**
 * __useImportSectionsMutation__
 *
 * To run a mutation, you first call `useImportSectionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportSectionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importSectionsMutation, { data, loading, error }] = useImportSectionsMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportSectionsMutation(baseOptions?: Apollo.MutationHookOptions<ImportSectionsMutation, ImportSectionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportSectionsMutation, ImportSectionsMutationVariables>(ImportSectionsDocument, options);
      }
export type ImportSectionsMutationHookResult = ReturnType<typeof useImportSectionsMutation>;
export type ImportSectionsMutationResult = Apollo.MutationResult<ImportSectionsMutation>;
export type ImportSectionsMutationOptions = Apollo.BaseMutationOptions<ImportSectionsMutation, ImportSectionsMutationVariables>;
export const RemoveGroupTagDocument = gql`
    mutation RemoveGroupTag($assessmentId: ID!, $groupId: ID!, $text: String!) {
  removeGroupTag(assessmentId: $assessmentId, groupId: $groupId, text: $text)
}
    `;
export type RemoveGroupTagMutationFn = Apollo.MutationFunction<RemoveGroupTagMutation, RemoveGroupTagMutationVariables>;

/**
 * __useRemoveGroupTagMutation__
 *
 * To run a mutation, you first call `useRemoveGroupTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveGroupTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeGroupTagMutation, { data, loading, error }] = useRemoveGroupTagMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      groupId: // value for 'groupId'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useRemoveGroupTagMutation(baseOptions?: Apollo.MutationHookOptions<RemoveGroupTagMutation, RemoveGroupTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveGroupTagMutation, RemoveGroupTagMutationVariables>(RemoveGroupTagDocument, options);
      }
export type RemoveGroupTagMutationHookResult = ReturnType<typeof useRemoveGroupTagMutation>;
export type RemoveGroupTagMutationResult = Apollo.MutationResult<RemoveGroupTagMutation>;
export type RemoveGroupTagMutationOptions = Apollo.BaseMutationOptions<RemoveGroupTagMutation, RemoveGroupTagMutationVariables>;
export const ResetGroupsDocument = gql`
    mutation resetGroups($assessmentId: ID!) {
  resetGroups(assessmentId: $assessmentId)
}
    `;
export type ResetGroupsMutationFn = Apollo.MutationFunction<ResetGroupsMutation, ResetGroupsMutationVariables>;

/**
 * __useResetGroupsMutation__
 *
 * To run a mutation, you first call `useResetGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetGroupsMutation, { data, loading, error }] = useResetGroupsMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useResetGroupsMutation(baseOptions?: Apollo.MutationHookOptions<ResetGroupsMutation, ResetGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetGroupsMutation, ResetGroupsMutationVariables>(ResetGroupsDocument, options);
      }
export type ResetGroupsMutationHookResult = ReturnType<typeof useResetGroupsMutation>;
export type ResetGroupsMutationResult = Apollo.MutationResult<ResetGroupsMutation>;
export type ResetGroupsMutationOptions = Apollo.BaseMutationOptions<ResetGroupsMutation, ResetGroupsMutationVariables>;
export const ResolveMessagesDocument = gql`
    mutation ResolveMessages($messageIds: [ID!]!, $assessmentId: ID!) {
  resolveMessages(messageIds: $messageIds, assessmentId: $assessmentId) {
    ...Message
  }
}
    ${MessageFragmentDoc}`;
export type ResolveMessagesMutationFn = Apollo.MutationFunction<ResolveMessagesMutation, ResolveMessagesMutationVariables>;

/**
 * __useResolveMessagesMutation__
 *
 * To run a mutation, you first call `useResolveMessagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveMessagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveMessagesMutation, { data, loading, error }] = useResolveMessagesMutation({
 *   variables: {
 *      messageIds: // value for 'messageIds'
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useResolveMessagesMutation(baseOptions?: Apollo.MutationHookOptions<ResolveMessagesMutation, ResolveMessagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResolveMessagesMutation, ResolveMessagesMutationVariables>(ResolveMessagesDocument, options);
      }
export type ResolveMessagesMutationHookResult = ReturnType<typeof useResolveMessagesMutation>;
export type ResolveMessagesMutationResult = Apollo.MutationResult<ResolveMessagesMutation>;
export type ResolveMessagesMutationOptions = Apollo.BaseMutationOptions<ResolveMessagesMutation, ResolveMessagesMutationVariables>;
export const SetupGroupsDocument = gql`
    mutation SetupGroups($assessmentId: ID!, $input: SetupGroupInput!, $settingsInput: GroupSettingsInput) {
  setupGroups(
    assessmentId: $assessmentId
    input: $input
    settingsInput: $settingsInput
  ) {
    ...Group
  }
}
    ${GroupFragmentDoc}`;
export type SetupGroupsMutationFn = Apollo.MutationFunction<SetupGroupsMutation, SetupGroupsMutationVariables>;

/**
 * __useSetupGroupsMutation__
 *
 * To run a mutation, you first call `useSetupGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetupGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setupGroupsMutation, { data, loading, error }] = useSetupGroupsMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      input: // value for 'input'
 *      settingsInput: // value for 'settingsInput'
 *   },
 * });
 */
export function useSetupGroupsMutation(baseOptions?: Apollo.MutationHookOptions<SetupGroupsMutation, SetupGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetupGroupsMutation, SetupGroupsMutationVariables>(SetupGroupsDocument, options);
      }
export type SetupGroupsMutationHookResult = ReturnType<typeof useSetupGroupsMutation>;
export type SetupGroupsMutationResult = Apollo.MutationResult<SetupGroupsMutation>;
export type SetupGroupsMutationOptions = Apollo.BaseMutationOptions<SetupGroupsMutation, SetupGroupsMutationVariables>;
export const UnassignMarkersDocument = gql`
    mutation UnassignMarkers($assessmentId: ID!, $groupMarkerIds: [ID!]!) {
  unassignMarkers(assessmentId: $assessmentId, groupMarkerIds: $groupMarkerIds)
}
    `;
export type UnassignMarkersMutationFn = Apollo.MutationFunction<UnassignMarkersMutation, UnassignMarkersMutationVariables>;

/**
 * __useUnassignMarkersMutation__
 *
 * To run a mutation, you first call `useUnassignMarkersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignMarkersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignMarkersMutation, { data, loading, error }] = useUnassignMarkersMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      groupMarkerIds: // value for 'groupMarkerIds'
 *   },
 * });
 */
export function useUnassignMarkersMutation(baseOptions?: Apollo.MutationHookOptions<UnassignMarkersMutation, UnassignMarkersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnassignMarkersMutation, UnassignMarkersMutationVariables>(UnassignMarkersDocument, options);
      }
export type UnassignMarkersMutationHookResult = ReturnType<typeof useUnassignMarkersMutation>;
export type UnassignMarkersMutationResult = Apollo.MutationResult<UnassignMarkersMutation>;
export type UnassignMarkersMutationOptions = Apollo.BaseMutationOptions<UnassignMarkersMutation, UnassignMarkersMutationVariables>;
export const UpdateGroupMembershipsDocument = gql`
    mutation UpdateGroupMemberships($assessmentId: ID!, $memberships: [GroupMembershipInput!]!) {
  updateGroupMemberships(assessmentId: $assessmentId, memberships: $memberships) {
    ...Group
  }
}
    ${GroupFragmentDoc}`;
export type UpdateGroupMembershipsMutationFn = Apollo.MutationFunction<UpdateGroupMembershipsMutation, UpdateGroupMembershipsMutationVariables>;

/**
 * __useUpdateGroupMembershipsMutation__
 *
 * To run a mutation, you first call `useUpdateGroupMembershipsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupMembershipsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupMembershipsMutation, { data, loading, error }] = useUpdateGroupMembershipsMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      memberships: // value for 'memberships'
 *   },
 * });
 */
export function useUpdateGroupMembershipsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGroupMembershipsMutation, UpdateGroupMembershipsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGroupMembershipsMutation, UpdateGroupMembershipsMutationVariables>(UpdateGroupMembershipsDocument, options);
      }
export type UpdateGroupMembershipsMutationHookResult = ReturnType<typeof useUpdateGroupMembershipsMutation>;
export type UpdateGroupMembershipsMutationResult = Apollo.MutationResult<UpdateGroupMembershipsMutation>;
export type UpdateGroupMembershipsMutationOptions = Apollo.BaseMutationOptions<UpdateGroupMembershipsMutation, UpdateGroupMembershipsMutationVariables>;
export const UpdateGroupDocument = gql`
    mutation UpdateGroup($assessmentId: ID!, $group: GroupUpdateInput!) {
  updateGroup(assessmentId: $assessmentId, group: $group) {
    ...Group
  }
}
    ${GroupFragmentDoc}`;
export type UpdateGroupMutationFn = Apollo.MutationFunction<UpdateGroupMutation, UpdateGroupMutationVariables>;

/**
 * __useUpdateGroupMutation__
 *
 * To run a mutation, you first call `useUpdateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupMutation, { data, loading, error }] = useUpdateGroupMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      group: // value for 'group'
 *   },
 * });
 */
export function useUpdateGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGroupMutation, UpdateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGroupMutation, UpdateGroupMutationVariables>(UpdateGroupDocument, options);
      }
export type UpdateGroupMutationHookResult = ReturnType<typeof useUpdateGroupMutation>;
export type UpdateGroupMutationResult = Apollo.MutationResult<UpdateGroupMutation>;
export type UpdateGroupMutationOptions = Apollo.BaseMutationOptions<UpdateGroupMutation, UpdateGroupMutationVariables>;
export const UpdateGroupNameDocument = gql`
    mutation UpdateGroupName($assessmentId: ID!, $input: GroupUpdateInput!) {
  updateGroup(assessmentId: $assessmentId, group: $input) {
    id
    name
  }
}
    `;
export type UpdateGroupNameMutationFn = Apollo.MutationFunction<UpdateGroupNameMutation, UpdateGroupNameMutationVariables>;

/**
 * __useUpdateGroupNameMutation__
 *
 * To run a mutation, you first call `useUpdateGroupNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupNameMutation, { data, loading, error }] = useUpdateGroupNameMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGroupNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGroupNameMutation, UpdateGroupNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGroupNameMutation, UpdateGroupNameMutationVariables>(UpdateGroupNameDocument, options);
      }
export type UpdateGroupNameMutationHookResult = ReturnType<typeof useUpdateGroupNameMutation>;
export type UpdateGroupNameMutationResult = Apollo.MutationResult<UpdateGroupNameMutation>;
export type UpdateGroupNameMutationOptions = Apollo.BaseMutationOptions<UpdateGroupNameMutation, UpdateGroupNameMutationVariables>;
export const AssignMarkerToGroupsDocument = gql`
    mutation assignMarkerToGroups($assessmentId: ID!, $groupIds: [ID!]!, $markerId: ID) {
  assignMarkerToGroups(
    assessmentId: $assessmentId
    groupIds: $groupIds
    markerId: $markerId
  ) {
    id
    markerId
    marker {
      ...User
    }
  }
}
    ${UserFragmentDoc}`;
export type AssignMarkerToGroupsMutationFn = Apollo.MutationFunction<AssignMarkerToGroupsMutation, AssignMarkerToGroupsMutationVariables>;

/**
 * __useAssignMarkerToGroupsMutation__
 *
 * To run a mutation, you first call `useAssignMarkerToGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignMarkerToGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignMarkerToGroupsMutation, { data, loading, error }] = useAssignMarkerToGroupsMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      groupIds: // value for 'groupIds'
 *      markerId: // value for 'markerId'
 *   },
 * });
 */
export function useAssignMarkerToGroupsMutation(baseOptions?: Apollo.MutationHookOptions<AssignMarkerToGroupsMutation, AssignMarkerToGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignMarkerToGroupsMutation, AssignMarkerToGroupsMutationVariables>(AssignMarkerToGroupsDocument, options);
      }
export type AssignMarkerToGroupsMutationHookResult = ReturnType<typeof useAssignMarkerToGroupsMutation>;
export type AssignMarkerToGroupsMutationResult = Apollo.MutationResult<AssignMarkerToGroupsMutation>;
export type AssignMarkerToGroupsMutationOptions = Apollo.BaseMutationOptions<AssignMarkerToGroupsMutation, AssignMarkerToGroupsMutationVariables>;
export const GroupHubNavigationDocument = gql`
    query GroupHubNavigation($assessmentId: ID!) {
  assessment(assessmentId: $assessmentId) {
    id
    settings {
      ...HubAssessmentSettings
    }
  }
}
    ${HubAssessmentSettingsFragmentDoc}`;

/**
 * __useGroupHubNavigationQuery__
 *
 * To run a query within a React component, call `useGroupHubNavigationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupHubNavigationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupHubNavigationQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useGroupHubNavigationQuery(baseOptions: Apollo.QueryHookOptions<GroupHubNavigationQuery, GroupHubNavigationQueryVariables> & ({ variables: GroupHubNavigationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupHubNavigationQuery, GroupHubNavigationQueryVariables>(GroupHubNavigationDocument, options);
      }
export function useGroupHubNavigationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupHubNavigationQuery, GroupHubNavigationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupHubNavigationQuery, GroupHubNavigationQueryVariables>(GroupHubNavigationDocument, options);
        }
export function useGroupHubNavigationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupHubNavigationQuery, GroupHubNavigationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupHubNavigationQuery, GroupHubNavigationQueryVariables>(GroupHubNavigationDocument, options);
        }
export type GroupHubNavigationQueryHookResult = ReturnType<typeof useGroupHubNavigationQuery>;
export type GroupHubNavigationLazyQueryHookResult = ReturnType<typeof useGroupHubNavigationLazyQuery>;
export type GroupHubNavigationSuspenseQueryHookResult = ReturnType<typeof useGroupHubNavigationSuspenseQuery>;
export type GroupHubNavigationQueryResult = Apollo.QueryResult<GroupHubNavigationQuery, GroupHubNavigationQueryVariables>;
export const GroupHubDocument = gql`
    query GroupHub($assessmentId: ID!) {
  assessment(assessmentId: $assessmentId) {
    id
    settings {
      ...HubAssessmentSettings
    }
  }
  messageInbox(assessmentId: $assessmentId) {
    ...Message
  }
  class(assessmentId: $assessmentId) {
    id
    students {
      ...GroupEnrollment
    }
    groups {
      ...Group
    }
  }
  charterDraft: charterForm(assessmentId: $assessmentId) {
    ...CharterForm
  }
  charterPublished: charterForm(assessmentId: $assessmentId, published: true) {
    id
    publishTimestamp
  }
  groupTask: task(assessmentId: $assessmentId, kind: GROUP) {
    ...HubTask
  }
  groupInstructionSheet: instructionSheet(
    assessmentId: $assessmentId
    kind: GROUP
  ) {
    id
    genaiGuidelineNotice {
      id
    }
  }
  individualTask: task(assessmentId: $assessmentId, kind: INDIVIDUAL) {
    ...HubTask
  }
  peerTask: task(assessmentId: $assessmentId, kind: PEER) {
    ...HubTask
  }
  groupRubricMarkingStatus: markerRubric(
    assessmentId: $assessmentId
    kind: GROUP
    status: DRAFT
  ) {
    id
    markingExists
    hasChanges
    publishedAt
  }
  individualRubricMarkingStatus: markerRubric(
    assessmentId: $assessmentId
    kind: INDIVIDUAL
    status: DRAFT
  ) {
    id
    markingExists
    hasChanges
    publishedAt
  }
  peerRubricMarkingStatus: markerRubric(
    assessmentId: $assessmentId
    kind: PEER
    status: DRAFT
  ) {
    id
    markingExists
    hasChanges
    publishedAt
  }
}
    ${HubAssessmentSettingsFragmentDoc}
${MessageFragmentDoc}
${GroupEnrollmentFragmentDoc}
${GroupFragmentDoc}
${CharterFormFragmentDoc}
${HubTaskFragmentDoc}`;

/**
 * __useGroupHubQuery__
 *
 * To run a query within a React component, call `useGroupHubQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupHubQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupHubQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useGroupHubQuery(baseOptions: Apollo.QueryHookOptions<GroupHubQuery, GroupHubQueryVariables> & ({ variables: GroupHubQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupHubQuery, GroupHubQueryVariables>(GroupHubDocument, options);
      }
export function useGroupHubLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupHubQuery, GroupHubQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupHubQuery, GroupHubQueryVariables>(GroupHubDocument, options);
        }
export function useGroupHubSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupHubQuery, GroupHubQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupHubQuery, GroupHubQueryVariables>(GroupHubDocument, options);
        }
export type GroupHubQueryHookResult = ReturnType<typeof useGroupHubQuery>;
export type GroupHubLazyQueryHookResult = ReturnType<typeof useGroupHubLazyQuery>;
export type GroupHubSuspenseQueryHookResult = ReturnType<typeof useGroupHubSuspenseQuery>;
export type GroupHubQueryResult = Apollo.QueryResult<GroupHubQuery, GroupHubQueryVariables>;
export const HomeDocument = gql`
    query Home($assessmentId: ID!) {
  token
  me {
    ...User
  }
  institution {
    ...Institution
  }
  featureFlags(assessmentId: $assessmentId) {
    ...FeatureFlags
  }
  assessment(assessmentId: $assessmentId) {
    ...Assessment
    tasks {
      ...Task
      instructionSheet {
        ...InstructionSheet
      }
      futureSheet {
        ...InstructionSheetWithFutureSettings
      }
    }
  }
  class(assessmentId: $assessmentId) {
    id
    students {
      ...GroupEnrollment
    }
    groups {
      ...Group
    }
  }
  userSettings(assessmentId: $assessmentId) {
    ...UserSettings
  }
  assessmentAccessCodes(assessmentId: $assessmentId) {
    ...AccessCode
  }
}
    ${UserFragmentDoc}
${InstitutionFragmentDoc}
${FeatureFlagsFragmentDoc}
${AssessmentFragmentDoc}
${TaskFragmentDoc}
${InstructionSheetFragmentDoc}
${InstructionSheetWithFutureSettingsFragmentDoc}
${GroupEnrollmentFragmentDoc}
${GroupFragmentDoc}
${UserSettingsFragmentDoc}
${AccessCodeFragmentDoc}`;

/**
 * __useHomeQuery__
 *
 * To run a query within a React component, call `useHomeQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useHomeQuery(baseOptions: Apollo.QueryHookOptions<HomeQuery, HomeQueryVariables> & ({ variables: HomeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeQuery, HomeQueryVariables>(HomeDocument, options);
      }
export function useHomeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeQuery, HomeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeQuery, HomeQueryVariables>(HomeDocument, options);
        }
export function useHomeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HomeQuery, HomeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HomeQuery, HomeQueryVariables>(HomeDocument, options);
        }
export type HomeQueryHookResult = ReturnType<typeof useHomeQuery>;
export type HomeLazyQueryHookResult = ReturnType<typeof useHomeLazyQuery>;
export type HomeSuspenseQueryHookResult = ReturnType<typeof useHomeSuspenseQuery>;
export type HomeQueryResult = Apollo.QueryResult<HomeQuery, HomeQueryVariables>;
export const ReleaseAssessmentDocument = gql`
    mutation ReleaseAssessment($assessmentId: ID!) {
  releaseAssessment(assessmentId: $assessmentId) {
    assessment {
      id
      settings {
        id
        openDate
        assessmentType
      }
    }
    sheets {
      ...InstructionSheet
    }
  }
}
    ${InstructionSheetFragmentDoc}`;
export type ReleaseAssessmentMutationFn = Apollo.MutationFunction<ReleaseAssessmentMutation, ReleaseAssessmentMutationVariables>;

/**
 * __useReleaseAssessmentMutation__
 *
 * To run a mutation, you first call `useReleaseAssessmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReleaseAssessmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [releaseAssessmentMutation, { data, loading, error }] = useReleaseAssessmentMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useReleaseAssessmentMutation(baseOptions?: Apollo.MutationHookOptions<ReleaseAssessmentMutation, ReleaseAssessmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReleaseAssessmentMutation, ReleaseAssessmentMutationVariables>(ReleaseAssessmentDocument, options);
      }
export type ReleaseAssessmentMutationHookResult = ReturnType<typeof useReleaseAssessmentMutation>;
export type ReleaseAssessmentMutationResult = Apollo.MutationResult<ReleaseAssessmentMutation>;
export type ReleaseAssessmentMutationOptions = Apollo.BaseMutationOptions<ReleaseAssessmentMutation, ReleaseAssessmentMutationVariables>;
export const SettingsDocument = gql`
    query Settings($assessmentId: ID!) {
  token
  me {
    ...User
  }
  institution {
    ...Institution
  }
  featureFlags(assessmentId: $assessmentId) {
    ...FeatureFlags
  }
  assessment(assessmentId: $assessmentId) {
    ...SettingsRouteAssessment
  }
}
    ${UserFragmentDoc}
${InstitutionFragmentDoc}
${FeatureFlagsFragmentDoc}
${SettingsRouteAssessmentFragmentDoc}`;

/**
 * __useSettingsQuery__
 *
 * To run a query within a React component, call `useSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettingsQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useSettingsQuery(baseOptions: Apollo.QueryHookOptions<SettingsQuery, SettingsQueryVariables> & ({ variables: SettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SettingsQuery, SettingsQueryVariables>(SettingsDocument, options);
      }
export function useSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SettingsQuery, SettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SettingsQuery, SettingsQueryVariables>(SettingsDocument, options);
        }
export function useSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SettingsQuery, SettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SettingsQuery, SettingsQueryVariables>(SettingsDocument, options);
        }
export type SettingsQueryHookResult = ReturnType<typeof useSettingsQuery>;
export type SettingsLazyQueryHookResult = ReturnType<typeof useSettingsLazyQuery>;
export type SettingsSuspenseQueryHookResult = ReturnType<typeof useSettingsSuspenseQuery>;
export type SettingsQueryResult = Apollo.QueryResult<SettingsQuery, SettingsQueryVariables>;
export const InsightsDocument = gql`
    query Insights($assessmentId: ID!) {
  token
  assessment(assessmentId: $assessmentId) {
    ...Assessment
  }
  futureSheet(assessmentId: $assessmentId) {
    id
    releaseTimestamp
  }
  class(assessmentId: $assessmentId) {
    groups {
      ...Group
    }
  }
  institution {
    id
    timezone
  }
}
    ${AssessmentFragmentDoc}
${GroupFragmentDoc}`;

/**
 * __useInsightsQuery__
 *
 * To run a query within a React component, call `useInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightsQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useInsightsQuery(baseOptions: Apollo.QueryHookOptions<InsightsQuery, InsightsQueryVariables> & ({ variables: InsightsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsightsQuery, InsightsQueryVariables>(InsightsDocument, options);
      }
export function useInsightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsightsQuery, InsightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsightsQuery, InsightsQueryVariables>(InsightsDocument, options);
        }
export function useInsightsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InsightsQuery, InsightsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InsightsQuery, InsightsQueryVariables>(InsightsDocument, options);
        }
export type InsightsQueryHookResult = ReturnType<typeof useInsightsQuery>;
export type InsightsLazyQueryHookResult = ReturnType<typeof useInsightsLazyQuery>;
export type InsightsSuspenseQueryHookResult = ReturnType<typeof useInsightsSuspenseQuery>;
export type InsightsQueryResult = Apollo.QueryResult<InsightsQuery, InsightsQueryVariables>;
export const MailingListDocument = gql`
    query MailingList($assessmentId: ID!) {
  me {
    email
  }
  insightsMailingList(assessmentId: $assessmentId) {
    ...MailingList
  }
}
    ${MailingListFragmentDoc}`;

/**
 * __useMailingListQuery__
 *
 * To run a query within a React component, call `useMailingListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMailingListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMailingListQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useMailingListQuery(baseOptions: Apollo.QueryHookOptions<MailingListQuery, MailingListQueryVariables> & ({ variables: MailingListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MailingListQuery, MailingListQueryVariables>(MailingListDocument, options);
      }
export function useMailingListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MailingListQuery, MailingListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MailingListQuery, MailingListQueryVariables>(MailingListDocument, options);
        }
export function useMailingListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MailingListQuery, MailingListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MailingListQuery, MailingListQueryVariables>(MailingListDocument, options);
        }
export type MailingListQueryHookResult = ReturnType<typeof useMailingListQuery>;
export type MailingListLazyQueryHookResult = ReturnType<typeof useMailingListLazyQuery>;
export type MailingListSuspenseQueryHookResult = ReturnType<typeof useMailingListSuspenseQuery>;
export type MailingListQueryResult = Apollo.QueryResult<MailingListQuery, MailingListQueryVariables>;
export const UpdateInsightsMailingListDocument = gql`
    mutation UpdateInsightsMailingList($assessmentId: ID!, $subscribed: Boolean!, $members: [String!]!) {
  updateInsightsMailingList(
    assessmentId: $assessmentId
    subscribed: $subscribed
    members: $members
  ) {
    ...MailingList
  }
}
    ${MailingListFragmentDoc}`;
export type UpdateInsightsMailingListMutationFn = Apollo.MutationFunction<UpdateInsightsMailingListMutation, UpdateInsightsMailingListMutationVariables>;

/**
 * __useUpdateInsightsMailingListMutation__
 *
 * To run a mutation, you first call `useUpdateInsightsMailingListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInsightsMailingListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInsightsMailingListMutation, { data, loading, error }] = useUpdateInsightsMailingListMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      subscribed: // value for 'subscribed'
 *      members: // value for 'members'
 *   },
 * });
 */
export function useUpdateInsightsMailingListMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInsightsMailingListMutation, UpdateInsightsMailingListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInsightsMailingListMutation, UpdateInsightsMailingListMutationVariables>(UpdateInsightsMailingListDocument, options);
      }
export type UpdateInsightsMailingListMutationHookResult = ReturnType<typeof useUpdateInsightsMailingListMutation>;
export type UpdateInsightsMailingListMutationResult = Apollo.MutationResult<UpdateInsightsMailingListMutation>;
export type UpdateInsightsMailingListMutationOptions = Apollo.BaseMutationOptions<UpdateInsightsMailingListMutation, UpdateInsightsMailingListMutationVariables>;
export const SnapshotTicksDocument = gql`
    query SnapshotTicks($assessmentId: ID!, $answerBlockId: ID!, $maxSnapshotId: ID) {
  snapshotTicks(
    assessmentId: $assessmentId
    answerBlockId: $answerBlockId
    maxSnapshotId: $maxSnapshotId
  ) {
    id
    version
    timestamp
  }
}
    `;

/**
 * __useSnapshotTicksQuery__
 *
 * To run a query within a React component, call `useSnapshotTicksQuery` and pass it any options that fit your needs.
 * When your component renders, `useSnapshotTicksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSnapshotTicksQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      answerBlockId: // value for 'answerBlockId'
 *      maxSnapshotId: // value for 'maxSnapshotId'
 *   },
 * });
 */
export function useSnapshotTicksQuery(baseOptions: Apollo.QueryHookOptions<SnapshotTicksQuery, SnapshotTicksQueryVariables> & ({ variables: SnapshotTicksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SnapshotTicksQuery, SnapshotTicksQueryVariables>(SnapshotTicksDocument, options);
      }
export function useSnapshotTicksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SnapshotTicksQuery, SnapshotTicksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SnapshotTicksQuery, SnapshotTicksQueryVariables>(SnapshotTicksDocument, options);
        }
export function useSnapshotTicksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SnapshotTicksQuery, SnapshotTicksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SnapshotTicksQuery, SnapshotTicksQueryVariables>(SnapshotTicksDocument, options);
        }
export type SnapshotTicksQueryHookResult = ReturnType<typeof useSnapshotTicksQuery>;
export type SnapshotTicksLazyQueryHookResult = ReturnType<typeof useSnapshotTicksLazyQuery>;
export type SnapshotTicksSuspenseQueryHookResult = ReturnType<typeof useSnapshotTicksSuspenseQuery>;
export type SnapshotTicksQueryResult = Apollo.QueryResult<SnapshotTicksQuery, SnapshotTicksQueryVariables>;
export const BuildMarkerRubricDocument = gql`
    mutation BuildMarkerRubric($assessmentId: ID!, $input: BuildMarkerRubricInput!) {
  buildMarkerRubric(assessmentId: $assessmentId, input: $input) {
    markerRubric {
      ...MarkerRubric
    }
    taskBlock {
      id
      markerRubric {
        id
      }
    }
    fieldRubric {
      id
      markerRubric {
        id
      }
    }
  }
}
    ${MarkerRubricFragmentDoc}`;
export type BuildMarkerRubricMutationFn = Apollo.MutationFunction<BuildMarkerRubricMutation, BuildMarkerRubricMutationVariables>;

/**
 * __useBuildMarkerRubricMutation__
 *
 * To run a mutation, you first call `useBuildMarkerRubricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuildMarkerRubricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buildMarkerRubricMutation, { data, loading, error }] = useBuildMarkerRubricMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBuildMarkerRubricMutation(baseOptions?: Apollo.MutationHookOptions<BuildMarkerRubricMutation, BuildMarkerRubricMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BuildMarkerRubricMutation, BuildMarkerRubricMutationVariables>(BuildMarkerRubricDocument, options);
      }
export type BuildMarkerRubricMutationHookResult = ReturnType<typeof useBuildMarkerRubricMutation>;
export type BuildMarkerRubricMutationResult = Apollo.MutationResult<BuildMarkerRubricMutation>;
export type BuildMarkerRubricMutationOptions = Apollo.BaseMutationOptions<BuildMarkerRubricMutation, BuildMarkerRubricMutationVariables>;
export const ClassOutcomesDocument = gql`
    query ClassOutcomes($assessmentId: ID!) {
  workOutcomes(assessmentId: $assessmentId) {
    ...WorkOutcomeClass
  }
}
    ${WorkOutcomeClassFragmentDoc}`;

/**
 * __useClassOutcomesQuery__
 *
 * To run a query within a React component, call `useClassOutcomesQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassOutcomesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassOutcomesQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useClassOutcomesQuery(baseOptions: Apollo.QueryHookOptions<ClassOutcomesQuery, ClassOutcomesQueryVariables> & ({ variables: ClassOutcomesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClassOutcomesQuery, ClassOutcomesQueryVariables>(ClassOutcomesDocument, options);
      }
export function useClassOutcomesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClassOutcomesQuery, ClassOutcomesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClassOutcomesQuery, ClassOutcomesQueryVariables>(ClassOutcomesDocument, options);
        }
export function useClassOutcomesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ClassOutcomesQuery, ClassOutcomesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClassOutcomesQuery, ClassOutcomesQueryVariables>(ClassOutcomesDocument, options);
        }
export type ClassOutcomesQueryHookResult = ReturnType<typeof useClassOutcomesQuery>;
export type ClassOutcomesLazyQueryHookResult = ReturnType<typeof useClassOutcomesLazyQuery>;
export type ClassOutcomesSuspenseQueryHookResult = ReturnType<typeof useClassOutcomesSuspenseQuery>;
export type ClassOutcomesQueryResult = Apollo.QueryResult<ClassOutcomesQuery, ClassOutcomesQueryVariables>;
export const ClassPeerOutcomesDocument = gql`
    query ClassPeerOutcomes($assessmentId: ID!) {
  classPeerOutcomes(assessmentId: $assessmentId) {
    ...PeerOutcome
  }
  peerRubric(assessmentId: $assessmentId) {
    id
    criteria {
      ...Criterion
    }
  }
}
    ${PeerOutcomeFragmentDoc}
${CriterionFragmentDoc}`;

/**
 * __useClassPeerOutcomesQuery__
 *
 * To run a query within a React component, call `useClassPeerOutcomesQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassPeerOutcomesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassPeerOutcomesQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useClassPeerOutcomesQuery(baseOptions: Apollo.QueryHookOptions<ClassPeerOutcomesQuery, ClassPeerOutcomesQueryVariables> & ({ variables: ClassPeerOutcomesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClassPeerOutcomesQuery, ClassPeerOutcomesQueryVariables>(ClassPeerOutcomesDocument, options);
      }
export function useClassPeerOutcomesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClassPeerOutcomesQuery, ClassPeerOutcomesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClassPeerOutcomesQuery, ClassPeerOutcomesQueryVariables>(ClassPeerOutcomesDocument, options);
        }
export function useClassPeerOutcomesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ClassPeerOutcomesQuery, ClassPeerOutcomesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClassPeerOutcomesQuery, ClassPeerOutcomesQueryVariables>(ClassPeerOutcomesDocument, options);
        }
export type ClassPeerOutcomesQueryHookResult = ReturnType<typeof useClassPeerOutcomesQuery>;
export type ClassPeerOutcomesLazyQueryHookResult = ReturnType<typeof useClassPeerOutcomesLazyQuery>;
export type ClassPeerOutcomesSuspenseQueryHookResult = ReturnType<typeof useClassPeerOutcomesSuspenseQuery>;
export type ClassPeerOutcomesQueryResult = Apollo.QueryResult<ClassPeerOutcomesQuery, ClassPeerOutcomesQueryVariables>;
export const ClassicMarkingDocument = gql`
    query ClassicMarking($assessmentId: ID!, $studentId: ID!) {
  me {
    id
    email
  }
  featureFlags(assessmentId: $assessmentId) {
    ...FeatureFlags
  }
  individualMarkerRubric: markerRubric(
    assessmentId: $assessmentId
    kind: INDIVIDUAL
    status: DRAFT
  ) {
    ...MarkerRubric
  }
  groupMarkerRubric: markerRubric(
    assessmentId: $assessmentId
    kind: GROUP
    status: DRAFT
  ) {
    ...MarkerRubric
  }
  peerMarkerRubric: markerRubric(
    assessmentId: $assessmentId
    kind: PEER
    status: DRAFT
  ) {
    ...MarkerRubric
  }
  studentWorkOutcome(assessmentId: $assessmentId, studentId: $studentId) {
    ...WorkOutcome
  }
  groupWorkOutcome(assessmentId: $assessmentId, studentId: $studentId) {
    ...WorkOutcome
  }
}
    ${FeatureFlagsFragmentDoc}
${MarkerRubricFragmentDoc}
${WorkOutcomeFragmentDoc}`;

/**
 * __useClassicMarkingQuery__
 *
 * To run a query within a React component, call `useClassicMarkingQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassicMarkingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassicMarkingQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useClassicMarkingQuery(baseOptions: Apollo.QueryHookOptions<ClassicMarkingQuery, ClassicMarkingQueryVariables> & ({ variables: ClassicMarkingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClassicMarkingQuery, ClassicMarkingQueryVariables>(ClassicMarkingDocument, options);
      }
export function useClassicMarkingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClassicMarkingQuery, ClassicMarkingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClassicMarkingQuery, ClassicMarkingQueryVariables>(ClassicMarkingDocument, options);
        }
export function useClassicMarkingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ClassicMarkingQuery, ClassicMarkingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClassicMarkingQuery, ClassicMarkingQueryVariables>(ClassicMarkingDocument, options);
        }
export type ClassicMarkingQueryHookResult = ReturnType<typeof useClassicMarkingQuery>;
export type ClassicMarkingLazyQueryHookResult = ReturnType<typeof useClassicMarkingLazyQuery>;
export type ClassicMarkingSuspenseQueryHookResult = ReturnType<typeof useClassicMarkingSuspenseQuery>;
export type ClassicMarkingQueryResult = Apollo.QueryResult<ClassicMarkingQuery, ClassicMarkingQueryVariables>;
export const ClearMarkerAdjustmentDocument = gql`
    mutation ClearMarkerAdjustment($workId: ID!, $studentId: ID!) {
  clearMarkerAdjustment(workId: $workId, studentId: $studentId) {
    studentOutcome {
      id
      studentId
      modifiers {
        id
        type
        component
        value
        note
        addedByUserId
        addedAt
      }
    }
  }
}
    `;
export type ClearMarkerAdjustmentMutationFn = Apollo.MutationFunction<ClearMarkerAdjustmentMutation, ClearMarkerAdjustmentMutationVariables>;

/**
 * __useClearMarkerAdjustmentMutation__
 *
 * To run a mutation, you first call `useClearMarkerAdjustmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearMarkerAdjustmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearMarkerAdjustmentMutation, { data, loading, error }] = useClearMarkerAdjustmentMutation({
 *   variables: {
 *      workId: // value for 'workId'
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useClearMarkerAdjustmentMutation(baseOptions?: Apollo.MutationHookOptions<ClearMarkerAdjustmentMutation, ClearMarkerAdjustmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearMarkerAdjustmentMutation, ClearMarkerAdjustmentMutationVariables>(ClearMarkerAdjustmentDocument, options);
      }
export type ClearMarkerAdjustmentMutationHookResult = ReturnType<typeof useClearMarkerAdjustmentMutation>;
export type ClearMarkerAdjustmentMutationResult = Apollo.MutationResult<ClearMarkerAdjustmentMutation>;
export type ClearMarkerAdjustmentMutationOptions = Apollo.BaseMutationOptions<ClearMarkerAdjustmentMutation, ClearMarkerAdjustmentMutationVariables>;
export const CompleteSubmissionOutcomesDocument = gql`
    mutation CompleteSubmissionOutcomes($assessmentId: ID!) {
  completeSubmissionOutcomes(assessmentId: $assessmentId) {
    updatedCount
    submissionOutcomes {
      id
      completedAt
    }
  }
}
    `;
export type CompleteSubmissionOutcomesMutationFn = Apollo.MutationFunction<CompleteSubmissionOutcomesMutation, CompleteSubmissionOutcomesMutationVariables>;

/**
 * __useCompleteSubmissionOutcomesMutation__
 *
 * To run a mutation, you first call `useCompleteSubmissionOutcomesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteSubmissionOutcomesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeSubmissionOutcomesMutation, { data, loading, error }] = useCompleteSubmissionOutcomesMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useCompleteSubmissionOutcomesMutation(baseOptions?: Apollo.MutationHookOptions<CompleteSubmissionOutcomesMutation, CompleteSubmissionOutcomesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteSubmissionOutcomesMutation, CompleteSubmissionOutcomesMutationVariables>(CompleteSubmissionOutcomesDocument, options);
      }
export type CompleteSubmissionOutcomesMutationHookResult = ReturnType<typeof useCompleteSubmissionOutcomesMutation>;
export type CompleteSubmissionOutcomesMutationResult = Apollo.MutationResult<CompleteSubmissionOutcomesMutation>;
export type CompleteSubmissionOutcomesMutationOptions = Apollo.BaseMutationOptions<CompleteSubmissionOutcomesMutation, CompleteSubmissionOutcomesMutationVariables>;
export const ContributionDocument = gql`
    query Contribution($assessmentId: ID!, $bodyAnswerBlockId: ID!, $referencesAnswerBlockId: ID!, $includeReferences: Boolean!, $includeDeletions: Boolean!, $bodyFrom: Int, $bodyTo: Int) {
  body: contribution(
    assessmentId: $assessmentId
    answerBlockId: $bodyAnswerBlockId
    from: $bodyFrom
    to: $bodyTo
    includeDeletions: $includeDeletions
  ) {
    ...ContributionFields
  }
  references: contribution(
    assessmentId: $assessmentId
    answerBlockId: $referencesAnswerBlockId
    includeDeletions: $includeDeletions
  ) @include(if: $includeReferences) {
    ...ContributionFields
  }
}
    ${ContributionFieldsFragmentDoc}`;

/**
 * __useContributionQuery__
 *
 * To run a query within a React component, call `useContributionQuery` and pass it any options that fit your needs.
 * When your component renders, `useContributionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContributionQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      bodyAnswerBlockId: // value for 'bodyAnswerBlockId'
 *      referencesAnswerBlockId: // value for 'referencesAnswerBlockId'
 *      includeReferences: // value for 'includeReferences'
 *      includeDeletions: // value for 'includeDeletions'
 *      bodyFrom: // value for 'bodyFrom'
 *      bodyTo: // value for 'bodyTo'
 *   },
 * });
 */
export function useContributionQuery(baseOptions: Apollo.QueryHookOptions<ContributionQuery, ContributionQueryVariables> & ({ variables: ContributionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContributionQuery, ContributionQueryVariables>(ContributionDocument, options);
      }
export function useContributionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContributionQuery, ContributionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContributionQuery, ContributionQueryVariables>(ContributionDocument, options);
        }
export function useContributionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContributionQuery, ContributionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContributionQuery, ContributionQueryVariables>(ContributionDocument, options);
        }
export type ContributionQueryHookResult = ReturnType<typeof useContributionQuery>;
export type ContributionLazyQueryHookResult = ReturnType<typeof useContributionLazyQuery>;
export type ContributionSuspenseQueryHookResult = ReturnType<typeof useContributionSuspenseQuery>;
export type ContributionQueryResult = Apollo.QueryResult<ContributionQuery, ContributionQueryVariables>;
export const CreateSkillDocument = gql`
    mutation CreateSkill($assessmentId: ID!, $input: CreateSkillInput!) {
  createSkill(assessmentId: $assessmentId, input: $input) {
    ...Skill
  }
}
    ${SkillFragmentDoc}`;
export type CreateSkillMutationFn = Apollo.MutationFunction<CreateSkillMutation, CreateSkillMutationVariables>;

/**
 * __useCreateSkillMutation__
 *
 * To run a mutation, you first call `useCreateSkillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSkillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSkillMutation, { data, loading, error }] = useCreateSkillMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSkillMutation(baseOptions?: Apollo.MutationHookOptions<CreateSkillMutation, CreateSkillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSkillMutation, CreateSkillMutationVariables>(CreateSkillDocument, options);
      }
export type CreateSkillMutationHookResult = ReturnType<typeof useCreateSkillMutation>;
export type CreateSkillMutationResult = Apollo.MutationResult<CreateSkillMutation>;
export type CreateSkillMutationOptions = Apollo.BaseMutationOptions<CreateSkillMutation, CreateSkillMutationVariables>;
export const CreateSmartCommentDocument = gql`
    mutation CreateSmartComment($assessmentId: ID!, $input: CreateSmartCommentInput!) {
  createSmartComment(assessmentId: $assessmentId, input: $input) {
    id
  }
}
    `;
export type CreateSmartCommentMutationFn = Apollo.MutationFunction<CreateSmartCommentMutation, CreateSmartCommentMutationVariables>;

/**
 * __useCreateSmartCommentMutation__
 *
 * To run a mutation, you first call `useCreateSmartCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSmartCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSmartCommentMutation, { data, loading, error }] = useCreateSmartCommentMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSmartCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateSmartCommentMutation, CreateSmartCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSmartCommentMutation, CreateSmartCommentMutationVariables>(CreateSmartCommentDocument, options);
      }
export type CreateSmartCommentMutationHookResult = ReturnType<typeof useCreateSmartCommentMutation>;
export type CreateSmartCommentMutationResult = Apollo.MutationResult<CreateSmartCommentMutation>;
export type CreateSmartCommentMutationOptions = Apollo.BaseMutationOptions<CreateSmartCommentMutation, CreateSmartCommentMutationVariables>;
export const CreateSubmissionOutcomeDocument = gql`
    mutation CreateSubmissionOutcome($assessmentId: ID!, $workOutcomeId: ID!, $markerScope: MarkerScopeInput!) {
  createSubmissionOutcome(
    assessmentId: $assessmentId
    workOutcomeId: $workOutcomeId
    markerScope: $markerScope
  ) {
    id
  }
}
    `;
export type CreateSubmissionOutcomeMutationFn = Apollo.MutationFunction<CreateSubmissionOutcomeMutation, CreateSubmissionOutcomeMutationVariables>;

/**
 * __useCreateSubmissionOutcomeMutation__
 *
 * To run a mutation, you first call `useCreateSubmissionOutcomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubmissionOutcomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubmissionOutcomeMutation, { data, loading, error }] = useCreateSubmissionOutcomeMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      workOutcomeId: // value for 'workOutcomeId'
 *      markerScope: // value for 'markerScope'
 *   },
 * });
 */
export function useCreateSubmissionOutcomeMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubmissionOutcomeMutation, CreateSubmissionOutcomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubmissionOutcomeMutation, CreateSubmissionOutcomeMutationVariables>(CreateSubmissionOutcomeDocument, options);
      }
export type CreateSubmissionOutcomeMutationHookResult = ReturnType<typeof useCreateSubmissionOutcomeMutation>;
export type CreateSubmissionOutcomeMutationResult = Apollo.MutationResult<CreateSubmissionOutcomeMutation>;
export type CreateSubmissionOutcomeMutationOptions = Apollo.BaseMutationOptions<CreateSubmissionOutcomeMutation, CreateSubmissionOutcomeMutationVariables>;
export const CreateThreadDocument = gql`
    mutation CreateThread($threadId: ID!, $input: ThreadInput!) {
  createThread(threadId: $threadId, input: $input) {
    ...Thread
  }
}
    ${ThreadFragmentDoc}`;
export type CreateThreadMutationFn = Apollo.MutationFunction<CreateThreadMutation, CreateThreadMutationVariables>;

/**
 * __useCreateThreadMutation__
 *
 * To run a mutation, you first call `useCreateThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createThreadMutation, { data, loading, error }] = useCreateThreadMutation({
 *   variables: {
 *      threadId: // value for 'threadId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateThreadMutation(baseOptions?: Apollo.MutationHookOptions<CreateThreadMutation, CreateThreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateThreadMutation, CreateThreadMutationVariables>(CreateThreadDocument, options);
      }
export type CreateThreadMutationHookResult = ReturnType<typeof useCreateThreadMutation>;
export type CreateThreadMutationResult = Apollo.MutationResult<CreateThreadMutation>;
export type CreateThreadMutationOptions = Apollo.BaseMutationOptions<CreateThreadMutation, CreateThreadMutationVariables>;
export const CriteriaBySkillDocument = gql`
    query CriteriaBySkill($assessmentId: ID!, $skillId: ID!) {
  criteriaBySkill(assessmentId: $assessmentId, skillId: $skillId) {
    ...ReuseCriterion
  }
}
    ${ReuseCriterionFragmentDoc}`;

/**
 * __useCriteriaBySkillQuery__
 *
 * To run a query within a React component, call `useCriteriaBySkillQuery` and pass it any options that fit your needs.
 * When your component renders, `useCriteriaBySkillQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCriteriaBySkillQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      skillId: // value for 'skillId'
 *   },
 * });
 */
export function useCriteriaBySkillQuery(baseOptions: Apollo.QueryHookOptions<CriteriaBySkillQuery, CriteriaBySkillQueryVariables> & ({ variables: CriteriaBySkillQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CriteriaBySkillQuery, CriteriaBySkillQueryVariables>(CriteriaBySkillDocument, options);
      }
export function useCriteriaBySkillLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CriteriaBySkillQuery, CriteriaBySkillQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CriteriaBySkillQuery, CriteriaBySkillQueryVariables>(CriteriaBySkillDocument, options);
        }
export function useCriteriaBySkillSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CriteriaBySkillQuery, CriteriaBySkillQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CriteriaBySkillQuery, CriteriaBySkillQueryVariables>(CriteriaBySkillDocument, options);
        }
export type CriteriaBySkillQueryHookResult = ReturnType<typeof useCriteriaBySkillQuery>;
export type CriteriaBySkillLazyQueryHookResult = ReturnType<typeof useCriteriaBySkillLazyQuery>;
export type CriteriaBySkillSuspenseQueryHookResult = ReturnType<typeof useCriteriaBySkillSuspenseQuery>;
export type CriteriaBySkillQueryResult = Apollo.QueryResult<CriteriaBySkillQuery, CriteriaBySkillQueryVariables>;
export const DeleteSmartCommentDocument = gql`
    mutation DeleteSmartComment($assessmentId: ID!, $smartCommentId: ID!) {
  deleteSmartComment(assessmentId: $assessmentId, smartCommentId: $smartCommentId) {
    id
  }
}
    `;
export type DeleteSmartCommentMutationFn = Apollo.MutationFunction<DeleteSmartCommentMutation, DeleteSmartCommentMutationVariables>;

/**
 * __useDeleteSmartCommentMutation__
 *
 * To run a mutation, you first call `useDeleteSmartCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSmartCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSmartCommentMutation, { data, loading, error }] = useDeleteSmartCommentMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      smartCommentId: // value for 'smartCommentId'
 *   },
 * });
 */
export function useDeleteSmartCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSmartCommentMutation, DeleteSmartCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSmartCommentMutation, DeleteSmartCommentMutationVariables>(DeleteSmartCommentDocument, options);
      }
export type DeleteSmartCommentMutationHookResult = ReturnType<typeof useDeleteSmartCommentMutation>;
export type DeleteSmartCommentMutationResult = Apollo.MutationResult<DeleteSmartCommentMutation>;
export type DeleteSmartCommentMutationOptions = Apollo.BaseMutationOptions<DeleteSmartCommentMutation, DeleteSmartCommentMutationVariables>;
export const DeleteThreadDocument = gql`
    mutation DeleteThread($threadId: ID!) {
  deleteThread(threadId: $threadId) {
    id
  }
}
    `;
export type DeleteThreadMutationFn = Apollo.MutationFunction<DeleteThreadMutation, DeleteThreadMutationVariables>;

/**
 * __useDeleteThreadMutation__
 *
 * To run a mutation, you first call `useDeleteThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteThreadMutation, { data, loading, error }] = useDeleteThreadMutation({
 *   variables: {
 *      threadId: // value for 'threadId'
 *   },
 * });
 */
export function useDeleteThreadMutation(baseOptions?: Apollo.MutationHookOptions<DeleteThreadMutation, DeleteThreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteThreadMutation, DeleteThreadMutationVariables>(DeleteThreadDocument, options);
      }
export type DeleteThreadMutationHookResult = ReturnType<typeof useDeleteThreadMutation>;
export type DeleteThreadMutationResult = Apollo.MutationResult<DeleteThreadMutation>;
export type DeleteThreadMutationOptions = Apollo.BaseMutationOptions<DeleteThreadMutation, DeleteThreadMutationVariables>;
export const DeletedAnswerBlockDocument = gql`
    query DeletedAnswerBlock($answerBlockId: ID!) {
  deletedAnswerBlock(answerBlockId: $answerBlockId) {
    id
    blockName
    latestBlockSnapshot {
      id
      content
      blockName
    }
  }
}
    `;

/**
 * __useDeletedAnswerBlockQuery__
 *
 * To run a query within a React component, call `useDeletedAnswerBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeletedAnswerBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedAnswerBlockQuery({
 *   variables: {
 *      answerBlockId: // value for 'answerBlockId'
 *   },
 * });
 */
export function useDeletedAnswerBlockQuery(baseOptions: Apollo.QueryHookOptions<DeletedAnswerBlockQuery, DeletedAnswerBlockQueryVariables> & ({ variables: DeletedAnswerBlockQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeletedAnswerBlockQuery, DeletedAnswerBlockQueryVariables>(DeletedAnswerBlockDocument, options);
      }
export function useDeletedAnswerBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeletedAnswerBlockQuery, DeletedAnswerBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeletedAnswerBlockQuery, DeletedAnswerBlockQueryVariables>(DeletedAnswerBlockDocument, options);
        }
export function useDeletedAnswerBlockSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DeletedAnswerBlockQuery, DeletedAnswerBlockQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DeletedAnswerBlockQuery, DeletedAnswerBlockQueryVariables>(DeletedAnswerBlockDocument, options);
        }
export type DeletedAnswerBlockQueryHookResult = ReturnType<typeof useDeletedAnswerBlockQuery>;
export type DeletedAnswerBlockLazyQueryHookResult = ReturnType<typeof useDeletedAnswerBlockLazyQuery>;
export type DeletedAnswerBlockSuspenseQueryHookResult = ReturnType<typeof useDeletedAnswerBlockSuspenseQuery>;
export type DeletedAnswerBlockQueryResult = Apollo.QueryResult<DeletedAnswerBlockQuery, DeletedAnswerBlockQueryVariables>;
export const DocumentBaseDocument = gql`
    query DocumentBase($assessmentId: ID!, $answerBlockId: ID!) {
  documentBase(assessmentId: $assessmentId, answerBlockId: $answerBlockId) {
    baseDoc
  }
}
    `;

/**
 * __useDocumentBaseQuery__
 *
 * To run a query within a React component, call `useDocumentBaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentBaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentBaseQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      answerBlockId: // value for 'answerBlockId'
 *   },
 * });
 */
export function useDocumentBaseQuery(baseOptions: Apollo.QueryHookOptions<DocumentBaseQuery, DocumentBaseQueryVariables> & ({ variables: DocumentBaseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentBaseQuery, DocumentBaseQueryVariables>(DocumentBaseDocument, options);
      }
export function useDocumentBaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentBaseQuery, DocumentBaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentBaseQuery, DocumentBaseQueryVariables>(DocumentBaseDocument, options);
        }
export function useDocumentBaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DocumentBaseQuery, DocumentBaseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DocumentBaseQuery, DocumentBaseQueryVariables>(DocumentBaseDocument, options);
        }
export type DocumentBaseQueryHookResult = ReturnType<typeof useDocumentBaseQuery>;
export type DocumentBaseLazyQueryHookResult = ReturnType<typeof useDocumentBaseLazyQuery>;
export type DocumentBaseSuspenseQueryHookResult = ReturnType<typeof useDocumentBaseSuspenseQuery>;
export type DocumentBaseQueryResult = Apollo.QueryResult<DocumentBaseQuery, DocumentBaseQueryVariables>;
export const DocumentWindowDocument = gql`
    query DocumentWindow($assessmentId: ID!, $answerBlockId: ID!, $targetVersion: Int!, $haveSnapshotVersion: Int, $buffer: Int) {
  documentWindow(
    assessmentId: $assessmentId
    answerBlockId: $answerBlockId
    targetVersion: $targetVersion
    haveSnapshotVersion: $haveSnapshotVersion
    buffer: $buffer
  ) {
    baseVersion
    document
    steps {
      version
      data
      userId
    }
  }
}
    `;

/**
 * __useDocumentWindowQuery__
 *
 * To run a query within a React component, call `useDocumentWindowQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentWindowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentWindowQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      answerBlockId: // value for 'answerBlockId'
 *      targetVersion: // value for 'targetVersion'
 *      haveSnapshotVersion: // value for 'haveSnapshotVersion'
 *      buffer: // value for 'buffer'
 *   },
 * });
 */
export function useDocumentWindowQuery(baseOptions: Apollo.QueryHookOptions<DocumentWindowQuery, DocumentWindowQueryVariables> & ({ variables: DocumentWindowQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentWindowQuery, DocumentWindowQueryVariables>(DocumentWindowDocument, options);
      }
export function useDocumentWindowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentWindowQuery, DocumentWindowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentWindowQuery, DocumentWindowQueryVariables>(DocumentWindowDocument, options);
        }
export function useDocumentWindowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DocumentWindowQuery, DocumentWindowQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DocumentWindowQuery, DocumentWindowQueryVariables>(DocumentWindowDocument, options);
        }
export type DocumentWindowQueryHookResult = ReturnType<typeof useDocumentWindowQuery>;
export type DocumentWindowLazyQueryHookResult = ReturnType<typeof useDocumentWindowLazyQuery>;
export type DocumentWindowSuspenseQueryHookResult = ReturnType<typeof useDocumentWindowSuspenseQuery>;
export type DocumentWindowQueryResult = Apollo.QueryResult<DocumentWindowQuery, DocumentWindowQueryVariables>;
export const DownloadWorkAttachmentsDocument = gql`
    mutation DownloadWorkAttachments($answerBlockId: ID!, $blockAttachmentIds: [ID!]!) {
  downloadWorkAttachments(
    answerBlockId: $answerBlockId
    blockAttachmentIds: $blockAttachmentIds
  )
}
    `;
export type DownloadWorkAttachmentsMutationFn = Apollo.MutationFunction<DownloadWorkAttachmentsMutation, DownloadWorkAttachmentsMutationVariables>;

/**
 * __useDownloadWorkAttachmentsMutation__
 *
 * To run a mutation, you first call `useDownloadWorkAttachmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadWorkAttachmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadWorkAttachmentsMutation, { data, loading, error }] = useDownloadWorkAttachmentsMutation({
 *   variables: {
 *      answerBlockId: // value for 'answerBlockId'
 *      blockAttachmentIds: // value for 'blockAttachmentIds'
 *   },
 * });
 */
export function useDownloadWorkAttachmentsMutation(baseOptions?: Apollo.MutationHookOptions<DownloadWorkAttachmentsMutation, DownloadWorkAttachmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadWorkAttachmentsMutation, DownloadWorkAttachmentsMutationVariables>(DownloadWorkAttachmentsDocument, options);
      }
export type DownloadWorkAttachmentsMutationHookResult = ReturnType<typeof useDownloadWorkAttachmentsMutation>;
export type DownloadWorkAttachmentsMutationResult = Apollo.MutationResult<DownloadWorkAttachmentsMutation>;
export type DownloadWorkAttachmentsMutationOptions = Apollo.BaseMutationOptions<DownloadWorkAttachmentsMutation, DownloadWorkAttachmentsMutationVariables>;
export const EditCommentDocument = gql`
    mutation EditComment($commentId: ID!, $content: String!) {
  editComment(commentId: $commentId, content: $content) {
    id
    content
    updatedAt
    createdBy {
      id
      name
      colourset
    }
  }
}
    `;
export type EditCommentMutationFn = Apollo.MutationFunction<EditCommentMutation, EditCommentMutationVariables>;

/**
 * __useEditCommentMutation__
 *
 * To run a mutation, you first call `useEditCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCommentMutation, { data, loading, error }] = useEditCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useEditCommentMutation(baseOptions?: Apollo.MutationHookOptions<EditCommentMutation, EditCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCommentMutation, EditCommentMutationVariables>(EditCommentDocument, options);
      }
export type EditCommentMutationHookResult = ReturnType<typeof useEditCommentMutation>;
export type EditCommentMutationResult = Apollo.MutationResult<EditCommentMutation>;
export type EditCommentMutationOptions = Apollo.BaseMutationOptions<EditCommentMutation, EditCommentMutationVariables>;
export const EditThreadTitleDocument = gql`
    mutation EditThreadTitle($threadId: ID!, $title: String!) {
  editThreadTitle(threadId: $threadId, title: $title) {
    id
    title
  }
}
    `;
export type EditThreadTitleMutationFn = Apollo.MutationFunction<EditThreadTitleMutation, EditThreadTitleMutationVariables>;

/**
 * __useEditThreadTitleMutation__
 *
 * To run a mutation, you first call `useEditThreadTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditThreadTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editThreadTitleMutation, { data, loading, error }] = useEditThreadTitleMutation({
 *   variables: {
 *      threadId: // value for 'threadId'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useEditThreadTitleMutation(baseOptions?: Apollo.MutationHookOptions<EditThreadTitleMutation, EditThreadTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditThreadTitleMutation, EditThreadTitleMutationVariables>(EditThreadTitleDocument, options);
      }
export type EditThreadTitleMutationHookResult = ReturnType<typeof useEditThreadTitleMutation>;
export type EditThreadTitleMutationResult = Apollo.MutationResult<EditThreadTitleMutation>;
export type EditThreadTitleMutationOptions = Apollo.BaseMutationOptions<EditThreadTitleMutation, EditThreadTitleMutationVariables>;
export const EntityThreadsDocument = gql`
    query EntityThreads($entityType: EntityType!, $entityIds: [ID!]!) {
  entityThreads(entityType: $entityType, entityIds: $entityIds) {
    ...Thread
  }
}
    ${ThreadFragmentDoc}`;

/**
 * __useEntityThreadsQuery__
 *
 * To run a query within a React component, call `useEntityThreadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityThreadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityThreadsQuery({
 *   variables: {
 *      entityType: // value for 'entityType'
 *      entityIds: // value for 'entityIds'
 *   },
 * });
 */
export function useEntityThreadsQuery(baseOptions: Apollo.QueryHookOptions<EntityThreadsQuery, EntityThreadsQueryVariables> & ({ variables: EntityThreadsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityThreadsQuery, EntityThreadsQueryVariables>(EntityThreadsDocument, options);
      }
export function useEntityThreadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityThreadsQuery, EntityThreadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityThreadsQuery, EntityThreadsQueryVariables>(EntityThreadsDocument, options);
        }
export function useEntityThreadsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntityThreadsQuery, EntityThreadsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityThreadsQuery, EntityThreadsQueryVariables>(EntityThreadsDocument, options);
        }
export type EntityThreadsQueryHookResult = ReturnType<typeof useEntityThreadsQuery>;
export type EntityThreadsLazyQueryHookResult = ReturnType<typeof useEntityThreadsLazyQuery>;
export type EntityThreadsSuspenseQueryHookResult = ReturnType<typeof useEntityThreadsSuspenseQuery>;
export type EntityThreadsQueryResult = Apollo.QueryResult<EntityThreadsQuery, EntityThreadsQueryVariables>;
export const OnEntityThreadsUpdatedDocument = gql`
    subscription onEntityThreadsUpdated($entityId: ID!, $entityType: EntityType!) {
  entityThreadsUpdated(entityId: $entityId, entityType: $entityType) {
    ...EntityThreadEvent
  }
}
    ${EntityThreadEventFragmentDoc}`;

/**
 * __useOnEntityThreadsUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnEntityThreadsUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnEntityThreadsUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnEntityThreadsUpdatedSubscription({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function useOnEntityThreadsUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnEntityThreadsUpdatedSubscription, OnEntityThreadsUpdatedSubscriptionVariables> & ({ variables: OnEntityThreadsUpdatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnEntityThreadsUpdatedSubscription, OnEntityThreadsUpdatedSubscriptionVariables>(OnEntityThreadsUpdatedDocument, options);
      }
export type OnEntityThreadsUpdatedSubscriptionHookResult = ReturnType<typeof useOnEntityThreadsUpdatedSubscription>;
export type OnEntityThreadsUpdatedSubscriptionResult = Apollo.SubscriptionResult<OnEntityThreadsUpdatedSubscription>;
export const GenerateWorkOutcomesCsvDocument = gql`
    mutation GenerateWorkOutcomesCsv($assessmentId: ID!, $byQuestions: Boolean) {
  generateWorkOutcomesCsv(assessmentId: $assessmentId, byQuestions: $byQuestions)
}
    `;
export type GenerateWorkOutcomesCsvMutationFn = Apollo.MutationFunction<GenerateWorkOutcomesCsvMutation, GenerateWorkOutcomesCsvMutationVariables>;

/**
 * __useGenerateWorkOutcomesCsvMutation__
 *
 * To run a mutation, you first call `useGenerateWorkOutcomesCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateWorkOutcomesCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateWorkOutcomesCsvMutation, { data, loading, error }] = useGenerateWorkOutcomesCsvMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      byQuestions: // value for 'byQuestions'
 *   },
 * });
 */
export function useGenerateWorkOutcomesCsvMutation(baseOptions?: Apollo.MutationHookOptions<GenerateWorkOutcomesCsvMutation, GenerateWorkOutcomesCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateWorkOutcomesCsvMutation, GenerateWorkOutcomesCsvMutationVariables>(GenerateWorkOutcomesCsvDocument, options);
      }
export type GenerateWorkOutcomesCsvMutationHookResult = ReturnType<typeof useGenerateWorkOutcomesCsvMutation>;
export type GenerateWorkOutcomesCsvMutationResult = Apollo.MutationResult<GenerateWorkOutcomesCsvMutation>;
export type GenerateWorkOutcomesCsvMutationOptions = Apollo.BaseMutationOptions<GenerateWorkOutcomesCsvMutation, GenerateWorkOutcomesCsvMutationVariables>;
export const GraderRouteDocument = gql`
    query GraderRoute($assessmentId: ID!) {
  token
  me {
    id
  }
  workOutcomes(assessmentId: $assessmentId) {
    id
    workId
    groupId
    studentId
    maxScore
    scoreBreakdown {
      ...ScoreBreakdown
    }
  }
  assessment(assessmentId: $assessmentId) {
    ...Assessment
  }
  individualSheet: instructionSheet(assessmentId: $assessmentId, kind: INDIVIDUAL) {
    ...MarkingSheet
  }
  rubric(assessmentId: $assessmentId) {
    id
    questions {
      ...QuestionRubric
    }
  }
  class(assessmentId: $assessmentId) {
    students {
      ...Enrollment
    }
    groupType
    groups {
      ...Group
    }
  }
}
    ${ScoreBreakdownFragmentDoc}
${AssessmentFragmentDoc}
${MarkingSheetFragmentDoc}
${QuestionRubricFragmentDoc}
${EnrollmentFragmentDoc}
${GroupFragmentDoc}`;

/**
 * __useGraderRouteQuery__
 *
 * To run a query within a React component, call `useGraderRouteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGraderRouteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGraderRouteQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useGraderRouteQuery(baseOptions: Apollo.QueryHookOptions<GraderRouteQuery, GraderRouteQueryVariables> & ({ variables: GraderRouteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraderRouteQuery, GraderRouteQueryVariables>(GraderRouteDocument, options);
      }
export function useGraderRouteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraderRouteQuery, GraderRouteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraderRouteQuery, GraderRouteQueryVariables>(GraderRouteDocument, options);
        }
export function useGraderRouteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraderRouteQuery, GraderRouteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraderRouteQuery, GraderRouteQueryVariables>(GraderRouteDocument, options);
        }
export type GraderRouteQueryHookResult = ReturnType<typeof useGraderRouteQuery>;
export type GraderRouteLazyQueryHookResult = ReturnType<typeof useGraderRouteLazyQuery>;
export type GraderRouteSuspenseQueryHookResult = ReturnType<typeof useGraderRouteSuspenseQuery>;
export type GraderRouteQueryResult = Apollo.QueryResult<GraderRouteQuery, GraderRouteQueryVariables>;
export const GroupPeerOutcomesDocument = gql`
    query GroupPeerOutcomes($assessmentId: ID!, $groupId: ID!) {
  groupPeerOutcomes(assessmentId: $assessmentId, groupId: $groupId) {
    ...PeerOutcome
  }
}
    ${PeerOutcomeFragmentDoc}`;

/**
 * __useGroupPeerOutcomesQuery__
 *
 * To run a query within a React component, call `useGroupPeerOutcomesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupPeerOutcomesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupPeerOutcomesQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGroupPeerOutcomesQuery(baseOptions: Apollo.QueryHookOptions<GroupPeerOutcomesQuery, GroupPeerOutcomesQueryVariables> & ({ variables: GroupPeerOutcomesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupPeerOutcomesQuery, GroupPeerOutcomesQueryVariables>(GroupPeerOutcomesDocument, options);
      }
export function useGroupPeerOutcomesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupPeerOutcomesQuery, GroupPeerOutcomesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupPeerOutcomesQuery, GroupPeerOutcomesQueryVariables>(GroupPeerOutcomesDocument, options);
        }
export function useGroupPeerOutcomesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupPeerOutcomesQuery, GroupPeerOutcomesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupPeerOutcomesQuery, GroupPeerOutcomesQueryVariables>(GroupPeerOutcomesDocument, options);
        }
export type GroupPeerOutcomesQueryHookResult = ReturnType<typeof useGroupPeerOutcomesQuery>;
export type GroupPeerOutcomesLazyQueryHookResult = ReturnType<typeof useGroupPeerOutcomesLazyQuery>;
export type GroupPeerOutcomesSuspenseQueryHookResult = ReturnType<typeof useGroupPeerOutcomesSuspenseQuery>;
export type GroupPeerOutcomesQueryResult = Apollo.QueryResult<GroupPeerOutcomesQuery, GroupPeerOutcomesQueryVariables>;
export const ImportSmartCommentsDocument = gql`
    mutation ImportSmartComments($assessmentId: ID!, $comments: [ImportSmartCommentInput!]!) {
  importSmartComments(assessmentId: $assessmentId, comments: $comments) {
    smartComments {
      id
      assessmentId
      content
      lastUsed
      score
    }
    skippedDuplicates
  }
}
    `;
export type ImportSmartCommentsMutationFn = Apollo.MutationFunction<ImportSmartCommentsMutation, ImportSmartCommentsMutationVariables>;

/**
 * __useImportSmartCommentsMutation__
 *
 * To run a mutation, you first call `useImportSmartCommentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportSmartCommentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importSmartCommentsMutation, { data, loading, error }] = useImportSmartCommentsMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      comments: // value for 'comments'
 *   },
 * });
 */
export function useImportSmartCommentsMutation(baseOptions?: Apollo.MutationHookOptions<ImportSmartCommentsMutation, ImportSmartCommentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportSmartCommentsMutation, ImportSmartCommentsMutationVariables>(ImportSmartCommentsDocument, options);
      }
export type ImportSmartCommentsMutationHookResult = ReturnType<typeof useImportSmartCommentsMutation>;
export type ImportSmartCommentsMutationResult = Apollo.MutationResult<ImportSmartCommentsMutation>;
export type ImportSmartCommentsMutationOptions = Apollo.BaseMutationOptions<ImportSmartCommentsMutation, ImportSmartCommentsMutationVariables>;
export const LinkCommentThreadDocument = gql`
    mutation LinkCommentThread($assessmentId: ID!, $threadId: ID!, $criterionId: Int!) {
  linkCommentThread(
    assessmentId: $assessmentId
    threadId: $threadId
    criterionId: $criterionId
  ) {
    id
    title
    entityType
    entityId
    criterionId
    createdBy {
      id
    }
    metadata {
      charterSectionType
      charterEditorId
    }
    comments {
      id
      content
      updatedAt
      createdBy {
        id
        name
        colourset
      }
    }
  }
}
    `;
export type LinkCommentThreadMutationFn = Apollo.MutationFunction<LinkCommentThreadMutation, LinkCommentThreadMutationVariables>;

/**
 * __useLinkCommentThreadMutation__
 *
 * To run a mutation, you first call `useLinkCommentThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkCommentThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkCommentThreadMutation, { data, loading, error }] = useLinkCommentThreadMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      threadId: // value for 'threadId'
 *      criterionId: // value for 'criterionId'
 *   },
 * });
 */
export function useLinkCommentThreadMutation(baseOptions?: Apollo.MutationHookOptions<LinkCommentThreadMutation, LinkCommentThreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkCommentThreadMutation, LinkCommentThreadMutationVariables>(LinkCommentThreadDocument, options);
      }
export type LinkCommentThreadMutationHookResult = ReturnType<typeof useLinkCommentThreadMutation>;
export type LinkCommentThreadMutationResult = Apollo.MutationResult<LinkCommentThreadMutation>;
export type LinkCommentThreadMutationOptions = Apollo.BaseMutationOptions<LinkCommentThreadMutation, LinkCommentThreadMutationVariables>;
export const MarkFieldOutcomeDocument = gql`
    mutation MarkFieldOutcome($assessmentId: ID!, $input: MarkFieldOutcomeInput!) {
  markFieldOutcome(assessmentId: $assessmentId, input: $input) {
    fieldOutcome {
      id
      score
      markerScore
      rubricOutcome {
        criterionOutcomes {
          ...CriterionOutcome
        }
        score
      }
    }
    questionOutcome {
      id
      scoreBreakdown {
        ...ScoreBreakdown
      }
    }
    workOutcome {
      id
      scoreBreakdown {
        ...ScoreBreakdown
      }
    }
  }
}
    ${CriterionOutcomeFragmentDoc}
${ScoreBreakdownFragmentDoc}`;
export type MarkFieldOutcomeMutationFn = Apollo.MutationFunction<MarkFieldOutcomeMutation, MarkFieldOutcomeMutationVariables>;

/**
 * __useMarkFieldOutcomeMutation__
 *
 * To run a mutation, you first call `useMarkFieldOutcomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkFieldOutcomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markFieldOutcomeMutation, { data, loading, error }] = useMarkFieldOutcomeMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkFieldOutcomeMutation(baseOptions?: Apollo.MutationHookOptions<MarkFieldOutcomeMutation, MarkFieldOutcomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkFieldOutcomeMutation, MarkFieldOutcomeMutationVariables>(MarkFieldOutcomeDocument, options);
      }
export type MarkFieldOutcomeMutationHookResult = ReturnType<typeof useMarkFieldOutcomeMutation>;
export type MarkFieldOutcomeMutationResult = Apollo.MutationResult<MarkFieldOutcomeMutation>;
export type MarkFieldOutcomeMutationOptions = Apollo.BaseMutationOptions<MarkFieldOutcomeMutation, MarkFieldOutcomeMutationVariables>;
export const MfaMarkingDocument = gql`
    query MfaMarking($assessmentId: ID!, $studentId: ID!) {
  studentWorkOutcome(assessmentId: $assessmentId, studentId: $studentId) {
    ...WorkOutcome
  }
  featureFlags(assessmentId: $assessmentId) {
    ...FeatureFlags
  }
}
    ${WorkOutcomeFragmentDoc}
${FeatureFlagsFragmentDoc}`;

/**
 * __useMfaMarkingQuery__
 *
 * To run a query within a React component, call `useMfaMarkingQuery` and pass it any options that fit your needs.
 * When your component renders, `useMfaMarkingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMfaMarkingQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useMfaMarkingQuery(baseOptions: Apollo.QueryHookOptions<MfaMarkingQuery, MfaMarkingQueryVariables> & ({ variables: MfaMarkingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MfaMarkingQuery, MfaMarkingQueryVariables>(MfaMarkingDocument, options);
      }
export function useMfaMarkingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MfaMarkingQuery, MfaMarkingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MfaMarkingQuery, MfaMarkingQueryVariables>(MfaMarkingDocument, options);
        }
export function useMfaMarkingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MfaMarkingQuery, MfaMarkingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MfaMarkingQuery, MfaMarkingQueryVariables>(MfaMarkingDocument, options);
        }
export type MfaMarkingQueryHookResult = ReturnType<typeof useMfaMarkingQuery>;
export type MfaMarkingLazyQueryHookResult = ReturnType<typeof useMfaMarkingLazyQuery>;
export type MfaMarkingSuspenseQueryHookResult = ReturnType<typeof useMfaMarkingSuspenseQuery>;
export type MfaMarkingQueryResult = Apollo.QueryResult<MfaMarkingQuery, MfaMarkingQueryVariables>;
export const MarkRouteDocument = gql`
    query MarkRoute($assessmentId: ID!) {
  token
  me {
    id
    email
  }
  assessment(assessmentId: $assessmentId) {
    ...Assessment
    tasks {
      id
      kind
      instructionSheet {
        ...MarkingSheet
      }
    }
  }
  class(assessmentId: $assessmentId) {
    groupType
    groups {
      ...Group
    }
    students {
      ...MarkEnrollment
    }
  }
  workOutcomes(assessmentId: $assessmentId) {
    ...WorkOutcomeMark
  }
  rubric(assessmentId: $assessmentId) {
    id
    questions {
      ...QuestionRubricWithCounts
    }
  }
}
    ${AssessmentFragmentDoc}
${MarkingSheetFragmentDoc}
${GroupFragmentDoc}
${MarkEnrollmentFragmentDoc}
${WorkOutcomeMarkFragmentDoc}
${QuestionRubricWithCountsFragmentDoc}`;

/**
 * __useMarkRouteQuery__
 *
 * To run a query within a React component, call `useMarkRouteQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarkRouteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarkRouteQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useMarkRouteQuery(baseOptions: Apollo.QueryHookOptions<MarkRouteQuery, MarkRouteQueryVariables> & ({ variables: MarkRouteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarkRouteQuery, MarkRouteQueryVariables>(MarkRouteDocument, options);
      }
export function useMarkRouteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarkRouteQuery, MarkRouteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarkRouteQuery, MarkRouteQueryVariables>(MarkRouteDocument, options);
        }
export function useMarkRouteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MarkRouteQuery, MarkRouteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MarkRouteQuery, MarkRouteQueryVariables>(MarkRouteDocument, options);
        }
export type MarkRouteQueryHookResult = ReturnType<typeof useMarkRouteQuery>;
export type MarkRouteLazyQueryHookResult = ReturnType<typeof useMarkRouteLazyQuery>;
export type MarkRouteSuspenseQueryHookResult = ReturnType<typeof useMarkRouteSuspenseQuery>;
export type MarkRouteQueryResult = Apollo.QueryResult<MarkRouteQuery, MarkRouteQueryVariables>;
export const MarkSubmissionOutcomeDocument = gql`
    mutation MarkSubmissionOutcome($assessmentId: ID!, $input: MarkSubmissionOutcomeInput!) {
  markSubmissionOutcome(assessmentId: $assessmentId, input: $input) {
    submissionOutcome {
      id
      score
      markerModifier
      rubricOutcome {
        criterionOutcomes {
          ...CriterionOutcome
        }
        score
      }
    }
    workOutcome {
      id
      scoreBreakdown {
        ...ScoreBreakdown
      }
    }
  }
}
    ${CriterionOutcomeFragmentDoc}
${ScoreBreakdownFragmentDoc}`;
export type MarkSubmissionOutcomeMutationFn = Apollo.MutationFunction<MarkSubmissionOutcomeMutation, MarkSubmissionOutcomeMutationVariables>;

/**
 * __useMarkSubmissionOutcomeMutation__
 *
 * To run a mutation, you first call `useMarkSubmissionOutcomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkSubmissionOutcomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markSubmissionOutcomeMutation, { data, loading, error }] = useMarkSubmissionOutcomeMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkSubmissionOutcomeMutation(baseOptions?: Apollo.MutationHookOptions<MarkSubmissionOutcomeMutation, MarkSubmissionOutcomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkSubmissionOutcomeMutation, MarkSubmissionOutcomeMutationVariables>(MarkSubmissionOutcomeDocument, options);
      }
export type MarkSubmissionOutcomeMutationHookResult = ReturnType<typeof useMarkSubmissionOutcomeMutation>;
export type MarkSubmissionOutcomeMutationResult = Apollo.MutationResult<MarkSubmissionOutcomeMutation>;
export type MarkSubmissionOutcomeMutationOptions = Apollo.BaseMutationOptions<MarkSubmissionOutcomeMutation, MarkSubmissionOutcomeMutationVariables>;
export const MarkerRubricByIdDocument = gql`
    query MarkerRubricById($markerRubricId: ID!) {
  markerRubricById(markerRubricId: $markerRubricId) {
    ...MarkerRubric
  }
}
    ${MarkerRubricFragmentDoc}`;

/**
 * __useMarkerRubricByIdQuery__
 *
 * To run a query within a React component, call `useMarkerRubricByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarkerRubricByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarkerRubricByIdQuery({
 *   variables: {
 *      markerRubricId: // value for 'markerRubricId'
 *   },
 * });
 */
export function useMarkerRubricByIdQuery(baseOptions: Apollo.QueryHookOptions<MarkerRubricByIdQuery, MarkerRubricByIdQueryVariables> & ({ variables: MarkerRubricByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarkerRubricByIdQuery, MarkerRubricByIdQueryVariables>(MarkerRubricByIdDocument, options);
      }
export function useMarkerRubricByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarkerRubricByIdQuery, MarkerRubricByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarkerRubricByIdQuery, MarkerRubricByIdQueryVariables>(MarkerRubricByIdDocument, options);
        }
export function useMarkerRubricByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MarkerRubricByIdQuery, MarkerRubricByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MarkerRubricByIdQuery, MarkerRubricByIdQueryVariables>(MarkerRubricByIdDocument, options);
        }
export type MarkerRubricByIdQueryHookResult = ReturnType<typeof useMarkerRubricByIdQuery>;
export type MarkerRubricByIdLazyQueryHookResult = ReturnType<typeof useMarkerRubricByIdLazyQuery>;
export type MarkerRubricByIdSuspenseQueryHookResult = ReturnType<typeof useMarkerRubricByIdSuspenseQuery>;
export type MarkerRubricByIdQueryResult = Apollo.QueryResult<MarkerRubricByIdQuery, MarkerRubricByIdQueryVariables>;
export const MarkerRubricDocument = gql`
    query MarkerRubric($assessmentId: ID!, $kind: MarkerRubricKind!, $status: MarkerRubricStatus!) {
  markerRubric(assessmentId: $assessmentId, kind: $kind, status: $status) {
    ...MarkerRubric
  }
}
    ${MarkerRubricFragmentDoc}`;

/**
 * __useMarkerRubricQuery__
 *
 * To run a query within a React component, call `useMarkerRubricQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarkerRubricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarkerRubricQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      kind: // value for 'kind'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useMarkerRubricQuery(baseOptions: Apollo.QueryHookOptions<MarkerRubricQuery, MarkerRubricQueryVariables> & ({ variables: MarkerRubricQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarkerRubricQuery, MarkerRubricQueryVariables>(MarkerRubricDocument, options);
      }
export function useMarkerRubricLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarkerRubricQuery, MarkerRubricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarkerRubricQuery, MarkerRubricQueryVariables>(MarkerRubricDocument, options);
        }
export function useMarkerRubricSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MarkerRubricQuery, MarkerRubricQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MarkerRubricQuery, MarkerRubricQueryVariables>(MarkerRubricDocument, options);
        }
export type MarkerRubricQueryHookResult = ReturnType<typeof useMarkerRubricQuery>;
export type MarkerRubricLazyQueryHookResult = ReturnType<typeof useMarkerRubricLazyQuery>;
export type MarkerRubricSuspenseQueryHookResult = ReturnType<typeof useMarkerRubricSuspenseQuery>;
export type MarkerRubricQueryResult = Apollo.QueryResult<MarkerRubricQuery, MarkerRubricQueryVariables>;
export const ModerationDocument = gql`
    query Moderation($assessmentId: ID!) {
  token
  me {
    id
  }
  assessment(assessmentId: $assessmentId) {
    ...Assessment
    tasks {
      id
      kind
      instructionSheet {
        ...MarkingSheet
      }
    }
  }
  class(assessmentId: $assessmentId) {
    groupType
    groups {
      ...Group
    }
    students {
      ...Enrollment
    }
  }
  classWorkGroups(assessmentId: $assessmentId) {
    ...WorkGroup
  }
  feedbackReleaseRules(assessmentId: $assessmentId) {
    ...FeedbackReleaseRule
  }
  moderationPenaltyRules(assessmentId: $assessmentId) {
    ...ModerationPenaltyRule
  }
  finalFeedbackVisibility: feedbackVisibilityForType(
    assessmentId: $assessmentId
    releaseType: FINAL
  ) {
    ...FeedbackVisibility
  }
  provisionalFeedbackVisibility: feedbackVisibilityForType(
    assessmentId: $assessmentId
    releaseType: PROVISIONAL
  ) {
    ...FeedbackVisibility
  }
  studentOutcomes(assessmentId: $assessmentId) {
    ...StudentOutcome
  }
  peerRubric(assessmentId: $assessmentId) {
    ...MarkerRubric
  }
}
    ${AssessmentFragmentDoc}
${MarkingSheetFragmentDoc}
${GroupFragmentDoc}
${EnrollmentFragmentDoc}
${WorkGroupFragmentDoc}
${FeedbackReleaseRuleFragmentDoc}
${ModerationPenaltyRuleFragmentDoc}
${FeedbackVisibilityFragmentDoc}
${StudentOutcomeFragmentDoc}
${MarkerRubricFragmentDoc}`;

/**
 * __useModerationQuery__
 *
 * To run a query within a React component, call `useModerationQuery` and pass it any options that fit your needs.
 * When your component renders, `useModerationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModerationQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useModerationQuery(baseOptions: Apollo.QueryHookOptions<ModerationQuery, ModerationQueryVariables> & ({ variables: ModerationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModerationQuery, ModerationQueryVariables>(ModerationDocument, options);
      }
export function useModerationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModerationQuery, ModerationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModerationQuery, ModerationQueryVariables>(ModerationDocument, options);
        }
export function useModerationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ModerationQuery, ModerationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ModerationQuery, ModerationQueryVariables>(ModerationDocument, options);
        }
export type ModerationQueryHookResult = ReturnType<typeof useModerationQuery>;
export type ModerationLazyQueryHookResult = ReturnType<typeof useModerationLazyQuery>;
export type ModerationSuspenseQueryHookResult = ReturnType<typeof useModerationSuspenseQuery>;
export type ModerationQueryResult = Apollo.QueryResult<ModerationQuery, ModerationQueryVariables>;
export const ModerationQuestionsDocument = gql`
    query ModerationQuestions($assessmentId: ID!, $taskKind: TaskKind) {
  moderationQuestions(assessmentId: $assessmentId, taskKind: $taskKind) {
    ...ModerationQuestion
  }
  assessmentQuestionScores(assessmentId: $assessmentId) {
    ...WorkOutcomeQuestionScores
  }
}
    ${ModerationQuestionFragmentDoc}
${WorkOutcomeQuestionScoresFragmentDoc}`;

/**
 * __useModerationQuestionsQuery__
 *
 * To run a query within a React component, call `useModerationQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useModerationQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModerationQuestionsQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      taskKind: // value for 'taskKind'
 *   },
 * });
 */
export function useModerationQuestionsQuery(baseOptions: Apollo.QueryHookOptions<ModerationQuestionsQuery, ModerationQuestionsQueryVariables> & ({ variables: ModerationQuestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModerationQuestionsQuery, ModerationQuestionsQueryVariables>(ModerationQuestionsDocument, options);
      }
export function useModerationQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModerationQuestionsQuery, ModerationQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModerationQuestionsQuery, ModerationQuestionsQueryVariables>(ModerationQuestionsDocument, options);
        }
export function useModerationQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ModerationQuestionsQuery, ModerationQuestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ModerationQuestionsQuery, ModerationQuestionsQueryVariables>(ModerationQuestionsDocument, options);
        }
export type ModerationQuestionsQueryHookResult = ReturnType<typeof useModerationQuestionsQuery>;
export type ModerationQuestionsLazyQueryHookResult = ReturnType<typeof useModerationQuestionsLazyQuery>;
export type ModerationQuestionsSuspenseQueryHookResult = ReturnType<typeof useModerationQuestionsSuspenseQuery>;
export type ModerationQuestionsQueryResult = Apollo.QueryResult<ModerationQuestionsQuery, ModerationQuestionsQueryVariables>;
export const ModeratorUpdateFieldRubricResponseDocument = gql`
    mutation ModeratorUpdateFieldRubricResponse($assessmentId: ID!, $input: UpdateFieldRubricInput!) {
  updateFieldRubricResponse(assessmentId: $assessmentId, input: $input) {
    fieldRubric {
      ...FieldRubric
      ...FieldRubricResponse
    }
    questionRubric {
      id
      counts {
        ...QuestionResponseCounts
      }
    }
    questionOutcomes {
      ...QuestionOutcomeScore
    }
    fieldOutcomes {
      ...FieldOutcomeScore
    }
    workOutcomes {
      ...WorkOutcomeScore
    }
  }
}
    ${FieldRubricFragmentDoc}
${FieldRubricResponseFragmentDoc}
${QuestionResponseCountsFragmentDoc}
${QuestionOutcomeScoreFragmentDoc}
${FieldOutcomeScoreFragmentDoc}
${WorkOutcomeScoreFragmentDoc}`;
export type ModeratorUpdateFieldRubricResponseMutationFn = Apollo.MutationFunction<ModeratorUpdateFieldRubricResponseMutation, ModeratorUpdateFieldRubricResponseMutationVariables>;

/**
 * __useModeratorUpdateFieldRubricResponseMutation__
 *
 * To run a mutation, you first call `useModeratorUpdateFieldRubricResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModeratorUpdateFieldRubricResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moderatorUpdateFieldRubricResponseMutation, { data, loading, error }] = useModeratorUpdateFieldRubricResponseMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useModeratorUpdateFieldRubricResponseMutation(baseOptions?: Apollo.MutationHookOptions<ModeratorUpdateFieldRubricResponseMutation, ModeratorUpdateFieldRubricResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ModeratorUpdateFieldRubricResponseMutation, ModeratorUpdateFieldRubricResponseMutationVariables>(ModeratorUpdateFieldRubricResponseDocument, options);
      }
export type ModeratorUpdateFieldRubricResponseMutationHookResult = ReturnType<typeof useModeratorUpdateFieldRubricResponseMutation>;
export type ModeratorUpdateFieldRubricResponseMutationResult = Apollo.MutationResult<ModeratorUpdateFieldRubricResponseMutation>;
export type ModeratorUpdateFieldRubricResponseMutationOptions = Apollo.BaseMutationOptions<ModeratorUpdateFieldRubricResponseMutation, ModeratorUpdateFieldRubricResponseMutationVariables>;
export const PastMarkerRubricDocument = gql`
    query PastMarkerRubric($markerRubricId: ID!) {
  pastMarkerRubric(markerRubricId: $markerRubricId) {
    ...MarkerRubric
  }
}
    ${MarkerRubricFragmentDoc}`;

/**
 * __usePastMarkerRubricQuery__
 *
 * To run a query within a React component, call `usePastMarkerRubricQuery` and pass it any options that fit your needs.
 * When your component renders, `usePastMarkerRubricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePastMarkerRubricQuery({
 *   variables: {
 *      markerRubricId: // value for 'markerRubricId'
 *   },
 * });
 */
export function usePastMarkerRubricQuery(baseOptions: Apollo.QueryHookOptions<PastMarkerRubricQuery, PastMarkerRubricQueryVariables> & ({ variables: PastMarkerRubricQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PastMarkerRubricQuery, PastMarkerRubricQueryVariables>(PastMarkerRubricDocument, options);
      }
export function usePastMarkerRubricLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PastMarkerRubricQuery, PastMarkerRubricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PastMarkerRubricQuery, PastMarkerRubricQueryVariables>(PastMarkerRubricDocument, options);
        }
export function usePastMarkerRubricSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PastMarkerRubricQuery, PastMarkerRubricQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PastMarkerRubricQuery, PastMarkerRubricQueryVariables>(PastMarkerRubricDocument, options);
        }
export type PastMarkerRubricQueryHookResult = ReturnType<typeof usePastMarkerRubricQuery>;
export type PastMarkerRubricLazyQueryHookResult = ReturnType<typeof usePastMarkerRubricLazyQuery>;
export type PastMarkerRubricSuspenseQueryHookResult = ReturnType<typeof usePastMarkerRubricSuspenseQuery>;
export type PastMarkerRubricQueryResult = Apollo.QueryResult<PastMarkerRubricQuery, PastMarkerRubricQueryVariables>;
export const PastMarkerRubricsDocument = gql`
    query PastMarkerRubrics($assessmentId: ID!) {
  pastMarkerRubrics(assessmentId: $assessmentId) {
    ...PastMarkerRubric
  }
}
    ${PastMarkerRubricFragmentDoc}`;

/**
 * __usePastMarkerRubricsQuery__
 *
 * To run a query within a React component, call `usePastMarkerRubricsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePastMarkerRubricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePastMarkerRubricsQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function usePastMarkerRubricsQuery(baseOptions: Apollo.QueryHookOptions<PastMarkerRubricsQuery, PastMarkerRubricsQueryVariables> & ({ variables: PastMarkerRubricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PastMarkerRubricsQuery, PastMarkerRubricsQueryVariables>(PastMarkerRubricsDocument, options);
      }
export function usePastMarkerRubricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PastMarkerRubricsQuery, PastMarkerRubricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PastMarkerRubricsQuery, PastMarkerRubricsQueryVariables>(PastMarkerRubricsDocument, options);
        }
export function usePastMarkerRubricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PastMarkerRubricsQuery, PastMarkerRubricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PastMarkerRubricsQuery, PastMarkerRubricsQueryVariables>(PastMarkerRubricsDocument, options);
        }
export type PastMarkerRubricsQueryHookResult = ReturnType<typeof usePastMarkerRubricsQuery>;
export type PastMarkerRubricsLazyQueryHookResult = ReturnType<typeof usePastMarkerRubricsLazyQuery>;
export type PastMarkerRubricsSuspenseQueryHookResult = ReturnType<typeof usePastMarkerRubricsSuspenseQuery>;
export type PastMarkerRubricsQueryResult = Apollo.QueryResult<PastMarkerRubricsQuery, PastMarkerRubricsQueryVariables>;
export const PublishMarkerRubricDocument = gql`
    mutation PublishMarkerRubric($markerRubricId: ID!) {
  publishMarkerRubric(markerRubricId: $markerRubricId) {
    ...MarkerRubric
  }
}
    ${MarkerRubricFragmentDoc}`;
export type PublishMarkerRubricMutationFn = Apollo.MutationFunction<PublishMarkerRubricMutation, PublishMarkerRubricMutationVariables>;

/**
 * __usePublishMarkerRubricMutation__
 *
 * To run a mutation, you first call `usePublishMarkerRubricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishMarkerRubricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishMarkerRubricMutation, { data, loading, error }] = usePublishMarkerRubricMutation({
 *   variables: {
 *      markerRubricId: // value for 'markerRubricId'
 *   },
 * });
 */
export function usePublishMarkerRubricMutation(baseOptions?: Apollo.MutationHookOptions<PublishMarkerRubricMutation, PublishMarkerRubricMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishMarkerRubricMutation, PublishMarkerRubricMutationVariables>(PublishMarkerRubricDocument, options);
      }
export type PublishMarkerRubricMutationHookResult = ReturnType<typeof usePublishMarkerRubricMutation>;
export type PublishMarkerRubricMutationResult = Apollo.MutationResult<PublishMarkerRubricMutation>;
export type PublishMarkerRubricMutationOptions = Apollo.BaseMutationOptions<PublishMarkerRubricMutation, PublishMarkerRubricMutationVariables>;
export const QuestionRubricDocument = gql`
    query QuestionRubric($questionRubricId: ID!) {
  questionRubric(questionRubricId: $questionRubricId) {
    fieldRubrics {
      ...FieldRubricResponse
    }
  }
}
    ${FieldRubricResponseFragmentDoc}`;

/**
 * __useQuestionRubricQuery__
 *
 * To run a query within a React component, call `useQuestionRubricQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuestionRubricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuestionRubricQuery({
 *   variables: {
 *      questionRubricId: // value for 'questionRubricId'
 *   },
 * });
 */
export function useQuestionRubricQuery(baseOptions: Apollo.QueryHookOptions<QuestionRubricQuery, QuestionRubricQueryVariables> & ({ variables: QuestionRubricQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuestionRubricQuery, QuestionRubricQueryVariables>(QuestionRubricDocument, options);
      }
export function useQuestionRubricLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuestionRubricQuery, QuestionRubricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuestionRubricQuery, QuestionRubricQueryVariables>(QuestionRubricDocument, options);
        }
export function useQuestionRubricSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QuestionRubricQuery, QuestionRubricQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QuestionRubricQuery, QuestionRubricQueryVariables>(QuestionRubricDocument, options);
        }
export type QuestionRubricQueryHookResult = ReturnType<typeof useQuestionRubricQuery>;
export type QuestionRubricLazyQueryHookResult = ReturnType<typeof useQuestionRubricLazyQuery>;
export type QuestionRubricSuspenseQueryHookResult = ReturnType<typeof useQuestionRubricSuspenseQuery>;
export type QuestionRubricQueryResult = Apollo.QueryResult<QuestionRubricQuery, QuestionRubricQueryVariables>;
export const ReleaseFeedbackForEveryoneDocument = gql`
    mutation ReleaseFeedbackForEveryone($assessmentId: ID!, $feedbackVisibility: FeedbackVisibilityInput, $releaseType: FeedbackReleaseType) {
  releaseFeedbackForEveryone(
    assessmentId: $assessmentId
    feedbackVisibility: $feedbackVisibility
    releaseType: $releaseType
  ) {
    feedbackReleaseRules {
      ...FeedbackReleaseRule
    }
    studentOutcomes {
      ...StudentOutcome
    }
  }
}
    ${FeedbackReleaseRuleFragmentDoc}
${StudentOutcomeFragmentDoc}`;
export type ReleaseFeedbackForEveryoneMutationFn = Apollo.MutationFunction<ReleaseFeedbackForEveryoneMutation, ReleaseFeedbackForEveryoneMutationVariables>;

/**
 * __useReleaseFeedbackForEveryoneMutation__
 *
 * To run a mutation, you first call `useReleaseFeedbackForEveryoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReleaseFeedbackForEveryoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [releaseFeedbackForEveryoneMutation, { data, loading, error }] = useReleaseFeedbackForEveryoneMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      feedbackVisibility: // value for 'feedbackVisibility'
 *      releaseType: // value for 'releaseType'
 *   },
 * });
 */
export function useReleaseFeedbackForEveryoneMutation(baseOptions?: Apollo.MutationHookOptions<ReleaseFeedbackForEveryoneMutation, ReleaseFeedbackForEveryoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReleaseFeedbackForEveryoneMutation, ReleaseFeedbackForEveryoneMutationVariables>(ReleaseFeedbackForEveryoneDocument, options);
      }
export type ReleaseFeedbackForEveryoneMutationHookResult = ReturnType<typeof useReleaseFeedbackForEveryoneMutation>;
export type ReleaseFeedbackForEveryoneMutationResult = Apollo.MutationResult<ReleaseFeedbackForEveryoneMutation>;
export type ReleaseFeedbackForEveryoneMutationOptions = Apollo.BaseMutationOptions<ReleaseFeedbackForEveryoneMutation, ReleaseFeedbackForEveryoneMutationVariables>;
export const RemoveMarkerRubricDocument = gql`
    mutation RemoveMarkerRubric($markerRubricId: ID!) {
  removeMarkerRubric(markerRubricId: $markerRubricId) {
    id
  }
}
    `;
export type RemoveMarkerRubricMutationFn = Apollo.MutationFunction<RemoveMarkerRubricMutation, RemoveMarkerRubricMutationVariables>;

/**
 * __useRemoveMarkerRubricMutation__
 *
 * To run a mutation, you first call `useRemoveMarkerRubricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMarkerRubricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMarkerRubricMutation, { data, loading, error }] = useRemoveMarkerRubricMutation({
 *   variables: {
 *      markerRubricId: // value for 'markerRubricId'
 *   },
 * });
 */
export function useRemoveMarkerRubricMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMarkerRubricMutation, RemoveMarkerRubricMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMarkerRubricMutation, RemoveMarkerRubricMutationVariables>(RemoveMarkerRubricDocument, options);
      }
export type RemoveMarkerRubricMutationHookResult = ReturnType<typeof useRemoveMarkerRubricMutation>;
export type RemoveMarkerRubricMutationResult = Apollo.MutationResult<RemoveMarkerRubricMutation>;
export type RemoveMarkerRubricMutationOptions = Apollo.BaseMutationOptions<RemoveMarkerRubricMutation, RemoveMarkerRubricMutationVariables>;
export const ResetFeedbackReleaseRuleDocument = gql`
    mutation ResetFeedbackReleaseRule($assessmentId: ID!, $releaseType: FeedbackReleaseType) {
  resetFeedbackReleaseRules(
    assessmentId: $assessmentId
    releaseType: $releaseType
  ) {
    ...FeedbackReleaseRule
  }
}
    ${FeedbackReleaseRuleFragmentDoc}`;
export type ResetFeedbackReleaseRuleMutationFn = Apollo.MutationFunction<ResetFeedbackReleaseRuleMutation, ResetFeedbackReleaseRuleMutationVariables>;

/**
 * __useResetFeedbackReleaseRuleMutation__
 *
 * To run a mutation, you first call `useResetFeedbackReleaseRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetFeedbackReleaseRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetFeedbackReleaseRuleMutation, { data, loading, error }] = useResetFeedbackReleaseRuleMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      releaseType: // value for 'releaseType'
 *   },
 * });
 */
export function useResetFeedbackReleaseRuleMutation(baseOptions?: Apollo.MutationHookOptions<ResetFeedbackReleaseRuleMutation, ResetFeedbackReleaseRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetFeedbackReleaseRuleMutation, ResetFeedbackReleaseRuleMutationVariables>(ResetFeedbackReleaseRuleDocument, options);
      }
export type ResetFeedbackReleaseRuleMutationHookResult = ReturnType<typeof useResetFeedbackReleaseRuleMutation>;
export type ResetFeedbackReleaseRuleMutationResult = Apollo.MutationResult<ResetFeedbackReleaseRuleMutation>;
export type ResetFeedbackReleaseRuleMutationOptions = Apollo.BaseMutationOptions<ResetFeedbackReleaseRuleMutation, ResetFeedbackReleaseRuleMutationVariables>;
export const ResetQuestionModerationChangesDocument = gql`
    mutation ResetQuestionModerationChanges($assessmentId: ID!) {
  resetQuestionModerationChanges(assessmentId: $assessmentId) {
    fieldRubrics {
      ...FieldRubric
      ...FieldRubricResponse
    }
    studentOutcomes {
      ...StudentOutcome
    }
    questionOutcomes {
      ...QuestionOutcomeScore
    }
    questionRubrics {
      id
      counts {
        ...QuestionResponseCounts
      }
    }
  }
}
    ${FieldRubricFragmentDoc}
${FieldRubricResponseFragmentDoc}
${StudentOutcomeFragmentDoc}
${QuestionOutcomeScoreFragmentDoc}
${QuestionResponseCountsFragmentDoc}`;
export type ResetQuestionModerationChangesMutationFn = Apollo.MutationFunction<ResetQuestionModerationChangesMutation, ResetQuestionModerationChangesMutationVariables>;

/**
 * __useResetQuestionModerationChangesMutation__
 *
 * To run a mutation, you first call `useResetQuestionModerationChangesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetQuestionModerationChangesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetQuestionModerationChangesMutation, { data, loading, error }] = useResetQuestionModerationChangesMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useResetQuestionModerationChangesMutation(baseOptions?: Apollo.MutationHookOptions<ResetQuestionModerationChangesMutation, ResetQuestionModerationChangesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetQuestionModerationChangesMutation, ResetQuestionModerationChangesMutationVariables>(ResetQuestionModerationChangesDocument, options);
      }
export type ResetQuestionModerationChangesMutationHookResult = ReturnType<typeof useResetQuestionModerationChangesMutation>;
export type ResetQuestionModerationChangesMutationResult = Apollo.MutationResult<ResetQuestionModerationChangesMutation>;
export type ResetQuestionModerationChangesMutationOptions = Apollo.BaseMutationOptions<ResetQuestionModerationChangesMutation, ResetQuestionModerationChangesMutationVariables>;
export const ResetRubricOutcomeForFieldDocument = gql`
    mutation ResetRubricOutcomeForField($assessmentId: ID!, $markerRubricId: ID!, $fieldOutcomeId: ID!) {
  resetRubricOutcomeForField(
    assessmentId: $assessmentId
    markerRubricId: $markerRubricId
    fieldOutcomeId: $fieldOutcomeId
  ) {
    fieldOutcome {
      id
      score
      markerScore
      rubricOutcome {
        criterionOutcomes {
          ...CriterionOutcome
        }
        score
      }
    }
    questionOutcome {
      id
      scoreBreakdown {
        ...ScoreBreakdown
      }
    }
    workOutcome {
      id
      scoreBreakdown {
        ...ScoreBreakdown
      }
    }
    criterionOutcomesDeleted
  }
}
    ${CriterionOutcomeFragmentDoc}
${ScoreBreakdownFragmentDoc}`;
export type ResetRubricOutcomeForFieldMutationFn = Apollo.MutationFunction<ResetRubricOutcomeForFieldMutation, ResetRubricOutcomeForFieldMutationVariables>;

/**
 * __useResetRubricOutcomeForFieldMutation__
 *
 * To run a mutation, you first call `useResetRubricOutcomeForFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetRubricOutcomeForFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetRubricOutcomeForFieldMutation, { data, loading, error }] = useResetRubricOutcomeForFieldMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      markerRubricId: // value for 'markerRubricId'
 *      fieldOutcomeId: // value for 'fieldOutcomeId'
 *   },
 * });
 */
export function useResetRubricOutcomeForFieldMutation(baseOptions?: Apollo.MutationHookOptions<ResetRubricOutcomeForFieldMutation, ResetRubricOutcomeForFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetRubricOutcomeForFieldMutation, ResetRubricOutcomeForFieldMutationVariables>(ResetRubricOutcomeForFieldDocument, options);
      }
export type ResetRubricOutcomeForFieldMutationHookResult = ReturnType<typeof useResetRubricOutcomeForFieldMutation>;
export type ResetRubricOutcomeForFieldMutationResult = Apollo.MutationResult<ResetRubricOutcomeForFieldMutation>;
export type ResetRubricOutcomeForFieldMutationOptions = Apollo.BaseMutationOptions<ResetRubricOutcomeForFieldMutation, ResetRubricOutcomeForFieldMutationVariables>;
export const ResetRubricOutcomeForSubmissionDocument = gql`
    mutation ResetRubricOutcomeForSubmission($assessmentId: ID!, $markerRubricId: ID!, $submissionOutcomeId: ID!) {
  resetRubricOutcomeForSubmission(
    assessmentId: $assessmentId
    markerRubricId: $markerRubricId
    submissionOutcomeId: $submissionOutcomeId
  ) {
    submissionOutcome {
      id
      score
      markerModifier
      rubricOutcome {
        criterionOutcomes {
          ...CriterionOutcome
        }
        score
      }
    }
    workOutcome {
      id
      scoreBreakdown {
        ...ScoreBreakdown
      }
    }
    criterionOutcomesDeleted
  }
}
    ${CriterionOutcomeFragmentDoc}
${ScoreBreakdownFragmentDoc}`;
export type ResetRubricOutcomeForSubmissionMutationFn = Apollo.MutationFunction<ResetRubricOutcomeForSubmissionMutation, ResetRubricOutcomeForSubmissionMutationVariables>;

/**
 * __useResetRubricOutcomeForSubmissionMutation__
 *
 * To run a mutation, you first call `useResetRubricOutcomeForSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetRubricOutcomeForSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetRubricOutcomeForSubmissionMutation, { data, loading, error }] = useResetRubricOutcomeForSubmissionMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      markerRubricId: // value for 'markerRubricId'
 *      submissionOutcomeId: // value for 'submissionOutcomeId'
 *   },
 * });
 */
export function useResetRubricOutcomeForSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<ResetRubricOutcomeForSubmissionMutation, ResetRubricOutcomeForSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetRubricOutcomeForSubmissionMutation, ResetRubricOutcomeForSubmissionMutationVariables>(ResetRubricOutcomeForSubmissionDocument, options);
      }
export type ResetRubricOutcomeForSubmissionMutationHookResult = ReturnType<typeof useResetRubricOutcomeForSubmissionMutation>;
export type ResetRubricOutcomeForSubmissionMutationResult = Apollo.MutationResult<ResetRubricOutcomeForSubmissionMutation>;
export type ResetRubricOutcomeForSubmissionMutationOptions = Apollo.BaseMutationOptions<ResetRubricOutcomeForSubmissionMutation, ResetRubricOutcomeForSubmissionMutationVariables>;
export const ResetRubricOutcomeDocument = gql`
    mutation ResetRubricOutcome($markerRubricId: ID!, $criteriaId: ID) {
  resetRubricOutcome(markerRubricId: $markerRubricId, criteriaId: $criteriaId) {
    criteria {
      id
      hasOutcomes
    }
  }
}
    `;
export type ResetRubricOutcomeMutationFn = Apollo.MutationFunction<ResetRubricOutcomeMutation, ResetRubricOutcomeMutationVariables>;

/**
 * __useResetRubricOutcomeMutation__
 *
 * To run a mutation, you first call `useResetRubricOutcomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetRubricOutcomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetRubricOutcomeMutation, { data, loading, error }] = useResetRubricOutcomeMutation({
 *   variables: {
 *      markerRubricId: // value for 'markerRubricId'
 *      criteriaId: // value for 'criteriaId'
 *   },
 * });
 */
export function useResetRubricOutcomeMutation(baseOptions?: Apollo.MutationHookOptions<ResetRubricOutcomeMutation, ResetRubricOutcomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetRubricOutcomeMutation, ResetRubricOutcomeMutationVariables>(ResetRubricOutcomeDocument, options);
      }
export type ResetRubricOutcomeMutationHookResult = ReturnType<typeof useResetRubricOutcomeMutation>;
export type ResetRubricOutcomeMutationResult = Apollo.MutationResult<ResetRubricOutcomeMutation>;
export type ResetRubricOutcomeMutationOptions = Apollo.BaseMutationOptions<ResetRubricOutcomeMutation, ResetRubricOutcomeMutationVariables>;
export const ResetScoreModerationChangesDocument = gql`
    mutation ResetScoreModerationChanges($assessmentId: ID!) {
  resetScoreModerationChanges(assessmentId: $assessmentId) {
    studentOutcomes {
      ...StudentOutcome
    }
    workOutcomes {
      id
      scoreBreakdown {
        ...ScoreBreakdown
      }
    }
  }
}
    ${StudentOutcomeFragmentDoc}
${ScoreBreakdownFragmentDoc}`;
export type ResetScoreModerationChangesMutationFn = Apollo.MutationFunction<ResetScoreModerationChangesMutation, ResetScoreModerationChangesMutationVariables>;

/**
 * __useResetScoreModerationChangesMutation__
 *
 * To run a mutation, you first call `useResetScoreModerationChangesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetScoreModerationChangesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetScoreModerationChangesMutation, { data, loading, error }] = useResetScoreModerationChangesMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useResetScoreModerationChangesMutation(baseOptions?: Apollo.MutationHookOptions<ResetScoreModerationChangesMutation, ResetScoreModerationChangesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetScoreModerationChangesMutation, ResetScoreModerationChangesMutationVariables>(ResetScoreModerationChangesDocument, options);
      }
export type ResetScoreModerationChangesMutationHookResult = ReturnType<typeof useResetScoreModerationChangesMutation>;
export type ResetScoreModerationChangesMutationResult = Apollo.MutationResult<ResetScoreModerationChangesMutation>;
export type ResetScoreModerationChangesMutationOptions = Apollo.BaseMutationOptions<ResetScoreModerationChangesMutation, ResetScoreModerationChangesMutationVariables>;
export const SaveMarkerRubricDocument = gql`
    mutation saveMarkerRubric($markerRubricId: ID!, $input: MarkerRubricInput!) {
  saveMarkerRubric(markerRubricId: $markerRubricId, input: $input) {
    ...MarkerRubric
  }
}
    ${MarkerRubricFragmentDoc}`;
export type SaveMarkerRubricMutationFn = Apollo.MutationFunction<SaveMarkerRubricMutation, SaveMarkerRubricMutationVariables>;

/**
 * __useSaveMarkerRubricMutation__
 *
 * To run a mutation, you first call `useSaveMarkerRubricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveMarkerRubricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveMarkerRubricMutation, { data, loading, error }] = useSaveMarkerRubricMutation({
 *   variables: {
 *      markerRubricId: // value for 'markerRubricId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveMarkerRubricMutation(baseOptions?: Apollo.MutationHookOptions<SaveMarkerRubricMutation, SaveMarkerRubricMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveMarkerRubricMutation, SaveMarkerRubricMutationVariables>(SaveMarkerRubricDocument, options);
      }
export type SaveMarkerRubricMutationHookResult = ReturnType<typeof useSaveMarkerRubricMutation>;
export type SaveMarkerRubricMutationResult = Apollo.MutationResult<SaveMarkerRubricMutation>;
export type SaveMarkerRubricMutationOptions = Apollo.BaseMutationOptions<SaveMarkerRubricMutation, SaveMarkerRubricMutationVariables>;
export const SetMarkerAdjustmentDocument = gql`
    mutation SetMarkerAdjustment($workId: ID!, $studentId: ID!, $value: Decimal!, $note: String) {
  setMarkerAdjustment(
    workId: $workId
    studentId: $studentId
    value: $value
    note: $note
  ) {
    studentOutcome {
      id
      studentId
      modifiers {
        id
        type
        component
        value
        note
        addedByUserId
        addedAt
      }
    }
  }
}
    `;
export type SetMarkerAdjustmentMutationFn = Apollo.MutationFunction<SetMarkerAdjustmentMutation, SetMarkerAdjustmentMutationVariables>;

/**
 * __useSetMarkerAdjustmentMutation__
 *
 * To run a mutation, you first call `useSetMarkerAdjustmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMarkerAdjustmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMarkerAdjustmentMutation, { data, loading, error }] = useSetMarkerAdjustmentMutation({
 *   variables: {
 *      workId: // value for 'workId'
 *      studentId: // value for 'studentId'
 *      value: // value for 'value'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useSetMarkerAdjustmentMutation(baseOptions?: Apollo.MutationHookOptions<SetMarkerAdjustmentMutation, SetMarkerAdjustmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMarkerAdjustmentMutation, SetMarkerAdjustmentMutationVariables>(SetMarkerAdjustmentDocument, options);
      }
export type SetMarkerAdjustmentMutationHookResult = ReturnType<typeof useSetMarkerAdjustmentMutation>;
export type SetMarkerAdjustmentMutationResult = Apollo.MutationResult<SetMarkerAdjustmentMutation>;
export type SetMarkerAdjustmentMutationOptions = Apollo.BaseMutationOptions<SetMarkerAdjustmentMutation, SetMarkerAdjustmentMutationVariables>;
export const SimilarityDocument = gql`
    query Similarity($submissionType: SubmissionType!, $workId: ID!) {
  latestResult(submissionType: $submissionType, workId: $workId) {
    id
    workId
    heraResultId
    similarity {
      display
      label
      value
    }
  }
}
    `;

/**
 * __useSimilarityQuery__
 *
 * To run a query within a React component, call `useSimilarityQuery` and pass it any options that fit your needs.
 * When your component renders, `useSimilarityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSimilarityQuery({
 *   variables: {
 *      submissionType: // value for 'submissionType'
 *      workId: // value for 'workId'
 *   },
 * });
 */
export function useSimilarityQuery(baseOptions: Apollo.QueryHookOptions<SimilarityQuery, SimilarityQueryVariables> & ({ variables: SimilarityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SimilarityQuery, SimilarityQueryVariables>(SimilarityDocument, options);
      }
export function useSimilarityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SimilarityQuery, SimilarityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SimilarityQuery, SimilarityQueryVariables>(SimilarityDocument, options);
        }
export function useSimilaritySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SimilarityQuery, SimilarityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SimilarityQuery, SimilarityQueryVariables>(SimilarityDocument, options);
        }
export type SimilarityQueryHookResult = ReturnType<typeof useSimilarityQuery>;
export type SimilarityLazyQueryHookResult = ReturnType<typeof useSimilarityLazyQuery>;
export type SimilaritySuspenseQueryHookResult = ReturnType<typeof useSimilaritySuspenseQuery>;
export type SimilarityQueryResult = Apollo.QueryResult<SimilarityQuery, SimilarityQueryVariables>;
export const SkillsDocument = gql`
    query Skills {
  skills {
    ...Skill
  }
}
    ${SkillFragmentDoc}`;

/**
 * __useSkillsQuery__
 *
 * To run a query within a React component, call `useSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSkillsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSkillsQuery(baseOptions?: Apollo.QueryHookOptions<SkillsQuery, SkillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SkillsQuery, SkillsQueryVariables>(SkillsDocument, options);
      }
export function useSkillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SkillsQuery, SkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SkillsQuery, SkillsQueryVariables>(SkillsDocument, options);
        }
export function useSkillsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SkillsQuery, SkillsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SkillsQuery, SkillsQueryVariables>(SkillsDocument, options);
        }
export type SkillsQueryHookResult = ReturnType<typeof useSkillsQuery>;
export type SkillsLazyQueryHookResult = ReturnType<typeof useSkillsLazyQuery>;
export type SkillsSuspenseQueryHookResult = ReturnType<typeof useSkillsSuspenseQuery>;
export type SkillsQueryResult = Apollo.QueryResult<SkillsQuery, SkillsQueryVariables>;
export const SmartCommentsBySkillsDocument = gql`
    query SmartCommentsBySkills($skillIds: [ID!]!, $rangeFrom: Int, $rangeTo: Int, $maxScore: Int) {
  smartCommentsBySkills(
    skillIds: $skillIds
    rangeFrom: $rangeFrom
    rangeTo: $rangeTo
    maxScore: $maxScore
  ) {
    ...SmartComment
  }
}
    ${SmartCommentFragmentDoc}`;

/**
 * __useSmartCommentsBySkillsQuery__
 *
 * To run a query within a React component, call `useSmartCommentsBySkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSmartCommentsBySkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSmartCommentsBySkillsQuery({
 *   variables: {
 *      skillIds: // value for 'skillIds'
 *      rangeFrom: // value for 'rangeFrom'
 *      rangeTo: // value for 'rangeTo'
 *      maxScore: // value for 'maxScore'
 *   },
 * });
 */
export function useSmartCommentsBySkillsQuery(baseOptions: Apollo.QueryHookOptions<SmartCommentsBySkillsQuery, SmartCommentsBySkillsQueryVariables> & ({ variables: SmartCommentsBySkillsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SmartCommentsBySkillsQuery, SmartCommentsBySkillsQueryVariables>(SmartCommentsBySkillsDocument, options);
      }
export function useSmartCommentsBySkillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SmartCommentsBySkillsQuery, SmartCommentsBySkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SmartCommentsBySkillsQuery, SmartCommentsBySkillsQueryVariables>(SmartCommentsBySkillsDocument, options);
        }
export function useSmartCommentsBySkillsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SmartCommentsBySkillsQuery, SmartCommentsBySkillsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SmartCommentsBySkillsQuery, SmartCommentsBySkillsQueryVariables>(SmartCommentsBySkillsDocument, options);
        }
export type SmartCommentsBySkillsQueryHookResult = ReturnType<typeof useSmartCommentsBySkillsQuery>;
export type SmartCommentsBySkillsLazyQueryHookResult = ReturnType<typeof useSmartCommentsBySkillsLazyQuery>;
export type SmartCommentsBySkillsSuspenseQueryHookResult = ReturnType<typeof useSmartCommentsBySkillsSuspenseQuery>;
export type SmartCommentsBySkillsQueryResult = Apollo.QueryResult<SmartCommentsBySkillsQuery, SmartCommentsBySkillsQueryVariables>;
export const SnapshotFieldOutcomeDocument = gql`
    mutation snapshotFieldOutcome($fieldOutcomeId: ID!, $input: SnapshotFieldOutcomeInput!) {
  snapshotFieldOutcome(fieldOutcomeId: $fieldOutcomeId, input: $input) {
    ...FieldOutcome
  }
}
    ${FieldOutcomeFragmentDoc}`;
export type SnapshotFieldOutcomeMutationFn = Apollo.MutationFunction<SnapshotFieldOutcomeMutation, SnapshotFieldOutcomeMutationVariables>;

/**
 * __useSnapshotFieldOutcomeMutation__
 *
 * To run a mutation, you first call `useSnapshotFieldOutcomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSnapshotFieldOutcomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [snapshotFieldOutcomeMutation, { data, loading, error }] = useSnapshotFieldOutcomeMutation({
 *   variables: {
 *      fieldOutcomeId: // value for 'fieldOutcomeId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSnapshotFieldOutcomeMutation(baseOptions?: Apollo.MutationHookOptions<SnapshotFieldOutcomeMutation, SnapshotFieldOutcomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SnapshotFieldOutcomeMutation, SnapshotFieldOutcomeMutationVariables>(SnapshotFieldOutcomeDocument, options);
      }
export type SnapshotFieldOutcomeMutationHookResult = ReturnType<typeof useSnapshotFieldOutcomeMutation>;
export type SnapshotFieldOutcomeMutationResult = Apollo.MutationResult<SnapshotFieldOutcomeMutation>;
export type SnapshotFieldOutcomeMutationOptions = Apollo.BaseMutationOptions<SnapshotFieldOutcomeMutation, SnapshotFieldOutcomeMutationVariables>;
export const SnapshotSubmissionOutcomeDocument = gql`
    mutation snapshotSubmissionOutcome($submissionOutcomeId: ID!, $input: SnapshotSubmissionOutcomeInput!) {
  snapshotSubmissionOutcome(
    submissionOutcomeId: $submissionOutcomeId
    input: $input
  ) {
    ...SubmissionOutcome
  }
}
    ${SubmissionOutcomeFragmentDoc}`;
export type SnapshotSubmissionOutcomeMutationFn = Apollo.MutationFunction<SnapshotSubmissionOutcomeMutation, SnapshotSubmissionOutcomeMutationVariables>;

/**
 * __useSnapshotSubmissionOutcomeMutation__
 *
 * To run a mutation, you first call `useSnapshotSubmissionOutcomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSnapshotSubmissionOutcomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [snapshotSubmissionOutcomeMutation, { data, loading, error }] = useSnapshotSubmissionOutcomeMutation({
 *   variables: {
 *      submissionOutcomeId: // value for 'submissionOutcomeId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSnapshotSubmissionOutcomeMutation(baseOptions?: Apollo.MutationHookOptions<SnapshotSubmissionOutcomeMutation, SnapshotSubmissionOutcomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SnapshotSubmissionOutcomeMutation, SnapshotSubmissionOutcomeMutationVariables>(SnapshotSubmissionOutcomeDocument, options);
      }
export type SnapshotSubmissionOutcomeMutationHookResult = ReturnType<typeof useSnapshotSubmissionOutcomeMutation>;
export type SnapshotSubmissionOutcomeMutationResult = Apollo.MutationResult<SnapshotSubmissionOutcomeMutation>;
export type SnapshotSubmissionOutcomeMutationOptions = Apollo.BaseMutationOptions<SnapshotSubmissionOutcomeMutation, SnapshotSubmissionOutcomeMutationVariables>;
export const StudentEnrollmentsDocument = gql`
    query StudentEnrollments($assessmentId: ID!, $studentId: ID!) {
  studentEnrollments(
    assessmentId: $assessmentId
    studentIds: [$studentId]
    withDeleted: false
  ) {
    ...Enrollment
  }
}
    ${EnrollmentFragmentDoc}`;

/**
 * __useStudentEnrollmentsQuery__
 *
 * To run a query within a React component, call `useStudentEnrollmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentEnrollmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentEnrollmentsQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useStudentEnrollmentsQuery(baseOptions: Apollo.QueryHookOptions<StudentEnrollmentsQuery, StudentEnrollmentsQueryVariables> & ({ variables: StudentEnrollmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentEnrollmentsQuery, StudentEnrollmentsQueryVariables>(StudentEnrollmentsDocument, options);
      }
export function useStudentEnrollmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentEnrollmentsQuery, StudentEnrollmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentEnrollmentsQuery, StudentEnrollmentsQueryVariables>(StudentEnrollmentsDocument, options);
        }
export function useStudentEnrollmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StudentEnrollmentsQuery, StudentEnrollmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StudentEnrollmentsQuery, StudentEnrollmentsQueryVariables>(StudentEnrollmentsDocument, options);
        }
export type StudentEnrollmentsQueryHookResult = ReturnType<typeof useStudentEnrollmentsQuery>;
export type StudentEnrollmentsLazyQueryHookResult = ReturnType<typeof useStudentEnrollmentsLazyQuery>;
export type StudentEnrollmentsSuspenseQueryHookResult = ReturnType<typeof useStudentEnrollmentsSuspenseQuery>;
export type StudentEnrollmentsQueryResult = Apollo.QueryResult<StudentEnrollmentsQuery, StudentEnrollmentsQueryVariables>;
export const StudentOutcomesDocument = gql`
    query StudentOutcomes($assessmentId: ID!) {
  studentOutcomes(assessmentId: $assessmentId) {
    ...StudentOutcome
  }
}
    ${StudentOutcomeFragmentDoc}`;

/**
 * __useStudentOutcomesQuery__
 *
 * To run a query within a React component, call `useStudentOutcomesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentOutcomesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentOutcomesQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useStudentOutcomesQuery(baseOptions: Apollo.QueryHookOptions<StudentOutcomesQuery, StudentOutcomesQueryVariables> & ({ variables: StudentOutcomesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentOutcomesQuery, StudentOutcomesQueryVariables>(StudentOutcomesDocument, options);
      }
export function useStudentOutcomesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentOutcomesQuery, StudentOutcomesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentOutcomesQuery, StudentOutcomesQueryVariables>(StudentOutcomesDocument, options);
        }
export function useStudentOutcomesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StudentOutcomesQuery, StudentOutcomesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StudentOutcomesQuery, StudentOutcomesQueryVariables>(StudentOutcomesDocument, options);
        }
export type StudentOutcomesQueryHookResult = ReturnType<typeof useStudentOutcomesQuery>;
export type StudentOutcomesLazyQueryHookResult = ReturnType<typeof useStudentOutcomesLazyQuery>;
export type StudentOutcomesSuspenseQueryHookResult = ReturnType<typeof useStudentOutcomesSuspenseQuery>;
export type StudentOutcomesQueryResult = Apollo.QueryResult<StudentOutcomesQuery, StudentOutcomesQueryVariables>;
export const StudentOutcomesUpdatedDocument = gql`
    subscription StudentOutcomesUpdated($assessmentId: ID!) {
  studentOutcomesUpdated(assessmentId: $assessmentId) {
    id
    studentId
    groupWorkOutcome {
      ...WorkOutcomeUpdated
    }
    individualWorkOutcome {
      ...WorkOutcomeUpdated
    }
    base {
      ...ComponentBreakdown
    }
    provisional {
      ...ComponentBreakdown
    }
    final {
      ...ComponentBreakdown
    }
  }
}
    ${WorkOutcomeUpdatedFragmentDoc}
${ComponentBreakdownFragmentDoc}`;

/**
 * __useStudentOutcomesUpdatedSubscription__
 *
 * To run a query within a React component, call `useStudentOutcomesUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useStudentOutcomesUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentOutcomesUpdatedSubscription({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useStudentOutcomesUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<StudentOutcomesUpdatedSubscription, StudentOutcomesUpdatedSubscriptionVariables> & ({ variables: StudentOutcomesUpdatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<StudentOutcomesUpdatedSubscription, StudentOutcomesUpdatedSubscriptionVariables>(StudentOutcomesUpdatedDocument, options);
      }
export type StudentOutcomesUpdatedSubscriptionHookResult = ReturnType<typeof useStudentOutcomesUpdatedSubscription>;
export type StudentOutcomesUpdatedSubscriptionResult = Apollo.SubscriptionResult<StudentOutcomesUpdatedSubscription>;
export const TimelineContributionDocument = gql`
    query TimelineContribution($assessmentId: ID!, $answerBlockId: ID!, $asOfVersion: Int, $includeDeletions: Boolean!, $from: Int, $to: Int) {
  contribution(
    assessmentId: $assessmentId
    answerBlockId: $answerBlockId
    asOfVersion: $asOfVersion
    from: $from
    to: $to
    includeDeletions: $includeDeletions
  ) {
    ...ContributionFields
  }
}
    ${ContributionFieldsFragmentDoc}`;

/**
 * __useTimelineContributionQuery__
 *
 * To run a query within a React component, call `useTimelineContributionQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimelineContributionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimelineContributionQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      answerBlockId: // value for 'answerBlockId'
 *      asOfVersion: // value for 'asOfVersion'
 *      includeDeletions: // value for 'includeDeletions'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useTimelineContributionQuery(baseOptions: Apollo.QueryHookOptions<TimelineContributionQuery, TimelineContributionQueryVariables> & ({ variables: TimelineContributionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimelineContributionQuery, TimelineContributionQueryVariables>(TimelineContributionDocument, options);
      }
export function useTimelineContributionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimelineContributionQuery, TimelineContributionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimelineContributionQuery, TimelineContributionQueryVariables>(TimelineContributionDocument, options);
        }
export function useTimelineContributionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TimelineContributionQuery, TimelineContributionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TimelineContributionQuery, TimelineContributionQueryVariables>(TimelineContributionDocument, options);
        }
export type TimelineContributionQueryHookResult = ReturnType<typeof useTimelineContributionQuery>;
export type TimelineContributionLazyQueryHookResult = ReturnType<typeof useTimelineContributionLazyQuery>;
export type TimelineContributionSuspenseQueryHookResult = ReturnType<typeof useTimelineContributionSuspenseQuery>;
export type TimelineContributionQueryResult = Apollo.QueryResult<TimelineContributionQuery, TimelineContributionQueryVariables>;
export const TimelineSnapshotsDocument = gql`
    query TimelineSnapshots($assessmentId: ID!, $answerBlockId: ID!, $versions: [Int!]!) {
  snapshots(
    assessmentId: $assessmentId
    answerBlockId: $answerBlockId
    versions: $versions
  ) {
    asOfVersion
    document
  }
}
    `;

/**
 * __useTimelineSnapshotsQuery__
 *
 * To run a query within a React component, call `useTimelineSnapshotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimelineSnapshotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimelineSnapshotsQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      answerBlockId: // value for 'answerBlockId'
 *      versions: // value for 'versions'
 *   },
 * });
 */
export function useTimelineSnapshotsQuery(baseOptions: Apollo.QueryHookOptions<TimelineSnapshotsQuery, TimelineSnapshotsQueryVariables> & ({ variables: TimelineSnapshotsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimelineSnapshotsQuery, TimelineSnapshotsQueryVariables>(TimelineSnapshotsDocument, options);
      }
export function useTimelineSnapshotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimelineSnapshotsQuery, TimelineSnapshotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimelineSnapshotsQuery, TimelineSnapshotsQueryVariables>(TimelineSnapshotsDocument, options);
        }
export function useTimelineSnapshotsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TimelineSnapshotsQuery, TimelineSnapshotsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TimelineSnapshotsQuery, TimelineSnapshotsQueryVariables>(TimelineSnapshotsDocument, options);
        }
export type TimelineSnapshotsQueryHookResult = ReturnType<typeof useTimelineSnapshotsQuery>;
export type TimelineSnapshotsLazyQueryHookResult = ReturnType<typeof useTimelineSnapshotsLazyQuery>;
export type TimelineSnapshotsSuspenseQueryHookResult = ReturnType<typeof useTimelineSnapshotsSuspenseQuery>;
export type TimelineSnapshotsQueryResult = Apollo.QueryResult<TimelineSnapshotsQuery, TimelineSnapshotsQueryVariables>;
export const UnlinkCommentThreadDocument = gql`
    mutation UnlinkCommentThread($assessmentId: ID!, $threadId: ID!) {
  unlinkCommentThread(assessmentId: $assessmentId, threadId: $threadId) {
    id
    title
    entityType
    entityId
    criterionId
    createdBy {
      id
    }
    metadata {
      charterSectionType
      charterEditorId
    }
    comments {
      id
      content
      updatedAt
      createdBy {
        id
        name
        colourset
      }
    }
  }
}
    `;
export type UnlinkCommentThreadMutationFn = Apollo.MutationFunction<UnlinkCommentThreadMutation, UnlinkCommentThreadMutationVariables>;

/**
 * __useUnlinkCommentThreadMutation__
 *
 * To run a mutation, you first call `useUnlinkCommentThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkCommentThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkCommentThreadMutation, { data, loading, error }] = useUnlinkCommentThreadMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      threadId: // value for 'threadId'
 *   },
 * });
 */
export function useUnlinkCommentThreadMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkCommentThreadMutation, UnlinkCommentThreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkCommentThreadMutation, UnlinkCommentThreadMutationVariables>(UnlinkCommentThreadDocument, options);
      }
export type UnlinkCommentThreadMutationHookResult = ReturnType<typeof useUnlinkCommentThreadMutation>;
export type UnlinkCommentThreadMutationResult = Apollo.MutationResult<UnlinkCommentThreadMutation>;
export type UnlinkCommentThreadMutationOptions = Apollo.BaseMutationOptions<UnlinkCommentThreadMutation, UnlinkCommentThreadMutationVariables>;
export const UpdateFeedbackReleaseRulesDocument = gql`
    mutation UpdateFeedbackReleaseRules($assessmentId: ID!, $rules: [FeedbackReleaseRuleInput!]!, $releaseType: FeedbackReleaseType) {
  updateFeedbackReleaseRules(
    assessmentId: $assessmentId
    rules: $rules
    releaseType: $releaseType
  ) {
    ...FeedbackReleaseRule
  }
}
    ${FeedbackReleaseRuleFragmentDoc}`;
export type UpdateFeedbackReleaseRulesMutationFn = Apollo.MutationFunction<UpdateFeedbackReleaseRulesMutation, UpdateFeedbackReleaseRulesMutationVariables>;

/**
 * __useUpdateFeedbackReleaseRulesMutation__
 *
 * To run a mutation, you first call `useUpdateFeedbackReleaseRulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeedbackReleaseRulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeedbackReleaseRulesMutation, { data, loading, error }] = useUpdateFeedbackReleaseRulesMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      rules: // value for 'rules'
 *      releaseType: // value for 'releaseType'
 *   },
 * });
 */
export function useUpdateFeedbackReleaseRulesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFeedbackReleaseRulesMutation, UpdateFeedbackReleaseRulesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFeedbackReleaseRulesMutation, UpdateFeedbackReleaseRulesMutationVariables>(UpdateFeedbackReleaseRulesDocument, options);
      }
export type UpdateFeedbackReleaseRulesMutationHookResult = ReturnType<typeof useUpdateFeedbackReleaseRulesMutation>;
export type UpdateFeedbackReleaseRulesMutationResult = Apollo.MutationResult<UpdateFeedbackReleaseRulesMutation>;
export type UpdateFeedbackReleaseRulesMutationOptions = Apollo.BaseMutationOptions<UpdateFeedbackReleaseRulesMutation, UpdateFeedbackReleaseRulesMutationVariables>;
export const UpdateFeedbackVisibilityDocument = gql`
    mutation UpdateFeedbackVisibility($assessmentId: ID!, $input: FeedbackVisibilityInput!, $releaseType: FeedbackReleaseType) {
  updateFeedbackVisibility(
    assessmentId: $assessmentId
    input: $input
    releaseType: $releaseType
  ) {
    ...FeedbackVisibility
  }
}
    ${FeedbackVisibilityFragmentDoc}`;
export type UpdateFeedbackVisibilityMutationFn = Apollo.MutationFunction<UpdateFeedbackVisibilityMutation, UpdateFeedbackVisibilityMutationVariables>;

/**
 * __useUpdateFeedbackVisibilityMutation__
 *
 * To run a mutation, you first call `useUpdateFeedbackVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeedbackVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeedbackVisibilityMutation, { data, loading, error }] = useUpdateFeedbackVisibilityMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      input: // value for 'input'
 *      releaseType: // value for 'releaseType'
 *   },
 * });
 */
export function useUpdateFeedbackVisibilityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFeedbackVisibilityMutation, UpdateFeedbackVisibilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFeedbackVisibilityMutation, UpdateFeedbackVisibilityMutationVariables>(UpdateFeedbackVisibilityDocument, options);
      }
export type UpdateFeedbackVisibilityMutationHookResult = ReturnType<typeof useUpdateFeedbackVisibilityMutation>;
export type UpdateFeedbackVisibilityMutationResult = Apollo.MutationResult<UpdateFeedbackVisibilityMutation>;
export type UpdateFeedbackVisibilityMutationOptions = Apollo.BaseMutationOptions<UpdateFeedbackVisibilityMutation, UpdateFeedbackVisibilityMutationVariables>;
export const UpdateFieldRubricResponseDocument = gql`
    mutation UpdateFieldRubricResponse($assessmentId: ID!, $input: UpdateFieldRubricInput!) {
  updateFieldRubricResponse(assessmentId: $assessmentId, input: $input) {
    fieldRubric {
      ...FieldRubric
    }
    questionOutcomes {
      ...QuestionOutcomeScore
    }
    fieldOutcomes {
      ...FieldOutcomeScore
      answer
      answers
    }
    workOutcomes {
      ...WorkOutcomeScore
    }
  }
}
    ${FieldRubricFragmentDoc}
${QuestionOutcomeScoreFragmentDoc}
${FieldOutcomeScoreFragmentDoc}
${WorkOutcomeScoreFragmentDoc}`;
export type UpdateFieldRubricResponseMutationFn = Apollo.MutationFunction<UpdateFieldRubricResponseMutation, UpdateFieldRubricResponseMutationVariables>;

/**
 * __useUpdateFieldRubricResponseMutation__
 *
 * To run a mutation, you first call `useUpdateFieldRubricResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFieldRubricResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFieldRubricResponseMutation, { data, loading, error }] = useUpdateFieldRubricResponseMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFieldRubricResponseMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFieldRubricResponseMutation, UpdateFieldRubricResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFieldRubricResponseMutation, UpdateFieldRubricResponseMutationVariables>(UpdateFieldRubricResponseDocument, options);
      }
export type UpdateFieldRubricResponseMutationHookResult = ReturnType<typeof useUpdateFieldRubricResponseMutation>;
export type UpdateFieldRubricResponseMutationResult = Apollo.MutationResult<UpdateFieldRubricResponseMutation>;
export type UpdateFieldRubricResponseMutationOptions = Apollo.BaseMutationOptions<UpdateFieldRubricResponseMutation, UpdateFieldRubricResponseMutationVariables>;
export const UpdateModerationPenaltyRulesDocument = gql`
    mutation UpdateModerationPenaltyRules($assessmentId: ID!, $rules: [ModerationPenaltyRuleInput!]!) {
  updateModerationPenaltyRules(assessmentId: $assessmentId, rules: $rules) {
    ...ModerationPenaltyRule
  }
}
    ${ModerationPenaltyRuleFragmentDoc}`;
export type UpdateModerationPenaltyRulesMutationFn = Apollo.MutationFunction<UpdateModerationPenaltyRulesMutation, UpdateModerationPenaltyRulesMutationVariables>;

/**
 * __useUpdateModerationPenaltyRulesMutation__
 *
 * To run a mutation, you first call `useUpdateModerationPenaltyRulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateModerationPenaltyRulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateModerationPenaltyRulesMutation, { data, loading, error }] = useUpdateModerationPenaltyRulesMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      rules: // value for 'rules'
 *   },
 * });
 */
export function useUpdateModerationPenaltyRulesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateModerationPenaltyRulesMutation, UpdateModerationPenaltyRulesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateModerationPenaltyRulesMutation, UpdateModerationPenaltyRulesMutationVariables>(UpdateModerationPenaltyRulesDocument, options);
      }
export type UpdateModerationPenaltyRulesMutationHookResult = ReturnType<typeof useUpdateModerationPenaltyRulesMutation>;
export type UpdateModerationPenaltyRulesMutationResult = Apollo.MutationResult<UpdateModerationPenaltyRulesMutation>;
export type UpdateModerationPenaltyRulesMutationOptions = Apollo.BaseMutationOptions<UpdateModerationPenaltyRulesMutation, UpdateModerationPenaltyRulesMutationVariables>;
export const UpdateQuestionRubricDocument = gql`
    mutation UpdateQuestionRubric($assessmentId: ID!, $input: UpdateQuestionRubricInput!) {
  updateQuestionRubric(assessmentId: $assessmentId, input: $input) {
    questionRubric {
      id
      fieldRubrics {
        ...FieldRubric
        ...FieldRubricResponse
      }
    }
    questionOutcomes {
      ...QuestionOutcomeScore
    }
    fieldOutcomes {
      ...FieldOutcomeScore
      answer
      answers
    }
    workOutcomes {
      ...WorkOutcomeScore
    }
  }
}
    ${FieldRubricFragmentDoc}
${FieldRubricResponseFragmentDoc}
${QuestionOutcomeScoreFragmentDoc}
${FieldOutcomeScoreFragmentDoc}
${WorkOutcomeScoreFragmentDoc}`;
export type UpdateQuestionRubricMutationFn = Apollo.MutationFunction<UpdateQuestionRubricMutation, UpdateQuestionRubricMutationVariables>;

/**
 * __useUpdateQuestionRubricMutation__
 *
 * To run a mutation, you first call `useUpdateQuestionRubricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionRubricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuestionRubricMutation, { data, loading, error }] = useUpdateQuestionRubricMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuestionRubricMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuestionRubricMutation, UpdateQuestionRubricMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuestionRubricMutation, UpdateQuestionRubricMutationVariables>(UpdateQuestionRubricDocument, options);
      }
export type UpdateQuestionRubricMutationHookResult = ReturnType<typeof useUpdateQuestionRubricMutation>;
export type UpdateQuestionRubricMutationResult = Apollo.MutationResult<UpdateQuestionRubricMutation>;
export type UpdateQuestionRubricMutationOptions = Apollo.BaseMutationOptions<UpdateQuestionRubricMutation, UpdateQuestionRubricMutationVariables>;
export const UpdateStudentOutcomeScoreDocument = gql`
    mutation updateStudentOutcomeScore($assessmentId: ID!, $studentId: ID!, $input: UpdateStudentOutcomeScoreInput!) {
  updateStudentOutcomeScore(
    assessmentId: $assessmentId
    studentId: $studentId
    input: $input
  ) {
    studentOutcome {
      ...StudentOutcome
    }
  }
}
    ${StudentOutcomeFragmentDoc}`;
export type UpdateStudentOutcomeScoreMutationFn = Apollo.MutationFunction<UpdateStudentOutcomeScoreMutation, UpdateStudentOutcomeScoreMutationVariables>;

/**
 * __useUpdateStudentOutcomeScoreMutation__
 *
 * To run a mutation, you first call `useUpdateStudentOutcomeScoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStudentOutcomeScoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStudentOutcomeScoreMutation, { data, loading, error }] = useUpdateStudentOutcomeScoreMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      studentId: // value for 'studentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStudentOutcomeScoreMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStudentOutcomeScoreMutation, UpdateStudentOutcomeScoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStudentOutcomeScoreMutation, UpdateStudentOutcomeScoreMutationVariables>(UpdateStudentOutcomeScoreDocument, options);
      }
export type UpdateStudentOutcomeScoreMutationHookResult = ReturnType<typeof useUpdateStudentOutcomeScoreMutation>;
export type UpdateStudentOutcomeScoreMutationResult = Apollo.MutationResult<UpdateStudentOutcomeScoreMutation>;
export type UpdateStudentOutcomeScoreMutationOptions = Apollo.BaseMutationOptions<UpdateStudentOutcomeScoreMutation, UpdateStudentOutcomeScoreMutationVariables>;
export const UpdateSubmissionMarkerModifierDocument = gql`
    mutation UpdateSubmissionMarkerModifier($assessmentId: ID!, $submissionOutcomeId: Int!, $awardedPoints: Float) {
  updateSubmissionMarkerModifier(
    assessmentId: $assessmentId
    submissionOutcomeId: $submissionOutcomeId
    awardedPoints: $awardedPoints
  ) {
    submissionOutcome {
      id
      score
      markerModifier
      rubricOutcome {
        criterionOutcomes {
          ...CriterionOutcome
        }
        score
      }
    }
    workOutcome {
      id
      scoreBreakdown {
        ...ScoreBreakdown
      }
    }
  }
}
    ${CriterionOutcomeFragmentDoc}
${ScoreBreakdownFragmentDoc}`;
export type UpdateSubmissionMarkerModifierMutationFn = Apollo.MutationFunction<UpdateSubmissionMarkerModifierMutation, UpdateSubmissionMarkerModifierMutationVariables>;

/**
 * __useUpdateSubmissionMarkerModifierMutation__
 *
 * To run a mutation, you first call `useUpdateSubmissionMarkerModifierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubmissionMarkerModifierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubmissionMarkerModifierMutation, { data, loading, error }] = useUpdateSubmissionMarkerModifierMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      submissionOutcomeId: // value for 'submissionOutcomeId'
 *      awardedPoints: // value for 'awardedPoints'
 *   },
 * });
 */
export function useUpdateSubmissionMarkerModifierMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSubmissionMarkerModifierMutation, UpdateSubmissionMarkerModifierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSubmissionMarkerModifierMutation, UpdateSubmissionMarkerModifierMutationVariables>(UpdateSubmissionMarkerModifierDocument, options);
      }
export type UpdateSubmissionMarkerModifierMutationHookResult = ReturnType<typeof useUpdateSubmissionMarkerModifierMutation>;
export type UpdateSubmissionMarkerModifierMutationResult = Apollo.MutationResult<UpdateSubmissionMarkerModifierMutation>;
export type UpdateSubmissionMarkerModifierMutationOptions = Apollo.BaseMutationOptions<UpdateSubmissionMarkerModifierMutation, UpdateSubmissionMarkerModifierMutationVariables>;
export const UpdateWorkOutcomeScoreDocument = gql`
    mutation updateWorkOutcomeScore($assessmentId: ID!, $input: UpdateWorkOutcomeScoreInput!) {
  updateWorkOutcomeScore(assessmentId: $assessmentId, input: $input) {
    studentOutcomes {
      ...StudentOutcome
    }
  }
}
    ${StudentOutcomeFragmentDoc}`;
export type UpdateWorkOutcomeScoreMutationFn = Apollo.MutationFunction<UpdateWorkOutcomeScoreMutation, UpdateWorkOutcomeScoreMutationVariables>;

/**
 * __useUpdateWorkOutcomeScoreMutation__
 *
 * To run a mutation, you first call `useUpdateWorkOutcomeScoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkOutcomeScoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkOutcomeScoreMutation, { data, loading, error }] = useUpdateWorkOutcomeScoreMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkOutcomeScoreMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkOutcomeScoreMutation, UpdateWorkOutcomeScoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkOutcomeScoreMutation, UpdateWorkOutcomeScoreMutationVariables>(UpdateWorkOutcomeScoreDocument, options);
      }
export type UpdateWorkOutcomeScoreMutationHookResult = ReturnType<typeof useUpdateWorkOutcomeScoreMutation>;
export type UpdateWorkOutcomeScoreMutationResult = Apollo.MutationResult<UpdateWorkOutcomeScoreMutation>;
export type UpdateWorkOutcomeScoreMutationOptions = Apollo.BaseMutationOptions<UpdateWorkOutcomeScoreMutation, UpdateWorkOutcomeScoreMutationVariables>;
export const WithdrawFeedbackDocument = gql`
    mutation WithdrawFeedback($assessmentId: ID!, $studentIds: [ID!]!) {
  withdrawFeedback(assessmentId: $assessmentId, studentIds: $studentIds) {
    ...StudentOutcome
  }
}
    ${StudentOutcomeFragmentDoc}`;
export type WithdrawFeedbackMutationFn = Apollo.MutationFunction<WithdrawFeedbackMutation, WithdrawFeedbackMutationVariables>;

/**
 * __useWithdrawFeedbackMutation__
 *
 * To run a mutation, you first call `useWithdrawFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWithdrawFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [withdrawFeedbackMutation, { data, loading, error }] = useWithdrawFeedbackMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      studentIds: // value for 'studentIds'
 *   },
 * });
 */
export function useWithdrawFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<WithdrawFeedbackMutation, WithdrawFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WithdrawFeedbackMutation, WithdrawFeedbackMutationVariables>(WithdrawFeedbackDocument, options);
      }
export type WithdrawFeedbackMutationHookResult = ReturnType<typeof useWithdrawFeedbackMutation>;
export type WithdrawFeedbackMutationResult = Apollo.MutationResult<WithdrawFeedbackMutation>;
export type WithdrawFeedbackMutationOptions = Apollo.BaseMutationOptions<WithdrawFeedbackMutation, WithdrawFeedbackMutationVariables>;
export const WorkRerouteDocument = gql`
    query WorkReroute($workId: ID!) {
  work(workId: $workId) {
    student {
      id
    }
    group {
      id
      members {
        id
      }
    }
  }
}
    `;

/**
 * __useWorkRerouteQuery__
 *
 * To run a query within a React component, call `useWorkRerouteQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkRerouteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkRerouteQuery({
 *   variables: {
 *      workId: // value for 'workId'
 *   },
 * });
 */
export function useWorkRerouteQuery(baseOptions: Apollo.QueryHookOptions<WorkRerouteQuery, WorkRerouteQueryVariables> & ({ variables: WorkRerouteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkRerouteQuery, WorkRerouteQueryVariables>(WorkRerouteDocument, options);
      }
export function useWorkRerouteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkRerouteQuery, WorkRerouteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkRerouteQuery, WorkRerouteQueryVariables>(WorkRerouteDocument, options);
        }
export function useWorkRerouteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkRerouteQuery, WorkRerouteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkRerouteQuery, WorkRerouteQueryVariables>(WorkRerouteDocument, options);
        }
export type WorkRerouteQueryHookResult = ReturnType<typeof useWorkRerouteQuery>;
export type WorkRerouteLazyQueryHookResult = ReturnType<typeof useWorkRerouteLazyQuery>;
export type WorkRerouteSuspenseQueryHookResult = ReturnType<typeof useWorkRerouteSuspenseQuery>;
export type WorkRerouteQueryResult = Apollo.QueryResult<WorkRerouteQuery, WorkRerouteQueryVariables>;
export const CaptureOnboardingInputDocument = gql`
    mutation CaptureOnboardingInput($subjectId: ID!, $subjectRole: SubjectRole!, $discipline: Discipline) {
  captureOnboardingInput(
    subjectId: $subjectId
    subjectRole: $subjectRole
    discipline: $discipline
  ) {
    ...OnboardingPayload
  }
}
    ${OnboardingPayloadFragmentDoc}`;
export type CaptureOnboardingInputMutationFn = Apollo.MutationFunction<CaptureOnboardingInputMutation, CaptureOnboardingInputMutationVariables>;

/**
 * __useCaptureOnboardingInputMutation__
 *
 * To run a mutation, you first call `useCaptureOnboardingInputMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCaptureOnboardingInputMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [captureOnboardingInputMutation, { data, loading, error }] = useCaptureOnboardingInputMutation({
 *   variables: {
 *      subjectId: // value for 'subjectId'
 *      subjectRole: // value for 'subjectRole'
 *      discipline: // value for 'discipline'
 *   },
 * });
 */
export function useCaptureOnboardingInputMutation(baseOptions?: Apollo.MutationHookOptions<CaptureOnboardingInputMutation, CaptureOnboardingInputMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CaptureOnboardingInputMutation, CaptureOnboardingInputMutationVariables>(CaptureOnboardingInputDocument, options);
      }
export type CaptureOnboardingInputMutationHookResult = ReturnType<typeof useCaptureOnboardingInputMutation>;
export type CaptureOnboardingInputMutationResult = Apollo.MutationResult<CaptureOnboardingInputMutation>;
export type CaptureOnboardingInputMutationOptions = Apollo.BaseMutationOptions<CaptureOnboardingInputMutation, CaptureOnboardingInputMutationVariables>;
export const SaveGlobalUserSettingsDocument = gql`
    mutation SaveGlobalUserSettings($userSettingsInput: GlobalUserSettingsInput!) {
  saveGlobalUserSettings(userSettingsInput: $userSettingsInput) {
    userSettings {
      showIaOnboarding
    }
  }
}
    `;
export type SaveGlobalUserSettingsMutationFn = Apollo.MutationFunction<SaveGlobalUserSettingsMutation, SaveGlobalUserSettingsMutationVariables>;

/**
 * __useSaveGlobalUserSettingsMutation__
 *
 * To run a mutation, you first call `useSaveGlobalUserSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveGlobalUserSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveGlobalUserSettingsMutation, { data, loading, error }] = useSaveGlobalUserSettingsMutation({
 *   variables: {
 *      userSettingsInput: // value for 'userSettingsInput'
 *   },
 * });
 */
export function useSaveGlobalUserSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SaveGlobalUserSettingsMutation, SaveGlobalUserSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveGlobalUserSettingsMutation, SaveGlobalUserSettingsMutationVariables>(SaveGlobalUserSettingsDocument, options);
      }
export type SaveGlobalUserSettingsMutationHookResult = ReturnType<typeof useSaveGlobalUserSettingsMutation>;
export type SaveGlobalUserSettingsMutationResult = Apollo.MutationResult<SaveGlobalUserSettingsMutation>;
export type SaveGlobalUserSettingsMutationOptions = Apollo.BaseMutationOptions<SaveGlobalUserSettingsMutation, SaveGlobalUserSettingsMutationVariables>;
export const AddTagDocument = gql`
    mutation AddTag($enrollmentId: ID!, $text: String!, $column: Int!) {
  addTag(enrollmentId: $enrollmentId, text: $text, column: $column) {
    text
    column
  }
}
    `;
export type AddTagMutationFn = Apollo.MutationFunction<AddTagMutation, AddTagMutationVariables>;

/**
 * __useAddTagMutation__
 *
 * To run a mutation, you first call `useAddTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTagMutation, { data, loading, error }] = useAddTagMutation({
 *   variables: {
 *      enrollmentId: // value for 'enrollmentId'
 *      text: // value for 'text'
 *      column: // value for 'column'
 *   },
 * });
 */
export function useAddTagMutation(baseOptions?: Apollo.MutationHookOptions<AddTagMutation, AddTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTagMutation, AddTagMutationVariables>(AddTagDocument, options);
      }
export type AddTagMutationHookResult = ReturnType<typeof useAddTagMutation>;
export type AddTagMutationResult = Apollo.MutationResult<AddTagMutation>;
export type AddTagMutationOptions = Apollo.BaseMutationOptions<AddTagMutation, AddTagMutationVariables>;
export const AssessmentProjectIssuesDocument = gql`
    query AssessmentProjectIssues($assessmentId: ID!) {
  assessmentProjectIssues(assessmentId: $assessmentId) {
    ...ProjectIssue
  }
}
    ${ProjectIssueFragmentDoc}`;

/**
 * __useAssessmentProjectIssuesQuery__
 *
 * To run a query within a React component, call `useAssessmentProjectIssuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssessmentProjectIssuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssessmentProjectIssuesQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useAssessmentProjectIssuesQuery(baseOptions: Apollo.QueryHookOptions<AssessmentProjectIssuesQuery, AssessmentProjectIssuesQueryVariables> & ({ variables: AssessmentProjectIssuesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssessmentProjectIssuesQuery, AssessmentProjectIssuesQueryVariables>(AssessmentProjectIssuesDocument, options);
      }
export function useAssessmentProjectIssuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssessmentProjectIssuesQuery, AssessmentProjectIssuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssessmentProjectIssuesQuery, AssessmentProjectIssuesQueryVariables>(AssessmentProjectIssuesDocument, options);
        }
export function useAssessmentProjectIssuesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssessmentProjectIssuesQuery, AssessmentProjectIssuesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AssessmentProjectIssuesQuery, AssessmentProjectIssuesQueryVariables>(AssessmentProjectIssuesDocument, options);
        }
export type AssessmentProjectIssuesQueryHookResult = ReturnType<typeof useAssessmentProjectIssuesQuery>;
export type AssessmentProjectIssuesLazyQueryHookResult = ReturnType<typeof useAssessmentProjectIssuesLazyQuery>;
export type AssessmentProjectIssuesSuspenseQueryHookResult = ReturnType<typeof useAssessmentProjectIssuesSuspenseQuery>;
export type AssessmentProjectIssuesQueryResult = Apollo.QueryResult<AssessmentProjectIssuesQuery, AssessmentProjectIssuesQueryVariables>;
export const BulkAddTagDocument = gql`
    mutation BulkAddTag($enrollmentIds: [ID!]!, $text: String!, $tab: ClassTab!) {
  bulkAddTag(enrollmentIds: $enrollmentIds, text: $text, tab: $tab) {
    text
    tab
  }
}
    `;
export type BulkAddTagMutationFn = Apollo.MutationFunction<BulkAddTagMutation, BulkAddTagMutationVariables>;

/**
 * __useBulkAddTagMutation__
 *
 * To run a mutation, you first call `useBulkAddTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkAddTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkAddTagMutation, { data, loading, error }] = useBulkAddTagMutation({
 *   variables: {
 *      enrollmentIds: // value for 'enrollmentIds'
 *      text: // value for 'text'
 *      tab: // value for 'tab'
 *   },
 * });
 */
export function useBulkAddTagMutation(baseOptions?: Apollo.MutationHookOptions<BulkAddTagMutation, BulkAddTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkAddTagMutation, BulkAddTagMutationVariables>(BulkAddTagDocument, options);
      }
export type BulkAddTagMutationHookResult = ReturnType<typeof useBulkAddTagMutation>;
export type BulkAddTagMutationResult = Apollo.MutationResult<BulkAddTagMutation>;
export type BulkAddTagMutationOptions = Apollo.BaseMutationOptions<BulkAddTagMutation, BulkAddTagMutationVariables>;
export const BulkRemoveTagDocument = gql`
    mutation BulkRemoveTag($enrollmentIds: [ID!]!, $text: String!, $tab: ClassTab!) {
  bulkRemoveTag(enrollmentIds: $enrollmentIds, text: $text, tab: $tab)
}
    `;
export type BulkRemoveTagMutationFn = Apollo.MutationFunction<BulkRemoveTagMutation, BulkRemoveTagMutationVariables>;

/**
 * __useBulkRemoveTagMutation__
 *
 * To run a mutation, you first call `useBulkRemoveTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkRemoveTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkRemoveTagMutation, { data, loading, error }] = useBulkRemoveTagMutation({
 *   variables: {
 *      enrollmentIds: // value for 'enrollmentIds'
 *      text: // value for 'text'
 *      tab: // value for 'tab'
 *   },
 * });
 */
export function useBulkRemoveTagMutation(baseOptions?: Apollo.MutationHookOptions<BulkRemoveTagMutation, BulkRemoveTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkRemoveTagMutation, BulkRemoveTagMutationVariables>(BulkRemoveTagDocument, options);
      }
export type BulkRemoveTagMutationHookResult = ReturnType<typeof useBulkRemoveTagMutation>;
export type BulkRemoveTagMutationResult = Apollo.MutationResult<BulkRemoveTagMutation>;
export type BulkRemoveTagMutationOptions = Apollo.BaseMutationOptions<BulkRemoveTagMutation, BulkRemoveTagMutationVariables>;
export const DownloadPeerEvaluationDataDocument = gql`
    mutation DownloadPeerEvaluationData($assessmentId: ID!, $enrollmentId: ID!) {
  downloadPeerEvaluationData(
    assessmentId: $assessmentId
    enrollmentId: $enrollmentId
  )
}
    `;
export type DownloadPeerEvaluationDataMutationFn = Apollo.MutationFunction<DownloadPeerEvaluationDataMutation, DownloadPeerEvaluationDataMutationVariables>;

/**
 * __useDownloadPeerEvaluationDataMutation__
 *
 * To run a mutation, you first call `useDownloadPeerEvaluationDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadPeerEvaluationDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadPeerEvaluationDataMutation, { data, loading, error }] = useDownloadPeerEvaluationDataMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      enrollmentId: // value for 'enrollmentId'
 *   },
 * });
 */
export function useDownloadPeerEvaluationDataMutation(baseOptions?: Apollo.MutationHookOptions<DownloadPeerEvaluationDataMutation, DownloadPeerEvaluationDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadPeerEvaluationDataMutation, DownloadPeerEvaluationDataMutationVariables>(DownloadPeerEvaluationDataDocument, options);
      }
export type DownloadPeerEvaluationDataMutationHookResult = ReturnType<typeof useDownloadPeerEvaluationDataMutation>;
export type DownloadPeerEvaluationDataMutationResult = Apollo.MutationResult<DownloadPeerEvaluationDataMutation>;
export type DownloadPeerEvaluationDataMutationOptions = Apollo.BaseMutationOptions<DownloadPeerEvaluationDataMutation, DownloadPeerEvaluationDataMutationVariables>;
export const DownloadSubmissionsDocument = gql`
    mutation DownloadSubmissions($assessmentId: ID!, $submissions: [SubmissionDetailInput!]!, $preferPdf: Boolean) {
  downloadSubmissions(
    assessmentId: $assessmentId
    submissions: $submissions
    preferPdf: $preferPdf
  )
}
    `;
export type DownloadSubmissionsMutationFn = Apollo.MutationFunction<DownloadSubmissionsMutation, DownloadSubmissionsMutationVariables>;

/**
 * __useDownloadSubmissionsMutation__
 *
 * To run a mutation, you first call `useDownloadSubmissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadSubmissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadSubmissionsMutation, { data, loading, error }] = useDownloadSubmissionsMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      submissions: // value for 'submissions'
 *      preferPdf: // value for 'preferPdf'
 *   },
 * });
 */
export function useDownloadSubmissionsMutation(baseOptions?: Apollo.MutationHookOptions<DownloadSubmissionsMutation, DownloadSubmissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadSubmissionsMutation, DownloadSubmissionsMutationVariables>(DownloadSubmissionsDocument, options);
      }
export type DownloadSubmissionsMutationHookResult = ReturnType<typeof useDownloadSubmissionsMutation>;
export type DownloadSubmissionsMutationResult = Apollo.MutationResult<DownloadSubmissionsMutation>;
export type DownloadSubmissionsMutationOptions = Apollo.BaseMutationOptions<DownloadSubmissionsMutation, DownloadSubmissionsMutationVariables>;
export const DownloadWorkArtifactsDocument = gql`
    mutation DownloadWorkArtifacts($assessmentId: ID!, $workArtifacts: [WorkArtifactDetailInput!]!) {
  downloadWorkArtifacts(
    assessmentId: $assessmentId
    workArtifacts: $workArtifacts
  )
}
    `;
export type DownloadWorkArtifactsMutationFn = Apollo.MutationFunction<DownloadWorkArtifactsMutation, DownloadWorkArtifactsMutationVariables>;

/**
 * __useDownloadWorkArtifactsMutation__
 *
 * To run a mutation, you first call `useDownloadWorkArtifactsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadWorkArtifactsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadWorkArtifactsMutation, { data, loading, error }] = useDownloadWorkArtifactsMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      workArtifacts: // value for 'workArtifacts'
 *   },
 * });
 */
export function useDownloadWorkArtifactsMutation(baseOptions?: Apollo.MutationHookOptions<DownloadWorkArtifactsMutation, DownloadWorkArtifactsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadWorkArtifactsMutation, DownloadWorkArtifactsMutationVariables>(DownloadWorkArtifactsDocument, options);
      }
export type DownloadWorkArtifactsMutationHookResult = ReturnType<typeof useDownloadWorkArtifactsMutation>;
export type DownloadWorkArtifactsMutationResult = Apollo.MutationResult<DownloadWorkArtifactsMutation>;
export type DownloadWorkArtifactsMutationOptions = Apollo.BaseMutationOptions<DownloadWorkArtifactsMutation, DownloadWorkArtifactsMutationVariables>;
export const EnrollmentsUpdatedDocument = gql`
    subscription EnrollmentsUpdated($assessmentId: ID!) {
  enrollmentsUpdated(assessmentId: $assessmentId)
}
    `;

/**
 * __useEnrollmentsUpdatedSubscription__
 *
 * To run a query within a React component, call `useEnrollmentsUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEnrollmentsUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrollmentsUpdatedSubscription({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useEnrollmentsUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<EnrollmentsUpdatedSubscription, EnrollmentsUpdatedSubscriptionVariables> & ({ variables: EnrollmentsUpdatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<EnrollmentsUpdatedSubscription, EnrollmentsUpdatedSubscriptionVariables>(EnrollmentsUpdatedDocument, options);
      }
export type EnrollmentsUpdatedSubscriptionHookResult = ReturnType<typeof useEnrollmentsUpdatedSubscription>;
export type EnrollmentsUpdatedSubscriptionResult = Apollo.SubscriptionResult<EnrollmentsUpdatedSubscription>;
export const ForceSubmissionsV2Document = gql`
    mutation forceSubmissionsV2($assessmentId: ID!, $workIds: [ID]!, $type: SubmissionType!, $submittedAt: DateTime!) {
  forceSubmissionsV2(
    assessmentId: $assessmentId
    workIds: $workIds
    type: $type
    submittedAt: $submittedAt
  ) {
    ...Result
  }
}
    ${ResultFragmentDoc}`;
export type ForceSubmissionsV2MutationFn = Apollo.MutationFunction<ForceSubmissionsV2Mutation, ForceSubmissionsV2MutationVariables>;

/**
 * __useForceSubmissionsV2Mutation__
 *
 * To run a mutation, you first call `useForceSubmissionsV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForceSubmissionsV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forceSubmissionsV2Mutation, { data, loading, error }] = useForceSubmissionsV2Mutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      workIds: // value for 'workIds'
 *      type: // value for 'type'
 *      submittedAt: // value for 'submittedAt'
 *   },
 * });
 */
export function useForceSubmissionsV2Mutation(baseOptions?: Apollo.MutationHookOptions<ForceSubmissionsV2Mutation, ForceSubmissionsV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForceSubmissionsV2Mutation, ForceSubmissionsV2MutationVariables>(ForceSubmissionsV2Document, options);
      }
export type ForceSubmissionsV2MutationHookResult = ReturnType<typeof useForceSubmissionsV2Mutation>;
export type ForceSubmissionsV2MutationResult = Apollo.MutationResult<ForceSubmissionsV2Mutation>;
export type ForceSubmissionsV2MutationOptions = Apollo.BaseMutationOptions<ForceSubmissionsV2Mutation, ForceSubmissionsV2MutationVariables>;
export const ForceSubmissionsDocument = gql`
    mutation forceSubmissions($assessmentId: ID!, $workIds: [ID]!, $type: SubmissionType!, $submittedAt: DateTime!) {
  forceSubmissions(
    assessmentId: $assessmentId
    workIds: $workIds
    type: $type
    submittedAt: $submittedAt
  ) {
    ...Result
  }
}
    ${ResultFragmentDoc}`;
export type ForceSubmissionsMutationFn = Apollo.MutationFunction<ForceSubmissionsMutation, ForceSubmissionsMutationVariables>;

/**
 * __useForceSubmissionsMutation__
 *
 * To run a mutation, you first call `useForceSubmissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForceSubmissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forceSubmissionsMutation, { data, loading, error }] = useForceSubmissionsMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      workIds: // value for 'workIds'
 *      type: // value for 'type'
 *      submittedAt: // value for 'submittedAt'
 *   },
 * });
 */
export function useForceSubmissionsMutation(baseOptions?: Apollo.MutationHookOptions<ForceSubmissionsMutation, ForceSubmissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForceSubmissionsMutation, ForceSubmissionsMutationVariables>(ForceSubmissionsDocument, options);
      }
export type ForceSubmissionsMutationHookResult = ReturnType<typeof useForceSubmissionsMutation>;
export type ForceSubmissionsMutationResult = Apollo.MutationResult<ForceSubmissionsMutation>;
export type ForceSubmissionsMutationOptions = Apollo.BaseMutationOptions<ForceSubmissionsMutation, ForceSubmissionsMutationVariables>;
export const GrantGroupExtensionsDocument = gql`
    mutation GrantGroupExtensions($assessmentId: ID!, $groupIds: [ID!]!, $input: GroupExtensionInput!) {
  grantGroupExtensions(
    assessmentId: $assessmentId
    groupIds: $groupIds
    input: $input
  ) {
    ...WorkSettings
  }
}
    ${WorkSettingsFragmentDoc}`;
export type GrantGroupExtensionsMutationFn = Apollo.MutationFunction<GrantGroupExtensionsMutation, GrantGroupExtensionsMutationVariables>;

/**
 * __useGrantGroupExtensionsMutation__
 *
 * To run a mutation, you first call `useGrantGroupExtensionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGrantGroupExtensionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [grantGroupExtensionsMutation, { data, loading, error }] = useGrantGroupExtensionsMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      groupIds: // value for 'groupIds'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGrantGroupExtensionsMutation(baseOptions?: Apollo.MutationHookOptions<GrantGroupExtensionsMutation, GrantGroupExtensionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GrantGroupExtensionsMutation, GrantGroupExtensionsMutationVariables>(GrantGroupExtensionsDocument, options);
      }
export type GrantGroupExtensionsMutationHookResult = ReturnType<typeof useGrantGroupExtensionsMutation>;
export type GrantGroupExtensionsMutationResult = Apollo.MutationResult<GrantGroupExtensionsMutation>;
export type GrantGroupExtensionsMutationOptions = Apollo.BaseMutationOptions<GrantGroupExtensionsMutation, GrantGroupExtensionsMutationVariables>;
export const InsertSyncRosterJobDocument = gql`
    mutation InsertSyncRosterJob($assessmentId: ID!, $withExtensions: Boolean, $extensionConflictAction: ExtensionConflictActionType) {
  insertSyncRosterJob(
    assessmentId: $assessmentId
    withExtensions: $withExtensions
    extensionConflictAction: $extensionConflictAction
  ) {
    ...BackgroundJob
  }
}
    ${BackgroundJobFragmentDoc}`;
export type InsertSyncRosterJobMutationFn = Apollo.MutationFunction<InsertSyncRosterJobMutation, InsertSyncRosterJobMutationVariables>;

/**
 * __useInsertSyncRosterJobMutation__
 *
 * To run a mutation, you first call `useInsertSyncRosterJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertSyncRosterJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertSyncRosterJobMutation, { data, loading, error }] = useInsertSyncRosterJobMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      withExtensions: // value for 'withExtensions'
 *      extensionConflictAction: // value for 'extensionConflictAction'
 *   },
 * });
 */
export function useInsertSyncRosterJobMutation(baseOptions?: Apollo.MutationHookOptions<InsertSyncRosterJobMutation, InsertSyncRosterJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertSyncRosterJobMutation, InsertSyncRosterJobMutationVariables>(InsertSyncRosterJobDocument, options);
      }
export type InsertSyncRosterJobMutationHookResult = ReturnType<typeof useInsertSyncRosterJobMutation>;
export type InsertSyncRosterJobMutationResult = Apollo.MutationResult<InsertSyncRosterJobMutation>;
export type InsertSyncRosterJobMutationOptions = Apollo.BaseMutationOptions<InsertSyncRosterJobMutation, InsertSyncRosterJobMutationVariables>;
export const RemoveTagDocument = gql`
    mutation RemoveTag($enrollmentId: ID!, $text: String!, $column: Int!) {
  removeTag(enrollmentId: $enrollmentId, text: $text, column: $column)
}
    `;
export type RemoveTagMutationFn = Apollo.MutationFunction<RemoveTagMutation, RemoveTagMutationVariables>;

/**
 * __useRemoveTagMutation__
 *
 * To run a mutation, you first call `useRemoveTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTagMutation, { data, loading, error }] = useRemoveTagMutation({
 *   variables: {
 *      enrollmentId: // value for 'enrollmentId'
 *      text: // value for 'text'
 *      column: // value for 'column'
 *   },
 * });
 */
export function useRemoveTagMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTagMutation, RemoveTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTagMutation, RemoveTagMutationVariables>(RemoveTagDocument, options);
      }
export type RemoveTagMutationHookResult = ReturnType<typeof useRemoveTagMutation>;
export type RemoveTagMutationResult = Apollo.MutationResult<RemoveTagMutation>;
export type RemoveTagMutationOptions = Apollo.BaseMutationOptions<RemoveTagMutation, RemoveTagMutationVariables>;
export const ResultsUpdatedDocument = gql`
    subscription ResultsUpdated($assessmentId: ID!) {
  resultsUpdated(assessmentId: $assessmentId) {
    ...Result
  }
}
    ${ResultFragmentDoc}`;

/**
 * __useResultsUpdatedSubscription__
 *
 * To run a query within a React component, call `useResultsUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useResultsUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResultsUpdatedSubscription({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useResultsUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<ResultsUpdatedSubscription, ResultsUpdatedSubscriptionVariables> & ({ variables: ResultsUpdatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ResultsUpdatedSubscription, ResultsUpdatedSubscriptionVariables>(ResultsUpdatedDocument, options);
      }
export type ResultsUpdatedSubscriptionHookResult = ReturnType<typeof useResultsUpdatedSubscription>;
export type ResultsUpdatedSubscriptionResult = Apollo.SubscriptionResult<ResultsUpdatedSubscription>;
export const SendEmailsToClassDocument = gql`
    mutation sendEmailsToClass($assessmentId: ID!, $submissionIds: [ID]!) {
  sendEmailsToClass(assessmentId: $assessmentId, submissionIds: $submissionIds)
}
    `;
export type SendEmailsToClassMutationFn = Apollo.MutationFunction<SendEmailsToClassMutation, SendEmailsToClassMutationVariables>;

/**
 * __useSendEmailsToClassMutation__
 *
 * To run a mutation, you first call `useSendEmailsToClassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEmailsToClassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEmailsToClassMutation, { data, loading, error }] = useSendEmailsToClassMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      submissionIds: // value for 'submissionIds'
 *   },
 * });
 */
export function useSendEmailsToClassMutation(baseOptions?: Apollo.MutationHookOptions<SendEmailsToClassMutation, SendEmailsToClassMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendEmailsToClassMutation, SendEmailsToClassMutationVariables>(SendEmailsToClassDocument, options);
      }
export type SendEmailsToClassMutationHookResult = ReturnType<typeof useSendEmailsToClassMutation>;
export type SendEmailsToClassMutationResult = Apollo.MutationResult<SendEmailsToClassMutation>;
export type SendEmailsToClassMutationOptions = Apollo.BaseMutationOptions<SendEmailsToClassMutation, SendEmailsToClassMutationVariables>;
export const SyncGradesDocument = gql`
    mutation SyncGrades($assessmentId: ID!) {
  syncGrades(assessmentId: $assessmentId)
}
    `;
export type SyncGradesMutationFn = Apollo.MutationFunction<SyncGradesMutation, SyncGradesMutationVariables>;

/**
 * __useSyncGradesMutation__
 *
 * To run a mutation, you first call `useSyncGradesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncGradesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncGradesMutation, { data, loading, error }] = useSyncGradesMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useSyncGradesMutation(baseOptions?: Apollo.MutationHookOptions<SyncGradesMutation, SyncGradesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncGradesMutation, SyncGradesMutationVariables>(SyncGradesDocument, options);
      }
export type SyncGradesMutationHookResult = ReturnType<typeof useSyncGradesMutation>;
export type SyncGradesMutationResult = Apollo.MutationResult<SyncGradesMutation>;
export type SyncGradesMutationOptions = Apollo.BaseMutationOptions<SyncGradesMutation, SyncGradesMutationVariables>;
export const UpdateStudentSettingsDocument = gql`
    mutation UpdateStudentSettings($assessmentId: ID!, $settings: [StudentSettingsInput]!) {
  updateStudentSettings(assessmentId: $assessmentId, settings: $settings) {
    ...WorkSettings
    studentId
  }
}
    ${WorkSettingsFragmentDoc}`;
export type UpdateStudentSettingsMutationFn = Apollo.MutationFunction<UpdateStudentSettingsMutation, UpdateStudentSettingsMutationVariables>;

/**
 * __useUpdateStudentSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateStudentSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStudentSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStudentSettingsMutation, { data, loading, error }] = useUpdateStudentSettingsMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useUpdateStudentSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStudentSettingsMutation, UpdateStudentSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStudentSettingsMutation, UpdateStudentSettingsMutationVariables>(UpdateStudentSettingsDocument, options);
      }
export type UpdateStudentSettingsMutationHookResult = ReturnType<typeof useUpdateStudentSettingsMutation>;
export type UpdateStudentSettingsMutationResult = Apollo.MutationResult<UpdateStudentSettingsMutation>;
export type UpdateStudentSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateStudentSettingsMutation, UpdateStudentSettingsMutationVariables>;
export const UpdateWorkSettingsDocument = gql`
    mutation UpdateWorkSettings($assessmentId: ID!, $enrollmentId: ID!, $dueDate: DateTime, $timeLimit: Int) {
  updateWorkSettings(
    assessmentId: $assessmentId
    enrollmentId: $enrollmentId
    dueDate: $dueDate
    timeLimit: $timeLimit
  ) {
    id
    dueDate
    timeLimit
  }
}
    `;
export type UpdateWorkSettingsMutationFn = Apollo.MutationFunction<UpdateWorkSettingsMutation, UpdateWorkSettingsMutationVariables>;

/**
 * __useUpdateWorkSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateWorkSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkSettingsMutation, { data, loading, error }] = useUpdateWorkSettingsMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      enrollmentId: // value for 'enrollmentId'
 *      dueDate: // value for 'dueDate'
 *      timeLimit: // value for 'timeLimit'
 *   },
 * });
 */
export function useUpdateWorkSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkSettingsMutation, UpdateWorkSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkSettingsMutation, UpdateWorkSettingsMutationVariables>(UpdateWorkSettingsDocument, options);
      }
export type UpdateWorkSettingsMutationHookResult = ReturnType<typeof useUpdateWorkSettingsMutation>;
export type UpdateWorkSettingsMutationResult = Apollo.MutationResult<UpdateWorkSettingsMutation>;
export type UpdateWorkSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateWorkSettingsMutation, UpdateWorkSettingsMutationVariables>;
export const UpdateEnrollmentsStatusDocument = gql`
    mutation UpdateEnrollmentsStatus($enrollmentIds: [ID!]!, $withdrawn: Boolean!, $assessmentId: ID!) {
  updateEnrollmentsStatus(
    assessmentId: $assessmentId
    enrollmentIds: $enrollmentIds
    withdrawn: $withdrawn
  ) {
    ...Enrollment
  }
}
    ${EnrollmentFragmentDoc}`;
export type UpdateEnrollmentsStatusMutationFn = Apollo.MutationFunction<UpdateEnrollmentsStatusMutation, UpdateEnrollmentsStatusMutationVariables>;

/**
 * __useUpdateEnrollmentsStatusMutation__
 *
 * To run a mutation, you first call `useUpdateEnrollmentsStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEnrollmentsStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEnrollmentsStatusMutation, { data, loading, error }] = useUpdateEnrollmentsStatusMutation({
 *   variables: {
 *      enrollmentIds: // value for 'enrollmentIds'
 *      withdrawn: // value for 'withdrawn'
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useUpdateEnrollmentsStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEnrollmentsStatusMutation, UpdateEnrollmentsStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEnrollmentsStatusMutation, UpdateEnrollmentsStatusMutationVariables>(UpdateEnrollmentsStatusDocument, options);
      }
export type UpdateEnrollmentsStatusMutationHookResult = ReturnType<typeof useUpdateEnrollmentsStatusMutation>;
export type UpdateEnrollmentsStatusMutationResult = Apollo.MutationResult<UpdateEnrollmentsStatusMutation>;
export type UpdateEnrollmentsStatusMutationOptions = Apollo.BaseMutationOptions<UpdateEnrollmentsStatusMutation, UpdateEnrollmentsStatusMutationVariables>;
export const WorksSettingsUpdatedDocument = gql`
    subscription WorksSettingsUpdated($assessmentId: ID!) {
  worksSettingsUpdated(assessmentId: $assessmentId) {
    ...WorkSettings
  }
}
    ${WorkSettingsFragmentDoc}`;

/**
 * __useWorksSettingsUpdatedSubscription__
 *
 * To run a query within a React component, call `useWorksSettingsUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWorksSettingsUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorksSettingsUpdatedSubscription({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useWorksSettingsUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<WorksSettingsUpdatedSubscription, WorksSettingsUpdatedSubscriptionVariables> & ({ variables: WorksSettingsUpdatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<WorksSettingsUpdatedSubscription, WorksSettingsUpdatedSubscriptionVariables>(WorksSettingsUpdatedDocument, options);
      }
export type WorksSettingsUpdatedSubscriptionHookResult = ReturnType<typeof useWorksSettingsUpdatedSubscription>;
export type WorksSettingsUpdatedSubscriptionResult = Apollo.SubscriptionResult<WorksSettingsUpdatedSubscription>;
export const AppendTagsForQuestionsDocument = gql`
    mutation AppendTagsForQuestions($id: [ID!]!, $input: [TagInput!]!) {
  appendTagsForQuestions(questionIds: $id, input: $input) {
    id
    cacheId
    tags {
      id
      name
    }
  }
}
    `;
export type AppendTagsForQuestionsMutationFn = Apollo.MutationFunction<AppendTagsForQuestionsMutation, AppendTagsForQuestionsMutationVariables>;

/**
 * __useAppendTagsForQuestionsMutation__
 *
 * To run a mutation, you first call `useAppendTagsForQuestionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppendTagsForQuestionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appendTagsForQuestionsMutation, { data, loading, error }] = useAppendTagsForQuestionsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAppendTagsForQuestionsMutation(baseOptions?: Apollo.MutationHookOptions<AppendTagsForQuestionsMutation, AppendTagsForQuestionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AppendTagsForQuestionsMutation, AppendTagsForQuestionsMutationVariables>(AppendTagsForQuestionsDocument, options);
      }
export type AppendTagsForQuestionsMutationHookResult = ReturnType<typeof useAppendTagsForQuestionsMutation>;
export type AppendTagsForQuestionsMutationResult = Apollo.MutationResult<AppendTagsForQuestionsMutation>;
export type AppendTagsForQuestionsMutationOptions = Apollo.BaseMutationOptions<AppendTagsForQuestionsMutation, AppendTagsForQuestionsMutationVariables>;
export const ArchiveQuestionDocument = gql`
    mutation ArchiveQuestion($questionId: ID!) {
  archiveQuestion(questionId: $questionId) {
    ...LibraryQuestionOverview
  }
}
    ${LibraryQuestionOverviewFragmentDoc}`;
export type ArchiveQuestionMutationFn = Apollo.MutationFunction<ArchiveQuestionMutation, ArchiveQuestionMutationVariables>;

/**
 * __useArchiveQuestionMutation__
 *
 * To run a mutation, you first call `useArchiveQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveQuestionMutation, { data, loading, error }] = useArchiveQuestionMutation({
 *   variables: {
 *      questionId: // value for 'questionId'
 *   },
 * });
 */
export function useArchiveQuestionMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveQuestionMutation, ArchiveQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveQuestionMutation, ArchiveQuestionMutationVariables>(ArchiveQuestionDocument, options);
      }
export type ArchiveQuestionMutationHookResult = ReturnType<typeof useArchiveQuestionMutation>;
export type ArchiveQuestionMutationResult = Apollo.MutationResult<ArchiveQuestionMutation>;
export type ArchiveQuestionMutationOptions = Apollo.BaseMutationOptions<ArchiveQuestionMutation, ArchiveQuestionMutationVariables>;
export const CopyQuestionDocument = gql`
    mutation CopyQuestion($questionId: ID!) {
  copyQuestion(questionId: $questionId) {
    ...LibraryQuestionOverview
  }
}
    ${LibraryQuestionOverviewFragmentDoc}`;
export type CopyQuestionMutationFn = Apollo.MutationFunction<CopyQuestionMutation, CopyQuestionMutationVariables>;

/**
 * __useCopyQuestionMutation__
 *
 * To run a mutation, you first call `useCopyQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyQuestionMutation, { data, loading, error }] = useCopyQuestionMutation({
 *   variables: {
 *      questionId: // value for 'questionId'
 *   },
 * });
 */
export function useCopyQuestionMutation(baseOptions?: Apollo.MutationHookOptions<CopyQuestionMutation, CopyQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyQuestionMutation, CopyQuestionMutationVariables>(CopyQuestionDocument, options);
      }
export type CopyQuestionMutationHookResult = ReturnType<typeof useCopyQuestionMutation>;
export type CopyQuestionMutationResult = Apollo.MutationResult<CopyQuestionMutation>;
export type CopyQuestionMutationOptions = Apollo.BaseMutationOptions<CopyQuestionMutation, CopyQuestionMutationVariables>;
export const CreateQuestionDocument = gql`
    mutation CreateQuestion($assessmentId: ID!, $childrenQuestions: [QuestionAttributes!], $input: QuestionAttributes!, $subjectId: ID!) {
  createQuestion(
    assessmentId: $assessmentId
    childrenQuestions: $childrenQuestions
    input: $input
    subjectId: $subjectId
  ) {
    ...LibraryQuestion
  }
}
    ${LibraryQuestionFragmentDoc}`;
export type CreateQuestionMutationFn = Apollo.MutationFunction<CreateQuestionMutation, CreateQuestionMutationVariables>;

/**
 * __useCreateQuestionMutation__
 *
 * To run a mutation, you first call `useCreateQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuestionMutation, { data, loading, error }] = useCreateQuestionMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      childrenQuestions: // value for 'childrenQuestions'
 *      input: // value for 'input'
 *      subjectId: // value for 'subjectId'
 *   },
 * });
 */
export function useCreateQuestionMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuestionMutation, CreateQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuestionMutation, CreateQuestionMutationVariables>(CreateQuestionDocument, options);
      }
export type CreateQuestionMutationHookResult = ReturnType<typeof useCreateQuestionMutation>;
export type CreateQuestionMutationResult = Apollo.MutationResult<CreateQuestionMutation>;
export type CreateQuestionMutationOptions = Apollo.BaseMutationOptions<CreateQuestionMutation, CreateQuestionMutationVariables>;
export const CreateQuestionSelectionDocument = gql`
    mutation CreateQuestionSelection($input: QuestionSelectionInput!) {
  createQuestionSelection(input: $input) {
    selection {
      ...QuestionSelection
    }
    incompleteRuleIndex
    selectedQuestionCount
    requiredQuestionCount
  }
}
    ${QuestionSelectionFragmentDoc}`;
export type CreateQuestionSelectionMutationFn = Apollo.MutationFunction<CreateQuestionSelectionMutation, CreateQuestionSelectionMutationVariables>;

/**
 * __useCreateQuestionSelectionMutation__
 *
 * To run a mutation, you first call `useCreateQuestionSelectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuestionSelectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuestionSelectionMutation, { data, loading, error }] = useCreateQuestionSelectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateQuestionSelectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuestionSelectionMutation, CreateQuestionSelectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuestionSelectionMutation, CreateQuestionSelectionMutationVariables>(CreateQuestionSelectionDocument, options);
      }
export type CreateQuestionSelectionMutationHookResult = ReturnType<typeof useCreateQuestionSelectionMutation>;
export type CreateQuestionSelectionMutationResult = Apollo.MutationResult<CreateQuestionSelectionMutation>;
export type CreateQuestionSelectionMutationOptions = Apollo.BaseMutationOptions<CreateQuestionSelectionMutation, CreateQuestionSelectionMutationVariables>;
export const CreateTagDocument = gql`
    mutation CreateTag($name: String!) {
  createTag(name: $name) {
    id
    name
  }
}
    `;
export type CreateTagMutationFn = Apollo.MutationFunction<CreateTagMutation, CreateTagMutationVariables>;

/**
 * __useCreateTagMutation__
 *
 * To run a mutation, you first call `useCreateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTagMutation, { data, loading, error }] = useCreateTagMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateTagMutation(baseOptions?: Apollo.MutationHookOptions<CreateTagMutation, CreateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTagMutation, CreateTagMutationVariables>(CreateTagDocument, options);
      }
export type CreateTagMutationHookResult = ReturnType<typeof useCreateTagMutation>;
export type CreateTagMutationResult = Apollo.MutationResult<CreateTagMutation>;
export type CreateTagMutationOptions = Apollo.BaseMutationOptions<CreateTagMutation, CreateTagMutationVariables>;
export const FindSimilarQuestionsDocument = gql`
    mutation FindSimilarQuestions($input: FindSimilarQuestionsInput!) {
  findSimilarQuestions(input: $input) {
    questions {
      id
      cacheId
    }
    incompleteReplacement
  }
}
    `;
export type FindSimilarQuestionsMutationFn = Apollo.MutationFunction<FindSimilarQuestionsMutation, FindSimilarQuestionsMutationVariables>;

/**
 * __useFindSimilarQuestionsMutation__
 *
 * To run a mutation, you first call `useFindSimilarQuestionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFindSimilarQuestionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [findSimilarQuestionsMutation, { data, loading, error }] = useFindSimilarQuestionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindSimilarQuestionsMutation(baseOptions?: Apollo.MutationHookOptions<FindSimilarQuestionsMutation, FindSimilarQuestionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FindSimilarQuestionsMutation, FindSimilarQuestionsMutationVariables>(FindSimilarQuestionsDocument, options);
      }
export type FindSimilarQuestionsMutationHookResult = ReturnType<typeof useFindSimilarQuestionsMutation>;
export type FindSimilarQuestionsMutationResult = Apollo.MutationResult<FindSimilarQuestionsMutation>;
export type FindSimilarQuestionsMutationOptions = Apollo.BaseMutationOptions<FindSimilarQuestionsMutation, FindSimilarQuestionsMutationVariables>;
export const LibraryQuestionDocument = gql`
    query LibraryQuestion($id: ID!) {
  question(questionId: $id) {
    ...LibraryQuestion
  }
  questionTagCategories {
    ...QuestionTagCategory
  }
}
    ${LibraryQuestionFragmentDoc}
${QuestionTagCategoryFragmentDoc}`;

/**
 * __useLibraryQuestionQuery__
 *
 * To run a query within a React component, call `useLibraryQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useLibraryQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLibraryQuestionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLibraryQuestionQuery(baseOptions: Apollo.QueryHookOptions<LibraryQuestionQuery, LibraryQuestionQueryVariables> & ({ variables: LibraryQuestionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LibraryQuestionQuery, LibraryQuestionQueryVariables>(LibraryQuestionDocument, options);
      }
export function useLibraryQuestionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LibraryQuestionQuery, LibraryQuestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LibraryQuestionQuery, LibraryQuestionQueryVariables>(LibraryQuestionDocument, options);
        }
export function useLibraryQuestionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LibraryQuestionQuery, LibraryQuestionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LibraryQuestionQuery, LibraryQuestionQueryVariables>(LibraryQuestionDocument, options);
        }
export type LibraryQuestionQueryHookResult = ReturnType<typeof useLibraryQuestionQuery>;
export type LibraryQuestionLazyQueryHookResult = ReturnType<typeof useLibraryQuestionLazyQuery>;
export type LibraryQuestionSuspenseQueryHookResult = ReturnType<typeof useLibraryQuestionSuspenseQuery>;
export type LibraryQuestionQueryResult = Apollo.QueryResult<LibraryQuestionQuery, LibraryQuestionQueryVariables>;
export const LibraryQuestionsDocument = gql`
    query LibraryQuestions($assessmentId: ID!) {
  libraryQuestions {
    ...LibraryQuestionOverview
  }
  assessment(assessmentId: $assessmentId) {
    id
    subjectId
    name
    settings {
      id
      vivaEnabled
    }
    tasks {
      id
      kind
      blocks {
        id
        libraryQuestionId
        questionSelection {
          sets {
            ...QuestionSet
          }
        }
      }
    }
  }
}
    ${LibraryQuestionOverviewFragmentDoc}
${QuestionSetFragmentDoc}`;

/**
 * __useLibraryQuestionsQuery__
 *
 * To run a query within a React component, call `useLibraryQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLibraryQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLibraryQuestionsQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useLibraryQuestionsQuery(baseOptions: Apollo.QueryHookOptions<LibraryQuestionsQuery, LibraryQuestionsQueryVariables> & ({ variables: LibraryQuestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LibraryQuestionsQuery, LibraryQuestionsQueryVariables>(LibraryQuestionsDocument, options);
      }
export function useLibraryQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LibraryQuestionsQuery, LibraryQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LibraryQuestionsQuery, LibraryQuestionsQueryVariables>(LibraryQuestionsDocument, options);
        }
export function useLibraryQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LibraryQuestionsQuery, LibraryQuestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LibraryQuestionsQuery, LibraryQuestionsQueryVariables>(LibraryQuestionsDocument, options);
        }
export type LibraryQuestionsQueryHookResult = ReturnType<typeof useLibraryQuestionsQuery>;
export type LibraryQuestionsLazyQueryHookResult = ReturnType<typeof useLibraryQuestionsLazyQuery>;
export type LibraryQuestionsSuspenseQueryHookResult = ReturnType<typeof useLibraryQuestionsSuspenseQuery>;
export type LibraryQuestionsQueryResult = Apollo.QueryResult<LibraryQuestionsQuery, LibraryQuestionsQueryVariables>;
export const PublishImportedQuestionsDocument = gql`
    mutation PublishImportedQuestions($input: PublishImportedQuestionsInput!) {
  publishImportedQuestions(input: $input) {
    ...LibraryQuestion
  }
}
    ${LibraryQuestionFragmentDoc}`;
export type PublishImportedQuestionsMutationFn = Apollo.MutationFunction<PublishImportedQuestionsMutation, PublishImportedQuestionsMutationVariables>;

/**
 * __usePublishImportedQuestionsMutation__
 *
 * To run a mutation, you first call `usePublishImportedQuestionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishImportedQuestionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishImportedQuestionsMutation, { data, loading, error }] = usePublishImportedQuestionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublishImportedQuestionsMutation(baseOptions?: Apollo.MutationHookOptions<PublishImportedQuestionsMutation, PublishImportedQuestionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishImportedQuestionsMutation, PublishImportedQuestionsMutationVariables>(PublishImportedQuestionsDocument, options);
      }
export type PublishImportedQuestionsMutationHookResult = ReturnType<typeof usePublishImportedQuestionsMutation>;
export type PublishImportedQuestionsMutationResult = Apollo.MutationResult<PublishImportedQuestionsMutation>;
export type PublishImportedQuestionsMutationOptions = Apollo.BaseMutationOptions<PublishImportedQuestionsMutation, PublishImportedQuestionsMutationVariables>;
export const QuestionContentDocument = gql`
    query QuestionContent($questionId: ID!) {
  question(questionId: $questionId) {
    id
    cacheId
    body {
      ...QuestionBody
    }
    childrenQuestions {
      ...LibraryQuestionOverview
      body {
        ...QuestionBody
      }
    }
  }
}
    ${QuestionBodyFragmentDoc}
${LibraryQuestionOverviewFragmentDoc}`;

/**
 * __useQuestionContentQuery__
 *
 * To run a query within a React component, call `useQuestionContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuestionContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuestionContentQuery({
 *   variables: {
 *      questionId: // value for 'questionId'
 *   },
 * });
 */
export function useQuestionContentQuery(baseOptions: Apollo.QueryHookOptions<QuestionContentQuery, QuestionContentQueryVariables> & ({ variables: QuestionContentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuestionContentQuery, QuestionContentQueryVariables>(QuestionContentDocument, options);
      }
export function useQuestionContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuestionContentQuery, QuestionContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuestionContentQuery, QuestionContentQueryVariables>(QuestionContentDocument, options);
        }
export function useQuestionContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QuestionContentQuery, QuestionContentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QuestionContentQuery, QuestionContentQueryVariables>(QuestionContentDocument, options);
        }
export type QuestionContentQueryHookResult = ReturnType<typeof useQuestionContentQuery>;
export type QuestionContentLazyQueryHookResult = ReturnType<typeof useQuestionContentLazyQuery>;
export type QuestionContentSuspenseQueryHookResult = ReturnType<typeof useQuestionContentSuspenseQuery>;
export type QuestionContentQueryResult = Apollo.QueryResult<QuestionContentQuery, QuestionContentQueryVariables>;
export const QuestionSelectionDocument = gql`
    query QuestionSelection($questionSelectionId: ID!, $assessmentId: ID!) {
  questionSelection(questionSelectionId: $questionSelectionId) {
    ...QuestionSelection
  }
  assessment(assessmentId: $assessmentId) {
    id
    name
    subjectId
    settings {
      id
      vivaEnabled
    }
    tasks {
      id
      kind
    }
  }
}
    ${QuestionSelectionFragmentDoc}`;

/**
 * __useQuestionSelectionQuery__
 *
 * To run a query within a React component, call `useQuestionSelectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuestionSelectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuestionSelectionQuery({
 *   variables: {
 *      questionSelectionId: // value for 'questionSelectionId'
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useQuestionSelectionQuery(baseOptions: Apollo.QueryHookOptions<QuestionSelectionQuery, QuestionSelectionQueryVariables> & ({ variables: QuestionSelectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuestionSelectionQuery, QuestionSelectionQueryVariables>(QuestionSelectionDocument, options);
      }
export function useQuestionSelectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuestionSelectionQuery, QuestionSelectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuestionSelectionQuery, QuestionSelectionQueryVariables>(QuestionSelectionDocument, options);
        }
export function useQuestionSelectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QuestionSelectionQuery, QuestionSelectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QuestionSelectionQuery, QuestionSelectionQueryVariables>(QuestionSelectionDocument, options);
        }
export type QuestionSelectionQueryHookResult = ReturnType<typeof useQuestionSelectionQuery>;
export type QuestionSelectionLazyQueryHookResult = ReturnType<typeof useQuestionSelectionLazyQuery>;
export type QuestionSelectionSuspenseQueryHookResult = ReturnType<typeof useQuestionSelectionSuspenseQuery>;
export type QuestionSelectionQueryResult = Apollo.QueryResult<QuestionSelectionQuery, QuestionSelectionQueryVariables>;
export const QuestionVersionDocument = gql`
    query QuestionVersion($versionId: ID!) {
  questionVersion(versionId: $versionId) {
    ...QuestionVersion
  }
}
    ${QuestionVersionFragmentDoc}`;

/**
 * __useQuestionVersionQuery__
 *
 * To run a query within a React component, call `useQuestionVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuestionVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuestionVersionQuery({
 *   variables: {
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useQuestionVersionQuery(baseOptions: Apollo.QueryHookOptions<QuestionVersionQuery, QuestionVersionQueryVariables> & ({ variables: QuestionVersionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuestionVersionQuery, QuestionVersionQueryVariables>(QuestionVersionDocument, options);
      }
export function useQuestionVersionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuestionVersionQuery, QuestionVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuestionVersionQuery, QuestionVersionQueryVariables>(QuestionVersionDocument, options);
        }
export function useQuestionVersionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QuestionVersionQuery, QuestionVersionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QuestionVersionQuery, QuestionVersionQueryVariables>(QuestionVersionDocument, options);
        }
export type QuestionVersionQueryHookResult = ReturnType<typeof useQuestionVersionQuery>;
export type QuestionVersionLazyQueryHookResult = ReturnType<typeof useQuestionVersionLazyQuery>;
export type QuestionVersionSuspenseQueryHookResult = ReturnType<typeof useQuestionVersionSuspenseQuery>;
export type QuestionVersionQueryResult = Apollo.QueryResult<QuestionVersionQuery, QuestionVersionQueryVariables>;
export const RegenerateQuestionSetDocument = gql`
    mutation RegenerateQuestionSet($input: RegenerateQuestionSetInput!) {
  regenerateQuestionSet(input: $input) {
    questionSet {
      ...QuestionSet
    }
    incompleteReplacement
  }
}
    ${QuestionSetFragmentDoc}`;
export type RegenerateQuestionSetMutationFn = Apollo.MutationFunction<RegenerateQuestionSetMutation, RegenerateQuestionSetMutationVariables>;

/**
 * __useRegenerateQuestionSetMutation__
 *
 * To run a mutation, you first call `useRegenerateQuestionSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegenerateQuestionSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regenerateQuestionSetMutation, { data, loading, error }] = useRegenerateQuestionSetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegenerateQuestionSetMutation(baseOptions?: Apollo.MutationHookOptions<RegenerateQuestionSetMutation, RegenerateQuestionSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegenerateQuestionSetMutation, RegenerateQuestionSetMutationVariables>(RegenerateQuestionSetDocument, options);
      }
export type RegenerateQuestionSetMutationHookResult = ReturnType<typeof useRegenerateQuestionSetMutation>;
export type RegenerateQuestionSetMutationResult = Apollo.MutationResult<RegenerateQuestionSetMutation>;
export type RegenerateQuestionSetMutationOptions = Apollo.BaseMutationOptions<RegenerateQuestionSetMutation, RegenerateQuestionSetMutationVariables>;
export const RegisterQuestionSourceFileDocument = gql`
    mutation RegisterQuestionSourceFile($input: RegisterQuestionSourceFileInput!) {
  registerQuestionSourceFile(input: $input) {
    ...QuestionSourceFile
  }
}
    ${QuestionSourceFileFragmentDoc}`;
export type RegisterQuestionSourceFileMutationFn = Apollo.MutationFunction<RegisterQuestionSourceFileMutation, RegisterQuestionSourceFileMutationVariables>;

/**
 * __useRegisterQuestionSourceFileMutation__
 *
 * To run a mutation, you first call `useRegisterQuestionSourceFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterQuestionSourceFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerQuestionSourceFileMutation, { data, loading, error }] = useRegisterQuestionSourceFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterQuestionSourceFileMutation(baseOptions?: Apollo.MutationHookOptions<RegisterQuestionSourceFileMutation, RegisterQuestionSourceFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterQuestionSourceFileMutation, RegisterQuestionSourceFileMutationVariables>(RegisterQuestionSourceFileDocument, options);
      }
export type RegisterQuestionSourceFileMutationHookResult = ReturnType<typeof useRegisterQuestionSourceFileMutation>;
export type RegisterQuestionSourceFileMutationResult = Apollo.MutationResult<RegisterQuestionSourceFileMutation>;
export type RegisterQuestionSourceFileMutationOptions = Apollo.BaseMutationOptions<RegisterQuestionSourceFileMutation, RegisterQuestionSourceFileMutationVariables>;
export const RemoveQuestionsUniformlyDocument = gql`
    mutation RemoveQuestionsUniformly($input: RemoveQuestionsUniformlyInput!) {
  removeQuestionsUniformly(input: $input) {
    ...QuestionSelection
  }
}
    ${QuestionSelectionFragmentDoc}`;
export type RemoveQuestionsUniformlyMutationFn = Apollo.MutationFunction<RemoveQuestionsUniformlyMutation, RemoveQuestionsUniformlyMutationVariables>;

/**
 * __useRemoveQuestionsUniformlyMutation__
 *
 * To run a mutation, you first call `useRemoveQuestionsUniformlyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveQuestionsUniformlyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeQuestionsUniformlyMutation, { data, loading, error }] = useRemoveQuestionsUniformlyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveQuestionsUniformlyMutation(baseOptions?: Apollo.MutationHookOptions<RemoveQuestionsUniformlyMutation, RemoveQuestionsUniformlyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveQuestionsUniformlyMutation, RemoveQuestionsUniformlyMutationVariables>(RemoveQuestionsUniformlyDocument, options);
      }
export type RemoveQuestionsUniformlyMutationHookResult = ReturnType<typeof useRemoveQuestionsUniformlyMutation>;
export type RemoveQuestionsUniformlyMutationResult = Apollo.MutationResult<RemoveQuestionsUniformlyMutation>;
export type RemoveQuestionsUniformlyMutationOptions = Apollo.BaseMutationOptions<RemoveQuestionsUniformlyMutation, RemoveQuestionsUniformlyMutationVariables>;
export const ReplaceQuestionInSetDocument = gql`
    mutation ReplaceQuestionInSet($input: ReplaceQuestionInSetInput!) {
  replaceQuestionInSet(input: $input) {
    ...QuestionSet
  }
}
    ${QuestionSetFragmentDoc}`;
export type ReplaceQuestionInSetMutationFn = Apollo.MutationFunction<ReplaceQuestionInSetMutation, ReplaceQuestionInSetMutationVariables>;

/**
 * __useReplaceQuestionInSetMutation__
 *
 * To run a mutation, you first call `useReplaceQuestionInSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplaceQuestionInSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replaceQuestionInSetMutation, { data, loading, error }] = useReplaceQuestionInSetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReplaceQuestionInSetMutation(baseOptions?: Apollo.MutationHookOptions<ReplaceQuestionInSetMutation, ReplaceQuestionInSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplaceQuestionInSetMutation, ReplaceQuestionInSetMutationVariables>(ReplaceQuestionInSetDocument, options);
      }
export type ReplaceQuestionInSetMutationHookResult = ReturnType<typeof useReplaceQuestionInSetMutation>;
export type ReplaceQuestionInSetMutationResult = Apollo.MutationResult<ReplaceQuestionInSetMutation>;
export type ReplaceQuestionInSetMutationOptions = Apollo.BaseMutationOptions<ReplaceQuestionInSetMutation, ReplaceQuestionInSetMutationVariables>;
export const UpdateQuestionAttributesDocument = gql`
    mutation UpdateQuestionAttributes($questionIds: [ID!]!, $input: QuestionAttributesInput!) {
  updateQuestionAttributes(questionIds: $questionIds, input: $input) {
    ...LibraryQuestionOverview
  }
}
    ${LibraryQuestionOverviewFragmentDoc}`;
export type UpdateQuestionAttributesMutationFn = Apollo.MutationFunction<UpdateQuestionAttributesMutation, UpdateQuestionAttributesMutationVariables>;

/**
 * __useUpdateQuestionAttributesMutation__
 *
 * To run a mutation, you first call `useUpdateQuestionAttributesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionAttributesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuestionAttributesMutation, { data, loading, error }] = useUpdateQuestionAttributesMutation({
 *   variables: {
 *      questionIds: // value for 'questionIds'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuestionAttributesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuestionAttributesMutation, UpdateQuestionAttributesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuestionAttributesMutation, UpdateQuestionAttributesMutationVariables>(UpdateQuestionAttributesDocument, options);
      }
export type UpdateQuestionAttributesMutationHookResult = ReturnType<typeof useUpdateQuestionAttributesMutation>;
export type UpdateQuestionAttributesMutationResult = Apollo.MutationResult<UpdateQuestionAttributesMutation>;
export type UpdateQuestionAttributesMutationOptions = Apollo.BaseMutationOptions<UpdateQuestionAttributesMutation, UpdateQuestionAttributesMutationVariables>;
export const UpdateQuestionDocument = gql`
    mutation UpdateQuestion($questionId: ID!, $input: QuestionAttributesInput!) {
  updateQuestion(questionId: $questionId, input: $input) {
    ...LibraryQuestion
  }
}
    ${LibraryQuestionFragmentDoc}`;
export type UpdateQuestionMutationFn = Apollo.MutationFunction<UpdateQuestionMutation, UpdateQuestionMutationVariables>;

/**
 * __useUpdateQuestionMutation__
 *
 * To run a mutation, you first call `useUpdateQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuestionMutation, { data, loading, error }] = useUpdateQuestionMutation({
 *   variables: {
 *      questionId: // value for 'questionId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuestionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuestionMutation, UpdateQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuestionMutation, UpdateQuestionMutationVariables>(UpdateQuestionDocument, options);
      }
export type UpdateQuestionMutationHookResult = ReturnType<typeof useUpdateQuestionMutation>;
export type UpdateQuestionMutationResult = Apollo.MutationResult<UpdateQuestionMutation>;
export type UpdateQuestionMutationOptions = Apollo.BaseMutationOptions<UpdateQuestionMutation, UpdateQuestionMutationVariables>;
export const UpdateQuestionSourceFileDocument = gql`
    mutation UpdateQuestionSourceFile($input: UpdateQuestionSourceFileInput!) {
  updateQuestionSourceFile(input: $input) {
    ...QuestionSourceFile
  }
}
    ${QuestionSourceFileFragmentDoc}`;
export type UpdateQuestionSourceFileMutationFn = Apollo.MutationFunction<UpdateQuestionSourceFileMutation, UpdateQuestionSourceFileMutationVariables>;

/**
 * __useUpdateQuestionSourceFileMutation__
 *
 * To run a mutation, you first call `useUpdateQuestionSourceFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionSourceFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuestionSourceFileMutation, { data, loading, error }] = useUpdateQuestionSourceFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuestionSourceFileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuestionSourceFileMutation, UpdateQuestionSourceFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuestionSourceFileMutation, UpdateQuestionSourceFileMutationVariables>(UpdateQuestionSourceFileDocument, options);
      }
export type UpdateQuestionSourceFileMutationHookResult = ReturnType<typeof useUpdateQuestionSourceFileMutation>;
export type UpdateQuestionSourceFileMutationResult = Apollo.MutationResult<UpdateQuestionSourceFileMutation>;
export type UpdateQuestionSourceFileMutationOptions = Apollo.BaseMutationOptions<UpdateQuestionSourceFileMutation, UpdateQuestionSourceFileMutationVariables>;
export const UpdateQuestionVersionDocument = gql`
    mutation updateQuestionVersion($input: UpdateQuestionVersionInput!, $childrenQuestions: [UpdateQuestionVersionInput!]!) {
  updateQuestionVersion(input: $input, childrenQuestions: $childrenQuestions) {
    ...LibraryQuestion
  }
}
    ${LibraryQuestionFragmentDoc}`;
export type UpdateQuestionVersionMutationFn = Apollo.MutationFunction<UpdateQuestionVersionMutation, UpdateQuestionVersionMutationVariables>;

/**
 * __useUpdateQuestionVersionMutation__
 *
 * To run a mutation, you first call `useUpdateQuestionVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuestionVersionMutation, { data, loading, error }] = useUpdateQuestionVersionMutation({
 *   variables: {
 *      input: // value for 'input'
 *      childrenQuestions: // value for 'childrenQuestions'
 *   },
 * });
 */
export function useUpdateQuestionVersionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuestionVersionMutation, UpdateQuestionVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuestionVersionMutation, UpdateQuestionVersionMutationVariables>(UpdateQuestionVersionDocument, options);
      }
export type UpdateQuestionVersionMutationHookResult = ReturnType<typeof useUpdateQuestionVersionMutation>;
export type UpdateQuestionVersionMutationResult = Apollo.MutationResult<UpdateQuestionVersionMutation>;
export type UpdateQuestionVersionMutationOptions = Apollo.BaseMutationOptions<UpdateQuestionVersionMutation, UpdateQuestionVersionMutationVariables>;
export const UpdateTagsForQuestionDocument = gql`
    mutation UpdateTagsForQuestion($questionId: ID!, $input: [TagInput!]!) {
  updateTagsForQuestion(questionId: $questionId, input: $input) {
    id
    cacheId
    tags {
      ...QuestionTag
    }
  }
}
    ${QuestionTagFragmentDoc}`;
export type UpdateTagsForQuestionMutationFn = Apollo.MutationFunction<UpdateTagsForQuestionMutation, UpdateTagsForQuestionMutationVariables>;

/**
 * __useUpdateTagsForQuestionMutation__
 *
 * To run a mutation, you first call `useUpdateTagsForQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTagsForQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTagsForQuestionMutation, { data, loading, error }] = useUpdateTagsForQuestionMutation({
 *   variables: {
 *      questionId: // value for 'questionId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTagsForQuestionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTagsForQuestionMutation, UpdateTagsForQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTagsForQuestionMutation, UpdateTagsForQuestionMutationVariables>(UpdateTagsForQuestionDocument, options);
      }
export type UpdateTagsForQuestionMutationHookResult = ReturnType<typeof useUpdateTagsForQuestionMutation>;
export type UpdateTagsForQuestionMutationResult = Apollo.MutationResult<UpdateTagsForQuestionMutation>;
export type UpdateTagsForQuestionMutationOptions = Apollo.BaseMutationOptions<UpdateTagsForQuestionMutation, UpdateTagsForQuestionMutationVariables>;
export const CreateSchoolyearDashboardUrlDocument = gql`
    mutation CreateSchoolyearDashboardUrl($assessmentId: ID!) {
  createSchoolyearDashboardUrl(assessmentId: $assessmentId) {
    url
  }
}
    `;
export type CreateSchoolyearDashboardUrlMutationFn = Apollo.MutationFunction<CreateSchoolyearDashboardUrlMutation, CreateSchoolyearDashboardUrlMutationVariables>;

/**
 * __useCreateSchoolyearDashboardUrlMutation__
 *
 * To run a mutation, you first call `useCreateSchoolyearDashboardUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSchoolyearDashboardUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSchoolyearDashboardUrlMutation, { data, loading, error }] = useCreateSchoolyearDashboardUrlMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useCreateSchoolyearDashboardUrlMutation(baseOptions?: Apollo.MutationHookOptions<CreateSchoolyearDashboardUrlMutation, CreateSchoolyearDashboardUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSchoolyearDashboardUrlMutation, CreateSchoolyearDashboardUrlMutationVariables>(CreateSchoolyearDashboardUrlDocument, options);
      }
export type CreateSchoolyearDashboardUrlMutationHookResult = ReturnType<typeof useCreateSchoolyearDashboardUrlMutation>;
export type CreateSchoolyearDashboardUrlMutationResult = Apollo.MutationResult<CreateSchoolyearDashboardUrlMutation>;
export type CreateSchoolyearDashboardUrlMutationOptions = Apollo.BaseMutationOptions<CreateSchoolyearDashboardUrlMutation, CreateSchoolyearDashboardUrlMutationVariables>;
export const CreateSchoolyearSettingsUrlDocument = gql`
    mutation CreateSchoolyearSettingsUrl($assessmentId: ID!) {
  createSchoolyearSettingsUrl(assessmentId: $assessmentId) {
    url
  }
}
    `;
export type CreateSchoolyearSettingsUrlMutationFn = Apollo.MutationFunction<CreateSchoolyearSettingsUrlMutation, CreateSchoolyearSettingsUrlMutationVariables>;

/**
 * __useCreateSchoolyearSettingsUrlMutation__
 *
 * To run a mutation, you first call `useCreateSchoolyearSettingsUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSchoolyearSettingsUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSchoolyearSettingsUrlMutation, { data, loading, error }] = useCreateSchoolyearSettingsUrlMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useCreateSchoolyearSettingsUrlMutation(baseOptions?: Apollo.MutationHookOptions<CreateSchoolyearSettingsUrlMutation, CreateSchoolyearSettingsUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSchoolyearSettingsUrlMutation, CreateSchoolyearSettingsUrlMutationVariables>(CreateSchoolyearSettingsUrlDocument, options);
      }
export type CreateSchoolyearSettingsUrlMutationHookResult = ReturnType<typeof useCreateSchoolyearSettingsUrlMutation>;
export type CreateSchoolyearSettingsUrlMutationResult = Apollo.MutationResult<CreateSchoolyearSettingsUrlMutation>;
export type CreateSchoolyearSettingsUrlMutationOptions = Apollo.BaseMutationOptions<CreateSchoolyearSettingsUrlMutation, CreateSchoolyearSettingsUrlMutationVariables>;
export const OnSchoolyearExamUpdatedDocument = gql`
    subscription onSchoolyearExamUpdated($assessmentId: ID!) {
  schoolyearExamUpdated(assessmentId: $assessmentId) {
    ...SchoolyearExam
  }
}
    ${SchoolyearExamFragmentDoc}`;

/**
 * __useOnSchoolyearExamUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnSchoolyearExamUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnSchoolyearExamUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnSchoolyearExamUpdatedSubscription({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useOnSchoolyearExamUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnSchoolyearExamUpdatedSubscription, OnSchoolyearExamUpdatedSubscriptionVariables> & ({ variables: OnSchoolyearExamUpdatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnSchoolyearExamUpdatedSubscription, OnSchoolyearExamUpdatedSubscriptionVariables>(OnSchoolyearExamUpdatedDocument, options);
      }
export type OnSchoolyearExamUpdatedSubscriptionHookResult = ReturnType<typeof useOnSchoolyearExamUpdatedSubscription>;
export type OnSchoolyearExamUpdatedSubscriptionResult = Apollo.SubscriptionResult<OnSchoolyearExamUpdatedSubscription>;
export const AssessmentSentimentDocument = gql`
    query AssessmentSentiment($assessmentId: ID!) {
  assessmentSentimentChecks(assessmentId: $assessmentId) {
    ...SentimentCheck
  }
}
    ${SentimentCheckFragmentDoc}`;

/**
 * __useAssessmentSentimentQuery__
 *
 * To run a query within a React component, call `useAssessmentSentimentQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssessmentSentimentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssessmentSentimentQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useAssessmentSentimentQuery(baseOptions: Apollo.QueryHookOptions<AssessmentSentimentQuery, AssessmentSentimentQueryVariables> & ({ variables: AssessmentSentimentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssessmentSentimentQuery, AssessmentSentimentQueryVariables>(AssessmentSentimentDocument, options);
      }
export function useAssessmentSentimentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssessmentSentimentQuery, AssessmentSentimentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssessmentSentimentQuery, AssessmentSentimentQueryVariables>(AssessmentSentimentDocument, options);
        }
export function useAssessmentSentimentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssessmentSentimentQuery, AssessmentSentimentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AssessmentSentimentQuery, AssessmentSentimentQueryVariables>(AssessmentSentimentDocument, options);
        }
export type AssessmentSentimentQueryHookResult = ReturnType<typeof useAssessmentSentimentQuery>;
export type AssessmentSentimentLazyQueryHookResult = ReturnType<typeof useAssessmentSentimentLazyQuery>;
export type AssessmentSentimentSuspenseQueryHookResult = ReturnType<typeof useAssessmentSentimentSuspenseQuery>;
export type AssessmentSentimentQueryResult = Apollo.QueryResult<AssessmentSentimentQuery, AssessmentSentimentQueryVariables>;
export const SentimentDocument = gql`
    query Sentiment($assessmentId: ID!, $groupId: ID!) {
  assessment(assessmentId: $assessmentId) {
    ...Assessment
  }
  groupSentimentChecks(assessmentId: $assessmentId, groupId: $groupId) {
    ...SentimentCheck
  }
  class(assessmentId: $assessmentId) {
    groups {
      ...Group
    }
  }
}
    ${AssessmentFragmentDoc}
${SentimentCheckFragmentDoc}
${GroupFragmentDoc}`;

/**
 * __useSentimentQuery__
 *
 * To run a query within a React component, call `useSentimentQuery` and pass it any options that fit your needs.
 * When your component renders, `useSentimentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSentimentQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useSentimentQuery(baseOptions: Apollo.QueryHookOptions<SentimentQuery, SentimentQueryVariables> & ({ variables: SentimentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SentimentQuery, SentimentQueryVariables>(SentimentDocument, options);
      }
export function useSentimentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SentimentQuery, SentimentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SentimentQuery, SentimentQueryVariables>(SentimentDocument, options);
        }
export function useSentimentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SentimentQuery, SentimentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SentimentQuery, SentimentQueryVariables>(SentimentDocument, options);
        }
export type SentimentQueryHookResult = ReturnType<typeof useSentimentQuery>;
export type SentimentLazyQueryHookResult = ReturnType<typeof useSentimentLazyQuery>;
export type SentimentSuspenseQueryHookResult = ReturnType<typeof useSentimentSuspenseQuery>;
export type SentimentQueryResult = Apollo.QueryResult<SentimentQuery, SentimentQueryVariables>;
export const SocraticDialoguesDocument = gql`
    query SocraticDialogues($assessmentId: ID!, $dialogueIds: [ID!]!) {
  socraticDialogues(assessmentId: $assessmentId, dialogueIds: $dialogueIds) {
    ...SocraticDialogue
  }
}
    ${SocraticDialogueFragmentDoc}`;

/**
 * __useSocraticDialoguesQuery__
 *
 * To run a query within a React component, call `useSocraticDialoguesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocraticDialoguesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocraticDialoguesQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      dialogueIds: // value for 'dialogueIds'
 *   },
 * });
 */
export function useSocraticDialoguesQuery(baseOptions: Apollo.QueryHookOptions<SocraticDialoguesQuery, SocraticDialoguesQueryVariables> & ({ variables: SocraticDialoguesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SocraticDialoguesQuery, SocraticDialoguesQueryVariables>(SocraticDialoguesDocument, options);
      }
export function useSocraticDialoguesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SocraticDialoguesQuery, SocraticDialoguesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SocraticDialoguesQuery, SocraticDialoguesQueryVariables>(SocraticDialoguesDocument, options);
        }
export function useSocraticDialoguesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SocraticDialoguesQuery, SocraticDialoguesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SocraticDialoguesQuery, SocraticDialoguesQueryVariables>(SocraticDialoguesDocument, options);
        }
export type SocraticDialoguesQueryHookResult = ReturnType<typeof useSocraticDialoguesQuery>;
export type SocraticDialoguesLazyQueryHookResult = ReturnType<typeof useSocraticDialoguesLazyQuery>;
export type SocraticDialoguesSuspenseQueryHookResult = ReturnType<typeof useSocraticDialoguesSuspenseQuery>;
export type SocraticDialoguesQueryResult = Apollo.QueryResult<SocraticDialoguesQuery, SocraticDialoguesQueryVariables>;
export const SocraticQuestionerPreviewDocument = gql`
    query SocraticQuestionerPreview($assessmentId: ID!, $taskId: ID!, $input: SocraticQuestionerPreviewInput!) {
  assessment(assessmentId: $assessmentId) {
    id
    settings {
      vivaSourceTask {
        ...VivaSourceTask
      }
    }
  }
  socraticQuestionerPreview(taskId: $taskId, input: $input) {
    ...SocraticQuestionerPreview
  }
}
    ${VivaSourceTaskFragmentDoc}
${SocraticQuestionerPreviewFragmentDoc}`;

/**
 * __useSocraticQuestionerPreviewQuery__
 *
 * To run a query within a React component, call `useSocraticQuestionerPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocraticQuestionerPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocraticQuestionerPreviewQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      taskId: // value for 'taskId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSocraticQuestionerPreviewQuery(baseOptions: Apollo.QueryHookOptions<SocraticQuestionerPreviewQuery, SocraticQuestionerPreviewQueryVariables> & ({ variables: SocraticQuestionerPreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SocraticQuestionerPreviewQuery, SocraticQuestionerPreviewQueryVariables>(SocraticQuestionerPreviewDocument, options);
      }
export function useSocraticQuestionerPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SocraticQuestionerPreviewQuery, SocraticQuestionerPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SocraticQuestionerPreviewQuery, SocraticQuestionerPreviewQueryVariables>(SocraticQuestionerPreviewDocument, options);
        }
export function useSocraticQuestionerPreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SocraticQuestionerPreviewQuery, SocraticQuestionerPreviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SocraticQuestionerPreviewQuery, SocraticQuestionerPreviewQueryVariables>(SocraticQuestionerPreviewDocument, options);
        }
export type SocraticQuestionerPreviewQueryHookResult = ReturnType<typeof useSocraticQuestionerPreviewQuery>;
export type SocraticQuestionerPreviewLazyQueryHookResult = ReturnType<typeof useSocraticQuestionerPreviewLazyQuery>;
export type SocraticQuestionerPreviewSuspenseQueryHookResult = ReturnType<typeof useSocraticQuestionerPreviewSuspenseQuery>;
export type SocraticQuestionerPreviewQueryResult = Apollo.QueryResult<SocraticQuestionerPreviewQuery, SocraticQuestionerPreviewQueryVariables>;
export const SocraticQuestionerRunUpdatedDocument = gql`
    subscription SocraticQuestionerRunUpdated($runId: ID!) {
  socraticQuestionerRunUpdated(runId: $runId) {
    ...SocraticQuestion
  }
}
    ${SocraticQuestionFragmentDoc}`;

/**
 * __useSocraticQuestionerRunUpdatedSubscription__
 *
 * To run a query within a React component, call `useSocraticQuestionerRunUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSocraticQuestionerRunUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocraticQuestionerRunUpdatedSubscription({
 *   variables: {
 *      runId: // value for 'runId'
 *   },
 * });
 */
export function useSocraticQuestionerRunUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<SocraticQuestionerRunUpdatedSubscription, SocraticQuestionerRunUpdatedSubscriptionVariables> & ({ variables: SocraticQuestionerRunUpdatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SocraticQuestionerRunUpdatedSubscription, SocraticQuestionerRunUpdatedSubscriptionVariables>(SocraticQuestionerRunUpdatedDocument, options);
      }
export type SocraticQuestionerRunUpdatedSubscriptionHookResult = ReturnType<typeof useSocraticQuestionerRunUpdatedSubscription>;
export type SocraticQuestionerRunUpdatedSubscriptionResult = Apollo.SubscriptionResult<SocraticQuestionerRunUpdatedSubscription>;
export const SocraticTranscriptDocument = gql`
    query SocraticTranscript($assessmentId: ID!, $dialogueId: ID!) {
  socraticTranscript(assessmentId: $assessmentId, dialogueId: $dialogueId) {
    status
    error
    text
    segments {
      text
      startTime
      endTime
    }
  }
}
    `;

/**
 * __useSocraticTranscriptQuery__
 *
 * To run a query within a React component, call `useSocraticTranscriptQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocraticTranscriptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocraticTranscriptQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      dialogueId: // value for 'dialogueId'
 *   },
 * });
 */
export function useSocraticTranscriptQuery(baseOptions: Apollo.QueryHookOptions<SocraticTranscriptQuery, SocraticTranscriptQueryVariables> & ({ variables: SocraticTranscriptQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SocraticTranscriptQuery, SocraticTranscriptQueryVariables>(SocraticTranscriptDocument, options);
      }
export function useSocraticTranscriptLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SocraticTranscriptQuery, SocraticTranscriptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SocraticTranscriptQuery, SocraticTranscriptQueryVariables>(SocraticTranscriptDocument, options);
        }
export function useSocraticTranscriptSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SocraticTranscriptQuery, SocraticTranscriptQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SocraticTranscriptQuery, SocraticTranscriptQueryVariables>(SocraticTranscriptDocument, options);
        }
export type SocraticTranscriptQueryHookResult = ReturnType<typeof useSocraticTranscriptQuery>;
export type SocraticTranscriptLazyQueryHookResult = ReturnType<typeof useSocraticTranscriptLazyQuery>;
export type SocraticTranscriptSuspenseQueryHookResult = ReturnType<typeof useSocraticTranscriptSuspenseQuery>;
export type SocraticTranscriptQueryResult = Apollo.QueryResult<SocraticTranscriptQuery, SocraticTranscriptQueryVariables>;
export const SocraticTranscriptionUpdatedDocument = gql`
    subscription SocraticTranscriptionUpdated($dialogueId: ID!) {
  socraticTranscriptionUpdated(dialogueId: $dialogueId) {
    turnId
    dialogueId
    status
    error
  }
}
    `;

/**
 * __useSocraticTranscriptionUpdatedSubscription__
 *
 * To run a query within a React component, call `useSocraticTranscriptionUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSocraticTranscriptionUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocraticTranscriptionUpdatedSubscription({
 *   variables: {
 *      dialogueId: // value for 'dialogueId'
 *   },
 * });
 */
export function useSocraticTranscriptionUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<SocraticTranscriptionUpdatedSubscription, SocraticTranscriptionUpdatedSubscriptionVariables> & ({ variables: SocraticTranscriptionUpdatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SocraticTranscriptionUpdatedSubscription, SocraticTranscriptionUpdatedSubscriptionVariables>(SocraticTranscriptionUpdatedDocument, options);
      }
export type SocraticTranscriptionUpdatedSubscriptionHookResult = ReturnType<typeof useSocraticTranscriptionUpdatedSubscription>;
export type SocraticTranscriptionUpdatedSubscriptionResult = Apollo.SubscriptionResult<SocraticTranscriptionUpdatedSubscription>;
export const StartSocraticQuestionerRunDocument = gql`
    mutation StartSocraticQuestionerRun($taskId: ID!, $input: StartSocraticQuestionerRunInput!) {
  startSocraticQuestionerRun(taskId: $taskId, input: $input) {
    run {
      ...SocraticQuestionerRun
    }
    error
  }
}
    ${SocraticQuestionerRunFragmentDoc}`;
export type StartSocraticQuestionerRunMutationFn = Apollo.MutationFunction<StartSocraticQuestionerRunMutation, StartSocraticQuestionerRunMutationVariables>;

/**
 * __useStartSocraticQuestionerRunMutation__
 *
 * To run a mutation, you first call `useStartSocraticQuestionerRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartSocraticQuestionerRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startSocraticQuestionerRunMutation, { data, loading, error }] = useStartSocraticQuestionerRunMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartSocraticQuestionerRunMutation(baseOptions?: Apollo.MutationHookOptions<StartSocraticQuestionerRunMutation, StartSocraticQuestionerRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartSocraticQuestionerRunMutation, StartSocraticQuestionerRunMutationVariables>(StartSocraticQuestionerRunDocument, options);
      }
export type StartSocraticQuestionerRunMutationHookResult = ReturnType<typeof useStartSocraticQuestionerRunMutation>;
export type StartSocraticQuestionerRunMutationResult = Apollo.MutationResult<StartSocraticQuestionerRunMutation>;
export type StartSocraticQuestionerRunMutationOptions = Apollo.BaseMutationOptions<StartSocraticQuestionerRunMutation, StartSocraticQuestionerRunMutationVariables>;
export const StudentWorkOutcomePreviewDocument = gql`
    query StudentWorkOutcomePreview($assessmentId: ID!, $studentId: ID!) {
  assessment(assessmentId: $assessmentId) {
    id
    name
  }
  studentWorkOutcome(assessmentId: $assessmentId, studentId: $studentId) {
    ...WorkOutcomePreview
  }
}
    ${WorkOutcomePreviewFragmentDoc}`;

/**
 * __useStudentWorkOutcomePreviewQuery__
 *
 * To run a query within a React component, call `useStudentWorkOutcomePreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentWorkOutcomePreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentWorkOutcomePreviewQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useStudentWorkOutcomePreviewQuery(baseOptions: Apollo.QueryHookOptions<StudentWorkOutcomePreviewQuery, StudentWorkOutcomePreviewQueryVariables> & ({ variables: StudentWorkOutcomePreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentWorkOutcomePreviewQuery, StudentWorkOutcomePreviewQueryVariables>(StudentWorkOutcomePreviewDocument, options);
      }
export function useStudentWorkOutcomePreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentWorkOutcomePreviewQuery, StudentWorkOutcomePreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentWorkOutcomePreviewQuery, StudentWorkOutcomePreviewQueryVariables>(StudentWorkOutcomePreviewDocument, options);
        }
export function useStudentWorkOutcomePreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StudentWorkOutcomePreviewQuery, StudentWorkOutcomePreviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StudentWorkOutcomePreviewQuery, StudentWorkOutcomePreviewQueryVariables>(StudentWorkOutcomePreviewDocument, options);
        }
export type StudentWorkOutcomePreviewQueryHookResult = ReturnType<typeof useStudentWorkOutcomePreviewQuery>;
export type StudentWorkOutcomePreviewLazyQueryHookResult = ReturnType<typeof useStudentWorkOutcomePreviewLazyQuery>;
export type StudentWorkOutcomePreviewSuspenseQueryHookResult = ReturnType<typeof useStudentWorkOutcomePreviewSuspenseQuery>;
export type StudentWorkOutcomePreviewQueryResult = Apollo.QueryResult<StudentWorkOutcomePreviewQuery, StudentWorkOutcomePreviewQueryVariables>;
export const AddLibraryQuestionsToTaskDocument = gql`
    mutation AddLibraryQuestionsToTask($taskId: ID!, $questionIds: [ID!]!) {
  addLibraryQuestionsToTask(taskId: $taskId, questionIds: $questionIds) {
    ...TaskBlock
  }
}
    ${TaskBlockFragmentDoc}`;
export type AddLibraryQuestionsToTaskMutationFn = Apollo.MutationFunction<AddLibraryQuestionsToTaskMutation, AddLibraryQuestionsToTaskMutationVariables>;

/**
 * __useAddLibraryQuestionsToTaskMutation__
 *
 * To run a mutation, you first call `useAddLibraryQuestionsToTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLibraryQuestionsToTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLibraryQuestionsToTaskMutation, { data, loading, error }] = useAddLibraryQuestionsToTaskMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      questionIds: // value for 'questionIds'
 *   },
 * });
 */
export function useAddLibraryQuestionsToTaskMutation(baseOptions?: Apollo.MutationHookOptions<AddLibraryQuestionsToTaskMutation, AddLibraryQuestionsToTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddLibraryQuestionsToTaskMutation, AddLibraryQuestionsToTaskMutationVariables>(AddLibraryQuestionsToTaskDocument, options);
      }
export type AddLibraryQuestionsToTaskMutationHookResult = ReturnType<typeof useAddLibraryQuestionsToTaskMutation>;
export type AddLibraryQuestionsToTaskMutationResult = Apollo.MutationResult<AddLibraryQuestionsToTaskMutation>;
export type AddLibraryQuestionsToTaskMutationOptions = Apollo.BaseMutationOptions<AddLibraryQuestionsToTaskMutation, AddLibraryQuestionsToTaskMutationVariables>;
export const AddQuestionSelectionToTaskDocument = gql`
    mutation AddQuestionSelectionToTask($taskId: ID!, $questionSelectionId: ID!) {
  addQuestionSelectionToTask(
    taskId: $taskId
    questionSelectionId: $questionSelectionId
  ) {
    ...TaskBlock
  }
}
    ${TaskBlockFragmentDoc}`;
export type AddQuestionSelectionToTaskMutationFn = Apollo.MutationFunction<AddQuestionSelectionToTaskMutation, AddQuestionSelectionToTaskMutationVariables>;

/**
 * __useAddQuestionSelectionToTaskMutation__
 *
 * To run a mutation, you first call `useAddQuestionSelectionToTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddQuestionSelectionToTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addQuestionSelectionToTaskMutation, { data, loading, error }] = useAddQuestionSelectionToTaskMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      questionSelectionId: // value for 'questionSelectionId'
 *   },
 * });
 */
export function useAddQuestionSelectionToTaskMutation(baseOptions?: Apollo.MutationHookOptions<AddQuestionSelectionToTaskMutation, AddQuestionSelectionToTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddQuestionSelectionToTaskMutation, AddQuestionSelectionToTaskMutationVariables>(AddQuestionSelectionToTaskDocument, options);
      }
export type AddQuestionSelectionToTaskMutationHookResult = ReturnType<typeof useAddQuestionSelectionToTaskMutation>;
export type AddQuestionSelectionToTaskMutationResult = Apollo.MutationResult<AddQuestionSelectionToTaskMutation>;
export type AddQuestionSelectionToTaskMutationOptions = Apollo.BaseMutationOptions<AddQuestionSelectionToTaskMutation, AddQuestionSelectionToTaskMutationVariables>;
export const AssessmentAccessCodesDocument = gql`
    query AssessmentAccessCodes($assessmentId: ID!) {
  assessmentAccessCodes(assessmentId: $assessmentId) {
    ...AccessCode
  }
}
    ${AccessCodeFragmentDoc}`;

/**
 * __useAssessmentAccessCodesQuery__
 *
 * To run a query within a React component, call `useAssessmentAccessCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssessmentAccessCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssessmentAccessCodesQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useAssessmentAccessCodesQuery(baseOptions: Apollo.QueryHookOptions<AssessmentAccessCodesQuery, AssessmentAccessCodesQueryVariables> & ({ variables: AssessmentAccessCodesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssessmentAccessCodesQuery, AssessmentAccessCodesQueryVariables>(AssessmentAccessCodesDocument, options);
      }
export function useAssessmentAccessCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssessmentAccessCodesQuery, AssessmentAccessCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssessmentAccessCodesQuery, AssessmentAccessCodesQueryVariables>(AssessmentAccessCodesDocument, options);
        }
export function useAssessmentAccessCodesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssessmentAccessCodesQuery, AssessmentAccessCodesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AssessmentAccessCodesQuery, AssessmentAccessCodesQueryVariables>(AssessmentAccessCodesDocument, options);
        }
export type AssessmentAccessCodesQueryHookResult = ReturnType<typeof useAssessmentAccessCodesQuery>;
export type AssessmentAccessCodesLazyQueryHookResult = ReturnType<typeof useAssessmentAccessCodesLazyQuery>;
export type AssessmentAccessCodesSuspenseQueryHookResult = ReturnType<typeof useAssessmentAccessCodesSuspenseQuery>;
export type AssessmentAccessCodesQueryResult = Apollo.QueryResult<AssessmentAccessCodesQuery, AssessmentAccessCodesQueryVariables>;
export const AssessmentSettingsDocument = gql`
    subscription AssessmentSettings($assessmentId: ID!) {
  assessmentSettings(assessmentId: $assessmentId) {
    ...AssessmentSettings
  }
}
    ${AssessmentSettingsFragmentDoc}`;

/**
 * __useAssessmentSettingsSubscription__
 *
 * To run a query within a React component, call `useAssessmentSettingsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAssessmentSettingsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssessmentSettingsSubscription({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useAssessmentSettingsSubscription(baseOptions: Apollo.SubscriptionHookOptions<AssessmentSettingsSubscription, AssessmentSettingsSubscriptionVariables> & ({ variables: AssessmentSettingsSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<AssessmentSettingsSubscription, AssessmentSettingsSubscriptionVariables>(AssessmentSettingsDocument, options);
      }
export type AssessmentSettingsSubscriptionHookResult = ReturnType<typeof useAssessmentSettingsSubscription>;
export type AssessmentSettingsSubscriptionResult = Apollo.SubscriptionResult<AssessmentSettingsSubscription>;
export const CancelReleaseDocument = gql`
    mutation CancelRelease($assessmentId: ID!, $sheetId: ID!) {
  cancelRelease(assessmentId: $assessmentId, sheetId: $sheetId) {
    task {
      ...TaskStatus
    }
  }
}
    ${TaskStatusFragmentDoc}`;
export type CancelReleaseMutationFn = Apollo.MutationFunction<CancelReleaseMutation, CancelReleaseMutationVariables>;

/**
 * __useCancelReleaseMutation__
 *
 * To run a mutation, you first call `useCancelReleaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelReleaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelReleaseMutation, { data, loading, error }] = useCancelReleaseMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      sheetId: // value for 'sheetId'
 *   },
 * });
 */
export function useCancelReleaseMutation(baseOptions?: Apollo.MutationHookOptions<CancelReleaseMutation, CancelReleaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelReleaseMutation, CancelReleaseMutationVariables>(CancelReleaseDocument, options);
      }
export type CancelReleaseMutationHookResult = ReturnType<typeof useCancelReleaseMutation>;
export type CancelReleaseMutationResult = Apollo.MutationResult<CancelReleaseMutation>;
export type CancelReleaseMutationOptions = Apollo.BaseMutationOptions<CancelReleaseMutation, CancelReleaseMutationVariables>;
export const ChangeAssessmentPresetDocument = gql`
    mutation ChangeAssessmentPreset($assessmentId: ID!, $preset: AssessmentPreset!) {
  changeAssessmentPreset(assessmentId: $assessmentId, preset: $preset) {
    task {
      ...TaskFormat
    }
    assessmentSettings {
      id
      vivaEnabled
      groupAssessmentEnabled
    }
  }
}
    ${TaskFormatFragmentDoc}`;
export type ChangeAssessmentPresetMutationFn = Apollo.MutationFunction<ChangeAssessmentPresetMutation, ChangeAssessmentPresetMutationVariables>;

/**
 * __useChangeAssessmentPresetMutation__
 *
 * To run a mutation, you first call `useChangeAssessmentPresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeAssessmentPresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeAssessmentPresetMutation, { data, loading, error }] = useChangeAssessmentPresetMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      preset: // value for 'preset'
 *   },
 * });
 */
export function useChangeAssessmentPresetMutation(baseOptions?: Apollo.MutationHookOptions<ChangeAssessmentPresetMutation, ChangeAssessmentPresetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeAssessmentPresetMutation, ChangeAssessmentPresetMutationVariables>(ChangeAssessmentPresetDocument, options);
      }
export type ChangeAssessmentPresetMutationHookResult = ReturnType<typeof useChangeAssessmentPresetMutation>;
export type ChangeAssessmentPresetMutationResult = Apollo.MutationResult<ChangeAssessmentPresetMutation>;
export type ChangeAssessmentPresetMutationOptions = Apollo.BaseMutationOptions<ChangeAssessmentPresetMutation, ChangeAssessmentPresetMutationVariables>;
export const CreatePrintArchiveDocument = gql`
    mutation CreatePrintArchive($taskId: ID!, $input: PrintArchiveInput!) {
  createPrintArchive(taskId: $taskId, input: $input)
}
    `;
export type CreatePrintArchiveMutationFn = Apollo.MutationFunction<CreatePrintArchiveMutation, CreatePrintArchiveMutationVariables>;

/**
 * __useCreatePrintArchiveMutation__
 *
 * To run a mutation, you first call `useCreatePrintArchiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePrintArchiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPrintArchiveMutation, { data, loading, error }] = useCreatePrintArchiveMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePrintArchiveMutation(baseOptions?: Apollo.MutationHookOptions<CreatePrintArchiveMutation, CreatePrintArchiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePrintArchiveMutation, CreatePrintArchiveMutationVariables>(CreatePrintArchiveDocument, options);
      }
export type CreatePrintArchiveMutationHookResult = ReturnType<typeof useCreatePrintArchiveMutation>;
export type CreatePrintArchiveMutationResult = Apollo.MutationResult<CreatePrintArchiveMutation>;
export type CreatePrintArchiveMutationOptions = Apollo.BaseMutationOptions<CreatePrintArchiveMutation, CreatePrintArchiveMutationVariables>;
export const CreateResourceDocument = gql`
    mutation CreateResource($assessmentId: ID!, $taskId: ID, $url: String!, $name: String!, $mediaId: ID) {
  createResource(
    assessmentId: $assessmentId
    taskId: $taskId
    url: $url
    name: $name
    mediaId: $mediaId
  ) {
    ...Resource
  }
}
    ${ResourceFragmentDoc}`;
export type CreateResourceMutationFn = Apollo.MutationFunction<CreateResourceMutation, CreateResourceMutationVariables>;

/**
 * __useCreateResourceMutation__
 *
 * To run a mutation, you first call `useCreateResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createResourceMutation, { data, loading, error }] = useCreateResourceMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      taskId: // value for 'taskId'
 *      url: // value for 'url'
 *      name: // value for 'name'
 *      mediaId: // value for 'mediaId'
 *   },
 * });
 */
export function useCreateResourceMutation(baseOptions?: Apollo.MutationHookOptions<CreateResourceMutation, CreateResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateResourceMutation, CreateResourceMutationVariables>(CreateResourceDocument, options);
      }
export type CreateResourceMutationHookResult = ReturnType<typeof useCreateResourceMutation>;
export type CreateResourceMutationResult = Apollo.MutationResult<CreateResourceMutation>;
export type CreateResourceMutationOptions = Apollo.BaseMutationOptions<CreateResourceMutation, CreateResourceMutationVariables>;
export const CreateTaskBlockDocument = gql`
    mutation CreateTaskBlock($taskId: ID!, $input: CreateTaskBlockInput!) {
  createTaskBlock(taskId: $taskId, input: $input) {
    ...TaskBlock
  }
}
    ${TaskBlockFragmentDoc}`;
export type CreateTaskBlockMutationFn = Apollo.MutationFunction<CreateTaskBlockMutation, CreateTaskBlockMutationVariables>;

/**
 * __useCreateTaskBlockMutation__
 *
 * To run a mutation, you first call `useCreateTaskBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskBlockMutation, { data, loading, error }] = useCreateTaskBlockMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTaskBlockMutation(baseOptions?: Apollo.MutationHookOptions<CreateTaskBlockMutation, CreateTaskBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTaskBlockMutation, CreateTaskBlockMutationVariables>(CreateTaskBlockDocument, options);
      }
export type CreateTaskBlockMutationHookResult = ReturnType<typeof useCreateTaskBlockMutation>;
export type CreateTaskBlockMutationResult = Apollo.MutationResult<CreateTaskBlockMutation>;
export type CreateTaskBlockMutationOptions = Apollo.BaseMutationOptions<CreateTaskBlockMutation, CreateTaskBlockMutationVariables>;
export const CreateTaskSaveDocument = gql`
    mutation CreateTaskSave($assessmentId: ID!, $content: String!, $editor: EditorType, $taskId: ID) {
  createTaskSave(
    assessmentId: $assessmentId
    content: $content
    editor: $editor
    taskId: $taskId
  ) {
    id
    serverId
    version
    rawContent
  }
}
    `;
export type CreateTaskSaveMutationFn = Apollo.MutationFunction<CreateTaskSaveMutation, CreateTaskSaveMutationVariables>;

/**
 * __useCreateTaskSaveMutation__
 *
 * To run a mutation, you first call `useCreateTaskSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskSaveMutation, { data, loading, error }] = useCreateTaskSaveMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      content: // value for 'content'
 *      editor: // value for 'editor'
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useCreateTaskSaveMutation(baseOptions?: Apollo.MutationHookOptions<CreateTaskSaveMutation, CreateTaskSaveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTaskSaveMutation, CreateTaskSaveMutationVariables>(CreateTaskSaveDocument, options);
      }
export type CreateTaskSaveMutationHookResult = ReturnType<typeof useCreateTaskSaveMutation>;
export type CreateTaskSaveMutationResult = Apollo.MutationResult<CreateTaskSaveMutation>;
export type CreateTaskSaveMutationOptions = Apollo.BaseMutationOptions<CreateTaskSaveMutation, CreateTaskSaveMutationVariables>;
export const DeleteGenaiGuidelineNoticeDocument = gql`
    mutation DeleteGenaiGuidelineNotice($taskId: ID!) {
  deleteGenaiGuidelineNotice(taskId: $taskId) {
    id
    genaiGuidelineNotice {
      ...TaskNotice
    }
  }
}
    ${TaskNoticeFragmentDoc}`;
export type DeleteGenaiGuidelineNoticeMutationFn = Apollo.MutationFunction<DeleteGenaiGuidelineNoticeMutation, DeleteGenaiGuidelineNoticeMutationVariables>;

/**
 * __useDeleteGenaiGuidelineNoticeMutation__
 *
 * To run a mutation, you first call `useDeleteGenaiGuidelineNoticeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGenaiGuidelineNoticeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGenaiGuidelineNoticeMutation, { data, loading, error }] = useDeleteGenaiGuidelineNoticeMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useDeleteGenaiGuidelineNoticeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGenaiGuidelineNoticeMutation, DeleteGenaiGuidelineNoticeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGenaiGuidelineNoticeMutation, DeleteGenaiGuidelineNoticeMutationVariables>(DeleteGenaiGuidelineNoticeDocument, options);
      }
export type DeleteGenaiGuidelineNoticeMutationHookResult = ReturnType<typeof useDeleteGenaiGuidelineNoticeMutation>;
export type DeleteGenaiGuidelineNoticeMutationResult = Apollo.MutationResult<DeleteGenaiGuidelineNoticeMutation>;
export type DeleteGenaiGuidelineNoticeMutationOptions = Apollo.BaseMutationOptions<DeleteGenaiGuidelineNoticeMutation, DeleteGenaiGuidelineNoticeMutationVariables>;
export const DeleteResourceDocument = gql`
    mutation DeleteResource($id: ID!) {
  deleteResource(id: $id) {
    id
    invalidated
  }
}
    `;
export type DeleteResourceMutationFn = Apollo.MutationFunction<DeleteResourceMutation, DeleteResourceMutationVariables>;

/**
 * __useDeleteResourceMutation__
 *
 * To run a mutation, you first call `useDeleteResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteResourceMutation, { data, loading, error }] = useDeleteResourceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteResourceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteResourceMutation, DeleteResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteResourceMutation, DeleteResourceMutationVariables>(DeleteResourceDocument, options);
      }
export type DeleteResourceMutationHookResult = ReturnType<typeof useDeleteResourceMutation>;
export type DeleteResourceMutationResult = Apollo.MutationResult<DeleteResourceMutation>;
export type DeleteResourceMutationOptions = Apollo.BaseMutationOptions<DeleteResourceMutation, DeleteResourceMutationVariables>;
export const DuplicateTaskBlockDocument = gql`
    mutation DuplicateTaskBlock($taskBlockId: ID!) {
  duplicateTaskBlock(taskBlockId: $taskBlockId) {
    ...TaskBlock
  }
}
    ${TaskBlockFragmentDoc}`;
export type DuplicateTaskBlockMutationFn = Apollo.MutationFunction<DuplicateTaskBlockMutation, DuplicateTaskBlockMutationVariables>;

/**
 * __useDuplicateTaskBlockMutation__
 *
 * To run a mutation, you first call `useDuplicateTaskBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateTaskBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateTaskBlockMutation, { data, loading, error }] = useDuplicateTaskBlockMutation({
 *   variables: {
 *      taskBlockId: // value for 'taskBlockId'
 *   },
 * });
 */
export function useDuplicateTaskBlockMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateTaskBlockMutation, DuplicateTaskBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateTaskBlockMutation, DuplicateTaskBlockMutationVariables>(DuplicateTaskBlockDocument, options);
      }
export type DuplicateTaskBlockMutationHookResult = ReturnType<typeof useDuplicateTaskBlockMutation>;
export type DuplicateTaskBlockMutationResult = Apollo.MutationResult<DuplicateTaskBlockMutation>;
export type DuplicateTaskBlockMutationOptions = Apollo.BaseMutationOptions<DuplicateTaskBlockMutation, DuplicateTaskBlockMutationVariables>;
export const EditTaskDocument = gql`
    mutation EditTask($assessmentId: ID!) {
  editTask(assessmentId: $assessmentId) {
    ...TaskStatus
  }
}
    ${TaskStatusFragmentDoc}`;
export type EditTaskMutationFn = Apollo.MutationFunction<EditTaskMutation, EditTaskMutationVariables>;

/**
 * __useEditTaskMutation__
 *
 * To run a mutation, you first call `useEditTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editTaskMutation, { data, loading, error }] = useEditTaskMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useEditTaskMutation(baseOptions?: Apollo.MutationHookOptions<EditTaskMutation, EditTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditTaskMutation, EditTaskMutationVariables>(EditTaskDocument, options);
      }
export type EditTaskMutationHookResult = ReturnType<typeof useEditTaskMutation>;
export type EditTaskMutationResult = Apollo.MutationResult<EditTaskMutation>;
export type EditTaskMutationOptions = Apollo.BaseMutationOptions<EditTaskMutation, EditTaskMutationVariables>;
export const EditTaskV2Document = gql`
    mutation EditTaskV2($taskId: ID!) {
  editTaskV2(taskId: $taskId) {
    ...HubTask
  }
}
    ${HubTaskFragmentDoc}`;
export type EditTaskV2MutationFn = Apollo.MutationFunction<EditTaskV2Mutation, EditTaskV2MutationVariables>;

/**
 * __useEditTaskV2Mutation__
 *
 * To run a mutation, you first call `useEditTaskV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditTaskV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editTaskV2Mutation, { data, loading, error }] = useEditTaskV2Mutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useEditTaskV2Mutation(baseOptions?: Apollo.MutationHookOptions<EditTaskV2Mutation, EditTaskV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditTaskV2Mutation, EditTaskV2MutationVariables>(EditTaskV2Document, options);
      }
export type EditTaskV2MutationHookResult = ReturnType<typeof useEditTaskV2Mutation>;
export type EditTaskV2MutationResult = Apollo.MutationResult<EditTaskV2Mutation>;
export type EditTaskV2MutationOptions = Apollo.BaseMutationOptions<EditTaskV2Mutation, EditTaskV2MutationVariables>;
export const GenerateReportDocument = gql`
    mutation GenerateReport($kind: String!, $assessmentId: ID!, $workId: ID, $anonymousName: String, $studentId: ID) {
  generateReport(
    kind: $kind
    assessmentId: $assessmentId
    workId: $workId
    anonymousName: $anonymousName
    studentId: $studentId
  ) {
    id
    assessmentId
    conflict
    resultUrl
    insertedAt
  }
}
    `;
export type GenerateReportMutationFn = Apollo.MutationFunction<GenerateReportMutation, GenerateReportMutationVariables>;

/**
 * __useGenerateReportMutation__
 *
 * To run a mutation, you first call `useGenerateReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateReportMutation, { data, loading, error }] = useGenerateReportMutation({
 *   variables: {
 *      kind: // value for 'kind'
 *      assessmentId: // value for 'assessmentId'
 *      workId: // value for 'workId'
 *      anonymousName: // value for 'anonymousName'
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useGenerateReportMutation(baseOptions?: Apollo.MutationHookOptions<GenerateReportMutation, GenerateReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateReportMutation, GenerateReportMutationVariables>(GenerateReportDocument, options);
      }
export type GenerateReportMutationHookResult = ReturnType<typeof useGenerateReportMutation>;
export type GenerateReportMutationResult = Apollo.MutationResult<GenerateReportMutation>;
export type GenerateReportMutationOptions = Apollo.BaseMutationOptions<GenerateReportMutation, GenerateReportMutationVariables>;
export const HasSubmissionDocument = gql`
    subscription HasSubmission($assessmentId: ID!) {
  hasSubmission(assessmentId: $assessmentId)
}
    `;

/**
 * __useHasSubmissionSubscription__
 *
 * To run a query within a React component, call `useHasSubmissionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useHasSubmissionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasSubmissionSubscription({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useHasSubmissionSubscription(baseOptions: Apollo.SubscriptionHookOptions<HasSubmissionSubscription, HasSubmissionSubscriptionVariables> & ({ variables: HasSubmissionSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<HasSubmissionSubscription, HasSubmissionSubscriptionVariables>(HasSubmissionDocument, options);
      }
export type HasSubmissionSubscriptionHookResult = ReturnType<typeof useHasSubmissionSubscription>;
export type HasSubmissionSubscriptionResult = Apollo.SubscriptionResult<HasSubmissionSubscription>;
export const ImportLibraryQuestionDocument = gql`
    mutation ImportLibraryQuestion($input: ImportLibraryQuestionInput!) {
  importLibraryQuestion(input: $input) {
    ...TaskBlock
  }
}
    ${TaskBlockFragmentDoc}`;
export type ImportLibraryQuestionMutationFn = Apollo.MutationFunction<ImportLibraryQuestionMutation, ImportLibraryQuestionMutationVariables>;

/**
 * __useImportLibraryQuestionMutation__
 *
 * To run a mutation, you first call `useImportLibraryQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportLibraryQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importLibraryQuestionMutation, { data, loading, error }] = useImportLibraryQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportLibraryQuestionMutation(baseOptions?: Apollo.MutationHookOptions<ImportLibraryQuestionMutation, ImportLibraryQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportLibraryQuestionMutation, ImportLibraryQuestionMutationVariables>(ImportLibraryQuestionDocument, options);
      }
export type ImportLibraryQuestionMutationHookResult = ReturnType<typeof useImportLibraryQuestionMutation>;
export type ImportLibraryQuestionMutationResult = Apollo.MutationResult<ImportLibraryQuestionMutation>;
export type ImportLibraryQuestionMutationOptions = Apollo.BaseMutationOptions<ImportLibraryQuestionMutation, ImportLibraryQuestionMutationVariables>;
export const InstructionSheetDocument = gql`
    query InstructionSheet($assessmentId: ID!) {
  assessment(assessmentId: $assessmentId) {
    id
    name
    settings {
      ...AssessmentSettings
    }
    tasks {
      ...Task
      instructionSheet {
        ...InstructionSheet
      }
      futureSheet {
        ...InstructionSheetWithFutureSettings
      }
    }
  }
}
    ${AssessmentSettingsFragmentDoc}
${TaskFragmentDoc}
${InstructionSheetFragmentDoc}
${InstructionSheetWithFutureSettingsFragmentDoc}`;

/**
 * __useInstructionSheetQuery__
 *
 * To run a query within a React component, call `useInstructionSheetQuery` and pass it any options that fit your needs.
 * When your component renders, `useInstructionSheetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInstructionSheetQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useInstructionSheetQuery(baseOptions: Apollo.QueryHookOptions<InstructionSheetQuery, InstructionSheetQueryVariables> & ({ variables: InstructionSheetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InstructionSheetQuery, InstructionSheetQueryVariables>(InstructionSheetDocument, options);
      }
export function useInstructionSheetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InstructionSheetQuery, InstructionSheetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InstructionSheetQuery, InstructionSheetQueryVariables>(InstructionSheetDocument, options);
        }
export function useInstructionSheetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InstructionSheetQuery, InstructionSheetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InstructionSheetQuery, InstructionSheetQueryVariables>(InstructionSheetDocument, options);
        }
export type InstructionSheetQueryHookResult = ReturnType<typeof useInstructionSheetQuery>;
export type InstructionSheetLazyQueryHookResult = ReturnType<typeof useInstructionSheetLazyQuery>;
export type InstructionSheetSuspenseQueryHookResult = ReturnType<typeof useInstructionSheetSuspenseQuery>;
export type InstructionSheetQueryResult = Apollo.QueryResult<InstructionSheetQuery, InstructionSheetQueryVariables>;
export const PrintArchiveUrlDocument = gql`
    query PrintArchiveUrl($taskId: ID!, $archiveId: ID!) {
  printArchiveUrl(taskId: $taskId, archiveId: $archiveId)
}
    `;

/**
 * __usePrintArchiveUrlQuery__
 *
 * To run a query within a React component, call `usePrintArchiveUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrintArchiveUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrintArchiveUrlQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      archiveId: // value for 'archiveId'
 *   },
 * });
 */
export function usePrintArchiveUrlQuery(baseOptions: Apollo.QueryHookOptions<PrintArchiveUrlQuery, PrintArchiveUrlQueryVariables> & ({ variables: PrintArchiveUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrintArchiveUrlQuery, PrintArchiveUrlQueryVariables>(PrintArchiveUrlDocument, options);
      }
export function usePrintArchiveUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrintArchiveUrlQuery, PrintArchiveUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrintArchiveUrlQuery, PrintArchiveUrlQueryVariables>(PrintArchiveUrlDocument, options);
        }
export function usePrintArchiveUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PrintArchiveUrlQuery, PrintArchiveUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PrintArchiveUrlQuery, PrintArchiveUrlQueryVariables>(PrintArchiveUrlDocument, options);
        }
export type PrintArchiveUrlQueryHookResult = ReturnType<typeof usePrintArchiveUrlQuery>;
export type PrintArchiveUrlLazyQueryHookResult = ReturnType<typeof usePrintArchiveUrlLazyQuery>;
export type PrintArchiveUrlSuspenseQueryHookResult = ReturnType<typeof usePrintArchiveUrlSuspenseQuery>;
export type PrintArchiveUrlQueryResult = Apollo.QueryResult<PrintArchiveUrlQuery, PrintArchiveUrlQueryVariables>;
export const QuestionTreeDocument = gql`
    query QuestionTree($assessmentId: ID!, $taskId: ID!, $input: [QuestionSelectionFilterInput!]!) {
  assessment(assessmentId: $assessmentId) {
    id
    name
  }
  questionTree(taskId: $taskId, selectionInput: $input) {
    ...QuestionBlock
  }
}
    ${QuestionBlockFragmentDoc}`;

/**
 * __useQuestionTreeQuery__
 *
 * To run a query within a React component, call `useQuestionTreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuestionTreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuestionTreeQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      taskId: // value for 'taskId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useQuestionTreeQuery(baseOptions: Apollo.QueryHookOptions<QuestionTreeQuery, QuestionTreeQueryVariables> & ({ variables: QuestionTreeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuestionTreeQuery, QuestionTreeQueryVariables>(QuestionTreeDocument, options);
      }
export function useQuestionTreeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuestionTreeQuery, QuestionTreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuestionTreeQuery, QuestionTreeQueryVariables>(QuestionTreeDocument, options);
        }
export function useQuestionTreeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QuestionTreeQuery, QuestionTreeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QuestionTreeQuery, QuestionTreeQueryVariables>(QuestionTreeDocument, options);
        }
export type QuestionTreeQueryHookResult = ReturnType<typeof useQuestionTreeQuery>;
export type QuestionTreeLazyQueryHookResult = ReturnType<typeof useQuestionTreeLazyQuery>;
export type QuestionTreeSuspenseQueryHookResult = ReturnType<typeof useQuestionTreeSuspenseQuery>;
export type QuestionTreeQueryResult = Apollo.QueryResult<QuestionTreeQuery, QuestionTreeQueryVariables>;
export const ReleaseTaskDocument = gql`
    mutation ReleaseTask($assessmentId: ID!, $saveId: ID!, $scheduleTimestamp: DateTime) {
  releaseTask(
    assessmentId: $assessmentId
    saveId: $saveId
    scheduleTimestamp: $scheduleTimestamp
  ) {
    ...InstructionSheetWithFutureSettings
  }
}
    ${InstructionSheetWithFutureSettingsFragmentDoc}`;
export type ReleaseTaskMutationFn = Apollo.MutationFunction<ReleaseTaskMutation, ReleaseTaskMutationVariables>;

/**
 * __useReleaseTaskMutation__
 *
 * To run a mutation, you first call `useReleaseTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReleaseTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [releaseTaskMutation, { data, loading, error }] = useReleaseTaskMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      saveId: // value for 'saveId'
 *      scheduleTimestamp: // value for 'scheduleTimestamp'
 *   },
 * });
 */
export function useReleaseTaskMutation(baseOptions?: Apollo.MutationHookOptions<ReleaseTaskMutation, ReleaseTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReleaseTaskMutation, ReleaseTaskMutationVariables>(ReleaseTaskDocument, options);
      }
export type ReleaseTaskMutationHookResult = ReturnType<typeof useReleaseTaskMutation>;
export type ReleaseTaskMutationResult = Apollo.MutationResult<ReleaseTaskMutation>;
export type ReleaseTaskMutationOptions = Apollo.BaseMutationOptions<ReleaseTaskMutation, ReleaseTaskMutationVariables>;
export const SaveGenaiGuidelineNoticeDocument = gql`
    mutation SaveGenaiGuidelineNotice($content: String!, $taskId: ID!, $version: Int!) {
  saveGenaiGuidelineNotice(content: $content, taskId: $taskId, version: $version) {
    ...TaskNotice
  }
}
    ${TaskNoticeFragmentDoc}`;
export type SaveGenaiGuidelineNoticeMutationFn = Apollo.MutationFunction<SaveGenaiGuidelineNoticeMutation, SaveGenaiGuidelineNoticeMutationVariables>;

/**
 * __useSaveGenaiGuidelineNoticeMutation__
 *
 * To run a mutation, you first call `useSaveGenaiGuidelineNoticeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveGenaiGuidelineNoticeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveGenaiGuidelineNoticeMutation, { data, loading, error }] = useSaveGenaiGuidelineNoticeMutation({
 *   variables: {
 *      content: // value for 'content'
 *      taskId: // value for 'taskId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useSaveGenaiGuidelineNoticeMutation(baseOptions?: Apollo.MutationHookOptions<SaveGenaiGuidelineNoticeMutation, SaveGenaiGuidelineNoticeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveGenaiGuidelineNoticeMutation, SaveGenaiGuidelineNoticeMutationVariables>(SaveGenaiGuidelineNoticeDocument, options);
      }
export type SaveGenaiGuidelineNoticeMutationHookResult = ReturnType<typeof useSaveGenaiGuidelineNoticeMutation>;
export type SaveGenaiGuidelineNoticeMutationResult = Apollo.MutationResult<SaveGenaiGuidelineNoticeMutation>;
export type SaveGenaiGuidelineNoticeMutationOptions = Apollo.BaseMutationOptions<SaveGenaiGuidelineNoticeMutation, SaveGenaiGuidelineNoticeMutationVariables>;
export const SaveQuestionStateDocument = gql`
    mutation SaveQuestionState($questionId: ID!, $input: SaveQuestionStateInput!) {
  saveQuestionState(questionId: $questionId, input: $input) {
    ...Question
  }
}
    ${QuestionFragmentDoc}`;
export type SaveQuestionStateMutationFn = Apollo.MutationFunction<SaveQuestionStateMutation, SaveQuestionStateMutationVariables>;

/**
 * __useSaveQuestionStateMutation__
 *
 * To run a mutation, you first call `useSaveQuestionStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveQuestionStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveQuestionStateMutation, { data, loading, error }] = useSaveQuestionStateMutation({
 *   variables: {
 *      questionId: // value for 'questionId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveQuestionStateMutation(baseOptions?: Apollo.MutationHookOptions<SaveQuestionStateMutation, SaveQuestionStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveQuestionStateMutation, SaveQuestionStateMutationVariables>(SaveQuestionStateDocument, options);
      }
export type SaveQuestionStateMutationHookResult = ReturnType<typeof useSaveQuestionStateMutation>;
export type SaveQuestionStateMutationResult = Apollo.MutationResult<SaveQuestionStateMutation>;
export type SaveQuestionStateMutationOptions = Apollo.BaseMutationOptions<SaveQuestionStateMutation, SaveQuestionStateMutationVariables>;
export const SetupAccessCodeDocument = gql`
    mutation SetupAccessCode($input: AccessCodeInput!, $assessmentId: ID!) {
  setupAccessCode(input: $input, assessmentId: $assessmentId) {
    ...AccessCode
  }
}
    ${AccessCodeFragmentDoc}`;
export type SetupAccessCodeMutationFn = Apollo.MutationFunction<SetupAccessCodeMutation, SetupAccessCodeMutationVariables>;

/**
 * __useSetupAccessCodeMutation__
 *
 * To run a mutation, you first call `useSetupAccessCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetupAccessCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setupAccessCodeMutation, { data, loading, error }] = useSetupAccessCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useSetupAccessCodeMutation(baseOptions?: Apollo.MutationHookOptions<SetupAccessCodeMutation, SetupAccessCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetupAccessCodeMutation, SetupAccessCodeMutationVariables>(SetupAccessCodeDocument, options);
      }
export type SetupAccessCodeMutationHookResult = ReturnType<typeof useSetupAccessCodeMutation>;
export type SetupAccessCodeMutationResult = Apollo.MutationResult<SetupAccessCodeMutation>;
export type SetupAccessCodeMutationOptions = Apollo.BaseMutationOptions<SetupAccessCodeMutation, SetupAccessCodeMutationVariables>;
export const SetupTaskDocument = gql`
    mutation SetupTask($assessmentId: ID!, $kind: TaskKind!) {
  setupTask(assessmentId: $assessmentId, kind: $kind) {
    ...HubTask
  }
}
    ${HubTaskFragmentDoc}`;
export type SetupTaskMutationFn = Apollo.MutationFunction<SetupTaskMutation, SetupTaskMutationVariables>;

/**
 * __useSetupTaskMutation__
 *
 * To run a mutation, you first call `useSetupTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetupTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setupTaskMutation, { data, loading, error }] = useSetupTaskMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      kind: // value for 'kind'
 *   },
 * });
 */
export function useSetupTaskMutation(baseOptions?: Apollo.MutationHookOptions<SetupTaskMutation, SetupTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetupTaskMutation, SetupTaskMutationVariables>(SetupTaskDocument, options);
      }
export type SetupTaskMutationHookResult = ReturnType<typeof useSetupTaskMutation>;
export type SetupTaskMutationResult = Apollo.MutationResult<SetupTaskMutation>;
export type SetupTaskMutationOptions = Apollo.BaseMutationOptions<SetupTaskMutation, SetupTaskMutationVariables>;
export const SheetReleasedDocument = gql`
    subscription SheetReleased($assessmentId: ID!) {
  sheetReleased(assessmentId: $assessmentId) {
    ...InstructionSheet
  }
}
    ${InstructionSheetFragmentDoc}`;

/**
 * __useSheetReleasedSubscription__
 *
 * To run a query within a React component, call `useSheetReleasedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSheetReleasedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSheetReleasedSubscription({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useSheetReleasedSubscription(baseOptions: Apollo.SubscriptionHookOptions<SheetReleasedSubscription, SheetReleasedSubscriptionVariables> & ({ variables: SheetReleasedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SheetReleasedSubscription, SheetReleasedSubscriptionVariables>(SheetReleasedDocument, options);
      }
export type SheetReleasedSubscriptionHookResult = ReturnType<typeof useSheetReleasedSubscription>;
export type SheetReleasedSubscriptionResult = Apollo.SubscriptionResult<SheetReleasedSubscription>;
export const SwapResourceDocument = gql`
    mutation SwapResource($id: ID!, $swapId: ID!) {
  swapResource(firstId: $id, secondId: $swapId)
}
    `;
export type SwapResourceMutationFn = Apollo.MutationFunction<SwapResourceMutation, SwapResourceMutationVariables>;

/**
 * __useSwapResourceMutation__
 *
 * To run a mutation, you first call `useSwapResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwapResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [swapResourceMutation, { data, loading, error }] = useSwapResourceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      swapId: // value for 'swapId'
 *   },
 * });
 */
export function useSwapResourceMutation(baseOptions?: Apollo.MutationHookOptions<SwapResourceMutation, SwapResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SwapResourceMutation, SwapResourceMutationVariables>(SwapResourceDocument, options);
      }
export type SwapResourceMutationHookResult = ReturnType<typeof useSwapResourceMutation>;
export type SwapResourceMutationResult = Apollo.MutationResult<SwapResourceMutation>;
export type SwapResourceMutationOptions = Apollo.BaseMutationOptions<SwapResourceMutation, SwapResourceMutationVariables>;
export const TaskDocument = gql`
    query Task($assessmentId: ID!, $taskId: ID) {
  token
  me {
    ...User
  }
  institution {
    ...Institution
  }
  featureFlags(assessmentId: $assessmentId) {
    ...FeatureFlags
  }
  assessment(assessmentId: $assessmentId) {
    ...Assessment
  }
  class(assessmentId: $assessmentId) {
    id
    students {
      ...GroupEnrollment
    }
    groups {
      ...Group
    }
  }
  userSettings(assessmentId: $assessmentId) {
    ...UserSettings
  }
  task(assessmentId: $assessmentId, taskId: $taskId) {
    ...Task
    instructionSheet {
      ...InstructionSheet
    }
    futureSheet {
      ...InstructionSheetWithFutureSettings
    }
  }
}
    ${UserFragmentDoc}
${InstitutionFragmentDoc}
${FeatureFlagsFragmentDoc}
${AssessmentFragmentDoc}
${GroupEnrollmentFragmentDoc}
${GroupFragmentDoc}
${UserSettingsFragmentDoc}
${TaskFragmentDoc}
${InstructionSheetFragmentDoc}
${InstructionSheetWithFutureSettingsFragmentDoc}`;

/**
 * __useTaskQuery__
 *
 * To run a query within a React component, call `useTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useTaskQuery(baseOptions: Apollo.QueryHookOptions<TaskQuery, TaskQueryVariables> & ({ variables: TaskQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskQuery, TaskQueryVariables>(TaskDocument, options);
      }
export function useTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskQuery, TaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskQuery, TaskQueryVariables>(TaskDocument, options);
        }
export function useTaskSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaskQuery, TaskQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TaskQuery, TaskQueryVariables>(TaskDocument, options);
        }
export type TaskQueryHookResult = ReturnType<typeof useTaskQuery>;
export type TaskLazyQueryHookResult = ReturnType<typeof useTaskLazyQuery>;
export type TaskSuspenseQueryHookResult = ReturnType<typeof useTaskSuspenseQuery>;
export type TaskQueryResult = Apollo.QueryResult<TaskQuery, TaskQueryVariables>;
export const UnlinkLibraryQuestionDocument = gql`
    mutation UnlinkLibraryQuestion($input: UnlinkLibraryQuestionInput!) {
  unlinkLibraryQuestion(input: $input) {
    ...TaskBlock
  }
}
    ${TaskBlockFragmentDoc}`;
export type UnlinkLibraryQuestionMutationFn = Apollo.MutationFunction<UnlinkLibraryQuestionMutation, UnlinkLibraryQuestionMutationVariables>;

/**
 * __useUnlinkLibraryQuestionMutation__
 *
 * To run a mutation, you first call `useUnlinkLibraryQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkLibraryQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkLibraryQuestionMutation, { data, loading, error }] = useUnlinkLibraryQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnlinkLibraryQuestionMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkLibraryQuestionMutation, UnlinkLibraryQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkLibraryQuestionMutation, UnlinkLibraryQuestionMutationVariables>(UnlinkLibraryQuestionDocument, options);
      }
export type UnlinkLibraryQuestionMutationHookResult = ReturnType<typeof useUnlinkLibraryQuestionMutation>;
export type UnlinkLibraryQuestionMutationResult = Apollo.MutationResult<UnlinkLibraryQuestionMutation>;
export type UnlinkLibraryQuestionMutationOptions = Apollo.BaseMutationOptions<UnlinkLibraryQuestionMutation, UnlinkLibraryQuestionMutationVariables>;
export const UpdateAssessmentNameDocument = gql`
    mutation UpdateAssessmentName($assessmentId: ID!, $name: String!) {
  updateAssessmentName(assessmentId: $assessmentId, name: $name) {
    id
    name
  }
}
    `;
export type UpdateAssessmentNameMutationFn = Apollo.MutationFunction<UpdateAssessmentNameMutation, UpdateAssessmentNameMutationVariables>;

/**
 * __useUpdateAssessmentNameMutation__
 *
 * To run a mutation, you first call `useUpdateAssessmentNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssessmentNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssessmentNameMutation, { data, loading, error }] = useUpdateAssessmentNameMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateAssessmentNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAssessmentNameMutation, UpdateAssessmentNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAssessmentNameMutation, UpdateAssessmentNameMutationVariables>(UpdateAssessmentNameDocument, options);
      }
export type UpdateAssessmentNameMutationHookResult = ReturnType<typeof useUpdateAssessmentNameMutation>;
export type UpdateAssessmentNameMutationResult = Apollo.MutationResult<UpdateAssessmentNameMutation>;
export type UpdateAssessmentNameMutationOptions = Apollo.BaseMutationOptions<UpdateAssessmentNameMutation, UpdateAssessmentNameMutationVariables>;
export const UpdateAssessmentSettingsDocument = gql`
    mutation UpdateAssessmentSettings($assessmentId: ID!, $input: AssessmentSettingsInput!) {
  updateAssessmentSettings(assessmentId: $assessmentId, input: $input) {
    ...Assessment
  }
}
    ${AssessmentFragmentDoc}`;
export type UpdateAssessmentSettingsMutationFn = Apollo.MutationFunction<UpdateAssessmentSettingsMutation, UpdateAssessmentSettingsMutationVariables>;

/**
 * __useUpdateAssessmentSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateAssessmentSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssessmentSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssessmentSettingsMutation, { data, loading, error }] = useUpdateAssessmentSettingsMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAssessmentSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAssessmentSettingsMutation, UpdateAssessmentSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAssessmentSettingsMutation, UpdateAssessmentSettingsMutationVariables>(UpdateAssessmentSettingsDocument, options);
      }
export type UpdateAssessmentSettingsMutationHookResult = ReturnType<typeof useUpdateAssessmentSettingsMutation>;
export type UpdateAssessmentSettingsMutationResult = Apollo.MutationResult<UpdateAssessmentSettingsMutation>;
export type UpdateAssessmentSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateAssessmentSettingsMutation, UpdateAssessmentSettingsMutationVariables>;
export const UpdateRequirementsDocument = gql`
    mutation UpdateRequirements($assessmentId: ID!, $requirements: RequirementsInput!) {
  updateRequirements(assessmentId: $assessmentId, requirements: $requirements) {
    ...Requirements
  }
}
    ${RequirementsFragmentDoc}`;
export type UpdateRequirementsMutationFn = Apollo.MutationFunction<UpdateRequirementsMutation, UpdateRequirementsMutationVariables>;

/**
 * __useUpdateRequirementsMutation__
 *
 * To run a mutation, you first call `useUpdateRequirementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRequirementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRequirementsMutation, { data, loading, error }] = useUpdateRequirementsMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      requirements: // value for 'requirements'
 *   },
 * });
 */
export function useUpdateRequirementsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRequirementsMutation, UpdateRequirementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRequirementsMutation, UpdateRequirementsMutationVariables>(UpdateRequirementsDocument, options);
      }
export type UpdateRequirementsMutationHookResult = ReturnType<typeof useUpdateRequirementsMutation>;
export type UpdateRequirementsMutationResult = Apollo.MutationResult<UpdateRequirementsMutation>;
export type UpdateRequirementsMutationOptions = Apollo.BaseMutationOptions<UpdateRequirementsMutation, UpdateRequirementsMutationVariables>;
export const UpdateResourceDocument = gql`
    mutation UpdateResource($id: ID!, $name: String, $url: String, $notes: String) {
  updateResource(id: $id, name: $name, url: $url, notes: $notes) {
    ...Resource
  }
}
    ${ResourceFragmentDoc}`;
export type UpdateResourceMutationFn = Apollo.MutationFunction<UpdateResourceMutation, UpdateResourceMutationVariables>;

/**
 * __useUpdateResourceMutation__
 *
 * To run a mutation, you first call `useUpdateResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResourceMutation, { data, loading, error }] = useUpdateResourceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      url: // value for 'url'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useUpdateResourceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateResourceMutation, UpdateResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateResourceMutation, UpdateResourceMutationVariables>(UpdateResourceDocument, options);
      }
export type UpdateResourceMutationHookResult = ReturnType<typeof useUpdateResourceMutation>;
export type UpdateResourceMutationResult = Apollo.MutationResult<UpdateResourceMutation>;
export type UpdateResourceMutationOptions = Apollo.BaseMutationOptions<UpdateResourceMutation, UpdateResourceMutationVariables>;
export const UpdateTaskBlockDocument = gql`
    mutation UpdateTaskBlock($taskBlockId: ID!, $input: UpdateTaskBlockInput!) {
  updateTaskBlock(taskBlockId: $taskBlockId, input: $input) {
    id
    points
    deleted
    hidden
    shuffle
    socraticQuestionerEnabled
  }
}
    `;
export type UpdateTaskBlockMutationFn = Apollo.MutationFunction<UpdateTaskBlockMutation, UpdateTaskBlockMutationVariables>;

/**
 * __useUpdateTaskBlockMutation__
 *
 * To run a mutation, you first call `useUpdateTaskBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskBlockMutation, { data, loading, error }] = useUpdateTaskBlockMutation({
 *   variables: {
 *      taskBlockId: // value for 'taskBlockId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTaskBlockMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskBlockMutation, UpdateTaskBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskBlockMutation, UpdateTaskBlockMutationVariables>(UpdateTaskBlockDocument, options);
      }
export type UpdateTaskBlockMutationHookResult = ReturnType<typeof useUpdateTaskBlockMutation>;
export type UpdateTaskBlockMutationResult = Apollo.MutationResult<UpdateTaskBlockMutation>;
export type UpdateTaskBlockMutationOptions = Apollo.BaseMutationOptions<UpdateTaskBlockMutation, UpdateTaskBlockMutationVariables>;
export const UpdateTaskBlocksDocument = gql`
    mutation UpdateTaskBlocks($taskBlocksList: [UpdateTaskBlocksInput!]!) {
  updateTaskBlocks(taskBlockList: $taskBlocksList) {
    ...TaskBlock
  }
}
    ${TaskBlockFragmentDoc}`;
export type UpdateTaskBlocksMutationFn = Apollo.MutationFunction<UpdateTaskBlocksMutation, UpdateTaskBlocksMutationVariables>;

/**
 * __useUpdateTaskBlocksMutation__
 *
 * To run a mutation, you first call `useUpdateTaskBlocksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskBlocksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskBlocksMutation, { data, loading, error }] = useUpdateTaskBlocksMutation({
 *   variables: {
 *      taskBlocksList: // value for 'taskBlocksList'
 *   },
 * });
 */
export function useUpdateTaskBlocksMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskBlocksMutation, UpdateTaskBlocksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskBlocksMutation, UpdateTaskBlocksMutationVariables>(UpdateTaskBlocksDocument, options);
      }
export type UpdateTaskBlocksMutationHookResult = ReturnType<typeof useUpdateTaskBlocksMutation>;
export type UpdateTaskBlocksMutationResult = Apollo.MutationResult<UpdateTaskBlocksMutation>;
export type UpdateTaskBlocksMutationOptions = Apollo.BaseMutationOptions<UpdateTaskBlocksMutation, UpdateTaskBlocksMutationVariables>;
export const UpdateTaskFormatDocument = gql`
    mutation UpdateTaskFormat($taskId: ID!, $format: TaskFormat!) {
  updateTaskFormat(taskId: $taskId, format: $format) {
    id
    format
  }
}
    `;
export type UpdateTaskFormatMutationFn = Apollo.MutationFunction<UpdateTaskFormatMutation, UpdateTaskFormatMutationVariables>;

/**
 * __useUpdateTaskFormatMutation__
 *
 * To run a mutation, you first call `useUpdateTaskFormatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskFormatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskFormatMutation, { data, loading, error }] = useUpdateTaskFormatMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      format: // value for 'format'
 *   },
 * });
 */
export function useUpdateTaskFormatMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskFormatMutation, UpdateTaskFormatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskFormatMutation, UpdateTaskFormatMutationVariables>(UpdateTaskFormatDocument, options);
      }
export type UpdateTaskFormatMutationHookResult = ReturnType<typeof useUpdateTaskFormatMutation>;
export type UpdateTaskFormatMutationResult = Apollo.MutationResult<UpdateTaskFormatMutation>;
export type UpdateTaskFormatMutationOptions = Apollo.BaseMutationOptions<UpdateTaskFormatMutation, UpdateTaskFormatMutationVariables>;
export const CopyAssessmentDocument = gql`
    mutation CopyAssessment($destinationAssessmentId: ID!, $sourceInstructionSheetId: ID!, $destinationTaskId: ID) {
  copyAssessment(
    destinationAssessmentId: $destinationAssessmentId
    sourceInstructionSheetId: $sourceInstructionSheetId
    destinationTaskId: $destinationTaskId
  ) {
    ...Task
  }
}
    ${TaskFragmentDoc}`;
export type CopyAssessmentMutationFn = Apollo.MutationFunction<CopyAssessmentMutation, CopyAssessmentMutationVariables>;

/**
 * __useCopyAssessmentMutation__
 *
 * To run a mutation, you first call `useCopyAssessmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyAssessmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyAssessmentMutation, { data, loading, error }] = useCopyAssessmentMutation({
 *   variables: {
 *      destinationAssessmentId: // value for 'destinationAssessmentId'
 *      sourceInstructionSheetId: // value for 'sourceInstructionSheetId'
 *      destinationTaskId: // value for 'destinationTaskId'
 *   },
 * });
 */
export function useCopyAssessmentMutation(baseOptions?: Apollo.MutationHookOptions<CopyAssessmentMutation, CopyAssessmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyAssessmentMutation, CopyAssessmentMutationVariables>(CopyAssessmentDocument, options);
      }
export type CopyAssessmentMutationHookResult = ReturnType<typeof useCopyAssessmentMutation>;
export type CopyAssessmentMutationResult = Apollo.MutationResult<CopyAssessmentMutation>;
export type CopyAssessmentMutationOptions = Apollo.BaseMutationOptions<CopyAssessmentMutation, CopyAssessmentMutationVariables>;
export const PastAssessmentsDocument = gql`
    query PastAssessments($assessmentId: ID) {
  pastInstructionSheets(assessmentId: $assessmentId) {
    assessment {
      name
      id
      subject {
        ...Subject
      }
      settings {
        ...AssessmentSettings
      }
    }
    sheet {
      id
      serverId
      taskId
      kind
      format
    }
  }
}
    ${SubjectFragmentDoc}
${AssessmentSettingsFragmentDoc}`;

/**
 * __usePastAssessmentsQuery__
 *
 * To run a query within a React component, call `usePastAssessmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePastAssessmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePastAssessmentsQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function usePastAssessmentsQuery(baseOptions?: Apollo.QueryHookOptions<PastAssessmentsQuery, PastAssessmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PastAssessmentsQuery, PastAssessmentsQueryVariables>(PastAssessmentsDocument, options);
      }
export function usePastAssessmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PastAssessmentsQuery, PastAssessmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PastAssessmentsQuery, PastAssessmentsQueryVariables>(PastAssessmentsDocument, options);
        }
export function usePastAssessmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PastAssessmentsQuery, PastAssessmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PastAssessmentsQuery, PastAssessmentsQueryVariables>(PastAssessmentsDocument, options);
        }
export type PastAssessmentsQueryHookResult = ReturnType<typeof usePastAssessmentsQuery>;
export type PastAssessmentsLazyQueryHookResult = ReturnType<typeof usePastAssessmentsLazyQuery>;
export type PastAssessmentsSuspenseQueryHookResult = ReturnType<typeof usePastAssessmentsSuspenseQuery>;
export type PastAssessmentsQueryResult = Apollo.QueryResult<PastAssessmentsQuery, PastAssessmentsQueryVariables>;
export const PastInstructionSheetDocument = gql`
    query PastInstructionSheet($assessmentId: ID!, $sheetId: ID!) {
  instructionSheet(assessmentId: $assessmentId, sheetId: $sheetId) {
    ...InstructionSheet
  }
}
    ${InstructionSheetFragmentDoc}`;

/**
 * __usePastInstructionSheetQuery__
 *
 * To run a query within a React component, call `usePastInstructionSheetQuery` and pass it any options that fit your needs.
 * When your component renders, `usePastInstructionSheetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePastInstructionSheetQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      sheetId: // value for 'sheetId'
 *   },
 * });
 */
export function usePastInstructionSheetQuery(baseOptions: Apollo.QueryHookOptions<PastInstructionSheetQuery, PastInstructionSheetQueryVariables> & ({ variables: PastInstructionSheetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PastInstructionSheetQuery, PastInstructionSheetQueryVariables>(PastInstructionSheetDocument, options);
      }
export function usePastInstructionSheetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PastInstructionSheetQuery, PastInstructionSheetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PastInstructionSheetQuery, PastInstructionSheetQueryVariables>(PastInstructionSheetDocument, options);
        }
export function usePastInstructionSheetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PastInstructionSheetQuery, PastInstructionSheetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PastInstructionSheetQuery, PastInstructionSheetQueryVariables>(PastInstructionSheetDocument, options);
        }
export type PastInstructionSheetQueryHookResult = ReturnType<typeof usePastInstructionSheetQuery>;
export type PastInstructionSheetLazyQueryHookResult = ReturnType<typeof usePastInstructionSheetLazyQuery>;
export type PastInstructionSheetSuspenseQueryHookResult = ReturnType<typeof usePastInstructionSheetSuspenseQuery>;
export type PastInstructionSheetQueryResult = Apollo.QueryResult<PastInstructionSheetQuery, PastInstructionSheetQueryVariables>;